
function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

      var $parcel$global =
        typeof globalThis !== 'undefined'
          ? globalThis
          : typeof self !== 'undefined'
          ? self
          : typeof window !== 'undefined'
          ? window
          : typeof global !== 'undefined'
          ? global
          : {};
  
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequireb6d4"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequireb6d4"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("0qhf8", function(module, exports) {

$parcel$export(module.exports, "Fragment", function () { return $0014624a040e5105$export$ffb0004e005737fa; }, function (v) { return $0014624a040e5105$export$ffb0004e005737fa = v; });
$parcel$export(module.exports, "jsx", function () { return $0014624a040e5105$export$34b9dba7ce09269b; }, function (v) { return $0014624a040e5105$export$34b9dba7ce09269b = v; });
$parcel$export(module.exports, "jsxs", function () { return $0014624a040e5105$export$25062201e9e25d76; }, function (v) { return $0014624a040e5105$export$25062201e9e25d76 = v; });
/**
 * @license React
 * react-jsx-runtime.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $0014624a040e5105$export$ffb0004e005737fa;
var $0014624a040e5105$export$34b9dba7ce09269b;
var $0014624a040e5105$export$25062201e9e25d76;
"use strict";

var $bh6RR = parcelRequire("bh6RR");
var $0014624a040e5105$var$k = Symbol.for("react.element"), $0014624a040e5105$var$l = Symbol.for("react.fragment"), $0014624a040e5105$var$m = Object.prototype.hasOwnProperty, $0014624a040e5105$var$n = $bh6RR.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED.ReactCurrentOwner, $0014624a040e5105$var$p = {
    key: !0,
    ref: !0,
    __self: !0,
    __source: !0
};
function $0014624a040e5105$var$q(c, a, g) {
    var b, d = {}, e = null, h = null;
    void 0 !== g && (e = "" + g);
    void 0 !== a.key && (e = "" + a.key);
    void 0 !== a.ref && (h = a.ref);
    for(b in a)$0014624a040e5105$var$m.call(a, b) && !$0014624a040e5105$var$p.hasOwnProperty(b) && (d[b] = a[b]);
    if (c && c.defaultProps) for(b in a = c.defaultProps, a)void 0 === d[b] && (d[b] = a[b]);
    return {
        $$typeof: $0014624a040e5105$var$k,
        type: c,
        key: e,
        ref: h,
        props: d,
        _owner: $0014624a040e5105$var$n.current
    };
}
$0014624a040e5105$export$ffb0004e005737fa = $0014624a040e5105$var$l;
$0014624a040e5105$export$34b9dba7ce09269b = $0014624a040e5105$var$q;
$0014624a040e5105$export$25062201e9e25d76 = $0014624a040e5105$var$q;

});
parcelRegister("bh6RR", function(module, exports) {
"use strict";

module.exports = (parcelRequire("cCfq4"));

});
parcelRegister("cCfq4", function(module, exports) {

$parcel$export(module.exports, "Children", function () { return $92f4fea5bc247620$export$dca3b0875bd9a954; }, function (v) { return $92f4fea5bc247620$export$dca3b0875bd9a954 = v; });
$parcel$export(module.exports, "Component", function () { return $92f4fea5bc247620$export$16fa2f45be04daa8; }, function (v) { return $92f4fea5bc247620$export$16fa2f45be04daa8 = v; });
$parcel$export(module.exports, "Fragment", function () { return $92f4fea5bc247620$export$ffb0004e005737fa; }, function (v) { return $92f4fea5bc247620$export$ffb0004e005737fa = v; });
$parcel$export(module.exports, "Profiler", function () { return $92f4fea5bc247620$export$e2c29f18771995cb; }, function (v) { return $92f4fea5bc247620$export$e2c29f18771995cb = v; });
$parcel$export(module.exports, "PureComponent", function () { return $92f4fea5bc247620$export$221d75b3f55bb0bd; }, function (v) { return $92f4fea5bc247620$export$221d75b3f55bb0bd = v; });
$parcel$export(module.exports, "StrictMode", function () { return $92f4fea5bc247620$export$5f8d39834fd61797; }, function (v) { return $92f4fea5bc247620$export$5f8d39834fd61797 = v; });
$parcel$export(module.exports, "Suspense", function () { return $92f4fea5bc247620$export$74bf444e3cd11ea5; }, function (v) { return $92f4fea5bc247620$export$74bf444e3cd11ea5 = v; });
$parcel$export(module.exports, "__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED", function () { return $92f4fea5bc247620$export$ae55be85d98224ed; }, function (v) { return $92f4fea5bc247620$export$ae55be85d98224ed = v; });
$parcel$export(module.exports, "act", function () { return $92f4fea5bc247620$export$3ba232387fd5d6dd; }, function (v) { return $92f4fea5bc247620$export$3ba232387fd5d6dd = v; });
$parcel$export(module.exports, "cloneElement", function () { return $92f4fea5bc247620$export$e530037191fcd5d7; }, function (v) { return $92f4fea5bc247620$export$e530037191fcd5d7 = v; });
$parcel$export(module.exports, "createContext", function () { return $92f4fea5bc247620$export$fd42f52fd3ae1109; }, function (v) { return $92f4fea5bc247620$export$fd42f52fd3ae1109 = v; });
$parcel$export(module.exports, "createElement", function () { return $92f4fea5bc247620$export$c8a8987d4410bf2d; }, function (v) { return $92f4fea5bc247620$export$c8a8987d4410bf2d = v; });
$parcel$export(module.exports, "createFactory", function () { return $92f4fea5bc247620$export$d38cd72104c1f0e9; }, function (v) { return $92f4fea5bc247620$export$d38cd72104c1f0e9 = v; });
$parcel$export(module.exports, "createRef", function () { return $92f4fea5bc247620$export$7d1e3a5e95ceca43; }, function (v) { return $92f4fea5bc247620$export$7d1e3a5e95ceca43 = v; });
$parcel$export(module.exports, "forwardRef", function () { return $92f4fea5bc247620$export$257a8862b851cb5b; }, function (v) { return $92f4fea5bc247620$export$257a8862b851cb5b = v; });
$parcel$export(module.exports, "isValidElement", function () { return $92f4fea5bc247620$export$a8257692ac88316c; }, function (v) { return $92f4fea5bc247620$export$a8257692ac88316c = v; });
$parcel$export(module.exports, "lazy", function () { return $92f4fea5bc247620$export$488013bae63b21da; }, function (v) { return $92f4fea5bc247620$export$488013bae63b21da = v; });
$parcel$export(module.exports, "memo", function () { return $92f4fea5bc247620$export$7c73462e0d25e514; }, function (v) { return $92f4fea5bc247620$export$7c73462e0d25e514 = v; });
$parcel$export(module.exports, "startTransition", function () { return $92f4fea5bc247620$export$7568632d0d33d16d; }, function (v) { return $92f4fea5bc247620$export$7568632d0d33d16d = v; });
$parcel$export(module.exports, "unstable_act", function () { return $92f4fea5bc247620$export$88948ce120ea2619; }, function (v) { return $92f4fea5bc247620$export$88948ce120ea2619 = v; });
$parcel$export(module.exports, "useCallback", function () { return $92f4fea5bc247620$export$35808ee640e87ca7; }, function (v) { return $92f4fea5bc247620$export$35808ee640e87ca7 = v; });
$parcel$export(module.exports, "useContext", function () { return $92f4fea5bc247620$export$fae74005e78b1a27; }, function (v) { return $92f4fea5bc247620$export$fae74005e78b1a27 = v; });
$parcel$export(module.exports, "useDebugValue", function () { return $92f4fea5bc247620$export$dc8fbce3eb94dc1e; }, function (v) { return $92f4fea5bc247620$export$dc8fbce3eb94dc1e = v; });
$parcel$export(module.exports, "useDeferredValue", function () { return $92f4fea5bc247620$export$6a7bc4e911dc01cf; }, function (v) { return $92f4fea5bc247620$export$6a7bc4e911dc01cf = v; });
$parcel$export(module.exports, "useEffect", function () { return $92f4fea5bc247620$export$6d9c69b0de29b591; }, function (v) { return $92f4fea5bc247620$export$6d9c69b0de29b591 = v; });
$parcel$export(module.exports, "useId", function () { return $92f4fea5bc247620$export$f680877a34711e37; }, function (v) { return $92f4fea5bc247620$export$f680877a34711e37 = v; });
$parcel$export(module.exports, "useImperativeHandle", function () { return $92f4fea5bc247620$export$d5a552a76deda3c2; }, function (v) { return $92f4fea5bc247620$export$d5a552a76deda3c2 = v; });
$parcel$export(module.exports, "useInsertionEffect", function () { return $92f4fea5bc247620$export$aaabe4eda9ed9969; }, function (v) { return $92f4fea5bc247620$export$aaabe4eda9ed9969 = v; });
$parcel$export(module.exports, "useLayoutEffect", function () { return $92f4fea5bc247620$export$e5c5a5f917a5871c; }, function (v) { return $92f4fea5bc247620$export$e5c5a5f917a5871c = v; });
$parcel$export(module.exports, "useMemo", function () { return $92f4fea5bc247620$export$1538c33de8887b59; }, function (v) { return $92f4fea5bc247620$export$1538c33de8887b59 = v; });
$parcel$export(module.exports, "useReducer", function () { return $92f4fea5bc247620$export$13e3392192263954; }, function (v) { return $92f4fea5bc247620$export$13e3392192263954 = v; });
$parcel$export(module.exports, "useRef", function () { return $92f4fea5bc247620$export$b8f5890fc79d6aca; }, function (v) { return $92f4fea5bc247620$export$b8f5890fc79d6aca = v; });
$parcel$export(module.exports, "useState", function () { return $92f4fea5bc247620$export$60241385465d0a34; }, function (v) { return $92f4fea5bc247620$export$60241385465d0a34 = v; });
$parcel$export(module.exports, "useSyncExternalStore", function () { return $92f4fea5bc247620$export$306c0aa65ff9ec16; }, function (v) { return $92f4fea5bc247620$export$306c0aa65ff9ec16 = v; });
$parcel$export(module.exports, "useTransition", function () { return $92f4fea5bc247620$export$7b286972b8d8ccbf; }, function (v) { return $92f4fea5bc247620$export$7b286972b8d8ccbf = v; });
$parcel$export(module.exports, "version", function () { return $92f4fea5bc247620$export$83d89fbfd8236492; }, function (v) { return $92f4fea5bc247620$export$83d89fbfd8236492 = v; });
/**
 * @license React
 * react.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $92f4fea5bc247620$export$dca3b0875bd9a954;
var $92f4fea5bc247620$export$16fa2f45be04daa8;
var $92f4fea5bc247620$export$ffb0004e005737fa;
var $92f4fea5bc247620$export$e2c29f18771995cb;
var $92f4fea5bc247620$export$221d75b3f55bb0bd;
var $92f4fea5bc247620$export$5f8d39834fd61797;
var $92f4fea5bc247620$export$74bf444e3cd11ea5;
var $92f4fea5bc247620$export$ae55be85d98224ed;
var $92f4fea5bc247620$export$3ba232387fd5d6dd;
var $92f4fea5bc247620$export$e530037191fcd5d7;
var $92f4fea5bc247620$export$fd42f52fd3ae1109;
var $92f4fea5bc247620$export$c8a8987d4410bf2d;
var $92f4fea5bc247620$export$d38cd72104c1f0e9;
var $92f4fea5bc247620$export$7d1e3a5e95ceca43;
var $92f4fea5bc247620$export$257a8862b851cb5b;
var $92f4fea5bc247620$export$a8257692ac88316c;
var $92f4fea5bc247620$export$488013bae63b21da;
var $92f4fea5bc247620$export$7c73462e0d25e514;
var $92f4fea5bc247620$export$7568632d0d33d16d;
var $92f4fea5bc247620$export$88948ce120ea2619;
var $92f4fea5bc247620$export$35808ee640e87ca7;
var $92f4fea5bc247620$export$fae74005e78b1a27;
var $92f4fea5bc247620$export$dc8fbce3eb94dc1e;
var $92f4fea5bc247620$export$6a7bc4e911dc01cf;
var $92f4fea5bc247620$export$6d9c69b0de29b591;
var $92f4fea5bc247620$export$f680877a34711e37;
var $92f4fea5bc247620$export$d5a552a76deda3c2;
var $92f4fea5bc247620$export$aaabe4eda9ed9969;
var $92f4fea5bc247620$export$e5c5a5f917a5871c;
var $92f4fea5bc247620$export$1538c33de8887b59;
var $92f4fea5bc247620$export$13e3392192263954;
var $92f4fea5bc247620$export$b8f5890fc79d6aca;
var $92f4fea5bc247620$export$60241385465d0a34;
var $92f4fea5bc247620$export$306c0aa65ff9ec16;
var $92f4fea5bc247620$export$7b286972b8d8ccbf;
var $92f4fea5bc247620$export$83d89fbfd8236492;
"use strict";
var $92f4fea5bc247620$var$l = Symbol.for("react.element"), $92f4fea5bc247620$var$n = Symbol.for("react.portal"), $92f4fea5bc247620$var$p = Symbol.for("react.fragment"), $92f4fea5bc247620$var$q = Symbol.for("react.strict_mode"), $92f4fea5bc247620$var$r = Symbol.for("react.profiler"), $92f4fea5bc247620$var$t = Symbol.for("react.provider"), $92f4fea5bc247620$var$u = Symbol.for("react.context"), $92f4fea5bc247620$var$v = Symbol.for("react.forward_ref"), $92f4fea5bc247620$var$w = Symbol.for("react.suspense"), $92f4fea5bc247620$var$x = Symbol.for("react.memo"), $92f4fea5bc247620$var$y = Symbol.for("react.lazy"), $92f4fea5bc247620$var$z = Symbol.iterator;
function $92f4fea5bc247620$var$A(a) {
    if (null === a || "object" !== typeof a) return null;
    a = $92f4fea5bc247620$var$z && a[$92f4fea5bc247620$var$z] || a["@@iterator"];
    return "function" === typeof a ? a : null;
}
var $92f4fea5bc247620$var$B = {
    isMounted: function() {
        return !1;
    },
    enqueueForceUpdate: function() {},
    enqueueReplaceState: function() {},
    enqueueSetState: function() {}
}, $92f4fea5bc247620$var$C = Object.assign, $92f4fea5bc247620$var$D = {};
function $92f4fea5bc247620$var$E(a, b, e) {
    this.props = a;
    this.context = b;
    this.refs = $92f4fea5bc247620$var$D;
    this.updater = e || $92f4fea5bc247620$var$B;
}
$92f4fea5bc247620$var$E.prototype.isReactComponent = {};
$92f4fea5bc247620$var$E.prototype.setState = function(a, b) {
    if ("object" !== typeof a && "function" !== typeof a && null != a) throw Error("setState(...): takes an object of state variables to update or a function which returns an object of state variables.");
    this.updater.enqueueSetState(this, a, b, "setState");
};
$92f4fea5bc247620$var$E.prototype.forceUpdate = function(a) {
    this.updater.enqueueForceUpdate(this, a, "forceUpdate");
};
function $92f4fea5bc247620$var$F() {}
$92f4fea5bc247620$var$F.prototype = $92f4fea5bc247620$var$E.prototype;
function $92f4fea5bc247620$var$G(a, b, e) {
    this.props = a;
    this.context = b;
    this.refs = $92f4fea5bc247620$var$D;
    this.updater = e || $92f4fea5bc247620$var$B;
}
var $92f4fea5bc247620$var$H = $92f4fea5bc247620$var$G.prototype = new $92f4fea5bc247620$var$F;
$92f4fea5bc247620$var$H.constructor = $92f4fea5bc247620$var$G;
$92f4fea5bc247620$var$C($92f4fea5bc247620$var$H, $92f4fea5bc247620$var$E.prototype);
$92f4fea5bc247620$var$H.isPureReactComponent = !0;
var $92f4fea5bc247620$var$I = Array.isArray, $92f4fea5bc247620$var$J = Object.prototype.hasOwnProperty, $92f4fea5bc247620$var$K = {
    current: null
}, $92f4fea5bc247620$var$L = {
    key: !0,
    ref: !0,
    __self: !0,
    __source: !0
};
function $92f4fea5bc247620$var$M(a, b, e) {
    var d, c = {}, k = null, h = null;
    if (null != b) for(d in void 0 !== b.ref && (h = b.ref), void 0 !== b.key && (k = "" + b.key), b)$92f4fea5bc247620$var$J.call(b, d) && !$92f4fea5bc247620$var$L.hasOwnProperty(d) && (c[d] = b[d]);
    var g = arguments.length - 2;
    if (1 === g) c.children = e;
    else if (1 < g) {
        for(var f = Array(g), m = 0; m < g; m++)f[m] = arguments[m + 2];
        c.children = f;
    }
    if (a && a.defaultProps) for(d in g = a.defaultProps, g)void 0 === c[d] && (c[d] = g[d]);
    return {
        $$typeof: $92f4fea5bc247620$var$l,
        type: a,
        key: k,
        ref: h,
        props: c,
        _owner: $92f4fea5bc247620$var$K.current
    };
}
function $92f4fea5bc247620$var$N(a, b) {
    return {
        $$typeof: $92f4fea5bc247620$var$l,
        type: a.type,
        key: b,
        ref: a.ref,
        props: a.props,
        _owner: a._owner
    };
}
function $92f4fea5bc247620$var$O(a) {
    return "object" === typeof a && null !== a && a.$$typeof === $92f4fea5bc247620$var$l;
}
function $92f4fea5bc247620$var$escape(a) {
    var b = {
        "=": "=0",
        ":": "=2"
    };
    return "$" + a.replace(/[=:]/g, function(a) {
        return b[a];
    });
}
var $92f4fea5bc247620$var$P = /\/+/g;
function $92f4fea5bc247620$var$Q(a, b) {
    return "object" === typeof a && null !== a && null != a.key ? $92f4fea5bc247620$var$escape("" + a.key) : b.toString(36);
}
function $92f4fea5bc247620$var$R(a, b, e, d, c) {
    var k = typeof a;
    if ("undefined" === k || "boolean" === k) a = null;
    var h = !1;
    if (null === a) h = !0;
    else switch(k){
        case "string":
        case "number":
            h = !0;
            break;
        case "object":
            switch(a.$$typeof){
                case $92f4fea5bc247620$var$l:
                case $92f4fea5bc247620$var$n:
                    h = !0;
            }
    }
    if (h) return h = a, c = c(h), a = "" === d ? "." + $92f4fea5bc247620$var$Q(h, 0) : d, $92f4fea5bc247620$var$I(c) ? (e = "", null != a && (e = a.replace($92f4fea5bc247620$var$P, "$&/") + "/"), $92f4fea5bc247620$var$R(c, b, e, "", function(a) {
        return a;
    })) : null != c && ($92f4fea5bc247620$var$O(c) && (c = $92f4fea5bc247620$var$N(c, e + (!c.key || h && h.key === c.key ? "" : ("" + c.key).replace($92f4fea5bc247620$var$P, "$&/") + "/") + a)), b.push(c)), 1;
    h = 0;
    d = "" === d ? "." : d + ":";
    if ($92f4fea5bc247620$var$I(a)) for(var g = 0; g < a.length; g++){
        k = a[g];
        var f = d + $92f4fea5bc247620$var$Q(k, g);
        h += $92f4fea5bc247620$var$R(k, b, e, f, c);
    }
    else if (f = $92f4fea5bc247620$var$A(a), "function" === typeof f) for(a = f.call(a), g = 0; !(k = a.next()).done;)k = k.value, f = d + $92f4fea5bc247620$var$Q(k, g++), h += $92f4fea5bc247620$var$R(k, b, e, f, c);
    else if ("object" === k) throw b = String(a), Error("Objects are not valid as a React child (found: " + ("[object Object]" === b ? "object with keys {" + Object.keys(a).join(", ") + "}" : b) + "). If you meant to render a collection of children, use an array instead.");
    return h;
}
function $92f4fea5bc247620$var$S(a, b, e) {
    if (null == a) return a;
    var d = [], c = 0;
    $92f4fea5bc247620$var$R(a, d, "", "", function(a) {
        return b.call(e, a, c++);
    });
    return d;
}
function $92f4fea5bc247620$var$T(a) {
    if (-1 === a._status) {
        var b = a._result;
        b = b();
        b.then(function(b) {
            if (0 === a._status || -1 === a._status) a._status = 1, a._result = b;
        }, function(b) {
            if (0 === a._status || -1 === a._status) a._status = 2, a._result = b;
        });
        -1 === a._status && (a._status = 0, a._result = b);
    }
    if (1 === a._status) return a._result.default;
    throw a._result;
}
var $92f4fea5bc247620$var$U = {
    current: null
}, $92f4fea5bc247620$var$V = {
    transition: null
}, $92f4fea5bc247620$var$W = {
    ReactCurrentDispatcher: $92f4fea5bc247620$var$U,
    ReactCurrentBatchConfig: $92f4fea5bc247620$var$V,
    ReactCurrentOwner: $92f4fea5bc247620$var$K
};
function $92f4fea5bc247620$var$X() {
    throw Error("act(...) is not supported in production builds of React.");
}
$92f4fea5bc247620$export$dca3b0875bd9a954 = {
    map: $92f4fea5bc247620$var$S,
    forEach: function(a, b, e) {
        $92f4fea5bc247620$var$S(a, function() {
            b.apply(this, arguments);
        }, e);
    },
    count: function(a) {
        var b = 0;
        $92f4fea5bc247620$var$S(a, function() {
            b++;
        });
        return b;
    },
    toArray: function(a) {
        return $92f4fea5bc247620$var$S(a, function(a) {
            return a;
        }) || [];
    },
    only: function(a) {
        if (!$92f4fea5bc247620$var$O(a)) throw Error("React.Children.only expected to receive a single React element child.");
        return a;
    }
};
$92f4fea5bc247620$export$16fa2f45be04daa8 = $92f4fea5bc247620$var$E;
$92f4fea5bc247620$export$ffb0004e005737fa = $92f4fea5bc247620$var$p;
$92f4fea5bc247620$export$e2c29f18771995cb = $92f4fea5bc247620$var$r;
$92f4fea5bc247620$export$221d75b3f55bb0bd = $92f4fea5bc247620$var$G;
$92f4fea5bc247620$export$5f8d39834fd61797 = $92f4fea5bc247620$var$q;
$92f4fea5bc247620$export$74bf444e3cd11ea5 = $92f4fea5bc247620$var$w;
$92f4fea5bc247620$export$ae55be85d98224ed = $92f4fea5bc247620$var$W;
$92f4fea5bc247620$export$3ba232387fd5d6dd = $92f4fea5bc247620$var$X;
$92f4fea5bc247620$export$e530037191fcd5d7 = function(a, b, e) {
    if (null === a || void 0 === a) throw Error("React.cloneElement(...): The argument must be a React element, but you passed " + a + ".");
    var d = $92f4fea5bc247620$var$C({}, a.props), c = a.key, k = a.ref, h = a._owner;
    if (null != b) {
        void 0 !== b.ref && (k = b.ref, h = $92f4fea5bc247620$var$K.current);
        void 0 !== b.key && (c = "" + b.key);
        if (a.type && a.type.defaultProps) var g = a.type.defaultProps;
        for(f in b)$92f4fea5bc247620$var$J.call(b, f) && !$92f4fea5bc247620$var$L.hasOwnProperty(f) && (d[f] = void 0 === b[f] && void 0 !== g ? g[f] : b[f]);
    }
    var f = arguments.length - 2;
    if (1 === f) d.children = e;
    else if (1 < f) {
        g = Array(f);
        for(var m = 0; m < f; m++)g[m] = arguments[m + 2];
        d.children = g;
    }
    return {
        $$typeof: $92f4fea5bc247620$var$l,
        type: a.type,
        key: c,
        ref: k,
        props: d,
        _owner: h
    };
};
$92f4fea5bc247620$export$fd42f52fd3ae1109 = function(a) {
    a = {
        $$typeof: $92f4fea5bc247620$var$u,
        _currentValue: a,
        _currentValue2: a,
        _threadCount: 0,
        Provider: null,
        Consumer: null,
        _defaultValue: null,
        _globalName: null
    };
    a.Provider = {
        $$typeof: $92f4fea5bc247620$var$t,
        _context: a
    };
    return a.Consumer = a;
};
$92f4fea5bc247620$export$c8a8987d4410bf2d = $92f4fea5bc247620$var$M;
$92f4fea5bc247620$export$d38cd72104c1f0e9 = function(a) {
    var b = $92f4fea5bc247620$var$M.bind(null, a);
    b.type = a;
    return b;
};
$92f4fea5bc247620$export$7d1e3a5e95ceca43 = function() {
    return {
        current: null
    };
};
$92f4fea5bc247620$export$257a8862b851cb5b = function(a) {
    return {
        $$typeof: $92f4fea5bc247620$var$v,
        render: a
    };
};
$92f4fea5bc247620$export$a8257692ac88316c = $92f4fea5bc247620$var$O;
$92f4fea5bc247620$export$488013bae63b21da = function(a) {
    return {
        $$typeof: $92f4fea5bc247620$var$y,
        _payload: {
            _status: -1,
            _result: a
        },
        _init: $92f4fea5bc247620$var$T
    };
};
$92f4fea5bc247620$export$7c73462e0d25e514 = function(a, b) {
    return {
        $$typeof: $92f4fea5bc247620$var$x,
        type: a,
        compare: void 0 === b ? null : b
    };
};
$92f4fea5bc247620$export$7568632d0d33d16d = function(a) {
    var b = $92f4fea5bc247620$var$V.transition;
    $92f4fea5bc247620$var$V.transition = {};
    try {
        a();
    } finally{
        $92f4fea5bc247620$var$V.transition = b;
    }
};
$92f4fea5bc247620$export$88948ce120ea2619 = $92f4fea5bc247620$var$X;
$92f4fea5bc247620$export$35808ee640e87ca7 = function(a, b) {
    return $92f4fea5bc247620$var$U.current.useCallback(a, b);
};
$92f4fea5bc247620$export$fae74005e78b1a27 = function(a) {
    return $92f4fea5bc247620$var$U.current.useContext(a);
};
$92f4fea5bc247620$export$dc8fbce3eb94dc1e = function() {};
$92f4fea5bc247620$export$6a7bc4e911dc01cf = function(a) {
    return $92f4fea5bc247620$var$U.current.useDeferredValue(a);
};
$92f4fea5bc247620$export$6d9c69b0de29b591 = function(a, b) {
    return $92f4fea5bc247620$var$U.current.useEffect(a, b);
};
$92f4fea5bc247620$export$f680877a34711e37 = function() {
    return $92f4fea5bc247620$var$U.current.useId();
};
$92f4fea5bc247620$export$d5a552a76deda3c2 = function(a, b, e) {
    return $92f4fea5bc247620$var$U.current.useImperativeHandle(a, b, e);
};
$92f4fea5bc247620$export$aaabe4eda9ed9969 = function(a, b) {
    return $92f4fea5bc247620$var$U.current.useInsertionEffect(a, b);
};
$92f4fea5bc247620$export$e5c5a5f917a5871c = function(a, b) {
    return $92f4fea5bc247620$var$U.current.useLayoutEffect(a, b);
};
$92f4fea5bc247620$export$1538c33de8887b59 = function(a, b) {
    return $92f4fea5bc247620$var$U.current.useMemo(a, b);
};
$92f4fea5bc247620$export$13e3392192263954 = function(a, b, e) {
    return $92f4fea5bc247620$var$U.current.useReducer(a, b, e);
};
$92f4fea5bc247620$export$b8f5890fc79d6aca = function(a) {
    return $92f4fea5bc247620$var$U.current.useRef(a);
};
$92f4fea5bc247620$export$60241385465d0a34 = function(a) {
    return $92f4fea5bc247620$var$U.current.useState(a);
};
$92f4fea5bc247620$export$306c0aa65ff9ec16 = function(a, b, e) {
    return $92f4fea5bc247620$var$U.current.useSyncExternalStore(a, b, e);
};
$92f4fea5bc247620$export$7b286972b8d8ccbf = function() {
    return $92f4fea5bc247620$var$U.current.useTransition();
};
$92f4fea5bc247620$export$83d89fbfd8236492 = "18.3.1";

});



parcelRegister("foRq4", function(module, exports) {

$parcel$export(module.exports, "__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED", function () { return $b36288e2db101ba3$export$ae55be85d98224ed; }, function (v) { return $b36288e2db101ba3$export$ae55be85d98224ed = v; });
$parcel$export(module.exports, "createPortal", function () { return $b36288e2db101ba3$export$d39a5bbd09211389; }, function (v) { return $b36288e2db101ba3$export$d39a5bbd09211389 = v; });
$parcel$export(module.exports, "createRoot", function () { return $b36288e2db101ba3$export$882461b6382ed46c; }, function (v) { return $b36288e2db101ba3$export$882461b6382ed46c = v; });
$parcel$export(module.exports, "findDOMNode", function () { return $b36288e2db101ba3$export$466bfc07425424d5; }, function (v) { return $b36288e2db101ba3$export$466bfc07425424d5 = v; });
$parcel$export(module.exports, "flushSync", function () { return $b36288e2db101ba3$export$cd75ccfd720a3cd4; }, function (v) { return $b36288e2db101ba3$export$cd75ccfd720a3cd4 = v; });
$parcel$export(module.exports, "hydrate", function () { return $b36288e2db101ba3$export$fa8d919ba61d84db; }, function (v) { return $b36288e2db101ba3$export$fa8d919ba61d84db = v; });
$parcel$export(module.exports, "hydrateRoot", function () { return $b36288e2db101ba3$export$757ceba2d55c277e; }, function (v) { return $b36288e2db101ba3$export$757ceba2d55c277e = v; });
$parcel$export(module.exports, "render", function () { return $b36288e2db101ba3$export$b3890eb0ae9dca99; }, function (v) { return $b36288e2db101ba3$export$b3890eb0ae9dca99 = v; });
$parcel$export(module.exports, "unmountComponentAtNode", function () { return $b36288e2db101ba3$export$502457920280e6be; }, function (v) { return $b36288e2db101ba3$export$502457920280e6be = v; });
$parcel$export(module.exports, "unstable_batchedUpdates", function () { return $b36288e2db101ba3$export$c78a37762a8d58e1; }, function (v) { return $b36288e2db101ba3$export$c78a37762a8d58e1 = v; });
$parcel$export(module.exports, "unstable_renderSubtreeIntoContainer", function () { return $b36288e2db101ba3$export$dc54d992c10e8a18; }, function (v) { return $b36288e2db101ba3$export$dc54d992c10e8a18 = v; });
$parcel$export(module.exports, "version", function () { return $b36288e2db101ba3$export$83d89fbfd8236492; }, function (v) { return $b36288e2db101ba3$export$83d89fbfd8236492 = v; });
/**
 * @license React
 * react-dom.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ /*
 Modernizr 3.0.0pre (Custom Build) | MIT
*/ var $b36288e2db101ba3$export$ae55be85d98224ed;
var $b36288e2db101ba3$export$d39a5bbd09211389;
var $b36288e2db101ba3$export$882461b6382ed46c;
var $b36288e2db101ba3$export$466bfc07425424d5;
var $b36288e2db101ba3$export$cd75ccfd720a3cd4;
var $b36288e2db101ba3$export$fa8d919ba61d84db;
var $b36288e2db101ba3$export$757ceba2d55c277e;
var $b36288e2db101ba3$export$b3890eb0ae9dca99;
var $b36288e2db101ba3$export$502457920280e6be;
var $b36288e2db101ba3$export$c78a37762a8d58e1;
var $b36288e2db101ba3$export$dc54d992c10e8a18;
var $b36288e2db101ba3$export$83d89fbfd8236492;
"use strict";

var $bh6RR = parcelRequire("bh6RR");

var $4LCdk = parcelRequire("4LCdk");
function $b36288e2db101ba3$var$p(a) {
    for(var b = "https://reactjs.org/docs/error-decoder.html?invariant=" + a, c = 1; c < arguments.length; c++)b += "&args[]=" + encodeURIComponent(arguments[c]);
    return "Minified React error #" + a + "; visit " + b + " for the full message or use the non-minified dev environment for full errors and additional helpful warnings.";
}
var $b36288e2db101ba3$var$da = new Set, $b36288e2db101ba3$var$ea = {};
function $b36288e2db101ba3$var$fa(a, b) {
    $b36288e2db101ba3$var$ha(a, b);
    $b36288e2db101ba3$var$ha(a + "Capture", b);
}
function $b36288e2db101ba3$var$ha(a, b) {
    $b36288e2db101ba3$var$ea[a] = b;
    for(a = 0; a < b.length; a++)$b36288e2db101ba3$var$da.add(b[a]);
}
var $b36288e2db101ba3$var$ia = !("undefined" === typeof window || "undefined" === typeof window.document || "undefined" === typeof window.document.createElement), $b36288e2db101ba3$var$ja = Object.prototype.hasOwnProperty, $b36288e2db101ba3$var$ka = /^[:A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD][:A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD\-.0-9\u00B7\u0300-\u036F\u203F-\u2040]*$/, $b36288e2db101ba3$var$la = {}, $b36288e2db101ba3$var$ma = {};
function $b36288e2db101ba3$var$oa(a) {
    if ($b36288e2db101ba3$var$ja.call($b36288e2db101ba3$var$ma, a)) return !0;
    if ($b36288e2db101ba3$var$ja.call($b36288e2db101ba3$var$la, a)) return !1;
    if ($b36288e2db101ba3$var$ka.test(a)) return $b36288e2db101ba3$var$ma[a] = !0;
    $b36288e2db101ba3$var$la[a] = !0;
    return !1;
}
function $b36288e2db101ba3$var$pa(a, b, c, d) {
    if (null !== c && 0 === c.type) return !1;
    switch(typeof b){
        case "function":
        case "symbol":
            return !0;
        case "boolean":
            if (d) return !1;
            if (null !== c) return !c.acceptsBooleans;
            a = a.toLowerCase().slice(0, 5);
            return "data-" !== a && "aria-" !== a;
        default:
            return !1;
    }
}
function $b36288e2db101ba3$var$qa(a, b, c, d) {
    if (null === b || "undefined" === typeof b || $b36288e2db101ba3$var$pa(a, b, c, d)) return !0;
    if (d) return !1;
    if (null !== c) switch(c.type){
        case 3:
            return !b;
        case 4:
            return !1 === b;
        case 5:
            return isNaN(b);
        case 6:
            return isNaN(b) || 1 > b;
    }
    return !1;
}
function $b36288e2db101ba3$var$v(a, b, c, d, e, f, g) {
    this.acceptsBooleans = 2 === b || 3 === b || 4 === b;
    this.attributeName = d;
    this.attributeNamespace = e;
    this.mustUseProperty = c;
    this.propertyName = a;
    this.type = b;
    this.sanitizeURL = f;
    this.removeEmptyString = g;
}
var $b36288e2db101ba3$var$z = {};
"children dangerouslySetInnerHTML defaultValue defaultChecked innerHTML suppressContentEditableWarning suppressHydrationWarning style".split(" ").forEach(function(a) {
    $b36288e2db101ba3$var$z[a] = new $b36288e2db101ba3$var$v(a, 0, !1, a, null, !1, !1);
});
[
    [
        "acceptCharset",
        "accept-charset"
    ],
    [
        "className",
        "class"
    ],
    [
        "htmlFor",
        "for"
    ],
    [
        "httpEquiv",
        "http-equiv"
    ]
].forEach(function(a) {
    var b = a[0];
    $b36288e2db101ba3$var$z[b] = new $b36288e2db101ba3$var$v(b, 1, !1, a[1], null, !1, !1);
});
[
    "contentEditable",
    "draggable",
    "spellCheck",
    "value"
].forEach(function(a) {
    $b36288e2db101ba3$var$z[a] = new $b36288e2db101ba3$var$v(a, 2, !1, a.toLowerCase(), null, !1, !1);
});
[
    "autoReverse",
    "externalResourcesRequired",
    "focusable",
    "preserveAlpha"
].forEach(function(a) {
    $b36288e2db101ba3$var$z[a] = new $b36288e2db101ba3$var$v(a, 2, !1, a, null, !1, !1);
});
"allowFullScreen async autoFocus autoPlay controls default defer disabled disablePictureInPicture disableRemotePlayback formNoValidate hidden loop noModule noValidate open playsInline readOnly required reversed scoped seamless itemScope".split(" ").forEach(function(a) {
    $b36288e2db101ba3$var$z[a] = new $b36288e2db101ba3$var$v(a, 3, !1, a.toLowerCase(), null, !1, !1);
});
[
    "checked",
    "multiple",
    "muted",
    "selected"
].forEach(function(a) {
    $b36288e2db101ba3$var$z[a] = new $b36288e2db101ba3$var$v(a, 3, !0, a, null, !1, !1);
});
[
    "capture",
    "download"
].forEach(function(a) {
    $b36288e2db101ba3$var$z[a] = new $b36288e2db101ba3$var$v(a, 4, !1, a, null, !1, !1);
});
[
    "cols",
    "rows",
    "size",
    "span"
].forEach(function(a) {
    $b36288e2db101ba3$var$z[a] = new $b36288e2db101ba3$var$v(a, 6, !1, a, null, !1, !1);
});
[
    "rowSpan",
    "start"
].forEach(function(a) {
    $b36288e2db101ba3$var$z[a] = new $b36288e2db101ba3$var$v(a, 5, !1, a.toLowerCase(), null, !1, !1);
});
var $b36288e2db101ba3$var$ra = /[\-:]([a-z])/g;
function $b36288e2db101ba3$var$sa(a) {
    return a[1].toUpperCase();
}
"accent-height alignment-baseline arabic-form baseline-shift cap-height clip-path clip-rule color-interpolation color-interpolation-filters color-profile color-rendering dominant-baseline enable-background fill-opacity fill-rule flood-color flood-opacity font-family font-size font-size-adjust font-stretch font-style font-variant font-weight glyph-name glyph-orientation-horizontal glyph-orientation-vertical horiz-adv-x horiz-origin-x image-rendering letter-spacing lighting-color marker-end marker-mid marker-start overline-position overline-thickness paint-order panose-1 pointer-events rendering-intent shape-rendering stop-color stop-opacity strikethrough-position strikethrough-thickness stroke-dasharray stroke-dashoffset stroke-linecap stroke-linejoin stroke-miterlimit stroke-opacity stroke-width text-anchor text-decoration text-rendering underline-position underline-thickness unicode-bidi unicode-range units-per-em v-alphabetic v-hanging v-ideographic v-mathematical vector-effect vert-adv-y vert-origin-x vert-origin-y word-spacing writing-mode xmlns:xlink x-height".split(" ").forEach(function(a) {
    var b = a.replace($b36288e2db101ba3$var$ra, $b36288e2db101ba3$var$sa);
    $b36288e2db101ba3$var$z[b] = new $b36288e2db101ba3$var$v(b, 1, !1, a, null, !1, !1);
});
"xlink:actuate xlink:arcrole xlink:role xlink:show xlink:title xlink:type".split(" ").forEach(function(a) {
    var b = a.replace($b36288e2db101ba3$var$ra, $b36288e2db101ba3$var$sa);
    $b36288e2db101ba3$var$z[b] = new $b36288e2db101ba3$var$v(b, 1, !1, a, "http://www.w3.org/1999/xlink", !1, !1);
});
[
    "xml:base",
    "xml:lang",
    "xml:space"
].forEach(function(a) {
    var b = a.replace($b36288e2db101ba3$var$ra, $b36288e2db101ba3$var$sa);
    $b36288e2db101ba3$var$z[b] = new $b36288e2db101ba3$var$v(b, 1, !1, a, "http://www.w3.org/XML/1998/namespace", !1, !1);
});
[
    "tabIndex",
    "crossOrigin"
].forEach(function(a) {
    $b36288e2db101ba3$var$z[a] = new $b36288e2db101ba3$var$v(a, 1, !1, a.toLowerCase(), null, !1, !1);
});
$b36288e2db101ba3$var$z.xlinkHref = new $b36288e2db101ba3$var$v("xlinkHref", 1, !1, "xlink:href", "http://www.w3.org/1999/xlink", !0, !1);
[
    "src",
    "href",
    "action",
    "formAction"
].forEach(function(a) {
    $b36288e2db101ba3$var$z[a] = new $b36288e2db101ba3$var$v(a, 1, !1, a.toLowerCase(), null, !0, !0);
});
function $b36288e2db101ba3$var$ta(a, b, c, d) {
    var e = $b36288e2db101ba3$var$z.hasOwnProperty(b) ? $b36288e2db101ba3$var$z[b] : null;
    if (null !== e ? 0 !== e.type : d || !(2 < b.length) || "o" !== b[0] && "O" !== b[0] || "n" !== b[1] && "N" !== b[1]) $b36288e2db101ba3$var$qa(b, c, e, d) && (c = null), d || null === e ? $b36288e2db101ba3$var$oa(b) && (null === c ? a.removeAttribute(b) : a.setAttribute(b, "" + c)) : e.mustUseProperty ? a[e.propertyName] = null === c ? 3 === e.type ? !1 : "" : c : (b = e.attributeName, d = e.attributeNamespace, null === c ? a.removeAttribute(b) : (e = e.type, c = 3 === e || 4 === e && !0 === c ? "" : "" + c, d ? a.setAttributeNS(d, b, c) : a.setAttribute(b, c)));
}
var $b36288e2db101ba3$var$ua = $bh6RR.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED, $b36288e2db101ba3$var$va = Symbol.for("react.element"), $b36288e2db101ba3$var$wa = Symbol.for("react.portal"), $b36288e2db101ba3$var$ya = Symbol.for("react.fragment"), $b36288e2db101ba3$var$za = Symbol.for("react.strict_mode"), $b36288e2db101ba3$var$Aa = Symbol.for("react.profiler"), $b36288e2db101ba3$var$Ba = Symbol.for("react.provider"), $b36288e2db101ba3$var$Ca = Symbol.for("react.context"), $b36288e2db101ba3$var$Da = Symbol.for("react.forward_ref"), $b36288e2db101ba3$var$Ea = Symbol.for("react.suspense"), $b36288e2db101ba3$var$Fa = Symbol.for("react.suspense_list"), $b36288e2db101ba3$var$Ga = Symbol.for("react.memo"), $b36288e2db101ba3$var$Ha = Symbol.for("react.lazy");
Symbol.for("react.scope");
Symbol.for("react.debug_trace_mode");
var $b36288e2db101ba3$var$Ia = Symbol.for("react.offscreen");
Symbol.for("react.legacy_hidden");
Symbol.for("react.cache");
Symbol.for("react.tracing_marker");
var $b36288e2db101ba3$var$Ja = Symbol.iterator;
function $b36288e2db101ba3$var$Ka(a) {
    if (null === a || "object" !== typeof a) return null;
    a = $b36288e2db101ba3$var$Ja && a[$b36288e2db101ba3$var$Ja] || a["@@iterator"];
    return "function" === typeof a ? a : null;
}
var $b36288e2db101ba3$var$A = Object.assign, $b36288e2db101ba3$var$La;
function $b36288e2db101ba3$var$Ma(a) {
    if (void 0 === $b36288e2db101ba3$var$La) try {
        throw Error();
    } catch (c) {
        var b = c.stack.trim().match(/\n( *(at )?)/);
        $b36288e2db101ba3$var$La = b && b[1] || "";
    }
    return "\n" + $b36288e2db101ba3$var$La + a;
}
var $b36288e2db101ba3$var$Na = !1;
function $b36288e2db101ba3$var$Oa(a, b) {
    if (!a || $b36288e2db101ba3$var$Na) return "";
    $b36288e2db101ba3$var$Na = !0;
    var c = Error.prepareStackTrace;
    Error.prepareStackTrace = void 0;
    try {
        if (b) {
            if (b = function() {
                throw Error();
            }, Object.defineProperty(b.prototype, "props", {
                set: function() {
                    throw Error();
                }
            }), "object" === typeof Reflect && Reflect.construct) {
                try {
                    Reflect.construct(b, []);
                } catch (l) {
                    var d = l;
                }
                Reflect.construct(a, [], b);
            } else {
                try {
                    b.call();
                } catch (l) {
                    d = l;
                }
                a.call(b.prototype);
            }
        } else {
            try {
                throw Error();
            } catch (l) {
                d = l;
            }
            a();
        }
    } catch (l) {
        if (l && d && "string" === typeof l.stack) {
            for(var e = l.stack.split("\n"), f = d.stack.split("\n"), g = e.length - 1, h = f.length - 1; 1 <= g && 0 <= h && e[g] !== f[h];)h--;
            for(; 1 <= g && 0 <= h; g--, h--)if (e[g] !== f[h]) {
                if (1 !== g || 1 !== h) {
                    do if (g--, h--, 0 > h || e[g] !== f[h]) {
                        var k = "\n" + e[g].replace(" at new ", " at ");
                        a.displayName && k.includes("<anonymous>") && (k = k.replace("<anonymous>", a.displayName));
                        return k;
                    }
                    while (1 <= g && 0 <= h);
                }
                break;
            }
        }
    } finally{
        $b36288e2db101ba3$var$Na = !1, Error.prepareStackTrace = c;
    }
    return (a = a ? a.displayName || a.name : "") ? $b36288e2db101ba3$var$Ma(a) : "";
}
function $b36288e2db101ba3$var$Pa(a) {
    switch(a.tag){
        case 5:
            return $b36288e2db101ba3$var$Ma(a.type);
        case 16:
            return $b36288e2db101ba3$var$Ma("Lazy");
        case 13:
            return $b36288e2db101ba3$var$Ma("Suspense");
        case 19:
            return $b36288e2db101ba3$var$Ma("SuspenseList");
        case 0:
        case 2:
        case 15:
            return a = $b36288e2db101ba3$var$Oa(a.type, !1), a;
        case 11:
            return a = $b36288e2db101ba3$var$Oa(a.type.render, !1), a;
        case 1:
            return a = $b36288e2db101ba3$var$Oa(a.type, !0), a;
        default:
            return "";
    }
}
function $b36288e2db101ba3$var$Qa(a) {
    if (null == a) return null;
    if ("function" === typeof a) return a.displayName || a.name || null;
    if ("string" === typeof a) return a;
    switch(a){
        case $b36288e2db101ba3$var$ya:
            return "Fragment";
        case $b36288e2db101ba3$var$wa:
            return "Portal";
        case $b36288e2db101ba3$var$Aa:
            return "Profiler";
        case $b36288e2db101ba3$var$za:
            return "StrictMode";
        case $b36288e2db101ba3$var$Ea:
            return "Suspense";
        case $b36288e2db101ba3$var$Fa:
            return "SuspenseList";
    }
    if ("object" === typeof a) switch(a.$$typeof){
        case $b36288e2db101ba3$var$Ca:
            return (a.displayName || "Context") + ".Consumer";
        case $b36288e2db101ba3$var$Ba:
            return (a._context.displayName || "Context") + ".Provider";
        case $b36288e2db101ba3$var$Da:
            var b = a.render;
            a = a.displayName;
            a || (a = b.displayName || b.name || "", a = "" !== a ? "ForwardRef(" + a + ")" : "ForwardRef");
            return a;
        case $b36288e2db101ba3$var$Ga:
            return b = a.displayName || null, null !== b ? b : $b36288e2db101ba3$var$Qa(a.type) || "Memo";
        case $b36288e2db101ba3$var$Ha:
            b = a._payload;
            a = a._init;
            try {
                return $b36288e2db101ba3$var$Qa(a(b));
            } catch (c) {}
    }
    return null;
}
function $b36288e2db101ba3$var$Ra(a) {
    var b = a.type;
    switch(a.tag){
        case 24:
            return "Cache";
        case 9:
            return (b.displayName || "Context") + ".Consumer";
        case 10:
            return (b._context.displayName || "Context") + ".Provider";
        case 18:
            return "DehydratedFragment";
        case 11:
            return a = b.render, a = a.displayName || a.name || "", b.displayName || ("" !== a ? "ForwardRef(" + a + ")" : "ForwardRef");
        case 7:
            return "Fragment";
        case 5:
            return b;
        case 4:
            return "Portal";
        case 3:
            return "Root";
        case 6:
            return "Text";
        case 16:
            return $b36288e2db101ba3$var$Qa(b);
        case 8:
            return b === $b36288e2db101ba3$var$za ? "StrictMode" : "Mode";
        case 22:
            return "Offscreen";
        case 12:
            return "Profiler";
        case 21:
            return "Scope";
        case 13:
            return "Suspense";
        case 19:
            return "SuspenseList";
        case 25:
            return "TracingMarker";
        case 1:
        case 0:
        case 17:
        case 2:
        case 14:
        case 15:
            if ("function" === typeof b) return b.displayName || b.name || null;
            if ("string" === typeof b) return b;
    }
    return null;
}
function $b36288e2db101ba3$var$Sa(a) {
    switch(typeof a){
        case "boolean":
        case "number":
        case "string":
        case "undefined":
            return a;
        case "object":
            return a;
        default:
            return "";
    }
}
function $b36288e2db101ba3$var$Ta(a) {
    var b = a.type;
    return (a = a.nodeName) && "input" === a.toLowerCase() && ("checkbox" === b || "radio" === b);
}
function $b36288e2db101ba3$var$Ua(a) {
    var b = $b36288e2db101ba3$var$Ta(a) ? "checked" : "value", c = Object.getOwnPropertyDescriptor(a.constructor.prototype, b), d = "" + a[b];
    if (!a.hasOwnProperty(b) && "undefined" !== typeof c && "function" === typeof c.get && "function" === typeof c.set) {
        var e = c.get, f = c.set;
        Object.defineProperty(a, b, {
            configurable: !0,
            get: function() {
                return e.call(this);
            },
            set: function(a) {
                d = "" + a;
                f.call(this, a);
            }
        });
        Object.defineProperty(a, b, {
            enumerable: c.enumerable
        });
        return {
            getValue: function() {
                return d;
            },
            setValue: function(a) {
                d = "" + a;
            },
            stopTracking: function() {
                a._valueTracker = null;
                delete a[b];
            }
        };
    }
}
function $b36288e2db101ba3$var$Va(a) {
    a._valueTracker || (a._valueTracker = $b36288e2db101ba3$var$Ua(a));
}
function $b36288e2db101ba3$var$Wa(a) {
    if (!a) return !1;
    var b = a._valueTracker;
    if (!b) return !0;
    var c = b.getValue();
    var d = "";
    a && (d = $b36288e2db101ba3$var$Ta(a) ? a.checked ? "true" : "false" : a.value);
    a = d;
    return a !== c ? (b.setValue(a), !0) : !1;
}
function $b36288e2db101ba3$var$Xa(a) {
    a = a || ("undefined" !== typeof document ? document : void 0);
    if ("undefined" === typeof a) return null;
    try {
        return a.activeElement || a.body;
    } catch (b) {
        return a.body;
    }
}
function $b36288e2db101ba3$var$Ya(a, b) {
    var c = b.checked;
    return $b36288e2db101ba3$var$A({}, b, {
        defaultChecked: void 0,
        defaultValue: void 0,
        value: void 0,
        checked: null != c ? c : a._wrapperState.initialChecked
    });
}
function $b36288e2db101ba3$var$Za(a, b) {
    var c = null == b.defaultValue ? "" : b.defaultValue, d = null != b.checked ? b.checked : b.defaultChecked;
    c = $b36288e2db101ba3$var$Sa(null != b.value ? b.value : c);
    a._wrapperState = {
        initialChecked: d,
        initialValue: c,
        controlled: "checkbox" === b.type || "radio" === b.type ? null != b.checked : null != b.value
    };
}
function $b36288e2db101ba3$var$ab(a, b) {
    b = b.checked;
    null != b && $b36288e2db101ba3$var$ta(a, "checked", b, !1);
}
function $b36288e2db101ba3$var$bb(a, b) {
    $b36288e2db101ba3$var$ab(a, b);
    var c = $b36288e2db101ba3$var$Sa(b.value), d = b.type;
    if (null != c) {
        if ("number" === d) {
            if (0 === c && "" === a.value || a.value != c) a.value = "" + c;
        } else a.value !== "" + c && (a.value = "" + c);
    } else if ("submit" === d || "reset" === d) {
        a.removeAttribute("value");
        return;
    }
    b.hasOwnProperty("value") ? $b36288e2db101ba3$var$cb(a, b.type, c) : b.hasOwnProperty("defaultValue") && $b36288e2db101ba3$var$cb(a, b.type, $b36288e2db101ba3$var$Sa(b.defaultValue));
    null == b.checked && null != b.defaultChecked && (a.defaultChecked = !!b.defaultChecked);
}
function $b36288e2db101ba3$var$db(a, b, c) {
    if (b.hasOwnProperty("value") || b.hasOwnProperty("defaultValue")) {
        var d = b.type;
        if (!("submit" !== d && "reset" !== d || void 0 !== b.value && null !== b.value)) return;
        b = "" + a._wrapperState.initialValue;
        c || b === a.value || (a.value = b);
        a.defaultValue = b;
    }
    c = a.name;
    "" !== c && (a.name = "");
    a.defaultChecked = !!a._wrapperState.initialChecked;
    "" !== c && (a.name = c);
}
function $b36288e2db101ba3$var$cb(a, b, c) {
    if ("number" !== b || $b36288e2db101ba3$var$Xa(a.ownerDocument) !== a) null == c ? a.defaultValue = "" + a._wrapperState.initialValue : a.defaultValue !== "" + c && (a.defaultValue = "" + c);
}
var $b36288e2db101ba3$var$eb = Array.isArray;
function $b36288e2db101ba3$var$fb(a, b, c, d) {
    a = a.options;
    if (b) {
        b = {};
        for(var e = 0; e < c.length; e++)b["$" + c[e]] = !0;
        for(c = 0; c < a.length; c++)e = b.hasOwnProperty("$" + a[c].value), a[c].selected !== e && (a[c].selected = e), e && d && (a[c].defaultSelected = !0);
    } else {
        c = "" + $b36288e2db101ba3$var$Sa(c);
        b = null;
        for(e = 0; e < a.length; e++){
            if (a[e].value === c) {
                a[e].selected = !0;
                d && (a[e].defaultSelected = !0);
                return;
            }
            null !== b || a[e].disabled || (b = a[e]);
        }
        null !== b && (b.selected = !0);
    }
}
function $b36288e2db101ba3$var$gb(a, b) {
    if (null != b.dangerouslySetInnerHTML) throw Error($b36288e2db101ba3$var$p(91));
    return $b36288e2db101ba3$var$A({}, b, {
        value: void 0,
        defaultValue: void 0,
        children: "" + a._wrapperState.initialValue
    });
}
function $b36288e2db101ba3$var$hb(a, b) {
    var c = b.value;
    if (null == c) {
        c = b.children;
        b = b.defaultValue;
        if (null != c) {
            if (null != b) throw Error($b36288e2db101ba3$var$p(92));
            if ($b36288e2db101ba3$var$eb(c)) {
                if (1 < c.length) throw Error($b36288e2db101ba3$var$p(93));
                c = c[0];
            }
            b = c;
        }
        null == b && (b = "");
        c = b;
    }
    a._wrapperState = {
        initialValue: $b36288e2db101ba3$var$Sa(c)
    };
}
function $b36288e2db101ba3$var$ib(a, b) {
    var c = $b36288e2db101ba3$var$Sa(b.value), d = $b36288e2db101ba3$var$Sa(b.defaultValue);
    null != c && (c = "" + c, c !== a.value && (a.value = c), null == b.defaultValue && a.defaultValue !== c && (a.defaultValue = c));
    null != d && (a.defaultValue = "" + d);
}
function $b36288e2db101ba3$var$jb(a) {
    var b = a.textContent;
    b === a._wrapperState.initialValue && "" !== b && null !== b && (a.value = b);
}
function $b36288e2db101ba3$var$kb(a) {
    switch(a){
        case "svg":
            return "http://www.w3.org/2000/svg";
        case "math":
            return "http://www.w3.org/1998/Math/MathML";
        default:
            return "http://www.w3.org/1999/xhtml";
    }
}
function $b36288e2db101ba3$var$lb(a, b) {
    return null == a || "http://www.w3.org/1999/xhtml" === a ? $b36288e2db101ba3$var$kb(b) : "http://www.w3.org/2000/svg" === a && "foreignObject" === b ? "http://www.w3.org/1999/xhtml" : a;
}
var $b36288e2db101ba3$var$mb, $b36288e2db101ba3$var$nb = function(a) {
    return "undefined" !== typeof MSApp && MSApp.execUnsafeLocalFunction ? function(b, c, d, e) {
        MSApp.execUnsafeLocalFunction(function() {
            return a(b, c, d, e);
        });
    } : a;
}(function(a, b) {
    if ("http://www.w3.org/2000/svg" !== a.namespaceURI || "innerHTML" in a) a.innerHTML = b;
    else {
        $b36288e2db101ba3$var$mb = $b36288e2db101ba3$var$mb || document.createElement("div");
        $b36288e2db101ba3$var$mb.innerHTML = "<svg>" + b.valueOf().toString() + "</svg>";
        for(b = $b36288e2db101ba3$var$mb.firstChild; a.firstChild;)a.removeChild(a.firstChild);
        for(; b.firstChild;)a.appendChild(b.firstChild);
    }
});
function $b36288e2db101ba3$var$ob(a, b) {
    if (b) {
        var c = a.firstChild;
        if (c && c === a.lastChild && 3 === c.nodeType) {
            c.nodeValue = b;
            return;
        }
    }
    a.textContent = b;
}
var $b36288e2db101ba3$var$pb = {
    animationIterationCount: !0,
    aspectRatio: !0,
    borderImageOutset: !0,
    borderImageSlice: !0,
    borderImageWidth: !0,
    boxFlex: !0,
    boxFlexGroup: !0,
    boxOrdinalGroup: !0,
    columnCount: !0,
    columns: !0,
    flex: !0,
    flexGrow: !0,
    flexPositive: !0,
    flexShrink: !0,
    flexNegative: !0,
    flexOrder: !0,
    gridArea: !0,
    gridRow: !0,
    gridRowEnd: !0,
    gridRowSpan: !0,
    gridRowStart: !0,
    gridColumn: !0,
    gridColumnEnd: !0,
    gridColumnSpan: !0,
    gridColumnStart: !0,
    fontWeight: !0,
    lineClamp: !0,
    lineHeight: !0,
    opacity: !0,
    order: !0,
    orphans: !0,
    tabSize: !0,
    widows: !0,
    zIndex: !0,
    zoom: !0,
    fillOpacity: !0,
    floodOpacity: !0,
    stopOpacity: !0,
    strokeDasharray: !0,
    strokeDashoffset: !0,
    strokeMiterlimit: !0,
    strokeOpacity: !0,
    strokeWidth: !0
}, $b36288e2db101ba3$var$qb = [
    "Webkit",
    "ms",
    "Moz",
    "O"
];
Object.keys($b36288e2db101ba3$var$pb).forEach(function(a) {
    $b36288e2db101ba3$var$qb.forEach(function(b) {
        b = b + a.charAt(0).toUpperCase() + a.substring(1);
        $b36288e2db101ba3$var$pb[b] = $b36288e2db101ba3$var$pb[a];
    });
});
function $b36288e2db101ba3$var$rb(a, b, c) {
    return null == b || "boolean" === typeof b || "" === b ? "" : c || "number" !== typeof b || 0 === b || $b36288e2db101ba3$var$pb.hasOwnProperty(a) && $b36288e2db101ba3$var$pb[a] ? ("" + b).trim() : b + "px";
}
function $b36288e2db101ba3$var$sb(a, b) {
    a = a.style;
    for(var c in b)if (b.hasOwnProperty(c)) {
        var d = 0 === c.indexOf("--"), e = $b36288e2db101ba3$var$rb(c, b[c], d);
        "float" === c && (c = "cssFloat");
        d ? a.setProperty(c, e) : a[c] = e;
    }
}
var $b36288e2db101ba3$var$tb = $b36288e2db101ba3$var$A({
    menuitem: !0
}, {
    area: !0,
    base: !0,
    br: !0,
    col: !0,
    embed: !0,
    hr: !0,
    img: !0,
    input: !0,
    keygen: !0,
    link: !0,
    meta: !0,
    param: !0,
    source: !0,
    track: !0,
    wbr: !0
});
function $b36288e2db101ba3$var$ub(a, b) {
    if (b) {
        if ($b36288e2db101ba3$var$tb[a] && (null != b.children || null != b.dangerouslySetInnerHTML)) throw Error($b36288e2db101ba3$var$p(137, a));
        if (null != b.dangerouslySetInnerHTML) {
            if (null != b.children) throw Error($b36288e2db101ba3$var$p(60));
            if ("object" !== typeof b.dangerouslySetInnerHTML || !("__html" in b.dangerouslySetInnerHTML)) throw Error($b36288e2db101ba3$var$p(61));
        }
        if (null != b.style && "object" !== typeof b.style) throw Error($b36288e2db101ba3$var$p(62));
    }
}
function $b36288e2db101ba3$var$vb(a, b) {
    if (-1 === a.indexOf("-")) return "string" === typeof b.is;
    switch(a){
        case "annotation-xml":
        case "color-profile":
        case "font-face":
        case "font-face-src":
        case "font-face-uri":
        case "font-face-format":
        case "font-face-name":
        case "missing-glyph":
            return !1;
        default:
            return !0;
    }
}
var $b36288e2db101ba3$var$wb = null;
function $b36288e2db101ba3$var$xb(a) {
    a = a.target || a.srcElement || window;
    a.correspondingUseElement && (a = a.correspondingUseElement);
    return 3 === a.nodeType ? a.parentNode : a;
}
var $b36288e2db101ba3$var$yb = null, $b36288e2db101ba3$var$zb = null, $b36288e2db101ba3$var$Ab = null;
function $b36288e2db101ba3$var$Bb(a) {
    if (a = $b36288e2db101ba3$var$Cb(a)) {
        if ("function" !== typeof $b36288e2db101ba3$var$yb) throw Error($b36288e2db101ba3$var$p(280));
        var b = a.stateNode;
        b && (b = $b36288e2db101ba3$var$Db(b), $b36288e2db101ba3$var$yb(a.stateNode, a.type, b));
    }
}
function $b36288e2db101ba3$var$Eb(a) {
    $b36288e2db101ba3$var$zb ? $b36288e2db101ba3$var$Ab ? $b36288e2db101ba3$var$Ab.push(a) : $b36288e2db101ba3$var$Ab = [
        a
    ] : $b36288e2db101ba3$var$zb = a;
}
function $b36288e2db101ba3$var$Fb() {
    if ($b36288e2db101ba3$var$zb) {
        var a = $b36288e2db101ba3$var$zb, b = $b36288e2db101ba3$var$Ab;
        $b36288e2db101ba3$var$Ab = $b36288e2db101ba3$var$zb = null;
        $b36288e2db101ba3$var$Bb(a);
        if (b) for(a = 0; a < b.length; a++)$b36288e2db101ba3$var$Bb(b[a]);
    }
}
function $b36288e2db101ba3$var$Gb(a, b) {
    return a(b);
}
function $b36288e2db101ba3$var$Hb() {}
var $b36288e2db101ba3$var$Ib = !1;
function $b36288e2db101ba3$var$Jb(a, b, c) {
    if ($b36288e2db101ba3$var$Ib) return a(b, c);
    $b36288e2db101ba3$var$Ib = !0;
    try {
        return $b36288e2db101ba3$var$Gb(a, b, c);
    } finally{
        if ($b36288e2db101ba3$var$Ib = !1, null !== $b36288e2db101ba3$var$zb || null !== $b36288e2db101ba3$var$Ab) $b36288e2db101ba3$var$Hb(), $b36288e2db101ba3$var$Fb();
    }
}
function $b36288e2db101ba3$var$Kb(a, b) {
    var c = a.stateNode;
    if (null === c) return null;
    var d = $b36288e2db101ba3$var$Db(c);
    if (null === d) return null;
    c = d[b];
    a: switch(b){
        case "onClick":
        case "onClickCapture":
        case "onDoubleClick":
        case "onDoubleClickCapture":
        case "onMouseDown":
        case "onMouseDownCapture":
        case "onMouseMove":
        case "onMouseMoveCapture":
        case "onMouseUp":
        case "onMouseUpCapture":
        case "onMouseEnter":
            (d = !d.disabled) || (a = a.type, d = !("button" === a || "input" === a || "select" === a || "textarea" === a));
            a = !d;
            break a;
        default:
            a = !1;
    }
    if (a) return null;
    if (c && "function" !== typeof c) throw Error($b36288e2db101ba3$var$p(231, b, typeof c));
    return c;
}
var $b36288e2db101ba3$var$Lb = !1;
if ($b36288e2db101ba3$var$ia) try {
    var $b36288e2db101ba3$var$Mb = {};
    Object.defineProperty($b36288e2db101ba3$var$Mb, "passive", {
        get: function() {
            $b36288e2db101ba3$var$Lb = !0;
        }
    });
    window.addEventListener("test", $b36288e2db101ba3$var$Mb, $b36288e2db101ba3$var$Mb);
    window.removeEventListener("test", $b36288e2db101ba3$var$Mb, $b36288e2db101ba3$var$Mb);
} catch (a) {
    $b36288e2db101ba3$var$Lb = !1;
}
function $b36288e2db101ba3$var$Nb(a, b, c, d, e, f, g, h, k) {
    var l = Array.prototype.slice.call(arguments, 3);
    try {
        b.apply(c, l);
    } catch (m) {
        this.onError(m);
    }
}
var $b36288e2db101ba3$var$Ob = !1, $b36288e2db101ba3$var$Pb = null, $b36288e2db101ba3$var$Qb = !1, $b36288e2db101ba3$var$Rb = null, $b36288e2db101ba3$var$Sb = {
    onError: function(a) {
        $b36288e2db101ba3$var$Ob = !0;
        $b36288e2db101ba3$var$Pb = a;
    }
};
function $b36288e2db101ba3$var$Tb(a, b, c, d, e, f, g, h, k) {
    $b36288e2db101ba3$var$Ob = !1;
    $b36288e2db101ba3$var$Pb = null;
    $b36288e2db101ba3$var$Nb.apply($b36288e2db101ba3$var$Sb, arguments);
}
function $b36288e2db101ba3$var$Ub(a, b, c, d, e, f, g, h, k) {
    $b36288e2db101ba3$var$Tb.apply(this, arguments);
    if ($b36288e2db101ba3$var$Ob) {
        if ($b36288e2db101ba3$var$Ob) {
            var l = $b36288e2db101ba3$var$Pb;
            $b36288e2db101ba3$var$Ob = !1;
            $b36288e2db101ba3$var$Pb = null;
        } else throw Error($b36288e2db101ba3$var$p(198));
        $b36288e2db101ba3$var$Qb || ($b36288e2db101ba3$var$Qb = !0, $b36288e2db101ba3$var$Rb = l);
    }
}
function $b36288e2db101ba3$var$Vb(a) {
    var b = a, c = a;
    if (a.alternate) for(; b.return;)b = b.return;
    else {
        a = b;
        do b = a, 0 !== (b.flags & 4098) && (c = b.return), a = b.return;
        while (a);
    }
    return 3 === b.tag ? c : null;
}
function $b36288e2db101ba3$var$Wb(a) {
    if (13 === a.tag) {
        var b = a.memoizedState;
        null === b && (a = a.alternate, null !== a && (b = a.memoizedState));
        if (null !== b) return b.dehydrated;
    }
    return null;
}
function $b36288e2db101ba3$var$Xb(a) {
    if ($b36288e2db101ba3$var$Vb(a) !== a) throw Error($b36288e2db101ba3$var$p(188));
}
function $b36288e2db101ba3$var$Yb(a) {
    var b = a.alternate;
    if (!b) {
        b = $b36288e2db101ba3$var$Vb(a);
        if (null === b) throw Error($b36288e2db101ba3$var$p(188));
        return b !== a ? null : a;
    }
    for(var c = a, d = b;;){
        var e = c.return;
        if (null === e) break;
        var f = e.alternate;
        if (null === f) {
            d = e.return;
            if (null !== d) {
                c = d;
                continue;
            }
            break;
        }
        if (e.child === f.child) {
            for(f = e.child; f;){
                if (f === c) return $b36288e2db101ba3$var$Xb(e), a;
                if (f === d) return $b36288e2db101ba3$var$Xb(e), b;
                f = f.sibling;
            }
            throw Error($b36288e2db101ba3$var$p(188));
        }
        if (c.return !== d.return) c = e, d = f;
        else {
            for(var g = !1, h = e.child; h;){
                if (h === c) {
                    g = !0;
                    c = e;
                    d = f;
                    break;
                }
                if (h === d) {
                    g = !0;
                    d = e;
                    c = f;
                    break;
                }
                h = h.sibling;
            }
            if (!g) {
                for(h = f.child; h;){
                    if (h === c) {
                        g = !0;
                        c = f;
                        d = e;
                        break;
                    }
                    if (h === d) {
                        g = !0;
                        d = f;
                        c = e;
                        break;
                    }
                    h = h.sibling;
                }
                if (!g) throw Error($b36288e2db101ba3$var$p(189));
            }
        }
        if (c.alternate !== d) throw Error($b36288e2db101ba3$var$p(190));
    }
    if (3 !== c.tag) throw Error($b36288e2db101ba3$var$p(188));
    return c.stateNode.current === c ? a : b;
}
function $b36288e2db101ba3$var$Zb(a) {
    a = $b36288e2db101ba3$var$Yb(a);
    return null !== a ? $b36288e2db101ba3$var$$b(a) : null;
}
function $b36288e2db101ba3$var$$b(a) {
    if (5 === a.tag || 6 === a.tag) return a;
    for(a = a.child; null !== a;){
        var b = $b36288e2db101ba3$var$$b(a);
        if (null !== b) return b;
        a = a.sibling;
    }
    return null;
}
var $b36288e2db101ba3$var$ac = $4LCdk.unstable_scheduleCallback, $b36288e2db101ba3$var$bc = $4LCdk.unstable_cancelCallback, $b36288e2db101ba3$var$cc = $4LCdk.unstable_shouldYield, $b36288e2db101ba3$var$dc = $4LCdk.unstable_requestPaint, $b36288e2db101ba3$var$B = $4LCdk.unstable_now, $b36288e2db101ba3$var$ec = $4LCdk.unstable_getCurrentPriorityLevel, $b36288e2db101ba3$var$fc = $4LCdk.unstable_ImmediatePriority, $b36288e2db101ba3$var$gc = $4LCdk.unstable_UserBlockingPriority, $b36288e2db101ba3$var$hc = $4LCdk.unstable_NormalPriority, $b36288e2db101ba3$var$ic = $4LCdk.unstable_LowPriority, $b36288e2db101ba3$var$jc = $4LCdk.unstable_IdlePriority, $b36288e2db101ba3$var$kc = null, $b36288e2db101ba3$var$lc = null;
function $b36288e2db101ba3$var$mc(a) {
    if ($b36288e2db101ba3$var$lc && "function" === typeof $b36288e2db101ba3$var$lc.onCommitFiberRoot) try {
        $b36288e2db101ba3$var$lc.onCommitFiberRoot($b36288e2db101ba3$var$kc, a, void 0, 128 === (a.current.flags & 128));
    } catch (b) {}
}
var $b36288e2db101ba3$var$oc = Math.clz32 ? Math.clz32 : $b36288e2db101ba3$var$nc, $b36288e2db101ba3$var$pc = Math.log, $b36288e2db101ba3$var$qc = Math.LN2;
function $b36288e2db101ba3$var$nc(a) {
    a >>>= 0;
    return 0 === a ? 32 : 31 - ($b36288e2db101ba3$var$pc(a) / $b36288e2db101ba3$var$qc | 0) | 0;
}
var $b36288e2db101ba3$var$rc = 64, $b36288e2db101ba3$var$sc = 4194304;
function $b36288e2db101ba3$var$tc(a) {
    switch(a & -a){
        case 1:
            return 1;
        case 2:
            return 2;
        case 4:
            return 4;
        case 8:
            return 8;
        case 16:
            return 16;
        case 32:
            return 32;
        case 64:
        case 128:
        case 256:
        case 512:
        case 1024:
        case 2048:
        case 4096:
        case 8192:
        case 16384:
        case 32768:
        case 65536:
        case 131072:
        case 262144:
        case 524288:
        case 1048576:
        case 2097152:
            return a & 4194240;
        case 4194304:
        case 8388608:
        case 16777216:
        case 33554432:
        case 67108864:
            return a & 130023424;
        case 134217728:
            return 134217728;
        case 268435456:
            return 268435456;
        case 536870912:
            return 536870912;
        case 1073741824:
            return 1073741824;
        default:
            return a;
    }
}
function $b36288e2db101ba3$var$uc(a, b) {
    var c = a.pendingLanes;
    if (0 === c) return 0;
    var d = 0, e = a.suspendedLanes, f = a.pingedLanes, g = c & 268435455;
    if (0 !== g) {
        var h = g & ~e;
        0 !== h ? d = $b36288e2db101ba3$var$tc(h) : (f &= g, 0 !== f && (d = $b36288e2db101ba3$var$tc(f)));
    } else g = c & ~e, 0 !== g ? d = $b36288e2db101ba3$var$tc(g) : 0 !== f && (d = $b36288e2db101ba3$var$tc(f));
    if (0 === d) return 0;
    if (0 !== b && b !== d && 0 === (b & e) && (e = d & -d, f = b & -b, e >= f || 16 === e && 0 !== (f & 4194240))) return b;
    0 !== (d & 4) && (d |= c & 16);
    b = a.entangledLanes;
    if (0 !== b) for(a = a.entanglements, b &= d; 0 < b;)c = 31 - $b36288e2db101ba3$var$oc(b), e = 1 << c, d |= a[c], b &= ~e;
    return d;
}
function $b36288e2db101ba3$var$vc(a, b) {
    switch(a){
        case 1:
        case 2:
        case 4:
            return b + 250;
        case 8:
        case 16:
        case 32:
        case 64:
        case 128:
        case 256:
        case 512:
        case 1024:
        case 2048:
        case 4096:
        case 8192:
        case 16384:
        case 32768:
        case 65536:
        case 131072:
        case 262144:
        case 524288:
        case 1048576:
        case 2097152:
            return b + 5E3;
        case 4194304:
        case 8388608:
        case 16777216:
        case 33554432:
        case 67108864:
            return -1;
        case 134217728:
        case 268435456:
        case 536870912:
        case 1073741824:
            return -1;
        default:
            return -1;
    }
}
function $b36288e2db101ba3$var$wc(a, b) {
    for(var c = a.suspendedLanes, d = a.pingedLanes, e = a.expirationTimes, f = a.pendingLanes; 0 < f;){
        var g = 31 - $b36288e2db101ba3$var$oc(f), h = 1 << g, k = e[g];
        if (-1 === k) {
            if (0 === (h & c) || 0 !== (h & d)) e[g] = $b36288e2db101ba3$var$vc(h, b);
        } else k <= b && (a.expiredLanes |= h);
        f &= ~h;
    }
}
function $b36288e2db101ba3$var$xc(a) {
    a = a.pendingLanes & -1073741825;
    return 0 !== a ? a : a & 1073741824 ? 1073741824 : 0;
}
function $b36288e2db101ba3$var$yc() {
    var a = $b36288e2db101ba3$var$rc;
    $b36288e2db101ba3$var$rc <<= 1;
    0 === ($b36288e2db101ba3$var$rc & 4194240) && ($b36288e2db101ba3$var$rc = 64);
    return a;
}
function $b36288e2db101ba3$var$zc(a) {
    for(var b = [], c = 0; 31 > c; c++)b.push(a);
    return b;
}
function $b36288e2db101ba3$var$Ac(a, b, c) {
    a.pendingLanes |= b;
    536870912 !== b && (a.suspendedLanes = 0, a.pingedLanes = 0);
    a = a.eventTimes;
    b = 31 - $b36288e2db101ba3$var$oc(b);
    a[b] = c;
}
function $b36288e2db101ba3$var$Bc(a, b) {
    var c = a.pendingLanes & ~b;
    a.pendingLanes = b;
    a.suspendedLanes = 0;
    a.pingedLanes = 0;
    a.expiredLanes &= b;
    a.mutableReadLanes &= b;
    a.entangledLanes &= b;
    b = a.entanglements;
    var d = a.eventTimes;
    for(a = a.expirationTimes; 0 < c;){
        var e = 31 - $b36288e2db101ba3$var$oc(c), f = 1 << e;
        b[e] = 0;
        d[e] = -1;
        a[e] = -1;
        c &= ~f;
    }
}
function $b36288e2db101ba3$var$Cc(a, b) {
    var c = a.entangledLanes |= b;
    for(a = a.entanglements; c;){
        var d = 31 - $b36288e2db101ba3$var$oc(c), e = 1 << d;
        e & b | a[d] & b && (a[d] |= b);
        c &= ~e;
    }
}
var $b36288e2db101ba3$var$C = 0;
function $b36288e2db101ba3$var$Dc(a) {
    a &= -a;
    return 1 < a ? 4 < a ? 0 !== (a & 268435455) ? 16 : 536870912 : 4 : 1;
}
var $b36288e2db101ba3$var$Ec, $b36288e2db101ba3$var$Fc, $b36288e2db101ba3$var$Gc, $b36288e2db101ba3$var$Hc, $b36288e2db101ba3$var$Ic, $b36288e2db101ba3$var$Jc = !1, $b36288e2db101ba3$var$Kc = [], $b36288e2db101ba3$var$Lc = null, $b36288e2db101ba3$var$Mc = null, $b36288e2db101ba3$var$Nc = null, $b36288e2db101ba3$var$Oc = new Map, $b36288e2db101ba3$var$Pc = new Map, $b36288e2db101ba3$var$Qc = [], $b36288e2db101ba3$var$Rc = "mousedown mouseup touchcancel touchend touchstart auxclick dblclick pointercancel pointerdown pointerup dragend dragstart drop compositionend compositionstart keydown keypress keyup input textInput copy cut paste click change contextmenu reset submit".split(" ");
function $b36288e2db101ba3$var$Sc(a, b) {
    switch(a){
        case "focusin":
        case "focusout":
            $b36288e2db101ba3$var$Lc = null;
            break;
        case "dragenter":
        case "dragleave":
            $b36288e2db101ba3$var$Mc = null;
            break;
        case "mouseover":
        case "mouseout":
            $b36288e2db101ba3$var$Nc = null;
            break;
        case "pointerover":
        case "pointerout":
            $b36288e2db101ba3$var$Oc.delete(b.pointerId);
            break;
        case "gotpointercapture":
        case "lostpointercapture":
            $b36288e2db101ba3$var$Pc.delete(b.pointerId);
    }
}
function $b36288e2db101ba3$var$Tc(a, b, c, d, e, f) {
    if (null === a || a.nativeEvent !== f) return a = {
        blockedOn: b,
        domEventName: c,
        eventSystemFlags: d,
        nativeEvent: f,
        targetContainers: [
            e
        ]
    }, null !== b && (b = $b36288e2db101ba3$var$Cb(b), null !== b && $b36288e2db101ba3$var$Fc(b)), a;
    a.eventSystemFlags |= d;
    b = a.targetContainers;
    null !== e && -1 === b.indexOf(e) && b.push(e);
    return a;
}
function $b36288e2db101ba3$var$Uc(a, b, c, d, e) {
    switch(b){
        case "focusin":
            return $b36288e2db101ba3$var$Lc = $b36288e2db101ba3$var$Tc($b36288e2db101ba3$var$Lc, a, b, c, d, e), !0;
        case "dragenter":
            return $b36288e2db101ba3$var$Mc = $b36288e2db101ba3$var$Tc($b36288e2db101ba3$var$Mc, a, b, c, d, e), !0;
        case "mouseover":
            return $b36288e2db101ba3$var$Nc = $b36288e2db101ba3$var$Tc($b36288e2db101ba3$var$Nc, a, b, c, d, e), !0;
        case "pointerover":
            var f = e.pointerId;
            $b36288e2db101ba3$var$Oc.set(f, $b36288e2db101ba3$var$Tc($b36288e2db101ba3$var$Oc.get(f) || null, a, b, c, d, e));
            return !0;
        case "gotpointercapture":
            return f = e.pointerId, $b36288e2db101ba3$var$Pc.set(f, $b36288e2db101ba3$var$Tc($b36288e2db101ba3$var$Pc.get(f) || null, a, b, c, d, e)), !0;
    }
    return !1;
}
function $b36288e2db101ba3$var$Vc(a) {
    var b = $b36288e2db101ba3$var$Wc(a.target);
    if (null !== b) {
        var c = $b36288e2db101ba3$var$Vb(b);
        if (null !== c) {
            if (b = c.tag, 13 === b) {
                if (b = $b36288e2db101ba3$var$Wb(c), null !== b) {
                    a.blockedOn = b;
                    $b36288e2db101ba3$var$Ic(a.priority, function() {
                        $b36288e2db101ba3$var$Gc(c);
                    });
                    return;
                }
            } else if (3 === b && c.stateNode.current.memoizedState.isDehydrated) {
                a.blockedOn = 3 === c.tag ? c.stateNode.containerInfo : null;
                return;
            }
        }
    }
    a.blockedOn = null;
}
function $b36288e2db101ba3$var$Xc(a) {
    if (null !== a.blockedOn) return !1;
    for(var b = a.targetContainers; 0 < b.length;){
        var c = $b36288e2db101ba3$var$Yc(a.domEventName, a.eventSystemFlags, b[0], a.nativeEvent);
        if (null === c) {
            c = a.nativeEvent;
            var d = new c.constructor(c.type, c);
            $b36288e2db101ba3$var$wb = d;
            c.target.dispatchEvent(d);
            $b36288e2db101ba3$var$wb = null;
        } else return b = $b36288e2db101ba3$var$Cb(c), null !== b && $b36288e2db101ba3$var$Fc(b), a.blockedOn = c, !1;
        b.shift();
    }
    return !0;
}
function $b36288e2db101ba3$var$Zc(a, b, c) {
    $b36288e2db101ba3$var$Xc(a) && c.delete(b);
}
function $b36288e2db101ba3$var$$c() {
    $b36288e2db101ba3$var$Jc = !1;
    null !== $b36288e2db101ba3$var$Lc && $b36288e2db101ba3$var$Xc($b36288e2db101ba3$var$Lc) && ($b36288e2db101ba3$var$Lc = null);
    null !== $b36288e2db101ba3$var$Mc && $b36288e2db101ba3$var$Xc($b36288e2db101ba3$var$Mc) && ($b36288e2db101ba3$var$Mc = null);
    null !== $b36288e2db101ba3$var$Nc && $b36288e2db101ba3$var$Xc($b36288e2db101ba3$var$Nc) && ($b36288e2db101ba3$var$Nc = null);
    $b36288e2db101ba3$var$Oc.forEach($b36288e2db101ba3$var$Zc);
    $b36288e2db101ba3$var$Pc.forEach($b36288e2db101ba3$var$Zc);
}
function $b36288e2db101ba3$var$ad(a, b) {
    a.blockedOn === b && (a.blockedOn = null, $b36288e2db101ba3$var$Jc || ($b36288e2db101ba3$var$Jc = !0, $4LCdk.unstable_scheduleCallback($4LCdk.unstable_NormalPriority, $b36288e2db101ba3$var$$c)));
}
function $b36288e2db101ba3$var$bd(a) {
    function b(b) {
        return $b36288e2db101ba3$var$ad(b, a);
    }
    if (0 < $b36288e2db101ba3$var$Kc.length) {
        $b36288e2db101ba3$var$ad($b36288e2db101ba3$var$Kc[0], a);
        for(var c = 1; c < $b36288e2db101ba3$var$Kc.length; c++){
            var d = $b36288e2db101ba3$var$Kc[c];
            d.blockedOn === a && (d.blockedOn = null);
        }
    }
    null !== $b36288e2db101ba3$var$Lc && $b36288e2db101ba3$var$ad($b36288e2db101ba3$var$Lc, a);
    null !== $b36288e2db101ba3$var$Mc && $b36288e2db101ba3$var$ad($b36288e2db101ba3$var$Mc, a);
    null !== $b36288e2db101ba3$var$Nc && $b36288e2db101ba3$var$ad($b36288e2db101ba3$var$Nc, a);
    $b36288e2db101ba3$var$Oc.forEach(b);
    $b36288e2db101ba3$var$Pc.forEach(b);
    for(c = 0; c < $b36288e2db101ba3$var$Qc.length; c++)d = $b36288e2db101ba3$var$Qc[c], d.blockedOn === a && (d.blockedOn = null);
    for(; 0 < $b36288e2db101ba3$var$Qc.length && (c = $b36288e2db101ba3$var$Qc[0], null === c.blockedOn);)$b36288e2db101ba3$var$Vc(c), null === c.blockedOn && $b36288e2db101ba3$var$Qc.shift();
}
var $b36288e2db101ba3$var$cd = $b36288e2db101ba3$var$ua.ReactCurrentBatchConfig, $b36288e2db101ba3$var$dd = !0;
function $b36288e2db101ba3$var$ed(a, b, c, d) {
    var e = $b36288e2db101ba3$var$C, f = $b36288e2db101ba3$var$cd.transition;
    $b36288e2db101ba3$var$cd.transition = null;
    try {
        $b36288e2db101ba3$var$C = 1, $b36288e2db101ba3$var$fd(a, b, c, d);
    } finally{
        $b36288e2db101ba3$var$C = e, $b36288e2db101ba3$var$cd.transition = f;
    }
}
function $b36288e2db101ba3$var$gd(a, b, c, d) {
    var e = $b36288e2db101ba3$var$C, f = $b36288e2db101ba3$var$cd.transition;
    $b36288e2db101ba3$var$cd.transition = null;
    try {
        $b36288e2db101ba3$var$C = 4, $b36288e2db101ba3$var$fd(a, b, c, d);
    } finally{
        $b36288e2db101ba3$var$C = e, $b36288e2db101ba3$var$cd.transition = f;
    }
}
function $b36288e2db101ba3$var$fd(a, b, c, d) {
    if ($b36288e2db101ba3$var$dd) {
        var e = $b36288e2db101ba3$var$Yc(a, b, c, d);
        if (null === e) $b36288e2db101ba3$var$hd(a, b, d, $b36288e2db101ba3$var$id, c), $b36288e2db101ba3$var$Sc(a, d);
        else if ($b36288e2db101ba3$var$Uc(e, a, b, c, d)) d.stopPropagation();
        else if ($b36288e2db101ba3$var$Sc(a, d), b & 4 && -1 < $b36288e2db101ba3$var$Rc.indexOf(a)) {
            for(; null !== e;){
                var f = $b36288e2db101ba3$var$Cb(e);
                null !== f && $b36288e2db101ba3$var$Ec(f);
                f = $b36288e2db101ba3$var$Yc(a, b, c, d);
                null === f && $b36288e2db101ba3$var$hd(a, b, d, $b36288e2db101ba3$var$id, c);
                if (f === e) break;
                e = f;
            }
            null !== e && d.stopPropagation();
        } else $b36288e2db101ba3$var$hd(a, b, d, null, c);
    }
}
var $b36288e2db101ba3$var$id = null;
function $b36288e2db101ba3$var$Yc(a, b, c, d) {
    $b36288e2db101ba3$var$id = null;
    a = $b36288e2db101ba3$var$xb(d);
    a = $b36288e2db101ba3$var$Wc(a);
    if (null !== a) {
        if (b = $b36288e2db101ba3$var$Vb(a), null === b) a = null;
        else if (c = b.tag, 13 === c) {
            a = $b36288e2db101ba3$var$Wb(b);
            if (null !== a) return a;
            a = null;
        } else if (3 === c) {
            if (b.stateNode.current.memoizedState.isDehydrated) return 3 === b.tag ? b.stateNode.containerInfo : null;
            a = null;
        } else b !== a && (a = null);
    }
    $b36288e2db101ba3$var$id = a;
    return null;
}
function $b36288e2db101ba3$var$jd(a) {
    switch(a){
        case "cancel":
        case "click":
        case "close":
        case "contextmenu":
        case "copy":
        case "cut":
        case "auxclick":
        case "dblclick":
        case "dragend":
        case "dragstart":
        case "drop":
        case "focusin":
        case "focusout":
        case "input":
        case "invalid":
        case "keydown":
        case "keypress":
        case "keyup":
        case "mousedown":
        case "mouseup":
        case "paste":
        case "pause":
        case "play":
        case "pointercancel":
        case "pointerdown":
        case "pointerup":
        case "ratechange":
        case "reset":
        case "resize":
        case "seeked":
        case "submit":
        case "touchcancel":
        case "touchend":
        case "touchstart":
        case "volumechange":
        case "change":
        case "selectionchange":
        case "textInput":
        case "compositionstart":
        case "compositionend":
        case "compositionupdate":
        case "beforeblur":
        case "afterblur":
        case "beforeinput":
        case "blur":
        case "fullscreenchange":
        case "focus":
        case "hashchange":
        case "popstate":
        case "select":
        case "selectstart":
            return 1;
        case "drag":
        case "dragenter":
        case "dragexit":
        case "dragleave":
        case "dragover":
        case "mousemove":
        case "mouseout":
        case "mouseover":
        case "pointermove":
        case "pointerout":
        case "pointerover":
        case "scroll":
        case "toggle":
        case "touchmove":
        case "wheel":
        case "mouseenter":
        case "mouseleave":
        case "pointerenter":
        case "pointerleave":
            return 4;
        case "message":
            switch($b36288e2db101ba3$var$ec()){
                case $b36288e2db101ba3$var$fc:
                    return 1;
                case $b36288e2db101ba3$var$gc:
                    return 4;
                case $b36288e2db101ba3$var$hc:
                case $b36288e2db101ba3$var$ic:
                    return 16;
                case $b36288e2db101ba3$var$jc:
                    return 536870912;
                default:
                    return 16;
            }
        default:
            return 16;
    }
}
var $b36288e2db101ba3$var$kd = null, $b36288e2db101ba3$var$ld = null, $b36288e2db101ba3$var$md = null;
function $b36288e2db101ba3$var$nd() {
    if ($b36288e2db101ba3$var$md) return $b36288e2db101ba3$var$md;
    var a, b = $b36288e2db101ba3$var$ld, c = b.length, d, e = "value" in $b36288e2db101ba3$var$kd ? $b36288e2db101ba3$var$kd.value : $b36288e2db101ba3$var$kd.textContent, f = e.length;
    for(a = 0; a < c && b[a] === e[a]; a++);
    var g = c - a;
    for(d = 1; d <= g && b[c - d] === e[f - d]; d++);
    return $b36288e2db101ba3$var$md = e.slice(a, 1 < d ? 1 - d : void 0);
}
function $b36288e2db101ba3$var$od(a) {
    var b = a.keyCode;
    "charCode" in a ? (a = a.charCode, 0 === a && 13 === b && (a = 13)) : a = b;
    10 === a && (a = 13);
    return 32 <= a || 13 === a ? a : 0;
}
function $b36288e2db101ba3$var$pd() {
    return !0;
}
function $b36288e2db101ba3$var$qd() {
    return !1;
}
function $b36288e2db101ba3$var$rd(a) {
    function b(b, d, e, f, g) {
        this._reactName = b;
        this._targetInst = e;
        this.type = d;
        this.nativeEvent = f;
        this.target = g;
        this.currentTarget = null;
        for(var c in a)a.hasOwnProperty(c) && (b = a[c], this[c] = b ? b(f) : f[c]);
        this.isDefaultPrevented = (null != f.defaultPrevented ? f.defaultPrevented : !1 === f.returnValue) ? $b36288e2db101ba3$var$pd : $b36288e2db101ba3$var$qd;
        this.isPropagationStopped = $b36288e2db101ba3$var$qd;
        return this;
    }
    $b36288e2db101ba3$var$A(b.prototype, {
        preventDefault: function() {
            this.defaultPrevented = !0;
            var a = this.nativeEvent;
            a && (a.preventDefault ? a.preventDefault() : "unknown" !== typeof a.returnValue && (a.returnValue = !1), this.isDefaultPrevented = $b36288e2db101ba3$var$pd);
        },
        stopPropagation: function() {
            var a = this.nativeEvent;
            a && (a.stopPropagation ? a.stopPropagation() : "unknown" !== typeof a.cancelBubble && (a.cancelBubble = !0), this.isPropagationStopped = $b36288e2db101ba3$var$pd);
        },
        persist: function() {},
        isPersistent: $b36288e2db101ba3$var$pd
    });
    return b;
}
var $b36288e2db101ba3$var$sd = {
    eventPhase: 0,
    bubbles: 0,
    cancelable: 0,
    timeStamp: function(a) {
        return a.timeStamp || Date.now();
    },
    defaultPrevented: 0,
    isTrusted: 0
}, $b36288e2db101ba3$var$td = $b36288e2db101ba3$var$rd($b36288e2db101ba3$var$sd), $b36288e2db101ba3$var$ud = $b36288e2db101ba3$var$A({}, $b36288e2db101ba3$var$sd, {
    view: 0,
    detail: 0
}), $b36288e2db101ba3$var$vd = $b36288e2db101ba3$var$rd($b36288e2db101ba3$var$ud), $b36288e2db101ba3$var$wd, $b36288e2db101ba3$var$xd, $b36288e2db101ba3$var$yd, $b36288e2db101ba3$var$Ad = $b36288e2db101ba3$var$A({}, $b36288e2db101ba3$var$ud, {
    screenX: 0,
    screenY: 0,
    clientX: 0,
    clientY: 0,
    pageX: 0,
    pageY: 0,
    ctrlKey: 0,
    shiftKey: 0,
    altKey: 0,
    metaKey: 0,
    getModifierState: $b36288e2db101ba3$var$zd,
    button: 0,
    buttons: 0,
    relatedTarget: function(a) {
        return void 0 === a.relatedTarget ? a.fromElement === a.srcElement ? a.toElement : a.fromElement : a.relatedTarget;
    },
    movementX: function(a) {
        if ("movementX" in a) return a.movementX;
        a !== $b36288e2db101ba3$var$yd && ($b36288e2db101ba3$var$yd && "mousemove" === a.type ? ($b36288e2db101ba3$var$wd = a.screenX - $b36288e2db101ba3$var$yd.screenX, $b36288e2db101ba3$var$xd = a.screenY - $b36288e2db101ba3$var$yd.screenY) : $b36288e2db101ba3$var$xd = $b36288e2db101ba3$var$wd = 0, $b36288e2db101ba3$var$yd = a);
        return $b36288e2db101ba3$var$wd;
    },
    movementY: function(a) {
        return "movementY" in a ? a.movementY : $b36288e2db101ba3$var$xd;
    }
}), $b36288e2db101ba3$var$Bd = $b36288e2db101ba3$var$rd($b36288e2db101ba3$var$Ad), $b36288e2db101ba3$var$Cd = $b36288e2db101ba3$var$A({}, $b36288e2db101ba3$var$Ad, {
    dataTransfer: 0
}), $b36288e2db101ba3$var$Dd = $b36288e2db101ba3$var$rd($b36288e2db101ba3$var$Cd), $b36288e2db101ba3$var$Ed = $b36288e2db101ba3$var$A({}, $b36288e2db101ba3$var$ud, {
    relatedTarget: 0
}), $b36288e2db101ba3$var$Fd = $b36288e2db101ba3$var$rd($b36288e2db101ba3$var$Ed), $b36288e2db101ba3$var$Gd = $b36288e2db101ba3$var$A({}, $b36288e2db101ba3$var$sd, {
    animationName: 0,
    elapsedTime: 0,
    pseudoElement: 0
}), $b36288e2db101ba3$var$Hd = $b36288e2db101ba3$var$rd($b36288e2db101ba3$var$Gd), $b36288e2db101ba3$var$Id = $b36288e2db101ba3$var$A({}, $b36288e2db101ba3$var$sd, {
    clipboardData: function(a) {
        return "clipboardData" in a ? a.clipboardData : window.clipboardData;
    }
}), $b36288e2db101ba3$var$Jd = $b36288e2db101ba3$var$rd($b36288e2db101ba3$var$Id), $b36288e2db101ba3$var$Kd = $b36288e2db101ba3$var$A({}, $b36288e2db101ba3$var$sd, {
    data: 0
}), $b36288e2db101ba3$var$Ld = $b36288e2db101ba3$var$rd($b36288e2db101ba3$var$Kd), $b36288e2db101ba3$var$Md = {
    Esc: "Escape",
    Spacebar: " ",
    Left: "ArrowLeft",
    Up: "ArrowUp",
    Right: "ArrowRight",
    Down: "ArrowDown",
    Del: "Delete",
    Win: "OS",
    Menu: "ContextMenu",
    Apps: "ContextMenu",
    Scroll: "ScrollLock",
    MozPrintableKey: "Unidentified"
}, $b36288e2db101ba3$var$Nd = {
    8: "Backspace",
    9: "Tab",
    12: "Clear",
    13: "Enter",
    16: "Shift",
    17: "Control",
    18: "Alt",
    19: "Pause",
    20: "CapsLock",
    27: "Escape",
    32: " ",
    33: "PageUp",
    34: "PageDown",
    35: "End",
    36: "Home",
    37: "ArrowLeft",
    38: "ArrowUp",
    39: "ArrowRight",
    40: "ArrowDown",
    45: "Insert",
    46: "Delete",
    112: "F1",
    113: "F2",
    114: "F3",
    115: "F4",
    116: "F5",
    117: "F6",
    118: "F7",
    119: "F8",
    120: "F9",
    121: "F10",
    122: "F11",
    123: "F12",
    144: "NumLock",
    145: "ScrollLock",
    224: "Meta"
}, $b36288e2db101ba3$var$Od = {
    Alt: "altKey",
    Control: "ctrlKey",
    Meta: "metaKey",
    Shift: "shiftKey"
};
function $b36288e2db101ba3$var$Pd(a) {
    var b = this.nativeEvent;
    return b.getModifierState ? b.getModifierState(a) : (a = $b36288e2db101ba3$var$Od[a]) ? !!b[a] : !1;
}
function $b36288e2db101ba3$var$zd() {
    return $b36288e2db101ba3$var$Pd;
}
var $b36288e2db101ba3$var$Qd = $b36288e2db101ba3$var$A({}, $b36288e2db101ba3$var$ud, {
    key: function(a) {
        if (a.key) {
            var b = $b36288e2db101ba3$var$Md[a.key] || a.key;
            if ("Unidentified" !== b) return b;
        }
        return "keypress" === a.type ? (a = $b36288e2db101ba3$var$od(a), 13 === a ? "Enter" : String.fromCharCode(a)) : "keydown" === a.type || "keyup" === a.type ? $b36288e2db101ba3$var$Nd[a.keyCode] || "Unidentified" : "";
    },
    code: 0,
    location: 0,
    ctrlKey: 0,
    shiftKey: 0,
    altKey: 0,
    metaKey: 0,
    repeat: 0,
    locale: 0,
    getModifierState: $b36288e2db101ba3$var$zd,
    charCode: function(a) {
        return "keypress" === a.type ? $b36288e2db101ba3$var$od(a) : 0;
    },
    keyCode: function(a) {
        return "keydown" === a.type || "keyup" === a.type ? a.keyCode : 0;
    },
    which: function(a) {
        return "keypress" === a.type ? $b36288e2db101ba3$var$od(a) : "keydown" === a.type || "keyup" === a.type ? a.keyCode : 0;
    }
}), $b36288e2db101ba3$var$Rd = $b36288e2db101ba3$var$rd($b36288e2db101ba3$var$Qd), $b36288e2db101ba3$var$Sd = $b36288e2db101ba3$var$A({}, $b36288e2db101ba3$var$Ad, {
    pointerId: 0,
    width: 0,
    height: 0,
    pressure: 0,
    tangentialPressure: 0,
    tiltX: 0,
    tiltY: 0,
    twist: 0,
    pointerType: 0,
    isPrimary: 0
}), $b36288e2db101ba3$var$Td = $b36288e2db101ba3$var$rd($b36288e2db101ba3$var$Sd), $b36288e2db101ba3$var$Ud = $b36288e2db101ba3$var$A({}, $b36288e2db101ba3$var$ud, {
    touches: 0,
    targetTouches: 0,
    changedTouches: 0,
    altKey: 0,
    metaKey: 0,
    ctrlKey: 0,
    shiftKey: 0,
    getModifierState: $b36288e2db101ba3$var$zd
}), $b36288e2db101ba3$var$Vd = $b36288e2db101ba3$var$rd($b36288e2db101ba3$var$Ud), $b36288e2db101ba3$var$Wd = $b36288e2db101ba3$var$A({}, $b36288e2db101ba3$var$sd, {
    propertyName: 0,
    elapsedTime: 0,
    pseudoElement: 0
}), $b36288e2db101ba3$var$Xd = $b36288e2db101ba3$var$rd($b36288e2db101ba3$var$Wd), $b36288e2db101ba3$var$Yd = $b36288e2db101ba3$var$A({}, $b36288e2db101ba3$var$Ad, {
    deltaX: function(a) {
        return "deltaX" in a ? a.deltaX : "wheelDeltaX" in a ? -a.wheelDeltaX : 0;
    },
    deltaY: function(a) {
        return "deltaY" in a ? a.deltaY : "wheelDeltaY" in a ? -a.wheelDeltaY : "wheelDelta" in a ? -a.wheelDelta : 0;
    },
    deltaZ: 0,
    deltaMode: 0
}), $b36288e2db101ba3$var$Zd = $b36288e2db101ba3$var$rd($b36288e2db101ba3$var$Yd), $b36288e2db101ba3$var$$d = [
    9,
    13,
    27,
    32
], $b36288e2db101ba3$var$ae = $b36288e2db101ba3$var$ia && "CompositionEvent" in window, $b36288e2db101ba3$var$be = null;
$b36288e2db101ba3$var$ia && "documentMode" in document && ($b36288e2db101ba3$var$be = document.documentMode);
var $b36288e2db101ba3$var$ce = $b36288e2db101ba3$var$ia && "TextEvent" in window && !$b36288e2db101ba3$var$be, $b36288e2db101ba3$var$de = $b36288e2db101ba3$var$ia && (!$b36288e2db101ba3$var$ae || $b36288e2db101ba3$var$be && 8 < $b36288e2db101ba3$var$be && 11 >= $b36288e2db101ba3$var$be), $b36288e2db101ba3$var$ee = String.fromCharCode(32), $b36288e2db101ba3$var$fe = !1;
function $b36288e2db101ba3$var$ge(a, b) {
    switch(a){
        case "keyup":
            return -1 !== $b36288e2db101ba3$var$$d.indexOf(b.keyCode);
        case "keydown":
            return 229 !== b.keyCode;
        case "keypress":
        case "mousedown":
        case "focusout":
            return !0;
        default:
            return !1;
    }
}
function $b36288e2db101ba3$var$he(a) {
    a = a.detail;
    return "object" === typeof a && "data" in a ? a.data : null;
}
var $b36288e2db101ba3$var$ie = !1;
function $b36288e2db101ba3$var$je(a, b) {
    switch(a){
        case "compositionend":
            return $b36288e2db101ba3$var$he(b);
        case "keypress":
            if (32 !== b.which) return null;
            $b36288e2db101ba3$var$fe = !0;
            return $b36288e2db101ba3$var$ee;
        case "textInput":
            return a = b.data, a === $b36288e2db101ba3$var$ee && $b36288e2db101ba3$var$fe ? null : a;
        default:
            return null;
    }
}
function $b36288e2db101ba3$var$ke(a, b) {
    if ($b36288e2db101ba3$var$ie) return "compositionend" === a || !$b36288e2db101ba3$var$ae && $b36288e2db101ba3$var$ge(a, b) ? (a = $b36288e2db101ba3$var$nd(), $b36288e2db101ba3$var$md = $b36288e2db101ba3$var$ld = $b36288e2db101ba3$var$kd = null, $b36288e2db101ba3$var$ie = !1, a) : null;
    switch(a){
        case "paste":
            return null;
        case "keypress":
            if (!(b.ctrlKey || b.altKey || b.metaKey) || b.ctrlKey && b.altKey) {
                if (b.char && 1 < b.char.length) return b.char;
                if (b.which) return String.fromCharCode(b.which);
            }
            return null;
        case "compositionend":
            return $b36288e2db101ba3$var$de && "ko" !== b.locale ? null : b.data;
        default:
            return null;
    }
}
var $b36288e2db101ba3$var$le = {
    color: !0,
    date: !0,
    datetime: !0,
    "datetime-local": !0,
    email: !0,
    month: !0,
    number: !0,
    password: !0,
    range: !0,
    search: !0,
    tel: !0,
    text: !0,
    time: !0,
    url: !0,
    week: !0
};
function $b36288e2db101ba3$var$me(a) {
    var b = a && a.nodeName && a.nodeName.toLowerCase();
    return "input" === b ? !!$b36288e2db101ba3$var$le[a.type] : "textarea" === b ? !0 : !1;
}
function $b36288e2db101ba3$var$ne(a, b, c, d) {
    $b36288e2db101ba3$var$Eb(d);
    b = $b36288e2db101ba3$var$oe(b, "onChange");
    0 < b.length && (c = new $b36288e2db101ba3$var$td("onChange", "change", null, c, d), a.push({
        event: c,
        listeners: b
    }));
}
var $b36288e2db101ba3$var$pe = null, $b36288e2db101ba3$var$qe = null;
function $b36288e2db101ba3$var$re(a) {
    $b36288e2db101ba3$var$se(a, 0);
}
function $b36288e2db101ba3$var$te(a) {
    var b = $b36288e2db101ba3$var$ue(a);
    if ($b36288e2db101ba3$var$Wa(b)) return a;
}
function $b36288e2db101ba3$var$ve(a, b) {
    if ("change" === a) return b;
}
var $b36288e2db101ba3$var$we = !1;
if ($b36288e2db101ba3$var$ia) {
    var $b36288e2db101ba3$var$xe;
    if ($b36288e2db101ba3$var$ia) {
        var $b36288e2db101ba3$var$ye = "oninput" in document;
        if (!$b36288e2db101ba3$var$ye) {
            var $b36288e2db101ba3$var$ze = document.createElement("div");
            $b36288e2db101ba3$var$ze.setAttribute("oninput", "return;");
            $b36288e2db101ba3$var$ye = "function" === typeof $b36288e2db101ba3$var$ze.oninput;
        }
        $b36288e2db101ba3$var$xe = $b36288e2db101ba3$var$ye;
    } else $b36288e2db101ba3$var$xe = !1;
    $b36288e2db101ba3$var$we = $b36288e2db101ba3$var$xe && (!document.documentMode || 9 < document.documentMode);
}
function $b36288e2db101ba3$var$Ae() {
    $b36288e2db101ba3$var$pe && ($b36288e2db101ba3$var$pe.detachEvent("onpropertychange", $b36288e2db101ba3$var$Be), $b36288e2db101ba3$var$qe = $b36288e2db101ba3$var$pe = null);
}
function $b36288e2db101ba3$var$Be(a) {
    if ("value" === a.propertyName && $b36288e2db101ba3$var$te($b36288e2db101ba3$var$qe)) {
        var b = [];
        $b36288e2db101ba3$var$ne(b, $b36288e2db101ba3$var$qe, a, $b36288e2db101ba3$var$xb(a));
        $b36288e2db101ba3$var$Jb($b36288e2db101ba3$var$re, b);
    }
}
function $b36288e2db101ba3$var$Ce(a, b, c) {
    "focusin" === a ? ($b36288e2db101ba3$var$Ae(), $b36288e2db101ba3$var$pe = b, $b36288e2db101ba3$var$qe = c, $b36288e2db101ba3$var$pe.attachEvent("onpropertychange", $b36288e2db101ba3$var$Be)) : "focusout" === a && $b36288e2db101ba3$var$Ae();
}
function $b36288e2db101ba3$var$De(a) {
    if ("selectionchange" === a || "keyup" === a || "keydown" === a) return $b36288e2db101ba3$var$te($b36288e2db101ba3$var$qe);
}
function $b36288e2db101ba3$var$Ee(a, b) {
    if ("click" === a) return $b36288e2db101ba3$var$te(b);
}
function $b36288e2db101ba3$var$Fe(a, b) {
    if ("input" === a || "change" === a) return $b36288e2db101ba3$var$te(b);
}
function $b36288e2db101ba3$var$Ge(a, b) {
    return a === b && (0 !== a || 1 / a === 1 / b) || a !== a && b !== b;
}
var $b36288e2db101ba3$var$He = "function" === typeof Object.is ? Object.is : $b36288e2db101ba3$var$Ge;
function $b36288e2db101ba3$var$Ie(a, b) {
    if ($b36288e2db101ba3$var$He(a, b)) return !0;
    if ("object" !== typeof a || null === a || "object" !== typeof b || null === b) return !1;
    var c = Object.keys(a), d = Object.keys(b);
    if (c.length !== d.length) return !1;
    for(d = 0; d < c.length; d++){
        var e = c[d];
        if (!$b36288e2db101ba3$var$ja.call(b, e) || !$b36288e2db101ba3$var$He(a[e], b[e])) return !1;
    }
    return !0;
}
function $b36288e2db101ba3$var$Je(a) {
    for(; a && a.firstChild;)a = a.firstChild;
    return a;
}
function $b36288e2db101ba3$var$Ke(a, b) {
    var c = $b36288e2db101ba3$var$Je(a);
    a = 0;
    for(var d; c;){
        if (3 === c.nodeType) {
            d = a + c.textContent.length;
            if (a <= b && d >= b) return {
                node: c,
                offset: b - a
            };
            a = d;
        }
        a: {
            for(; c;){
                if (c.nextSibling) {
                    c = c.nextSibling;
                    break a;
                }
                c = c.parentNode;
            }
            c = void 0;
        }
        c = $b36288e2db101ba3$var$Je(c);
    }
}
function $b36288e2db101ba3$var$Le(a, b) {
    return a && b ? a === b ? !0 : a && 3 === a.nodeType ? !1 : b && 3 === b.nodeType ? $b36288e2db101ba3$var$Le(a, b.parentNode) : "contains" in a ? a.contains(b) : a.compareDocumentPosition ? !!(a.compareDocumentPosition(b) & 16) : !1 : !1;
}
function $b36288e2db101ba3$var$Me() {
    for(var a = window, b = $b36288e2db101ba3$var$Xa(); b instanceof a.HTMLIFrameElement;){
        try {
            var c = "string" === typeof b.contentWindow.location.href;
        } catch (d) {
            c = !1;
        }
        if (c) a = b.contentWindow;
        else break;
        b = $b36288e2db101ba3$var$Xa(a.document);
    }
    return b;
}
function $b36288e2db101ba3$var$Ne(a) {
    var b = a && a.nodeName && a.nodeName.toLowerCase();
    return b && ("input" === b && ("text" === a.type || "search" === a.type || "tel" === a.type || "url" === a.type || "password" === a.type) || "textarea" === b || "true" === a.contentEditable);
}
function $b36288e2db101ba3$var$Oe(a) {
    var b = $b36288e2db101ba3$var$Me(), c = a.focusedElem, d = a.selectionRange;
    if (b !== c && c && c.ownerDocument && $b36288e2db101ba3$var$Le(c.ownerDocument.documentElement, c)) {
        if (null !== d && $b36288e2db101ba3$var$Ne(c)) {
            if (b = d.start, a = d.end, void 0 === a && (a = b), "selectionStart" in c) c.selectionStart = b, c.selectionEnd = Math.min(a, c.value.length);
            else if (a = (b = c.ownerDocument || document) && b.defaultView || window, a.getSelection) {
                a = a.getSelection();
                var e = c.textContent.length, f = Math.min(d.start, e);
                d = void 0 === d.end ? f : Math.min(d.end, e);
                !a.extend && f > d && (e = d, d = f, f = e);
                e = $b36288e2db101ba3$var$Ke(c, f);
                var g = $b36288e2db101ba3$var$Ke(c, d);
                e && g && (1 !== a.rangeCount || a.anchorNode !== e.node || a.anchorOffset !== e.offset || a.focusNode !== g.node || a.focusOffset !== g.offset) && (b = b.createRange(), b.setStart(e.node, e.offset), a.removeAllRanges(), f > d ? (a.addRange(b), a.extend(g.node, g.offset)) : (b.setEnd(g.node, g.offset), a.addRange(b)));
            }
        }
        b = [];
        for(a = c; a = a.parentNode;)1 === a.nodeType && b.push({
            element: a,
            left: a.scrollLeft,
            top: a.scrollTop
        });
        "function" === typeof c.focus && c.focus();
        for(c = 0; c < b.length; c++)a = b[c], a.element.scrollLeft = a.left, a.element.scrollTop = a.top;
    }
}
var $b36288e2db101ba3$var$Pe = $b36288e2db101ba3$var$ia && "documentMode" in document && 11 >= document.documentMode, $b36288e2db101ba3$var$Qe = null, $b36288e2db101ba3$var$Re = null, $b36288e2db101ba3$var$Se = null, $b36288e2db101ba3$var$Te = !1;
function $b36288e2db101ba3$var$Ue(a, b, c) {
    var d = c.window === c ? c.document : 9 === c.nodeType ? c : c.ownerDocument;
    $b36288e2db101ba3$var$Te || null == $b36288e2db101ba3$var$Qe || $b36288e2db101ba3$var$Qe !== $b36288e2db101ba3$var$Xa(d) || (d = $b36288e2db101ba3$var$Qe, "selectionStart" in d && $b36288e2db101ba3$var$Ne(d) ? d = {
        start: d.selectionStart,
        end: d.selectionEnd
    } : (d = (d.ownerDocument && d.ownerDocument.defaultView || window).getSelection(), d = {
        anchorNode: d.anchorNode,
        anchorOffset: d.anchorOffset,
        focusNode: d.focusNode,
        focusOffset: d.focusOffset
    }), $b36288e2db101ba3$var$Se && $b36288e2db101ba3$var$Ie($b36288e2db101ba3$var$Se, d) || ($b36288e2db101ba3$var$Se = d, d = $b36288e2db101ba3$var$oe($b36288e2db101ba3$var$Re, "onSelect"), 0 < d.length && (b = new $b36288e2db101ba3$var$td("onSelect", "select", null, b, c), a.push({
        event: b,
        listeners: d
    }), b.target = $b36288e2db101ba3$var$Qe)));
}
function $b36288e2db101ba3$var$Ve(a, b) {
    var c = {};
    c[a.toLowerCase()] = b.toLowerCase();
    c["Webkit" + a] = "webkit" + b;
    c["Moz" + a] = "moz" + b;
    return c;
}
var $b36288e2db101ba3$var$We = {
    animationend: $b36288e2db101ba3$var$Ve("Animation", "AnimationEnd"),
    animationiteration: $b36288e2db101ba3$var$Ve("Animation", "AnimationIteration"),
    animationstart: $b36288e2db101ba3$var$Ve("Animation", "AnimationStart"),
    transitionend: $b36288e2db101ba3$var$Ve("Transition", "TransitionEnd")
}, $b36288e2db101ba3$var$Xe = {}, $b36288e2db101ba3$var$Ye = {};
$b36288e2db101ba3$var$ia && ($b36288e2db101ba3$var$Ye = document.createElement("div").style, "AnimationEvent" in window || (delete $b36288e2db101ba3$var$We.animationend.animation, delete $b36288e2db101ba3$var$We.animationiteration.animation, delete $b36288e2db101ba3$var$We.animationstart.animation), "TransitionEvent" in window || delete $b36288e2db101ba3$var$We.transitionend.transition);
function $b36288e2db101ba3$var$Ze(a) {
    if ($b36288e2db101ba3$var$Xe[a]) return $b36288e2db101ba3$var$Xe[a];
    if (!$b36288e2db101ba3$var$We[a]) return a;
    var b = $b36288e2db101ba3$var$We[a], c;
    for(c in b)if (b.hasOwnProperty(c) && c in $b36288e2db101ba3$var$Ye) return $b36288e2db101ba3$var$Xe[a] = b[c];
    return a;
}
var $b36288e2db101ba3$var$$e = $b36288e2db101ba3$var$Ze("animationend"), $b36288e2db101ba3$var$af = $b36288e2db101ba3$var$Ze("animationiteration"), $b36288e2db101ba3$var$bf = $b36288e2db101ba3$var$Ze("animationstart"), $b36288e2db101ba3$var$cf = $b36288e2db101ba3$var$Ze("transitionend"), $b36288e2db101ba3$var$df = new Map, $b36288e2db101ba3$var$ef = "abort auxClick cancel canPlay canPlayThrough click close contextMenu copy cut drag dragEnd dragEnter dragExit dragLeave dragOver dragStart drop durationChange emptied encrypted ended error gotPointerCapture input invalid keyDown keyPress keyUp load loadedData loadedMetadata loadStart lostPointerCapture mouseDown mouseMove mouseOut mouseOver mouseUp paste pause play playing pointerCancel pointerDown pointerMove pointerOut pointerOver pointerUp progress rateChange reset resize seeked seeking stalled submit suspend timeUpdate touchCancel touchEnd touchStart volumeChange scroll toggle touchMove waiting wheel".split(" ");
function $b36288e2db101ba3$var$ff(a, b) {
    $b36288e2db101ba3$var$df.set(a, b);
    $b36288e2db101ba3$var$fa(b, [
        a
    ]);
}
for(var $b36288e2db101ba3$var$gf = 0; $b36288e2db101ba3$var$gf < $b36288e2db101ba3$var$ef.length; $b36288e2db101ba3$var$gf++){
    var $b36288e2db101ba3$var$hf = $b36288e2db101ba3$var$ef[$b36288e2db101ba3$var$gf], $b36288e2db101ba3$var$jf = $b36288e2db101ba3$var$hf.toLowerCase(), $b36288e2db101ba3$var$kf = $b36288e2db101ba3$var$hf[0].toUpperCase() + $b36288e2db101ba3$var$hf.slice(1);
    $b36288e2db101ba3$var$ff($b36288e2db101ba3$var$jf, "on" + $b36288e2db101ba3$var$kf);
}
$b36288e2db101ba3$var$ff($b36288e2db101ba3$var$$e, "onAnimationEnd");
$b36288e2db101ba3$var$ff($b36288e2db101ba3$var$af, "onAnimationIteration");
$b36288e2db101ba3$var$ff($b36288e2db101ba3$var$bf, "onAnimationStart");
$b36288e2db101ba3$var$ff("dblclick", "onDoubleClick");
$b36288e2db101ba3$var$ff("focusin", "onFocus");
$b36288e2db101ba3$var$ff("focusout", "onBlur");
$b36288e2db101ba3$var$ff($b36288e2db101ba3$var$cf, "onTransitionEnd");
$b36288e2db101ba3$var$ha("onMouseEnter", [
    "mouseout",
    "mouseover"
]);
$b36288e2db101ba3$var$ha("onMouseLeave", [
    "mouseout",
    "mouseover"
]);
$b36288e2db101ba3$var$ha("onPointerEnter", [
    "pointerout",
    "pointerover"
]);
$b36288e2db101ba3$var$ha("onPointerLeave", [
    "pointerout",
    "pointerover"
]);
$b36288e2db101ba3$var$fa("onChange", "change click focusin focusout input keydown keyup selectionchange".split(" "));
$b36288e2db101ba3$var$fa("onSelect", "focusout contextmenu dragend focusin keydown keyup mousedown mouseup selectionchange".split(" "));
$b36288e2db101ba3$var$fa("onBeforeInput", [
    "compositionend",
    "keypress",
    "textInput",
    "paste"
]);
$b36288e2db101ba3$var$fa("onCompositionEnd", "compositionend focusout keydown keypress keyup mousedown".split(" "));
$b36288e2db101ba3$var$fa("onCompositionStart", "compositionstart focusout keydown keypress keyup mousedown".split(" "));
$b36288e2db101ba3$var$fa("onCompositionUpdate", "compositionupdate focusout keydown keypress keyup mousedown".split(" "));
var $b36288e2db101ba3$var$lf = "abort canplay canplaythrough durationchange emptied encrypted ended error loadeddata loadedmetadata loadstart pause play playing progress ratechange resize seeked seeking stalled suspend timeupdate volumechange waiting".split(" "), $b36288e2db101ba3$var$mf = new Set("cancel close invalid load scroll toggle".split(" ").concat($b36288e2db101ba3$var$lf));
function $b36288e2db101ba3$var$nf(a, b, c) {
    var d = a.type || "unknown-event";
    a.currentTarget = c;
    $b36288e2db101ba3$var$Ub(d, b, void 0, a);
    a.currentTarget = null;
}
function $b36288e2db101ba3$var$se(a, b) {
    b = 0 !== (b & 4);
    for(var c = 0; c < a.length; c++){
        var d = a[c], e = d.event;
        d = d.listeners;
        a: {
            var f = void 0;
            if (b) for(var g = d.length - 1; 0 <= g; g--){
                var h = d[g], k = h.instance, l = h.currentTarget;
                h = h.listener;
                if (k !== f && e.isPropagationStopped()) break a;
                $b36288e2db101ba3$var$nf(e, h, l);
                f = k;
            }
            else for(g = 0; g < d.length; g++){
                h = d[g];
                k = h.instance;
                l = h.currentTarget;
                h = h.listener;
                if (k !== f && e.isPropagationStopped()) break a;
                $b36288e2db101ba3$var$nf(e, h, l);
                f = k;
            }
        }
    }
    if ($b36288e2db101ba3$var$Qb) throw a = $b36288e2db101ba3$var$Rb, $b36288e2db101ba3$var$Qb = !1, $b36288e2db101ba3$var$Rb = null, a;
}
function $b36288e2db101ba3$var$D(a, b) {
    var c = b[$b36288e2db101ba3$var$of];
    void 0 === c && (c = b[$b36288e2db101ba3$var$of] = new Set);
    var d = a + "__bubble";
    c.has(d) || ($b36288e2db101ba3$var$pf(b, a, 2, !1), c.add(d));
}
function $b36288e2db101ba3$var$qf(a, b, c) {
    var d = 0;
    b && (d |= 4);
    $b36288e2db101ba3$var$pf(c, a, d, b);
}
var $b36288e2db101ba3$var$rf = "_reactListening" + Math.random().toString(36).slice(2);
function $b36288e2db101ba3$var$sf(a) {
    if (!a[$b36288e2db101ba3$var$rf]) {
        a[$b36288e2db101ba3$var$rf] = !0;
        $b36288e2db101ba3$var$da.forEach(function(b) {
            "selectionchange" !== b && ($b36288e2db101ba3$var$mf.has(b) || $b36288e2db101ba3$var$qf(b, !1, a), $b36288e2db101ba3$var$qf(b, !0, a));
        });
        var b = 9 === a.nodeType ? a : a.ownerDocument;
        null === b || b[$b36288e2db101ba3$var$rf] || (b[$b36288e2db101ba3$var$rf] = !0, $b36288e2db101ba3$var$qf("selectionchange", !1, b));
    }
}
function $b36288e2db101ba3$var$pf(a, b, c, d) {
    switch($b36288e2db101ba3$var$jd(b)){
        case 1:
            var e = $b36288e2db101ba3$var$ed;
            break;
        case 4:
            e = $b36288e2db101ba3$var$gd;
            break;
        default:
            e = $b36288e2db101ba3$var$fd;
    }
    c = e.bind(null, b, c, a);
    e = void 0;
    !$b36288e2db101ba3$var$Lb || "touchstart" !== b && "touchmove" !== b && "wheel" !== b || (e = !0);
    d ? void 0 !== e ? a.addEventListener(b, c, {
        capture: !0,
        passive: e
    }) : a.addEventListener(b, c, !0) : void 0 !== e ? a.addEventListener(b, c, {
        passive: e
    }) : a.addEventListener(b, c, !1);
}
function $b36288e2db101ba3$var$hd(a, b, c, d, e) {
    var f = d;
    if (0 === (b & 1) && 0 === (b & 2) && null !== d) a: for(;;){
        if (null === d) return;
        var g = d.tag;
        if (3 === g || 4 === g) {
            var h = d.stateNode.containerInfo;
            if (h === e || 8 === h.nodeType && h.parentNode === e) break;
            if (4 === g) for(g = d.return; null !== g;){
                var k = g.tag;
                if (3 === k || 4 === k) {
                    if (k = g.stateNode.containerInfo, k === e || 8 === k.nodeType && k.parentNode === e) return;
                }
                g = g.return;
            }
            for(; null !== h;){
                g = $b36288e2db101ba3$var$Wc(h);
                if (null === g) return;
                k = g.tag;
                if (5 === k || 6 === k) {
                    d = f = g;
                    continue a;
                }
                h = h.parentNode;
            }
        }
        d = d.return;
    }
    $b36288e2db101ba3$var$Jb(function() {
        var d = f, e = $b36288e2db101ba3$var$xb(c), g = [];
        a: {
            var h = $b36288e2db101ba3$var$df.get(a);
            if (void 0 !== h) {
                var k = $b36288e2db101ba3$var$td, n = a;
                switch(a){
                    case "keypress":
                        if (0 === $b36288e2db101ba3$var$od(c)) break a;
                    case "keydown":
                    case "keyup":
                        k = $b36288e2db101ba3$var$Rd;
                        break;
                    case "focusin":
                        n = "focus";
                        k = $b36288e2db101ba3$var$Fd;
                        break;
                    case "focusout":
                        n = "blur";
                        k = $b36288e2db101ba3$var$Fd;
                        break;
                    case "beforeblur":
                    case "afterblur":
                        k = $b36288e2db101ba3$var$Fd;
                        break;
                    case "click":
                        if (2 === c.button) break a;
                    case "auxclick":
                    case "dblclick":
                    case "mousedown":
                    case "mousemove":
                    case "mouseup":
                    case "mouseout":
                    case "mouseover":
                    case "contextmenu":
                        k = $b36288e2db101ba3$var$Bd;
                        break;
                    case "drag":
                    case "dragend":
                    case "dragenter":
                    case "dragexit":
                    case "dragleave":
                    case "dragover":
                    case "dragstart":
                    case "drop":
                        k = $b36288e2db101ba3$var$Dd;
                        break;
                    case "touchcancel":
                    case "touchend":
                    case "touchmove":
                    case "touchstart":
                        k = $b36288e2db101ba3$var$Vd;
                        break;
                    case $b36288e2db101ba3$var$$e:
                    case $b36288e2db101ba3$var$af:
                    case $b36288e2db101ba3$var$bf:
                        k = $b36288e2db101ba3$var$Hd;
                        break;
                    case $b36288e2db101ba3$var$cf:
                        k = $b36288e2db101ba3$var$Xd;
                        break;
                    case "scroll":
                        k = $b36288e2db101ba3$var$vd;
                        break;
                    case "wheel":
                        k = $b36288e2db101ba3$var$Zd;
                        break;
                    case "copy":
                    case "cut":
                    case "paste":
                        k = $b36288e2db101ba3$var$Jd;
                        break;
                    case "gotpointercapture":
                    case "lostpointercapture":
                    case "pointercancel":
                    case "pointerdown":
                    case "pointermove":
                    case "pointerout":
                    case "pointerover":
                    case "pointerup":
                        k = $b36288e2db101ba3$var$Td;
                }
                var t = 0 !== (b & 4), J = !t && "scroll" === a, x = t ? null !== h ? h + "Capture" : null : h;
                t = [];
                for(var w = d, u; null !== w;){
                    u = w;
                    var F = u.stateNode;
                    5 === u.tag && null !== F && (u = F, null !== x && (F = $b36288e2db101ba3$var$Kb(w, x), null != F && t.push($b36288e2db101ba3$var$tf(w, F, u))));
                    if (J) break;
                    w = w.return;
                }
                0 < t.length && (h = new k(h, n, null, c, e), g.push({
                    event: h,
                    listeners: t
                }));
            }
        }
        if (0 === (b & 7)) {
            a: {
                h = "mouseover" === a || "pointerover" === a;
                k = "mouseout" === a || "pointerout" === a;
                if (h && c !== $b36288e2db101ba3$var$wb && (n = c.relatedTarget || c.fromElement) && ($b36288e2db101ba3$var$Wc(n) || n[$b36288e2db101ba3$var$uf])) break a;
                if (k || h) {
                    h = e.window === e ? e : (h = e.ownerDocument) ? h.defaultView || h.parentWindow : window;
                    if (k) {
                        if (n = c.relatedTarget || c.toElement, k = d, n = n ? $b36288e2db101ba3$var$Wc(n) : null, null !== n && (J = $b36288e2db101ba3$var$Vb(n), n !== J || 5 !== n.tag && 6 !== n.tag)) n = null;
                    } else k = null, n = d;
                    if (k !== n) {
                        t = $b36288e2db101ba3$var$Bd;
                        F = "onMouseLeave";
                        x = "onMouseEnter";
                        w = "mouse";
                        if ("pointerout" === a || "pointerover" === a) t = $b36288e2db101ba3$var$Td, F = "onPointerLeave", x = "onPointerEnter", w = "pointer";
                        J = null == k ? h : $b36288e2db101ba3$var$ue(k);
                        u = null == n ? h : $b36288e2db101ba3$var$ue(n);
                        h = new t(F, w + "leave", k, c, e);
                        h.target = J;
                        h.relatedTarget = u;
                        F = null;
                        $b36288e2db101ba3$var$Wc(e) === d && (t = new t(x, w + "enter", n, c, e), t.target = u, t.relatedTarget = J, F = t);
                        J = F;
                        if (k && n) b: {
                            t = k;
                            x = n;
                            w = 0;
                            for(u = t; u; u = $b36288e2db101ba3$var$vf(u))w++;
                            u = 0;
                            for(F = x; F; F = $b36288e2db101ba3$var$vf(F))u++;
                            for(; 0 < w - u;)t = $b36288e2db101ba3$var$vf(t), w--;
                            for(; 0 < u - w;)x = $b36288e2db101ba3$var$vf(x), u--;
                            for(; w--;){
                                if (t === x || null !== x && t === x.alternate) break b;
                                t = $b36288e2db101ba3$var$vf(t);
                                x = $b36288e2db101ba3$var$vf(x);
                            }
                            t = null;
                        }
                        else t = null;
                        null !== k && $b36288e2db101ba3$var$wf(g, h, k, t, !1);
                        null !== n && null !== J && $b36288e2db101ba3$var$wf(g, J, n, t, !0);
                    }
                }
            }
            a: {
                h = d ? $b36288e2db101ba3$var$ue(d) : window;
                k = h.nodeName && h.nodeName.toLowerCase();
                if ("select" === k || "input" === k && "file" === h.type) var na = $b36288e2db101ba3$var$ve;
                else if ($b36288e2db101ba3$var$me(h)) {
                    if ($b36288e2db101ba3$var$we) na = $b36288e2db101ba3$var$Fe;
                    else {
                        na = $b36288e2db101ba3$var$De;
                        var xa = $b36288e2db101ba3$var$Ce;
                    }
                } else (k = h.nodeName) && "input" === k.toLowerCase() && ("checkbox" === h.type || "radio" === h.type) && (na = $b36288e2db101ba3$var$Ee);
                if (na && (na = na(a, d))) {
                    $b36288e2db101ba3$var$ne(g, na, c, e);
                    break a;
                }
                xa && xa(a, h, d);
                "focusout" === a && (xa = h._wrapperState) && xa.controlled && "number" === h.type && $b36288e2db101ba3$var$cb(h, "number", h.value);
            }
            xa = d ? $b36288e2db101ba3$var$ue(d) : window;
            switch(a){
                case "focusin":
                    if ($b36288e2db101ba3$var$me(xa) || "true" === xa.contentEditable) $b36288e2db101ba3$var$Qe = xa, $b36288e2db101ba3$var$Re = d, $b36288e2db101ba3$var$Se = null;
                    break;
                case "focusout":
                    $b36288e2db101ba3$var$Se = $b36288e2db101ba3$var$Re = $b36288e2db101ba3$var$Qe = null;
                    break;
                case "mousedown":
                    $b36288e2db101ba3$var$Te = !0;
                    break;
                case "contextmenu":
                case "mouseup":
                case "dragend":
                    $b36288e2db101ba3$var$Te = !1;
                    $b36288e2db101ba3$var$Ue(g, c, e);
                    break;
                case "selectionchange":
                    if ($b36288e2db101ba3$var$Pe) break;
                case "keydown":
                case "keyup":
                    $b36288e2db101ba3$var$Ue(g, c, e);
            }
            var $a;
            if ($b36288e2db101ba3$var$ae) b: {
                switch(a){
                    case "compositionstart":
                        var ba = "onCompositionStart";
                        break b;
                    case "compositionend":
                        ba = "onCompositionEnd";
                        break b;
                    case "compositionupdate":
                        ba = "onCompositionUpdate";
                        break b;
                }
                ba = void 0;
            }
            else $b36288e2db101ba3$var$ie ? $b36288e2db101ba3$var$ge(a, c) && (ba = "onCompositionEnd") : "keydown" === a && 229 === c.keyCode && (ba = "onCompositionStart");
            ba && ($b36288e2db101ba3$var$de && "ko" !== c.locale && ($b36288e2db101ba3$var$ie || "onCompositionStart" !== ba ? "onCompositionEnd" === ba && $b36288e2db101ba3$var$ie && ($a = $b36288e2db101ba3$var$nd()) : ($b36288e2db101ba3$var$kd = e, $b36288e2db101ba3$var$ld = "value" in $b36288e2db101ba3$var$kd ? $b36288e2db101ba3$var$kd.value : $b36288e2db101ba3$var$kd.textContent, $b36288e2db101ba3$var$ie = !0)), xa = $b36288e2db101ba3$var$oe(d, ba), 0 < xa.length && (ba = new $b36288e2db101ba3$var$Ld(ba, a, null, c, e), g.push({
                event: ba,
                listeners: xa
            }), $a ? ba.data = $a : ($a = $b36288e2db101ba3$var$he(c), null !== $a && (ba.data = $a))));
            if ($a = $b36288e2db101ba3$var$ce ? $b36288e2db101ba3$var$je(a, c) : $b36288e2db101ba3$var$ke(a, c)) d = $b36288e2db101ba3$var$oe(d, "onBeforeInput"), 0 < d.length && (e = new $b36288e2db101ba3$var$Ld("onBeforeInput", "beforeinput", null, c, e), g.push({
                event: e,
                listeners: d
            }), e.data = $a);
        }
        $b36288e2db101ba3$var$se(g, b);
    });
}
function $b36288e2db101ba3$var$tf(a, b, c) {
    return {
        instance: a,
        listener: b,
        currentTarget: c
    };
}
function $b36288e2db101ba3$var$oe(a, b) {
    for(var c = b + "Capture", d = []; null !== a;){
        var e = a, f = e.stateNode;
        5 === e.tag && null !== f && (e = f, f = $b36288e2db101ba3$var$Kb(a, c), null != f && d.unshift($b36288e2db101ba3$var$tf(a, f, e)), f = $b36288e2db101ba3$var$Kb(a, b), null != f && d.push($b36288e2db101ba3$var$tf(a, f, e)));
        a = a.return;
    }
    return d;
}
function $b36288e2db101ba3$var$vf(a) {
    if (null === a) return null;
    do a = a.return;
    while (a && 5 !== a.tag);
    return a ? a : null;
}
function $b36288e2db101ba3$var$wf(a, b, c, d, e) {
    for(var f = b._reactName, g = []; null !== c && c !== d;){
        var h = c, k = h.alternate, l = h.stateNode;
        if (null !== k && k === d) break;
        5 === h.tag && null !== l && (h = l, e ? (k = $b36288e2db101ba3$var$Kb(c, f), null != k && g.unshift($b36288e2db101ba3$var$tf(c, k, h))) : e || (k = $b36288e2db101ba3$var$Kb(c, f), null != k && g.push($b36288e2db101ba3$var$tf(c, k, h))));
        c = c.return;
    }
    0 !== g.length && a.push({
        event: b,
        listeners: g
    });
}
var $b36288e2db101ba3$var$xf = /\r\n?/g, $b36288e2db101ba3$var$yf = /\u0000|\uFFFD/g;
function $b36288e2db101ba3$var$zf(a) {
    return ("string" === typeof a ? a : "" + a).replace($b36288e2db101ba3$var$xf, "\n").replace($b36288e2db101ba3$var$yf, "");
}
function $b36288e2db101ba3$var$Af(a, b, c) {
    b = $b36288e2db101ba3$var$zf(b);
    if ($b36288e2db101ba3$var$zf(a) !== b && c) throw Error($b36288e2db101ba3$var$p(425));
}
function $b36288e2db101ba3$var$Bf() {}
var $b36288e2db101ba3$var$Cf = null, $b36288e2db101ba3$var$Df = null;
function $b36288e2db101ba3$var$Ef(a, b) {
    return "textarea" === a || "noscript" === a || "string" === typeof b.children || "number" === typeof b.children || "object" === typeof b.dangerouslySetInnerHTML && null !== b.dangerouslySetInnerHTML && null != b.dangerouslySetInnerHTML.__html;
}
var $b36288e2db101ba3$var$Ff = "function" === typeof setTimeout ? setTimeout : void 0, $b36288e2db101ba3$var$Gf = "function" === typeof clearTimeout ? clearTimeout : void 0, $b36288e2db101ba3$var$Hf = "function" === typeof Promise ? Promise : void 0, $b36288e2db101ba3$var$Jf = "function" === typeof queueMicrotask ? queueMicrotask : "undefined" !== typeof $b36288e2db101ba3$var$Hf ? function(a) {
    return $b36288e2db101ba3$var$Hf.resolve(null).then(a).catch($b36288e2db101ba3$var$If);
} : $b36288e2db101ba3$var$Ff;
function $b36288e2db101ba3$var$If(a) {
    setTimeout(function() {
        throw a;
    });
}
function $b36288e2db101ba3$var$Kf(a, b) {
    var c = b, d = 0;
    do {
        var e = c.nextSibling;
        a.removeChild(c);
        if (e && 8 === e.nodeType) {
            if (c = e.data, "/$" === c) {
                if (0 === d) {
                    a.removeChild(e);
                    $b36288e2db101ba3$var$bd(b);
                    return;
                }
                d--;
            } else "$" !== c && "$?" !== c && "$!" !== c || d++;
        }
        c = e;
    }while (c);
    $b36288e2db101ba3$var$bd(b);
}
function $b36288e2db101ba3$var$Lf(a) {
    for(; null != a; a = a.nextSibling){
        var b = a.nodeType;
        if (1 === b || 3 === b) break;
        if (8 === b) {
            b = a.data;
            if ("$" === b || "$!" === b || "$?" === b) break;
            if ("/$" === b) return null;
        }
    }
    return a;
}
function $b36288e2db101ba3$var$Mf(a) {
    a = a.previousSibling;
    for(var b = 0; a;){
        if (8 === a.nodeType) {
            var c = a.data;
            if ("$" === c || "$!" === c || "$?" === c) {
                if (0 === b) return a;
                b--;
            } else "/$" === c && b++;
        }
        a = a.previousSibling;
    }
    return null;
}
var $b36288e2db101ba3$var$Nf = Math.random().toString(36).slice(2), $b36288e2db101ba3$var$Of = "__reactFiber$" + $b36288e2db101ba3$var$Nf, $b36288e2db101ba3$var$Pf = "__reactProps$" + $b36288e2db101ba3$var$Nf, $b36288e2db101ba3$var$uf = "__reactContainer$" + $b36288e2db101ba3$var$Nf, $b36288e2db101ba3$var$of = "__reactEvents$" + $b36288e2db101ba3$var$Nf, $b36288e2db101ba3$var$Qf = "__reactListeners$" + $b36288e2db101ba3$var$Nf, $b36288e2db101ba3$var$Rf = "__reactHandles$" + $b36288e2db101ba3$var$Nf;
function $b36288e2db101ba3$var$Wc(a) {
    var b = a[$b36288e2db101ba3$var$Of];
    if (b) return b;
    for(var c = a.parentNode; c;){
        if (b = c[$b36288e2db101ba3$var$uf] || c[$b36288e2db101ba3$var$Of]) {
            c = b.alternate;
            if (null !== b.child || null !== c && null !== c.child) for(a = $b36288e2db101ba3$var$Mf(a); null !== a;){
                if (c = a[$b36288e2db101ba3$var$Of]) return c;
                a = $b36288e2db101ba3$var$Mf(a);
            }
            return b;
        }
        a = c;
        c = a.parentNode;
    }
    return null;
}
function $b36288e2db101ba3$var$Cb(a) {
    a = a[$b36288e2db101ba3$var$Of] || a[$b36288e2db101ba3$var$uf];
    return !a || 5 !== a.tag && 6 !== a.tag && 13 !== a.tag && 3 !== a.tag ? null : a;
}
function $b36288e2db101ba3$var$ue(a) {
    if (5 === a.tag || 6 === a.tag) return a.stateNode;
    throw Error($b36288e2db101ba3$var$p(33));
}
function $b36288e2db101ba3$var$Db(a) {
    return a[$b36288e2db101ba3$var$Pf] || null;
}
var $b36288e2db101ba3$var$Sf = [], $b36288e2db101ba3$var$Tf = -1;
function $b36288e2db101ba3$var$Uf(a) {
    return {
        current: a
    };
}
function $b36288e2db101ba3$var$E(a) {
    0 > $b36288e2db101ba3$var$Tf || (a.current = $b36288e2db101ba3$var$Sf[$b36288e2db101ba3$var$Tf], $b36288e2db101ba3$var$Sf[$b36288e2db101ba3$var$Tf] = null, $b36288e2db101ba3$var$Tf--);
}
function $b36288e2db101ba3$var$G(a, b) {
    $b36288e2db101ba3$var$Tf++;
    $b36288e2db101ba3$var$Sf[$b36288e2db101ba3$var$Tf] = a.current;
    a.current = b;
}
var $b36288e2db101ba3$var$Vf = {}, $b36288e2db101ba3$var$H = $b36288e2db101ba3$var$Uf($b36288e2db101ba3$var$Vf), $b36288e2db101ba3$var$Wf = $b36288e2db101ba3$var$Uf(!1), $b36288e2db101ba3$var$Xf = $b36288e2db101ba3$var$Vf;
function $b36288e2db101ba3$var$Yf(a, b) {
    var c = a.type.contextTypes;
    if (!c) return $b36288e2db101ba3$var$Vf;
    var d = a.stateNode;
    if (d && d.__reactInternalMemoizedUnmaskedChildContext === b) return d.__reactInternalMemoizedMaskedChildContext;
    var e = {}, f;
    for(f in c)e[f] = b[f];
    d && (a = a.stateNode, a.__reactInternalMemoizedUnmaskedChildContext = b, a.__reactInternalMemoizedMaskedChildContext = e);
    return e;
}
function $b36288e2db101ba3$var$Zf(a) {
    a = a.childContextTypes;
    return null !== a && void 0 !== a;
}
function $b36288e2db101ba3$var$$f() {
    $b36288e2db101ba3$var$E($b36288e2db101ba3$var$Wf);
    $b36288e2db101ba3$var$E($b36288e2db101ba3$var$H);
}
function $b36288e2db101ba3$var$ag(a, b, c) {
    if ($b36288e2db101ba3$var$H.current !== $b36288e2db101ba3$var$Vf) throw Error($b36288e2db101ba3$var$p(168));
    $b36288e2db101ba3$var$G($b36288e2db101ba3$var$H, b);
    $b36288e2db101ba3$var$G($b36288e2db101ba3$var$Wf, c);
}
function $b36288e2db101ba3$var$bg(a, b, c) {
    var d = a.stateNode;
    b = b.childContextTypes;
    if ("function" !== typeof d.getChildContext) return c;
    d = d.getChildContext();
    for(var e in d)if (!(e in b)) throw Error($b36288e2db101ba3$var$p(108, $b36288e2db101ba3$var$Ra(a) || "Unknown", e));
    return $b36288e2db101ba3$var$A({}, c, d);
}
function $b36288e2db101ba3$var$cg(a) {
    a = (a = a.stateNode) && a.__reactInternalMemoizedMergedChildContext || $b36288e2db101ba3$var$Vf;
    $b36288e2db101ba3$var$Xf = $b36288e2db101ba3$var$H.current;
    $b36288e2db101ba3$var$G($b36288e2db101ba3$var$H, a);
    $b36288e2db101ba3$var$G($b36288e2db101ba3$var$Wf, $b36288e2db101ba3$var$Wf.current);
    return !0;
}
function $b36288e2db101ba3$var$dg(a, b, c) {
    var d = a.stateNode;
    if (!d) throw Error($b36288e2db101ba3$var$p(169));
    c ? (a = $b36288e2db101ba3$var$bg(a, b, $b36288e2db101ba3$var$Xf), d.__reactInternalMemoizedMergedChildContext = a, $b36288e2db101ba3$var$E($b36288e2db101ba3$var$Wf), $b36288e2db101ba3$var$E($b36288e2db101ba3$var$H), $b36288e2db101ba3$var$G($b36288e2db101ba3$var$H, a)) : $b36288e2db101ba3$var$E($b36288e2db101ba3$var$Wf);
    $b36288e2db101ba3$var$G($b36288e2db101ba3$var$Wf, c);
}
var $b36288e2db101ba3$var$eg = null, $b36288e2db101ba3$var$fg = !1, $b36288e2db101ba3$var$gg = !1;
function $b36288e2db101ba3$var$hg(a) {
    null === $b36288e2db101ba3$var$eg ? $b36288e2db101ba3$var$eg = [
        a
    ] : $b36288e2db101ba3$var$eg.push(a);
}
function $b36288e2db101ba3$var$ig(a) {
    $b36288e2db101ba3$var$fg = !0;
    $b36288e2db101ba3$var$hg(a);
}
function $b36288e2db101ba3$var$jg() {
    if (!$b36288e2db101ba3$var$gg && null !== $b36288e2db101ba3$var$eg) {
        $b36288e2db101ba3$var$gg = !0;
        var a = 0, b = $b36288e2db101ba3$var$C;
        try {
            var c = $b36288e2db101ba3$var$eg;
            for($b36288e2db101ba3$var$C = 1; a < c.length; a++){
                var d = c[a];
                do d = d(!0);
                while (null !== d);
            }
            $b36288e2db101ba3$var$eg = null;
            $b36288e2db101ba3$var$fg = !1;
        } catch (e) {
            throw null !== $b36288e2db101ba3$var$eg && ($b36288e2db101ba3$var$eg = $b36288e2db101ba3$var$eg.slice(a + 1)), $b36288e2db101ba3$var$ac($b36288e2db101ba3$var$fc, $b36288e2db101ba3$var$jg), e;
        } finally{
            $b36288e2db101ba3$var$C = b, $b36288e2db101ba3$var$gg = !1;
        }
    }
    return null;
}
var $b36288e2db101ba3$var$kg = [], $b36288e2db101ba3$var$lg = 0, $b36288e2db101ba3$var$mg = null, $b36288e2db101ba3$var$ng = 0, $b36288e2db101ba3$var$og = [], $b36288e2db101ba3$var$pg = 0, $b36288e2db101ba3$var$qg = null, $b36288e2db101ba3$var$rg = 1, $b36288e2db101ba3$var$sg = "";
function $b36288e2db101ba3$var$tg(a, b) {
    $b36288e2db101ba3$var$kg[$b36288e2db101ba3$var$lg++] = $b36288e2db101ba3$var$ng;
    $b36288e2db101ba3$var$kg[$b36288e2db101ba3$var$lg++] = $b36288e2db101ba3$var$mg;
    $b36288e2db101ba3$var$mg = a;
    $b36288e2db101ba3$var$ng = b;
}
function $b36288e2db101ba3$var$ug(a, b, c) {
    $b36288e2db101ba3$var$og[$b36288e2db101ba3$var$pg++] = $b36288e2db101ba3$var$rg;
    $b36288e2db101ba3$var$og[$b36288e2db101ba3$var$pg++] = $b36288e2db101ba3$var$sg;
    $b36288e2db101ba3$var$og[$b36288e2db101ba3$var$pg++] = $b36288e2db101ba3$var$qg;
    $b36288e2db101ba3$var$qg = a;
    var d = $b36288e2db101ba3$var$rg;
    a = $b36288e2db101ba3$var$sg;
    var e = 32 - $b36288e2db101ba3$var$oc(d) - 1;
    d &= ~(1 << e);
    c += 1;
    var f = 32 - $b36288e2db101ba3$var$oc(b) + e;
    if (30 < f) {
        var g = e - e % 5;
        f = (d & (1 << g) - 1).toString(32);
        d >>= g;
        e -= g;
        $b36288e2db101ba3$var$rg = 1 << 32 - $b36288e2db101ba3$var$oc(b) + e | c << e | d;
        $b36288e2db101ba3$var$sg = f + a;
    } else $b36288e2db101ba3$var$rg = 1 << f | c << e | d, $b36288e2db101ba3$var$sg = a;
}
function $b36288e2db101ba3$var$vg(a) {
    null !== a.return && ($b36288e2db101ba3$var$tg(a, 1), $b36288e2db101ba3$var$ug(a, 1, 0));
}
function $b36288e2db101ba3$var$wg(a) {
    for(; a === $b36288e2db101ba3$var$mg;)$b36288e2db101ba3$var$mg = $b36288e2db101ba3$var$kg[--$b36288e2db101ba3$var$lg], $b36288e2db101ba3$var$kg[$b36288e2db101ba3$var$lg] = null, $b36288e2db101ba3$var$ng = $b36288e2db101ba3$var$kg[--$b36288e2db101ba3$var$lg], $b36288e2db101ba3$var$kg[$b36288e2db101ba3$var$lg] = null;
    for(; a === $b36288e2db101ba3$var$qg;)$b36288e2db101ba3$var$qg = $b36288e2db101ba3$var$og[--$b36288e2db101ba3$var$pg], $b36288e2db101ba3$var$og[$b36288e2db101ba3$var$pg] = null, $b36288e2db101ba3$var$sg = $b36288e2db101ba3$var$og[--$b36288e2db101ba3$var$pg], $b36288e2db101ba3$var$og[$b36288e2db101ba3$var$pg] = null, $b36288e2db101ba3$var$rg = $b36288e2db101ba3$var$og[--$b36288e2db101ba3$var$pg], $b36288e2db101ba3$var$og[$b36288e2db101ba3$var$pg] = null;
}
var $b36288e2db101ba3$var$xg = null, $b36288e2db101ba3$var$yg = null, $b36288e2db101ba3$var$I = !1, $b36288e2db101ba3$var$zg = null;
function $b36288e2db101ba3$var$Ag(a, b) {
    var c = $b36288e2db101ba3$var$Bg(5, null, null, 0);
    c.elementType = "DELETED";
    c.stateNode = b;
    c.return = a;
    b = a.deletions;
    null === b ? (a.deletions = [
        c
    ], a.flags |= 16) : b.push(c);
}
function $b36288e2db101ba3$var$Cg(a, b) {
    switch(a.tag){
        case 5:
            var c = a.type;
            b = 1 !== b.nodeType || c.toLowerCase() !== b.nodeName.toLowerCase() ? null : b;
            return null !== b ? (a.stateNode = b, $b36288e2db101ba3$var$xg = a, $b36288e2db101ba3$var$yg = $b36288e2db101ba3$var$Lf(b.firstChild), !0) : !1;
        case 6:
            return b = "" === a.pendingProps || 3 !== b.nodeType ? null : b, null !== b ? (a.stateNode = b, $b36288e2db101ba3$var$xg = a, $b36288e2db101ba3$var$yg = null, !0) : !1;
        case 13:
            return b = 8 !== b.nodeType ? null : b, null !== b ? (c = null !== $b36288e2db101ba3$var$qg ? {
                id: $b36288e2db101ba3$var$rg,
                overflow: $b36288e2db101ba3$var$sg
            } : null, a.memoizedState = {
                dehydrated: b,
                treeContext: c,
                retryLane: 1073741824
            }, c = $b36288e2db101ba3$var$Bg(18, null, null, 0), c.stateNode = b, c.return = a, a.child = c, $b36288e2db101ba3$var$xg = a, $b36288e2db101ba3$var$yg = null, !0) : !1;
        default:
            return !1;
    }
}
function $b36288e2db101ba3$var$Dg(a) {
    return 0 !== (a.mode & 1) && 0 === (a.flags & 128);
}
function $b36288e2db101ba3$var$Eg(a) {
    if ($b36288e2db101ba3$var$I) {
        var b = $b36288e2db101ba3$var$yg;
        if (b) {
            var c = b;
            if (!$b36288e2db101ba3$var$Cg(a, b)) {
                if ($b36288e2db101ba3$var$Dg(a)) throw Error($b36288e2db101ba3$var$p(418));
                b = $b36288e2db101ba3$var$Lf(c.nextSibling);
                var d = $b36288e2db101ba3$var$xg;
                b && $b36288e2db101ba3$var$Cg(a, b) ? $b36288e2db101ba3$var$Ag(d, c) : (a.flags = a.flags & -4097 | 2, $b36288e2db101ba3$var$I = !1, $b36288e2db101ba3$var$xg = a);
            }
        } else {
            if ($b36288e2db101ba3$var$Dg(a)) throw Error($b36288e2db101ba3$var$p(418));
            a.flags = a.flags & -4097 | 2;
            $b36288e2db101ba3$var$I = !1;
            $b36288e2db101ba3$var$xg = a;
        }
    }
}
function $b36288e2db101ba3$var$Fg(a) {
    for(a = a.return; null !== a && 5 !== a.tag && 3 !== a.tag && 13 !== a.tag;)a = a.return;
    $b36288e2db101ba3$var$xg = a;
}
function $b36288e2db101ba3$var$Gg(a) {
    if (a !== $b36288e2db101ba3$var$xg) return !1;
    if (!$b36288e2db101ba3$var$I) return $b36288e2db101ba3$var$Fg(a), $b36288e2db101ba3$var$I = !0, !1;
    var b;
    (b = 3 !== a.tag) && !(b = 5 !== a.tag) && (b = a.type, b = "head" !== b && "body" !== b && !$b36288e2db101ba3$var$Ef(a.type, a.memoizedProps));
    if (b && (b = $b36288e2db101ba3$var$yg)) {
        if ($b36288e2db101ba3$var$Dg(a)) throw $b36288e2db101ba3$var$Hg(), Error($b36288e2db101ba3$var$p(418));
        for(; b;)$b36288e2db101ba3$var$Ag(a, b), b = $b36288e2db101ba3$var$Lf(b.nextSibling);
    }
    $b36288e2db101ba3$var$Fg(a);
    if (13 === a.tag) {
        a = a.memoizedState;
        a = null !== a ? a.dehydrated : null;
        if (!a) throw Error($b36288e2db101ba3$var$p(317));
        a: {
            a = a.nextSibling;
            for(b = 0; a;){
                if (8 === a.nodeType) {
                    var c = a.data;
                    if ("/$" === c) {
                        if (0 === b) {
                            $b36288e2db101ba3$var$yg = $b36288e2db101ba3$var$Lf(a.nextSibling);
                            break a;
                        }
                        b--;
                    } else "$" !== c && "$!" !== c && "$?" !== c || b++;
                }
                a = a.nextSibling;
            }
            $b36288e2db101ba3$var$yg = null;
        }
    } else $b36288e2db101ba3$var$yg = $b36288e2db101ba3$var$xg ? $b36288e2db101ba3$var$Lf(a.stateNode.nextSibling) : null;
    return !0;
}
function $b36288e2db101ba3$var$Hg() {
    for(var a = $b36288e2db101ba3$var$yg; a;)a = $b36288e2db101ba3$var$Lf(a.nextSibling);
}
function $b36288e2db101ba3$var$Ig() {
    $b36288e2db101ba3$var$yg = $b36288e2db101ba3$var$xg = null;
    $b36288e2db101ba3$var$I = !1;
}
function $b36288e2db101ba3$var$Jg(a) {
    null === $b36288e2db101ba3$var$zg ? $b36288e2db101ba3$var$zg = [
        a
    ] : $b36288e2db101ba3$var$zg.push(a);
}
var $b36288e2db101ba3$var$Kg = $b36288e2db101ba3$var$ua.ReactCurrentBatchConfig;
function $b36288e2db101ba3$var$Lg(a, b, c) {
    a = c.ref;
    if (null !== a && "function" !== typeof a && "object" !== typeof a) {
        if (c._owner) {
            c = c._owner;
            if (c) {
                if (1 !== c.tag) throw Error($b36288e2db101ba3$var$p(309));
                var d = c.stateNode;
            }
            if (!d) throw Error($b36288e2db101ba3$var$p(147, a));
            var e = d, f = "" + a;
            if (null !== b && null !== b.ref && "function" === typeof b.ref && b.ref._stringRef === f) return b.ref;
            b = function(a) {
                var b = e.refs;
                null === a ? delete b[f] : b[f] = a;
            };
            b._stringRef = f;
            return b;
        }
        if ("string" !== typeof a) throw Error($b36288e2db101ba3$var$p(284));
        if (!c._owner) throw Error($b36288e2db101ba3$var$p(290, a));
    }
    return a;
}
function $b36288e2db101ba3$var$Mg(a, b) {
    a = Object.prototype.toString.call(b);
    throw Error($b36288e2db101ba3$var$p(31, "[object Object]" === a ? "object with keys {" + Object.keys(b).join(", ") + "}" : a));
}
function $b36288e2db101ba3$var$Ng(a) {
    var b = a._init;
    return b(a._payload);
}
function $b36288e2db101ba3$var$Og(a) {
    function b(b, c) {
        if (a) {
            var d = b.deletions;
            null === d ? (b.deletions = [
                c
            ], b.flags |= 16) : d.push(c);
        }
    }
    function c(c, d) {
        if (!a) return null;
        for(; null !== d;)b(c, d), d = d.sibling;
        return null;
    }
    function d(a, b) {
        for(a = new Map; null !== b;)null !== b.key ? a.set(b.key, b) : a.set(b.index, b), b = b.sibling;
        return a;
    }
    function e(a, b) {
        a = $b36288e2db101ba3$var$Pg(a, b);
        a.index = 0;
        a.sibling = null;
        return a;
    }
    function f(b, c, d) {
        b.index = d;
        if (!a) return b.flags |= 1048576, c;
        d = b.alternate;
        if (null !== d) return d = d.index, d < c ? (b.flags |= 2, c) : d;
        b.flags |= 2;
        return c;
    }
    function g(b) {
        a && null === b.alternate && (b.flags |= 2);
        return b;
    }
    function h(a, b, c, d) {
        if (null === b || 6 !== b.tag) return b = $b36288e2db101ba3$var$Qg(c, a.mode, d), b.return = a, b;
        b = e(b, c);
        b.return = a;
        return b;
    }
    function k(a, b, c, d) {
        var f = c.type;
        if (f === $b36288e2db101ba3$var$ya) return m(a, b, c.props.children, d, c.key);
        if (null !== b && (b.elementType === f || "object" === typeof f && null !== f && f.$$typeof === $b36288e2db101ba3$var$Ha && $b36288e2db101ba3$var$Ng(f) === b.type)) return d = e(b, c.props), d.ref = $b36288e2db101ba3$var$Lg(a, b, c), d.return = a, d;
        d = $b36288e2db101ba3$var$Rg(c.type, c.key, c.props, null, a.mode, d);
        d.ref = $b36288e2db101ba3$var$Lg(a, b, c);
        d.return = a;
        return d;
    }
    function l(a, b, c, d) {
        if (null === b || 4 !== b.tag || b.stateNode.containerInfo !== c.containerInfo || b.stateNode.implementation !== c.implementation) return b = $b36288e2db101ba3$var$Sg(c, a.mode, d), b.return = a, b;
        b = e(b, c.children || []);
        b.return = a;
        return b;
    }
    function m(a, b, c, d, f) {
        if (null === b || 7 !== b.tag) return b = $b36288e2db101ba3$var$Tg(c, a.mode, d, f), b.return = a, b;
        b = e(b, c);
        b.return = a;
        return b;
    }
    function q(a, b, c) {
        if ("string" === typeof b && "" !== b || "number" === typeof b) return b = $b36288e2db101ba3$var$Qg("" + b, a.mode, c), b.return = a, b;
        if ("object" === typeof b && null !== b) {
            switch(b.$$typeof){
                case $b36288e2db101ba3$var$va:
                    return c = $b36288e2db101ba3$var$Rg(b.type, b.key, b.props, null, a.mode, c), c.ref = $b36288e2db101ba3$var$Lg(a, null, b), c.return = a, c;
                case $b36288e2db101ba3$var$wa:
                    return b = $b36288e2db101ba3$var$Sg(b, a.mode, c), b.return = a, b;
                case $b36288e2db101ba3$var$Ha:
                    var d = b._init;
                    return q(a, d(b._payload), c);
            }
            if ($b36288e2db101ba3$var$eb(b) || $b36288e2db101ba3$var$Ka(b)) return b = $b36288e2db101ba3$var$Tg(b, a.mode, c, null), b.return = a, b;
            $b36288e2db101ba3$var$Mg(a, b);
        }
        return null;
    }
    function r(a, b, c, d) {
        var e = null !== b ? b.key : null;
        if ("string" === typeof c && "" !== c || "number" === typeof c) return null !== e ? null : h(a, b, "" + c, d);
        if ("object" === typeof c && null !== c) {
            switch(c.$$typeof){
                case $b36288e2db101ba3$var$va:
                    return c.key === e ? k(a, b, c, d) : null;
                case $b36288e2db101ba3$var$wa:
                    return c.key === e ? l(a, b, c, d) : null;
                case $b36288e2db101ba3$var$Ha:
                    return e = c._init, r(a, b, e(c._payload), d);
            }
            if ($b36288e2db101ba3$var$eb(c) || $b36288e2db101ba3$var$Ka(c)) return null !== e ? null : m(a, b, c, d, null);
            $b36288e2db101ba3$var$Mg(a, c);
        }
        return null;
    }
    function y(a, b, c, d, e) {
        if ("string" === typeof d && "" !== d || "number" === typeof d) return a = a.get(c) || null, h(b, a, "" + d, e);
        if ("object" === typeof d && null !== d) {
            switch(d.$$typeof){
                case $b36288e2db101ba3$var$va:
                    return a = a.get(null === d.key ? c : d.key) || null, k(b, a, d, e);
                case $b36288e2db101ba3$var$wa:
                    return a = a.get(null === d.key ? c : d.key) || null, l(b, a, d, e);
                case $b36288e2db101ba3$var$Ha:
                    var f = d._init;
                    return y(a, b, c, f(d._payload), e);
            }
            if ($b36288e2db101ba3$var$eb(d) || $b36288e2db101ba3$var$Ka(d)) return a = a.get(c) || null, m(b, a, d, e, null);
            $b36288e2db101ba3$var$Mg(b, d);
        }
        return null;
    }
    function n(e, g, h, k) {
        for(var l = null, m = null, u = g, w = g = 0, x = null; null !== u && w < h.length; w++){
            u.index > w ? (x = u, u = null) : x = u.sibling;
            var n = r(e, u, h[w], k);
            if (null === n) {
                null === u && (u = x);
                break;
            }
            a && u && null === n.alternate && b(e, u);
            g = f(n, g, w);
            null === m ? l = n : m.sibling = n;
            m = n;
            u = x;
        }
        if (w === h.length) return c(e, u), $b36288e2db101ba3$var$I && $b36288e2db101ba3$var$tg(e, w), l;
        if (null === u) {
            for(; w < h.length; w++)u = q(e, h[w], k), null !== u && (g = f(u, g, w), null === m ? l = u : m.sibling = u, m = u);
            $b36288e2db101ba3$var$I && $b36288e2db101ba3$var$tg(e, w);
            return l;
        }
        for(u = d(e, u); w < h.length; w++)x = y(u, e, w, h[w], k), null !== x && (a && null !== x.alternate && u.delete(null === x.key ? w : x.key), g = f(x, g, w), null === m ? l = x : m.sibling = x, m = x);
        a && u.forEach(function(a) {
            return b(e, a);
        });
        $b36288e2db101ba3$var$I && $b36288e2db101ba3$var$tg(e, w);
        return l;
    }
    function t(e, g, h, k) {
        var l = $b36288e2db101ba3$var$Ka(h);
        if ("function" !== typeof l) throw Error($b36288e2db101ba3$var$p(150));
        h = l.call(h);
        if (null == h) throw Error($b36288e2db101ba3$var$p(151));
        for(var u = l = null, m = g, w = g = 0, x = null, n = h.next(); null !== m && !n.done; w++, n = h.next()){
            m.index > w ? (x = m, m = null) : x = m.sibling;
            var t = r(e, m, n.value, k);
            if (null === t) {
                null === m && (m = x);
                break;
            }
            a && m && null === t.alternate && b(e, m);
            g = f(t, g, w);
            null === u ? l = t : u.sibling = t;
            u = t;
            m = x;
        }
        if (n.done) return c(e, m), $b36288e2db101ba3$var$I && $b36288e2db101ba3$var$tg(e, w), l;
        if (null === m) {
            for(; !n.done; w++, n = h.next())n = q(e, n.value, k), null !== n && (g = f(n, g, w), null === u ? l = n : u.sibling = n, u = n);
            $b36288e2db101ba3$var$I && $b36288e2db101ba3$var$tg(e, w);
            return l;
        }
        for(m = d(e, m); !n.done; w++, n = h.next())n = y(m, e, w, n.value, k), null !== n && (a && null !== n.alternate && m.delete(null === n.key ? w : n.key), g = f(n, g, w), null === u ? l = n : u.sibling = n, u = n);
        a && m.forEach(function(a) {
            return b(e, a);
        });
        $b36288e2db101ba3$var$I && $b36288e2db101ba3$var$tg(e, w);
        return l;
    }
    function J(a, d, f, h) {
        "object" === typeof f && null !== f && f.type === $b36288e2db101ba3$var$ya && null === f.key && (f = f.props.children);
        if ("object" === typeof f && null !== f) {
            switch(f.$$typeof){
                case $b36288e2db101ba3$var$va:
                    a: {
                        for(var k = f.key, l = d; null !== l;){
                            if (l.key === k) {
                                k = f.type;
                                if (k === $b36288e2db101ba3$var$ya) {
                                    if (7 === l.tag) {
                                        c(a, l.sibling);
                                        d = e(l, f.props.children);
                                        d.return = a;
                                        a = d;
                                        break a;
                                    }
                                } else if (l.elementType === k || "object" === typeof k && null !== k && k.$$typeof === $b36288e2db101ba3$var$Ha && $b36288e2db101ba3$var$Ng(k) === l.type) {
                                    c(a, l.sibling);
                                    d = e(l, f.props);
                                    d.ref = $b36288e2db101ba3$var$Lg(a, l, f);
                                    d.return = a;
                                    a = d;
                                    break a;
                                }
                                c(a, l);
                                break;
                            } else b(a, l);
                            l = l.sibling;
                        }
                        f.type === $b36288e2db101ba3$var$ya ? (d = $b36288e2db101ba3$var$Tg(f.props.children, a.mode, h, f.key), d.return = a, a = d) : (h = $b36288e2db101ba3$var$Rg(f.type, f.key, f.props, null, a.mode, h), h.ref = $b36288e2db101ba3$var$Lg(a, d, f), h.return = a, a = h);
                    }
                    return g(a);
                case $b36288e2db101ba3$var$wa:
                    a: {
                        for(l = f.key; null !== d;){
                            if (d.key === l) {
                                if (4 === d.tag && d.stateNode.containerInfo === f.containerInfo && d.stateNode.implementation === f.implementation) {
                                    c(a, d.sibling);
                                    d = e(d, f.children || []);
                                    d.return = a;
                                    a = d;
                                    break a;
                                } else {
                                    c(a, d);
                                    break;
                                }
                            } else b(a, d);
                            d = d.sibling;
                        }
                        d = $b36288e2db101ba3$var$Sg(f, a.mode, h);
                        d.return = a;
                        a = d;
                    }
                    return g(a);
                case $b36288e2db101ba3$var$Ha:
                    return l = f._init, J(a, d, l(f._payload), h);
            }
            if ($b36288e2db101ba3$var$eb(f)) return n(a, d, f, h);
            if ($b36288e2db101ba3$var$Ka(f)) return t(a, d, f, h);
            $b36288e2db101ba3$var$Mg(a, f);
        }
        return "string" === typeof f && "" !== f || "number" === typeof f ? (f = "" + f, null !== d && 6 === d.tag ? (c(a, d.sibling), d = e(d, f), d.return = a, a = d) : (c(a, d), d = $b36288e2db101ba3$var$Qg(f, a.mode, h), d.return = a, a = d), g(a)) : c(a, d);
    }
    return J;
}
var $b36288e2db101ba3$var$Ug = $b36288e2db101ba3$var$Og(!0), $b36288e2db101ba3$var$Vg = $b36288e2db101ba3$var$Og(!1), $b36288e2db101ba3$var$Wg = $b36288e2db101ba3$var$Uf(null), $b36288e2db101ba3$var$Xg = null, $b36288e2db101ba3$var$Yg = null, $b36288e2db101ba3$var$Zg = null;
function $b36288e2db101ba3$var$$g() {
    $b36288e2db101ba3$var$Zg = $b36288e2db101ba3$var$Yg = $b36288e2db101ba3$var$Xg = null;
}
function $b36288e2db101ba3$var$ah(a) {
    var b = $b36288e2db101ba3$var$Wg.current;
    $b36288e2db101ba3$var$E($b36288e2db101ba3$var$Wg);
    a._currentValue = b;
}
function $b36288e2db101ba3$var$bh(a, b, c) {
    for(; null !== a;){
        var d = a.alternate;
        (a.childLanes & b) !== b ? (a.childLanes |= b, null !== d && (d.childLanes |= b)) : null !== d && (d.childLanes & b) !== b && (d.childLanes |= b);
        if (a === c) break;
        a = a.return;
    }
}
function $b36288e2db101ba3$var$ch(a, b) {
    $b36288e2db101ba3$var$Xg = a;
    $b36288e2db101ba3$var$Zg = $b36288e2db101ba3$var$Yg = null;
    a = a.dependencies;
    null !== a && null !== a.firstContext && (0 !== (a.lanes & b) && ($b36288e2db101ba3$var$dh = !0), a.firstContext = null);
}
function $b36288e2db101ba3$var$eh(a) {
    var b = a._currentValue;
    if ($b36288e2db101ba3$var$Zg !== a) {
        if (a = {
            context: a,
            memoizedValue: b,
            next: null
        }, null === $b36288e2db101ba3$var$Yg) {
            if (null === $b36288e2db101ba3$var$Xg) throw Error($b36288e2db101ba3$var$p(308));
            $b36288e2db101ba3$var$Yg = a;
            $b36288e2db101ba3$var$Xg.dependencies = {
                lanes: 0,
                firstContext: a
            };
        } else $b36288e2db101ba3$var$Yg = $b36288e2db101ba3$var$Yg.next = a;
    }
    return b;
}
var $b36288e2db101ba3$var$fh = null;
function $b36288e2db101ba3$var$gh(a) {
    null === $b36288e2db101ba3$var$fh ? $b36288e2db101ba3$var$fh = [
        a
    ] : $b36288e2db101ba3$var$fh.push(a);
}
function $b36288e2db101ba3$var$hh(a, b, c, d) {
    var e = b.interleaved;
    null === e ? (c.next = c, $b36288e2db101ba3$var$gh(b)) : (c.next = e.next, e.next = c);
    b.interleaved = c;
    return $b36288e2db101ba3$var$ih(a, d);
}
function $b36288e2db101ba3$var$ih(a, b) {
    a.lanes |= b;
    var c = a.alternate;
    null !== c && (c.lanes |= b);
    c = a;
    for(a = a.return; null !== a;)a.childLanes |= b, c = a.alternate, null !== c && (c.childLanes |= b), c = a, a = a.return;
    return 3 === c.tag ? c.stateNode : null;
}
var $b36288e2db101ba3$var$jh = !1;
function $b36288e2db101ba3$var$kh(a) {
    a.updateQueue = {
        baseState: a.memoizedState,
        firstBaseUpdate: null,
        lastBaseUpdate: null,
        shared: {
            pending: null,
            interleaved: null,
            lanes: 0
        },
        effects: null
    };
}
function $b36288e2db101ba3$var$lh(a, b) {
    a = a.updateQueue;
    b.updateQueue === a && (b.updateQueue = {
        baseState: a.baseState,
        firstBaseUpdate: a.firstBaseUpdate,
        lastBaseUpdate: a.lastBaseUpdate,
        shared: a.shared,
        effects: a.effects
    });
}
function $b36288e2db101ba3$var$mh(a, b) {
    return {
        eventTime: a,
        lane: b,
        tag: 0,
        payload: null,
        callback: null,
        next: null
    };
}
function $b36288e2db101ba3$var$nh(a, b, c) {
    var d = a.updateQueue;
    if (null === d) return null;
    d = d.shared;
    if (0 !== ($b36288e2db101ba3$var$K & 2)) {
        var e = d.pending;
        null === e ? b.next = b : (b.next = e.next, e.next = b);
        d.pending = b;
        return $b36288e2db101ba3$var$ih(a, c);
    }
    e = d.interleaved;
    null === e ? (b.next = b, $b36288e2db101ba3$var$gh(d)) : (b.next = e.next, e.next = b);
    d.interleaved = b;
    return $b36288e2db101ba3$var$ih(a, c);
}
function $b36288e2db101ba3$var$oh(a, b, c) {
    b = b.updateQueue;
    if (null !== b && (b = b.shared, 0 !== (c & 4194240))) {
        var d = b.lanes;
        d &= a.pendingLanes;
        c |= d;
        b.lanes = c;
        $b36288e2db101ba3$var$Cc(a, c);
    }
}
function $b36288e2db101ba3$var$ph(a, b) {
    var c = a.updateQueue, d = a.alternate;
    if (null !== d && (d = d.updateQueue, c === d)) {
        var e = null, f = null;
        c = c.firstBaseUpdate;
        if (null !== c) {
            do {
                var g = {
                    eventTime: c.eventTime,
                    lane: c.lane,
                    tag: c.tag,
                    payload: c.payload,
                    callback: c.callback,
                    next: null
                };
                null === f ? e = f = g : f = f.next = g;
                c = c.next;
            }while (null !== c);
            null === f ? e = f = b : f = f.next = b;
        } else e = f = b;
        c = {
            baseState: d.baseState,
            firstBaseUpdate: e,
            lastBaseUpdate: f,
            shared: d.shared,
            effects: d.effects
        };
        a.updateQueue = c;
        return;
    }
    a = c.lastBaseUpdate;
    null === a ? c.firstBaseUpdate = b : a.next = b;
    c.lastBaseUpdate = b;
}
function $b36288e2db101ba3$var$qh(a, b, c, d) {
    var e = a.updateQueue;
    $b36288e2db101ba3$var$jh = !1;
    var f = e.firstBaseUpdate, g = e.lastBaseUpdate, h = e.shared.pending;
    if (null !== h) {
        e.shared.pending = null;
        var k = h, l = k.next;
        k.next = null;
        null === g ? f = l : g.next = l;
        g = k;
        var m = a.alternate;
        null !== m && (m = m.updateQueue, h = m.lastBaseUpdate, h !== g && (null === h ? m.firstBaseUpdate = l : h.next = l, m.lastBaseUpdate = k));
    }
    if (null !== f) {
        var q = e.baseState;
        g = 0;
        m = l = k = null;
        h = f;
        do {
            var r = h.lane, y = h.eventTime;
            if ((d & r) === r) {
                null !== m && (m = m.next = {
                    eventTime: y,
                    lane: 0,
                    tag: h.tag,
                    payload: h.payload,
                    callback: h.callback,
                    next: null
                });
                a: {
                    var n = a, t = h;
                    r = b;
                    y = c;
                    switch(t.tag){
                        case 1:
                            n = t.payload;
                            if ("function" === typeof n) {
                                q = n.call(y, q, r);
                                break a;
                            }
                            q = n;
                            break a;
                        case 3:
                            n.flags = n.flags & -65537 | 128;
                        case 0:
                            n = t.payload;
                            r = "function" === typeof n ? n.call(y, q, r) : n;
                            if (null === r || void 0 === r) break a;
                            q = $b36288e2db101ba3$var$A({}, q, r);
                            break a;
                        case 2:
                            $b36288e2db101ba3$var$jh = !0;
                    }
                }
                null !== h.callback && 0 !== h.lane && (a.flags |= 64, r = e.effects, null === r ? e.effects = [
                    h
                ] : r.push(h));
            } else y = {
                eventTime: y,
                lane: r,
                tag: h.tag,
                payload: h.payload,
                callback: h.callback,
                next: null
            }, null === m ? (l = m = y, k = q) : m = m.next = y, g |= r;
            h = h.next;
            if (null === h) {
                if (h = e.shared.pending, null === h) break;
                else r = h, h = r.next, r.next = null, e.lastBaseUpdate = r, e.shared.pending = null;
            }
        }while (1);
        null === m && (k = q);
        e.baseState = k;
        e.firstBaseUpdate = l;
        e.lastBaseUpdate = m;
        b = e.shared.interleaved;
        if (null !== b) {
            e = b;
            do g |= e.lane, e = e.next;
            while (e !== b);
        } else null === f && (e.shared.lanes = 0);
        $b36288e2db101ba3$var$rh |= g;
        a.lanes = g;
        a.memoizedState = q;
    }
}
function $b36288e2db101ba3$var$sh(a, b, c) {
    a = b.effects;
    b.effects = null;
    if (null !== a) for(b = 0; b < a.length; b++){
        var d = a[b], e = d.callback;
        if (null !== e) {
            d.callback = null;
            d = c;
            if ("function" !== typeof e) throw Error($b36288e2db101ba3$var$p(191, e));
            e.call(d);
        }
    }
}
var $b36288e2db101ba3$var$th = {}, $b36288e2db101ba3$var$uh = $b36288e2db101ba3$var$Uf($b36288e2db101ba3$var$th), $b36288e2db101ba3$var$vh = $b36288e2db101ba3$var$Uf($b36288e2db101ba3$var$th), $b36288e2db101ba3$var$wh = $b36288e2db101ba3$var$Uf($b36288e2db101ba3$var$th);
function $b36288e2db101ba3$var$xh(a) {
    if (a === $b36288e2db101ba3$var$th) throw Error($b36288e2db101ba3$var$p(174));
    return a;
}
function $b36288e2db101ba3$var$yh(a, b) {
    $b36288e2db101ba3$var$G($b36288e2db101ba3$var$wh, b);
    $b36288e2db101ba3$var$G($b36288e2db101ba3$var$vh, a);
    $b36288e2db101ba3$var$G($b36288e2db101ba3$var$uh, $b36288e2db101ba3$var$th);
    a = b.nodeType;
    switch(a){
        case 9:
        case 11:
            b = (b = b.documentElement) ? b.namespaceURI : $b36288e2db101ba3$var$lb(null, "");
            break;
        default:
            a = 8 === a ? b.parentNode : b, b = a.namespaceURI || null, a = a.tagName, b = $b36288e2db101ba3$var$lb(b, a);
    }
    $b36288e2db101ba3$var$E($b36288e2db101ba3$var$uh);
    $b36288e2db101ba3$var$G($b36288e2db101ba3$var$uh, b);
}
function $b36288e2db101ba3$var$zh() {
    $b36288e2db101ba3$var$E($b36288e2db101ba3$var$uh);
    $b36288e2db101ba3$var$E($b36288e2db101ba3$var$vh);
    $b36288e2db101ba3$var$E($b36288e2db101ba3$var$wh);
}
function $b36288e2db101ba3$var$Ah(a) {
    $b36288e2db101ba3$var$xh($b36288e2db101ba3$var$wh.current);
    var b = $b36288e2db101ba3$var$xh($b36288e2db101ba3$var$uh.current);
    var c = $b36288e2db101ba3$var$lb(b, a.type);
    b !== c && ($b36288e2db101ba3$var$G($b36288e2db101ba3$var$vh, a), $b36288e2db101ba3$var$G($b36288e2db101ba3$var$uh, c));
}
function $b36288e2db101ba3$var$Bh(a) {
    $b36288e2db101ba3$var$vh.current === a && ($b36288e2db101ba3$var$E($b36288e2db101ba3$var$uh), $b36288e2db101ba3$var$E($b36288e2db101ba3$var$vh));
}
var $b36288e2db101ba3$var$L = $b36288e2db101ba3$var$Uf(0);
function $b36288e2db101ba3$var$Ch(a) {
    for(var b = a; null !== b;){
        if (13 === b.tag) {
            var c = b.memoizedState;
            if (null !== c && (c = c.dehydrated, null === c || "$?" === c.data || "$!" === c.data)) return b;
        } else if (19 === b.tag && void 0 !== b.memoizedProps.revealOrder) {
            if (0 !== (b.flags & 128)) return b;
        } else if (null !== b.child) {
            b.child.return = b;
            b = b.child;
            continue;
        }
        if (b === a) break;
        for(; null === b.sibling;){
            if (null === b.return || b.return === a) return null;
            b = b.return;
        }
        b.sibling.return = b.return;
        b = b.sibling;
    }
    return null;
}
var $b36288e2db101ba3$var$Dh = [];
function $b36288e2db101ba3$var$Eh() {
    for(var a = 0; a < $b36288e2db101ba3$var$Dh.length; a++)$b36288e2db101ba3$var$Dh[a]._workInProgressVersionPrimary = null;
    $b36288e2db101ba3$var$Dh.length = 0;
}
var $b36288e2db101ba3$var$Fh = $b36288e2db101ba3$var$ua.ReactCurrentDispatcher, $b36288e2db101ba3$var$Gh = $b36288e2db101ba3$var$ua.ReactCurrentBatchConfig, $b36288e2db101ba3$var$Hh = 0, $b36288e2db101ba3$var$M = null, $b36288e2db101ba3$var$N = null, $b36288e2db101ba3$var$O = null, $b36288e2db101ba3$var$Ih = !1, $b36288e2db101ba3$var$Jh = !1, $b36288e2db101ba3$var$Kh = 0, $b36288e2db101ba3$var$Lh = 0;
function $b36288e2db101ba3$var$P() {
    throw Error($b36288e2db101ba3$var$p(321));
}
function $b36288e2db101ba3$var$Mh(a, b) {
    if (null === b) return !1;
    for(var c = 0; c < b.length && c < a.length; c++)if (!$b36288e2db101ba3$var$He(a[c], b[c])) return !1;
    return !0;
}
function $b36288e2db101ba3$var$Nh(a, b, c, d, e, f) {
    $b36288e2db101ba3$var$Hh = f;
    $b36288e2db101ba3$var$M = b;
    b.memoizedState = null;
    b.updateQueue = null;
    b.lanes = 0;
    $b36288e2db101ba3$var$Fh.current = null === a || null === a.memoizedState ? $b36288e2db101ba3$var$Oh : $b36288e2db101ba3$var$Ph;
    a = c(d, e);
    if ($b36288e2db101ba3$var$Jh) {
        f = 0;
        do {
            $b36288e2db101ba3$var$Jh = !1;
            $b36288e2db101ba3$var$Kh = 0;
            if (25 <= f) throw Error($b36288e2db101ba3$var$p(301));
            f += 1;
            $b36288e2db101ba3$var$O = $b36288e2db101ba3$var$N = null;
            b.updateQueue = null;
            $b36288e2db101ba3$var$Fh.current = $b36288e2db101ba3$var$Qh;
            a = c(d, e);
        }while ($b36288e2db101ba3$var$Jh);
    }
    $b36288e2db101ba3$var$Fh.current = $b36288e2db101ba3$var$Rh;
    b = null !== $b36288e2db101ba3$var$N && null !== $b36288e2db101ba3$var$N.next;
    $b36288e2db101ba3$var$Hh = 0;
    $b36288e2db101ba3$var$O = $b36288e2db101ba3$var$N = $b36288e2db101ba3$var$M = null;
    $b36288e2db101ba3$var$Ih = !1;
    if (b) throw Error($b36288e2db101ba3$var$p(300));
    return a;
}
function $b36288e2db101ba3$var$Sh() {
    var a = 0 !== $b36288e2db101ba3$var$Kh;
    $b36288e2db101ba3$var$Kh = 0;
    return a;
}
function $b36288e2db101ba3$var$Th() {
    var a = {
        memoizedState: null,
        baseState: null,
        baseQueue: null,
        queue: null,
        next: null
    };
    null === $b36288e2db101ba3$var$O ? $b36288e2db101ba3$var$M.memoizedState = $b36288e2db101ba3$var$O = a : $b36288e2db101ba3$var$O = $b36288e2db101ba3$var$O.next = a;
    return $b36288e2db101ba3$var$O;
}
function $b36288e2db101ba3$var$Uh() {
    if (null === $b36288e2db101ba3$var$N) {
        var a = $b36288e2db101ba3$var$M.alternate;
        a = null !== a ? a.memoizedState : null;
    } else a = $b36288e2db101ba3$var$N.next;
    var b = null === $b36288e2db101ba3$var$O ? $b36288e2db101ba3$var$M.memoizedState : $b36288e2db101ba3$var$O.next;
    if (null !== b) $b36288e2db101ba3$var$O = b, $b36288e2db101ba3$var$N = a;
    else {
        if (null === a) throw Error($b36288e2db101ba3$var$p(310));
        $b36288e2db101ba3$var$N = a;
        a = {
            memoizedState: $b36288e2db101ba3$var$N.memoizedState,
            baseState: $b36288e2db101ba3$var$N.baseState,
            baseQueue: $b36288e2db101ba3$var$N.baseQueue,
            queue: $b36288e2db101ba3$var$N.queue,
            next: null
        };
        null === $b36288e2db101ba3$var$O ? $b36288e2db101ba3$var$M.memoizedState = $b36288e2db101ba3$var$O = a : $b36288e2db101ba3$var$O = $b36288e2db101ba3$var$O.next = a;
    }
    return $b36288e2db101ba3$var$O;
}
function $b36288e2db101ba3$var$Vh(a, b) {
    return "function" === typeof b ? b(a) : b;
}
function $b36288e2db101ba3$var$Wh(a) {
    var b = $b36288e2db101ba3$var$Uh(), c = b.queue;
    if (null === c) throw Error($b36288e2db101ba3$var$p(311));
    c.lastRenderedReducer = a;
    var d = $b36288e2db101ba3$var$N, e = d.baseQueue, f = c.pending;
    if (null !== f) {
        if (null !== e) {
            var g = e.next;
            e.next = f.next;
            f.next = g;
        }
        d.baseQueue = e = f;
        c.pending = null;
    }
    if (null !== e) {
        f = e.next;
        d = d.baseState;
        var h = g = null, k = null, l = f;
        do {
            var m = l.lane;
            if (($b36288e2db101ba3$var$Hh & m) === m) null !== k && (k = k.next = {
                lane: 0,
                action: l.action,
                hasEagerState: l.hasEagerState,
                eagerState: l.eagerState,
                next: null
            }), d = l.hasEagerState ? l.eagerState : a(d, l.action);
            else {
                var q = {
                    lane: m,
                    action: l.action,
                    hasEagerState: l.hasEagerState,
                    eagerState: l.eagerState,
                    next: null
                };
                null === k ? (h = k = q, g = d) : k = k.next = q;
                $b36288e2db101ba3$var$M.lanes |= m;
                $b36288e2db101ba3$var$rh |= m;
            }
            l = l.next;
        }while (null !== l && l !== f);
        null === k ? g = d : k.next = h;
        $b36288e2db101ba3$var$He(d, b.memoizedState) || ($b36288e2db101ba3$var$dh = !0);
        b.memoizedState = d;
        b.baseState = g;
        b.baseQueue = k;
        c.lastRenderedState = d;
    }
    a = c.interleaved;
    if (null !== a) {
        e = a;
        do f = e.lane, $b36288e2db101ba3$var$M.lanes |= f, $b36288e2db101ba3$var$rh |= f, e = e.next;
        while (e !== a);
    } else null === e && (c.lanes = 0);
    return [
        b.memoizedState,
        c.dispatch
    ];
}
function $b36288e2db101ba3$var$Xh(a) {
    var b = $b36288e2db101ba3$var$Uh(), c = b.queue;
    if (null === c) throw Error($b36288e2db101ba3$var$p(311));
    c.lastRenderedReducer = a;
    var d = c.dispatch, e = c.pending, f = b.memoizedState;
    if (null !== e) {
        c.pending = null;
        var g = e = e.next;
        do f = a(f, g.action), g = g.next;
        while (g !== e);
        $b36288e2db101ba3$var$He(f, b.memoizedState) || ($b36288e2db101ba3$var$dh = !0);
        b.memoizedState = f;
        null === b.baseQueue && (b.baseState = f);
        c.lastRenderedState = f;
    }
    return [
        f,
        d
    ];
}
function $b36288e2db101ba3$var$Yh() {}
function $b36288e2db101ba3$var$Zh(a, b) {
    var c = $b36288e2db101ba3$var$M, d = $b36288e2db101ba3$var$Uh(), e = b(), f = !$b36288e2db101ba3$var$He(d.memoizedState, e);
    f && (d.memoizedState = e, $b36288e2db101ba3$var$dh = !0);
    d = d.queue;
    $b36288e2db101ba3$var$$h($b36288e2db101ba3$var$ai.bind(null, c, d, a), [
        a
    ]);
    if (d.getSnapshot !== b || f || null !== $b36288e2db101ba3$var$O && $b36288e2db101ba3$var$O.memoizedState.tag & 1) {
        c.flags |= 2048;
        $b36288e2db101ba3$var$bi(9, $b36288e2db101ba3$var$ci.bind(null, c, d, e, b), void 0, null);
        if (null === $b36288e2db101ba3$var$Q) throw Error($b36288e2db101ba3$var$p(349));
        0 !== ($b36288e2db101ba3$var$Hh & 30) || $b36288e2db101ba3$var$di(c, b, e);
    }
    return e;
}
function $b36288e2db101ba3$var$di(a, b, c) {
    a.flags |= 16384;
    a = {
        getSnapshot: b,
        value: c
    };
    b = $b36288e2db101ba3$var$M.updateQueue;
    null === b ? (b = {
        lastEffect: null,
        stores: null
    }, $b36288e2db101ba3$var$M.updateQueue = b, b.stores = [
        a
    ]) : (c = b.stores, null === c ? b.stores = [
        a
    ] : c.push(a));
}
function $b36288e2db101ba3$var$ci(a, b, c, d) {
    b.value = c;
    b.getSnapshot = d;
    $b36288e2db101ba3$var$ei(b) && $b36288e2db101ba3$var$fi(a);
}
function $b36288e2db101ba3$var$ai(a, b, c) {
    return c(function() {
        $b36288e2db101ba3$var$ei(b) && $b36288e2db101ba3$var$fi(a);
    });
}
function $b36288e2db101ba3$var$ei(a) {
    var b = a.getSnapshot;
    a = a.value;
    try {
        var c = b();
        return !$b36288e2db101ba3$var$He(a, c);
    } catch (d) {
        return !0;
    }
}
function $b36288e2db101ba3$var$fi(a) {
    var b = $b36288e2db101ba3$var$ih(a, 1);
    null !== b && $b36288e2db101ba3$var$gi(b, a, 1, -1);
}
function $b36288e2db101ba3$var$hi(a) {
    var b = $b36288e2db101ba3$var$Th();
    "function" === typeof a && (a = a());
    b.memoizedState = b.baseState = a;
    a = {
        pending: null,
        interleaved: null,
        lanes: 0,
        dispatch: null,
        lastRenderedReducer: $b36288e2db101ba3$var$Vh,
        lastRenderedState: a
    };
    b.queue = a;
    a = a.dispatch = $b36288e2db101ba3$var$ii.bind(null, $b36288e2db101ba3$var$M, a);
    return [
        b.memoizedState,
        a
    ];
}
function $b36288e2db101ba3$var$bi(a, b, c, d) {
    a = {
        tag: a,
        create: b,
        destroy: c,
        deps: d,
        next: null
    };
    b = $b36288e2db101ba3$var$M.updateQueue;
    null === b ? (b = {
        lastEffect: null,
        stores: null
    }, $b36288e2db101ba3$var$M.updateQueue = b, b.lastEffect = a.next = a) : (c = b.lastEffect, null === c ? b.lastEffect = a.next = a : (d = c.next, c.next = a, a.next = d, b.lastEffect = a));
    return a;
}
function $b36288e2db101ba3$var$ji() {
    return $b36288e2db101ba3$var$Uh().memoizedState;
}
function $b36288e2db101ba3$var$ki(a, b, c, d) {
    var e = $b36288e2db101ba3$var$Th();
    $b36288e2db101ba3$var$M.flags |= a;
    e.memoizedState = $b36288e2db101ba3$var$bi(1 | b, c, void 0, void 0 === d ? null : d);
}
function $b36288e2db101ba3$var$li(a, b, c, d) {
    var e = $b36288e2db101ba3$var$Uh();
    d = void 0 === d ? null : d;
    var f = void 0;
    if (null !== $b36288e2db101ba3$var$N) {
        var g = $b36288e2db101ba3$var$N.memoizedState;
        f = g.destroy;
        if (null !== d && $b36288e2db101ba3$var$Mh(d, g.deps)) {
            e.memoizedState = $b36288e2db101ba3$var$bi(b, c, f, d);
            return;
        }
    }
    $b36288e2db101ba3$var$M.flags |= a;
    e.memoizedState = $b36288e2db101ba3$var$bi(1 | b, c, f, d);
}
function $b36288e2db101ba3$var$mi(a, b) {
    return $b36288e2db101ba3$var$ki(8390656, 8, a, b);
}
function $b36288e2db101ba3$var$$h(a, b) {
    return $b36288e2db101ba3$var$li(2048, 8, a, b);
}
function $b36288e2db101ba3$var$ni(a, b) {
    return $b36288e2db101ba3$var$li(4, 2, a, b);
}
function $b36288e2db101ba3$var$oi(a, b) {
    return $b36288e2db101ba3$var$li(4, 4, a, b);
}
function $b36288e2db101ba3$var$pi(a, b) {
    if ("function" === typeof b) return a = a(), b(a), function() {
        b(null);
    };
    if (null !== b && void 0 !== b) return a = a(), b.current = a, function() {
        b.current = null;
    };
}
function $b36288e2db101ba3$var$qi(a, b, c) {
    c = null !== c && void 0 !== c ? c.concat([
        a
    ]) : null;
    return $b36288e2db101ba3$var$li(4, 4, $b36288e2db101ba3$var$pi.bind(null, b, a), c);
}
function $b36288e2db101ba3$var$ri() {}
function $b36288e2db101ba3$var$si(a, b) {
    var c = $b36288e2db101ba3$var$Uh();
    b = void 0 === b ? null : b;
    var d = c.memoizedState;
    if (null !== d && null !== b && $b36288e2db101ba3$var$Mh(b, d[1])) return d[0];
    c.memoizedState = [
        a,
        b
    ];
    return a;
}
function $b36288e2db101ba3$var$ti(a, b) {
    var c = $b36288e2db101ba3$var$Uh();
    b = void 0 === b ? null : b;
    var d = c.memoizedState;
    if (null !== d && null !== b && $b36288e2db101ba3$var$Mh(b, d[1])) return d[0];
    a = a();
    c.memoizedState = [
        a,
        b
    ];
    return a;
}
function $b36288e2db101ba3$var$ui(a, b, c) {
    if (0 === ($b36288e2db101ba3$var$Hh & 21)) return a.baseState && (a.baseState = !1, $b36288e2db101ba3$var$dh = !0), a.memoizedState = c;
    $b36288e2db101ba3$var$He(c, b) || (c = $b36288e2db101ba3$var$yc(), $b36288e2db101ba3$var$M.lanes |= c, $b36288e2db101ba3$var$rh |= c, a.baseState = !0);
    return b;
}
function $b36288e2db101ba3$var$vi(a, b) {
    var c = $b36288e2db101ba3$var$C;
    $b36288e2db101ba3$var$C = 0 !== c && 4 > c ? c : 4;
    a(!0);
    var d = $b36288e2db101ba3$var$Gh.transition;
    $b36288e2db101ba3$var$Gh.transition = {};
    try {
        a(!1), b();
    } finally{
        $b36288e2db101ba3$var$C = c, $b36288e2db101ba3$var$Gh.transition = d;
    }
}
function $b36288e2db101ba3$var$wi() {
    return $b36288e2db101ba3$var$Uh().memoizedState;
}
function $b36288e2db101ba3$var$xi(a, b, c) {
    var d = $b36288e2db101ba3$var$yi(a);
    c = {
        lane: d,
        action: c,
        hasEagerState: !1,
        eagerState: null,
        next: null
    };
    if ($b36288e2db101ba3$var$zi(a)) $b36288e2db101ba3$var$Ai(b, c);
    else if (c = $b36288e2db101ba3$var$hh(a, b, c, d), null !== c) {
        var e = $b36288e2db101ba3$var$R();
        $b36288e2db101ba3$var$gi(c, a, d, e);
        $b36288e2db101ba3$var$Bi(c, b, d);
    }
}
function $b36288e2db101ba3$var$ii(a, b, c) {
    var d = $b36288e2db101ba3$var$yi(a), e = {
        lane: d,
        action: c,
        hasEagerState: !1,
        eagerState: null,
        next: null
    };
    if ($b36288e2db101ba3$var$zi(a)) $b36288e2db101ba3$var$Ai(b, e);
    else {
        var f = a.alternate;
        if (0 === a.lanes && (null === f || 0 === f.lanes) && (f = b.lastRenderedReducer, null !== f)) try {
            var g = b.lastRenderedState, h = f(g, c);
            e.hasEagerState = !0;
            e.eagerState = h;
            if ($b36288e2db101ba3$var$He(h, g)) {
                var k = b.interleaved;
                null === k ? (e.next = e, $b36288e2db101ba3$var$gh(b)) : (e.next = k.next, k.next = e);
                b.interleaved = e;
                return;
            }
        } catch (l) {} finally{}
        c = $b36288e2db101ba3$var$hh(a, b, e, d);
        null !== c && (e = $b36288e2db101ba3$var$R(), $b36288e2db101ba3$var$gi(c, a, d, e), $b36288e2db101ba3$var$Bi(c, b, d));
    }
}
function $b36288e2db101ba3$var$zi(a) {
    var b = a.alternate;
    return a === $b36288e2db101ba3$var$M || null !== b && b === $b36288e2db101ba3$var$M;
}
function $b36288e2db101ba3$var$Ai(a, b) {
    $b36288e2db101ba3$var$Jh = $b36288e2db101ba3$var$Ih = !0;
    var c = a.pending;
    null === c ? b.next = b : (b.next = c.next, c.next = b);
    a.pending = b;
}
function $b36288e2db101ba3$var$Bi(a, b, c) {
    if (0 !== (c & 4194240)) {
        var d = b.lanes;
        d &= a.pendingLanes;
        c |= d;
        b.lanes = c;
        $b36288e2db101ba3$var$Cc(a, c);
    }
}
var $b36288e2db101ba3$var$Rh = {
    readContext: $b36288e2db101ba3$var$eh,
    useCallback: $b36288e2db101ba3$var$P,
    useContext: $b36288e2db101ba3$var$P,
    useEffect: $b36288e2db101ba3$var$P,
    useImperativeHandle: $b36288e2db101ba3$var$P,
    useInsertionEffect: $b36288e2db101ba3$var$P,
    useLayoutEffect: $b36288e2db101ba3$var$P,
    useMemo: $b36288e2db101ba3$var$P,
    useReducer: $b36288e2db101ba3$var$P,
    useRef: $b36288e2db101ba3$var$P,
    useState: $b36288e2db101ba3$var$P,
    useDebugValue: $b36288e2db101ba3$var$P,
    useDeferredValue: $b36288e2db101ba3$var$P,
    useTransition: $b36288e2db101ba3$var$P,
    useMutableSource: $b36288e2db101ba3$var$P,
    useSyncExternalStore: $b36288e2db101ba3$var$P,
    useId: $b36288e2db101ba3$var$P,
    unstable_isNewReconciler: !1
}, $b36288e2db101ba3$var$Oh = {
    readContext: $b36288e2db101ba3$var$eh,
    useCallback: function(a, b) {
        $b36288e2db101ba3$var$Th().memoizedState = [
            a,
            void 0 === b ? null : b
        ];
        return a;
    },
    useContext: $b36288e2db101ba3$var$eh,
    useEffect: $b36288e2db101ba3$var$mi,
    useImperativeHandle: function(a, b, c) {
        c = null !== c && void 0 !== c ? c.concat([
            a
        ]) : null;
        return $b36288e2db101ba3$var$ki(4194308, 4, $b36288e2db101ba3$var$pi.bind(null, b, a), c);
    },
    useLayoutEffect: function(a, b) {
        return $b36288e2db101ba3$var$ki(4194308, 4, a, b);
    },
    useInsertionEffect: function(a, b) {
        return $b36288e2db101ba3$var$ki(4, 2, a, b);
    },
    useMemo: function(a, b) {
        var c = $b36288e2db101ba3$var$Th();
        b = void 0 === b ? null : b;
        a = a();
        c.memoizedState = [
            a,
            b
        ];
        return a;
    },
    useReducer: function(a, b, c) {
        var d = $b36288e2db101ba3$var$Th();
        b = void 0 !== c ? c(b) : b;
        d.memoizedState = d.baseState = b;
        a = {
            pending: null,
            interleaved: null,
            lanes: 0,
            dispatch: null,
            lastRenderedReducer: a,
            lastRenderedState: b
        };
        d.queue = a;
        a = a.dispatch = $b36288e2db101ba3$var$xi.bind(null, $b36288e2db101ba3$var$M, a);
        return [
            d.memoizedState,
            a
        ];
    },
    useRef: function(a) {
        var b = $b36288e2db101ba3$var$Th();
        a = {
            current: a
        };
        return b.memoizedState = a;
    },
    useState: $b36288e2db101ba3$var$hi,
    useDebugValue: $b36288e2db101ba3$var$ri,
    useDeferredValue: function(a) {
        return $b36288e2db101ba3$var$Th().memoizedState = a;
    },
    useTransition: function() {
        var a = $b36288e2db101ba3$var$hi(!1), b = a[0];
        a = $b36288e2db101ba3$var$vi.bind(null, a[1]);
        $b36288e2db101ba3$var$Th().memoizedState = a;
        return [
            b,
            a
        ];
    },
    useMutableSource: function() {},
    useSyncExternalStore: function(a, b, c) {
        var d = $b36288e2db101ba3$var$M, e = $b36288e2db101ba3$var$Th();
        if ($b36288e2db101ba3$var$I) {
            if (void 0 === c) throw Error($b36288e2db101ba3$var$p(407));
            c = c();
        } else {
            c = b();
            if (null === $b36288e2db101ba3$var$Q) throw Error($b36288e2db101ba3$var$p(349));
            0 !== ($b36288e2db101ba3$var$Hh & 30) || $b36288e2db101ba3$var$di(d, b, c);
        }
        e.memoizedState = c;
        var f = {
            value: c,
            getSnapshot: b
        };
        e.queue = f;
        $b36288e2db101ba3$var$mi($b36288e2db101ba3$var$ai.bind(null, d, f, a), [
            a
        ]);
        d.flags |= 2048;
        $b36288e2db101ba3$var$bi(9, $b36288e2db101ba3$var$ci.bind(null, d, f, c, b), void 0, null);
        return c;
    },
    useId: function() {
        var a = $b36288e2db101ba3$var$Th(), b = $b36288e2db101ba3$var$Q.identifierPrefix;
        if ($b36288e2db101ba3$var$I) {
            var c = $b36288e2db101ba3$var$sg;
            var d = $b36288e2db101ba3$var$rg;
            c = (d & ~(1 << 32 - $b36288e2db101ba3$var$oc(d) - 1)).toString(32) + c;
            b = ":" + b + "R" + c;
            c = $b36288e2db101ba3$var$Kh++;
            0 < c && (b += "H" + c.toString(32));
            b += ":";
        } else c = $b36288e2db101ba3$var$Lh++, b = ":" + b + "r" + c.toString(32) + ":";
        return a.memoizedState = b;
    },
    unstable_isNewReconciler: !1
}, $b36288e2db101ba3$var$Ph = {
    readContext: $b36288e2db101ba3$var$eh,
    useCallback: $b36288e2db101ba3$var$si,
    useContext: $b36288e2db101ba3$var$eh,
    useEffect: $b36288e2db101ba3$var$$h,
    useImperativeHandle: $b36288e2db101ba3$var$qi,
    useInsertionEffect: $b36288e2db101ba3$var$ni,
    useLayoutEffect: $b36288e2db101ba3$var$oi,
    useMemo: $b36288e2db101ba3$var$ti,
    useReducer: $b36288e2db101ba3$var$Wh,
    useRef: $b36288e2db101ba3$var$ji,
    useState: function() {
        return $b36288e2db101ba3$var$Wh($b36288e2db101ba3$var$Vh);
    },
    useDebugValue: $b36288e2db101ba3$var$ri,
    useDeferredValue: function(a) {
        var b = $b36288e2db101ba3$var$Uh();
        return $b36288e2db101ba3$var$ui(b, $b36288e2db101ba3$var$N.memoizedState, a);
    },
    useTransition: function() {
        var a = $b36288e2db101ba3$var$Wh($b36288e2db101ba3$var$Vh)[0], b = $b36288e2db101ba3$var$Uh().memoizedState;
        return [
            a,
            b
        ];
    },
    useMutableSource: $b36288e2db101ba3$var$Yh,
    useSyncExternalStore: $b36288e2db101ba3$var$Zh,
    useId: $b36288e2db101ba3$var$wi,
    unstable_isNewReconciler: !1
}, $b36288e2db101ba3$var$Qh = {
    readContext: $b36288e2db101ba3$var$eh,
    useCallback: $b36288e2db101ba3$var$si,
    useContext: $b36288e2db101ba3$var$eh,
    useEffect: $b36288e2db101ba3$var$$h,
    useImperativeHandle: $b36288e2db101ba3$var$qi,
    useInsertionEffect: $b36288e2db101ba3$var$ni,
    useLayoutEffect: $b36288e2db101ba3$var$oi,
    useMemo: $b36288e2db101ba3$var$ti,
    useReducer: $b36288e2db101ba3$var$Xh,
    useRef: $b36288e2db101ba3$var$ji,
    useState: function() {
        return $b36288e2db101ba3$var$Xh($b36288e2db101ba3$var$Vh);
    },
    useDebugValue: $b36288e2db101ba3$var$ri,
    useDeferredValue: function(a) {
        var b = $b36288e2db101ba3$var$Uh();
        return null === $b36288e2db101ba3$var$N ? b.memoizedState = a : $b36288e2db101ba3$var$ui(b, $b36288e2db101ba3$var$N.memoizedState, a);
    },
    useTransition: function() {
        var a = $b36288e2db101ba3$var$Xh($b36288e2db101ba3$var$Vh)[0], b = $b36288e2db101ba3$var$Uh().memoizedState;
        return [
            a,
            b
        ];
    },
    useMutableSource: $b36288e2db101ba3$var$Yh,
    useSyncExternalStore: $b36288e2db101ba3$var$Zh,
    useId: $b36288e2db101ba3$var$wi,
    unstable_isNewReconciler: !1
};
function $b36288e2db101ba3$var$Ci(a, b) {
    if (a && a.defaultProps) {
        b = $b36288e2db101ba3$var$A({}, b);
        a = a.defaultProps;
        for(var c in a)void 0 === b[c] && (b[c] = a[c]);
        return b;
    }
    return b;
}
function $b36288e2db101ba3$var$Di(a, b, c, d) {
    b = a.memoizedState;
    c = c(d, b);
    c = null === c || void 0 === c ? b : $b36288e2db101ba3$var$A({}, b, c);
    a.memoizedState = c;
    0 === a.lanes && (a.updateQueue.baseState = c);
}
var $b36288e2db101ba3$var$Ei = {
    isMounted: function(a) {
        return (a = a._reactInternals) ? $b36288e2db101ba3$var$Vb(a) === a : !1;
    },
    enqueueSetState: function(a, b, c) {
        a = a._reactInternals;
        var d = $b36288e2db101ba3$var$R(), e = $b36288e2db101ba3$var$yi(a), f = $b36288e2db101ba3$var$mh(d, e);
        f.payload = b;
        void 0 !== c && null !== c && (f.callback = c);
        b = $b36288e2db101ba3$var$nh(a, f, e);
        null !== b && ($b36288e2db101ba3$var$gi(b, a, e, d), $b36288e2db101ba3$var$oh(b, a, e));
    },
    enqueueReplaceState: function(a, b, c) {
        a = a._reactInternals;
        var d = $b36288e2db101ba3$var$R(), e = $b36288e2db101ba3$var$yi(a), f = $b36288e2db101ba3$var$mh(d, e);
        f.tag = 1;
        f.payload = b;
        void 0 !== c && null !== c && (f.callback = c);
        b = $b36288e2db101ba3$var$nh(a, f, e);
        null !== b && ($b36288e2db101ba3$var$gi(b, a, e, d), $b36288e2db101ba3$var$oh(b, a, e));
    },
    enqueueForceUpdate: function(a, b) {
        a = a._reactInternals;
        var c = $b36288e2db101ba3$var$R(), d = $b36288e2db101ba3$var$yi(a), e = $b36288e2db101ba3$var$mh(c, d);
        e.tag = 2;
        void 0 !== b && null !== b && (e.callback = b);
        b = $b36288e2db101ba3$var$nh(a, e, d);
        null !== b && ($b36288e2db101ba3$var$gi(b, a, d, c), $b36288e2db101ba3$var$oh(b, a, d));
    }
};
function $b36288e2db101ba3$var$Fi(a, b, c, d, e, f, g) {
    a = a.stateNode;
    return "function" === typeof a.shouldComponentUpdate ? a.shouldComponentUpdate(d, f, g) : b.prototype && b.prototype.isPureReactComponent ? !$b36288e2db101ba3$var$Ie(c, d) || !$b36288e2db101ba3$var$Ie(e, f) : !0;
}
function $b36288e2db101ba3$var$Gi(a, b, c) {
    var d = !1, e = $b36288e2db101ba3$var$Vf;
    var f = b.contextType;
    "object" === typeof f && null !== f ? f = $b36288e2db101ba3$var$eh(f) : (e = $b36288e2db101ba3$var$Zf(b) ? $b36288e2db101ba3$var$Xf : $b36288e2db101ba3$var$H.current, d = b.contextTypes, f = (d = null !== d && void 0 !== d) ? $b36288e2db101ba3$var$Yf(a, e) : $b36288e2db101ba3$var$Vf);
    b = new b(c, f);
    a.memoizedState = null !== b.state && void 0 !== b.state ? b.state : null;
    b.updater = $b36288e2db101ba3$var$Ei;
    a.stateNode = b;
    b._reactInternals = a;
    d && (a = a.stateNode, a.__reactInternalMemoizedUnmaskedChildContext = e, a.__reactInternalMemoizedMaskedChildContext = f);
    return b;
}
function $b36288e2db101ba3$var$Hi(a, b, c, d) {
    a = b.state;
    "function" === typeof b.componentWillReceiveProps && b.componentWillReceiveProps(c, d);
    "function" === typeof b.UNSAFE_componentWillReceiveProps && b.UNSAFE_componentWillReceiveProps(c, d);
    b.state !== a && $b36288e2db101ba3$var$Ei.enqueueReplaceState(b, b.state, null);
}
function $b36288e2db101ba3$var$Ii(a, b, c, d) {
    var e = a.stateNode;
    e.props = c;
    e.state = a.memoizedState;
    e.refs = {};
    $b36288e2db101ba3$var$kh(a);
    var f = b.contextType;
    "object" === typeof f && null !== f ? e.context = $b36288e2db101ba3$var$eh(f) : (f = $b36288e2db101ba3$var$Zf(b) ? $b36288e2db101ba3$var$Xf : $b36288e2db101ba3$var$H.current, e.context = $b36288e2db101ba3$var$Yf(a, f));
    e.state = a.memoizedState;
    f = b.getDerivedStateFromProps;
    "function" === typeof f && ($b36288e2db101ba3$var$Di(a, b, f, c), e.state = a.memoizedState);
    "function" === typeof b.getDerivedStateFromProps || "function" === typeof e.getSnapshotBeforeUpdate || "function" !== typeof e.UNSAFE_componentWillMount && "function" !== typeof e.componentWillMount || (b = e.state, "function" === typeof e.componentWillMount && e.componentWillMount(), "function" === typeof e.UNSAFE_componentWillMount && e.UNSAFE_componentWillMount(), b !== e.state && $b36288e2db101ba3$var$Ei.enqueueReplaceState(e, e.state, null), $b36288e2db101ba3$var$qh(a, c, e, d), e.state = a.memoizedState);
    "function" === typeof e.componentDidMount && (a.flags |= 4194308);
}
function $b36288e2db101ba3$var$Ji(a, b) {
    try {
        var c = "", d = b;
        do c += $b36288e2db101ba3$var$Pa(d), d = d.return;
        while (d);
        var e = c;
    } catch (f) {
        e = "\nError generating stack: " + f.message + "\n" + f.stack;
    }
    return {
        value: a,
        source: b,
        stack: e,
        digest: null
    };
}
function $b36288e2db101ba3$var$Ki(a, b, c) {
    return {
        value: a,
        source: null,
        stack: null != c ? c : null,
        digest: null != b ? b : null
    };
}
function $b36288e2db101ba3$var$Li(a, b) {
    try {
        console.error(b.value);
    } catch (c) {
        setTimeout(function() {
            throw c;
        });
    }
}
var $b36288e2db101ba3$var$Mi = "function" === typeof WeakMap ? WeakMap : Map;
function $b36288e2db101ba3$var$Ni(a, b, c) {
    c = $b36288e2db101ba3$var$mh(-1, c);
    c.tag = 3;
    c.payload = {
        element: null
    };
    var d = b.value;
    c.callback = function() {
        $b36288e2db101ba3$var$Oi || ($b36288e2db101ba3$var$Oi = !0, $b36288e2db101ba3$var$Pi = d);
        $b36288e2db101ba3$var$Li(a, b);
    };
    return c;
}
function $b36288e2db101ba3$var$Qi(a, b, c) {
    c = $b36288e2db101ba3$var$mh(-1, c);
    c.tag = 3;
    var d = a.type.getDerivedStateFromError;
    if ("function" === typeof d) {
        var e = b.value;
        c.payload = function() {
            return d(e);
        };
        c.callback = function() {
            $b36288e2db101ba3$var$Li(a, b);
        };
    }
    var f = a.stateNode;
    null !== f && "function" === typeof f.componentDidCatch && (c.callback = function() {
        $b36288e2db101ba3$var$Li(a, b);
        "function" !== typeof d && (null === $b36288e2db101ba3$var$Ri ? $b36288e2db101ba3$var$Ri = new Set([
            this
        ]) : $b36288e2db101ba3$var$Ri.add(this));
        var c = b.stack;
        this.componentDidCatch(b.value, {
            componentStack: null !== c ? c : ""
        });
    });
    return c;
}
function $b36288e2db101ba3$var$Si(a, b, c) {
    var d = a.pingCache;
    if (null === d) {
        d = a.pingCache = new $b36288e2db101ba3$var$Mi;
        var e = new Set;
        d.set(b, e);
    } else e = d.get(b), void 0 === e && (e = new Set, d.set(b, e));
    e.has(c) || (e.add(c), a = $b36288e2db101ba3$var$Ti.bind(null, a, b, c), b.then(a, a));
}
function $b36288e2db101ba3$var$Ui(a) {
    do {
        var b;
        if (b = 13 === a.tag) b = a.memoizedState, b = null !== b ? null !== b.dehydrated ? !0 : !1 : !0;
        if (b) return a;
        a = a.return;
    }while (null !== a);
    return null;
}
function $b36288e2db101ba3$var$Vi(a, b, c, d, e) {
    if (0 === (a.mode & 1)) return a === b ? a.flags |= 65536 : (a.flags |= 128, c.flags |= 131072, c.flags &= -52805, 1 === c.tag && (null === c.alternate ? c.tag = 17 : (b = $b36288e2db101ba3$var$mh(-1, 1), b.tag = 2, $b36288e2db101ba3$var$nh(c, b, 1))), c.lanes |= 1), a;
    a.flags |= 65536;
    a.lanes = e;
    return a;
}
var $b36288e2db101ba3$var$Wi = $b36288e2db101ba3$var$ua.ReactCurrentOwner, $b36288e2db101ba3$var$dh = !1;
function $b36288e2db101ba3$var$Xi(a, b, c, d) {
    b.child = null === a ? $b36288e2db101ba3$var$Vg(b, null, c, d) : $b36288e2db101ba3$var$Ug(b, a.child, c, d);
}
function $b36288e2db101ba3$var$Yi(a, b, c, d, e) {
    c = c.render;
    var f = b.ref;
    $b36288e2db101ba3$var$ch(b, e);
    d = $b36288e2db101ba3$var$Nh(a, b, c, d, f, e);
    c = $b36288e2db101ba3$var$Sh();
    if (null !== a && !$b36288e2db101ba3$var$dh) return b.updateQueue = a.updateQueue, b.flags &= -2053, a.lanes &= ~e, $b36288e2db101ba3$var$Zi(a, b, e);
    $b36288e2db101ba3$var$I && c && $b36288e2db101ba3$var$vg(b);
    b.flags |= 1;
    $b36288e2db101ba3$var$Xi(a, b, d, e);
    return b.child;
}
function $b36288e2db101ba3$var$$i(a, b, c, d, e) {
    if (null === a) {
        var f = c.type;
        if ("function" === typeof f && !$b36288e2db101ba3$var$aj(f) && void 0 === f.defaultProps && null === c.compare && void 0 === c.defaultProps) return b.tag = 15, b.type = f, $b36288e2db101ba3$var$bj(a, b, f, d, e);
        a = $b36288e2db101ba3$var$Rg(c.type, null, d, b, b.mode, e);
        a.ref = b.ref;
        a.return = b;
        return b.child = a;
    }
    f = a.child;
    if (0 === (a.lanes & e)) {
        var g = f.memoizedProps;
        c = c.compare;
        c = null !== c ? c : $b36288e2db101ba3$var$Ie;
        if (c(g, d) && a.ref === b.ref) return $b36288e2db101ba3$var$Zi(a, b, e);
    }
    b.flags |= 1;
    a = $b36288e2db101ba3$var$Pg(f, d);
    a.ref = b.ref;
    a.return = b;
    return b.child = a;
}
function $b36288e2db101ba3$var$bj(a, b, c, d, e) {
    if (null !== a) {
        var f = a.memoizedProps;
        if ($b36288e2db101ba3$var$Ie(f, d) && a.ref === b.ref) {
            if ($b36288e2db101ba3$var$dh = !1, b.pendingProps = d = f, 0 !== (a.lanes & e)) 0 !== (a.flags & 131072) && ($b36288e2db101ba3$var$dh = !0);
            else return b.lanes = a.lanes, $b36288e2db101ba3$var$Zi(a, b, e);
        }
    }
    return $b36288e2db101ba3$var$cj(a, b, c, d, e);
}
function $b36288e2db101ba3$var$dj(a, b, c) {
    var d = b.pendingProps, e = d.children, f = null !== a ? a.memoizedState : null;
    if ("hidden" === d.mode) {
        if (0 === (b.mode & 1)) b.memoizedState = {
            baseLanes: 0,
            cachePool: null,
            transitions: null
        }, $b36288e2db101ba3$var$G($b36288e2db101ba3$var$ej, $b36288e2db101ba3$var$fj), $b36288e2db101ba3$var$fj |= c;
        else {
            if (0 === (c & 1073741824)) return a = null !== f ? f.baseLanes | c : c, b.lanes = b.childLanes = 1073741824, b.memoizedState = {
                baseLanes: a,
                cachePool: null,
                transitions: null
            }, b.updateQueue = null, $b36288e2db101ba3$var$G($b36288e2db101ba3$var$ej, $b36288e2db101ba3$var$fj), $b36288e2db101ba3$var$fj |= a, null;
            b.memoizedState = {
                baseLanes: 0,
                cachePool: null,
                transitions: null
            };
            d = null !== f ? f.baseLanes : c;
            $b36288e2db101ba3$var$G($b36288e2db101ba3$var$ej, $b36288e2db101ba3$var$fj);
            $b36288e2db101ba3$var$fj |= d;
        }
    } else null !== f ? (d = f.baseLanes | c, b.memoizedState = null) : d = c, $b36288e2db101ba3$var$G($b36288e2db101ba3$var$ej, $b36288e2db101ba3$var$fj), $b36288e2db101ba3$var$fj |= d;
    $b36288e2db101ba3$var$Xi(a, b, e, c);
    return b.child;
}
function $b36288e2db101ba3$var$gj(a, b) {
    var c = b.ref;
    if (null === a && null !== c || null !== a && a.ref !== c) b.flags |= 512, b.flags |= 2097152;
}
function $b36288e2db101ba3$var$cj(a, b, c, d, e) {
    var f = $b36288e2db101ba3$var$Zf(c) ? $b36288e2db101ba3$var$Xf : $b36288e2db101ba3$var$H.current;
    f = $b36288e2db101ba3$var$Yf(b, f);
    $b36288e2db101ba3$var$ch(b, e);
    c = $b36288e2db101ba3$var$Nh(a, b, c, d, f, e);
    d = $b36288e2db101ba3$var$Sh();
    if (null !== a && !$b36288e2db101ba3$var$dh) return b.updateQueue = a.updateQueue, b.flags &= -2053, a.lanes &= ~e, $b36288e2db101ba3$var$Zi(a, b, e);
    $b36288e2db101ba3$var$I && d && $b36288e2db101ba3$var$vg(b);
    b.flags |= 1;
    $b36288e2db101ba3$var$Xi(a, b, c, e);
    return b.child;
}
function $b36288e2db101ba3$var$hj(a, b, c, d, e) {
    if ($b36288e2db101ba3$var$Zf(c)) {
        var f = !0;
        $b36288e2db101ba3$var$cg(b);
    } else f = !1;
    $b36288e2db101ba3$var$ch(b, e);
    if (null === b.stateNode) $b36288e2db101ba3$var$ij(a, b), $b36288e2db101ba3$var$Gi(b, c, d), $b36288e2db101ba3$var$Ii(b, c, d, e), d = !0;
    else if (null === a) {
        var g = b.stateNode, h = b.memoizedProps;
        g.props = h;
        var k = g.context, l = c.contextType;
        "object" === typeof l && null !== l ? l = $b36288e2db101ba3$var$eh(l) : (l = $b36288e2db101ba3$var$Zf(c) ? $b36288e2db101ba3$var$Xf : $b36288e2db101ba3$var$H.current, l = $b36288e2db101ba3$var$Yf(b, l));
        var m = c.getDerivedStateFromProps, q = "function" === typeof m || "function" === typeof g.getSnapshotBeforeUpdate;
        q || "function" !== typeof g.UNSAFE_componentWillReceiveProps && "function" !== typeof g.componentWillReceiveProps || (h !== d || k !== l) && $b36288e2db101ba3$var$Hi(b, g, d, l);
        $b36288e2db101ba3$var$jh = !1;
        var r = b.memoizedState;
        g.state = r;
        $b36288e2db101ba3$var$qh(b, d, g, e);
        k = b.memoizedState;
        h !== d || r !== k || $b36288e2db101ba3$var$Wf.current || $b36288e2db101ba3$var$jh ? ("function" === typeof m && ($b36288e2db101ba3$var$Di(b, c, m, d), k = b.memoizedState), (h = $b36288e2db101ba3$var$jh || $b36288e2db101ba3$var$Fi(b, c, h, d, r, k, l)) ? (q || "function" !== typeof g.UNSAFE_componentWillMount && "function" !== typeof g.componentWillMount || ("function" === typeof g.componentWillMount && g.componentWillMount(), "function" === typeof g.UNSAFE_componentWillMount && g.UNSAFE_componentWillMount()), "function" === typeof g.componentDidMount && (b.flags |= 4194308)) : ("function" === typeof g.componentDidMount && (b.flags |= 4194308), b.memoizedProps = d, b.memoizedState = k), g.props = d, g.state = k, g.context = l, d = h) : ("function" === typeof g.componentDidMount && (b.flags |= 4194308), d = !1);
    } else {
        g = b.stateNode;
        $b36288e2db101ba3$var$lh(a, b);
        h = b.memoizedProps;
        l = b.type === b.elementType ? h : $b36288e2db101ba3$var$Ci(b.type, h);
        g.props = l;
        q = b.pendingProps;
        r = g.context;
        k = c.contextType;
        "object" === typeof k && null !== k ? k = $b36288e2db101ba3$var$eh(k) : (k = $b36288e2db101ba3$var$Zf(c) ? $b36288e2db101ba3$var$Xf : $b36288e2db101ba3$var$H.current, k = $b36288e2db101ba3$var$Yf(b, k));
        var y = c.getDerivedStateFromProps;
        (m = "function" === typeof y || "function" === typeof g.getSnapshotBeforeUpdate) || "function" !== typeof g.UNSAFE_componentWillReceiveProps && "function" !== typeof g.componentWillReceiveProps || (h !== q || r !== k) && $b36288e2db101ba3$var$Hi(b, g, d, k);
        $b36288e2db101ba3$var$jh = !1;
        r = b.memoizedState;
        g.state = r;
        $b36288e2db101ba3$var$qh(b, d, g, e);
        var n = b.memoizedState;
        h !== q || r !== n || $b36288e2db101ba3$var$Wf.current || $b36288e2db101ba3$var$jh ? ("function" === typeof y && ($b36288e2db101ba3$var$Di(b, c, y, d), n = b.memoizedState), (l = $b36288e2db101ba3$var$jh || $b36288e2db101ba3$var$Fi(b, c, l, d, r, n, k) || !1) ? (m || "function" !== typeof g.UNSAFE_componentWillUpdate && "function" !== typeof g.componentWillUpdate || ("function" === typeof g.componentWillUpdate && g.componentWillUpdate(d, n, k), "function" === typeof g.UNSAFE_componentWillUpdate && g.UNSAFE_componentWillUpdate(d, n, k)), "function" === typeof g.componentDidUpdate && (b.flags |= 4), "function" === typeof g.getSnapshotBeforeUpdate && (b.flags |= 1024)) : ("function" !== typeof g.componentDidUpdate || h === a.memoizedProps && r === a.memoizedState || (b.flags |= 4), "function" !== typeof g.getSnapshotBeforeUpdate || h === a.memoizedProps && r === a.memoizedState || (b.flags |= 1024), b.memoizedProps = d, b.memoizedState = n), g.props = d, g.state = n, g.context = k, d = l) : ("function" !== typeof g.componentDidUpdate || h === a.memoizedProps && r === a.memoizedState || (b.flags |= 4), "function" !== typeof g.getSnapshotBeforeUpdate || h === a.memoizedProps && r === a.memoizedState || (b.flags |= 1024), d = !1);
    }
    return $b36288e2db101ba3$var$jj(a, b, c, d, f, e);
}
function $b36288e2db101ba3$var$jj(a, b, c, d, e, f) {
    $b36288e2db101ba3$var$gj(a, b);
    var g = 0 !== (b.flags & 128);
    if (!d && !g) return e && $b36288e2db101ba3$var$dg(b, c, !1), $b36288e2db101ba3$var$Zi(a, b, f);
    d = b.stateNode;
    $b36288e2db101ba3$var$Wi.current = b;
    var h = g && "function" !== typeof c.getDerivedStateFromError ? null : d.render();
    b.flags |= 1;
    null !== a && g ? (b.child = $b36288e2db101ba3$var$Ug(b, a.child, null, f), b.child = $b36288e2db101ba3$var$Ug(b, null, h, f)) : $b36288e2db101ba3$var$Xi(a, b, h, f);
    b.memoizedState = d.state;
    e && $b36288e2db101ba3$var$dg(b, c, !0);
    return b.child;
}
function $b36288e2db101ba3$var$kj(a) {
    var b = a.stateNode;
    b.pendingContext ? $b36288e2db101ba3$var$ag(a, b.pendingContext, b.pendingContext !== b.context) : b.context && $b36288e2db101ba3$var$ag(a, b.context, !1);
    $b36288e2db101ba3$var$yh(a, b.containerInfo);
}
function $b36288e2db101ba3$var$lj(a, b, c, d, e) {
    $b36288e2db101ba3$var$Ig();
    $b36288e2db101ba3$var$Jg(e);
    b.flags |= 256;
    $b36288e2db101ba3$var$Xi(a, b, c, d);
    return b.child;
}
var $b36288e2db101ba3$var$mj = {
    dehydrated: null,
    treeContext: null,
    retryLane: 0
};
function $b36288e2db101ba3$var$nj(a) {
    return {
        baseLanes: a,
        cachePool: null,
        transitions: null
    };
}
function $b36288e2db101ba3$var$oj(a, b, c) {
    var d = b.pendingProps, e = $b36288e2db101ba3$var$L.current, f = !1, g = 0 !== (b.flags & 128), h;
    (h = g) || (h = null !== a && null === a.memoizedState ? !1 : 0 !== (e & 2));
    if (h) f = !0, b.flags &= -129;
    else if (null === a || null !== a.memoizedState) e |= 1;
    $b36288e2db101ba3$var$G($b36288e2db101ba3$var$L, e & 1);
    if (null === a) {
        $b36288e2db101ba3$var$Eg(b);
        a = b.memoizedState;
        if (null !== a && (a = a.dehydrated, null !== a)) return 0 === (b.mode & 1) ? b.lanes = 1 : "$!" === a.data ? b.lanes = 8 : b.lanes = 1073741824, null;
        g = d.children;
        a = d.fallback;
        return f ? (d = b.mode, f = b.child, g = {
            mode: "hidden",
            children: g
        }, 0 === (d & 1) && null !== f ? (f.childLanes = 0, f.pendingProps = g) : f = $b36288e2db101ba3$var$pj(g, d, 0, null), a = $b36288e2db101ba3$var$Tg(a, d, c, null), f.return = b, a.return = b, f.sibling = a, b.child = f, b.child.memoizedState = $b36288e2db101ba3$var$nj(c), b.memoizedState = $b36288e2db101ba3$var$mj, a) : $b36288e2db101ba3$var$qj(b, g);
    }
    e = a.memoizedState;
    if (null !== e && (h = e.dehydrated, null !== h)) return $b36288e2db101ba3$var$rj(a, b, g, d, h, e, c);
    if (f) {
        f = d.fallback;
        g = b.mode;
        e = a.child;
        h = e.sibling;
        var k = {
            mode: "hidden",
            children: d.children
        };
        0 === (g & 1) && b.child !== e ? (d = b.child, d.childLanes = 0, d.pendingProps = k, b.deletions = null) : (d = $b36288e2db101ba3$var$Pg(e, k), d.subtreeFlags = e.subtreeFlags & 14680064);
        null !== h ? f = $b36288e2db101ba3$var$Pg(h, f) : (f = $b36288e2db101ba3$var$Tg(f, g, c, null), f.flags |= 2);
        f.return = b;
        d.return = b;
        d.sibling = f;
        b.child = d;
        d = f;
        f = b.child;
        g = a.child.memoizedState;
        g = null === g ? $b36288e2db101ba3$var$nj(c) : {
            baseLanes: g.baseLanes | c,
            cachePool: null,
            transitions: g.transitions
        };
        f.memoizedState = g;
        f.childLanes = a.childLanes & ~c;
        b.memoizedState = $b36288e2db101ba3$var$mj;
        return d;
    }
    f = a.child;
    a = f.sibling;
    d = $b36288e2db101ba3$var$Pg(f, {
        mode: "visible",
        children: d.children
    });
    0 === (b.mode & 1) && (d.lanes = c);
    d.return = b;
    d.sibling = null;
    null !== a && (c = b.deletions, null === c ? (b.deletions = [
        a
    ], b.flags |= 16) : c.push(a));
    b.child = d;
    b.memoizedState = null;
    return d;
}
function $b36288e2db101ba3$var$qj(a, b) {
    b = $b36288e2db101ba3$var$pj({
        mode: "visible",
        children: b
    }, a.mode, 0, null);
    b.return = a;
    return a.child = b;
}
function $b36288e2db101ba3$var$sj(a, b, c, d) {
    null !== d && $b36288e2db101ba3$var$Jg(d);
    $b36288e2db101ba3$var$Ug(b, a.child, null, c);
    a = $b36288e2db101ba3$var$qj(b, b.pendingProps.children);
    a.flags |= 2;
    b.memoizedState = null;
    return a;
}
function $b36288e2db101ba3$var$rj(a, b, c, d, e, f, g) {
    if (c) {
        if (b.flags & 256) return b.flags &= -257, d = $b36288e2db101ba3$var$Ki(Error($b36288e2db101ba3$var$p(422))), $b36288e2db101ba3$var$sj(a, b, g, d);
        if (null !== b.memoizedState) return b.child = a.child, b.flags |= 128, null;
        f = d.fallback;
        e = b.mode;
        d = $b36288e2db101ba3$var$pj({
            mode: "visible",
            children: d.children
        }, e, 0, null);
        f = $b36288e2db101ba3$var$Tg(f, e, g, null);
        f.flags |= 2;
        d.return = b;
        f.return = b;
        d.sibling = f;
        b.child = d;
        0 !== (b.mode & 1) && $b36288e2db101ba3$var$Ug(b, a.child, null, g);
        b.child.memoizedState = $b36288e2db101ba3$var$nj(g);
        b.memoizedState = $b36288e2db101ba3$var$mj;
        return f;
    }
    if (0 === (b.mode & 1)) return $b36288e2db101ba3$var$sj(a, b, g, null);
    if ("$!" === e.data) {
        d = e.nextSibling && e.nextSibling.dataset;
        if (d) var h = d.dgst;
        d = h;
        f = Error($b36288e2db101ba3$var$p(419));
        d = $b36288e2db101ba3$var$Ki(f, d, void 0);
        return $b36288e2db101ba3$var$sj(a, b, g, d);
    }
    h = 0 !== (g & a.childLanes);
    if ($b36288e2db101ba3$var$dh || h) {
        d = $b36288e2db101ba3$var$Q;
        if (null !== d) {
            switch(g & -g){
                case 4:
                    e = 2;
                    break;
                case 16:
                    e = 8;
                    break;
                case 64:
                case 128:
                case 256:
                case 512:
                case 1024:
                case 2048:
                case 4096:
                case 8192:
                case 16384:
                case 32768:
                case 65536:
                case 131072:
                case 262144:
                case 524288:
                case 1048576:
                case 2097152:
                case 4194304:
                case 8388608:
                case 16777216:
                case 33554432:
                case 67108864:
                    e = 32;
                    break;
                case 536870912:
                    e = 268435456;
                    break;
                default:
                    e = 0;
            }
            e = 0 !== (e & (d.suspendedLanes | g)) ? 0 : e;
            0 !== e && e !== f.retryLane && (f.retryLane = e, $b36288e2db101ba3$var$ih(a, e), $b36288e2db101ba3$var$gi(d, a, e, -1));
        }
        $b36288e2db101ba3$var$tj();
        d = $b36288e2db101ba3$var$Ki(Error($b36288e2db101ba3$var$p(421)));
        return $b36288e2db101ba3$var$sj(a, b, g, d);
    }
    if ("$?" === e.data) return b.flags |= 128, b.child = a.child, b = $b36288e2db101ba3$var$uj.bind(null, a), e._reactRetry = b, null;
    a = f.treeContext;
    $b36288e2db101ba3$var$yg = $b36288e2db101ba3$var$Lf(e.nextSibling);
    $b36288e2db101ba3$var$xg = b;
    $b36288e2db101ba3$var$I = !0;
    $b36288e2db101ba3$var$zg = null;
    null !== a && ($b36288e2db101ba3$var$og[$b36288e2db101ba3$var$pg++] = $b36288e2db101ba3$var$rg, $b36288e2db101ba3$var$og[$b36288e2db101ba3$var$pg++] = $b36288e2db101ba3$var$sg, $b36288e2db101ba3$var$og[$b36288e2db101ba3$var$pg++] = $b36288e2db101ba3$var$qg, $b36288e2db101ba3$var$rg = a.id, $b36288e2db101ba3$var$sg = a.overflow, $b36288e2db101ba3$var$qg = b);
    b = $b36288e2db101ba3$var$qj(b, d.children);
    b.flags |= 4096;
    return b;
}
function $b36288e2db101ba3$var$vj(a, b, c) {
    a.lanes |= b;
    var d = a.alternate;
    null !== d && (d.lanes |= b);
    $b36288e2db101ba3$var$bh(a.return, b, c);
}
function $b36288e2db101ba3$var$wj(a, b, c, d, e) {
    var f = a.memoizedState;
    null === f ? a.memoizedState = {
        isBackwards: b,
        rendering: null,
        renderingStartTime: 0,
        last: d,
        tail: c,
        tailMode: e
    } : (f.isBackwards = b, f.rendering = null, f.renderingStartTime = 0, f.last = d, f.tail = c, f.tailMode = e);
}
function $b36288e2db101ba3$var$xj(a, b, c) {
    var d = b.pendingProps, e = d.revealOrder, f = d.tail;
    $b36288e2db101ba3$var$Xi(a, b, d.children, c);
    d = $b36288e2db101ba3$var$L.current;
    if (0 !== (d & 2)) d = d & 1 | 2, b.flags |= 128;
    else {
        if (null !== a && 0 !== (a.flags & 128)) a: for(a = b.child; null !== a;){
            if (13 === a.tag) null !== a.memoizedState && $b36288e2db101ba3$var$vj(a, c, b);
            else if (19 === a.tag) $b36288e2db101ba3$var$vj(a, c, b);
            else if (null !== a.child) {
                a.child.return = a;
                a = a.child;
                continue;
            }
            if (a === b) break a;
            for(; null === a.sibling;){
                if (null === a.return || a.return === b) break a;
                a = a.return;
            }
            a.sibling.return = a.return;
            a = a.sibling;
        }
        d &= 1;
    }
    $b36288e2db101ba3$var$G($b36288e2db101ba3$var$L, d);
    if (0 === (b.mode & 1)) b.memoizedState = null;
    else switch(e){
        case "forwards":
            c = b.child;
            for(e = null; null !== c;)a = c.alternate, null !== a && null === $b36288e2db101ba3$var$Ch(a) && (e = c), c = c.sibling;
            c = e;
            null === c ? (e = b.child, b.child = null) : (e = c.sibling, c.sibling = null);
            $b36288e2db101ba3$var$wj(b, !1, e, c, f);
            break;
        case "backwards":
            c = null;
            e = b.child;
            for(b.child = null; null !== e;){
                a = e.alternate;
                if (null !== a && null === $b36288e2db101ba3$var$Ch(a)) {
                    b.child = e;
                    break;
                }
                a = e.sibling;
                e.sibling = c;
                c = e;
                e = a;
            }
            $b36288e2db101ba3$var$wj(b, !0, c, null, f);
            break;
        case "together":
            $b36288e2db101ba3$var$wj(b, !1, null, null, void 0);
            break;
        default:
            b.memoizedState = null;
    }
    return b.child;
}
function $b36288e2db101ba3$var$ij(a, b) {
    0 === (b.mode & 1) && null !== a && (a.alternate = null, b.alternate = null, b.flags |= 2);
}
function $b36288e2db101ba3$var$Zi(a, b, c) {
    null !== a && (b.dependencies = a.dependencies);
    $b36288e2db101ba3$var$rh |= b.lanes;
    if (0 === (c & b.childLanes)) return null;
    if (null !== a && b.child !== a.child) throw Error($b36288e2db101ba3$var$p(153));
    if (null !== b.child) {
        a = b.child;
        c = $b36288e2db101ba3$var$Pg(a, a.pendingProps);
        b.child = c;
        for(c.return = b; null !== a.sibling;)a = a.sibling, c = c.sibling = $b36288e2db101ba3$var$Pg(a, a.pendingProps), c.return = b;
        c.sibling = null;
    }
    return b.child;
}
function $b36288e2db101ba3$var$yj(a, b, c) {
    switch(b.tag){
        case 3:
            $b36288e2db101ba3$var$kj(b);
            $b36288e2db101ba3$var$Ig();
            break;
        case 5:
            $b36288e2db101ba3$var$Ah(b);
            break;
        case 1:
            $b36288e2db101ba3$var$Zf(b.type) && $b36288e2db101ba3$var$cg(b);
            break;
        case 4:
            $b36288e2db101ba3$var$yh(b, b.stateNode.containerInfo);
            break;
        case 10:
            var d = b.type._context, e = b.memoizedProps.value;
            $b36288e2db101ba3$var$G($b36288e2db101ba3$var$Wg, d._currentValue);
            d._currentValue = e;
            break;
        case 13:
            d = b.memoizedState;
            if (null !== d) {
                if (null !== d.dehydrated) return $b36288e2db101ba3$var$G($b36288e2db101ba3$var$L, $b36288e2db101ba3$var$L.current & 1), b.flags |= 128, null;
                if (0 !== (c & b.child.childLanes)) return $b36288e2db101ba3$var$oj(a, b, c);
                $b36288e2db101ba3$var$G($b36288e2db101ba3$var$L, $b36288e2db101ba3$var$L.current & 1);
                a = $b36288e2db101ba3$var$Zi(a, b, c);
                return null !== a ? a.sibling : null;
            }
            $b36288e2db101ba3$var$G($b36288e2db101ba3$var$L, $b36288e2db101ba3$var$L.current & 1);
            break;
        case 19:
            d = 0 !== (c & b.childLanes);
            if (0 !== (a.flags & 128)) {
                if (d) return $b36288e2db101ba3$var$xj(a, b, c);
                b.flags |= 128;
            }
            e = b.memoizedState;
            null !== e && (e.rendering = null, e.tail = null, e.lastEffect = null);
            $b36288e2db101ba3$var$G($b36288e2db101ba3$var$L, $b36288e2db101ba3$var$L.current);
            if (d) break;
            else return null;
        case 22:
        case 23:
            return b.lanes = 0, $b36288e2db101ba3$var$dj(a, b, c);
    }
    return $b36288e2db101ba3$var$Zi(a, b, c);
}
var $b36288e2db101ba3$var$zj, $b36288e2db101ba3$var$Aj, $b36288e2db101ba3$var$Bj, $b36288e2db101ba3$var$Cj;
$b36288e2db101ba3$var$zj = function(a, b) {
    for(var c = b.child; null !== c;){
        if (5 === c.tag || 6 === c.tag) a.appendChild(c.stateNode);
        else if (4 !== c.tag && null !== c.child) {
            c.child.return = c;
            c = c.child;
            continue;
        }
        if (c === b) break;
        for(; null === c.sibling;){
            if (null === c.return || c.return === b) return;
            c = c.return;
        }
        c.sibling.return = c.return;
        c = c.sibling;
    }
};
$b36288e2db101ba3$var$Aj = function() {};
$b36288e2db101ba3$var$Bj = function(a, b, c, d) {
    var e = a.memoizedProps;
    if (e !== d) {
        a = b.stateNode;
        $b36288e2db101ba3$var$xh($b36288e2db101ba3$var$uh.current);
        var f = null;
        switch(c){
            case "input":
                e = $b36288e2db101ba3$var$Ya(a, e);
                d = $b36288e2db101ba3$var$Ya(a, d);
                f = [];
                break;
            case "select":
                e = $b36288e2db101ba3$var$A({}, e, {
                    value: void 0
                });
                d = $b36288e2db101ba3$var$A({}, d, {
                    value: void 0
                });
                f = [];
                break;
            case "textarea":
                e = $b36288e2db101ba3$var$gb(a, e);
                d = $b36288e2db101ba3$var$gb(a, d);
                f = [];
                break;
            default:
                "function" !== typeof e.onClick && "function" === typeof d.onClick && (a.onclick = $b36288e2db101ba3$var$Bf);
        }
        $b36288e2db101ba3$var$ub(c, d);
        var g;
        c = null;
        for(l in e)if (!d.hasOwnProperty(l) && e.hasOwnProperty(l) && null != e[l]) {
            if ("style" === l) {
                var h = e[l];
                for(g in h)h.hasOwnProperty(g) && (c || (c = {}), c[g] = "");
            } else "dangerouslySetInnerHTML" !== l && "children" !== l && "suppressContentEditableWarning" !== l && "suppressHydrationWarning" !== l && "autoFocus" !== l && ($b36288e2db101ba3$var$ea.hasOwnProperty(l) ? f || (f = []) : (f = f || []).push(l, null));
        }
        for(l in d){
            var k = d[l];
            h = null != e ? e[l] : void 0;
            if (d.hasOwnProperty(l) && k !== h && (null != k || null != h)) {
                if ("style" === l) {
                    if (h) {
                        for(g in h)!h.hasOwnProperty(g) || k && k.hasOwnProperty(g) || (c || (c = {}), c[g] = "");
                        for(g in k)k.hasOwnProperty(g) && h[g] !== k[g] && (c || (c = {}), c[g] = k[g]);
                    } else c || (f || (f = []), f.push(l, c)), c = k;
                } else "dangerouslySetInnerHTML" === l ? (k = k ? k.__html : void 0, h = h ? h.__html : void 0, null != k && h !== k && (f = f || []).push(l, k)) : "children" === l ? "string" !== typeof k && "number" !== typeof k || (f = f || []).push(l, "" + k) : "suppressContentEditableWarning" !== l && "suppressHydrationWarning" !== l && ($b36288e2db101ba3$var$ea.hasOwnProperty(l) ? (null != k && "onScroll" === l && $b36288e2db101ba3$var$D("scroll", a), f || h === k || (f = [])) : (f = f || []).push(l, k));
            }
        }
        c && (f = f || []).push("style", c);
        var l = f;
        if (b.updateQueue = l) b.flags |= 4;
    }
};
$b36288e2db101ba3$var$Cj = function(a, b, c, d) {
    c !== d && (b.flags |= 4);
};
function $b36288e2db101ba3$var$Dj(a, b) {
    if (!$b36288e2db101ba3$var$I) switch(a.tailMode){
        case "hidden":
            b = a.tail;
            for(var c = null; null !== b;)null !== b.alternate && (c = b), b = b.sibling;
            null === c ? a.tail = null : c.sibling = null;
            break;
        case "collapsed":
            c = a.tail;
            for(var d = null; null !== c;)null !== c.alternate && (d = c), c = c.sibling;
            null === d ? b || null === a.tail ? a.tail = null : a.tail.sibling = null : d.sibling = null;
    }
}
function $b36288e2db101ba3$var$S(a) {
    var b = null !== a.alternate && a.alternate.child === a.child, c = 0, d = 0;
    if (b) for(var e = a.child; null !== e;)c |= e.lanes | e.childLanes, d |= e.subtreeFlags & 14680064, d |= e.flags & 14680064, e.return = a, e = e.sibling;
    else for(e = a.child; null !== e;)c |= e.lanes | e.childLanes, d |= e.subtreeFlags, d |= e.flags, e.return = a, e = e.sibling;
    a.subtreeFlags |= d;
    a.childLanes = c;
    return b;
}
function $b36288e2db101ba3$var$Ej(a, b, c) {
    var d = b.pendingProps;
    $b36288e2db101ba3$var$wg(b);
    switch(b.tag){
        case 2:
        case 16:
        case 15:
        case 0:
        case 11:
        case 7:
        case 8:
        case 12:
        case 9:
        case 14:
            return $b36288e2db101ba3$var$S(b), null;
        case 1:
            return $b36288e2db101ba3$var$Zf(b.type) && $b36288e2db101ba3$var$$f(), $b36288e2db101ba3$var$S(b), null;
        case 3:
            d = b.stateNode;
            $b36288e2db101ba3$var$zh();
            $b36288e2db101ba3$var$E($b36288e2db101ba3$var$Wf);
            $b36288e2db101ba3$var$E($b36288e2db101ba3$var$H);
            $b36288e2db101ba3$var$Eh();
            d.pendingContext && (d.context = d.pendingContext, d.pendingContext = null);
            if (null === a || null === a.child) $b36288e2db101ba3$var$Gg(b) ? b.flags |= 4 : null === a || a.memoizedState.isDehydrated && 0 === (b.flags & 256) || (b.flags |= 1024, null !== $b36288e2db101ba3$var$zg && ($b36288e2db101ba3$var$Fj($b36288e2db101ba3$var$zg), $b36288e2db101ba3$var$zg = null));
            $b36288e2db101ba3$var$Aj(a, b);
            $b36288e2db101ba3$var$S(b);
            return null;
        case 5:
            $b36288e2db101ba3$var$Bh(b);
            var e = $b36288e2db101ba3$var$xh($b36288e2db101ba3$var$wh.current);
            c = b.type;
            if (null !== a && null != b.stateNode) $b36288e2db101ba3$var$Bj(a, b, c, d, e), a.ref !== b.ref && (b.flags |= 512, b.flags |= 2097152);
            else {
                if (!d) {
                    if (null === b.stateNode) throw Error($b36288e2db101ba3$var$p(166));
                    $b36288e2db101ba3$var$S(b);
                    return null;
                }
                a = $b36288e2db101ba3$var$xh($b36288e2db101ba3$var$uh.current);
                if ($b36288e2db101ba3$var$Gg(b)) {
                    d = b.stateNode;
                    c = b.type;
                    var f = b.memoizedProps;
                    d[$b36288e2db101ba3$var$Of] = b;
                    d[$b36288e2db101ba3$var$Pf] = f;
                    a = 0 !== (b.mode & 1);
                    switch(c){
                        case "dialog":
                            $b36288e2db101ba3$var$D("cancel", d);
                            $b36288e2db101ba3$var$D("close", d);
                            break;
                        case "iframe":
                        case "object":
                        case "embed":
                            $b36288e2db101ba3$var$D("load", d);
                            break;
                        case "video":
                        case "audio":
                            for(e = 0; e < $b36288e2db101ba3$var$lf.length; e++)$b36288e2db101ba3$var$D($b36288e2db101ba3$var$lf[e], d);
                            break;
                        case "source":
                            $b36288e2db101ba3$var$D("error", d);
                            break;
                        case "img":
                        case "image":
                        case "link":
                            $b36288e2db101ba3$var$D("error", d);
                            $b36288e2db101ba3$var$D("load", d);
                            break;
                        case "details":
                            $b36288e2db101ba3$var$D("toggle", d);
                            break;
                        case "input":
                            $b36288e2db101ba3$var$Za(d, f);
                            $b36288e2db101ba3$var$D("invalid", d);
                            break;
                        case "select":
                            d._wrapperState = {
                                wasMultiple: !!f.multiple
                            };
                            $b36288e2db101ba3$var$D("invalid", d);
                            break;
                        case "textarea":
                            $b36288e2db101ba3$var$hb(d, f), $b36288e2db101ba3$var$D("invalid", d);
                    }
                    $b36288e2db101ba3$var$ub(c, f);
                    e = null;
                    for(var g in f)if (f.hasOwnProperty(g)) {
                        var h = f[g];
                        "children" === g ? "string" === typeof h ? d.textContent !== h && (!0 !== f.suppressHydrationWarning && $b36288e2db101ba3$var$Af(d.textContent, h, a), e = [
                            "children",
                            h
                        ]) : "number" === typeof h && d.textContent !== "" + h && (!0 !== f.suppressHydrationWarning && $b36288e2db101ba3$var$Af(d.textContent, h, a), e = [
                            "children",
                            "" + h
                        ]) : $b36288e2db101ba3$var$ea.hasOwnProperty(g) && null != h && "onScroll" === g && $b36288e2db101ba3$var$D("scroll", d);
                    }
                    switch(c){
                        case "input":
                            $b36288e2db101ba3$var$Va(d);
                            $b36288e2db101ba3$var$db(d, f, !0);
                            break;
                        case "textarea":
                            $b36288e2db101ba3$var$Va(d);
                            $b36288e2db101ba3$var$jb(d);
                            break;
                        case "select":
                        case "option":
                            break;
                        default:
                            "function" === typeof f.onClick && (d.onclick = $b36288e2db101ba3$var$Bf);
                    }
                    d = e;
                    b.updateQueue = d;
                    null !== d && (b.flags |= 4);
                } else {
                    g = 9 === e.nodeType ? e : e.ownerDocument;
                    "http://www.w3.org/1999/xhtml" === a && (a = $b36288e2db101ba3$var$kb(c));
                    "http://www.w3.org/1999/xhtml" === a ? "script" === c ? (a = g.createElement("div"), a.innerHTML = "<script></script>", a = a.removeChild(a.firstChild)) : "string" === typeof d.is ? a = g.createElement(c, {
                        is: d.is
                    }) : (a = g.createElement(c), "select" === c && (g = a, d.multiple ? g.multiple = !0 : d.size && (g.size = d.size))) : a = g.createElementNS(a, c);
                    a[$b36288e2db101ba3$var$Of] = b;
                    a[$b36288e2db101ba3$var$Pf] = d;
                    $b36288e2db101ba3$var$zj(a, b, !1, !1);
                    b.stateNode = a;
                    a: {
                        g = $b36288e2db101ba3$var$vb(c, d);
                        switch(c){
                            case "dialog":
                                $b36288e2db101ba3$var$D("cancel", a);
                                $b36288e2db101ba3$var$D("close", a);
                                e = d;
                                break;
                            case "iframe":
                            case "object":
                            case "embed":
                                $b36288e2db101ba3$var$D("load", a);
                                e = d;
                                break;
                            case "video":
                            case "audio":
                                for(e = 0; e < $b36288e2db101ba3$var$lf.length; e++)$b36288e2db101ba3$var$D($b36288e2db101ba3$var$lf[e], a);
                                e = d;
                                break;
                            case "source":
                                $b36288e2db101ba3$var$D("error", a);
                                e = d;
                                break;
                            case "img":
                            case "image":
                            case "link":
                                $b36288e2db101ba3$var$D("error", a);
                                $b36288e2db101ba3$var$D("load", a);
                                e = d;
                                break;
                            case "details":
                                $b36288e2db101ba3$var$D("toggle", a);
                                e = d;
                                break;
                            case "input":
                                $b36288e2db101ba3$var$Za(a, d);
                                e = $b36288e2db101ba3$var$Ya(a, d);
                                $b36288e2db101ba3$var$D("invalid", a);
                                break;
                            case "option":
                                e = d;
                                break;
                            case "select":
                                a._wrapperState = {
                                    wasMultiple: !!d.multiple
                                };
                                e = $b36288e2db101ba3$var$A({}, d, {
                                    value: void 0
                                });
                                $b36288e2db101ba3$var$D("invalid", a);
                                break;
                            case "textarea":
                                $b36288e2db101ba3$var$hb(a, d);
                                e = $b36288e2db101ba3$var$gb(a, d);
                                $b36288e2db101ba3$var$D("invalid", a);
                                break;
                            default:
                                e = d;
                        }
                        $b36288e2db101ba3$var$ub(c, e);
                        h = e;
                        for(f in h)if (h.hasOwnProperty(f)) {
                            var k = h[f];
                            "style" === f ? $b36288e2db101ba3$var$sb(a, k) : "dangerouslySetInnerHTML" === f ? (k = k ? k.__html : void 0, null != k && $b36288e2db101ba3$var$nb(a, k)) : "children" === f ? "string" === typeof k ? ("textarea" !== c || "" !== k) && $b36288e2db101ba3$var$ob(a, k) : "number" === typeof k && $b36288e2db101ba3$var$ob(a, "" + k) : "suppressContentEditableWarning" !== f && "suppressHydrationWarning" !== f && "autoFocus" !== f && ($b36288e2db101ba3$var$ea.hasOwnProperty(f) ? null != k && "onScroll" === f && $b36288e2db101ba3$var$D("scroll", a) : null != k && $b36288e2db101ba3$var$ta(a, f, k, g));
                        }
                        switch(c){
                            case "input":
                                $b36288e2db101ba3$var$Va(a);
                                $b36288e2db101ba3$var$db(a, d, !1);
                                break;
                            case "textarea":
                                $b36288e2db101ba3$var$Va(a);
                                $b36288e2db101ba3$var$jb(a);
                                break;
                            case "option":
                                null != d.value && a.setAttribute("value", "" + $b36288e2db101ba3$var$Sa(d.value));
                                break;
                            case "select":
                                a.multiple = !!d.multiple;
                                f = d.value;
                                null != f ? $b36288e2db101ba3$var$fb(a, !!d.multiple, f, !1) : null != d.defaultValue && $b36288e2db101ba3$var$fb(a, !!d.multiple, d.defaultValue, !0);
                                break;
                            default:
                                "function" === typeof e.onClick && (a.onclick = $b36288e2db101ba3$var$Bf);
                        }
                        switch(c){
                            case "button":
                            case "input":
                            case "select":
                            case "textarea":
                                d = !!d.autoFocus;
                                break a;
                            case "img":
                                d = !0;
                                break a;
                            default:
                                d = !1;
                        }
                    }
                    d && (b.flags |= 4);
                }
                null !== b.ref && (b.flags |= 512, b.flags |= 2097152);
            }
            $b36288e2db101ba3$var$S(b);
            return null;
        case 6:
            if (a && null != b.stateNode) $b36288e2db101ba3$var$Cj(a, b, a.memoizedProps, d);
            else {
                if ("string" !== typeof d && null === b.stateNode) throw Error($b36288e2db101ba3$var$p(166));
                c = $b36288e2db101ba3$var$xh($b36288e2db101ba3$var$wh.current);
                $b36288e2db101ba3$var$xh($b36288e2db101ba3$var$uh.current);
                if ($b36288e2db101ba3$var$Gg(b)) {
                    d = b.stateNode;
                    c = b.memoizedProps;
                    d[$b36288e2db101ba3$var$Of] = b;
                    if (f = d.nodeValue !== c) {
                        if (a = $b36288e2db101ba3$var$xg, null !== a) switch(a.tag){
                            case 3:
                                $b36288e2db101ba3$var$Af(d.nodeValue, c, 0 !== (a.mode & 1));
                                break;
                            case 5:
                                !0 !== a.memoizedProps.suppressHydrationWarning && $b36288e2db101ba3$var$Af(d.nodeValue, c, 0 !== (a.mode & 1));
                        }
                    }
                    f && (b.flags |= 4);
                } else d = (9 === c.nodeType ? c : c.ownerDocument).createTextNode(d), d[$b36288e2db101ba3$var$Of] = b, b.stateNode = d;
            }
            $b36288e2db101ba3$var$S(b);
            return null;
        case 13:
            $b36288e2db101ba3$var$E($b36288e2db101ba3$var$L);
            d = b.memoizedState;
            if (null === a || null !== a.memoizedState && null !== a.memoizedState.dehydrated) {
                if ($b36288e2db101ba3$var$I && null !== $b36288e2db101ba3$var$yg && 0 !== (b.mode & 1) && 0 === (b.flags & 128)) $b36288e2db101ba3$var$Hg(), $b36288e2db101ba3$var$Ig(), b.flags |= 98560, f = !1;
                else if (f = $b36288e2db101ba3$var$Gg(b), null !== d && null !== d.dehydrated) {
                    if (null === a) {
                        if (!f) throw Error($b36288e2db101ba3$var$p(318));
                        f = b.memoizedState;
                        f = null !== f ? f.dehydrated : null;
                        if (!f) throw Error($b36288e2db101ba3$var$p(317));
                        f[$b36288e2db101ba3$var$Of] = b;
                    } else $b36288e2db101ba3$var$Ig(), 0 === (b.flags & 128) && (b.memoizedState = null), b.flags |= 4;
                    $b36288e2db101ba3$var$S(b);
                    f = !1;
                } else null !== $b36288e2db101ba3$var$zg && ($b36288e2db101ba3$var$Fj($b36288e2db101ba3$var$zg), $b36288e2db101ba3$var$zg = null), f = !0;
                if (!f) return b.flags & 65536 ? b : null;
            }
            if (0 !== (b.flags & 128)) return b.lanes = c, b;
            d = null !== d;
            d !== (null !== a && null !== a.memoizedState) && d && (b.child.flags |= 8192, 0 !== (b.mode & 1) && (null === a || 0 !== ($b36288e2db101ba3$var$L.current & 1) ? 0 === $b36288e2db101ba3$var$T && ($b36288e2db101ba3$var$T = 3) : $b36288e2db101ba3$var$tj()));
            null !== b.updateQueue && (b.flags |= 4);
            $b36288e2db101ba3$var$S(b);
            return null;
        case 4:
            return $b36288e2db101ba3$var$zh(), $b36288e2db101ba3$var$Aj(a, b), null === a && $b36288e2db101ba3$var$sf(b.stateNode.containerInfo), $b36288e2db101ba3$var$S(b), null;
        case 10:
            return $b36288e2db101ba3$var$ah(b.type._context), $b36288e2db101ba3$var$S(b), null;
        case 17:
            return $b36288e2db101ba3$var$Zf(b.type) && $b36288e2db101ba3$var$$f(), $b36288e2db101ba3$var$S(b), null;
        case 19:
            $b36288e2db101ba3$var$E($b36288e2db101ba3$var$L);
            f = b.memoizedState;
            if (null === f) return $b36288e2db101ba3$var$S(b), null;
            d = 0 !== (b.flags & 128);
            g = f.rendering;
            if (null === g) {
                if (d) $b36288e2db101ba3$var$Dj(f, !1);
                else {
                    if (0 !== $b36288e2db101ba3$var$T || null !== a && 0 !== (a.flags & 128)) for(a = b.child; null !== a;){
                        g = $b36288e2db101ba3$var$Ch(a);
                        if (null !== g) {
                            b.flags |= 128;
                            $b36288e2db101ba3$var$Dj(f, !1);
                            d = g.updateQueue;
                            null !== d && (b.updateQueue = d, b.flags |= 4);
                            b.subtreeFlags = 0;
                            d = c;
                            for(c = b.child; null !== c;)f = c, a = d, f.flags &= 14680066, g = f.alternate, null === g ? (f.childLanes = 0, f.lanes = a, f.child = null, f.subtreeFlags = 0, f.memoizedProps = null, f.memoizedState = null, f.updateQueue = null, f.dependencies = null, f.stateNode = null) : (f.childLanes = g.childLanes, f.lanes = g.lanes, f.child = g.child, f.subtreeFlags = 0, f.deletions = null, f.memoizedProps = g.memoizedProps, f.memoizedState = g.memoizedState, f.updateQueue = g.updateQueue, f.type = g.type, a = g.dependencies, f.dependencies = null === a ? null : {
                                lanes: a.lanes,
                                firstContext: a.firstContext
                            }), c = c.sibling;
                            $b36288e2db101ba3$var$G($b36288e2db101ba3$var$L, $b36288e2db101ba3$var$L.current & 1 | 2);
                            return b.child;
                        }
                        a = a.sibling;
                    }
                    null !== f.tail && $b36288e2db101ba3$var$B() > $b36288e2db101ba3$var$Gj && (b.flags |= 128, d = !0, $b36288e2db101ba3$var$Dj(f, !1), b.lanes = 4194304);
                }
            } else {
                if (!d) {
                    if (a = $b36288e2db101ba3$var$Ch(g), null !== a) {
                        if (b.flags |= 128, d = !0, c = a.updateQueue, null !== c && (b.updateQueue = c, b.flags |= 4), $b36288e2db101ba3$var$Dj(f, !0), null === f.tail && "hidden" === f.tailMode && !g.alternate && !$b36288e2db101ba3$var$I) return $b36288e2db101ba3$var$S(b), null;
                    } else 2 * $b36288e2db101ba3$var$B() - f.renderingStartTime > $b36288e2db101ba3$var$Gj && 1073741824 !== c && (b.flags |= 128, d = !0, $b36288e2db101ba3$var$Dj(f, !1), b.lanes = 4194304);
                }
                f.isBackwards ? (g.sibling = b.child, b.child = g) : (c = f.last, null !== c ? c.sibling = g : b.child = g, f.last = g);
            }
            if (null !== f.tail) return b = f.tail, f.rendering = b, f.tail = b.sibling, f.renderingStartTime = $b36288e2db101ba3$var$B(), b.sibling = null, c = $b36288e2db101ba3$var$L.current, $b36288e2db101ba3$var$G($b36288e2db101ba3$var$L, d ? c & 1 | 2 : c & 1), b;
            $b36288e2db101ba3$var$S(b);
            return null;
        case 22:
        case 23:
            return $b36288e2db101ba3$var$Hj(), d = null !== b.memoizedState, null !== a && null !== a.memoizedState !== d && (b.flags |= 8192), d && 0 !== (b.mode & 1) ? 0 !== ($b36288e2db101ba3$var$fj & 1073741824) && ($b36288e2db101ba3$var$S(b), b.subtreeFlags & 6 && (b.flags |= 8192)) : $b36288e2db101ba3$var$S(b), null;
        case 24:
            return null;
        case 25:
            return null;
    }
    throw Error($b36288e2db101ba3$var$p(156, b.tag));
}
function $b36288e2db101ba3$var$Ij(a, b) {
    $b36288e2db101ba3$var$wg(b);
    switch(b.tag){
        case 1:
            return $b36288e2db101ba3$var$Zf(b.type) && $b36288e2db101ba3$var$$f(), a = b.flags, a & 65536 ? (b.flags = a & -65537 | 128, b) : null;
        case 3:
            return $b36288e2db101ba3$var$zh(), $b36288e2db101ba3$var$E($b36288e2db101ba3$var$Wf), $b36288e2db101ba3$var$E($b36288e2db101ba3$var$H), $b36288e2db101ba3$var$Eh(), a = b.flags, 0 !== (a & 65536) && 0 === (a & 128) ? (b.flags = a & -65537 | 128, b) : null;
        case 5:
            return $b36288e2db101ba3$var$Bh(b), null;
        case 13:
            $b36288e2db101ba3$var$E($b36288e2db101ba3$var$L);
            a = b.memoizedState;
            if (null !== a && null !== a.dehydrated) {
                if (null === b.alternate) throw Error($b36288e2db101ba3$var$p(340));
                $b36288e2db101ba3$var$Ig();
            }
            a = b.flags;
            return a & 65536 ? (b.flags = a & -65537 | 128, b) : null;
        case 19:
            return $b36288e2db101ba3$var$E($b36288e2db101ba3$var$L), null;
        case 4:
            return $b36288e2db101ba3$var$zh(), null;
        case 10:
            return $b36288e2db101ba3$var$ah(b.type._context), null;
        case 22:
        case 23:
            return $b36288e2db101ba3$var$Hj(), null;
        case 24:
            return null;
        default:
            return null;
    }
}
var $b36288e2db101ba3$var$Jj = !1, $b36288e2db101ba3$var$U = !1, $b36288e2db101ba3$var$Kj = "function" === typeof WeakSet ? WeakSet : Set, $b36288e2db101ba3$var$V = null;
function $b36288e2db101ba3$var$Lj(a, b) {
    var c = a.ref;
    if (null !== c) {
        if ("function" === typeof c) try {
            c(null);
        } catch (d) {
            $b36288e2db101ba3$var$W(a, b, d);
        }
        else c.current = null;
    }
}
function $b36288e2db101ba3$var$Mj(a, b, c) {
    try {
        c();
    } catch (d) {
        $b36288e2db101ba3$var$W(a, b, d);
    }
}
var $b36288e2db101ba3$var$Nj = !1;
function $b36288e2db101ba3$var$Oj(a, b) {
    $b36288e2db101ba3$var$Cf = $b36288e2db101ba3$var$dd;
    a = $b36288e2db101ba3$var$Me();
    if ($b36288e2db101ba3$var$Ne(a)) {
        if ("selectionStart" in a) var c = {
            start: a.selectionStart,
            end: a.selectionEnd
        };
        else a: {
            c = (c = a.ownerDocument) && c.defaultView || window;
            var d = c.getSelection && c.getSelection();
            if (d && 0 !== d.rangeCount) {
                c = d.anchorNode;
                var e = d.anchorOffset, f = d.focusNode;
                d = d.focusOffset;
                try {
                    c.nodeType, f.nodeType;
                } catch (F) {
                    c = null;
                    break a;
                }
                var g = 0, h = -1, k = -1, l = 0, m = 0, q = a, r = null;
                b: for(;;){
                    for(var y;;){
                        q !== c || 0 !== e && 3 !== q.nodeType || (h = g + e);
                        q !== f || 0 !== d && 3 !== q.nodeType || (k = g + d);
                        3 === q.nodeType && (g += q.nodeValue.length);
                        if (null === (y = q.firstChild)) break;
                        r = q;
                        q = y;
                    }
                    for(;;){
                        if (q === a) break b;
                        r === c && ++l === e && (h = g);
                        r === f && ++m === d && (k = g);
                        if (null !== (y = q.nextSibling)) break;
                        q = r;
                        r = q.parentNode;
                    }
                    q = y;
                }
                c = -1 === h || -1 === k ? null : {
                    start: h,
                    end: k
                };
            } else c = null;
        }
        c = c || {
            start: 0,
            end: 0
        };
    } else c = null;
    $b36288e2db101ba3$var$Df = {
        focusedElem: a,
        selectionRange: c
    };
    $b36288e2db101ba3$var$dd = !1;
    for($b36288e2db101ba3$var$V = b; null !== $b36288e2db101ba3$var$V;)if (b = $b36288e2db101ba3$var$V, a = b.child, 0 !== (b.subtreeFlags & 1028) && null !== a) a.return = b, $b36288e2db101ba3$var$V = a;
    else for(; null !== $b36288e2db101ba3$var$V;){
        b = $b36288e2db101ba3$var$V;
        try {
            var n = b.alternate;
            if (0 !== (b.flags & 1024)) switch(b.tag){
                case 0:
                case 11:
                case 15:
                    break;
                case 1:
                    if (null !== n) {
                        var t = n.memoizedProps, J = n.memoizedState, x = b.stateNode, w = x.getSnapshotBeforeUpdate(b.elementType === b.type ? t : $b36288e2db101ba3$var$Ci(b.type, t), J);
                        x.__reactInternalSnapshotBeforeUpdate = w;
                    }
                    break;
                case 3:
                    var u = b.stateNode.containerInfo;
                    1 === u.nodeType ? u.textContent = "" : 9 === u.nodeType && u.documentElement && u.removeChild(u.documentElement);
                    break;
                case 5:
                case 6:
                case 4:
                case 17:
                    break;
                default:
                    throw Error($b36288e2db101ba3$var$p(163));
            }
        } catch (F) {
            $b36288e2db101ba3$var$W(b, b.return, F);
        }
        a = b.sibling;
        if (null !== a) {
            a.return = b.return;
            $b36288e2db101ba3$var$V = a;
            break;
        }
        $b36288e2db101ba3$var$V = b.return;
    }
    n = $b36288e2db101ba3$var$Nj;
    $b36288e2db101ba3$var$Nj = !1;
    return n;
}
function $b36288e2db101ba3$var$Pj(a, b, c) {
    var d = b.updateQueue;
    d = null !== d ? d.lastEffect : null;
    if (null !== d) {
        var e = d = d.next;
        do {
            if ((e.tag & a) === a) {
                var f = e.destroy;
                e.destroy = void 0;
                void 0 !== f && $b36288e2db101ba3$var$Mj(b, c, f);
            }
            e = e.next;
        }while (e !== d);
    }
}
function $b36288e2db101ba3$var$Qj(a, b) {
    b = b.updateQueue;
    b = null !== b ? b.lastEffect : null;
    if (null !== b) {
        var c = b = b.next;
        do {
            if ((c.tag & a) === a) {
                var d = c.create;
                c.destroy = d();
            }
            c = c.next;
        }while (c !== b);
    }
}
function $b36288e2db101ba3$var$Rj(a) {
    var b = a.ref;
    if (null !== b) {
        var c = a.stateNode;
        switch(a.tag){
            case 5:
                a = c;
                break;
            default:
                a = c;
        }
        "function" === typeof b ? b(a) : b.current = a;
    }
}
function $b36288e2db101ba3$var$Sj(a) {
    var b = a.alternate;
    null !== b && (a.alternate = null, $b36288e2db101ba3$var$Sj(b));
    a.child = null;
    a.deletions = null;
    a.sibling = null;
    5 === a.tag && (b = a.stateNode, null !== b && (delete b[$b36288e2db101ba3$var$Of], delete b[$b36288e2db101ba3$var$Pf], delete b[$b36288e2db101ba3$var$of], delete b[$b36288e2db101ba3$var$Qf], delete b[$b36288e2db101ba3$var$Rf]));
    a.stateNode = null;
    a.return = null;
    a.dependencies = null;
    a.memoizedProps = null;
    a.memoizedState = null;
    a.pendingProps = null;
    a.stateNode = null;
    a.updateQueue = null;
}
function $b36288e2db101ba3$var$Tj(a) {
    return 5 === a.tag || 3 === a.tag || 4 === a.tag;
}
function $b36288e2db101ba3$var$Uj(a) {
    a: for(;;){
        for(; null === a.sibling;){
            if (null === a.return || $b36288e2db101ba3$var$Tj(a.return)) return null;
            a = a.return;
        }
        a.sibling.return = a.return;
        for(a = a.sibling; 5 !== a.tag && 6 !== a.tag && 18 !== a.tag;){
            if (a.flags & 2) continue a;
            if (null === a.child || 4 === a.tag) continue a;
            else a.child.return = a, a = a.child;
        }
        if (!(a.flags & 2)) return a.stateNode;
    }
}
function $b36288e2db101ba3$var$Vj(a, b, c) {
    var d = a.tag;
    if (5 === d || 6 === d) a = a.stateNode, b ? 8 === c.nodeType ? c.parentNode.insertBefore(a, b) : c.insertBefore(a, b) : (8 === c.nodeType ? (b = c.parentNode, b.insertBefore(a, c)) : (b = c, b.appendChild(a)), c = c._reactRootContainer, null !== c && void 0 !== c || null !== b.onclick || (b.onclick = $b36288e2db101ba3$var$Bf));
    else if (4 !== d && (a = a.child, null !== a)) for($b36288e2db101ba3$var$Vj(a, b, c), a = a.sibling; null !== a;)$b36288e2db101ba3$var$Vj(a, b, c), a = a.sibling;
}
function $b36288e2db101ba3$var$Wj(a, b, c) {
    var d = a.tag;
    if (5 === d || 6 === d) a = a.stateNode, b ? c.insertBefore(a, b) : c.appendChild(a);
    else if (4 !== d && (a = a.child, null !== a)) for($b36288e2db101ba3$var$Wj(a, b, c), a = a.sibling; null !== a;)$b36288e2db101ba3$var$Wj(a, b, c), a = a.sibling;
}
var $b36288e2db101ba3$var$X = null, $b36288e2db101ba3$var$Xj = !1;
function $b36288e2db101ba3$var$Yj(a, b, c) {
    for(c = c.child; null !== c;)$b36288e2db101ba3$var$Zj(a, b, c), c = c.sibling;
}
function $b36288e2db101ba3$var$Zj(a, b, c) {
    if ($b36288e2db101ba3$var$lc && "function" === typeof $b36288e2db101ba3$var$lc.onCommitFiberUnmount) try {
        $b36288e2db101ba3$var$lc.onCommitFiberUnmount($b36288e2db101ba3$var$kc, c);
    } catch (h) {}
    switch(c.tag){
        case 5:
            $b36288e2db101ba3$var$U || $b36288e2db101ba3$var$Lj(c, b);
        case 6:
            var d = $b36288e2db101ba3$var$X, e = $b36288e2db101ba3$var$Xj;
            $b36288e2db101ba3$var$X = null;
            $b36288e2db101ba3$var$Yj(a, b, c);
            $b36288e2db101ba3$var$X = d;
            $b36288e2db101ba3$var$Xj = e;
            null !== $b36288e2db101ba3$var$X && ($b36288e2db101ba3$var$Xj ? (a = $b36288e2db101ba3$var$X, c = c.stateNode, 8 === a.nodeType ? a.parentNode.removeChild(c) : a.removeChild(c)) : $b36288e2db101ba3$var$X.removeChild(c.stateNode));
            break;
        case 18:
            null !== $b36288e2db101ba3$var$X && ($b36288e2db101ba3$var$Xj ? (a = $b36288e2db101ba3$var$X, c = c.stateNode, 8 === a.nodeType ? $b36288e2db101ba3$var$Kf(a.parentNode, c) : 1 === a.nodeType && $b36288e2db101ba3$var$Kf(a, c), $b36288e2db101ba3$var$bd(a)) : $b36288e2db101ba3$var$Kf($b36288e2db101ba3$var$X, c.stateNode));
            break;
        case 4:
            d = $b36288e2db101ba3$var$X;
            e = $b36288e2db101ba3$var$Xj;
            $b36288e2db101ba3$var$X = c.stateNode.containerInfo;
            $b36288e2db101ba3$var$Xj = !0;
            $b36288e2db101ba3$var$Yj(a, b, c);
            $b36288e2db101ba3$var$X = d;
            $b36288e2db101ba3$var$Xj = e;
            break;
        case 0:
        case 11:
        case 14:
        case 15:
            if (!$b36288e2db101ba3$var$U && (d = c.updateQueue, null !== d && (d = d.lastEffect, null !== d))) {
                e = d = d.next;
                do {
                    var f = e, g = f.destroy;
                    f = f.tag;
                    void 0 !== g && (0 !== (f & 2) ? $b36288e2db101ba3$var$Mj(c, b, g) : 0 !== (f & 4) && $b36288e2db101ba3$var$Mj(c, b, g));
                    e = e.next;
                }while (e !== d);
            }
            $b36288e2db101ba3$var$Yj(a, b, c);
            break;
        case 1:
            if (!$b36288e2db101ba3$var$U && ($b36288e2db101ba3$var$Lj(c, b), d = c.stateNode, "function" === typeof d.componentWillUnmount)) try {
                d.props = c.memoizedProps, d.state = c.memoizedState, d.componentWillUnmount();
            } catch (h) {
                $b36288e2db101ba3$var$W(c, b, h);
            }
            $b36288e2db101ba3$var$Yj(a, b, c);
            break;
        case 21:
            $b36288e2db101ba3$var$Yj(a, b, c);
            break;
        case 22:
            c.mode & 1 ? ($b36288e2db101ba3$var$U = (d = $b36288e2db101ba3$var$U) || null !== c.memoizedState, $b36288e2db101ba3$var$Yj(a, b, c), $b36288e2db101ba3$var$U = d) : $b36288e2db101ba3$var$Yj(a, b, c);
            break;
        default:
            $b36288e2db101ba3$var$Yj(a, b, c);
    }
}
function $b36288e2db101ba3$var$ak(a) {
    var b = a.updateQueue;
    if (null !== b) {
        a.updateQueue = null;
        var c = a.stateNode;
        null === c && (c = a.stateNode = new $b36288e2db101ba3$var$Kj);
        b.forEach(function(b) {
            var d = $b36288e2db101ba3$var$bk.bind(null, a, b);
            c.has(b) || (c.add(b), b.then(d, d));
        });
    }
}
function $b36288e2db101ba3$var$ck(a, b) {
    var c = b.deletions;
    if (null !== c) for(var d = 0; d < c.length; d++){
        var e = c[d];
        try {
            var f = a, g = b, h = g;
            a: for(; null !== h;){
                switch(h.tag){
                    case 5:
                        $b36288e2db101ba3$var$X = h.stateNode;
                        $b36288e2db101ba3$var$Xj = !1;
                        break a;
                    case 3:
                        $b36288e2db101ba3$var$X = h.stateNode.containerInfo;
                        $b36288e2db101ba3$var$Xj = !0;
                        break a;
                    case 4:
                        $b36288e2db101ba3$var$X = h.stateNode.containerInfo;
                        $b36288e2db101ba3$var$Xj = !0;
                        break a;
                }
                h = h.return;
            }
            if (null === $b36288e2db101ba3$var$X) throw Error($b36288e2db101ba3$var$p(160));
            $b36288e2db101ba3$var$Zj(f, g, e);
            $b36288e2db101ba3$var$X = null;
            $b36288e2db101ba3$var$Xj = !1;
            var k = e.alternate;
            null !== k && (k.return = null);
            e.return = null;
        } catch (l) {
            $b36288e2db101ba3$var$W(e, b, l);
        }
    }
    if (b.subtreeFlags & 12854) for(b = b.child; null !== b;)$b36288e2db101ba3$var$dk(b, a), b = b.sibling;
}
function $b36288e2db101ba3$var$dk(a, b) {
    var c = a.alternate, d = a.flags;
    switch(a.tag){
        case 0:
        case 11:
        case 14:
        case 15:
            $b36288e2db101ba3$var$ck(b, a);
            $b36288e2db101ba3$var$ek(a);
            if (d & 4) {
                try {
                    $b36288e2db101ba3$var$Pj(3, a, a.return), $b36288e2db101ba3$var$Qj(3, a);
                } catch (t) {
                    $b36288e2db101ba3$var$W(a, a.return, t);
                }
                try {
                    $b36288e2db101ba3$var$Pj(5, a, a.return);
                } catch (t) {
                    $b36288e2db101ba3$var$W(a, a.return, t);
                }
            }
            break;
        case 1:
            $b36288e2db101ba3$var$ck(b, a);
            $b36288e2db101ba3$var$ek(a);
            d & 512 && null !== c && $b36288e2db101ba3$var$Lj(c, c.return);
            break;
        case 5:
            $b36288e2db101ba3$var$ck(b, a);
            $b36288e2db101ba3$var$ek(a);
            d & 512 && null !== c && $b36288e2db101ba3$var$Lj(c, c.return);
            if (a.flags & 32) {
                var e = a.stateNode;
                try {
                    $b36288e2db101ba3$var$ob(e, "");
                } catch (t) {
                    $b36288e2db101ba3$var$W(a, a.return, t);
                }
            }
            if (d & 4 && (e = a.stateNode, null != e)) {
                var f = a.memoizedProps, g = null !== c ? c.memoizedProps : f, h = a.type, k = a.updateQueue;
                a.updateQueue = null;
                if (null !== k) try {
                    "input" === h && "radio" === f.type && null != f.name && $b36288e2db101ba3$var$ab(e, f);
                    $b36288e2db101ba3$var$vb(h, g);
                    var l = $b36288e2db101ba3$var$vb(h, f);
                    for(g = 0; g < k.length; g += 2){
                        var m = k[g], q = k[g + 1];
                        "style" === m ? $b36288e2db101ba3$var$sb(e, q) : "dangerouslySetInnerHTML" === m ? $b36288e2db101ba3$var$nb(e, q) : "children" === m ? $b36288e2db101ba3$var$ob(e, q) : $b36288e2db101ba3$var$ta(e, m, q, l);
                    }
                    switch(h){
                        case "input":
                            $b36288e2db101ba3$var$bb(e, f);
                            break;
                        case "textarea":
                            $b36288e2db101ba3$var$ib(e, f);
                            break;
                        case "select":
                            var r = e._wrapperState.wasMultiple;
                            e._wrapperState.wasMultiple = !!f.multiple;
                            var y = f.value;
                            null != y ? $b36288e2db101ba3$var$fb(e, !!f.multiple, y, !1) : r !== !!f.multiple && (null != f.defaultValue ? $b36288e2db101ba3$var$fb(e, !!f.multiple, f.defaultValue, !0) : $b36288e2db101ba3$var$fb(e, !!f.multiple, f.multiple ? [] : "", !1));
                    }
                    e[$b36288e2db101ba3$var$Pf] = f;
                } catch (t) {
                    $b36288e2db101ba3$var$W(a, a.return, t);
                }
            }
            break;
        case 6:
            $b36288e2db101ba3$var$ck(b, a);
            $b36288e2db101ba3$var$ek(a);
            if (d & 4) {
                if (null === a.stateNode) throw Error($b36288e2db101ba3$var$p(162));
                e = a.stateNode;
                f = a.memoizedProps;
                try {
                    e.nodeValue = f;
                } catch (t) {
                    $b36288e2db101ba3$var$W(a, a.return, t);
                }
            }
            break;
        case 3:
            $b36288e2db101ba3$var$ck(b, a);
            $b36288e2db101ba3$var$ek(a);
            if (d & 4 && null !== c && c.memoizedState.isDehydrated) try {
                $b36288e2db101ba3$var$bd(b.containerInfo);
            } catch (t) {
                $b36288e2db101ba3$var$W(a, a.return, t);
            }
            break;
        case 4:
            $b36288e2db101ba3$var$ck(b, a);
            $b36288e2db101ba3$var$ek(a);
            break;
        case 13:
            $b36288e2db101ba3$var$ck(b, a);
            $b36288e2db101ba3$var$ek(a);
            e = a.child;
            e.flags & 8192 && (f = null !== e.memoizedState, e.stateNode.isHidden = f, !f || null !== e.alternate && null !== e.alternate.memoizedState || ($b36288e2db101ba3$var$fk = $b36288e2db101ba3$var$B()));
            d & 4 && $b36288e2db101ba3$var$ak(a);
            break;
        case 22:
            m = null !== c && null !== c.memoizedState;
            a.mode & 1 ? ($b36288e2db101ba3$var$U = (l = $b36288e2db101ba3$var$U) || m, $b36288e2db101ba3$var$ck(b, a), $b36288e2db101ba3$var$U = l) : $b36288e2db101ba3$var$ck(b, a);
            $b36288e2db101ba3$var$ek(a);
            if (d & 8192) {
                l = null !== a.memoizedState;
                if ((a.stateNode.isHidden = l) && !m && 0 !== (a.mode & 1)) for($b36288e2db101ba3$var$V = a, m = a.child; null !== m;){
                    for(q = $b36288e2db101ba3$var$V = m; null !== $b36288e2db101ba3$var$V;){
                        r = $b36288e2db101ba3$var$V;
                        y = r.child;
                        switch(r.tag){
                            case 0:
                            case 11:
                            case 14:
                            case 15:
                                $b36288e2db101ba3$var$Pj(4, r, r.return);
                                break;
                            case 1:
                                $b36288e2db101ba3$var$Lj(r, r.return);
                                var n = r.stateNode;
                                if ("function" === typeof n.componentWillUnmount) {
                                    d = r;
                                    c = r.return;
                                    try {
                                        b = d, n.props = b.memoizedProps, n.state = b.memoizedState, n.componentWillUnmount();
                                    } catch (t) {
                                        $b36288e2db101ba3$var$W(d, c, t);
                                    }
                                }
                                break;
                            case 5:
                                $b36288e2db101ba3$var$Lj(r, r.return);
                                break;
                            case 22:
                                if (null !== r.memoizedState) {
                                    $b36288e2db101ba3$var$gk(q);
                                    continue;
                                }
                        }
                        null !== y ? (y.return = r, $b36288e2db101ba3$var$V = y) : $b36288e2db101ba3$var$gk(q);
                    }
                    m = m.sibling;
                }
                a: for(m = null, q = a;;){
                    if (5 === q.tag) {
                        if (null === m) {
                            m = q;
                            try {
                                e = q.stateNode, l ? (f = e.style, "function" === typeof f.setProperty ? f.setProperty("display", "none", "important") : f.display = "none") : (h = q.stateNode, k = q.memoizedProps.style, g = void 0 !== k && null !== k && k.hasOwnProperty("display") ? k.display : null, h.style.display = $b36288e2db101ba3$var$rb("display", g));
                            } catch (t) {
                                $b36288e2db101ba3$var$W(a, a.return, t);
                            }
                        }
                    } else if (6 === q.tag) {
                        if (null === m) try {
                            q.stateNode.nodeValue = l ? "" : q.memoizedProps;
                        } catch (t) {
                            $b36288e2db101ba3$var$W(a, a.return, t);
                        }
                    } else if ((22 !== q.tag && 23 !== q.tag || null === q.memoizedState || q === a) && null !== q.child) {
                        q.child.return = q;
                        q = q.child;
                        continue;
                    }
                    if (q === a) break a;
                    for(; null === q.sibling;){
                        if (null === q.return || q.return === a) break a;
                        m === q && (m = null);
                        q = q.return;
                    }
                    m === q && (m = null);
                    q.sibling.return = q.return;
                    q = q.sibling;
                }
            }
            break;
        case 19:
            $b36288e2db101ba3$var$ck(b, a);
            $b36288e2db101ba3$var$ek(a);
            d & 4 && $b36288e2db101ba3$var$ak(a);
            break;
        case 21:
            break;
        default:
            $b36288e2db101ba3$var$ck(b, a), $b36288e2db101ba3$var$ek(a);
    }
}
function $b36288e2db101ba3$var$ek(a) {
    var b = a.flags;
    if (b & 2) {
        try {
            a: {
                for(var c = a.return; null !== c;){
                    if ($b36288e2db101ba3$var$Tj(c)) {
                        var d = c;
                        break a;
                    }
                    c = c.return;
                }
                throw Error($b36288e2db101ba3$var$p(160));
            }
            switch(d.tag){
                case 5:
                    var e = d.stateNode;
                    d.flags & 32 && ($b36288e2db101ba3$var$ob(e, ""), d.flags &= -33);
                    var f = $b36288e2db101ba3$var$Uj(a);
                    $b36288e2db101ba3$var$Wj(a, f, e);
                    break;
                case 3:
                case 4:
                    var g = d.stateNode.containerInfo, h = $b36288e2db101ba3$var$Uj(a);
                    $b36288e2db101ba3$var$Vj(a, h, g);
                    break;
                default:
                    throw Error($b36288e2db101ba3$var$p(161));
            }
        } catch (k) {
            $b36288e2db101ba3$var$W(a, a.return, k);
        }
        a.flags &= -3;
    }
    b & 4096 && (a.flags &= -4097);
}
function $b36288e2db101ba3$var$hk(a, b, c) {
    $b36288e2db101ba3$var$V = a;
    $b36288e2db101ba3$var$ik(a, b, c);
}
function $b36288e2db101ba3$var$ik(a, b, c) {
    for(var d = 0 !== (a.mode & 1); null !== $b36288e2db101ba3$var$V;){
        var e = $b36288e2db101ba3$var$V, f = e.child;
        if (22 === e.tag && d) {
            var g = null !== e.memoizedState || $b36288e2db101ba3$var$Jj;
            if (!g) {
                var h = e.alternate, k = null !== h && null !== h.memoizedState || $b36288e2db101ba3$var$U;
                h = $b36288e2db101ba3$var$Jj;
                var l = $b36288e2db101ba3$var$U;
                $b36288e2db101ba3$var$Jj = g;
                if (($b36288e2db101ba3$var$U = k) && !l) for($b36288e2db101ba3$var$V = e; null !== $b36288e2db101ba3$var$V;)g = $b36288e2db101ba3$var$V, k = g.child, 22 === g.tag && null !== g.memoizedState ? $b36288e2db101ba3$var$jk(e) : null !== k ? (k.return = g, $b36288e2db101ba3$var$V = k) : $b36288e2db101ba3$var$jk(e);
                for(; null !== f;)$b36288e2db101ba3$var$V = f, $b36288e2db101ba3$var$ik(f, b, c), f = f.sibling;
                $b36288e2db101ba3$var$V = e;
                $b36288e2db101ba3$var$Jj = h;
                $b36288e2db101ba3$var$U = l;
            }
            $b36288e2db101ba3$var$kk(a, b, c);
        } else 0 !== (e.subtreeFlags & 8772) && null !== f ? (f.return = e, $b36288e2db101ba3$var$V = f) : $b36288e2db101ba3$var$kk(a, b, c);
    }
}
function $b36288e2db101ba3$var$kk(a) {
    for(; null !== $b36288e2db101ba3$var$V;){
        var b = $b36288e2db101ba3$var$V;
        if (0 !== (b.flags & 8772)) {
            var c = b.alternate;
            try {
                if (0 !== (b.flags & 8772)) switch(b.tag){
                    case 0:
                    case 11:
                    case 15:
                        $b36288e2db101ba3$var$U || $b36288e2db101ba3$var$Qj(5, b);
                        break;
                    case 1:
                        var d = b.stateNode;
                        if (b.flags & 4 && !$b36288e2db101ba3$var$U) {
                            if (null === c) d.componentDidMount();
                            else {
                                var e = b.elementType === b.type ? c.memoizedProps : $b36288e2db101ba3$var$Ci(b.type, c.memoizedProps);
                                d.componentDidUpdate(e, c.memoizedState, d.__reactInternalSnapshotBeforeUpdate);
                            }
                        }
                        var f = b.updateQueue;
                        null !== f && $b36288e2db101ba3$var$sh(b, f, d);
                        break;
                    case 3:
                        var g = b.updateQueue;
                        if (null !== g) {
                            c = null;
                            if (null !== b.child) switch(b.child.tag){
                                case 5:
                                    c = b.child.stateNode;
                                    break;
                                case 1:
                                    c = b.child.stateNode;
                            }
                            $b36288e2db101ba3$var$sh(b, g, c);
                        }
                        break;
                    case 5:
                        var h = b.stateNode;
                        if (null === c && b.flags & 4) {
                            c = h;
                            var k = b.memoizedProps;
                            switch(b.type){
                                case "button":
                                case "input":
                                case "select":
                                case "textarea":
                                    k.autoFocus && c.focus();
                                    break;
                                case "img":
                                    k.src && (c.src = k.src);
                            }
                        }
                        break;
                    case 6:
                        break;
                    case 4:
                        break;
                    case 12:
                        break;
                    case 13:
                        if (null === b.memoizedState) {
                            var l = b.alternate;
                            if (null !== l) {
                                var m = l.memoizedState;
                                if (null !== m) {
                                    var q = m.dehydrated;
                                    null !== q && $b36288e2db101ba3$var$bd(q);
                                }
                            }
                        }
                        break;
                    case 19:
                    case 17:
                    case 21:
                    case 22:
                    case 23:
                    case 25:
                        break;
                    default:
                        throw Error($b36288e2db101ba3$var$p(163));
                }
                $b36288e2db101ba3$var$U || b.flags & 512 && $b36288e2db101ba3$var$Rj(b);
            } catch (r) {
                $b36288e2db101ba3$var$W(b, b.return, r);
            }
        }
        if (b === a) {
            $b36288e2db101ba3$var$V = null;
            break;
        }
        c = b.sibling;
        if (null !== c) {
            c.return = b.return;
            $b36288e2db101ba3$var$V = c;
            break;
        }
        $b36288e2db101ba3$var$V = b.return;
    }
}
function $b36288e2db101ba3$var$gk(a) {
    for(; null !== $b36288e2db101ba3$var$V;){
        var b = $b36288e2db101ba3$var$V;
        if (b === a) {
            $b36288e2db101ba3$var$V = null;
            break;
        }
        var c = b.sibling;
        if (null !== c) {
            c.return = b.return;
            $b36288e2db101ba3$var$V = c;
            break;
        }
        $b36288e2db101ba3$var$V = b.return;
    }
}
function $b36288e2db101ba3$var$jk(a) {
    for(; null !== $b36288e2db101ba3$var$V;){
        var b = $b36288e2db101ba3$var$V;
        try {
            switch(b.tag){
                case 0:
                case 11:
                case 15:
                    var c = b.return;
                    try {
                        $b36288e2db101ba3$var$Qj(4, b);
                    } catch (k) {
                        $b36288e2db101ba3$var$W(b, c, k);
                    }
                    break;
                case 1:
                    var d = b.stateNode;
                    if ("function" === typeof d.componentDidMount) {
                        var e = b.return;
                        try {
                            d.componentDidMount();
                        } catch (k) {
                            $b36288e2db101ba3$var$W(b, e, k);
                        }
                    }
                    var f = b.return;
                    try {
                        $b36288e2db101ba3$var$Rj(b);
                    } catch (k) {
                        $b36288e2db101ba3$var$W(b, f, k);
                    }
                    break;
                case 5:
                    var g = b.return;
                    try {
                        $b36288e2db101ba3$var$Rj(b);
                    } catch (k) {
                        $b36288e2db101ba3$var$W(b, g, k);
                    }
            }
        } catch (k) {
            $b36288e2db101ba3$var$W(b, b.return, k);
        }
        if (b === a) {
            $b36288e2db101ba3$var$V = null;
            break;
        }
        var h = b.sibling;
        if (null !== h) {
            h.return = b.return;
            $b36288e2db101ba3$var$V = h;
            break;
        }
        $b36288e2db101ba3$var$V = b.return;
    }
}
var $b36288e2db101ba3$var$lk = Math.ceil, $b36288e2db101ba3$var$mk = $b36288e2db101ba3$var$ua.ReactCurrentDispatcher, $b36288e2db101ba3$var$nk = $b36288e2db101ba3$var$ua.ReactCurrentOwner, $b36288e2db101ba3$var$ok = $b36288e2db101ba3$var$ua.ReactCurrentBatchConfig, $b36288e2db101ba3$var$K = 0, $b36288e2db101ba3$var$Q = null, $b36288e2db101ba3$var$Y = null, $b36288e2db101ba3$var$Z = 0, $b36288e2db101ba3$var$fj = 0, $b36288e2db101ba3$var$ej = $b36288e2db101ba3$var$Uf(0), $b36288e2db101ba3$var$T = 0, $b36288e2db101ba3$var$pk = null, $b36288e2db101ba3$var$rh = 0, $b36288e2db101ba3$var$qk = 0, $b36288e2db101ba3$var$rk = 0, $b36288e2db101ba3$var$sk = null, $b36288e2db101ba3$var$tk = null, $b36288e2db101ba3$var$fk = 0, $b36288e2db101ba3$var$Gj = Infinity, $b36288e2db101ba3$var$uk = null, $b36288e2db101ba3$var$Oi = !1, $b36288e2db101ba3$var$Pi = null, $b36288e2db101ba3$var$Ri = null, $b36288e2db101ba3$var$vk = !1, $b36288e2db101ba3$var$wk = null, $b36288e2db101ba3$var$xk = 0, $b36288e2db101ba3$var$yk = 0, $b36288e2db101ba3$var$zk = null, $b36288e2db101ba3$var$Ak = -1, $b36288e2db101ba3$var$Bk = 0;
function $b36288e2db101ba3$var$R() {
    return 0 !== ($b36288e2db101ba3$var$K & 6) ? $b36288e2db101ba3$var$B() : -1 !== $b36288e2db101ba3$var$Ak ? $b36288e2db101ba3$var$Ak : $b36288e2db101ba3$var$Ak = $b36288e2db101ba3$var$B();
}
function $b36288e2db101ba3$var$yi(a) {
    if (0 === (a.mode & 1)) return 1;
    if (0 !== ($b36288e2db101ba3$var$K & 2) && 0 !== $b36288e2db101ba3$var$Z) return $b36288e2db101ba3$var$Z & -$b36288e2db101ba3$var$Z;
    if (null !== $b36288e2db101ba3$var$Kg.transition) return 0 === $b36288e2db101ba3$var$Bk && ($b36288e2db101ba3$var$Bk = $b36288e2db101ba3$var$yc()), $b36288e2db101ba3$var$Bk;
    a = $b36288e2db101ba3$var$C;
    if (0 !== a) return a;
    a = window.event;
    a = void 0 === a ? 16 : $b36288e2db101ba3$var$jd(a.type);
    return a;
}
function $b36288e2db101ba3$var$gi(a, b, c, d) {
    if (50 < $b36288e2db101ba3$var$yk) throw $b36288e2db101ba3$var$yk = 0, $b36288e2db101ba3$var$zk = null, Error($b36288e2db101ba3$var$p(185));
    $b36288e2db101ba3$var$Ac(a, c, d);
    if (0 === ($b36288e2db101ba3$var$K & 2) || a !== $b36288e2db101ba3$var$Q) a === $b36288e2db101ba3$var$Q && (0 === ($b36288e2db101ba3$var$K & 2) && ($b36288e2db101ba3$var$qk |= c), 4 === $b36288e2db101ba3$var$T && $b36288e2db101ba3$var$Ck(a, $b36288e2db101ba3$var$Z)), $b36288e2db101ba3$var$Dk(a, d), 1 === c && 0 === $b36288e2db101ba3$var$K && 0 === (b.mode & 1) && ($b36288e2db101ba3$var$Gj = $b36288e2db101ba3$var$B() + 500, $b36288e2db101ba3$var$fg && $b36288e2db101ba3$var$jg());
}
function $b36288e2db101ba3$var$Dk(a, b) {
    var c = a.callbackNode;
    $b36288e2db101ba3$var$wc(a, b);
    var d = $b36288e2db101ba3$var$uc(a, a === $b36288e2db101ba3$var$Q ? $b36288e2db101ba3$var$Z : 0);
    if (0 === d) null !== c && $b36288e2db101ba3$var$bc(c), a.callbackNode = null, a.callbackPriority = 0;
    else if (b = d & -d, a.callbackPriority !== b) {
        null != c && $b36288e2db101ba3$var$bc(c);
        if (1 === b) 0 === a.tag ? $b36288e2db101ba3$var$ig($b36288e2db101ba3$var$Ek.bind(null, a)) : $b36288e2db101ba3$var$hg($b36288e2db101ba3$var$Ek.bind(null, a)), $b36288e2db101ba3$var$Jf(function() {
            0 === ($b36288e2db101ba3$var$K & 6) && $b36288e2db101ba3$var$jg();
        }), c = null;
        else {
            switch($b36288e2db101ba3$var$Dc(d)){
                case 1:
                    c = $b36288e2db101ba3$var$fc;
                    break;
                case 4:
                    c = $b36288e2db101ba3$var$gc;
                    break;
                case 16:
                    c = $b36288e2db101ba3$var$hc;
                    break;
                case 536870912:
                    c = $b36288e2db101ba3$var$jc;
                    break;
                default:
                    c = $b36288e2db101ba3$var$hc;
            }
            c = $b36288e2db101ba3$var$Fk(c, $b36288e2db101ba3$var$Gk.bind(null, a));
        }
        a.callbackPriority = b;
        a.callbackNode = c;
    }
}
function $b36288e2db101ba3$var$Gk(a, b) {
    $b36288e2db101ba3$var$Ak = -1;
    $b36288e2db101ba3$var$Bk = 0;
    if (0 !== ($b36288e2db101ba3$var$K & 6)) throw Error($b36288e2db101ba3$var$p(327));
    var c = a.callbackNode;
    if ($b36288e2db101ba3$var$Hk() && a.callbackNode !== c) return null;
    var d = $b36288e2db101ba3$var$uc(a, a === $b36288e2db101ba3$var$Q ? $b36288e2db101ba3$var$Z : 0);
    if (0 === d) return null;
    if (0 !== (d & 30) || 0 !== (d & a.expiredLanes) || b) b = $b36288e2db101ba3$var$Ik(a, d);
    else {
        b = d;
        var e = $b36288e2db101ba3$var$K;
        $b36288e2db101ba3$var$K |= 2;
        var f = $b36288e2db101ba3$var$Jk();
        if ($b36288e2db101ba3$var$Q !== a || $b36288e2db101ba3$var$Z !== b) $b36288e2db101ba3$var$uk = null, $b36288e2db101ba3$var$Gj = $b36288e2db101ba3$var$B() + 500, $b36288e2db101ba3$var$Kk(a, b);
        for(;;)try {
            $b36288e2db101ba3$var$Lk();
            break;
        } catch (h) {
            $b36288e2db101ba3$var$Mk(a, h);
        }
        $b36288e2db101ba3$var$$g();
        $b36288e2db101ba3$var$mk.current = f;
        $b36288e2db101ba3$var$K = e;
        null !== $b36288e2db101ba3$var$Y ? b = 0 : ($b36288e2db101ba3$var$Q = null, $b36288e2db101ba3$var$Z = 0, b = $b36288e2db101ba3$var$T);
    }
    if (0 !== b) {
        2 === b && (e = $b36288e2db101ba3$var$xc(a), 0 !== e && (d = e, b = $b36288e2db101ba3$var$Nk(a, e)));
        if (1 === b) throw c = $b36288e2db101ba3$var$pk, $b36288e2db101ba3$var$Kk(a, 0), $b36288e2db101ba3$var$Ck(a, d), $b36288e2db101ba3$var$Dk(a, $b36288e2db101ba3$var$B()), c;
        if (6 === b) $b36288e2db101ba3$var$Ck(a, d);
        else {
            e = a.current.alternate;
            if (0 === (d & 30) && !$b36288e2db101ba3$var$Ok(e) && (b = $b36288e2db101ba3$var$Ik(a, d), 2 === b && (f = $b36288e2db101ba3$var$xc(a), 0 !== f && (d = f, b = $b36288e2db101ba3$var$Nk(a, f))), 1 === b)) throw c = $b36288e2db101ba3$var$pk, $b36288e2db101ba3$var$Kk(a, 0), $b36288e2db101ba3$var$Ck(a, d), $b36288e2db101ba3$var$Dk(a, $b36288e2db101ba3$var$B()), c;
            a.finishedWork = e;
            a.finishedLanes = d;
            switch(b){
                case 0:
                case 1:
                    throw Error($b36288e2db101ba3$var$p(345));
                case 2:
                    $b36288e2db101ba3$var$Pk(a, $b36288e2db101ba3$var$tk, $b36288e2db101ba3$var$uk);
                    break;
                case 3:
                    $b36288e2db101ba3$var$Ck(a, d);
                    if ((d & 130023424) === d && (b = $b36288e2db101ba3$var$fk + 500 - $b36288e2db101ba3$var$B(), 10 < b)) {
                        if (0 !== $b36288e2db101ba3$var$uc(a, 0)) break;
                        e = a.suspendedLanes;
                        if ((e & d) !== d) {
                            $b36288e2db101ba3$var$R();
                            a.pingedLanes |= a.suspendedLanes & e;
                            break;
                        }
                        a.timeoutHandle = $b36288e2db101ba3$var$Ff($b36288e2db101ba3$var$Pk.bind(null, a, $b36288e2db101ba3$var$tk, $b36288e2db101ba3$var$uk), b);
                        break;
                    }
                    $b36288e2db101ba3$var$Pk(a, $b36288e2db101ba3$var$tk, $b36288e2db101ba3$var$uk);
                    break;
                case 4:
                    $b36288e2db101ba3$var$Ck(a, d);
                    if ((d & 4194240) === d) break;
                    b = a.eventTimes;
                    for(e = -1; 0 < d;){
                        var g = 31 - $b36288e2db101ba3$var$oc(d);
                        f = 1 << g;
                        g = b[g];
                        g > e && (e = g);
                        d &= ~f;
                    }
                    d = e;
                    d = $b36288e2db101ba3$var$B() - d;
                    d = (120 > d ? 120 : 480 > d ? 480 : 1080 > d ? 1080 : 1920 > d ? 1920 : 3E3 > d ? 3E3 : 4320 > d ? 4320 : 1960 * $b36288e2db101ba3$var$lk(d / 1960)) - d;
                    if (10 < d) {
                        a.timeoutHandle = $b36288e2db101ba3$var$Ff($b36288e2db101ba3$var$Pk.bind(null, a, $b36288e2db101ba3$var$tk, $b36288e2db101ba3$var$uk), d);
                        break;
                    }
                    $b36288e2db101ba3$var$Pk(a, $b36288e2db101ba3$var$tk, $b36288e2db101ba3$var$uk);
                    break;
                case 5:
                    $b36288e2db101ba3$var$Pk(a, $b36288e2db101ba3$var$tk, $b36288e2db101ba3$var$uk);
                    break;
                default:
                    throw Error($b36288e2db101ba3$var$p(329));
            }
        }
    }
    $b36288e2db101ba3$var$Dk(a, $b36288e2db101ba3$var$B());
    return a.callbackNode === c ? $b36288e2db101ba3$var$Gk.bind(null, a) : null;
}
function $b36288e2db101ba3$var$Nk(a, b) {
    var c = $b36288e2db101ba3$var$sk;
    a.current.memoizedState.isDehydrated && ($b36288e2db101ba3$var$Kk(a, b).flags |= 256);
    a = $b36288e2db101ba3$var$Ik(a, b);
    2 !== a && (b = $b36288e2db101ba3$var$tk, $b36288e2db101ba3$var$tk = c, null !== b && $b36288e2db101ba3$var$Fj(b));
    return a;
}
function $b36288e2db101ba3$var$Fj(a) {
    null === $b36288e2db101ba3$var$tk ? $b36288e2db101ba3$var$tk = a : $b36288e2db101ba3$var$tk.push.apply($b36288e2db101ba3$var$tk, a);
}
function $b36288e2db101ba3$var$Ok(a) {
    for(var b = a;;){
        if (b.flags & 16384) {
            var c = b.updateQueue;
            if (null !== c && (c = c.stores, null !== c)) for(var d = 0; d < c.length; d++){
                var e = c[d], f = e.getSnapshot;
                e = e.value;
                try {
                    if (!$b36288e2db101ba3$var$He(f(), e)) return !1;
                } catch (g) {
                    return !1;
                }
            }
        }
        c = b.child;
        if (b.subtreeFlags & 16384 && null !== c) c.return = b, b = c;
        else {
            if (b === a) break;
            for(; null === b.sibling;){
                if (null === b.return || b.return === a) return !0;
                b = b.return;
            }
            b.sibling.return = b.return;
            b = b.sibling;
        }
    }
    return !0;
}
function $b36288e2db101ba3$var$Ck(a, b) {
    b &= ~$b36288e2db101ba3$var$rk;
    b &= ~$b36288e2db101ba3$var$qk;
    a.suspendedLanes |= b;
    a.pingedLanes &= ~b;
    for(a = a.expirationTimes; 0 < b;){
        var c = 31 - $b36288e2db101ba3$var$oc(b), d = 1 << c;
        a[c] = -1;
        b &= ~d;
    }
}
function $b36288e2db101ba3$var$Ek(a) {
    if (0 !== ($b36288e2db101ba3$var$K & 6)) throw Error($b36288e2db101ba3$var$p(327));
    $b36288e2db101ba3$var$Hk();
    var b = $b36288e2db101ba3$var$uc(a, 0);
    if (0 === (b & 1)) return $b36288e2db101ba3$var$Dk(a, $b36288e2db101ba3$var$B()), null;
    var c = $b36288e2db101ba3$var$Ik(a, b);
    if (0 !== a.tag && 2 === c) {
        var d = $b36288e2db101ba3$var$xc(a);
        0 !== d && (b = d, c = $b36288e2db101ba3$var$Nk(a, d));
    }
    if (1 === c) throw c = $b36288e2db101ba3$var$pk, $b36288e2db101ba3$var$Kk(a, 0), $b36288e2db101ba3$var$Ck(a, b), $b36288e2db101ba3$var$Dk(a, $b36288e2db101ba3$var$B()), c;
    if (6 === c) throw Error($b36288e2db101ba3$var$p(345));
    a.finishedWork = a.current.alternate;
    a.finishedLanes = b;
    $b36288e2db101ba3$var$Pk(a, $b36288e2db101ba3$var$tk, $b36288e2db101ba3$var$uk);
    $b36288e2db101ba3$var$Dk(a, $b36288e2db101ba3$var$B());
    return null;
}
function $b36288e2db101ba3$var$Qk(a, b) {
    var c = $b36288e2db101ba3$var$K;
    $b36288e2db101ba3$var$K |= 1;
    try {
        return a(b);
    } finally{
        $b36288e2db101ba3$var$K = c, 0 === $b36288e2db101ba3$var$K && ($b36288e2db101ba3$var$Gj = $b36288e2db101ba3$var$B() + 500, $b36288e2db101ba3$var$fg && $b36288e2db101ba3$var$jg());
    }
}
function $b36288e2db101ba3$var$Rk(a) {
    null !== $b36288e2db101ba3$var$wk && 0 === $b36288e2db101ba3$var$wk.tag && 0 === ($b36288e2db101ba3$var$K & 6) && $b36288e2db101ba3$var$Hk();
    var b = $b36288e2db101ba3$var$K;
    $b36288e2db101ba3$var$K |= 1;
    var c = $b36288e2db101ba3$var$ok.transition, d = $b36288e2db101ba3$var$C;
    try {
        if ($b36288e2db101ba3$var$ok.transition = null, $b36288e2db101ba3$var$C = 1, a) return a();
    } finally{
        $b36288e2db101ba3$var$C = d, $b36288e2db101ba3$var$ok.transition = c, $b36288e2db101ba3$var$K = b, 0 === ($b36288e2db101ba3$var$K & 6) && $b36288e2db101ba3$var$jg();
    }
}
function $b36288e2db101ba3$var$Hj() {
    $b36288e2db101ba3$var$fj = $b36288e2db101ba3$var$ej.current;
    $b36288e2db101ba3$var$E($b36288e2db101ba3$var$ej);
}
function $b36288e2db101ba3$var$Kk(a, b) {
    a.finishedWork = null;
    a.finishedLanes = 0;
    var c = a.timeoutHandle;
    -1 !== c && (a.timeoutHandle = -1, $b36288e2db101ba3$var$Gf(c));
    if (null !== $b36288e2db101ba3$var$Y) for(c = $b36288e2db101ba3$var$Y.return; null !== c;){
        var d = c;
        $b36288e2db101ba3$var$wg(d);
        switch(d.tag){
            case 1:
                d = d.type.childContextTypes;
                null !== d && void 0 !== d && $b36288e2db101ba3$var$$f();
                break;
            case 3:
                $b36288e2db101ba3$var$zh();
                $b36288e2db101ba3$var$E($b36288e2db101ba3$var$Wf);
                $b36288e2db101ba3$var$E($b36288e2db101ba3$var$H);
                $b36288e2db101ba3$var$Eh();
                break;
            case 5:
                $b36288e2db101ba3$var$Bh(d);
                break;
            case 4:
                $b36288e2db101ba3$var$zh();
                break;
            case 13:
                $b36288e2db101ba3$var$E($b36288e2db101ba3$var$L);
                break;
            case 19:
                $b36288e2db101ba3$var$E($b36288e2db101ba3$var$L);
                break;
            case 10:
                $b36288e2db101ba3$var$ah(d.type._context);
                break;
            case 22:
            case 23:
                $b36288e2db101ba3$var$Hj();
        }
        c = c.return;
    }
    $b36288e2db101ba3$var$Q = a;
    $b36288e2db101ba3$var$Y = a = $b36288e2db101ba3$var$Pg(a.current, null);
    $b36288e2db101ba3$var$Z = $b36288e2db101ba3$var$fj = b;
    $b36288e2db101ba3$var$T = 0;
    $b36288e2db101ba3$var$pk = null;
    $b36288e2db101ba3$var$rk = $b36288e2db101ba3$var$qk = $b36288e2db101ba3$var$rh = 0;
    $b36288e2db101ba3$var$tk = $b36288e2db101ba3$var$sk = null;
    if (null !== $b36288e2db101ba3$var$fh) {
        for(b = 0; b < $b36288e2db101ba3$var$fh.length; b++)if (c = $b36288e2db101ba3$var$fh[b], d = c.interleaved, null !== d) {
            c.interleaved = null;
            var e = d.next, f = c.pending;
            if (null !== f) {
                var g = f.next;
                f.next = e;
                d.next = g;
            }
            c.pending = d;
        }
        $b36288e2db101ba3$var$fh = null;
    }
    return a;
}
function $b36288e2db101ba3$var$Mk(a, b) {
    do {
        var c = $b36288e2db101ba3$var$Y;
        try {
            $b36288e2db101ba3$var$$g();
            $b36288e2db101ba3$var$Fh.current = $b36288e2db101ba3$var$Rh;
            if ($b36288e2db101ba3$var$Ih) {
                for(var d = $b36288e2db101ba3$var$M.memoizedState; null !== d;){
                    var e = d.queue;
                    null !== e && (e.pending = null);
                    d = d.next;
                }
                $b36288e2db101ba3$var$Ih = !1;
            }
            $b36288e2db101ba3$var$Hh = 0;
            $b36288e2db101ba3$var$O = $b36288e2db101ba3$var$N = $b36288e2db101ba3$var$M = null;
            $b36288e2db101ba3$var$Jh = !1;
            $b36288e2db101ba3$var$Kh = 0;
            $b36288e2db101ba3$var$nk.current = null;
            if (null === c || null === c.return) {
                $b36288e2db101ba3$var$T = 1;
                $b36288e2db101ba3$var$pk = b;
                $b36288e2db101ba3$var$Y = null;
                break;
            }
            a: {
                var f = a, g = c.return, h = c, k = b;
                b = $b36288e2db101ba3$var$Z;
                h.flags |= 32768;
                if (null !== k && "object" === typeof k && "function" === typeof k.then) {
                    var l = k, m = h, q = m.tag;
                    if (0 === (m.mode & 1) && (0 === q || 11 === q || 15 === q)) {
                        var r = m.alternate;
                        r ? (m.updateQueue = r.updateQueue, m.memoizedState = r.memoizedState, m.lanes = r.lanes) : (m.updateQueue = null, m.memoizedState = null);
                    }
                    var y = $b36288e2db101ba3$var$Ui(g);
                    if (null !== y) {
                        y.flags &= -257;
                        $b36288e2db101ba3$var$Vi(y, g, h, f, b);
                        y.mode & 1 && $b36288e2db101ba3$var$Si(f, l, b);
                        b = y;
                        k = l;
                        var n = b.updateQueue;
                        if (null === n) {
                            var t = new Set;
                            t.add(k);
                            b.updateQueue = t;
                        } else n.add(k);
                        break a;
                    } else {
                        if (0 === (b & 1)) {
                            $b36288e2db101ba3$var$Si(f, l, b);
                            $b36288e2db101ba3$var$tj();
                            break a;
                        }
                        k = Error($b36288e2db101ba3$var$p(426));
                    }
                } else if ($b36288e2db101ba3$var$I && h.mode & 1) {
                    var J = $b36288e2db101ba3$var$Ui(g);
                    if (null !== J) {
                        0 === (J.flags & 65536) && (J.flags |= 256);
                        $b36288e2db101ba3$var$Vi(J, g, h, f, b);
                        $b36288e2db101ba3$var$Jg($b36288e2db101ba3$var$Ji(k, h));
                        break a;
                    }
                }
                f = k = $b36288e2db101ba3$var$Ji(k, h);
                4 !== $b36288e2db101ba3$var$T && ($b36288e2db101ba3$var$T = 2);
                null === $b36288e2db101ba3$var$sk ? $b36288e2db101ba3$var$sk = [
                    f
                ] : $b36288e2db101ba3$var$sk.push(f);
                f = g;
                do {
                    switch(f.tag){
                        case 3:
                            f.flags |= 65536;
                            b &= -b;
                            f.lanes |= b;
                            var x = $b36288e2db101ba3$var$Ni(f, k, b);
                            $b36288e2db101ba3$var$ph(f, x);
                            break a;
                        case 1:
                            h = k;
                            var w = f.type, u = f.stateNode;
                            if (0 === (f.flags & 128) && ("function" === typeof w.getDerivedStateFromError || null !== u && "function" === typeof u.componentDidCatch && (null === $b36288e2db101ba3$var$Ri || !$b36288e2db101ba3$var$Ri.has(u)))) {
                                f.flags |= 65536;
                                b &= -b;
                                f.lanes |= b;
                                var F = $b36288e2db101ba3$var$Qi(f, h, b);
                                $b36288e2db101ba3$var$ph(f, F);
                                break a;
                            }
                    }
                    f = f.return;
                }while (null !== f);
            }
            $b36288e2db101ba3$var$Sk(c);
        } catch (na) {
            b = na;
            $b36288e2db101ba3$var$Y === c && null !== c && ($b36288e2db101ba3$var$Y = c = c.return);
            continue;
        }
        break;
    }while (1);
}
function $b36288e2db101ba3$var$Jk() {
    var a = $b36288e2db101ba3$var$mk.current;
    $b36288e2db101ba3$var$mk.current = $b36288e2db101ba3$var$Rh;
    return null === a ? $b36288e2db101ba3$var$Rh : a;
}
function $b36288e2db101ba3$var$tj() {
    if (0 === $b36288e2db101ba3$var$T || 3 === $b36288e2db101ba3$var$T || 2 === $b36288e2db101ba3$var$T) $b36288e2db101ba3$var$T = 4;
    null === $b36288e2db101ba3$var$Q || 0 === ($b36288e2db101ba3$var$rh & 268435455) && 0 === ($b36288e2db101ba3$var$qk & 268435455) || $b36288e2db101ba3$var$Ck($b36288e2db101ba3$var$Q, $b36288e2db101ba3$var$Z);
}
function $b36288e2db101ba3$var$Ik(a, b) {
    var c = $b36288e2db101ba3$var$K;
    $b36288e2db101ba3$var$K |= 2;
    var d = $b36288e2db101ba3$var$Jk();
    if ($b36288e2db101ba3$var$Q !== a || $b36288e2db101ba3$var$Z !== b) $b36288e2db101ba3$var$uk = null, $b36288e2db101ba3$var$Kk(a, b);
    for(;;)try {
        $b36288e2db101ba3$var$Tk();
        break;
    } catch (e) {
        $b36288e2db101ba3$var$Mk(a, e);
    }
    $b36288e2db101ba3$var$$g();
    $b36288e2db101ba3$var$K = c;
    $b36288e2db101ba3$var$mk.current = d;
    if (null !== $b36288e2db101ba3$var$Y) throw Error($b36288e2db101ba3$var$p(261));
    $b36288e2db101ba3$var$Q = null;
    $b36288e2db101ba3$var$Z = 0;
    return $b36288e2db101ba3$var$T;
}
function $b36288e2db101ba3$var$Tk() {
    for(; null !== $b36288e2db101ba3$var$Y;)$b36288e2db101ba3$var$Uk($b36288e2db101ba3$var$Y);
}
function $b36288e2db101ba3$var$Lk() {
    for(; null !== $b36288e2db101ba3$var$Y && !$b36288e2db101ba3$var$cc();)$b36288e2db101ba3$var$Uk($b36288e2db101ba3$var$Y);
}
function $b36288e2db101ba3$var$Uk(a) {
    var b = $b36288e2db101ba3$var$Vk(a.alternate, a, $b36288e2db101ba3$var$fj);
    a.memoizedProps = a.pendingProps;
    null === b ? $b36288e2db101ba3$var$Sk(a) : $b36288e2db101ba3$var$Y = b;
    $b36288e2db101ba3$var$nk.current = null;
}
function $b36288e2db101ba3$var$Sk(a) {
    var b = a;
    do {
        var c = b.alternate;
        a = b.return;
        if (0 === (b.flags & 32768)) {
            if (c = $b36288e2db101ba3$var$Ej(c, b, $b36288e2db101ba3$var$fj), null !== c) {
                $b36288e2db101ba3$var$Y = c;
                return;
            }
        } else {
            c = $b36288e2db101ba3$var$Ij(c, b);
            if (null !== c) {
                c.flags &= 32767;
                $b36288e2db101ba3$var$Y = c;
                return;
            }
            if (null !== a) a.flags |= 32768, a.subtreeFlags = 0, a.deletions = null;
            else {
                $b36288e2db101ba3$var$T = 6;
                $b36288e2db101ba3$var$Y = null;
                return;
            }
        }
        b = b.sibling;
        if (null !== b) {
            $b36288e2db101ba3$var$Y = b;
            return;
        }
        $b36288e2db101ba3$var$Y = b = a;
    }while (null !== b);
    0 === $b36288e2db101ba3$var$T && ($b36288e2db101ba3$var$T = 5);
}
function $b36288e2db101ba3$var$Pk(a, b, c) {
    var d = $b36288e2db101ba3$var$C, e = $b36288e2db101ba3$var$ok.transition;
    try {
        $b36288e2db101ba3$var$ok.transition = null, $b36288e2db101ba3$var$C = 1, $b36288e2db101ba3$var$Wk(a, b, c, d);
    } finally{
        $b36288e2db101ba3$var$ok.transition = e, $b36288e2db101ba3$var$C = d;
    }
    return null;
}
function $b36288e2db101ba3$var$Wk(a, b, c, d) {
    do $b36288e2db101ba3$var$Hk();
    while (null !== $b36288e2db101ba3$var$wk);
    if (0 !== ($b36288e2db101ba3$var$K & 6)) throw Error($b36288e2db101ba3$var$p(327));
    c = a.finishedWork;
    var e = a.finishedLanes;
    if (null === c) return null;
    a.finishedWork = null;
    a.finishedLanes = 0;
    if (c === a.current) throw Error($b36288e2db101ba3$var$p(177));
    a.callbackNode = null;
    a.callbackPriority = 0;
    var f = c.lanes | c.childLanes;
    $b36288e2db101ba3$var$Bc(a, f);
    a === $b36288e2db101ba3$var$Q && ($b36288e2db101ba3$var$Y = $b36288e2db101ba3$var$Q = null, $b36288e2db101ba3$var$Z = 0);
    0 === (c.subtreeFlags & 2064) && 0 === (c.flags & 2064) || $b36288e2db101ba3$var$vk || ($b36288e2db101ba3$var$vk = !0, $b36288e2db101ba3$var$Fk($b36288e2db101ba3$var$hc, function() {
        $b36288e2db101ba3$var$Hk();
        return null;
    }));
    f = 0 !== (c.flags & 15990);
    if (0 !== (c.subtreeFlags & 15990) || f) {
        f = $b36288e2db101ba3$var$ok.transition;
        $b36288e2db101ba3$var$ok.transition = null;
        var g = $b36288e2db101ba3$var$C;
        $b36288e2db101ba3$var$C = 1;
        var h = $b36288e2db101ba3$var$K;
        $b36288e2db101ba3$var$K |= 4;
        $b36288e2db101ba3$var$nk.current = null;
        $b36288e2db101ba3$var$Oj(a, c);
        $b36288e2db101ba3$var$dk(c, a);
        $b36288e2db101ba3$var$Oe($b36288e2db101ba3$var$Df);
        $b36288e2db101ba3$var$dd = !!$b36288e2db101ba3$var$Cf;
        $b36288e2db101ba3$var$Df = $b36288e2db101ba3$var$Cf = null;
        a.current = c;
        $b36288e2db101ba3$var$hk(c, a, e);
        $b36288e2db101ba3$var$dc();
        $b36288e2db101ba3$var$K = h;
        $b36288e2db101ba3$var$C = g;
        $b36288e2db101ba3$var$ok.transition = f;
    } else a.current = c;
    $b36288e2db101ba3$var$vk && ($b36288e2db101ba3$var$vk = !1, $b36288e2db101ba3$var$wk = a, $b36288e2db101ba3$var$xk = e);
    f = a.pendingLanes;
    0 === f && ($b36288e2db101ba3$var$Ri = null);
    $b36288e2db101ba3$var$mc(c.stateNode, d);
    $b36288e2db101ba3$var$Dk(a, $b36288e2db101ba3$var$B());
    if (null !== b) for(d = a.onRecoverableError, c = 0; c < b.length; c++)e = b[c], d(e.value, {
        componentStack: e.stack,
        digest: e.digest
    });
    if ($b36288e2db101ba3$var$Oi) throw $b36288e2db101ba3$var$Oi = !1, a = $b36288e2db101ba3$var$Pi, $b36288e2db101ba3$var$Pi = null, a;
    0 !== ($b36288e2db101ba3$var$xk & 1) && 0 !== a.tag && $b36288e2db101ba3$var$Hk();
    f = a.pendingLanes;
    0 !== (f & 1) ? a === $b36288e2db101ba3$var$zk ? $b36288e2db101ba3$var$yk++ : ($b36288e2db101ba3$var$yk = 0, $b36288e2db101ba3$var$zk = a) : $b36288e2db101ba3$var$yk = 0;
    $b36288e2db101ba3$var$jg();
    return null;
}
function $b36288e2db101ba3$var$Hk() {
    if (null !== $b36288e2db101ba3$var$wk) {
        var a = $b36288e2db101ba3$var$Dc($b36288e2db101ba3$var$xk), b = $b36288e2db101ba3$var$ok.transition, c = $b36288e2db101ba3$var$C;
        try {
            $b36288e2db101ba3$var$ok.transition = null;
            $b36288e2db101ba3$var$C = 16 > a ? 16 : a;
            if (null === $b36288e2db101ba3$var$wk) var d = !1;
            else {
                a = $b36288e2db101ba3$var$wk;
                $b36288e2db101ba3$var$wk = null;
                $b36288e2db101ba3$var$xk = 0;
                if (0 !== ($b36288e2db101ba3$var$K & 6)) throw Error($b36288e2db101ba3$var$p(331));
                var e = $b36288e2db101ba3$var$K;
                $b36288e2db101ba3$var$K |= 4;
                for($b36288e2db101ba3$var$V = a.current; null !== $b36288e2db101ba3$var$V;){
                    var f = $b36288e2db101ba3$var$V, g = f.child;
                    if (0 !== ($b36288e2db101ba3$var$V.flags & 16)) {
                        var h = f.deletions;
                        if (null !== h) {
                            for(var k = 0; k < h.length; k++){
                                var l = h[k];
                                for($b36288e2db101ba3$var$V = l; null !== $b36288e2db101ba3$var$V;){
                                    var m = $b36288e2db101ba3$var$V;
                                    switch(m.tag){
                                        case 0:
                                        case 11:
                                        case 15:
                                            $b36288e2db101ba3$var$Pj(8, m, f);
                                    }
                                    var q = m.child;
                                    if (null !== q) q.return = m, $b36288e2db101ba3$var$V = q;
                                    else for(; null !== $b36288e2db101ba3$var$V;){
                                        m = $b36288e2db101ba3$var$V;
                                        var r = m.sibling, y = m.return;
                                        $b36288e2db101ba3$var$Sj(m);
                                        if (m === l) {
                                            $b36288e2db101ba3$var$V = null;
                                            break;
                                        }
                                        if (null !== r) {
                                            r.return = y;
                                            $b36288e2db101ba3$var$V = r;
                                            break;
                                        }
                                        $b36288e2db101ba3$var$V = y;
                                    }
                                }
                            }
                            var n = f.alternate;
                            if (null !== n) {
                                var t = n.child;
                                if (null !== t) {
                                    n.child = null;
                                    do {
                                        var J = t.sibling;
                                        t.sibling = null;
                                        t = J;
                                    }while (null !== t);
                                }
                            }
                            $b36288e2db101ba3$var$V = f;
                        }
                    }
                    if (0 !== (f.subtreeFlags & 2064) && null !== g) g.return = f, $b36288e2db101ba3$var$V = g;
                    else b: for(; null !== $b36288e2db101ba3$var$V;){
                        f = $b36288e2db101ba3$var$V;
                        if (0 !== (f.flags & 2048)) switch(f.tag){
                            case 0:
                            case 11:
                            case 15:
                                $b36288e2db101ba3$var$Pj(9, f, f.return);
                        }
                        var x = f.sibling;
                        if (null !== x) {
                            x.return = f.return;
                            $b36288e2db101ba3$var$V = x;
                            break b;
                        }
                        $b36288e2db101ba3$var$V = f.return;
                    }
                }
                var w = a.current;
                for($b36288e2db101ba3$var$V = w; null !== $b36288e2db101ba3$var$V;){
                    g = $b36288e2db101ba3$var$V;
                    var u = g.child;
                    if (0 !== (g.subtreeFlags & 2064) && null !== u) u.return = g, $b36288e2db101ba3$var$V = u;
                    else b: for(g = w; null !== $b36288e2db101ba3$var$V;){
                        h = $b36288e2db101ba3$var$V;
                        if (0 !== (h.flags & 2048)) try {
                            switch(h.tag){
                                case 0:
                                case 11:
                                case 15:
                                    $b36288e2db101ba3$var$Qj(9, h);
                            }
                        } catch (na) {
                            $b36288e2db101ba3$var$W(h, h.return, na);
                        }
                        if (h === g) {
                            $b36288e2db101ba3$var$V = null;
                            break b;
                        }
                        var F = h.sibling;
                        if (null !== F) {
                            F.return = h.return;
                            $b36288e2db101ba3$var$V = F;
                            break b;
                        }
                        $b36288e2db101ba3$var$V = h.return;
                    }
                }
                $b36288e2db101ba3$var$K = e;
                $b36288e2db101ba3$var$jg();
                if ($b36288e2db101ba3$var$lc && "function" === typeof $b36288e2db101ba3$var$lc.onPostCommitFiberRoot) try {
                    $b36288e2db101ba3$var$lc.onPostCommitFiberRoot($b36288e2db101ba3$var$kc, a);
                } catch (na) {}
                d = !0;
            }
            return d;
        } finally{
            $b36288e2db101ba3$var$C = c, $b36288e2db101ba3$var$ok.transition = b;
        }
    }
    return !1;
}
function $b36288e2db101ba3$var$Xk(a, b, c) {
    b = $b36288e2db101ba3$var$Ji(c, b);
    b = $b36288e2db101ba3$var$Ni(a, b, 1);
    a = $b36288e2db101ba3$var$nh(a, b, 1);
    b = $b36288e2db101ba3$var$R();
    null !== a && ($b36288e2db101ba3$var$Ac(a, 1, b), $b36288e2db101ba3$var$Dk(a, b));
}
function $b36288e2db101ba3$var$W(a, b, c) {
    if (3 === a.tag) $b36288e2db101ba3$var$Xk(a, a, c);
    else for(; null !== b;){
        if (3 === b.tag) {
            $b36288e2db101ba3$var$Xk(b, a, c);
            break;
        } else if (1 === b.tag) {
            var d = b.stateNode;
            if ("function" === typeof b.type.getDerivedStateFromError || "function" === typeof d.componentDidCatch && (null === $b36288e2db101ba3$var$Ri || !$b36288e2db101ba3$var$Ri.has(d))) {
                a = $b36288e2db101ba3$var$Ji(c, a);
                a = $b36288e2db101ba3$var$Qi(b, a, 1);
                b = $b36288e2db101ba3$var$nh(b, a, 1);
                a = $b36288e2db101ba3$var$R();
                null !== b && ($b36288e2db101ba3$var$Ac(b, 1, a), $b36288e2db101ba3$var$Dk(b, a));
                break;
            }
        }
        b = b.return;
    }
}
function $b36288e2db101ba3$var$Ti(a, b, c) {
    var d = a.pingCache;
    null !== d && d.delete(b);
    b = $b36288e2db101ba3$var$R();
    a.pingedLanes |= a.suspendedLanes & c;
    $b36288e2db101ba3$var$Q === a && ($b36288e2db101ba3$var$Z & c) === c && (4 === $b36288e2db101ba3$var$T || 3 === $b36288e2db101ba3$var$T && ($b36288e2db101ba3$var$Z & 130023424) === $b36288e2db101ba3$var$Z && 500 > $b36288e2db101ba3$var$B() - $b36288e2db101ba3$var$fk ? $b36288e2db101ba3$var$Kk(a, 0) : $b36288e2db101ba3$var$rk |= c);
    $b36288e2db101ba3$var$Dk(a, b);
}
function $b36288e2db101ba3$var$Yk(a, b) {
    0 === b && (0 === (a.mode & 1) ? b = 1 : (b = $b36288e2db101ba3$var$sc, $b36288e2db101ba3$var$sc <<= 1, 0 === ($b36288e2db101ba3$var$sc & 130023424) && ($b36288e2db101ba3$var$sc = 4194304)));
    var c = $b36288e2db101ba3$var$R();
    a = $b36288e2db101ba3$var$ih(a, b);
    null !== a && ($b36288e2db101ba3$var$Ac(a, b, c), $b36288e2db101ba3$var$Dk(a, c));
}
function $b36288e2db101ba3$var$uj(a) {
    var b = a.memoizedState, c = 0;
    null !== b && (c = b.retryLane);
    $b36288e2db101ba3$var$Yk(a, c);
}
function $b36288e2db101ba3$var$bk(a, b) {
    var c = 0;
    switch(a.tag){
        case 13:
            var d = a.stateNode;
            var e = a.memoizedState;
            null !== e && (c = e.retryLane);
            break;
        case 19:
            d = a.stateNode;
            break;
        default:
            throw Error($b36288e2db101ba3$var$p(314));
    }
    null !== d && d.delete(b);
    $b36288e2db101ba3$var$Yk(a, c);
}
var $b36288e2db101ba3$var$Vk;
$b36288e2db101ba3$var$Vk = function(a, b, c) {
    if (null !== a) {
        if (a.memoizedProps !== b.pendingProps || $b36288e2db101ba3$var$Wf.current) $b36288e2db101ba3$var$dh = !0;
        else {
            if (0 === (a.lanes & c) && 0 === (b.flags & 128)) return $b36288e2db101ba3$var$dh = !1, $b36288e2db101ba3$var$yj(a, b, c);
            $b36288e2db101ba3$var$dh = 0 !== (a.flags & 131072) ? !0 : !1;
        }
    } else $b36288e2db101ba3$var$dh = !1, $b36288e2db101ba3$var$I && 0 !== (b.flags & 1048576) && $b36288e2db101ba3$var$ug(b, $b36288e2db101ba3$var$ng, b.index);
    b.lanes = 0;
    switch(b.tag){
        case 2:
            var d = b.type;
            $b36288e2db101ba3$var$ij(a, b);
            a = b.pendingProps;
            var e = $b36288e2db101ba3$var$Yf(b, $b36288e2db101ba3$var$H.current);
            $b36288e2db101ba3$var$ch(b, c);
            e = $b36288e2db101ba3$var$Nh(null, b, d, a, e, c);
            var f = $b36288e2db101ba3$var$Sh();
            b.flags |= 1;
            "object" === typeof e && null !== e && "function" === typeof e.render && void 0 === e.$$typeof ? (b.tag = 1, b.memoizedState = null, b.updateQueue = null, $b36288e2db101ba3$var$Zf(d) ? (f = !0, $b36288e2db101ba3$var$cg(b)) : f = !1, b.memoizedState = null !== e.state && void 0 !== e.state ? e.state : null, $b36288e2db101ba3$var$kh(b), e.updater = $b36288e2db101ba3$var$Ei, b.stateNode = e, e._reactInternals = b, $b36288e2db101ba3$var$Ii(b, d, a, c), b = $b36288e2db101ba3$var$jj(null, b, d, !0, f, c)) : (b.tag = 0, $b36288e2db101ba3$var$I && f && $b36288e2db101ba3$var$vg(b), $b36288e2db101ba3$var$Xi(null, b, e, c), b = b.child);
            return b;
        case 16:
            d = b.elementType;
            a: {
                $b36288e2db101ba3$var$ij(a, b);
                a = b.pendingProps;
                e = d._init;
                d = e(d._payload);
                b.type = d;
                e = b.tag = $b36288e2db101ba3$var$Zk(d);
                a = $b36288e2db101ba3$var$Ci(d, a);
                switch(e){
                    case 0:
                        b = $b36288e2db101ba3$var$cj(null, b, d, a, c);
                        break a;
                    case 1:
                        b = $b36288e2db101ba3$var$hj(null, b, d, a, c);
                        break a;
                    case 11:
                        b = $b36288e2db101ba3$var$Yi(null, b, d, a, c);
                        break a;
                    case 14:
                        b = $b36288e2db101ba3$var$$i(null, b, d, $b36288e2db101ba3$var$Ci(d.type, a), c);
                        break a;
                }
                throw Error($b36288e2db101ba3$var$p(306, d, ""));
            }
            return b;
        case 0:
            return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : $b36288e2db101ba3$var$Ci(d, e), $b36288e2db101ba3$var$cj(a, b, d, e, c);
        case 1:
            return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : $b36288e2db101ba3$var$Ci(d, e), $b36288e2db101ba3$var$hj(a, b, d, e, c);
        case 3:
            a: {
                $b36288e2db101ba3$var$kj(b);
                if (null === a) throw Error($b36288e2db101ba3$var$p(387));
                d = b.pendingProps;
                f = b.memoizedState;
                e = f.element;
                $b36288e2db101ba3$var$lh(a, b);
                $b36288e2db101ba3$var$qh(b, d, null, c);
                var g = b.memoizedState;
                d = g.element;
                if (f.isDehydrated) {
                    if (f = {
                        element: d,
                        isDehydrated: !1,
                        cache: g.cache,
                        pendingSuspenseBoundaries: g.pendingSuspenseBoundaries,
                        transitions: g.transitions
                    }, b.updateQueue.baseState = f, b.memoizedState = f, b.flags & 256) {
                        e = $b36288e2db101ba3$var$Ji(Error($b36288e2db101ba3$var$p(423)), b);
                        b = $b36288e2db101ba3$var$lj(a, b, d, c, e);
                        break a;
                    } else if (d !== e) {
                        e = $b36288e2db101ba3$var$Ji(Error($b36288e2db101ba3$var$p(424)), b);
                        b = $b36288e2db101ba3$var$lj(a, b, d, c, e);
                        break a;
                    } else for($b36288e2db101ba3$var$yg = $b36288e2db101ba3$var$Lf(b.stateNode.containerInfo.firstChild), $b36288e2db101ba3$var$xg = b, $b36288e2db101ba3$var$I = !0, $b36288e2db101ba3$var$zg = null, c = $b36288e2db101ba3$var$Vg(b, null, d, c), b.child = c; c;)c.flags = c.flags & -3 | 4096, c = c.sibling;
                } else {
                    $b36288e2db101ba3$var$Ig();
                    if (d === e) {
                        b = $b36288e2db101ba3$var$Zi(a, b, c);
                        break a;
                    }
                    $b36288e2db101ba3$var$Xi(a, b, d, c);
                }
                b = b.child;
            }
            return b;
        case 5:
            return $b36288e2db101ba3$var$Ah(b), null === a && $b36288e2db101ba3$var$Eg(b), d = b.type, e = b.pendingProps, f = null !== a ? a.memoizedProps : null, g = e.children, $b36288e2db101ba3$var$Ef(d, e) ? g = null : null !== f && $b36288e2db101ba3$var$Ef(d, f) && (b.flags |= 32), $b36288e2db101ba3$var$gj(a, b), $b36288e2db101ba3$var$Xi(a, b, g, c), b.child;
        case 6:
            return null === a && $b36288e2db101ba3$var$Eg(b), null;
        case 13:
            return $b36288e2db101ba3$var$oj(a, b, c);
        case 4:
            return $b36288e2db101ba3$var$yh(b, b.stateNode.containerInfo), d = b.pendingProps, null === a ? b.child = $b36288e2db101ba3$var$Ug(b, null, d, c) : $b36288e2db101ba3$var$Xi(a, b, d, c), b.child;
        case 11:
            return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : $b36288e2db101ba3$var$Ci(d, e), $b36288e2db101ba3$var$Yi(a, b, d, e, c);
        case 7:
            return $b36288e2db101ba3$var$Xi(a, b, b.pendingProps, c), b.child;
        case 8:
            return $b36288e2db101ba3$var$Xi(a, b, b.pendingProps.children, c), b.child;
        case 12:
            return $b36288e2db101ba3$var$Xi(a, b, b.pendingProps.children, c), b.child;
        case 10:
            a: {
                d = b.type._context;
                e = b.pendingProps;
                f = b.memoizedProps;
                g = e.value;
                $b36288e2db101ba3$var$G($b36288e2db101ba3$var$Wg, d._currentValue);
                d._currentValue = g;
                if (null !== f) {
                    if ($b36288e2db101ba3$var$He(f.value, g)) {
                        if (f.children === e.children && !$b36288e2db101ba3$var$Wf.current) {
                            b = $b36288e2db101ba3$var$Zi(a, b, c);
                            break a;
                        }
                    } else for(f = b.child, null !== f && (f.return = b); null !== f;){
                        var h = f.dependencies;
                        if (null !== h) {
                            g = f.child;
                            for(var k = h.firstContext; null !== k;){
                                if (k.context === d) {
                                    if (1 === f.tag) {
                                        k = $b36288e2db101ba3$var$mh(-1, c & -c);
                                        k.tag = 2;
                                        var l = f.updateQueue;
                                        if (null !== l) {
                                            l = l.shared;
                                            var m = l.pending;
                                            null === m ? k.next = k : (k.next = m.next, m.next = k);
                                            l.pending = k;
                                        }
                                    }
                                    f.lanes |= c;
                                    k = f.alternate;
                                    null !== k && (k.lanes |= c);
                                    $b36288e2db101ba3$var$bh(f.return, c, b);
                                    h.lanes |= c;
                                    break;
                                }
                                k = k.next;
                            }
                        } else if (10 === f.tag) g = f.type === b.type ? null : f.child;
                        else if (18 === f.tag) {
                            g = f.return;
                            if (null === g) throw Error($b36288e2db101ba3$var$p(341));
                            g.lanes |= c;
                            h = g.alternate;
                            null !== h && (h.lanes |= c);
                            $b36288e2db101ba3$var$bh(g, c, b);
                            g = f.sibling;
                        } else g = f.child;
                        if (null !== g) g.return = f;
                        else for(g = f; null !== g;){
                            if (g === b) {
                                g = null;
                                break;
                            }
                            f = g.sibling;
                            if (null !== f) {
                                f.return = g.return;
                                g = f;
                                break;
                            }
                            g = g.return;
                        }
                        f = g;
                    }
                }
                $b36288e2db101ba3$var$Xi(a, b, e.children, c);
                b = b.child;
            }
            return b;
        case 9:
            return e = b.type, d = b.pendingProps.children, $b36288e2db101ba3$var$ch(b, c), e = $b36288e2db101ba3$var$eh(e), d = d(e), b.flags |= 1, $b36288e2db101ba3$var$Xi(a, b, d, c), b.child;
        case 14:
            return d = b.type, e = $b36288e2db101ba3$var$Ci(d, b.pendingProps), e = $b36288e2db101ba3$var$Ci(d.type, e), $b36288e2db101ba3$var$$i(a, b, d, e, c);
        case 15:
            return $b36288e2db101ba3$var$bj(a, b, b.type, b.pendingProps, c);
        case 17:
            return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : $b36288e2db101ba3$var$Ci(d, e), $b36288e2db101ba3$var$ij(a, b), b.tag = 1, $b36288e2db101ba3$var$Zf(d) ? (a = !0, $b36288e2db101ba3$var$cg(b)) : a = !1, $b36288e2db101ba3$var$ch(b, c), $b36288e2db101ba3$var$Gi(b, d, e), $b36288e2db101ba3$var$Ii(b, d, e, c), $b36288e2db101ba3$var$jj(null, b, d, !0, a, c);
        case 19:
            return $b36288e2db101ba3$var$xj(a, b, c);
        case 22:
            return $b36288e2db101ba3$var$dj(a, b, c);
    }
    throw Error($b36288e2db101ba3$var$p(156, b.tag));
};
function $b36288e2db101ba3$var$Fk(a, b) {
    return $b36288e2db101ba3$var$ac(a, b);
}
function $b36288e2db101ba3$var$$k(a, b, c, d) {
    this.tag = a;
    this.key = c;
    this.sibling = this.child = this.return = this.stateNode = this.type = this.elementType = null;
    this.index = 0;
    this.ref = null;
    this.pendingProps = b;
    this.dependencies = this.memoizedState = this.updateQueue = this.memoizedProps = null;
    this.mode = d;
    this.subtreeFlags = this.flags = 0;
    this.deletions = null;
    this.childLanes = this.lanes = 0;
    this.alternate = null;
}
function $b36288e2db101ba3$var$Bg(a, b, c, d) {
    return new $b36288e2db101ba3$var$$k(a, b, c, d);
}
function $b36288e2db101ba3$var$aj(a) {
    a = a.prototype;
    return !(!a || !a.isReactComponent);
}
function $b36288e2db101ba3$var$Zk(a) {
    if ("function" === typeof a) return $b36288e2db101ba3$var$aj(a) ? 1 : 0;
    if (void 0 !== a && null !== a) {
        a = a.$$typeof;
        if (a === $b36288e2db101ba3$var$Da) return 11;
        if (a === $b36288e2db101ba3$var$Ga) return 14;
    }
    return 2;
}
function $b36288e2db101ba3$var$Pg(a, b) {
    var c = a.alternate;
    null === c ? (c = $b36288e2db101ba3$var$Bg(a.tag, b, a.key, a.mode), c.elementType = a.elementType, c.type = a.type, c.stateNode = a.stateNode, c.alternate = a, a.alternate = c) : (c.pendingProps = b, c.type = a.type, c.flags = 0, c.subtreeFlags = 0, c.deletions = null);
    c.flags = a.flags & 14680064;
    c.childLanes = a.childLanes;
    c.lanes = a.lanes;
    c.child = a.child;
    c.memoizedProps = a.memoizedProps;
    c.memoizedState = a.memoizedState;
    c.updateQueue = a.updateQueue;
    b = a.dependencies;
    c.dependencies = null === b ? null : {
        lanes: b.lanes,
        firstContext: b.firstContext
    };
    c.sibling = a.sibling;
    c.index = a.index;
    c.ref = a.ref;
    return c;
}
function $b36288e2db101ba3$var$Rg(a, b, c, d, e, f) {
    var g = 2;
    d = a;
    if ("function" === typeof a) $b36288e2db101ba3$var$aj(a) && (g = 1);
    else if ("string" === typeof a) g = 5;
    else a: switch(a){
        case $b36288e2db101ba3$var$ya:
            return $b36288e2db101ba3$var$Tg(c.children, e, f, b);
        case $b36288e2db101ba3$var$za:
            g = 8;
            e |= 8;
            break;
        case $b36288e2db101ba3$var$Aa:
            return a = $b36288e2db101ba3$var$Bg(12, c, b, e | 2), a.elementType = $b36288e2db101ba3$var$Aa, a.lanes = f, a;
        case $b36288e2db101ba3$var$Ea:
            return a = $b36288e2db101ba3$var$Bg(13, c, b, e), a.elementType = $b36288e2db101ba3$var$Ea, a.lanes = f, a;
        case $b36288e2db101ba3$var$Fa:
            return a = $b36288e2db101ba3$var$Bg(19, c, b, e), a.elementType = $b36288e2db101ba3$var$Fa, a.lanes = f, a;
        case $b36288e2db101ba3$var$Ia:
            return $b36288e2db101ba3$var$pj(c, e, f, b);
        default:
            if ("object" === typeof a && null !== a) switch(a.$$typeof){
                case $b36288e2db101ba3$var$Ba:
                    g = 10;
                    break a;
                case $b36288e2db101ba3$var$Ca:
                    g = 9;
                    break a;
                case $b36288e2db101ba3$var$Da:
                    g = 11;
                    break a;
                case $b36288e2db101ba3$var$Ga:
                    g = 14;
                    break a;
                case $b36288e2db101ba3$var$Ha:
                    g = 16;
                    d = null;
                    break a;
            }
            throw Error($b36288e2db101ba3$var$p(130, null == a ? a : typeof a, ""));
    }
    b = $b36288e2db101ba3$var$Bg(g, c, b, e);
    b.elementType = a;
    b.type = d;
    b.lanes = f;
    return b;
}
function $b36288e2db101ba3$var$Tg(a, b, c, d) {
    a = $b36288e2db101ba3$var$Bg(7, a, d, b);
    a.lanes = c;
    return a;
}
function $b36288e2db101ba3$var$pj(a, b, c, d) {
    a = $b36288e2db101ba3$var$Bg(22, a, d, b);
    a.elementType = $b36288e2db101ba3$var$Ia;
    a.lanes = c;
    a.stateNode = {
        isHidden: !1
    };
    return a;
}
function $b36288e2db101ba3$var$Qg(a, b, c) {
    a = $b36288e2db101ba3$var$Bg(6, a, null, b);
    a.lanes = c;
    return a;
}
function $b36288e2db101ba3$var$Sg(a, b, c) {
    b = $b36288e2db101ba3$var$Bg(4, null !== a.children ? a.children : [], a.key, b);
    b.lanes = c;
    b.stateNode = {
        containerInfo: a.containerInfo,
        pendingChildren: null,
        implementation: a.implementation
    };
    return b;
}
function $b36288e2db101ba3$var$al(a, b, c, d, e) {
    this.tag = b;
    this.containerInfo = a;
    this.finishedWork = this.pingCache = this.current = this.pendingChildren = null;
    this.timeoutHandle = -1;
    this.callbackNode = this.pendingContext = this.context = null;
    this.callbackPriority = 0;
    this.eventTimes = $b36288e2db101ba3$var$zc(0);
    this.expirationTimes = $b36288e2db101ba3$var$zc(-1);
    this.entangledLanes = this.finishedLanes = this.mutableReadLanes = this.expiredLanes = this.pingedLanes = this.suspendedLanes = this.pendingLanes = 0;
    this.entanglements = $b36288e2db101ba3$var$zc(0);
    this.identifierPrefix = d;
    this.onRecoverableError = e;
    this.mutableSourceEagerHydrationData = null;
}
function $b36288e2db101ba3$var$bl(a, b, c, d, e, f, g, h, k) {
    a = new $b36288e2db101ba3$var$al(a, b, c, h, k);
    1 === b ? (b = 1, !0 === f && (b |= 8)) : b = 0;
    f = $b36288e2db101ba3$var$Bg(3, null, null, b);
    a.current = f;
    f.stateNode = a;
    f.memoizedState = {
        element: d,
        isDehydrated: c,
        cache: null,
        transitions: null,
        pendingSuspenseBoundaries: null
    };
    $b36288e2db101ba3$var$kh(f);
    return a;
}
function $b36288e2db101ba3$var$cl(a, b, c) {
    var d = 3 < arguments.length && void 0 !== arguments[3] ? arguments[3] : null;
    return {
        $$typeof: $b36288e2db101ba3$var$wa,
        key: null == d ? null : "" + d,
        children: a,
        containerInfo: b,
        implementation: c
    };
}
function $b36288e2db101ba3$var$dl(a) {
    if (!a) return $b36288e2db101ba3$var$Vf;
    a = a._reactInternals;
    a: {
        if ($b36288e2db101ba3$var$Vb(a) !== a || 1 !== a.tag) throw Error($b36288e2db101ba3$var$p(170));
        var b = a;
        do {
            switch(b.tag){
                case 3:
                    b = b.stateNode.context;
                    break a;
                case 1:
                    if ($b36288e2db101ba3$var$Zf(b.type)) {
                        b = b.stateNode.__reactInternalMemoizedMergedChildContext;
                        break a;
                    }
            }
            b = b.return;
        }while (null !== b);
        throw Error($b36288e2db101ba3$var$p(171));
    }
    if (1 === a.tag) {
        var c = a.type;
        if ($b36288e2db101ba3$var$Zf(c)) return $b36288e2db101ba3$var$bg(a, c, b);
    }
    return b;
}
function $b36288e2db101ba3$var$el(a, b, c, d, e, f, g, h, k) {
    a = $b36288e2db101ba3$var$bl(c, d, !0, a, e, f, g, h, k);
    a.context = $b36288e2db101ba3$var$dl(null);
    c = a.current;
    d = $b36288e2db101ba3$var$R();
    e = $b36288e2db101ba3$var$yi(c);
    f = $b36288e2db101ba3$var$mh(d, e);
    f.callback = void 0 !== b && null !== b ? b : null;
    $b36288e2db101ba3$var$nh(c, f, e);
    a.current.lanes = e;
    $b36288e2db101ba3$var$Ac(a, e, d);
    $b36288e2db101ba3$var$Dk(a, d);
    return a;
}
function $b36288e2db101ba3$var$fl(a, b, c, d) {
    var e = b.current, f = $b36288e2db101ba3$var$R(), g = $b36288e2db101ba3$var$yi(e);
    c = $b36288e2db101ba3$var$dl(c);
    null === b.context ? b.context = c : b.pendingContext = c;
    b = $b36288e2db101ba3$var$mh(f, g);
    b.payload = {
        element: a
    };
    d = void 0 === d ? null : d;
    null !== d && (b.callback = d);
    a = $b36288e2db101ba3$var$nh(e, b, g);
    null !== a && ($b36288e2db101ba3$var$gi(a, e, g, f), $b36288e2db101ba3$var$oh(a, e, g));
    return g;
}
function $b36288e2db101ba3$var$gl(a) {
    a = a.current;
    if (!a.child) return null;
    switch(a.child.tag){
        case 5:
            return a.child.stateNode;
        default:
            return a.child.stateNode;
    }
}
function $b36288e2db101ba3$var$hl(a, b) {
    a = a.memoizedState;
    if (null !== a && null !== a.dehydrated) {
        var c = a.retryLane;
        a.retryLane = 0 !== c && c < b ? c : b;
    }
}
function $b36288e2db101ba3$var$il(a, b) {
    $b36288e2db101ba3$var$hl(a, b);
    (a = a.alternate) && $b36288e2db101ba3$var$hl(a, b);
}
function $b36288e2db101ba3$var$jl() {
    return null;
}
var $b36288e2db101ba3$var$kl = "function" === typeof reportError ? reportError : function(a) {
    console.error(a);
};
function $b36288e2db101ba3$var$ll(a) {
    this._internalRoot = a;
}
$b36288e2db101ba3$var$ml.prototype.render = $b36288e2db101ba3$var$ll.prototype.render = function(a) {
    var b = this._internalRoot;
    if (null === b) throw Error($b36288e2db101ba3$var$p(409));
    $b36288e2db101ba3$var$fl(a, b, null, null);
};
$b36288e2db101ba3$var$ml.prototype.unmount = $b36288e2db101ba3$var$ll.prototype.unmount = function() {
    var a = this._internalRoot;
    if (null !== a) {
        this._internalRoot = null;
        var b = a.containerInfo;
        $b36288e2db101ba3$var$Rk(function() {
            $b36288e2db101ba3$var$fl(null, a, null, null);
        });
        b[$b36288e2db101ba3$var$uf] = null;
    }
};
function $b36288e2db101ba3$var$ml(a) {
    this._internalRoot = a;
}
$b36288e2db101ba3$var$ml.prototype.unstable_scheduleHydration = function(a) {
    if (a) {
        var b = $b36288e2db101ba3$var$Hc();
        a = {
            blockedOn: null,
            target: a,
            priority: b
        };
        for(var c = 0; c < $b36288e2db101ba3$var$Qc.length && 0 !== b && b < $b36288e2db101ba3$var$Qc[c].priority; c++);
        $b36288e2db101ba3$var$Qc.splice(c, 0, a);
        0 === c && $b36288e2db101ba3$var$Vc(a);
    }
};
function $b36288e2db101ba3$var$nl(a) {
    return !(!a || 1 !== a.nodeType && 9 !== a.nodeType && 11 !== a.nodeType);
}
function $b36288e2db101ba3$var$ol(a) {
    return !(!a || 1 !== a.nodeType && 9 !== a.nodeType && 11 !== a.nodeType && (8 !== a.nodeType || " react-mount-point-unstable " !== a.nodeValue));
}
function $b36288e2db101ba3$var$pl() {}
function $b36288e2db101ba3$var$ql(a, b, c, d, e) {
    if (e) {
        if ("function" === typeof d) {
            var f = d;
            d = function() {
                var a = $b36288e2db101ba3$var$gl(g);
                f.call(a);
            };
        }
        var g = $b36288e2db101ba3$var$el(b, d, a, 0, null, !1, !1, "", $b36288e2db101ba3$var$pl);
        a._reactRootContainer = g;
        a[$b36288e2db101ba3$var$uf] = g.current;
        $b36288e2db101ba3$var$sf(8 === a.nodeType ? a.parentNode : a);
        $b36288e2db101ba3$var$Rk();
        return g;
    }
    for(; e = a.lastChild;)a.removeChild(e);
    if ("function" === typeof d) {
        var h = d;
        d = function() {
            var a = $b36288e2db101ba3$var$gl(k);
            h.call(a);
        };
    }
    var k = $b36288e2db101ba3$var$bl(a, 0, !1, null, null, !1, !1, "", $b36288e2db101ba3$var$pl);
    a._reactRootContainer = k;
    a[$b36288e2db101ba3$var$uf] = k.current;
    $b36288e2db101ba3$var$sf(8 === a.nodeType ? a.parentNode : a);
    $b36288e2db101ba3$var$Rk(function() {
        $b36288e2db101ba3$var$fl(b, k, c, d);
    });
    return k;
}
function $b36288e2db101ba3$var$rl(a, b, c, d, e) {
    var f = c._reactRootContainer;
    if (f) {
        var g = f;
        if ("function" === typeof e) {
            var h = e;
            e = function() {
                var a = $b36288e2db101ba3$var$gl(g);
                h.call(a);
            };
        }
        $b36288e2db101ba3$var$fl(b, g, a, e);
    } else g = $b36288e2db101ba3$var$ql(c, b, a, e, d);
    return $b36288e2db101ba3$var$gl(g);
}
$b36288e2db101ba3$var$Ec = function(a) {
    switch(a.tag){
        case 3:
            var b = a.stateNode;
            if (b.current.memoizedState.isDehydrated) {
                var c = $b36288e2db101ba3$var$tc(b.pendingLanes);
                0 !== c && ($b36288e2db101ba3$var$Cc(b, c | 1), $b36288e2db101ba3$var$Dk(b, $b36288e2db101ba3$var$B()), 0 === ($b36288e2db101ba3$var$K & 6) && ($b36288e2db101ba3$var$Gj = $b36288e2db101ba3$var$B() + 500, $b36288e2db101ba3$var$jg()));
            }
            break;
        case 13:
            $b36288e2db101ba3$var$Rk(function() {
                var b = $b36288e2db101ba3$var$ih(a, 1);
                if (null !== b) {
                    var c = $b36288e2db101ba3$var$R();
                    $b36288e2db101ba3$var$gi(b, a, 1, c);
                }
            }), $b36288e2db101ba3$var$il(a, 1);
    }
};
$b36288e2db101ba3$var$Fc = function(a) {
    if (13 === a.tag) {
        var b = $b36288e2db101ba3$var$ih(a, 134217728);
        if (null !== b) {
            var c = $b36288e2db101ba3$var$R();
            $b36288e2db101ba3$var$gi(b, a, 134217728, c);
        }
        $b36288e2db101ba3$var$il(a, 134217728);
    }
};
$b36288e2db101ba3$var$Gc = function(a) {
    if (13 === a.tag) {
        var b = $b36288e2db101ba3$var$yi(a), c = $b36288e2db101ba3$var$ih(a, b);
        if (null !== c) {
            var d = $b36288e2db101ba3$var$R();
            $b36288e2db101ba3$var$gi(c, a, b, d);
        }
        $b36288e2db101ba3$var$il(a, b);
    }
};
$b36288e2db101ba3$var$Hc = function() {
    return $b36288e2db101ba3$var$C;
};
$b36288e2db101ba3$var$Ic = function(a, b) {
    var c = $b36288e2db101ba3$var$C;
    try {
        return $b36288e2db101ba3$var$C = a, b();
    } finally{
        $b36288e2db101ba3$var$C = c;
    }
};
$b36288e2db101ba3$var$yb = function(a, b, c) {
    switch(b){
        case "input":
            $b36288e2db101ba3$var$bb(a, c);
            b = c.name;
            if ("radio" === c.type && null != b) {
                for(c = a; c.parentNode;)c = c.parentNode;
                c = c.querySelectorAll("input[name=" + JSON.stringify("" + b) + '][type="radio"]');
                for(b = 0; b < c.length; b++){
                    var d = c[b];
                    if (d !== a && d.form === a.form) {
                        var e = $b36288e2db101ba3$var$Db(d);
                        if (!e) throw Error($b36288e2db101ba3$var$p(90));
                        $b36288e2db101ba3$var$Wa(d);
                        $b36288e2db101ba3$var$bb(d, e);
                    }
                }
            }
            break;
        case "textarea":
            $b36288e2db101ba3$var$ib(a, c);
            break;
        case "select":
            b = c.value, null != b && $b36288e2db101ba3$var$fb(a, !!c.multiple, b, !1);
    }
};
$b36288e2db101ba3$var$Gb = $b36288e2db101ba3$var$Qk;
$b36288e2db101ba3$var$Hb = $b36288e2db101ba3$var$Rk;
var $b36288e2db101ba3$var$sl = {
    usingClientEntryPoint: !1,
    Events: [
        $b36288e2db101ba3$var$Cb,
        $b36288e2db101ba3$var$ue,
        $b36288e2db101ba3$var$Db,
        $b36288e2db101ba3$var$Eb,
        $b36288e2db101ba3$var$Fb,
        $b36288e2db101ba3$var$Qk
    ]
}, $b36288e2db101ba3$var$tl = {
    findFiberByHostInstance: $b36288e2db101ba3$var$Wc,
    bundleType: 0,
    version: "18.3.1",
    rendererPackageName: "react-dom"
};
var $b36288e2db101ba3$var$ul = {
    bundleType: $b36288e2db101ba3$var$tl.bundleType,
    version: $b36288e2db101ba3$var$tl.version,
    rendererPackageName: $b36288e2db101ba3$var$tl.rendererPackageName,
    rendererConfig: $b36288e2db101ba3$var$tl.rendererConfig,
    overrideHookState: null,
    overrideHookStateDeletePath: null,
    overrideHookStateRenamePath: null,
    overrideProps: null,
    overridePropsDeletePath: null,
    overridePropsRenamePath: null,
    setErrorHandler: null,
    setSuspenseHandler: null,
    scheduleUpdate: null,
    currentDispatcherRef: $b36288e2db101ba3$var$ua.ReactCurrentDispatcher,
    findHostInstanceByFiber: function(a) {
        a = $b36288e2db101ba3$var$Zb(a);
        return null === a ? null : a.stateNode;
    },
    findFiberByHostInstance: $b36288e2db101ba3$var$tl.findFiberByHostInstance || $b36288e2db101ba3$var$jl,
    findHostInstancesForRefresh: null,
    scheduleRefresh: null,
    scheduleRoot: null,
    setRefreshHandler: null,
    getCurrentFiber: null,
    reconcilerVersion: "18.3.1-next-f1338f8080-20240426"
};
if ("undefined" !== typeof __REACT_DEVTOOLS_GLOBAL_HOOK__) {
    var $b36288e2db101ba3$var$vl = __REACT_DEVTOOLS_GLOBAL_HOOK__;
    if (!$b36288e2db101ba3$var$vl.isDisabled && $b36288e2db101ba3$var$vl.supportsFiber) try {
        $b36288e2db101ba3$var$kc = $b36288e2db101ba3$var$vl.inject($b36288e2db101ba3$var$ul), $b36288e2db101ba3$var$lc = $b36288e2db101ba3$var$vl;
    } catch (a) {}
}
$b36288e2db101ba3$export$ae55be85d98224ed = $b36288e2db101ba3$var$sl;
$b36288e2db101ba3$export$d39a5bbd09211389 = function(a, b) {
    var c = 2 < arguments.length && void 0 !== arguments[2] ? arguments[2] : null;
    if (!$b36288e2db101ba3$var$nl(b)) throw Error($b36288e2db101ba3$var$p(200));
    return $b36288e2db101ba3$var$cl(a, b, null, c);
};
$b36288e2db101ba3$export$882461b6382ed46c = function(a, b) {
    if (!$b36288e2db101ba3$var$nl(a)) throw Error($b36288e2db101ba3$var$p(299));
    var c = !1, d = "", e = $b36288e2db101ba3$var$kl;
    null !== b && void 0 !== b && (!0 === b.unstable_strictMode && (c = !0), void 0 !== b.identifierPrefix && (d = b.identifierPrefix), void 0 !== b.onRecoverableError && (e = b.onRecoverableError));
    b = $b36288e2db101ba3$var$bl(a, 1, !1, null, null, c, !1, d, e);
    a[$b36288e2db101ba3$var$uf] = b.current;
    $b36288e2db101ba3$var$sf(8 === a.nodeType ? a.parentNode : a);
    return new $b36288e2db101ba3$var$ll(b);
};
$b36288e2db101ba3$export$466bfc07425424d5 = function(a) {
    if (null == a) return null;
    if (1 === a.nodeType) return a;
    var b = a._reactInternals;
    if (void 0 === b) {
        if ("function" === typeof a.render) throw Error($b36288e2db101ba3$var$p(188));
        a = Object.keys(a).join(",");
        throw Error($b36288e2db101ba3$var$p(268, a));
    }
    a = $b36288e2db101ba3$var$Zb(b);
    a = null === a ? null : a.stateNode;
    return a;
};
$b36288e2db101ba3$export$cd75ccfd720a3cd4 = function(a) {
    return $b36288e2db101ba3$var$Rk(a);
};
$b36288e2db101ba3$export$fa8d919ba61d84db = function(a, b, c) {
    if (!$b36288e2db101ba3$var$ol(b)) throw Error($b36288e2db101ba3$var$p(200));
    return $b36288e2db101ba3$var$rl(null, a, b, !0, c);
};
$b36288e2db101ba3$export$757ceba2d55c277e = function(a, b, c) {
    if (!$b36288e2db101ba3$var$nl(a)) throw Error($b36288e2db101ba3$var$p(405));
    var d = null != c && c.hydratedSources || null, e = !1, f = "", g = $b36288e2db101ba3$var$kl;
    null !== c && void 0 !== c && (!0 === c.unstable_strictMode && (e = !0), void 0 !== c.identifierPrefix && (f = c.identifierPrefix), void 0 !== c.onRecoverableError && (g = c.onRecoverableError));
    b = $b36288e2db101ba3$var$el(b, null, a, 1, null != c ? c : null, e, !1, f, g);
    a[$b36288e2db101ba3$var$uf] = b.current;
    $b36288e2db101ba3$var$sf(a);
    if (d) for(a = 0; a < d.length; a++)c = d[a], e = c._getVersion, e = e(c._source), null == b.mutableSourceEagerHydrationData ? b.mutableSourceEagerHydrationData = [
        c,
        e
    ] : b.mutableSourceEagerHydrationData.push(c, e);
    return new $b36288e2db101ba3$var$ml(b);
};
$b36288e2db101ba3$export$b3890eb0ae9dca99 = function(a, b, c) {
    if (!$b36288e2db101ba3$var$ol(b)) throw Error($b36288e2db101ba3$var$p(200));
    return $b36288e2db101ba3$var$rl(null, a, b, !1, c);
};
$b36288e2db101ba3$export$502457920280e6be = function(a) {
    if (!$b36288e2db101ba3$var$ol(a)) throw Error($b36288e2db101ba3$var$p(40));
    return a._reactRootContainer ? ($b36288e2db101ba3$var$Rk(function() {
        $b36288e2db101ba3$var$rl(null, null, a, !1, function() {
            a._reactRootContainer = null;
            a[$b36288e2db101ba3$var$uf] = null;
        });
    }), !0) : !1;
};
$b36288e2db101ba3$export$c78a37762a8d58e1 = $b36288e2db101ba3$var$Qk;
$b36288e2db101ba3$export$dc54d992c10e8a18 = function(a, b, c, d) {
    if (!$b36288e2db101ba3$var$ol(c)) throw Error($b36288e2db101ba3$var$p(200));
    if (null == a || void 0 === a._reactInternals) throw Error($b36288e2db101ba3$var$p(38));
    return $b36288e2db101ba3$var$rl(a, b, c, !1, d);
};
$b36288e2db101ba3$export$83d89fbfd8236492 = "18.3.1-next-f1338f8080-20240426";

});
parcelRegister("4LCdk", function(module, exports) {
"use strict";

module.exports = (parcelRequire("8BKFp"));

});
parcelRegister("8BKFp", function(module, exports) {

$parcel$export(module.exports, "unstable_now", function () { return $6445fa7f31ec0ca5$export$c4744153514ff05d; }, function (v) { return $6445fa7f31ec0ca5$export$c4744153514ff05d = v; });
$parcel$export(module.exports, "unstable_IdlePriority", function () { return $6445fa7f31ec0ca5$export$3e506c1ccc9cc1a7; }, function (v) { return $6445fa7f31ec0ca5$export$3e506c1ccc9cc1a7 = v; });
$parcel$export(module.exports, "unstable_ImmediatePriority", function () { return $6445fa7f31ec0ca5$export$e26fe2ed2fa76875; }, function (v) { return $6445fa7f31ec0ca5$export$e26fe2ed2fa76875 = v; });
$parcel$export(module.exports, "unstable_LowPriority", function () { return $6445fa7f31ec0ca5$export$502329bbf4b505b1; }, function (v) { return $6445fa7f31ec0ca5$export$502329bbf4b505b1 = v; });
$parcel$export(module.exports, "unstable_NormalPriority", function () { return $6445fa7f31ec0ca5$export$6e3807111c4874c4; }, function (v) { return $6445fa7f31ec0ca5$export$6e3807111c4874c4 = v; });
$parcel$export(module.exports, "unstable_Profiling", function () { return $6445fa7f31ec0ca5$export$c27134553091fb3a; }, function (v) { return $6445fa7f31ec0ca5$export$c27134553091fb3a = v; });
$parcel$export(module.exports, "unstable_UserBlockingPriority", function () { return $6445fa7f31ec0ca5$export$33ee1acdc04fd2a2; }, function (v) { return $6445fa7f31ec0ca5$export$33ee1acdc04fd2a2 = v; });
$parcel$export(module.exports, "unstable_cancelCallback", function () { return $6445fa7f31ec0ca5$export$b00a404bbd5edef2; }, function (v) { return $6445fa7f31ec0ca5$export$b00a404bbd5edef2 = v; });
$parcel$export(module.exports, "unstable_continueExecution", function () { return $6445fa7f31ec0ca5$export$8352ce38b91d0c62; }, function (v) { return $6445fa7f31ec0ca5$export$8352ce38b91d0c62 = v; });
$parcel$export(module.exports, "unstable_forceFrameRate", function () { return $6445fa7f31ec0ca5$export$d66a1c1c77bd778b; }, function (v) { return $6445fa7f31ec0ca5$export$d66a1c1c77bd778b = v; });
$parcel$export(module.exports, "unstable_getCurrentPriorityLevel", function () { return $6445fa7f31ec0ca5$export$d3dfb8e4810cb555; }, function (v) { return $6445fa7f31ec0ca5$export$d3dfb8e4810cb555 = v; });
$parcel$export(module.exports, "unstable_getFirstCallbackNode", function () { return $6445fa7f31ec0ca5$export$839f9183b0465a69; }, function (v) { return $6445fa7f31ec0ca5$export$839f9183b0465a69 = v; });
$parcel$export(module.exports, "unstable_next", function () { return $6445fa7f31ec0ca5$export$72fdf0e06517287b; }, function (v) { return $6445fa7f31ec0ca5$export$72fdf0e06517287b = v; });
$parcel$export(module.exports, "unstable_pauseExecution", function () { return $6445fa7f31ec0ca5$export$4b844e58a3e414b4; }, function (v) { return $6445fa7f31ec0ca5$export$4b844e58a3e414b4 = v; });
$parcel$export(module.exports, "unstable_requestPaint", function () { return $6445fa7f31ec0ca5$export$816d2913ae6b83b1; }, function (v) { return $6445fa7f31ec0ca5$export$816d2913ae6b83b1 = v; });
$parcel$export(module.exports, "unstable_runWithPriority", function () { return $6445fa7f31ec0ca5$export$61bcfe829111a1d0; }, function (v) { return $6445fa7f31ec0ca5$export$61bcfe829111a1d0 = v; });
$parcel$export(module.exports, "unstable_scheduleCallback", function () { return $6445fa7f31ec0ca5$export$7ee8c9beb337bc3f; }, function (v) { return $6445fa7f31ec0ca5$export$7ee8c9beb337bc3f = v; });
$parcel$export(module.exports, "unstable_shouldYield", function () { return $6445fa7f31ec0ca5$export$b5836b71941fa3ed; }, function (v) { return $6445fa7f31ec0ca5$export$b5836b71941fa3ed = v; });
$parcel$export(module.exports, "unstable_wrapCallback", function () { return $6445fa7f31ec0ca5$export$cf845f2c119da08a; }, function (v) { return $6445fa7f31ec0ca5$export$cf845f2c119da08a = v; });
/**
 * @license React
 * scheduler.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $6445fa7f31ec0ca5$export$c4744153514ff05d;
var $6445fa7f31ec0ca5$export$3e506c1ccc9cc1a7;
var $6445fa7f31ec0ca5$export$e26fe2ed2fa76875;
var $6445fa7f31ec0ca5$export$502329bbf4b505b1;
var $6445fa7f31ec0ca5$export$6e3807111c4874c4;
var $6445fa7f31ec0ca5$export$c27134553091fb3a;
var $6445fa7f31ec0ca5$export$33ee1acdc04fd2a2;
var $6445fa7f31ec0ca5$export$b00a404bbd5edef2;
var $6445fa7f31ec0ca5$export$8352ce38b91d0c62;
var $6445fa7f31ec0ca5$export$d66a1c1c77bd778b;
var $6445fa7f31ec0ca5$export$d3dfb8e4810cb555;
var $6445fa7f31ec0ca5$export$839f9183b0465a69;
var $6445fa7f31ec0ca5$export$72fdf0e06517287b;
var $6445fa7f31ec0ca5$export$4b844e58a3e414b4;
var $6445fa7f31ec0ca5$export$816d2913ae6b83b1;
var $6445fa7f31ec0ca5$export$61bcfe829111a1d0;
var $6445fa7f31ec0ca5$export$7ee8c9beb337bc3f;
var $6445fa7f31ec0ca5$export$b5836b71941fa3ed;
var $6445fa7f31ec0ca5$export$cf845f2c119da08a;
"use strict";
function $6445fa7f31ec0ca5$var$f(a, b) {
    var c = a.length;
    a.push(b);
    a: for(; 0 < c;){
        var d = c - 1 >>> 1, e = a[d];
        if (0 < $6445fa7f31ec0ca5$var$g(e, b)) a[d] = b, a[c] = e, c = d;
        else break a;
    }
}
function $6445fa7f31ec0ca5$var$h(a) {
    return 0 === a.length ? null : a[0];
}
function $6445fa7f31ec0ca5$var$k(a) {
    if (0 === a.length) return null;
    var b = a[0], c = a.pop();
    if (c !== b) {
        a[0] = c;
        a: for(var d = 0, e = a.length, w = e >>> 1; d < w;){
            var m = 2 * (d + 1) - 1, C = a[m], n = m + 1, x = a[n];
            if (0 > $6445fa7f31ec0ca5$var$g(C, c)) n < e && 0 > $6445fa7f31ec0ca5$var$g(x, C) ? (a[d] = x, a[n] = c, d = n) : (a[d] = C, a[m] = c, d = m);
            else if (n < e && 0 > $6445fa7f31ec0ca5$var$g(x, c)) a[d] = x, a[n] = c, d = n;
            else break a;
        }
    }
    return b;
}
function $6445fa7f31ec0ca5$var$g(a, b) {
    var c = a.sortIndex - b.sortIndex;
    return 0 !== c ? c : a.id - b.id;
}
if ("object" === typeof performance && "function" === typeof performance.now) {
    var $6445fa7f31ec0ca5$var$l = performance;
    $6445fa7f31ec0ca5$export$c4744153514ff05d = function() {
        return $6445fa7f31ec0ca5$var$l.now();
    };
} else {
    var $6445fa7f31ec0ca5$var$p = Date, $6445fa7f31ec0ca5$var$q = $6445fa7f31ec0ca5$var$p.now();
    $6445fa7f31ec0ca5$export$c4744153514ff05d = function() {
        return $6445fa7f31ec0ca5$var$p.now() - $6445fa7f31ec0ca5$var$q;
    };
}
var $6445fa7f31ec0ca5$var$r = [], $6445fa7f31ec0ca5$var$t = [], $6445fa7f31ec0ca5$var$u = 1, $6445fa7f31ec0ca5$var$v = null, $6445fa7f31ec0ca5$var$y = 3, $6445fa7f31ec0ca5$var$z = !1, $6445fa7f31ec0ca5$var$A = !1, $6445fa7f31ec0ca5$var$B = !1, $6445fa7f31ec0ca5$var$D = "function" === typeof setTimeout ? setTimeout : null, $6445fa7f31ec0ca5$var$E = "function" === typeof clearTimeout ? clearTimeout : null, $6445fa7f31ec0ca5$var$F = "undefined" !== typeof setImmediate ? setImmediate : null;
"undefined" !== typeof navigator && void 0 !== navigator.scheduling && void 0 !== navigator.scheduling.isInputPending && navigator.scheduling.isInputPending.bind(navigator.scheduling);
function $6445fa7f31ec0ca5$var$G(a) {
    for(var b = $6445fa7f31ec0ca5$var$h($6445fa7f31ec0ca5$var$t); null !== b;){
        if (null === b.callback) $6445fa7f31ec0ca5$var$k($6445fa7f31ec0ca5$var$t);
        else if (b.startTime <= a) $6445fa7f31ec0ca5$var$k($6445fa7f31ec0ca5$var$t), b.sortIndex = b.expirationTime, $6445fa7f31ec0ca5$var$f($6445fa7f31ec0ca5$var$r, b);
        else break;
        b = $6445fa7f31ec0ca5$var$h($6445fa7f31ec0ca5$var$t);
    }
}
function $6445fa7f31ec0ca5$var$H(a) {
    $6445fa7f31ec0ca5$var$B = !1;
    $6445fa7f31ec0ca5$var$G(a);
    if (!$6445fa7f31ec0ca5$var$A) {
        if (null !== $6445fa7f31ec0ca5$var$h($6445fa7f31ec0ca5$var$r)) $6445fa7f31ec0ca5$var$A = !0, $6445fa7f31ec0ca5$var$I($6445fa7f31ec0ca5$var$J);
        else {
            var b = $6445fa7f31ec0ca5$var$h($6445fa7f31ec0ca5$var$t);
            null !== b && $6445fa7f31ec0ca5$var$K($6445fa7f31ec0ca5$var$H, b.startTime - a);
        }
    }
}
function $6445fa7f31ec0ca5$var$J(a, b) {
    $6445fa7f31ec0ca5$var$A = !1;
    $6445fa7f31ec0ca5$var$B && ($6445fa7f31ec0ca5$var$B = !1, $6445fa7f31ec0ca5$var$E($6445fa7f31ec0ca5$var$L), $6445fa7f31ec0ca5$var$L = -1);
    $6445fa7f31ec0ca5$var$z = !0;
    var c = $6445fa7f31ec0ca5$var$y;
    try {
        $6445fa7f31ec0ca5$var$G(b);
        for($6445fa7f31ec0ca5$var$v = $6445fa7f31ec0ca5$var$h($6445fa7f31ec0ca5$var$r); null !== $6445fa7f31ec0ca5$var$v && (!($6445fa7f31ec0ca5$var$v.expirationTime > b) || a && !$6445fa7f31ec0ca5$var$M());){
            var d = $6445fa7f31ec0ca5$var$v.callback;
            if ("function" === typeof d) {
                $6445fa7f31ec0ca5$var$v.callback = null;
                $6445fa7f31ec0ca5$var$y = $6445fa7f31ec0ca5$var$v.priorityLevel;
                var e = d($6445fa7f31ec0ca5$var$v.expirationTime <= b);
                b = $6445fa7f31ec0ca5$export$c4744153514ff05d();
                "function" === typeof e ? $6445fa7f31ec0ca5$var$v.callback = e : $6445fa7f31ec0ca5$var$v === $6445fa7f31ec0ca5$var$h($6445fa7f31ec0ca5$var$r) && $6445fa7f31ec0ca5$var$k($6445fa7f31ec0ca5$var$r);
                $6445fa7f31ec0ca5$var$G(b);
            } else $6445fa7f31ec0ca5$var$k($6445fa7f31ec0ca5$var$r);
            $6445fa7f31ec0ca5$var$v = $6445fa7f31ec0ca5$var$h($6445fa7f31ec0ca5$var$r);
        }
        if (null !== $6445fa7f31ec0ca5$var$v) var w = !0;
        else {
            var m = $6445fa7f31ec0ca5$var$h($6445fa7f31ec0ca5$var$t);
            null !== m && $6445fa7f31ec0ca5$var$K($6445fa7f31ec0ca5$var$H, m.startTime - b);
            w = !1;
        }
        return w;
    } finally{
        $6445fa7f31ec0ca5$var$v = null, $6445fa7f31ec0ca5$var$y = c, $6445fa7f31ec0ca5$var$z = !1;
    }
}
var $6445fa7f31ec0ca5$var$N = !1, $6445fa7f31ec0ca5$var$O = null, $6445fa7f31ec0ca5$var$L = -1, $6445fa7f31ec0ca5$var$P = 5, $6445fa7f31ec0ca5$var$Q = -1;
function $6445fa7f31ec0ca5$var$M() {
    return $6445fa7f31ec0ca5$export$c4744153514ff05d() - $6445fa7f31ec0ca5$var$Q < $6445fa7f31ec0ca5$var$P ? !1 : !0;
}
function $6445fa7f31ec0ca5$var$R() {
    if (null !== $6445fa7f31ec0ca5$var$O) {
        var a = $6445fa7f31ec0ca5$export$c4744153514ff05d();
        $6445fa7f31ec0ca5$var$Q = a;
        var b = !0;
        try {
            b = $6445fa7f31ec0ca5$var$O(!0, a);
        } finally{
            b ? $6445fa7f31ec0ca5$var$S() : ($6445fa7f31ec0ca5$var$N = !1, $6445fa7f31ec0ca5$var$O = null);
        }
    } else $6445fa7f31ec0ca5$var$N = !1;
}
var $6445fa7f31ec0ca5$var$S;
if ("function" === typeof $6445fa7f31ec0ca5$var$F) $6445fa7f31ec0ca5$var$S = function() {
    $6445fa7f31ec0ca5$var$F($6445fa7f31ec0ca5$var$R);
};
else if ("undefined" !== typeof MessageChannel) {
    var $6445fa7f31ec0ca5$var$T = new MessageChannel, $6445fa7f31ec0ca5$var$U = $6445fa7f31ec0ca5$var$T.port2;
    $6445fa7f31ec0ca5$var$T.port1.onmessage = $6445fa7f31ec0ca5$var$R;
    $6445fa7f31ec0ca5$var$S = function() {
        $6445fa7f31ec0ca5$var$U.postMessage(null);
    };
} else $6445fa7f31ec0ca5$var$S = function() {
    $6445fa7f31ec0ca5$var$D($6445fa7f31ec0ca5$var$R, 0);
};
function $6445fa7f31ec0ca5$var$I(a) {
    $6445fa7f31ec0ca5$var$O = a;
    $6445fa7f31ec0ca5$var$N || ($6445fa7f31ec0ca5$var$N = !0, $6445fa7f31ec0ca5$var$S());
}
function $6445fa7f31ec0ca5$var$K(a, b) {
    $6445fa7f31ec0ca5$var$L = $6445fa7f31ec0ca5$var$D(function() {
        a($6445fa7f31ec0ca5$export$c4744153514ff05d());
    }, b);
}
$6445fa7f31ec0ca5$export$3e506c1ccc9cc1a7 = 5;
$6445fa7f31ec0ca5$export$e26fe2ed2fa76875 = 1;
$6445fa7f31ec0ca5$export$502329bbf4b505b1 = 4;
$6445fa7f31ec0ca5$export$6e3807111c4874c4 = 3;
$6445fa7f31ec0ca5$export$c27134553091fb3a = null;
$6445fa7f31ec0ca5$export$33ee1acdc04fd2a2 = 2;
$6445fa7f31ec0ca5$export$b00a404bbd5edef2 = function(a) {
    a.callback = null;
};
$6445fa7f31ec0ca5$export$8352ce38b91d0c62 = function() {
    $6445fa7f31ec0ca5$var$A || $6445fa7f31ec0ca5$var$z || ($6445fa7f31ec0ca5$var$A = !0, $6445fa7f31ec0ca5$var$I($6445fa7f31ec0ca5$var$J));
};
$6445fa7f31ec0ca5$export$d66a1c1c77bd778b = function(a) {
    0 > a || 125 < a ? console.error("forceFrameRate takes a positive int between 0 and 125, forcing frame rates higher than 125 fps is not supported") : $6445fa7f31ec0ca5$var$P = 0 < a ? Math.floor(1E3 / a) : 5;
};
$6445fa7f31ec0ca5$export$d3dfb8e4810cb555 = function() {
    return $6445fa7f31ec0ca5$var$y;
};
$6445fa7f31ec0ca5$export$839f9183b0465a69 = function() {
    return $6445fa7f31ec0ca5$var$h($6445fa7f31ec0ca5$var$r);
};
$6445fa7f31ec0ca5$export$72fdf0e06517287b = function(a) {
    switch($6445fa7f31ec0ca5$var$y){
        case 1:
        case 2:
        case 3:
            var b = 3;
            break;
        default:
            b = $6445fa7f31ec0ca5$var$y;
    }
    var c = $6445fa7f31ec0ca5$var$y;
    $6445fa7f31ec0ca5$var$y = b;
    try {
        return a();
    } finally{
        $6445fa7f31ec0ca5$var$y = c;
    }
};
$6445fa7f31ec0ca5$export$4b844e58a3e414b4 = function() {};
$6445fa7f31ec0ca5$export$816d2913ae6b83b1 = function() {};
$6445fa7f31ec0ca5$export$61bcfe829111a1d0 = function(a, b) {
    switch(a){
        case 1:
        case 2:
        case 3:
        case 4:
        case 5:
            break;
        default:
            a = 3;
    }
    var c = $6445fa7f31ec0ca5$var$y;
    $6445fa7f31ec0ca5$var$y = a;
    try {
        return b();
    } finally{
        $6445fa7f31ec0ca5$var$y = c;
    }
};
$6445fa7f31ec0ca5$export$7ee8c9beb337bc3f = function(a, b, c) {
    var d = $6445fa7f31ec0ca5$export$c4744153514ff05d();
    "object" === typeof c && null !== c ? (c = c.delay, c = "number" === typeof c && 0 < c ? d + c : d) : c = d;
    switch(a){
        case 1:
            var e = -1;
            break;
        case 2:
            e = 250;
            break;
        case 5:
            e = 1073741823;
            break;
        case 4:
            e = 1E4;
            break;
        default:
            e = 5E3;
    }
    e = c + e;
    a = {
        id: $6445fa7f31ec0ca5$var$u++,
        callback: b,
        priorityLevel: a,
        startTime: c,
        expirationTime: e,
        sortIndex: -1
    };
    c > d ? (a.sortIndex = c, $6445fa7f31ec0ca5$var$f($6445fa7f31ec0ca5$var$t, a), null === $6445fa7f31ec0ca5$var$h($6445fa7f31ec0ca5$var$r) && a === $6445fa7f31ec0ca5$var$h($6445fa7f31ec0ca5$var$t) && ($6445fa7f31ec0ca5$var$B ? ($6445fa7f31ec0ca5$var$E($6445fa7f31ec0ca5$var$L), $6445fa7f31ec0ca5$var$L = -1) : $6445fa7f31ec0ca5$var$B = !0, $6445fa7f31ec0ca5$var$K($6445fa7f31ec0ca5$var$H, c - d))) : (a.sortIndex = e, $6445fa7f31ec0ca5$var$f($6445fa7f31ec0ca5$var$r, a), $6445fa7f31ec0ca5$var$A || $6445fa7f31ec0ca5$var$z || ($6445fa7f31ec0ca5$var$A = !0, $6445fa7f31ec0ca5$var$I($6445fa7f31ec0ca5$var$J)));
    return a;
};
$6445fa7f31ec0ca5$export$b5836b71941fa3ed = $6445fa7f31ec0ca5$var$M;
$6445fa7f31ec0ca5$export$cf845f2c119da08a = function(a) {
    var b = $6445fa7f31ec0ca5$var$y;
    return function() {
        var c = $6445fa7f31ec0ca5$var$y;
        $6445fa7f31ec0ca5$var$y = b;
        try {
            return a.apply(this, arguments);
        } finally{
            $6445fa7f31ec0ca5$var$y = c;
        }
    };
};

});



parcelRegister("2tbKl", function(module, exports) {
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ "use strict";

var $c3YnH = parcelRequire("c3YnH");
function $1cc766ccf0672393$var$emptyFunction() {}
function $1cc766ccf0672393$var$emptyFunctionWithReset() {}
$1cc766ccf0672393$var$emptyFunctionWithReset.resetWarningCache = $1cc766ccf0672393$var$emptyFunction;
module.exports = function() {
    function shim(props, propName, componentName, location, propFullName, secret) {
        if (secret === $c3YnH) // It is still safe when called from React.
        return;
        var err = new Error("Calling PropTypes validators directly is not supported by the `prop-types` package. Use PropTypes.checkPropTypes() to call them. Read more at http://fb.me/use-check-prop-types");
        err.name = "Invariant Violation";
        throw err;
    }
    shim.isRequired = shim;
    function getShim() {
        return shim;
    }
    // Important!
    // Keep this list in sync with production version in `./factoryWithTypeCheckers.js`.
    var ReactPropTypes = {
        array: shim,
        bigint: shim,
        bool: shim,
        func: shim,
        number: shim,
        object: shim,
        string: shim,
        symbol: shim,
        any: shim,
        arrayOf: getShim,
        element: shim,
        elementType: shim,
        instanceOf: getShim,
        node: shim,
        objectOf: getShim,
        oneOf: getShim,
        oneOfType: getShim,
        shape: getShim,
        exact: getShim,
        checkPropTypes: $1cc766ccf0672393$var$emptyFunctionWithReset,
        resetWarningCache: $1cc766ccf0672393$var$emptyFunction
    };
    ReactPropTypes.PropTypes = ReactPropTypes;
    return ReactPropTypes;
};

});
parcelRegister("c3YnH", function(module, exports) {
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ "use strict";
var $8c849a51633fc8b0$var$ReactPropTypesSecret = "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED";
module.exports = $8c849a51633fc8b0$var$ReactPropTypesSecret;

});


var $d4dab640dcbe486c$exports = {};
"use strict";

$d4dab640dcbe486c$exports = (parcelRequire("0qhf8"));


parcelRequire("bh6RR");
var $6fc264ec92100d3a$exports = {};

$parcel$export($6fc264ec92100d3a$exports, "createRoot", function () { return $6fc264ec92100d3a$export$882461b6382ed46c; }, function (v) { return $6fc264ec92100d3a$export$882461b6382ed46c = v; });
$parcel$export($6fc264ec92100d3a$exports, "hydrateRoot", function () { return $6fc264ec92100d3a$export$757ceba2d55c277e; }, function (v) { return $6fc264ec92100d3a$export$757ceba2d55c277e = v; });
var $6fc264ec92100d3a$export$882461b6382ed46c;
var $6fc264ec92100d3a$export$757ceba2d55c277e;
"use strict";
var $47cfd4084854a574$exports = {};
"use strict";
function $47cfd4084854a574$var$checkDCE() {
    /* global __REACT_DEVTOOLS_GLOBAL_HOOK__ */ if (typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ === "undefined" || typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE !== "function") return;
    try {
        // Verify that the code above has been dead code eliminated (DCE'd).
        __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE($47cfd4084854a574$var$checkDCE);
    } catch (err) {
        // DevTools shouldn't crash React, no matter what.
        // We should still report in case we break this code.
        console.error(err);
    }
}
// DCE check should happen before ReactDOM bundle executes so that
// DevTools can report bad minification during injection.
$47cfd4084854a574$var$checkDCE();

$47cfd4084854a574$exports = (parcelRequire("foRq4"));


var $6fc264ec92100d3a$var$i;
$6fc264ec92100d3a$export$882461b6382ed46c = $47cfd4084854a574$exports.createRoot;
$6fc264ec92100d3a$export$757ceba2d55c277e = $47cfd4084854a574$exports.hydrateRoot;



parcelRequire("bh6RR");
/******************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */ /* global Reflect, Promise, SuppressedError, Symbol */ var $f5ed4ab2a4d1861b$var$extendStatics = function(d, b) {
    $f5ed4ab2a4d1861b$var$extendStatics = Object.setPrototypeOf || ({
        __proto__: []
    }) instanceof Array && function(d, b) {
        d.__proto__ = b;
    } || function(d, b) {
        for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
    };
    return $f5ed4ab2a4d1861b$var$extendStatics(d, b);
};
function $f5ed4ab2a4d1861b$export$a8ba968b8961cb8a(d, b) {
    if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
    $f5ed4ab2a4d1861b$var$extendStatics(d, b);
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
}
var $f5ed4ab2a4d1861b$export$18ce0697a983be9b = function() {
    $f5ed4ab2a4d1861b$export$18ce0697a983be9b = Object.assign || function __assign(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $f5ed4ab2a4d1861b$export$18ce0697a983be9b.apply(this, arguments);
};
function $f5ed4ab2a4d1861b$export$3c9a16f847548506(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
}
function $f5ed4ab2a4d1861b$export$29e00dfd3077644b(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
}
function $f5ed4ab2a4d1861b$export$d5ad3fd78186038f(paramIndex, decorator) {
    return function(target, key) {
        decorator(target, key, paramIndex);
    };
}
function $f5ed4ab2a4d1861b$export$3a84e1ae4e97e9b0(ctor, descriptorIn, decorators, contextIn, initializers, extraInitializers) {
    function accept(f) {
        if (f !== void 0 && typeof f !== "function") throw new TypeError("Function expected");
        return f;
    }
    var kind = contextIn.kind, key = kind === "getter" ? "get" : kind === "setter" ? "set" : "value";
    var target = !descriptorIn && ctor ? contextIn["static"] ? ctor : ctor.prototype : null;
    var descriptor = descriptorIn || (target ? Object.getOwnPropertyDescriptor(target, contextIn.name) : {});
    var _, done = false;
    for(var i = decorators.length - 1; i >= 0; i--){
        var context = {};
        for(var p in contextIn)context[p] = p === "access" ? {} : contextIn[p];
        for(var p in contextIn.access)context.access[p] = contextIn.access[p];
        context.addInitializer = function(f) {
            if (done) throw new TypeError("Cannot add initializers after decoration has completed");
            extraInitializers.push(accept(f || null));
        };
        var result = (0, decorators[i])(kind === "accessor" ? {
            get: descriptor.get,
            set: descriptor.set
        } : descriptor[key], context);
        if (kind === "accessor") {
            if (result === void 0) continue;
            if (result === null || typeof result !== "object") throw new TypeError("Object expected");
            if (_ = accept(result.get)) descriptor.get = _;
            if (_ = accept(result.set)) descriptor.set = _;
            if (_ = accept(result.init)) initializers.unshift(_);
        } else if (_ = accept(result)) {
            if (kind === "field") initializers.unshift(_);
            else descriptor[key] = _;
        }
    }
    if (target) Object.defineProperty(target, contextIn.name, descriptor);
    done = true;
}
function $f5ed4ab2a4d1861b$export$d831c04e792af3d(thisArg, initializers, value) {
    var useValue = arguments.length > 2;
    for(var i = 0; i < initializers.length; i++)value = useValue ? initializers[i].call(thisArg, value) : initializers[i].call(thisArg);
    return useValue ? value : void 0;
}
function $f5ed4ab2a4d1861b$export$6a2a36740a146cb8(x) {
    return typeof x === "symbol" ? x : "".concat(x);
}
function $f5ed4ab2a4d1861b$export$d1a06452d3489bc7(f, name, prefix) {
    if (typeof name === "symbol") name = name.description ? "[".concat(name.description, "]") : "";
    return Object.defineProperty(f, "name", {
        configurable: true,
        value: prefix ? "".concat(prefix, " ", name) : name
    });
}
function $f5ed4ab2a4d1861b$export$f1db080c865becb9(metadataKey, metadataValue) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(metadataKey, metadataValue);
}
function $f5ed4ab2a4d1861b$export$1050f835b63b671e(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
}
function $f5ed4ab2a4d1861b$export$67ebef60e6f28a6(thisArg, body) {
    var _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g;
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(g && (g = 0, op[0] && (_ = 0)), _)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
}
var $f5ed4ab2a4d1861b$export$45d3717a4c69092e = Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
};
function $f5ed4ab2a4d1861b$export$f33643c0debef087(m, o) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(o, p)) $f5ed4ab2a4d1861b$export$45d3717a4c69092e(o, m, p);
}
function $f5ed4ab2a4d1861b$export$19a8beecd37a4c45(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function() {
            if (o && i >= o.length) o = void 0;
            return {
                value: o && o[i++],
                done: !o
            };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
}
function $f5ed4ab2a4d1861b$export$8d051b38c9118094(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while((n === void 0 || n-- > 0) && !(r = i.next()).done)ar.push(r.value);
    } catch (error) {
        e = {
            error: error
        };
    } finally{
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        } finally{
            if (e) throw e.error;
        }
    }
    return ar;
}
function $f5ed4ab2a4d1861b$export$afc72e2116322959() {
    for(var ar = [], i = 0; i < arguments.length; i++)ar = ar.concat($f5ed4ab2a4d1861b$export$8d051b38c9118094(arguments[i]));
    return ar;
}
function $f5ed4ab2a4d1861b$export$6388937ca91ccae8() {
    for(var s = 0, i = 0, il = arguments.length; i < il; i++)s += arguments[i].length;
    for(var r = Array(s), k = 0, i = 0; i < il; i++)for(var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)r[k] = a[j];
    return r;
}
function $f5ed4ab2a4d1861b$export$1216008129fb82ed(to, from, pack) {
    if (pack || arguments.length === 2) {
        for(var i = 0, l = from.length, ar; i < l; i++)if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
}
function $f5ed4ab2a4d1861b$export$10c90e4f7922046c(v) {
    return this instanceof $f5ed4ab2a4d1861b$export$10c90e4f7922046c ? (this.v = v, this) : new $f5ed4ab2a4d1861b$export$10c90e4f7922046c(v);
}
function $f5ed4ab2a4d1861b$export$e427f37a30a4de9b(thisArg, _arguments, generator) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var g = generator.apply(thisArg, _arguments || []), i, q = [];
    return i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function() {
        return this;
    }, i;
    function verb(n) {
        if (g[n]) i[n] = function(v) {
            return new Promise(function(a, b) {
                q.push([
                    n,
                    v,
                    a,
                    b
                ]) > 1 || resume(n, v);
            });
        };
    }
    function resume(n, v) {
        try {
            step(g[n](v));
        } catch (e) {
            settle(q[0][3], e);
        }
    }
    function step(r) {
        r.value instanceof $f5ed4ab2a4d1861b$export$10c90e4f7922046c ? Promise.resolve(r.value.v).then(fulfill, reject) : settle(q[0][2], r);
    }
    function fulfill(value) {
        resume("next", value);
    }
    function reject(value) {
        resume("throw", value);
    }
    function settle(f, v) {
        if (f(v), q.shift(), q.length) resume(q[0][0], q[0][1]);
    }
}
function $f5ed4ab2a4d1861b$export$bbd80228419bb833(o) {
    var i, p;
    return i = {}, verb("next"), verb("throw", function(e) {
        throw e;
    }), verb("return"), i[Symbol.iterator] = function() {
        return this;
    }, i;
    function verb(n, f) {
        i[n] = o[n] ? function(v) {
            return (p = !p) ? {
                value: $f5ed4ab2a4d1861b$export$10c90e4f7922046c(o[n](v)),
                done: false
            } : f ? f(v) : v;
        } : f;
    }
}
function $f5ed4ab2a4d1861b$export$e3b29a3d6162315f(o) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var m = o[Symbol.asyncIterator], i;
    return m ? m.call(o) : (o = typeof $f5ed4ab2a4d1861b$export$19a8beecd37a4c45 === "function" ? $f5ed4ab2a4d1861b$export$19a8beecd37a4c45(o) : o[Symbol.iterator](), i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function() {
        return this;
    }, i);
    function verb(n) {
        i[n] = o[n] && function(v) {
            return new Promise(function(resolve, reject) {
                v = o[n](v), settle(resolve, reject, v.done, v.value);
            });
        };
    }
    function settle(resolve, reject, d, v) {
        Promise.resolve(v).then(function(v) {
            resolve({
                value: v,
                done: d
            });
        }, reject);
    }
}
function $f5ed4ab2a4d1861b$export$4fb47efe1390b86f(cooked, raw) {
    if (Object.defineProperty) Object.defineProperty(cooked, "raw", {
        value: raw
    });
    else cooked.raw = raw;
    return cooked;
}
var $f5ed4ab2a4d1861b$var$__setModuleDefault = Object.create ? function(o, v) {
    Object.defineProperty(o, "default", {
        enumerable: true,
        value: v
    });
} : function(o, v) {
    o["default"] = v;
};
function $f5ed4ab2a4d1861b$export$c21735bcef00d192(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k in mod)if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) $f5ed4ab2a4d1861b$export$45d3717a4c69092e(result, mod, k);
    }
    $f5ed4ab2a4d1861b$var$__setModuleDefault(result, mod);
    return result;
}
function $f5ed4ab2a4d1861b$export$da59b14a69baef04(mod) {
    return mod && mod.__esModule ? mod : {
        default: mod
    };
}
function $f5ed4ab2a4d1861b$export$d5dcaf168c640c35(receiver, state, kind, f) {
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a getter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
    return kind === "m" ? f : kind === "a" ? f.call(receiver) : f ? f.value : state.get(receiver);
}
function $f5ed4ab2a4d1861b$export$d40a35129aaff81f(receiver, state, value, kind, f) {
    if (kind === "m") throw new TypeError("Private method is not writable");
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a setter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot write private member to an object whose class did not declare it");
    return kind === "a" ? f.call(receiver, value) : f ? f.value = value : state.set(receiver, value), value;
}
function $f5ed4ab2a4d1861b$export$81fdc39f203e4e04(state, receiver) {
    if (receiver === null || typeof receiver !== "object" && typeof receiver !== "function") throw new TypeError("Cannot use 'in' operator on non-object");
    return typeof state === "function" ? receiver === state : state.has(receiver);
}
function $f5ed4ab2a4d1861b$export$88ac25d8e944e405(env, value, async) {
    if (value !== null && value !== void 0) {
        if (typeof value !== "object" && typeof value !== "function") throw new TypeError("Object expected.");
        var dispose;
        if (async) {
            if (!Symbol.asyncDispose) throw new TypeError("Symbol.asyncDispose is not defined.");
            dispose = value[Symbol.asyncDispose];
        }
        if (dispose === void 0) {
            if (!Symbol.dispose) throw new TypeError("Symbol.dispose is not defined.");
            dispose = value[Symbol.dispose];
        }
        if (typeof dispose !== "function") throw new TypeError("Object not disposable.");
        env.stack.push({
            value: value,
            dispose: dispose,
            async: async
        });
    } else if (async) env.stack.push({
        async: true
    });
    return value;
}
var $f5ed4ab2a4d1861b$var$_SuppressedError = typeof SuppressedError === "function" ? SuppressedError : function(error, suppressed, message) {
    var e = new Error(message);
    return e.name = "SuppressedError", e.error = error, e.suppressed = suppressed, e;
};
function $f5ed4ab2a4d1861b$export$8f076105dc360e92(env) {
    function fail(e) {
        env.error = env.hasError ? new $f5ed4ab2a4d1861b$var$_SuppressedError(e, env.error, "An error was suppressed during disposal.") : e;
        env.hasError = true;
    }
    function next() {
        while(env.stack.length){
            var rec = env.stack.pop();
            try {
                var result = rec.dispose && rec.dispose.call(rec.value);
                if (rec.async) return Promise.resolve(result).then(next, function(e) {
                    fail(e);
                    return next();
                });
            } catch (e) {
                fail(e);
            }
        }
        if (env.hasError) throw env.error;
    }
    return next();
}
var $f5ed4ab2a4d1861b$export$2e2bcd8739ae039 = {
    __extends: $f5ed4ab2a4d1861b$export$a8ba968b8961cb8a,
    __assign: $f5ed4ab2a4d1861b$export$18ce0697a983be9b,
    __rest: $f5ed4ab2a4d1861b$export$3c9a16f847548506,
    __decorate: $f5ed4ab2a4d1861b$export$29e00dfd3077644b,
    __param: $f5ed4ab2a4d1861b$export$d5ad3fd78186038f,
    __metadata: $f5ed4ab2a4d1861b$export$f1db080c865becb9,
    __awaiter: $f5ed4ab2a4d1861b$export$1050f835b63b671e,
    __generator: $f5ed4ab2a4d1861b$export$67ebef60e6f28a6,
    __createBinding: $f5ed4ab2a4d1861b$export$45d3717a4c69092e,
    __exportStar: $f5ed4ab2a4d1861b$export$f33643c0debef087,
    __values: $f5ed4ab2a4d1861b$export$19a8beecd37a4c45,
    __read: $f5ed4ab2a4d1861b$export$8d051b38c9118094,
    __spread: $f5ed4ab2a4d1861b$export$afc72e2116322959,
    __spreadArrays: $f5ed4ab2a4d1861b$export$6388937ca91ccae8,
    __spreadArray: $f5ed4ab2a4d1861b$export$1216008129fb82ed,
    __await: $f5ed4ab2a4d1861b$export$10c90e4f7922046c,
    __asyncGenerator: $f5ed4ab2a4d1861b$export$e427f37a30a4de9b,
    __asyncDelegator: $f5ed4ab2a4d1861b$export$bbd80228419bb833,
    __asyncValues: $f5ed4ab2a4d1861b$export$e3b29a3d6162315f,
    __makeTemplateObject: $f5ed4ab2a4d1861b$export$4fb47efe1390b86f,
    __importStar: $f5ed4ab2a4d1861b$export$c21735bcef00d192,
    __importDefault: $f5ed4ab2a4d1861b$export$da59b14a69baef04,
    __classPrivateFieldGet: $f5ed4ab2a4d1861b$export$d5dcaf168c640c35,
    __classPrivateFieldSet: $f5ed4ab2a4d1861b$export$d40a35129aaff81f,
    __classPrivateFieldIn: $f5ed4ab2a4d1861b$export$81fdc39f203e4e04,
    __addDisposableResource: $f5ed4ab2a4d1861b$export$88ac25d8e944e405,
    __disposeResources: $f5ed4ab2a4d1861b$export$8f076105dc360e92
};


function $9145dbf8e0e857b1$export$2e2bcd8739ae039(fn) {
    var cache = Object.create(null);
    return function(arg) {
        if (cache[arg] === undefined) cache[arg] = fn(arg);
        return cache[arg];
    };
}


var $a4c525d7dbc25949$var$reactPropsRegex = /^((children|dangerouslySetInnerHTML|key|ref|autoFocus|defaultValue|defaultChecked|innerHTML|suppressContentEditableWarning|suppressHydrationWarning|valueLink|abbr|accept|acceptCharset|accessKey|action|allow|allowUserMedia|allowPaymentRequest|allowFullScreen|allowTransparency|alt|async|autoComplete|autoPlay|capture|cellPadding|cellSpacing|challenge|charSet|checked|cite|classID|className|cols|colSpan|content|contentEditable|contextMenu|controls|controlsList|coords|crossOrigin|data|dateTime|decoding|default|defer|dir|disabled|disablePictureInPicture|disableRemotePlayback|download|draggable|encType|enterKeyHint|form|formAction|formEncType|formMethod|formNoValidate|formTarget|frameBorder|headers|height|hidden|high|href|hrefLang|htmlFor|httpEquiv|id|inputMode|integrity|is|keyParams|keyType|kind|label|lang|list|loading|loop|low|marginHeight|marginWidth|max|maxLength|media|mediaGroup|method|min|minLength|multiple|muted|name|nonce|noValidate|open|optimum|pattern|placeholder|playsInline|poster|preload|profile|radioGroup|readOnly|referrerPolicy|rel|required|reversed|role|rows|rowSpan|sandbox|scope|scoped|scrolling|seamless|selected|shape|size|sizes|slot|span|spellCheck|src|srcDoc|srcLang|srcSet|start|step|style|summary|tabIndex|target|title|translate|type|useMap|value|width|wmode|wrap|about|datatype|inlist|prefix|property|resource|typeof|vocab|autoCapitalize|autoCorrect|autoSave|color|incremental|fallback|inert|itemProp|itemScope|itemType|itemID|itemRef|on|option|results|security|unselectable|accentHeight|accumulate|additive|alignmentBaseline|allowReorder|alphabetic|amplitude|arabicForm|ascent|attributeName|attributeType|autoReverse|azimuth|baseFrequency|baselineShift|baseProfile|bbox|begin|bias|by|calcMode|capHeight|clip|clipPathUnits|clipPath|clipRule|colorInterpolation|colorInterpolationFilters|colorProfile|colorRendering|contentScriptType|contentStyleType|cursor|cx|cy|d|decelerate|descent|diffuseConstant|direction|display|divisor|dominantBaseline|dur|dx|dy|edgeMode|elevation|enableBackground|end|exponent|externalResourcesRequired|fill|fillOpacity|fillRule|filter|filterRes|filterUnits|floodColor|floodOpacity|focusable|fontFamily|fontSize|fontSizeAdjust|fontStretch|fontStyle|fontVariant|fontWeight|format|from|fr|fx|fy|g1|g2|glyphName|glyphOrientationHorizontal|glyphOrientationVertical|glyphRef|gradientTransform|gradientUnits|hanging|horizAdvX|horizOriginX|ideographic|imageRendering|in|in2|intercept|k|k1|k2|k3|k4|kernelMatrix|kernelUnitLength|kerning|keyPoints|keySplines|keyTimes|lengthAdjust|letterSpacing|lightingColor|limitingConeAngle|local|markerEnd|markerMid|markerStart|markerHeight|markerUnits|markerWidth|mask|maskContentUnits|maskUnits|mathematical|mode|numOctaves|offset|opacity|operator|order|orient|orientation|origin|overflow|overlinePosition|overlineThickness|panose1|paintOrder|pathLength|patternContentUnits|patternTransform|patternUnits|pointerEvents|points|pointsAtX|pointsAtY|pointsAtZ|preserveAlpha|preserveAspectRatio|primitiveUnits|r|radius|refX|refY|renderingIntent|repeatCount|repeatDur|requiredExtensions|requiredFeatures|restart|result|rotate|rx|ry|scale|seed|shapeRendering|slope|spacing|specularConstant|specularExponent|speed|spreadMethod|startOffset|stdDeviation|stemh|stemv|stitchTiles|stopColor|stopOpacity|strikethroughPosition|strikethroughThickness|string|stroke|strokeDasharray|strokeDashoffset|strokeLinecap|strokeLinejoin|strokeMiterlimit|strokeOpacity|strokeWidth|surfaceScale|systemLanguage|tableValues|targetX|targetY|textAnchor|textDecoration|textRendering|textLength|to|transform|u1|u2|underlinePosition|underlineThickness|unicode|unicodeBidi|unicodeRange|unitsPerEm|vAlphabetic|vHanging|vIdeographic|vMathematical|values|vectorEffect|version|vertAdvY|vertOriginX|vertOriginY|viewBox|viewTarget|visibility|widths|wordSpacing|writingMode|x|xHeight|x1|x2|xChannelSelector|xlinkActuate|xlinkArcrole|xlinkHref|xlinkRole|xlinkShow|xlinkTitle|xlinkType|xmlBase|xmlns|xmlnsXlink|xmlLang|xmlSpace|y|y1|y2|yChannelSelector|z|zoomAndPan|for|class|autofocus)|(([Dd][Aa][Tt][Aa]|[Aa][Rr][Ii][Aa]|x)-.*))$/; // https://esbench.com/bench/5bfee68a4cd7e6009ef61d23
var $a4c525d7dbc25949$export$2e2bcd8739ae039 = /* #__PURE__ */ (0, $9145dbf8e0e857b1$export$2e2bcd8739ae039)(function(prop) {
    return $a4c525d7dbc25949$var$reactPropsRegex.test(prop) || prop.charCodeAt(0) === 111 && prop.charCodeAt(1) === 110 && prop.charCodeAt(2) < 91;
});



var $bh6RR = parcelRequire("bh6RR");
var $53a106364dbd0a1b$exports = {};
//
$53a106364dbd0a1b$exports = function shallowEqual(objA, objB, compare, compareContext) {
    var ret = compare ? compare.call(compareContext, objA, objB) : void 0;
    if (ret !== void 0) return !!ret;
    if (objA === objB) return true;
    if (typeof objA !== "object" || !objA || typeof objB !== "object" || !objB) return false;
    var keysA = Object.keys(objA);
    var keysB = Object.keys(objB);
    if (keysA.length !== keysB.length) return false;
    var bHasOwnProperty = Object.prototype.hasOwnProperty.bind(objB);
    // Test for A's keys different from B.
    for(var idx = 0; idx < keysA.length; idx++){
        var key = keysA[idx];
        if (!bHasOwnProperty(key)) return false;
        var valueA = objA[key];
        var valueB = objB[key];
        ret = compare ? compare.call(compareContext, valueA, valueB, key) : void 0;
        if (ret === false || ret === void 0 && valueA !== valueB) return false;
    }
    return true;
};


var $783faa7ec18221fc$export$71ad59f2e432cfe8 = "-ms-";
var $783faa7ec18221fc$export$2c0f367103c8d01c = "-moz-";
var $783faa7ec18221fc$export$39dfd62a25e0fe93 = "-webkit-";
var $783faa7ec18221fc$export$a29989082612d0d9 = "comm";
var $783faa7ec18221fc$export$aa3a2e812ca8570d = "rule";
var $783faa7ec18221fc$export$527d108ccf083c2b = "decl";
var $783faa7ec18221fc$export$d3d35020fa5b54f0 = "@page";
var $783faa7ec18221fc$export$500415a86c544f73 = "@media";
var $783faa7ec18221fc$export$a763edbf796b780a = "@import";
var $783faa7ec18221fc$export$2790aeb8b4e5c826 = "@charset";
var $783faa7ec18221fc$export$1cc683e23b84b133 = "@viewport";
var $783faa7ec18221fc$export$9447a5efea57e862 = "@supports";
var $783faa7ec18221fc$export$ef011b4e114b1fba = "@document";
var $783faa7ec18221fc$export$6aad947bda0f3f46 = "@namespace";
var $783faa7ec18221fc$export$b44a8529a35fcb60 = "@keyframes";
var $783faa7ec18221fc$export$2c16de31893252e6 = "@font-face";
var $783faa7ec18221fc$export$3d846dd52e150c6f = "@counter-style";
var $783faa7ec18221fc$export$22314bfbb57653fe = "@font-feature-values";
var $783faa7ec18221fc$export$d773506282b3cfe6 = "@layer";
var $783faa7ec18221fc$export$1c5a554c78c0cd12 = "@scope";
var $783faa7ec18221fc$export$2335f513bbd82c6d = Math.abs;
var $783faa7ec18221fc$export$6788812c4e6611e6 = String.fromCharCode;
var $783faa7ec18221fc$export$e6e34fd1f2686227 = Object.assign;
function $783faa7ec18221fc$export$d6af199866bfb566(e, r) {
    return $783faa7ec18221fc$export$a9db5e087081082d(e, 0) ^ 45 ? (((r << 2 ^ $783faa7ec18221fc$export$a9db5e087081082d(e, 0)) << 2 ^ $783faa7ec18221fc$export$a9db5e087081082d(e, 1)) << 2 ^ $783faa7ec18221fc$export$a9db5e087081082d(e, 2)) << 2 ^ $783faa7ec18221fc$export$a9db5e087081082d(e, 3) : 0;
}
function $783faa7ec18221fc$export$87c2784dc9fc4ab(e) {
    return e.trim();
}
function $783faa7ec18221fc$export$4659b591c19bdf3d(e, r) {
    return (e = r.exec(e)) ? e[0] : e;
}
function $783faa7ec18221fc$export$77ad94ebf1c2b9ed(e, r, a) {
    return e.replace(r, a);
}
function $783faa7ec18221fc$export$f8e21b1e77979a08(e, r, a) {
    return e.indexOf(r, a);
}
function $783faa7ec18221fc$export$a9db5e087081082d(e, r) {
    return e.charCodeAt(r) | 0;
}
function $783faa7ec18221fc$export$2f35ab04d2335697(e, r, a) {
    return e.slice(r, a);
}
function $783faa7ec18221fc$export$36776f635604f274(e) {
    return e.length;
}
function $783faa7ec18221fc$export$f9084667e487ed46(e) {
    return e.length;
}
function $783faa7ec18221fc$export$10d8903dec122b9d(e, r) {
    return r.push(e), e;
}
function $783faa7ec18221fc$export$1be1fc439b849fdf(e, r) {
    return e.map(r).join("");
}
function $783faa7ec18221fc$export$3dea766d36a8935f(e, r) {
    return e.filter(function(e) {
        return !$783faa7ec18221fc$export$4659b591c19bdf3d(e, r);
    });
}
var $783faa7ec18221fc$export$53f1d5ea8de3d7c = 1;
var $783faa7ec18221fc$export$4e0c71f277ca26b3 = 1;
var $783faa7ec18221fc$export$f24224f1c91d8156 = 0;
var $783faa7ec18221fc$export$5880b8b5730aff45 = 0;
var $783faa7ec18221fc$export$c0306caf338ac095 = 0;
var $783faa7ec18221fc$export$30a86d91af8ff6e6 = "";
function $783faa7ec18221fc$export$35059013cd4a06db(e, r, a, n, c, s, t, u) {
    return {
        value: e,
        root: r,
        parent: a,
        type: n,
        props: c,
        children: s,
        line: $783faa7ec18221fc$export$53f1d5ea8de3d7c,
        column: $783faa7ec18221fc$export$4e0c71f277ca26b3,
        length: t,
        return: "",
        siblings: u
    };
}
function $783faa7ec18221fc$export$784d13d8ee351f07(e, r) {
    return $783faa7ec18221fc$export$e6e34fd1f2686227($783faa7ec18221fc$export$35059013cd4a06db("", null, null, "", null, null, 0, e.siblings), e, {
        length: -e.length
    }, r);
}
function $783faa7ec18221fc$export$590e8b2c435046d9(e) {
    while(e.root)e = $783faa7ec18221fc$export$784d13d8ee351f07(e.root, {
        children: [
            e
        ]
    });
    $783faa7ec18221fc$export$10d8903dec122b9d(e, e.siblings);
}
function $783faa7ec18221fc$export$eba6f6f03b0a92e7() {
    return $783faa7ec18221fc$export$c0306caf338ac095;
}
function $783faa7ec18221fc$export$232faf9add678146() {
    $783faa7ec18221fc$export$c0306caf338ac095 = $783faa7ec18221fc$export$5880b8b5730aff45 > 0 ? $783faa7ec18221fc$export$a9db5e087081082d($783faa7ec18221fc$export$30a86d91af8ff6e6, --$783faa7ec18221fc$export$5880b8b5730aff45) : 0;
    if ($783faa7ec18221fc$export$4e0c71f277ca26b3--, $783faa7ec18221fc$export$c0306caf338ac095 === 10) $783faa7ec18221fc$export$4e0c71f277ca26b3 = 1, $783faa7ec18221fc$export$53f1d5ea8de3d7c--;
    return $783faa7ec18221fc$export$c0306caf338ac095;
}
function $783faa7ec18221fc$export$48cfd1e771a65c4f() {
    $783faa7ec18221fc$export$c0306caf338ac095 = $783faa7ec18221fc$export$5880b8b5730aff45 < $783faa7ec18221fc$export$f24224f1c91d8156 ? $783faa7ec18221fc$export$a9db5e087081082d($783faa7ec18221fc$export$30a86d91af8ff6e6, $783faa7ec18221fc$export$5880b8b5730aff45++) : 0;
    if ($783faa7ec18221fc$export$4e0c71f277ca26b3++, $783faa7ec18221fc$export$c0306caf338ac095 === 10) $783faa7ec18221fc$export$4e0c71f277ca26b3 = 1, $783faa7ec18221fc$export$53f1d5ea8de3d7c++;
    return $783faa7ec18221fc$export$c0306caf338ac095;
}
function $783faa7ec18221fc$export$4d3fb11e950abb9e() {
    return $783faa7ec18221fc$export$a9db5e087081082d($783faa7ec18221fc$export$30a86d91af8ff6e6, $783faa7ec18221fc$export$5880b8b5730aff45);
}
function $783faa7ec18221fc$export$e88cb2efb12ae807() {
    return $783faa7ec18221fc$export$5880b8b5730aff45;
}
function $783faa7ec18221fc$export$58adb3bec8346d0f(e, r) {
    return $783faa7ec18221fc$export$2f35ab04d2335697($783faa7ec18221fc$export$30a86d91af8ff6e6, e, r);
}
function $783faa7ec18221fc$export$9e1725a4cfeada27(e) {
    switch(e){
        case 0:
        case 9:
        case 10:
        case 13:
        case 32:
            return 5;
        case 33:
        case 43:
        case 44:
        case 47:
        case 62:
        case 64:
        case 126:
        case 59:
        case 123:
        case 125:
            return 4;
        case 58:
            return 3;
        case 34:
        case 39:
        case 40:
        case 91:
            return 2;
        case 41:
        case 93:
            return 1;
    }
    return 0;
}
function $783faa7ec18221fc$export$2de70f21292aac9e(e) {
    return $783faa7ec18221fc$export$53f1d5ea8de3d7c = $783faa7ec18221fc$export$4e0c71f277ca26b3 = 1, $783faa7ec18221fc$export$f24224f1c91d8156 = $783faa7ec18221fc$export$36776f635604f274($783faa7ec18221fc$export$30a86d91af8ff6e6 = e), $783faa7ec18221fc$export$5880b8b5730aff45 = 0, [];
}
function $783faa7ec18221fc$export$45918ac1574455b1(e) {
    return $783faa7ec18221fc$export$30a86d91af8ff6e6 = "", e;
}
function $783faa7ec18221fc$export$410ac95b9ec204b8(e) {
    return $783faa7ec18221fc$export$87c2784dc9fc4ab($783faa7ec18221fc$export$58adb3bec8346d0f($783faa7ec18221fc$export$5880b8b5730aff45 - 1, $783faa7ec18221fc$export$c889f2fcc19dbf12(e === 91 ? e + 2 : e === 40 ? e + 1 : e)));
}
function $783faa7ec18221fc$export$660b2ee2d4fb4eff(e) {
    return $783faa7ec18221fc$export$45918ac1574455b1($783faa7ec18221fc$export$5f8c09e3ae6f64e1($783faa7ec18221fc$export$2de70f21292aac9e(e)));
}
function $783faa7ec18221fc$export$7af1228ff777d175(e) {
    while($783faa7ec18221fc$export$c0306caf338ac095 = $783faa7ec18221fc$export$4d3fb11e950abb9e())if ($783faa7ec18221fc$export$c0306caf338ac095 < 33) $783faa7ec18221fc$export$48cfd1e771a65c4f();
    else break;
    return $783faa7ec18221fc$export$9e1725a4cfeada27(e) > 2 || $783faa7ec18221fc$export$9e1725a4cfeada27($783faa7ec18221fc$export$c0306caf338ac095) > 3 ? "" : " ";
}
function $783faa7ec18221fc$export$5f8c09e3ae6f64e1(e) {
    while($783faa7ec18221fc$export$48cfd1e771a65c4f())switch($783faa7ec18221fc$export$9e1725a4cfeada27($783faa7ec18221fc$export$c0306caf338ac095)){
        case 0:
            $783faa7ec18221fc$export$10d8903dec122b9d($783faa7ec18221fc$export$c2ab62c7bf24634($783faa7ec18221fc$export$5880b8b5730aff45 - 1), e);
            break;
        case 2:
            $783faa7ec18221fc$export$10d8903dec122b9d($783faa7ec18221fc$export$410ac95b9ec204b8($783faa7ec18221fc$export$c0306caf338ac095), e);
            break;
        default:
            $783faa7ec18221fc$export$10d8903dec122b9d($783faa7ec18221fc$export$6788812c4e6611e6($783faa7ec18221fc$export$c0306caf338ac095), e);
    }
    return e;
}
function $783faa7ec18221fc$export$955ba06d119e085e(e, r) {
    while(--r && $783faa7ec18221fc$export$48cfd1e771a65c4f())if ($783faa7ec18221fc$export$c0306caf338ac095 < 48 || $783faa7ec18221fc$export$c0306caf338ac095 > 102 || $783faa7ec18221fc$export$c0306caf338ac095 > 57 && $783faa7ec18221fc$export$c0306caf338ac095 < 65 || $783faa7ec18221fc$export$c0306caf338ac095 > 70 && $783faa7ec18221fc$export$c0306caf338ac095 < 97) break;
    return $783faa7ec18221fc$export$58adb3bec8346d0f(e, $783faa7ec18221fc$export$e88cb2efb12ae807() + (r < 6 && $783faa7ec18221fc$export$4d3fb11e950abb9e() == 32 && $783faa7ec18221fc$export$48cfd1e771a65c4f() == 32));
}
function $783faa7ec18221fc$export$c889f2fcc19dbf12(e) {
    while($783faa7ec18221fc$export$48cfd1e771a65c4f())switch($783faa7ec18221fc$export$c0306caf338ac095){
        case e:
            return $783faa7ec18221fc$export$5880b8b5730aff45;
        case 34:
        case 39:
            if (e !== 34 && e !== 39) $783faa7ec18221fc$export$c889f2fcc19dbf12($783faa7ec18221fc$export$c0306caf338ac095);
            break;
        case 40:
            if (e === 41) $783faa7ec18221fc$export$c889f2fcc19dbf12(e);
            break;
        case 92:
            $783faa7ec18221fc$export$48cfd1e771a65c4f();
            break;
    }
    return $783faa7ec18221fc$export$5880b8b5730aff45;
}
function $783faa7ec18221fc$export$4254d4e2b3745c4c(e, r) {
    while($783faa7ec18221fc$export$48cfd1e771a65c4f())if (e + $783faa7ec18221fc$export$c0306caf338ac095 === 57) break;
    else if (e + $783faa7ec18221fc$export$c0306caf338ac095 === 84 && $783faa7ec18221fc$export$4d3fb11e950abb9e() === 47) break;
    return "/*" + $783faa7ec18221fc$export$58adb3bec8346d0f(r, $783faa7ec18221fc$export$5880b8b5730aff45 - 1) + "*" + $783faa7ec18221fc$export$6788812c4e6611e6(e === 47 ? e : $783faa7ec18221fc$export$48cfd1e771a65c4f());
}
function $783faa7ec18221fc$export$c2ab62c7bf24634(e) {
    while(!$783faa7ec18221fc$export$9e1725a4cfeada27($783faa7ec18221fc$export$4d3fb11e950abb9e()))$783faa7ec18221fc$export$48cfd1e771a65c4f();
    return $783faa7ec18221fc$export$58adb3bec8346d0f(e, $783faa7ec18221fc$export$5880b8b5730aff45);
}
function $783faa7ec18221fc$export$ef7acd7185315e22(e) {
    return $783faa7ec18221fc$export$45918ac1574455b1($783faa7ec18221fc$export$98e6a39c04603d36("", null, null, null, [
        ""
    ], e = $783faa7ec18221fc$export$2de70f21292aac9e(e), 0, [
        0
    ], e));
}
function $783faa7ec18221fc$export$98e6a39c04603d36(e, r, a, n, c, s, t, u, i) {
    var f = 0;
    var o = 0;
    var l = t;
    var v = 0;
    var p = 0;
    var h = 0;
    var b = 1;
    var w = 1;
    var d = 1;
    var g = 0;
    var k = "";
    var x = c;
    var y = s;
    var j = n;
    var z = k;
    while(w)switch(h = g, g = $783faa7ec18221fc$export$48cfd1e771a65c4f()){
        case 40:
            if (h != 108 && $783faa7ec18221fc$export$a9db5e087081082d(z, l - 1) == 58) {
                if ($783faa7ec18221fc$export$f8e21b1e77979a08(z += $783faa7ec18221fc$export$77ad94ebf1c2b9ed($783faa7ec18221fc$export$410ac95b9ec204b8(g), "&", "&\f"), "&\f", $783faa7ec18221fc$export$2335f513bbd82c6d(f ? u[f - 1] : 0)) != -1) d = -1;
                break;
            }
        case 34:
        case 39:
        case 91:
            z += $783faa7ec18221fc$export$410ac95b9ec204b8(g);
            break;
        case 9:
        case 10:
        case 13:
        case 32:
            z += $783faa7ec18221fc$export$7af1228ff777d175(h);
            break;
        case 92:
            z += $783faa7ec18221fc$export$955ba06d119e085e($783faa7ec18221fc$export$e88cb2efb12ae807() - 1, 7);
            continue;
        case 47:
            switch($783faa7ec18221fc$export$4d3fb11e950abb9e()){
                case 42:
                case 47:
                    $783faa7ec18221fc$export$10d8903dec122b9d($783faa7ec18221fc$export$4a34f930e789283c($783faa7ec18221fc$export$4254d4e2b3745c4c($783faa7ec18221fc$export$48cfd1e771a65c4f(), $783faa7ec18221fc$export$e88cb2efb12ae807()), r, a, i), i);
                    break;
                default:
                    z += "/";
            }
            break;
        case 123 * b:
            u[f++] = $783faa7ec18221fc$export$36776f635604f274(z) * d;
        case 125 * b:
        case 59:
        case 0:
            switch(g){
                case 0:
                case 125:
                    w = 0;
                case 59 + o:
                    if (d == -1) z = $783faa7ec18221fc$export$77ad94ebf1c2b9ed(z, /\f/g, "");
                    if (p > 0 && $783faa7ec18221fc$export$36776f635604f274(z) - l) $783faa7ec18221fc$export$10d8903dec122b9d(p > 32 ? $783faa7ec18221fc$export$f8483753829ec8f3(z + ";", n, a, l - 1, i) : $783faa7ec18221fc$export$f8483753829ec8f3($783faa7ec18221fc$export$77ad94ebf1c2b9ed(z, " ", "") + ";", n, a, l - 2, i), i);
                    break;
                case 59:
                    z += ";";
                default:
                    $783faa7ec18221fc$export$10d8903dec122b9d(j = $783faa7ec18221fc$export$3307ffa7023ede1e(z, r, a, f, o, c, u, k, x = [], y = [], l, s), s);
                    if (g === 123) {
                        if (o === 0) $783faa7ec18221fc$export$98e6a39c04603d36(z, r, j, j, x, s, l, u, y);
                        else switch(v === 99 && $783faa7ec18221fc$export$a9db5e087081082d(z, 3) === 110 ? 100 : v){
                            case 100:
                            case 108:
                            case 109:
                            case 115:
                                $783faa7ec18221fc$export$98e6a39c04603d36(e, j, j, n && $783faa7ec18221fc$export$10d8903dec122b9d($783faa7ec18221fc$export$3307ffa7023ede1e(e, j, j, 0, 0, c, u, k, c, x = [], l, y), y), c, y, l, u, n ? x : y);
                                break;
                            default:
                                $783faa7ec18221fc$export$98e6a39c04603d36(z, j, j, j, [
                                    ""
                                ], y, 0, u, y);
                        }
                    }
            }
            f = o = p = 0, b = d = 1, k = z = "", l = t;
            break;
        case 58:
            l = 1 + $783faa7ec18221fc$export$36776f635604f274(z), p = h;
        default:
            if (b < 1) {
                if (g == 123) --b;
                else if (g == 125 && b++ == 0 && $783faa7ec18221fc$export$232faf9add678146() == 125) continue;
            }
            switch(z += $783faa7ec18221fc$export$6788812c4e6611e6(g), g * b){
                case 38:
                    d = o > 0 ? 1 : (z += "\f", -1);
                    break;
                case 44:
                    u[f++] = ($783faa7ec18221fc$export$36776f635604f274(z) - 1) * d, d = 1;
                    break;
                case 64:
                    if ($783faa7ec18221fc$export$4d3fb11e950abb9e() === 45) z += $783faa7ec18221fc$export$410ac95b9ec204b8($783faa7ec18221fc$export$48cfd1e771a65c4f());
                    v = $783faa7ec18221fc$export$4d3fb11e950abb9e(), o = l = $783faa7ec18221fc$export$36776f635604f274(k = z += $783faa7ec18221fc$export$c2ab62c7bf24634($783faa7ec18221fc$export$e88cb2efb12ae807())), g++;
                    break;
                case 45:
                    if (h === 45 && $783faa7ec18221fc$export$36776f635604f274(z) == 2) b = 0;
            }
    }
    return s;
}
function $783faa7ec18221fc$export$3307ffa7023ede1e(e, r, a, n, s, t, u, i, f, o, l, v) {
    var p = s - 1;
    var h = s === 0 ? t : [
        ""
    ];
    var b = $783faa7ec18221fc$export$f9084667e487ed46(h);
    for(var w = 0, d = 0, g = 0; w < n; ++w)for(var k = 0, m = $783faa7ec18221fc$export$2f35ab04d2335697(e, p + 1, p = $783faa7ec18221fc$export$2335f513bbd82c6d(d = u[w])), x = e; k < b; ++k)if (x = $783faa7ec18221fc$export$87c2784dc9fc4ab(d > 0 ? h[k] + " " + m : $783faa7ec18221fc$export$77ad94ebf1c2b9ed(m, /&\f/g, h[k]))) f[g++] = x;
    return $783faa7ec18221fc$export$35059013cd4a06db(e, r, a, s === 0 ? $783faa7ec18221fc$export$aa3a2e812ca8570d : i, f, o, l, v);
}
function $783faa7ec18221fc$export$4a34f930e789283c(e, r, a, c) {
    return $783faa7ec18221fc$export$35059013cd4a06db(e, r, a, $783faa7ec18221fc$export$a29989082612d0d9, $783faa7ec18221fc$export$6788812c4e6611e6($783faa7ec18221fc$export$eba6f6f03b0a92e7()), $783faa7ec18221fc$export$2f35ab04d2335697(e, 2, -2), 0, c);
}
function $783faa7ec18221fc$export$f8483753829ec8f3(e, r, a, n, c) {
    return $783faa7ec18221fc$export$35059013cd4a06db(e, r, a, $783faa7ec18221fc$export$527d108ccf083c2b, $783faa7ec18221fc$export$2f35ab04d2335697(e, 0, n), $783faa7ec18221fc$export$2f35ab04d2335697(e, n + 1, -1), n, c);
}
function $783faa7ec18221fc$export$82e9f45cca5ba907(n, c, s) {
    switch($783faa7ec18221fc$export$d6af199866bfb566(n, c)){
        case 5103:
            return $783faa7ec18221fc$export$39dfd62a25e0fe93 + "print-" + n + n;
        case 5737:
        case 4201:
        case 3177:
        case 3433:
        case 1641:
        case 4457:
        case 2921:
        case 5572:
        case 6356:
        case 5844:
        case 3191:
        case 6645:
        case 3005:
        case 6391:
        case 5879:
        case 5623:
        case 6135:
        case 4599:
        case 4855:
        case 4215:
        case 6389:
        case 5109:
        case 5365:
        case 5621:
        case 3829:
            return $783faa7ec18221fc$export$39dfd62a25e0fe93 + n + n;
        case 4789:
            return $783faa7ec18221fc$export$2c0f367103c8d01c + n + n;
        case 5349:
        case 4246:
        case 4810:
        case 6968:
        case 2756:
            return $783faa7ec18221fc$export$39dfd62a25e0fe93 + n + $783faa7ec18221fc$export$2c0f367103c8d01c + n + $783faa7ec18221fc$export$71ad59f2e432cfe8 + n + n;
        case 5936:
            switch($783faa7ec18221fc$export$a9db5e087081082d(n, c + 11)){
                case 114:
                    return $783faa7ec18221fc$export$39dfd62a25e0fe93 + n + $783faa7ec18221fc$export$71ad59f2e432cfe8 + $783faa7ec18221fc$export$77ad94ebf1c2b9ed(n, /[svh]\w+-[tblr]{2}/, "tb") + n;
                case 108:
                    return $783faa7ec18221fc$export$39dfd62a25e0fe93 + n + $783faa7ec18221fc$export$71ad59f2e432cfe8 + $783faa7ec18221fc$export$77ad94ebf1c2b9ed(n, /[svh]\w+-[tblr]{2}/, "tb-rl") + n;
                case 45:
                    return $783faa7ec18221fc$export$39dfd62a25e0fe93 + n + $783faa7ec18221fc$export$71ad59f2e432cfe8 + $783faa7ec18221fc$export$77ad94ebf1c2b9ed(n, /[svh]\w+-[tblr]{2}/, "lr") + n;
            }
        case 6828:
        case 4268:
        case 2903:
            return $783faa7ec18221fc$export$39dfd62a25e0fe93 + n + $783faa7ec18221fc$export$71ad59f2e432cfe8 + n + n;
        case 6165:
            return $783faa7ec18221fc$export$39dfd62a25e0fe93 + n + $783faa7ec18221fc$export$71ad59f2e432cfe8 + "flex-" + n + n;
        case 5187:
            return $783faa7ec18221fc$export$39dfd62a25e0fe93 + n + $783faa7ec18221fc$export$77ad94ebf1c2b9ed(n, /(\w+).+(:[^]+)/, $783faa7ec18221fc$export$39dfd62a25e0fe93 + "box-$1$2" + $783faa7ec18221fc$export$71ad59f2e432cfe8 + "flex-$1$2") + n;
        case 5443:
            return $783faa7ec18221fc$export$39dfd62a25e0fe93 + n + $783faa7ec18221fc$export$71ad59f2e432cfe8 + "flex-item-" + $783faa7ec18221fc$export$77ad94ebf1c2b9ed(n, /flex-|-self/g, "") + (!$783faa7ec18221fc$export$4659b591c19bdf3d(n, /flex-|baseline/) ? $783faa7ec18221fc$export$71ad59f2e432cfe8 + "grid-row-" + $783faa7ec18221fc$export$77ad94ebf1c2b9ed(n, /flex-|-self/g, "") : "") + n;
        case 4675:
            return $783faa7ec18221fc$export$39dfd62a25e0fe93 + n + $783faa7ec18221fc$export$71ad59f2e432cfe8 + "flex-line-pack" + $783faa7ec18221fc$export$77ad94ebf1c2b9ed(n, /align-content|flex-|-self/g, "") + n;
        case 5548:
            return $783faa7ec18221fc$export$39dfd62a25e0fe93 + n + $783faa7ec18221fc$export$71ad59f2e432cfe8 + $783faa7ec18221fc$export$77ad94ebf1c2b9ed(n, "shrink", "negative") + n;
        case 5292:
            return $783faa7ec18221fc$export$39dfd62a25e0fe93 + n + $783faa7ec18221fc$export$71ad59f2e432cfe8 + $783faa7ec18221fc$export$77ad94ebf1c2b9ed(n, "basis", "preferred-size") + n;
        case 6060:
            return $783faa7ec18221fc$export$39dfd62a25e0fe93 + "box-" + $783faa7ec18221fc$export$77ad94ebf1c2b9ed(n, "-grow", "") + $783faa7ec18221fc$export$39dfd62a25e0fe93 + n + $783faa7ec18221fc$export$71ad59f2e432cfe8 + $783faa7ec18221fc$export$77ad94ebf1c2b9ed(n, "grow", "positive") + n;
        case 4554:
            return $783faa7ec18221fc$export$39dfd62a25e0fe93 + $783faa7ec18221fc$export$77ad94ebf1c2b9ed(n, /([^-])(transform)/g, "$1" + $783faa7ec18221fc$export$39dfd62a25e0fe93 + "$2") + n;
        case 6187:
            return $783faa7ec18221fc$export$77ad94ebf1c2b9ed($783faa7ec18221fc$export$77ad94ebf1c2b9ed($783faa7ec18221fc$export$77ad94ebf1c2b9ed(n, /(zoom-|grab)/, $783faa7ec18221fc$export$39dfd62a25e0fe93 + "$1"), /(image-set)/, $783faa7ec18221fc$export$39dfd62a25e0fe93 + "$1"), n, "") + n;
        case 5495:
        case 3959:
            return $783faa7ec18221fc$export$77ad94ebf1c2b9ed(n, /(image-set\([^]*)/, $783faa7ec18221fc$export$39dfd62a25e0fe93 + "$1" + "$`$1");
        case 4968:
            return $783faa7ec18221fc$export$77ad94ebf1c2b9ed($783faa7ec18221fc$export$77ad94ebf1c2b9ed(n, /(.+:)(flex-)?(.*)/, $783faa7ec18221fc$export$39dfd62a25e0fe93 + "box-pack:$3" + $783faa7ec18221fc$export$71ad59f2e432cfe8 + "flex-pack:$3"), /s.+-b[^;]+/, "justify") + $783faa7ec18221fc$export$39dfd62a25e0fe93 + n + n;
        case 4200:
            if (!$783faa7ec18221fc$export$4659b591c19bdf3d(n, /flex-|baseline/)) return $783faa7ec18221fc$export$71ad59f2e432cfe8 + "grid-column-align" + $783faa7ec18221fc$export$2f35ab04d2335697(n, c) + n;
            break;
        case 2592:
        case 3360:
            return $783faa7ec18221fc$export$71ad59f2e432cfe8 + $783faa7ec18221fc$export$77ad94ebf1c2b9ed(n, "template-", "") + n;
        case 4384:
        case 3616:
            if (s && s.some(function(e, r) {
                return c = r, $783faa7ec18221fc$export$4659b591c19bdf3d(e.props, /grid-\w+-end/);
            })) return ~$783faa7ec18221fc$export$f8e21b1e77979a08(n + (s = s[c].value), "span", 0) ? n : $783faa7ec18221fc$export$71ad59f2e432cfe8 + $783faa7ec18221fc$export$77ad94ebf1c2b9ed(n, "-start", "") + n + $783faa7ec18221fc$export$71ad59f2e432cfe8 + "grid-row-span:" + (~$783faa7ec18221fc$export$f8e21b1e77979a08(s, "span", 0) ? $783faa7ec18221fc$export$4659b591c19bdf3d(s, /\d+/) : +$783faa7ec18221fc$export$4659b591c19bdf3d(s, /\d+/) - +$783faa7ec18221fc$export$4659b591c19bdf3d(n, /\d+/)) + ";";
            return $783faa7ec18221fc$export$71ad59f2e432cfe8 + $783faa7ec18221fc$export$77ad94ebf1c2b9ed(n, "-start", "") + n;
        case 4896:
        case 4128:
            return s && s.some(function(e) {
                return $783faa7ec18221fc$export$4659b591c19bdf3d(e.props, /grid-\w+-start/);
            }) ? n : $783faa7ec18221fc$export$71ad59f2e432cfe8 + $783faa7ec18221fc$export$77ad94ebf1c2b9ed($783faa7ec18221fc$export$77ad94ebf1c2b9ed(n, "-end", "-span"), "span ", "") + n;
        case 4095:
        case 3583:
        case 4068:
        case 2532:
            return $783faa7ec18221fc$export$77ad94ebf1c2b9ed(n, /(.+)-inline(.+)/, $783faa7ec18221fc$export$39dfd62a25e0fe93 + "$1$2") + n;
        case 8116:
        case 7059:
        case 5753:
        case 5535:
        case 5445:
        case 5701:
        case 4933:
        case 4677:
        case 5533:
        case 5789:
        case 5021:
        case 4765:
            if ($783faa7ec18221fc$export$36776f635604f274(n) - 1 - c > 6) switch($783faa7ec18221fc$export$a9db5e087081082d(n, c + 1)){
                case 109:
                    if ($783faa7ec18221fc$export$a9db5e087081082d(n, c + 4) !== 45) break;
                case 102:
                    return $783faa7ec18221fc$export$77ad94ebf1c2b9ed(n, /(.+:)(.+)-([^]+)/, "$1" + $783faa7ec18221fc$export$39dfd62a25e0fe93 + "$2-$3" + "$1" + $783faa7ec18221fc$export$2c0f367103c8d01c + ($783faa7ec18221fc$export$a9db5e087081082d(n, c + 3) == 108 ? "$3" : "$2-$3")) + n;
                case 115:
                    return ~$783faa7ec18221fc$export$f8e21b1e77979a08(n, "stretch", 0) ? $783faa7ec18221fc$export$82e9f45cca5ba907($783faa7ec18221fc$export$77ad94ebf1c2b9ed(n, "stretch", "fill-available"), c, s) + n : n;
            }
            break;
        case 5152:
        case 5920:
            return $783faa7ec18221fc$export$77ad94ebf1c2b9ed(n, /(.+?):(\d+)(\s*\/\s*(span)?\s*(\d+))?(.*)/, function(r, a, c, s, t, u, i) {
                return $783faa7ec18221fc$export$71ad59f2e432cfe8 + a + ":" + c + i + (s ? $783faa7ec18221fc$export$71ad59f2e432cfe8 + a + "-span:" + (t ? u : +u - +c) + i : "") + n;
            });
        case 4949:
            if ($783faa7ec18221fc$export$a9db5e087081082d(n, c + 6) === 121) return $783faa7ec18221fc$export$77ad94ebf1c2b9ed(n, ":", ":" + $783faa7ec18221fc$export$39dfd62a25e0fe93) + n;
            break;
        case 6444:
            switch($783faa7ec18221fc$export$a9db5e087081082d(n, $783faa7ec18221fc$export$a9db5e087081082d(n, 14) === 45 ? 18 : 11)){
                case 120:
                    return $783faa7ec18221fc$export$77ad94ebf1c2b9ed(n, /(.+:)([^;\s!]+)(;|(\s+)?!.+)?/, "$1" + $783faa7ec18221fc$export$39dfd62a25e0fe93 + ($783faa7ec18221fc$export$a9db5e087081082d(n, 14) === 45 ? "inline-" : "") + "box$3" + "$1" + $783faa7ec18221fc$export$39dfd62a25e0fe93 + "$2$3" + "$1" + $783faa7ec18221fc$export$71ad59f2e432cfe8 + "$2box$3") + n;
                case 100:
                    return $783faa7ec18221fc$export$77ad94ebf1c2b9ed(n, ":", ":" + $783faa7ec18221fc$export$71ad59f2e432cfe8) + n;
            }
            break;
        case 5719:
        case 2647:
        case 2135:
        case 3927:
        case 2391:
            return $783faa7ec18221fc$export$77ad94ebf1c2b9ed(n, "scroll-", "scroll-snap-") + n;
    }
    return n;
}
function $783faa7ec18221fc$export$dfdc1655ccc5b9cb(e, r) {
    var a = "";
    for(var n = 0; n < e.length; n++)a += r(e[n], n, e, r) || "";
    return a;
}
function $783faa7ec18221fc$export$fac44ee5b035f737(e, r, a, t) {
    switch(e.type){
        case $783faa7ec18221fc$export$d773506282b3cfe6:
            if (e.children.length) break;
        case $783faa7ec18221fc$export$a763edbf796b780a:
        case $783faa7ec18221fc$export$527d108ccf083c2b:
            return e.return = e.return || e.value;
        case $783faa7ec18221fc$export$a29989082612d0d9:
            return "";
        case $783faa7ec18221fc$export$b44a8529a35fcb60:
            return e.return = e.value + "{" + $783faa7ec18221fc$export$dfdc1655ccc5b9cb(e.children, t) + "}";
        case $783faa7ec18221fc$export$aa3a2e812ca8570d:
            if (!$783faa7ec18221fc$export$36776f635604f274(e.value = e.props.join(","))) return "";
    }
    return $783faa7ec18221fc$export$36776f635604f274(a = $783faa7ec18221fc$export$dfdc1655ccc5b9cb(e.children, t)) ? e.return = e.value + "{" + a + "}" : "";
}
function $783faa7ec18221fc$export$5a7767152ae0305f(e) {
    var r = $783faa7ec18221fc$export$f9084667e487ed46(e);
    return function(a, n, c, s) {
        var t = "";
        for(var u = 0; u < r; u++)t += e[u](a, n, c, s) || "";
        return t;
    };
}
function $783faa7ec18221fc$export$38bcb760f1d4871c(e) {
    return function(r) {
        if (!r.root) {
            if (r = r.return) e(r);
        }
    };
}
function $783faa7ec18221fc$export$e08c7d021b829b7a(n, t, u, i) {
    if (n.length > -1) {
        if (!n.return) switch(n.type){
            case $783faa7ec18221fc$export$527d108ccf083c2b:
                n.return = $783faa7ec18221fc$export$82e9f45cca5ba907(n.value, n.length, u);
                return;
            case $783faa7ec18221fc$export$b44a8529a35fcb60:
                return $783faa7ec18221fc$export$dfdc1655ccc5b9cb([
                    $783faa7ec18221fc$export$784d13d8ee351f07(n, {
                        value: $783faa7ec18221fc$export$77ad94ebf1c2b9ed(n.value, "@", "@" + $783faa7ec18221fc$export$39dfd62a25e0fe93)
                    })
                ], i);
            case $783faa7ec18221fc$export$aa3a2e812ca8570d:
                if (n.length) return $783faa7ec18221fc$export$1be1fc439b849fdf(u = n.props, function(c) {
                    switch($783faa7ec18221fc$export$4659b591c19bdf3d(c, i = /(::plac\w+|:read-\w+)/)){
                        case ":read-only":
                        case ":read-write":
                            $783faa7ec18221fc$export$590e8b2c435046d9($783faa7ec18221fc$export$784d13d8ee351f07(n, {
                                props: [
                                    $783faa7ec18221fc$export$77ad94ebf1c2b9ed(c, /:(read-\w+)/, ":" + $783faa7ec18221fc$export$2c0f367103c8d01c + "$1")
                                ]
                            }));
                            $783faa7ec18221fc$export$590e8b2c435046d9($783faa7ec18221fc$export$784d13d8ee351f07(n, {
                                props: [
                                    c
                                ]
                            }));
                            $783faa7ec18221fc$export$e6e34fd1f2686227(n, {
                                props: $783faa7ec18221fc$export$3dea766d36a8935f(u, i)
                            });
                            break;
                        case "::placeholder":
                            $783faa7ec18221fc$export$590e8b2c435046d9($783faa7ec18221fc$export$784d13d8ee351f07(n, {
                                props: [
                                    $783faa7ec18221fc$export$77ad94ebf1c2b9ed(c, /:(plac\w+)/, ":" + $783faa7ec18221fc$export$39dfd62a25e0fe93 + "input-$1")
                                ]
                            }));
                            $783faa7ec18221fc$export$590e8b2c435046d9($783faa7ec18221fc$export$784d13d8ee351f07(n, {
                                props: [
                                    $783faa7ec18221fc$export$77ad94ebf1c2b9ed(c, /:(plac\w+)/, ":" + $783faa7ec18221fc$export$2c0f367103c8d01c + "$1")
                                ]
                            }));
                            $783faa7ec18221fc$export$590e8b2c435046d9($783faa7ec18221fc$export$784d13d8ee351f07(n, {
                                props: [
                                    $783faa7ec18221fc$export$77ad94ebf1c2b9ed(c, /:(plac\w+)/, $783faa7ec18221fc$export$71ad59f2e432cfe8 + "input-$1")
                                ]
                            }));
                            $783faa7ec18221fc$export$590e8b2c435046d9($783faa7ec18221fc$export$784d13d8ee351f07(n, {
                                props: [
                                    c
                                ]
                            }));
                            $783faa7ec18221fc$export$e6e34fd1f2686227(n, {
                                props: $783faa7ec18221fc$export$3dea766d36a8935f(u, i)
                            });
                            break;
                    }
                    return "";
                });
        }
    }
}
function $783faa7ec18221fc$export$76a88f7de6507443(e) {
    switch(e.type){
        case $783faa7ec18221fc$export$aa3a2e812ca8570d:
            e.props = e.props.map(function(r) {
                return $783faa7ec18221fc$export$1be1fc439b849fdf($783faa7ec18221fc$export$660b2ee2d4fb4eff(r), function(r, a, n) {
                    switch($783faa7ec18221fc$export$a9db5e087081082d(r, 0)){
                        case 12:
                            return $783faa7ec18221fc$export$2f35ab04d2335697(r, 1, $783faa7ec18221fc$export$36776f635604f274(r));
                        case 0:
                        case 40:
                        case 43:
                        case 62:
                        case 126:
                            return r;
                        case 58:
                            if (n[++a] === "global") n[a] = "", n[++a] = "\f" + $783faa7ec18221fc$export$2f35ab04d2335697(n[a], a = 1, -1);
                        case 32:
                            return a === 1 ? "" : r;
                        default:
                            switch(a){
                                case 0:
                                    e = r;
                                    return $783faa7ec18221fc$export$f9084667e487ed46(n) > 1 ? "" : r;
                                case a = $783faa7ec18221fc$export$f9084667e487ed46(n) - 1:
                                case 2:
                                    return a === 2 ? r + e + e : r + e;
                                default:
                                    return r;
                            }
                    }
                });
            });
    }
}


var $78b52bced097bc64$export$2e2bcd8739ae039 = {
    animationIterationCount: 1,
    aspectRatio: 1,
    borderImageOutset: 1,
    borderImageSlice: 1,
    borderImageWidth: 1,
    boxFlex: 1,
    boxFlexGroup: 1,
    boxOrdinalGroup: 1,
    columnCount: 1,
    columns: 1,
    flex: 1,
    flexGrow: 1,
    flexPositive: 1,
    flexShrink: 1,
    flexNegative: 1,
    flexOrder: 1,
    gridRow: 1,
    gridRowEnd: 1,
    gridRowSpan: 1,
    gridRowStart: 1,
    gridColumn: 1,
    gridColumnEnd: 1,
    gridColumnSpan: 1,
    gridColumnStart: 1,
    msGridRow: 1,
    msGridRowSpan: 1,
    msGridColumn: 1,
    msGridColumnSpan: 1,
    fontWeight: 1,
    lineHeight: 1,
    opacity: 1,
    order: 1,
    orphans: 1,
    tabSize: 1,
    widows: 1,
    zIndex: 1,
    zoom: 1,
    WebkitLineClamp: 1,
    // SVG-related properties
    fillOpacity: 1,
    floodOpacity: 1,
    stopOpacity: 1,
    strokeDasharray: 1,
    strokeDashoffset: 1,
    strokeMiterlimit: 1,
    strokeOpacity: 1,
    strokeWidth: 1
};


var $391299e0893a3dfa$exports = {};
// shim for using process in browser
var $391299e0893a3dfa$var$process = $391299e0893a3dfa$exports = {};
// cached from whatever global is present so that test runners that stub it
// don't break things.  But we need to wrap it in a try catch in case it is
// wrapped in strict mode code which doesn't define any globals.  It's inside a
// function because try/catches deoptimize in certain engines.
var $391299e0893a3dfa$var$cachedSetTimeout;
var $391299e0893a3dfa$var$cachedClearTimeout;
function $391299e0893a3dfa$var$defaultSetTimout() {
    throw new Error("setTimeout has not been defined");
}
function $391299e0893a3dfa$var$defaultClearTimeout() {
    throw new Error("clearTimeout has not been defined");
}
(function() {
    try {
        if (typeof setTimeout === "function") $391299e0893a3dfa$var$cachedSetTimeout = setTimeout;
        else $391299e0893a3dfa$var$cachedSetTimeout = $391299e0893a3dfa$var$defaultSetTimout;
    } catch (e) {
        $391299e0893a3dfa$var$cachedSetTimeout = $391299e0893a3dfa$var$defaultSetTimout;
    }
    try {
        if (typeof clearTimeout === "function") $391299e0893a3dfa$var$cachedClearTimeout = clearTimeout;
        else $391299e0893a3dfa$var$cachedClearTimeout = $391299e0893a3dfa$var$defaultClearTimeout;
    } catch (e) {
        $391299e0893a3dfa$var$cachedClearTimeout = $391299e0893a3dfa$var$defaultClearTimeout;
    }
})();
function $391299e0893a3dfa$var$runTimeout(fun) {
    if ($391299e0893a3dfa$var$cachedSetTimeout === setTimeout) //normal enviroments in sane situations
    return setTimeout(fun, 0);
    // if setTimeout wasn't available but was latter defined
    if (($391299e0893a3dfa$var$cachedSetTimeout === $391299e0893a3dfa$var$defaultSetTimout || !$391299e0893a3dfa$var$cachedSetTimeout) && setTimeout) {
        $391299e0893a3dfa$var$cachedSetTimeout = setTimeout;
        return setTimeout(fun, 0);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return $391299e0893a3dfa$var$cachedSetTimeout(fun, 0);
    } catch (e) {
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't trust the global object when called normally
            return $391299e0893a3dfa$var$cachedSetTimeout.call(null, fun, 0);
        } catch (e) {
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error
            return $391299e0893a3dfa$var$cachedSetTimeout.call(this, fun, 0);
        }
    }
}
function $391299e0893a3dfa$var$runClearTimeout(marker) {
    if ($391299e0893a3dfa$var$cachedClearTimeout === clearTimeout) //normal enviroments in sane situations
    return clearTimeout(marker);
    // if clearTimeout wasn't available but was latter defined
    if (($391299e0893a3dfa$var$cachedClearTimeout === $391299e0893a3dfa$var$defaultClearTimeout || !$391299e0893a3dfa$var$cachedClearTimeout) && clearTimeout) {
        $391299e0893a3dfa$var$cachedClearTimeout = clearTimeout;
        return clearTimeout(marker);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return $391299e0893a3dfa$var$cachedClearTimeout(marker);
    } catch (e) {
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't  trust the global object when called normally
            return $391299e0893a3dfa$var$cachedClearTimeout.call(null, marker);
        } catch (e) {
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error.
            // Some versions of I.E. have different rules for clearTimeout vs setTimeout
            return $391299e0893a3dfa$var$cachedClearTimeout.call(this, marker);
        }
    }
}
var $391299e0893a3dfa$var$queue = [];
var $391299e0893a3dfa$var$draining = false;
var $391299e0893a3dfa$var$currentQueue;
var $391299e0893a3dfa$var$queueIndex = -1;
function $391299e0893a3dfa$var$cleanUpNextTick() {
    if (!$391299e0893a3dfa$var$draining || !$391299e0893a3dfa$var$currentQueue) return;
    $391299e0893a3dfa$var$draining = false;
    if ($391299e0893a3dfa$var$currentQueue.length) $391299e0893a3dfa$var$queue = $391299e0893a3dfa$var$currentQueue.concat($391299e0893a3dfa$var$queue);
    else $391299e0893a3dfa$var$queueIndex = -1;
    if ($391299e0893a3dfa$var$queue.length) $391299e0893a3dfa$var$drainQueue();
}
function $391299e0893a3dfa$var$drainQueue() {
    if ($391299e0893a3dfa$var$draining) return;
    var timeout = $391299e0893a3dfa$var$runTimeout($391299e0893a3dfa$var$cleanUpNextTick);
    $391299e0893a3dfa$var$draining = true;
    var len = $391299e0893a3dfa$var$queue.length;
    while(len){
        $391299e0893a3dfa$var$currentQueue = $391299e0893a3dfa$var$queue;
        $391299e0893a3dfa$var$queue = [];
        while(++$391299e0893a3dfa$var$queueIndex < len)if ($391299e0893a3dfa$var$currentQueue) $391299e0893a3dfa$var$currentQueue[$391299e0893a3dfa$var$queueIndex].run();
        $391299e0893a3dfa$var$queueIndex = -1;
        len = $391299e0893a3dfa$var$queue.length;
    }
    $391299e0893a3dfa$var$currentQueue = null;
    $391299e0893a3dfa$var$draining = false;
    $391299e0893a3dfa$var$runClearTimeout(timeout);
}
$391299e0893a3dfa$var$process.nextTick = function(fun) {
    var args = new Array(arguments.length - 1);
    if (arguments.length > 1) for(var i = 1; i < arguments.length; i++)args[i - 1] = arguments[i];
    $391299e0893a3dfa$var$queue.push(new $391299e0893a3dfa$var$Item(fun, args));
    if ($391299e0893a3dfa$var$queue.length === 1 && !$391299e0893a3dfa$var$draining) $391299e0893a3dfa$var$runTimeout($391299e0893a3dfa$var$drainQueue);
};
// v8 likes predictible objects
function $391299e0893a3dfa$var$Item(fun, array) {
    this.fun = fun;
    this.array = array;
}
$391299e0893a3dfa$var$Item.prototype.run = function() {
    this.fun.apply(null, this.array);
};
$391299e0893a3dfa$var$process.title = "browser";
$391299e0893a3dfa$var$process.browser = true;
$391299e0893a3dfa$var$process.env = {};
$391299e0893a3dfa$var$process.argv = [];
$391299e0893a3dfa$var$process.version = ""; // empty string to avoid regexp issues
$391299e0893a3dfa$var$process.versions = {};
function $391299e0893a3dfa$var$noop() {}
$391299e0893a3dfa$var$process.on = $391299e0893a3dfa$var$noop;
$391299e0893a3dfa$var$process.addListener = $391299e0893a3dfa$var$noop;
$391299e0893a3dfa$var$process.once = $391299e0893a3dfa$var$noop;
$391299e0893a3dfa$var$process.off = $391299e0893a3dfa$var$noop;
$391299e0893a3dfa$var$process.removeListener = $391299e0893a3dfa$var$noop;
$391299e0893a3dfa$var$process.removeAllListeners = $391299e0893a3dfa$var$noop;
$391299e0893a3dfa$var$process.emit = $391299e0893a3dfa$var$noop;
$391299e0893a3dfa$var$process.prependListener = $391299e0893a3dfa$var$noop;
$391299e0893a3dfa$var$process.prependOnceListener = $391299e0893a3dfa$var$noop;
$391299e0893a3dfa$var$process.listeners = function(name) {
    return [];
};
$391299e0893a3dfa$var$process.binding = function(name) {
    throw new Error("process.binding is not supported");
};
$391299e0893a3dfa$var$process.cwd = function() {
    return "/";
};
$391299e0893a3dfa$var$process.chdir = function(dir) {
    throw new Error("process.chdir is not supported");
};
$391299e0893a3dfa$var$process.umask = function() {
    return 0;
};


var $e484c752f3f06549$var$f = ("undefined" != typeof $391299e0893a3dfa$exports && void 0 !== $391299e0893a3dfa$exports.env && undefined, "data-styled"), $e484c752f3f06549$var$m = "active", $e484c752f3f06549$var$y = "data-styled-version", $e484c752f3f06549$export$83d89fbfd8236492 = "6.1.11", $e484c752f3f06549$var$g = "/*!sc*/\n", $e484c752f3f06549$var$S = "undefined" != typeof window && "HTMLElement" in window, $e484c752f3f06549$var$w = Boolean("boolean" == typeof SC_DISABLE_SPEEDY ? SC_DISABLE_SPEEDY : ("undefined" != typeof $391299e0893a3dfa$exports && $391299e0893a3dfa$exports.env, "undefined" != typeof $391299e0893a3dfa$exports && $391299e0893a3dfa$exports.env, false)), $e484c752f3f06549$var$b = {}, $e484c752f3f06549$var$E = /invalid hook call/i, $e484c752f3f06549$var$N = new Set, $e484c752f3f06549$var$P = function(t, n) {
    var o, s, i, a, e;
}, $e484c752f3f06549$var$_ = Object.freeze([]), $e484c752f3f06549$var$C = Object.freeze({});
function $e484c752f3f06549$var$I(e, t, n) {
    return void 0 === n && (n = $e484c752f3f06549$var$C), e.theme !== n.theme && e.theme || t || n.theme;
}
var $e484c752f3f06549$var$A = new Set([
    "a",
    "abbr",
    "address",
    "area",
    "article",
    "aside",
    "audio",
    "b",
    "base",
    "bdi",
    "bdo",
    "big",
    "blockquote",
    "body",
    "br",
    "button",
    "canvas",
    "caption",
    "cite",
    "code",
    "col",
    "colgroup",
    "data",
    "datalist",
    "dd",
    "del",
    "details",
    "dfn",
    "dialog",
    "div",
    "dl",
    "dt",
    "em",
    "embed",
    "fieldset",
    "figcaption",
    "figure",
    "footer",
    "form",
    "h1",
    "h2",
    "h3",
    "h4",
    "h5",
    "h6",
    "header",
    "hgroup",
    "hr",
    "html",
    "i",
    "iframe",
    "img",
    "input",
    "ins",
    "kbd",
    "keygen",
    "label",
    "legend",
    "li",
    "link",
    "main",
    "map",
    "mark",
    "menu",
    "menuitem",
    "meta",
    "meter",
    "nav",
    "noscript",
    "object",
    "ol",
    "optgroup",
    "option",
    "output",
    "p",
    "param",
    "picture",
    "pre",
    "progress",
    "q",
    "rp",
    "rt",
    "ruby",
    "s",
    "samp",
    "script",
    "section",
    "select",
    "small",
    "source",
    "span",
    "strong",
    "style",
    "sub",
    "summary",
    "sup",
    "table",
    "tbody",
    "td",
    "textarea",
    "tfoot",
    "th",
    "thead",
    "time",
    "tr",
    "track",
    "u",
    "ul",
    "use",
    "var",
    "video",
    "wbr",
    "circle",
    "clipPath",
    "defs",
    "ellipse",
    "foreignObject",
    "g",
    "image",
    "line",
    "linearGradient",
    "marker",
    "mask",
    "path",
    "pattern",
    "polygon",
    "polyline",
    "radialGradient",
    "rect",
    "stop",
    "svg",
    "text",
    "tspan"
]), $e484c752f3f06549$var$O = /[!"#$%&'()*+,./:;<=>?@[\\\]^`{|}~-]+/g, $e484c752f3f06549$var$D = /(^-|-$)/g;
function $e484c752f3f06549$var$R(e) {
    return e.replace($e484c752f3f06549$var$O, "-").replace($e484c752f3f06549$var$D, "");
}
var $e484c752f3f06549$var$T = /(a)(d)/gi, $e484c752f3f06549$var$k = 52, $e484c752f3f06549$var$j = function(e) {
    return String.fromCharCode(e + (e > 25 ? 39 : 97));
};
function $e484c752f3f06549$var$x(e) {
    var t, n = "";
    for(t = Math.abs(e); t > $e484c752f3f06549$var$k; t = t / $e484c752f3f06549$var$k | 0)n = $e484c752f3f06549$var$j(t % $e484c752f3f06549$var$k) + n;
    return ($e484c752f3f06549$var$j(t % $e484c752f3f06549$var$k) + n).replace($e484c752f3f06549$var$T, "$1-$2");
}
var $e484c752f3f06549$var$V, $e484c752f3f06549$var$F = 5381, $e484c752f3f06549$var$M = function(e, t) {
    for(var n = t.length; n;)e = 33 * e ^ t.charCodeAt(--n);
    return e;
}, $e484c752f3f06549$var$$ = function(e) {
    return $e484c752f3f06549$var$M($e484c752f3f06549$var$F, e);
};
function $e484c752f3f06549$var$z(e) {
    return $e484c752f3f06549$var$x($e484c752f3f06549$var$$(e) >>> 0);
}
function $e484c752f3f06549$var$B(e) {
    return (0, e.displayName) || e.name || "Component";
}
function $e484c752f3f06549$var$L(e) {
    return "string" == typeof e && true;
}
var $e484c752f3f06549$var$G = "function" == typeof Symbol && Symbol.for, $e484c752f3f06549$var$Y = $e484c752f3f06549$var$G ? Symbol.for("react.memo") : 60115, $e484c752f3f06549$var$W = $e484c752f3f06549$var$G ? Symbol.for("react.forward_ref") : 60112, $e484c752f3f06549$var$q = {
    childContextTypes: !0,
    contextType: !0,
    contextTypes: !0,
    defaultProps: !0,
    displayName: !0,
    getDefaultProps: !0,
    getDerivedStateFromError: !0,
    getDerivedStateFromProps: !0,
    mixins: !0,
    propTypes: !0,
    type: !0
}, $e484c752f3f06549$var$H = {
    name: !0,
    length: !0,
    prototype: !0,
    caller: !0,
    callee: !0,
    arguments: !0,
    arity: !0
}, $e484c752f3f06549$var$U = {
    $$typeof: !0,
    compare: !0,
    defaultProps: !0,
    displayName: !0,
    propTypes: !0,
    type: !0
}, $e484c752f3f06549$var$J = (($e484c752f3f06549$var$V = {})[$e484c752f3f06549$var$W] = {
    $$typeof: !0,
    render: !0,
    defaultProps: !0,
    displayName: !0,
    propTypes: !0
}, $e484c752f3f06549$var$V[$e484c752f3f06549$var$Y] = $e484c752f3f06549$var$U, $e484c752f3f06549$var$V);
function $e484c752f3f06549$var$X(e) {
    var t;
    return ("type" in (t = e) && t.type.$$typeof) === $e484c752f3f06549$var$Y ? $e484c752f3f06549$var$U : "$$typeof" in e ? $e484c752f3f06549$var$J[e.$$typeof] : $e484c752f3f06549$var$q;
}
var $e484c752f3f06549$var$Z = Object.defineProperty, $e484c752f3f06549$var$K = Object.getOwnPropertyNames, $e484c752f3f06549$var$Q = Object.getOwnPropertySymbols, $e484c752f3f06549$var$ee = Object.getOwnPropertyDescriptor, $e484c752f3f06549$var$te = Object.getPrototypeOf, $e484c752f3f06549$var$ne = Object.prototype;
function $e484c752f3f06549$var$oe(e, t, n) {
    if ("string" != typeof t) {
        if ($e484c752f3f06549$var$ne) {
            var o = $e484c752f3f06549$var$te(t);
            o && o !== $e484c752f3f06549$var$ne && $e484c752f3f06549$var$oe(e, o, n);
        }
        var r = $e484c752f3f06549$var$K(t);
        $e484c752f3f06549$var$Q && (r = r.concat($e484c752f3f06549$var$Q(t)));
        for(var s = $e484c752f3f06549$var$X(e), i = $e484c752f3f06549$var$X(t), a = 0; a < r.length; ++a){
            var c = r[a];
            if (!(c in $e484c752f3f06549$var$H || n && n[c] || i && c in i || s && c in s)) {
                var l = $e484c752f3f06549$var$ee(t, c);
                try {
                    $e484c752f3f06549$var$Z(e, c, l);
                } catch (e) {}
            }
        }
    }
    return e;
}
function $e484c752f3f06549$var$re(e) {
    return "function" == typeof e;
}
function $e484c752f3f06549$export$7ba318d8d2f06c76(e) {
    return "object" == typeof e && "styledComponentId" in e;
}
function $e484c752f3f06549$var$ie(e, t) {
    return e && t ? "".concat(e, " ").concat(t) : e || t || "";
}
function $e484c752f3f06549$var$ae(e, t) {
    if (0 === e.length) return "";
    for(var n = e[0], o = 1; o < e.length; o++)n += t ? t + e[o] : e[o];
    return n;
}
function $e484c752f3f06549$var$ce(e) {
    return null !== e && "object" == typeof e && e.constructor.name === Object.name && !("props" in e && e.$$typeof);
}
function $e484c752f3f06549$var$le(e, t, n) {
    if (void 0 === n && (n = !1), !n && !$e484c752f3f06549$var$ce(e) && !Array.isArray(e)) return t;
    if (Array.isArray(t)) for(var o = 0; o < t.length; o++)e[o] = $e484c752f3f06549$var$le(e[o], t[o]);
    else if ($e484c752f3f06549$var$ce(t)) for(var o in t)e[o] = $e484c752f3f06549$var$le(e[o], t[o]);
    return e;
}
function $e484c752f3f06549$var$ue(e, t) {
    Object.defineProperty(e, "toString", {
        value: t
    });
}
var $e484c752f3f06549$var$pe = {};
function $e484c752f3f06549$var$de() {
    for(var e = [], t = 0; t < arguments.length; t++)e[t] = arguments[t];
    for(var n = e[0], o = [], r = 1, s = e.length; r < s; r += 1)o.push(e[r]);
    return o.forEach(function(e) {
        n = n.replace(/%[a-z]/, e);
    }), n;
}
function $e484c752f3f06549$var$he(t) {
    for(var n = [], o = 1; o < arguments.length; o++)n[o - 1] = arguments[o];
    return new Error("An error occurred. See https://github.com/styled-components/styled-components/blob/main/packages/styled-components/src/utils/errors.md#".concat(t, " for more information.").concat(n.length > 0 ? " Args: ".concat(n.join(", ")) : ""));
}
var $e484c752f3f06549$var$fe = function() {
    function e(e) {
        this.groupSizes = new Uint32Array(512), this.length = 512, this.tag = e;
    }
    return e.prototype.indexOfGroup = function(e) {
        for(var t = 0, n = 0; n < e; n++)t += this.groupSizes[n];
        return t;
    }, e.prototype.insertRules = function(e, t) {
        if (e >= this.groupSizes.length) {
            for(var n = this.groupSizes, o = n.length, r = o; e >= r;)if ((r <<= 1) < 0) throw $e484c752f3f06549$var$he(16, "".concat(e));
            this.groupSizes = new Uint32Array(r), this.groupSizes.set(n), this.length = r;
            for(var s = o; s < r; s++)this.groupSizes[s] = 0;
        }
        for(var i = this.indexOfGroup(e + 1), a = (s = 0, t.length); s < a; s++)this.tag.insertRule(i, t[s]) && (this.groupSizes[e]++, i++);
    }, e.prototype.clearGroup = function(e) {
        if (e < this.length) {
            var t = this.groupSizes[e], n = this.indexOfGroup(e), o = n + t;
            this.groupSizes[e] = 0;
            for(var r = n; r < o; r++)this.tag.deleteRule(n);
        }
    }, e.prototype.getGroup = function(e) {
        var t = "";
        if (e >= this.length || 0 === this.groupSizes[e]) return t;
        for(var n = this.groupSizes[e], o = this.indexOfGroup(e), r = o + n, s = o; s < r; s++)t += "".concat(this.tag.getRule(s)).concat($e484c752f3f06549$var$g);
        return t;
    }, e;
}(), $e484c752f3f06549$var$me = 1073741824, $e484c752f3f06549$var$ye = new Map, $e484c752f3f06549$var$ve = new Map, $e484c752f3f06549$var$ge = 1, $e484c752f3f06549$var$Se = function(e) {
    if ($e484c752f3f06549$var$ye.has(e)) return $e484c752f3f06549$var$ye.get(e);
    for(; $e484c752f3f06549$var$ve.has($e484c752f3f06549$var$ge);)$e484c752f3f06549$var$ge++;
    var t = $e484c752f3f06549$var$ge++;
    return $e484c752f3f06549$var$ye.set(e, t), $e484c752f3f06549$var$ve.set(t, e), t;
}, $e484c752f3f06549$var$we = function(e, t) {
    $e484c752f3f06549$var$ge = t + 1, $e484c752f3f06549$var$ye.set(e, t), $e484c752f3f06549$var$ve.set(t, e);
}, $e484c752f3f06549$var$be = "style[".concat($e484c752f3f06549$var$f, "][").concat($e484c752f3f06549$var$y, '="').concat($e484c752f3f06549$export$83d89fbfd8236492, '"]'), $e484c752f3f06549$var$Ee = new RegExp("^".concat($e484c752f3f06549$var$f, '\\.g(\\d+)\\[id="([\\w\\d-]+)"\\].*?"([^"]*)')), $e484c752f3f06549$var$Ne = function(e, t, n) {
    for(var o, r = n.split(","), s = 0, i = r.length; s < i; s++)(o = r[s]) && e.registerName(t, o);
}, $e484c752f3f06549$var$Pe = function(e, t) {
    for(var n, o = (null !== (n = t.textContent) && void 0 !== n ? n : "").split($e484c752f3f06549$var$g), r = [], s = 0, i = o.length; s < i; s++){
        var a = o[s].trim();
        if (a) {
            var c = a.match($e484c752f3f06549$var$Ee);
            if (c) {
                var l = 0 | parseInt(c[1], 10), u = c[2];
                0 !== l && ($e484c752f3f06549$var$we(u, l), $e484c752f3f06549$var$Ne(e, u, c[3]), e.getTag().insertRules(l, r)), r.length = 0;
            } else r.push(a);
        }
    }
};
function $e484c752f3f06549$var$_e() {
    return "undefined" != typeof __webpack_nonce__ ? __webpack_nonce__ : null;
}
var $e484c752f3f06549$var$Ce = function(e) {
    var t = document.head, n = e || t, o = document.createElement("style"), r = function(e) {
        var t = Array.from(e.querySelectorAll("style[".concat($e484c752f3f06549$var$f, "]")));
        return t[t.length - 1];
    }(n), s = void 0 !== r ? r.nextSibling : null;
    o.setAttribute($e484c752f3f06549$var$f, $e484c752f3f06549$var$m), o.setAttribute($e484c752f3f06549$var$y, $e484c752f3f06549$export$83d89fbfd8236492);
    var i = $e484c752f3f06549$var$_e();
    return i && o.setAttribute("nonce", i), n.insertBefore(o, s), o;
}, $e484c752f3f06549$var$Ie = function() {
    function e(e) {
        this.element = $e484c752f3f06549$var$Ce(e), this.element.appendChild(document.createTextNode("")), this.sheet = function(e) {
            if (e.sheet) return e.sheet;
            for(var t = document.styleSheets, n = 0, o = t.length; n < o; n++){
                var r = t[n];
                if (r.ownerNode === e) return r;
            }
            throw $e484c752f3f06549$var$he(17);
        }(this.element), this.length = 0;
    }
    return e.prototype.insertRule = function(e, t) {
        try {
            return this.sheet.insertRule(t, e), this.length++, !0;
        } catch (e) {
            return !1;
        }
    }, e.prototype.deleteRule = function(e) {
        this.sheet.deleteRule(e), this.length--;
    }, e.prototype.getRule = function(e) {
        var t = this.sheet.cssRules[e];
        return t && t.cssText ? t.cssText : "";
    }, e;
}(), $e484c752f3f06549$var$Ae = function() {
    function e(e) {
        this.element = $e484c752f3f06549$var$Ce(e), this.nodes = this.element.childNodes, this.length = 0;
    }
    return e.prototype.insertRule = function(e, t) {
        if (e <= this.length && e >= 0) {
            var n = document.createTextNode(t);
            return this.element.insertBefore(n, this.nodes[e] || null), this.length++, !0;
        }
        return !1;
    }, e.prototype.deleteRule = function(e) {
        this.element.removeChild(this.nodes[e]), this.length--;
    }, e.prototype.getRule = function(e) {
        return e < this.length ? this.nodes[e].textContent : "";
    }, e;
}(), $e484c752f3f06549$var$Oe = function() {
    function e(e) {
        this.rules = [], this.length = 0;
    }
    return e.prototype.insertRule = function(e, t) {
        return e <= this.length && (this.rules.splice(e, 0, t), this.length++, !0);
    }, e.prototype.deleteRule = function(e) {
        this.rules.splice(e, 1), this.length--;
    }, e.prototype.getRule = function(e) {
        return e < this.length ? this.rules[e] : "";
    }, e;
}(), $e484c752f3f06549$var$De = $e484c752f3f06549$var$S, $e484c752f3f06549$var$Re = {
    isServer: !$e484c752f3f06549$var$S,
    useCSSOMInjection: !$e484c752f3f06549$var$w
}, $e484c752f3f06549$var$Te = function() {
    function e(e, n, o) {
        void 0 === e && (e = $e484c752f3f06549$var$C), void 0 === n && (n = {});
        var r = this;
        this.options = (0, $f5ed4ab2a4d1861b$export$18ce0697a983be9b)((0, $f5ed4ab2a4d1861b$export$18ce0697a983be9b)({}, $e484c752f3f06549$var$Re), e), this.gs = n, this.names = new Map(o), this.server = !!e.isServer, !this.server && $e484c752f3f06549$var$S && $e484c752f3f06549$var$De && ($e484c752f3f06549$var$De = !1, function(e) {
            for(var t = document.querySelectorAll($e484c752f3f06549$var$be), n = 0, o = t.length; n < o; n++){
                var r = t[n];
                r && r.getAttribute($e484c752f3f06549$var$f) !== $e484c752f3f06549$var$m && ($e484c752f3f06549$var$Pe(e, r), r.parentNode && r.parentNode.removeChild(r));
            }
        }(this)), $e484c752f3f06549$var$ue(this, function() {
            return function(e) {
                for(var t = e.getTag(), n = t.length, o = "", r = function(n) {
                    var r = function(e) {
                        return $e484c752f3f06549$var$ve.get(e);
                    }(n);
                    if (void 0 === r) return "continue";
                    var s = e.names.get(r), i = t.getGroup(n);
                    if (void 0 === s || 0 === i.length) return "continue";
                    var a = "".concat($e484c752f3f06549$var$f, ".g").concat(n, '[id="').concat(r, '"]'), c = "";
                    void 0 !== s && s.forEach(function(e) {
                        e.length > 0 && (c += "".concat(e, ","));
                    }), o += "".concat(i).concat(a, '{content:"').concat(c, '"}').concat($e484c752f3f06549$var$g);
                }, s = 0; s < n; s++)r(s);
                return o;
            }(r);
        });
    }
    return e.registerId = function(e) {
        return $e484c752f3f06549$var$Se(e);
    }, e.prototype.reconstructWithOptions = function(n, o) {
        return void 0 === o && (o = !0), new e((0, $f5ed4ab2a4d1861b$export$18ce0697a983be9b)((0, $f5ed4ab2a4d1861b$export$18ce0697a983be9b)({}, this.options), n), this.gs, o && this.names || void 0);
    }, e.prototype.allocateGSInstance = function(e) {
        return this.gs[e] = (this.gs[e] || 0) + 1;
    }, e.prototype.getTag = function() {
        var e;
        return this.tag || (this.tag = (e = function(e) {
            var t = e.useCSSOMInjection, n = e.target;
            return e.isServer ? new $e484c752f3f06549$var$Oe(n) : t ? new $e484c752f3f06549$var$Ie(n) : new $e484c752f3f06549$var$Ae(n);
        }(this.options), new $e484c752f3f06549$var$fe(e)));
    }, e.prototype.hasNameForId = function(e, t) {
        return this.names.has(e) && this.names.get(e).has(t);
    }, e.prototype.registerName = function(e, t) {
        if ($e484c752f3f06549$var$Se(e), this.names.has(e)) this.names.get(e).add(t);
        else {
            var n = new Set;
            n.add(t), this.names.set(e, n);
        }
    }, e.prototype.insertRules = function(e, t, n) {
        this.registerName(e, t), this.getTag().insertRules($e484c752f3f06549$var$Se(e), n);
    }, e.prototype.clearNames = function(e) {
        this.names.has(e) && this.names.get(e).clear();
    }, e.prototype.clearRules = function(e) {
        this.getTag().clearGroup($e484c752f3f06549$var$Se(e)), this.clearNames(e);
    }, e.prototype.clearTag = function() {
        this.tag = void 0;
    }, e;
}(), $e484c752f3f06549$var$ke = /&/g, $e484c752f3f06549$var$je = /^\s*\/\/.*$/gm;
function $e484c752f3f06549$var$xe(e, t) {
    return e.map(function(e) {
        return "rule" === e.type && (e.value = "".concat(t, " ").concat(e.value), e.value = e.value.replaceAll(",", ",".concat(t, " ")), e.props = e.props.map(function(e) {
            return "".concat(t, " ").concat(e);
        })), Array.isArray(e.children) && "@keyframes" !== e.type && (e.children = $e484c752f3f06549$var$xe(e.children, t)), e;
    });
}
function $e484c752f3f06549$var$Ve(e) {
    var t, n, o, r = void 0 === e ? $e484c752f3f06549$var$C : e, s = r.options, i = void 0 === s ? $e484c752f3f06549$var$C : s, a = r.plugins, c = void 0 === a ? $e484c752f3f06549$var$_ : a, l = function(e, o, r) {
        return r.startsWith(n) && r.endsWith(n) && r.replaceAll(n, "").length > 0 ? ".".concat(t) : e;
    }, u = c.slice();
    u.push(function(e) {
        e.type === $783faa7ec18221fc$export$aa3a2e812ca8570d && e.value.includes("&") && (e.props[0] = e.props[0].replace($e484c752f3f06549$var$ke, n).replace(o, l));
    }), i.prefix && u.push($783faa7ec18221fc$export$e08c7d021b829b7a), u.push($783faa7ec18221fc$export$fac44ee5b035f737);
    var p = function(e, r, s, a) {
        void 0 === r && (r = ""), void 0 === s && (s = ""), void 0 === a && (a = "&"), t = a, n = r, o = new RegExp("\\".concat(n, "\\b"), "g");
        var c = e.replace($e484c752f3f06549$var$je, ""), l = $783faa7ec18221fc$export$ef7acd7185315e22(s || r ? "".concat(s, " ").concat(r, " { ").concat(c, " }") : c);
        i.namespace && (l = $e484c752f3f06549$var$xe(l, i.namespace));
        var p = [];
        return $783faa7ec18221fc$export$dfdc1655ccc5b9cb(l, $783faa7ec18221fc$export$5a7767152ae0305f(u.concat($783faa7ec18221fc$export$38bcb760f1d4871c(function(e) {
            return p.push(e);
        })))), p;
    };
    return p.hash = c.length ? c.reduce(function(e, t) {
        return t.name || $e484c752f3f06549$var$he(15), $e484c752f3f06549$var$M(e, t.name);
    }, $e484c752f3f06549$var$F).toString() : "", p;
}
var $e484c752f3f06549$var$Fe = new $e484c752f3f06549$var$Te, $e484c752f3f06549$var$Me = $e484c752f3f06549$var$Ve(), $e484c752f3f06549$export$8c190ef828af4c86 = (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createContext({
    shouldForwardProp: void 0,
    styleSheet: $e484c752f3f06549$var$Fe,
    stylis: $e484c752f3f06549$var$Me
}), $e484c752f3f06549$export$91317688fc694efa = $e484c752f3f06549$export$8c190ef828af4c86.Consumer, $e484c752f3f06549$var$Be = (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createContext(void 0);
function $e484c752f3f06549$var$Le() {
    return (0, $bh6RR.useContext)($e484c752f3f06549$export$8c190ef828af4c86);
}
function $e484c752f3f06549$export$a473771da2f0ff7c(e) {
    var t = (0, $bh6RR.useState)(e.stylisPlugins), n = t[0], r = t[1], c = $e484c752f3f06549$var$Le().styleSheet, l = (0, $bh6RR.useMemo)(function() {
        var t = c;
        return e.sheet ? t = e.sheet : e.target && (t = t.reconstructWithOptions({
            target: e.target
        }, !1)), e.disableCSSOMInjection && (t = t.reconstructWithOptions({
            useCSSOMInjection: !1
        })), t;
    }, [
        e.disableCSSOMInjection,
        e.sheet,
        e.target,
        c
    ]), u = (0, $bh6RR.useMemo)(function() {
        return $e484c752f3f06549$var$Ve({
            options: {
                namespace: e.namespace,
                prefix: e.enableVendorPrefixes
            },
            plugins: n
        });
    }, [
        e.enableVendorPrefixes,
        e.namespace,
        n
    ]);
    (0, $bh6RR.useEffect)(function() {
        (0, (/*@__PURE__*/$parcel$interopDefault($53a106364dbd0a1b$exports)))(n, e.stylisPlugins) || r(e.stylisPlugins);
    }, [
        e.stylisPlugins
    ]);
    var d = (0, $bh6RR.useMemo)(function() {
        return {
            shouldForwardProp: e.shouldForwardProp,
            styleSheet: l,
            stylis: u
        };
    }, [
        e.shouldForwardProp,
        l,
        u
    ]);
    return (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement($e484c752f3f06549$export$8c190ef828af4c86.Provider, {
        value: d
    }, (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement($e484c752f3f06549$var$Be.Provider, {
        value: u
    }, e.children));
}
var $e484c752f3f06549$var$Ye = function() {
    function e(e, t) {
        var n = this;
        this.inject = function(e, t) {
            void 0 === t && (t = $e484c752f3f06549$var$Me);
            var o = n.name + t.hash;
            e.hasNameForId(n.id, o) || e.insertRules(n.id, o, t(n.rules, o, "@keyframes"));
        }, this.name = e, this.id = "sc-keyframes-".concat(e), this.rules = t, $e484c752f3f06549$var$ue(this, function() {
            throw $e484c752f3f06549$var$he(12, String(n.name));
        });
    }
    return e.prototype.getName = function(e) {
        return void 0 === e && (e = $e484c752f3f06549$var$Me), this.name + e.hash;
    }, e;
}(), $e484c752f3f06549$var$We = function(e) {
    return e >= "A" && e <= "Z";
};
function $e484c752f3f06549$var$qe(e) {
    for(var t = "", n = 0; n < e.length; n++){
        var o = e[n];
        if (1 === n && "-" === o && "-" === e[0]) return e;
        $e484c752f3f06549$var$We(o) ? t += "-" + o.toLowerCase() : t += o;
    }
    return t.startsWith("ms-") ? "-" + t : t;
}
var $e484c752f3f06549$var$He = function(e) {
    return null == e || !1 === e || "" === e;
}, $e484c752f3f06549$var$Ue = function(t) {
    var n, o, r = [];
    for(var s in t){
        var i = t[s];
        t.hasOwnProperty(s) && !$e484c752f3f06549$var$He(i) && (Array.isArray(i) && i.isCss || $e484c752f3f06549$var$re(i) ? r.push("".concat($e484c752f3f06549$var$qe(s), ":"), i, ";") : $e484c752f3f06549$var$ce(i) ? r.push.apply(r, (0, $f5ed4ab2a4d1861b$export$1216008129fb82ed)((0, $f5ed4ab2a4d1861b$export$1216008129fb82ed)([
            "".concat(s, " {")
        ], $e484c752f3f06549$var$Ue(i), !1), [
            "}"
        ], !1)) : r.push("".concat($e484c752f3f06549$var$qe(s), ": ").concat((n = s, null == (o = i) || "boolean" == typeof o || "" === o ? "" : "number" != typeof o || 0 === o || n in (0, $78b52bced097bc64$export$2e2bcd8739ae039) || n.startsWith("--") ? String(o).trim() : "".concat(o, "px")), ";")));
    }
    return r;
};
function $e484c752f3f06549$var$Je(e, t, n, o) {
    if ($e484c752f3f06549$var$He(e)) return [];
    if ($e484c752f3f06549$export$7ba318d8d2f06c76(e)) return [
        ".".concat(e.styledComponentId)
    ];
    if ($e484c752f3f06549$var$re(e)) {
        if (!$e484c752f3f06549$var$re(s = e) || s.prototype && s.prototype.isReactComponent || !t) return [
            e
        ];
        var r = e(t);
        return $e484c752f3f06549$var$Je(r, t, n, o);
    }
    var s;
    return e instanceof $e484c752f3f06549$var$Ye ? n ? (e.inject(n, o), [
        e.getName(o)
    ]) : [
        e
    ] : $e484c752f3f06549$var$ce(e) ? $e484c752f3f06549$var$Ue(e) : Array.isArray(e) ? Array.prototype.concat.apply($e484c752f3f06549$var$_, e.map(function(e) {
        return $e484c752f3f06549$var$Je(e, t, n, o);
    })) : [
        e.toString()
    ];
}
function $e484c752f3f06549$var$Xe(e) {
    for(var t = 0; t < e.length; t += 1){
        var n = e[t];
        if ($e484c752f3f06549$var$re(n) && !$e484c752f3f06549$export$7ba318d8d2f06c76(n)) return !1;
    }
    return !0;
}
var $e484c752f3f06549$var$Ze = $e484c752f3f06549$var$$($e484c752f3f06549$export$83d89fbfd8236492), $e484c752f3f06549$var$Ke = function() {
    function e(e, t, n) {
        this.rules = e, this.staticRulesId = "", this.isStatic = (void 0 === n || n.isStatic) && $e484c752f3f06549$var$Xe(e), this.componentId = t, this.baseHash = $e484c752f3f06549$var$M($e484c752f3f06549$var$Ze, t), this.baseStyle = n, $e484c752f3f06549$var$Te.registerId(t);
    }
    return e.prototype.generateAndInjectStyles = function(e, t, n) {
        var o = this.baseStyle ? this.baseStyle.generateAndInjectStyles(e, t, n) : "";
        if (this.isStatic && !n.hash) {
            if (this.staticRulesId && t.hasNameForId(this.componentId, this.staticRulesId)) o = $e484c752f3f06549$var$ie(o, this.staticRulesId);
            else {
                var r = $e484c752f3f06549$var$ae($e484c752f3f06549$var$Je(this.rules, e, t, n)), s = $e484c752f3f06549$var$x($e484c752f3f06549$var$M(this.baseHash, r) >>> 0);
                if (!t.hasNameForId(this.componentId, s)) {
                    var i = n(r, ".".concat(s), void 0, this.componentId);
                    t.insertRules(this.componentId, s, i);
                }
                o = $e484c752f3f06549$var$ie(o, s), this.staticRulesId = s;
            }
        } else {
            for(var a = $e484c752f3f06549$var$M(this.baseHash, n.hash), c = "", l = 0; l < this.rules.length; l++){
                var u = this.rules[l];
                if ("string" == typeof u) c += u;
                else if (u) {
                    var p = $e484c752f3f06549$var$ae($e484c752f3f06549$var$Je(u, e, t, n));
                    a = $e484c752f3f06549$var$M(a, p + l), c += p;
                }
            }
            if (c) {
                var d = $e484c752f3f06549$var$x(a >>> 0);
                t.hasNameForId(this.componentId, d) || t.insertRules(this.componentId, d, n(c, ".".concat(d), void 0, this.componentId)), o = $e484c752f3f06549$var$ie(o, d);
            }
        }
        return o;
    }, e;
}(), $e484c752f3f06549$export$2c657da244d00bd6 = (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createContext(void 0), $e484c752f3f06549$export$b631efc24e9d5e2f = $e484c752f3f06549$export$2c657da244d00bd6.Consumer;
function $e484c752f3f06549$export$93d4e7f90805808f() {
    var e = (0, $bh6RR.useContext)($e484c752f3f06549$export$2c657da244d00bd6);
    if (!e) throw $e484c752f3f06549$var$he(18);
    return e;
}
function $e484c752f3f06549$export$d8964aec282183a3(e) {
    var n = (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).useContext($e484c752f3f06549$export$2c657da244d00bd6), r = (0, $bh6RR.useMemo)(function() {
        return function(e, n) {
            if (!e) throw $e484c752f3f06549$var$he(14);
            if ($e484c752f3f06549$var$re(e)) {
                var o = e(n);
                return o;
            }
            if (Array.isArray(e) || "object" != typeof e) throw $e484c752f3f06549$var$he(8);
            return n ? (0, $f5ed4ab2a4d1861b$export$18ce0697a983be9b)((0, $f5ed4ab2a4d1861b$export$18ce0697a983be9b)({}, n), e) : e;
        }(e.theme, n);
    }, [
        e.theme,
        n
    ]);
    return e.children ? (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement($e484c752f3f06549$export$2c657da244d00bd6.Provider, {
        value: r
    }, e.children) : null;
}
var $e484c752f3f06549$var$ot = {}, $e484c752f3f06549$var$rt = new Set;
function $e484c752f3f06549$var$st(e, r, s) {
    var i = $e484c752f3f06549$export$7ba318d8d2f06c76(e), a = e, c = !$e484c752f3f06549$var$L(e), p = r.attrs, d = void 0 === p ? $e484c752f3f06549$var$_ : p, h = r.componentId, f = void 0 === h ? function(e, t) {
        var n = "string" != typeof e ? "sc" : $e484c752f3f06549$var$R(e);
        $e484c752f3f06549$var$ot[n] = ($e484c752f3f06549$var$ot[n] || 0) + 1;
        var o = "".concat(n, "-").concat($e484c752f3f06549$var$z($e484c752f3f06549$export$83d89fbfd8236492 + n + $e484c752f3f06549$var$ot[n]));
        return t ? "".concat(t, "-").concat(o) : o;
    }(r.displayName, r.parentComponentId) : h, m = r.displayName, y = void 0 === m ? function(e) {
        return $e484c752f3f06549$var$L(e) ? "styled.".concat(e) : "Styled(".concat($e484c752f3f06549$var$B(e), ")");
    }(e) : m, g = r.displayName && r.componentId ? "".concat($e484c752f3f06549$var$R(r.displayName), "-").concat(r.componentId) : r.componentId || f, S = i && a.attrs ? a.attrs.concat(d).filter(Boolean) : d, w = r.shouldForwardProp;
    if (i && a.shouldForwardProp) {
        var b = a.shouldForwardProp;
        if (r.shouldForwardProp) {
            var E = r.shouldForwardProp;
            w = function(e, t) {
                return b(e, t) && E(e, t);
            };
        } else w = b;
    }
    var N = new $e484c752f3f06549$var$Ke(s, g, i ? a.componentStyle : void 0);
    function O(e, r) {
        return function(e, r, s) {
            var i = e.attrs, a = e.componentStyle, c = e.defaultProps, p = e.foldedComponentIds, d = e.styledComponentId, h = e.target, f = (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).useContext($e484c752f3f06549$export$2c657da244d00bd6), m = $e484c752f3f06549$var$Le(), y = e.shouldForwardProp || m.shouldForwardProp;
            var v = $e484c752f3f06549$var$I(r, f, c) || $e484c752f3f06549$var$C, g = function(e, n, o) {
                for(var r, s = (0, $f5ed4ab2a4d1861b$export$18ce0697a983be9b)((0, $f5ed4ab2a4d1861b$export$18ce0697a983be9b)({}, n), {
                    className: void 0,
                    theme: o
                }), i = 0; i < e.length; i += 1){
                    var a = $e484c752f3f06549$var$re(r = e[i]) ? r(s) : r;
                    for(var c in a)s[c] = "className" === c ? $e484c752f3f06549$var$ie(s[c], a[c]) : "style" === c ? (0, $f5ed4ab2a4d1861b$export$18ce0697a983be9b)((0, $f5ed4ab2a4d1861b$export$18ce0697a983be9b)({}, s[c]), a[c]) : a[c];
                }
                return n.className && (s.className = $e484c752f3f06549$var$ie(s.className, n.className)), s;
            }(i, r, v), S = g.as || h, w = {};
            for(var b in g)void 0 === g[b] || "$" === b[0] || "as" === b || "theme" === b && g.theme === v || ("forwardedAs" === b ? w.as = g.forwardedAs : y && !y(b, S) || (w[b] = g[b], y));
            var E = function(e, t) {
                var n = $e484c752f3f06549$var$Le(), o = e.generateAndInjectStyles(t, n.styleSheet, n.stylis);
                return o;
            }(a, g);
            var N = $e484c752f3f06549$var$ie(p, d);
            return E && (N += " " + E), g.className && (N += " " + g.className), w[$e484c752f3f06549$var$L(S) && !$e484c752f3f06549$var$A.has(S) ? "class" : "className"] = N, w.ref = s, (0, $bh6RR.createElement)(S, w);
        }(D, e, r);
    }
    O.displayName = y;
    var D = (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).forwardRef(O);
    return D.attrs = S, D.componentStyle = N, D.displayName = y, D.shouldForwardProp = w, D.foldedComponentIds = i ? $e484c752f3f06549$var$ie(a.foldedComponentIds, a.styledComponentId) : "", D.styledComponentId = g, D.target = i ? a.target : e, Object.defineProperty(D, "defaultProps", {
        get: function() {
            return this._foldedDefaultProps;
        },
        set: function(e) {
            this._foldedDefaultProps = i ? function(e) {
                for(var t = [], n = 1; n < arguments.length; n++)t[n - 1] = arguments[n];
                for(var o = 0, r = t; o < r.length; o++)$e484c752f3f06549$var$le(e, r[o], !0);
                return e;
            }({}, a.defaultProps, e) : e;
        }
    }), $e484c752f3f06549$var$ue(D, function() {
        return ".".concat(D.styledComponentId);
    }), c && $e484c752f3f06549$var$oe(D, e, {
        attrs: !0,
        componentStyle: !0,
        displayName: !0,
        foldedComponentIds: !0,
        shouldForwardProp: !0,
        styledComponentId: !0,
        target: !0
    }), D;
}
function $e484c752f3f06549$var$it(e, t) {
    for(var n = [
        e[0]
    ], o = 0, r = t.length; o < r; o += 1)n.push(t[o], e[o + 1]);
    return n;
}
var $e484c752f3f06549$var$at = function(e) {
    return Object.assign(e, {
        isCss: !0
    });
};
function $e484c752f3f06549$export$dbf350e5966cf602(t) {
    for(var n = [], o = 1; o < arguments.length; o++)n[o - 1] = arguments[o];
    if ($e484c752f3f06549$var$re(t) || $e484c752f3f06549$var$ce(t)) return $e484c752f3f06549$var$at($e484c752f3f06549$var$Je($e484c752f3f06549$var$it($e484c752f3f06549$var$_, (0, $f5ed4ab2a4d1861b$export$1216008129fb82ed)([
        t
    ], n, !0))));
    var r = t;
    return 0 === n.length && 1 === r.length && "string" == typeof r[0] ? $e484c752f3f06549$var$Je(r) : $e484c752f3f06549$var$at($e484c752f3f06549$var$Je($e484c752f3f06549$var$it(r, n)));
}
function $e484c752f3f06549$var$lt(n, o, r) {
    if (void 0 === r && (r = $e484c752f3f06549$var$C), !o) throw $e484c752f3f06549$var$he(1, o);
    var s = function(t) {
        for(var s = [], i = 1; i < arguments.length; i++)s[i - 1] = arguments[i];
        return n(o, r, $e484c752f3f06549$export$dbf350e5966cf602.apply(void 0, (0, $f5ed4ab2a4d1861b$export$1216008129fb82ed)([
            t
        ], s, !1)));
    };
    return s.attrs = function(e) {
        return $e484c752f3f06549$var$lt(n, o, (0, $f5ed4ab2a4d1861b$export$18ce0697a983be9b)((0, $f5ed4ab2a4d1861b$export$18ce0697a983be9b)({}, r), {
            attrs: Array.prototype.concat(r.attrs, e).filter(Boolean)
        }));
    }, s.withConfig = function(e) {
        return $e484c752f3f06549$var$lt(n, o, (0, $f5ed4ab2a4d1861b$export$18ce0697a983be9b)((0, $f5ed4ab2a4d1861b$export$18ce0697a983be9b)({}, r), e));
    }, s;
}
var $e484c752f3f06549$var$ut = function(e) {
    return $e484c752f3f06549$var$lt($e484c752f3f06549$var$st, e);
}, $e484c752f3f06549$export$2e2bcd8739ae039 = $e484c752f3f06549$var$ut;
$e484c752f3f06549$var$A.forEach(function(e) {
    $e484c752f3f06549$export$2e2bcd8739ae039[e] = $e484c752f3f06549$var$ut(e);
});
var $e484c752f3f06549$var$dt = function() {
    function e(e, t) {
        this.rules = e, this.componentId = t, this.isStatic = $e484c752f3f06549$var$Xe(e), $e484c752f3f06549$var$Te.registerId(this.componentId + 1);
    }
    return e.prototype.createStyles = function(e, t, n, o) {
        var r = o($e484c752f3f06549$var$ae($e484c752f3f06549$var$Je(this.rules, t, n, o)), ""), s = this.componentId + e;
        n.insertRules(s, s, r);
    }, e.prototype.removeStyles = function(e, t) {
        t.clearRules(this.componentId + e);
    }, e.prototype.renderStyles = function(e, t, n, o) {
        e > 2 && $e484c752f3f06549$var$Te.registerId(this.componentId + e), this.removeStyles(e, n), this.createStyles(e, t, n, o);
    }, e;
}();
function $e484c752f3f06549$export$f0f03736edb61697(n) {
    for(var r = [], s = 1; s < arguments.length; s++)r[s - 1] = arguments[s];
    var i = $e484c752f3f06549$export$dbf350e5966cf602.apply(void 0, (0, $f5ed4ab2a4d1861b$export$1216008129fb82ed)([
        n
    ], r, !1)), a = "sc-global-".concat($e484c752f3f06549$var$z(JSON.stringify(i))), c = new $e484c752f3f06549$var$dt(i, a);
    var l = function(e) {
        var t = $e484c752f3f06549$var$Le(), n = (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).useContext($e484c752f3f06549$export$2c657da244d00bd6), r = (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).useRef(t.styleSheet.allocateGSInstance(a)).current;
        return t.styleSheet.server && u(r, e, t.styleSheet, n, t.stylis), (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).useLayoutEffect(function() {
            if (!t.styleSheet.server) return u(r, e, t.styleSheet, n, t.stylis), function() {
                return c.removeStyles(r, t.styleSheet);
            };
        }, [
            r,
            e,
            t.styleSheet,
            n,
            t.stylis
        ]), null;
    };
    function u(e, n, o, r, s) {
        if (c.isStatic) c.renderStyles(e, $e484c752f3f06549$var$b, o, s);
        else {
            var i = (0, $f5ed4ab2a4d1861b$export$18ce0697a983be9b)((0, $f5ed4ab2a4d1861b$export$18ce0697a983be9b)({}, n), {
                theme: $e484c752f3f06549$var$I(n, r, l.defaultProps)
            });
            c.renderStyles(e, i, o, s);
        }
    }
    return (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).memo(l);
}
function $e484c752f3f06549$export$d25ddfdf17c3ad3e(t) {
    for(var n = [], o = 1; o < arguments.length; o++)n[o - 1] = arguments[o];
    var r = $e484c752f3f06549$var$ae($e484c752f3f06549$export$dbf350e5966cf602.apply(void 0, (0, $f5ed4ab2a4d1861b$export$1216008129fb82ed)([
        t
    ], n, !1))), s = $e484c752f3f06549$var$z(r);
    return new $e484c752f3f06549$var$Ye(s, r);
}
function $e484c752f3f06549$export$e8748c6a27b910dc(e) {
    var n = (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).forwardRef(function(n, r) {
        var s = $e484c752f3f06549$var$I(n, (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).useContext($e484c752f3f06549$export$2c657da244d00bd6), e.defaultProps);
        return (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement(e, (0, $f5ed4ab2a4d1861b$export$18ce0697a983be9b)({}, n, {
            theme: s,
            ref: r
        }));
    });
    return n.displayName = "WithTheme(".concat($e484c752f3f06549$var$B(e), ")"), $e484c752f3f06549$var$oe(n, e);
}
var $e484c752f3f06549$export$ae8c7d15c8b89a20 = function() {
    function e() {
        var e = this;
        this._emitSheetCSS = function() {
            var t = e.instance.toString(), n = $e484c752f3f06549$var$_e(), o = $e484c752f3f06549$var$ae([
                n && 'nonce="'.concat(n, '"'),
                "".concat($e484c752f3f06549$var$f, '="true"'),
                "".concat($e484c752f3f06549$var$y, '="').concat($e484c752f3f06549$export$83d89fbfd8236492, '"')
            ].filter(Boolean), " ");
            return "<style ".concat(o, ">").concat(t, "</style>");
        }, this.getStyleTags = function() {
            if (e.sealed) throw $e484c752f3f06549$var$he(2);
            return e._emitSheetCSS();
        }, this.getStyleElement = function() {
            var n;
            if (e.sealed) throw $e484c752f3f06549$var$he(2);
            var r = ((n = {})[$e484c752f3f06549$var$f] = "", n[$e484c752f3f06549$var$y] = $e484c752f3f06549$export$83d89fbfd8236492, n.dangerouslySetInnerHTML = {
                __html: e.instance.toString()
            }, n), s = $e484c752f3f06549$var$_e();
            return s && (r.nonce = s), [
                (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement("style", (0, $f5ed4ab2a4d1861b$export$18ce0697a983be9b)({}, r, {
                    key: "sc-0-0"
                }))
            ];
        }, this.seal = function() {
            e.sealed = !0;
        }, this.instance = new $e484c752f3f06549$var$Te({
            isServer: !0
        }), this.sealed = !1;
    }
    return e.prototype.collectStyles = function(e) {
        if (this.sealed) throw $e484c752f3f06549$var$he(2);
        return (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement($e484c752f3f06549$export$a473771da2f0ff7c, {
            sheet: this.instance
        }, e);
    }, e.prototype.interleaveWithNodeStream = function(e) {
        throw $e484c752f3f06549$var$he(3);
    }, e;
}(), $e484c752f3f06549$export$5c87cfe6c475f500 = {
    StyleSheet: $e484c752f3f06549$var$Te,
    mainSheet: $e484c752f3f06549$var$Fe
};
var $e484c752f3f06549$var$gt = "__sc-".concat($e484c752f3f06549$var$f, "__");



const $cb3c883d63db9e8e$var$MaxWidthWrapper = (0, $e484c752f3f06549$export$2e2bcd8739ae039).div.withConfig({
    displayName: "MaxWidthWrapper",
    componentId: "sc-12pdsmw-0"
})([
    "position:relative;max-width:min(100%,calc(1200px + 32px * 2));margin-left:auto;margin-right:auto;padding-left:16px;padding-right:16px;"
]);
var $cb3c883d63db9e8e$export$2e2bcd8739ae039 = $cb3c883d63db9e8e$var$MaxWidthWrapper;





parcelRequire("bh6RR");


var $bh6RR = parcelRequire("bh6RR");
var $aa40b802dd2fccfc$exports = {};
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $aa40b802dd2fccfc$var$ReactIs, $aa40b802dd2fccfc$var$throwOnDirectAccess;

// By explicitly using `prop-types` you are opting into new production behavior.
// http://fb.me/prop-types-in-prod
$aa40b802dd2fccfc$exports = (parcelRequire("2tbKl"))();


function $6f30083c1b59d95d$var$_extends() {
    $6f30083c1b59d95d$var$_extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $6f30083c1b59d95d$var$_extends.apply(this, arguments);
}
function $6f30083c1b59d95d$var$_objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = $6f30083c1b59d95d$var$_objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function $6f30083c1b59d95d$var$_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
var $6f30083c1b59d95d$var$Moon = (0, $bh6RR.forwardRef)(function(_ref, ref) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? "currentColor" : _ref$color, _ref$size = _ref.size, size = _ref$size === void 0 ? 24 : _ref$size, rest = $6f30083c1b59d95d$var$_objectWithoutProperties(_ref, [
        "color",
        "size"
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement("svg", $6f30083c1b59d95d$var$_extends({
        ref: ref,
        xmlns: "http://www.w3.org/2000/svg",
        width: size,
        height: size,
        viewBox: "0 0 24 24",
        fill: "none",
        stroke: color,
        strokeWidth: "2",
        strokeLinecap: "round",
        strokeLinejoin: "round"
    }, rest), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement("path", {
        d: "M21 12.79A9 9 0 1 1 11.21 3 7 7 0 0 0 21 12.79z"
    }));
});
$6f30083c1b59d95d$var$Moon.propTypes = {
    color: (0, (/*@__PURE__*/$parcel$interopDefault($aa40b802dd2fccfc$exports))).string,
    size: (0, (/*@__PURE__*/$parcel$interopDefault($aa40b802dd2fccfc$exports))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($aa40b802dd2fccfc$exports))).string,
        (0, (/*@__PURE__*/$parcel$interopDefault($aa40b802dd2fccfc$exports))).number
    ])
};
$6f30083c1b59d95d$var$Moon.displayName = "Moon";
var $6f30083c1b59d95d$export$2e2bcd8739ae039 = $6f30083c1b59d95d$var$Moon;


var $bh6RR = parcelRequire("bh6RR");

function $97380dd89b43ffb4$var$_extends() {
    $97380dd89b43ffb4$var$_extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $97380dd89b43ffb4$var$_extends.apply(this, arguments);
}
function $97380dd89b43ffb4$var$_objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = $97380dd89b43ffb4$var$_objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function $97380dd89b43ffb4$var$_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
var $97380dd89b43ffb4$var$Sun = (0, $bh6RR.forwardRef)(function(_ref, ref) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? "currentColor" : _ref$color, _ref$size = _ref.size, size = _ref$size === void 0 ? 24 : _ref$size, rest = $97380dd89b43ffb4$var$_objectWithoutProperties(_ref, [
        "color",
        "size"
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement("svg", $97380dd89b43ffb4$var$_extends({
        ref: ref,
        xmlns: "http://www.w3.org/2000/svg",
        width: size,
        height: size,
        viewBox: "0 0 24 24",
        fill: "none",
        stroke: color,
        strokeWidth: "2",
        strokeLinecap: "round",
        strokeLinejoin: "round"
    }, rest), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement("circle", {
        cx: "12",
        cy: "12",
        r: "5"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement("line", {
        x1: "12",
        y1: "1",
        x2: "12",
        y2: "3"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement("line", {
        x1: "12",
        y1: "21",
        x2: "12",
        y2: "23"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement("line", {
        x1: "4.22",
        y1: "4.22",
        x2: "5.64",
        y2: "5.64"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement("line", {
        x1: "18.36",
        y1: "18.36",
        x2: "19.78",
        y2: "19.78"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement("line", {
        x1: "1",
        y1: "12",
        x2: "3",
        y2: "12"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement("line", {
        x1: "21",
        y1: "12",
        x2: "23",
        y2: "12"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement("line", {
        x1: "4.22",
        y1: "19.78",
        x2: "5.64",
        y2: "18.36"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement("line", {
        x1: "18.36",
        y1: "5.64",
        x2: "19.78",
        y2: "4.22"
    }));
});
$97380dd89b43ffb4$var$Sun.propTypes = {
    color: (0, (/*@__PURE__*/$parcel$interopDefault($aa40b802dd2fccfc$exports))).string,
    size: (0, (/*@__PURE__*/$parcel$interopDefault($aa40b802dd2fccfc$exports))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($aa40b802dd2fccfc$exports))).string,
        (0, (/*@__PURE__*/$parcel$interopDefault($aa40b802dd2fccfc$exports))).number
    ])
};
$97380dd89b43ffb4$var$Sun.displayName = "Sun";
var $97380dd89b43ffb4$export$2e2bcd8739ae039 = $97380dd89b43ffb4$var$Sun;



const $41f8a5367d186866$export$3407ea1c46ff4268 = 12;
const $41f8a5367d186866$export$56d196d2844d1ca1 = {
    darkBlue: {
        elements: `hsl(209deg 23% 22%)`,
        background: `hsl(207deg 26% 17%)`,
        text: `hsl(200deg 15% 8%)`
    },
    darkGray: {
        input: `hsl(0deg 0% 52%)`
    },
    lightGray: {
        background: `hsl(0deg 0% 98%)`
    },
    white: `hsl(0deg 0% 100%)`
};
const $41f8a5367d186866$export$caa8b992bc9d96e3 = {
    light: 300,
    bold: 600,
    extrabold: 800
};
const $41f8a5367d186866$export$426e07cd0772984d = {
    laptopMax: 1440,
    tabletMax: 1100,
    mobileMax: 550
};
const $41f8a5367d186866$export$538a4a49c4b9cbab = {
    laptopAndSmaller: `(max-width: ${$41f8a5367d186866$export$426e07cd0772984d.laptopMax / 16}rem)`,
    tabletAndSmaller: `(max-width: ${$41f8a5367d186866$export$426e07cd0772984d.tabletMax / 16}rem)`,
    mobileAndSmaller: `(max-width: ${$41f8a5367d186866$export$426e07cd0772984d.mobileMax / 16}rem)`
};
const $41f8a5367d186866$export$a08edecc0325c594 = {
    small: `
    0.5px 1px 1px hsl(var(--shadow-color) / 0.7)
  `,
    medium: `
    1px 2px 2px hsl(var(--shadow-color) / 0.333),
    2px 4px 4px hsl(var(--shadow-color) / 0.333),
    3px 6px 6px hsl(var(--shadow-color) / 0.333)
  `,
    large: `
    1px 2px 2px hsl(var(--shadow-color) / 0.2),
    2px 4px 4px hsl(var(--shadow-color) / 0.2),
    4px 8px 8px hsl(var(--shadow-color) / 0.2),
    8px 16px 16px hsl(var(--shadow-color) / 0.2),
    16px 32px 32px hsl(var(--shadow-color) / 0.2)
  `
}; /*
    --dark-blue-elements: hsl(209, 23%, 22%)
    --dark-blue-background: hsl(207, 26%, 17%)
    --dark-blue-text: hsl(200, 15%, 8%)
    --dark-gray-input: hsl(0, 0%, 52%)
    --light-gray-background: hsl(0, 0%, 98%)
    --white: hsl(0, 0%, 100%)
*/ 


function $02ce57c81a0104d3$var$Header({ theme: theme, themeToggler: themeToggler }) {
    return /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)($02ce57c81a0104d3$var$Wrapper, {
        children: /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)($02ce57c81a0104d3$var$Content, {
            children: [
                /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)($02ce57c81a0104d3$var$Title, {
                    children: "Where in the world?"
                }),
                /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)($02ce57c81a0104d3$var$ThemeButton, {
                    onClick: themeToggler,
                    children: theme === "light" ? /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)((0, $d4dab640dcbe486c$exports.Fragment), {
                        children: [
                            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $6f30083c1b59d95d$export$2e2bcd8739ae039), {
                                size: 14
                            }),
                            "Dark Mode"
                        ]
                    }) : /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)((0, $d4dab640dcbe486c$exports.Fragment), {
                        children: [
                            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $97380dd89b43ffb4$export$2e2bcd8739ae039), {
                                size: 14
                            }),
                            "Light Mode"
                        ]
                    })
                })
            ]
        })
    });
}
const $02ce57c81a0104d3$var$Wrapper = (0, $e484c752f3f06549$export$2e2bcd8739ae039).header.withConfig({
    displayName: "Header__Wrapper",
    componentId: "sc-hk3otr-0"
})([
    "background-color:",
    ";box-shadow:",
    ";margin-bottom:32px;"
], ({ theme: theme })=>theme.elements, (0, $41f8a5367d186866$export$a08edecc0325c594).small);
const $02ce57c81a0104d3$var$Content = (0, $e484c752f3f06549$export$2e2bcd8739ae039)((0, $cb3c883d63db9e8e$export$2e2bcd8739ae039)).withConfig({
    displayName: "Header__Content",
    componentId: "sc-hk3otr-1"
})([
    "display:flex;padding:16px;"
]);
const $02ce57c81a0104d3$var$Title = (0, $e484c752f3f06549$export$2e2bcd8739ae039).h1.withConfig({
    displayName: "Header__Title",
    componentId: "sc-hk3otr-2"
})([
    "font-size:16px;"
]);
const $02ce57c81a0104d3$var$ThemeButton = (0, $e484c752f3f06549$export$2e2bcd8739ae039).button.withConfig({
    displayName: "Header__ThemeButton",
    componentId: "sc-hk3otr-3"
})([
    "padding:8px;margin:-8px;margin-left:auto;font-size:14px;display:flex;align-items:center;justify-content:center;gap:8px;"
]);
var $02ce57c81a0104d3$export$2e2bcd8739ae039 = $02ce57c81a0104d3$var$Header;






var $bh6RR = parcelRequire("bh6RR");

parcelRequire("bh6RR");


var $bh6RR = parcelRequire("bh6RR");

function $9951a200f74894aa$var$_extends() {
    $9951a200f74894aa$var$_extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $9951a200f74894aa$var$_extends.apply(this, arguments);
}
function $9951a200f74894aa$var$_objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = $9951a200f74894aa$var$_objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function $9951a200f74894aa$var$_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
var $9951a200f74894aa$var$CornerDownLeft = (0, $bh6RR.forwardRef)(function(_ref, ref) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? "currentColor" : _ref$color, _ref$size = _ref.size, size = _ref$size === void 0 ? 24 : _ref$size, rest = $9951a200f74894aa$var$_objectWithoutProperties(_ref, [
        "color",
        "size"
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement("svg", $9951a200f74894aa$var$_extends({
        ref: ref,
        xmlns: "http://www.w3.org/2000/svg",
        width: size,
        height: size,
        viewBox: "0 0 24 24",
        fill: "none",
        stroke: color,
        strokeWidth: "2",
        strokeLinecap: "round",
        strokeLinejoin: "round"
    }, rest), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement("polyline", {
        points: "9 10 4 15 9 20"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement("path", {
        d: "M20 4v7a4 4 0 0 1-4 4H4"
    }));
});
$9951a200f74894aa$var$CornerDownLeft.propTypes = {
    color: (0, (/*@__PURE__*/$parcel$interopDefault($aa40b802dd2fccfc$exports))).string,
    size: (0, (/*@__PURE__*/$parcel$interopDefault($aa40b802dd2fccfc$exports))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($aa40b802dd2fccfc$exports))).string,
        (0, (/*@__PURE__*/$parcel$interopDefault($aa40b802dd2fccfc$exports))).number
    ])
};
$9951a200f74894aa$var$CornerDownLeft.displayName = "CornerDownLeft";
var $9951a200f74894aa$export$2e2bcd8739ae039 = $9951a200f74894aa$var$CornerDownLeft;



function $0d8704a8d6951237$var$InfoDetail({ label: label, children: children }) {
    return /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)("p", {
        children: [
            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)("strong", {
                children: [
                    label,
                    ":"
                ]
            }),
            " ",
            children
        ]
    });
}
function $0d8704a8d6951237$var$CountryDetail({ country: country, handleGoBack: handleGoBack, countries: countries, handleCountrySelect: handleCountrySelect }) {
    const { flag: flag, countryName: countryName, nativeNames: nativeNames, population: population, region: region, subregion: subregion, capital: capital, topLevelDomain: topLevelDomain, currencies: currencies, languages: languages, borders: borders } = country;
    const borderCountries = borders?.length > 0 ? countries.filter((country)=>borders.includes(country.alpha3Code)) : null;
    return /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)((0, $d4dab640dcbe486c$exports.Fragment), {
        children: [
            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)($0d8704a8d6951237$var$BackButton, {
                onClick: handleGoBack,
                children: [
                    /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)($0d8704a8d6951237$var$IconWrapper, {
                        children: /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $9951a200f74894aa$export$2e2bcd8739ae039), {
                            size: 24,
                            strokeWidth: 1.5
                        })
                    }),
                    /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)($0d8704a8d6951237$var$ButtonText, {
                        children: "Back to Home"
                    })
                ]
            }),
            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)($0d8704a8d6951237$var$SectionWrapper, {
                children: [
                    /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)($0d8704a8d6951237$var$ImageWrapper, {
                        children: /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)($0d8704a8d6951237$var$Image, {
                            src: flag,
                            alt: `Flag of ${countryName}`
                        })
                    }),
                    /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)($0d8704a8d6951237$var$DetailsWrapper, {
                        children: [
                            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)($0d8704a8d6951237$var$Heading, {
                                children: countryName
                            }),
                            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)($0d8704a8d6951237$var$Info, {
                                children: [
                                    nativeNames.length > 0 && /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)($0d8704a8d6951237$var$InfoDetail, {
                                        label: nativeNames.length > 1 ? "Native names" : "Native name",
                                        children: nativeNames.join(", ")
                                    }),
                                    Number.isFinite(population) && /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)($0d8704a8d6951237$var$InfoDetail, {
                                        label: "Population",
                                        children: population.toLocaleString()
                                    }),
                                    region && /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)($0d8704a8d6951237$var$InfoDetail, {
                                        label: "Region",
                                        children: region
                                    }),
                                    subregion && /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)($0d8704a8d6951237$var$InfoDetail, {
                                        label: "Sub Region",
                                        children: subregion
                                    }),
                                    capital && /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)($0d8704a8d6951237$var$InfoDetail, {
                                        label: "Capital",
                                        children: capital
                                    }),
                                    topLevelDomain && /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)($0d8704a8d6951237$var$InfoDetail, {
                                        label: "Top Level Domain",
                                        children: topLevelDomain
                                    }),
                                    currencies && currencies.length > 0 && /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)($0d8704a8d6951237$var$InfoDetail, {
                                        label: currencies.length > 1 ? "Currencies" : "Currency",
                                        children: currencies.join(", ")
                                    }),
                                    languages && languages.length > 0 && /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)($0d8704a8d6951237$var$InfoDetail, {
                                        label: languages.length > 1 ? "Languages" : "Language",
                                        children: languages.join(", ")
                                    })
                                ]
                            }),
                            borderCountries && borderCountries.length > 0 && /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)("div", {
                                children: [
                                    /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("strong", {
                                        children: "Border Countries:"
                                    }),
                                    " ",
                                    /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)($0d8704a8d6951237$var$Tags, {
                                        children: borderCountries.map((country)=>/*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)($0d8704a8d6951237$var$Tag, {
                                                children: /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)($0d8704a8d6951237$var$TagButton, {
                                                    onClick: ()=>handleCountrySelect(country),
                                                    children: country.countryName
                                                })
                                            }, country.numericCode))
                                    })
                                ]
                            })
                        ]
                    })
                ]
            })
        ]
    });
}
const $0d8704a8d6951237$var$BackButton = (0, $e484c752f3f06549$export$2e2bcd8739ae039).button.withConfig({
    displayName: "CountryDetail__BackButton",
    componentId: "sc-kdd7zn-0"
})([
    "padding:12px 16px;position:relative;padding-left:44px;border-radius:8px;background:",
    ";box-shadow:",
    ";font-size:14px;will-change:transform;&:hover{box-shadow:",
    ";transform:scale(1.01);}"
], ({ theme: theme })=>theme.elements, (0, $41f8a5367d186866$export$a08edecc0325c594).medium, (0, $41f8a5367d186866$export$a08edecc0325c594).large);
const $0d8704a8d6951237$var$IconWrapper = (0, $e484c752f3f06549$export$2e2bcd8739ae039).div.withConfig({
    displayName: "CountryDetail__IconWrapper",
    componentId: "sc-kdd7zn-1"
})([
    "position:absolute;top:0;bottom:0;left:12px;margin:auto;height:24px;"
]);
const $0d8704a8d6951237$var$ButtonText = (0, $e484c752f3f06549$export$2e2bcd8739ae039).span.withConfig({
    displayName: "CountryDetail__ButtonText",
    componentId: "sc-kdd7zn-2"
})([
    "display:block;"
]);
const $0d8704a8d6951237$var$SectionWrapper = (0, $e484c752f3f06549$export$2e2bcd8739ae039).section.withConfig({
    displayName: "CountryDetail__SectionWrapper",
    componentId: "sc-kdd7zn-3"
})([
    "padding-top:32px;display:flex;gap:64px;@media ",
    "{gap:48px;}@media ",
    "{gap:32px;}@media ",
    "{flex-direction:column;padding-left:8px;padding-right:8px;}"
], ({ theme: theme })=>theme.queries.laptopAndSmaller, ({ theme: theme })=>theme.queries.tabletAndSmaller, ({ theme: theme })=>theme.queries.mobileAndSmaller);
const $0d8704a8d6951237$var$ImageWrapper = (0, $e484c752f3f06549$export$2e2bcd8739ae039).div.withConfig({
    displayName: "CountryDetail__ImageWrapper",
    componentId: "sc-kdd7zn-4"
})([
    "flex:1;overflow:hidden;"
]);
const $0d8704a8d6951237$var$Image = (0, $e484c752f3f06549$export$2e2bcd8739ae039).img.withConfig({
    displayName: "CountryDetail__Image",
    componentId: "sc-kdd7zn-5"
})([
    "width:100%;object-fit:cover;aspect-ratio:3 / 2;border-radius:4px;"
]);
const $0d8704a8d6951237$var$DetailsWrapper = (0, $e484c752f3f06549$export$2e2bcd8739ae039).div.withConfig({
    displayName: "CountryDetail__DetailsWrapper",
    componentId: "sc-kdd7zn-6"
})([
    "flex:1;display:flex;flex-direction:column;gap:32px;@media ",
    "{gap:16px;}"
], ({ theme: theme })=>theme.queries.mobileAndSmaller);
const $0d8704a8d6951237$var$Heading = (0, $e484c752f3f06549$export$2e2bcd8739ae039).h2.withConfig({
    displayName: "CountryDetail__Heading",
    componentId: "sc-kdd7zn-7"
})([
    ""
]);
const $0d8704a8d6951237$var$Info = (0, $e484c752f3f06549$export$2e2bcd8739ae039).div.withConfig({
    displayName: "CountryDetail__Info",
    componentId: "sc-kdd7zn-8"
})([
    "columns:2;column-gap:16px;& p:not(:last-child){margin-bottom:4px;}@media ",
    "{columns:1;}"
], ({ theme: theme })=>theme.queries.tabletAndSmaller);
const $0d8704a8d6951237$var$Tags = (0, $e484c752f3f06549$export$2e2bcd8739ae039).ul.withConfig({
    displayName: "CountryDetail__Tags",
    componentId: "sc-kdd7zn-9"
})([
    "display:inline;list-style:none;padding:4px 0;padding-left:16px;"
]);
const $0d8704a8d6951237$var$Tag = (0, $e484c752f3f06549$export$2e2bcd8739ae039).li.withConfig({
    displayName: "CountryDetail__Tag",
    componentId: "sc-kdd7zn-10"
})([
    "display:inline-block;margin-bottom:8px;&:not(:last-of-type){margin-right:8px;}"
]);
const $0d8704a8d6951237$var$TagButton = (0, $e484c752f3f06549$export$2e2bcd8739ae039).button.withConfig({
    displayName: "CountryDetail__TagButton",
    componentId: "sc-kdd7zn-11"
})([
    "padding:4px 16px;border-radius:4px;background-color:",
    ";box-shadow:",
    ";&:hover{box-shadow:",
    ";transform:scale(1.01);}"
], ({ theme: theme })=>theme.elements, (0, $41f8a5367d186866$export$a08edecc0325c594).small, (0, $41f8a5367d186866$export$a08edecc0325c594).medium);
var $0d8704a8d6951237$export$2e2bcd8739ae039 = $0d8704a8d6951237$var$CountryDetail;






var $bh6RR = parcelRequire("bh6RR");


parcelRequire("bh6RR");


var $bh6RR = parcelRequire("bh6RR");

function $b2f34bbb74584a39$var$_extends() {
    $b2f34bbb74584a39$var$_extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $b2f34bbb74584a39$var$_extends.apply(this, arguments);
}
function $b2f34bbb74584a39$var$_objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = $b2f34bbb74584a39$var$_objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function $b2f34bbb74584a39$var$_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
var $b2f34bbb74584a39$var$ChevronDown = (0, $bh6RR.forwardRef)(function(_ref, ref) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? "currentColor" : _ref$color, _ref$size = _ref.size, size = _ref$size === void 0 ? 24 : _ref$size, rest = $b2f34bbb74584a39$var$_objectWithoutProperties(_ref, [
        "color",
        "size"
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement("svg", $b2f34bbb74584a39$var$_extends({
        ref: ref,
        xmlns: "http://www.w3.org/2000/svg",
        width: size,
        height: size,
        viewBox: "0 0 24 24",
        fill: "none",
        stroke: color,
        strokeWidth: "2",
        strokeLinecap: "round",
        strokeLinejoin: "round"
    }, rest), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement("polyline", {
        points: "6 9 12 15 18 9"
    }));
});
$b2f34bbb74584a39$var$ChevronDown.propTypes = {
    color: (0, (/*@__PURE__*/$parcel$interopDefault($aa40b802dd2fccfc$exports))).string,
    size: (0, (/*@__PURE__*/$parcel$interopDefault($aa40b802dd2fccfc$exports))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($aa40b802dd2fccfc$exports))).string,
        (0, (/*@__PURE__*/$parcel$interopDefault($aa40b802dd2fccfc$exports))).number
    ])
};
$b2f34bbb74584a39$var$ChevronDown.displayName = "ChevronDown";
var $b2f34bbb74584a39$export$2e2bcd8739ae039 = $b2f34bbb74584a39$var$ChevronDown;



var $bh6RR = parcelRequire("bh6RR");
function $94608eec51e6cebf$export$3b0fb6f82ad6f16(value, children) {
    const childArray = (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).Children.toArray(children);
    const selectedChild = childArray.find((child)=>child.props.value === value);
    return selectedChild.props.children;
}



function $a1b07b0aa6ea9233$var$Select({ id: id, value: value, children: children, ...delegated }) {
    /*
    The children are the <option>'s. So this helper dives into the values
    of each of the child elements, find which ones match, and then returns
    the appropriate displayed value.
  */ const displayedValue = (0, $94608eec51e6cebf$export$3b0fb6f82ad6f16)(value, children);
    return /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)($a1b07b0aa6ea9233$var$Wrapper, {
        children: [
            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)($a1b07b0aa6ea9233$var$NativeSelect, {
                id: id,
                value: value,
                ...delegated,
                children: children
            }),
            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)($a1b07b0aa6ea9233$var$PresentationalBit, {
                children: [
                    displayedValue,
                    /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)($a1b07b0aa6ea9233$var$IconWrapper, {
                        children: /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $b2f34bbb74584a39$export$2e2bcd8739ae039), {
                            size: 24,
                            strokeWidth: 1
                        })
                    })
                ]
            })
        ]
    });
}
const $a1b07b0aa6ea9233$var$oscillate = (0, $e484c752f3f06549$export$d25ddfdf17c3ad3e)([
    "0%{transform:translateY(0);}25%{transform:translateY(3px);}50%{transform:translateY(-1px);}75%{transform:translateY(2px);}100%{transform:translateY(0);}"
]);
const $a1b07b0aa6ea9233$var$Wrapper = (0, $e484c752f3f06549$export$2e2bcd8739ae039).div.withConfig({
    displayName: "Select__Wrapper",
    componentId: "sc-1281icn-0"
})([
    "position:relative;width:max-content;"
]);
const $a1b07b0aa6ea9233$var$NativeSelect = (0, $e484c752f3f06549$export$2e2bcd8739ae039).select.withConfig({
    displayName: "Select__NativeSelect",
    componentId: "sc-1281icn-1"
})([
    "position:absolute;top:0;left:0;width:100%;height:100%;opacity:0;"
]);
const $a1b07b0aa6ea9233$var$PresentationalBit = (0, $e484c752f3f06549$export$2e2bcd8739ae039).div.withConfig({
    displayName: "Select__PresentationalBit",
    componentId: "sc-1281icn-2"
})([
    "background-color:",
    ";font-size:14px;padding:12px 16px;border-radius:8px;padding-right:52px;box-shadow:",
    ";",
    ":focus + &{outline:1px dotted #212121;outline:5px auto -webkit-focus-ring-color;}",
    ":hover + &{}"
], ({ theme: theme })=>theme.elements, (0, $41f8a5367d186866$export$a08edecc0325c594).medium, $a1b07b0aa6ea9233$var$NativeSelect, $a1b07b0aa6ea9233$var$NativeSelect);
const $a1b07b0aa6ea9233$var$IconWrapper = (0, $e484c752f3f06549$export$2e2bcd8739ae039).div.withConfig({
    displayName: "Select__IconWrapper",
    componentId: "sc-1281icn-3"
})([
    "position:absolute;top:0;bottom:0;right:10px;margin:auto;height:24px;width:24px;pointer-events:none;",
    ":hover + ",
    " &{animation:",
    " 0.6s ease-out;}"
], $a1b07b0aa6ea9233$var$NativeSelect, $a1b07b0aa6ea9233$var$PresentationalBit, $a1b07b0aa6ea9233$var$oscillate);
var $a1b07b0aa6ea9233$export$2e2bcd8739ae039 = $a1b07b0aa6ea9233$var$Select;





parcelRequire("bh6RR");


var $bh6RR = parcelRequire("bh6RR");

function $5091e65244ff7ba2$var$_extends() {
    $5091e65244ff7ba2$var$_extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $5091e65244ff7ba2$var$_extends.apply(this, arguments);
}
function $5091e65244ff7ba2$var$_objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = $5091e65244ff7ba2$var$_objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function $5091e65244ff7ba2$var$_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
var $5091e65244ff7ba2$var$Search = (0, $bh6RR.forwardRef)(function(_ref, ref) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? "currentColor" : _ref$color, _ref$size = _ref.size, size = _ref$size === void 0 ? 24 : _ref$size, rest = $5091e65244ff7ba2$var$_objectWithoutProperties(_ref, [
        "color",
        "size"
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement("svg", $5091e65244ff7ba2$var$_extends({
        ref: ref,
        xmlns: "http://www.w3.org/2000/svg",
        width: size,
        height: size,
        viewBox: "0 0 24 24",
        fill: "none",
        stroke: color,
        strokeWidth: "2",
        strokeLinecap: "round",
        strokeLinejoin: "round"
    }, rest), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement("circle", {
        cx: "11",
        cy: "11",
        r: "8"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement("line", {
        x1: "21",
        y1: "21",
        x2: "16.65",
        y2: "16.65"
    }));
});
$5091e65244ff7ba2$var$Search.propTypes = {
    color: (0, (/*@__PURE__*/$parcel$interopDefault($aa40b802dd2fccfc$exports))).string,
    size: (0, (/*@__PURE__*/$parcel$interopDefault($aa40b802dd2fccfc$exports))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($aa40b802dd2fccfc$exports))).string,
        (0, (/*@__PURE__*/$parcel$interopDefault($aa40b802dd2fccfc$exports))).number
    ])
};
$5091e65244ff7ba2$var$Search.displayName = "Search";
var $5091e65244ff7ba2$export$2e2bcd8739ae039 = $5091e65244ff7ba2$var$Search;


var $bh6RR = parcelRequire("bh6RR");

function $494f5dd770a03ddd$var$_extends() {
    $494f5dd770a03ddd$var$_extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $494f5dd770a03ddd$var$_extends.apply(this, arguments);
}
function $494f5dd770a03ddd$var$_objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = $494f5dd770a03ddd$var$_objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function $494f5dd770a03ddd$var$_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
var $494f5dd770a03ddd$var$X = (0, $bh6RR.forwardRef)(function(_ref, ref) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? "currentColor" : _ref$color, _ref$size = _ref.size, size = _ref$size === void 0 ? 24 : _ref$size, rest = $494f5dd770a03ddd$var$_objectWithoutProperties(_ref, [
        "color",
        "size"
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement("svg", $494f5dd770a03ddd$var$_extends({
        ref: ref,
        xmlns: "http://www.w3.org/2000/svg",
        width: size,
        height: size,
        viewBox: "0 0 24 24",
        fill: "none",
        stroke: color,
        strokeWidth: "2",
        strokeLinecap: "round",
        strokeLinejoin: "round"
    }, rest), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement("line", {
        x1: "18",
        y1: "6",
        x2: "6",
        y2: "18"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement("line", {
        x1: "6",
        y1: "6",
        x2: "18",
        y2: "18"
    }));
});
$494f5dd770a03ddd$var$X.propTypes = {
    color: (0, (/*@__PURE__*/$parcel$interopDefault($aa40b802dd2fccfc$exports))).string,
    size: (0, (/*@__PURE__*/$parcel$interopDefault($aa40b802dd2fccfc$exports))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($aa40b802dd2fccfc$exports))).string,
        (0, (/*@__PURE__*/$parcel$interopDefault($aa40b802dd2fccfc$exports))).number
    ])
};
$494f5dd770a03ddd$var$X.displayName = "X";
var $494f5dd770a03ddd$export$2e2bcd8739ae039 = $494f5dd770a03ddd$var$X;




var $bh6RR = parcelRequire("bh6RR");

const $5db3838af17558bd$var$VisuallyHidden = ({ children: children, ...delegated })=>{
    const [forceShow, setForceShow] = (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).useState(false);
    (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).useEffect(()=>{
        return;
    }, []);
    if (forceShow) return children;
    return /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)($5db3838af17558bd$var$Wrapper, {
        ...delegated,
        children: children
    });
};
const $5db3838af17558bd$var$Wrapper = (0, $e484c752f3f06549$export$2e2bcd8739ae039).div.withConfig({
    displayName: "VisuallyHidden__Wrapper",
    componentId: "sc-1icltto-0"
})([
    "position:absolute;overflow:hidden;clip:rect(0 0 0 0);height:1px;width:1px;margin:-1px;padding:0;border:0;"
]);
var $5db3838af17558bd$export$2e2bcd8739ae039 = $5db3838af17558bd$var$VisuallyHidden;





function $6423f2b356e6849d$var$IconInput({ id: id, label: label, clearSearchTerm: clearSearchTerm, value: value, ...delegated }) {
    return /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)($6423f2b356e6849d$var$Wrapper, {
        htmlFor: id,
        children: [
            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $5db3838af17558bd$export$2e2bcd8739ae039), {
                children: label
            }),
            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)($6423f2b356e6849d$var$IconWrapper, {
                children: /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $5091e65244ff7ba2$export$2e2bcd8739ae039), {
                    size: 24,
                    strokeWidth: 1.5
                })
            }),
            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)($6423f2b356e6849d$var$TextInput, {
                id: id,
                value: value,
                ...delegated
            }),
            value !== "" && /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)($6423f2b356e6849d$var$ClearButton, {
                type: "button",
                onClick: clearSearchTerm,
                children: /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $494f5dd770a03ddd$export$2e2bcd8739ae039), {
                    size: 24,
                    strokeWidth: 0.5
                })
            })
        ]
    });
}
const $6423f2b356e6849d$var$Wrapper = (0, $e484c752f3f06549$export$2e2bcd8739ae039).label.withConfig({
    displayName: "IconInput__Wrapper",
    componentId: "sc-ck40iv-0"
})([
    "display:flex;position:relative;border-radius:8px;max-width:480px;flex:1 1 480px;margin-right:auto;"
]);
const $6423f2b356e6849d$var$IconWrapper = (0, $e484c752f3f06549$export$2e2bcd8739ae039).div.withConfig({
    displayName: "IconInput__IconWrapper",
    componentId: "sc-ck40iv-1"
})([
    "position:absolute;top:0;bottom:0;left:12px;margin:auto;height:24px;"
]);
const $6423f2b356e6849d$var$TextInput = (0, $e484c752f3f06549$export$2e2bcd8739ae039).input.withConfig({
    displayName: "IconInput__TextInput",
    componentId: "sc-ck40iv-2"
})([
    "padding:12px 16px;padding-left:calc(24px * 2);outline-offset:2px;border:none;border-radius:8px;box-shadow:",
    ";flex:1;background-color:",
    ";&::placeholder{font-size:14px;color:",
    ";}"
], (0, $41f8a5367d186866$export$a08edecc0325c594).medium, ({ theme: theme })=>theme.elements, ({ theme: theme })=>theme.placeholderText);
const $6423f2b356e6849d$var$ClearButton = (0, $e484c752f3f06549$export$2e2bcd8739ae039).button.withConfig({
    displayName: "IconInput__ClearButton",
    componentId: "sc-ck40iv-3"
})([
    "position:absolute;top:0;bottom:0;right:0;height:48px;width:48px;margin:auto;display:grid;place-content:center;"
]);
var $6423f2b356e6849d$export$2e2bcd8739ae039 = $6423f2b356e6849d$var$IconInput;




const $b00c301911a66893$var$REGIONS = [
    "Africa",
    "Americas",
    "Asia",
    "Europe",
    "Oceania"
];
function $b00c301911a66893$var$CountrySearchForm({ searchTerm: searchTerm, handleSearchTermChange: handleSearchTermChange, region: region, handleRegionChange: handleRegionChange }) {
    const id = (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).useId();
    const searchTermId = `${id}-searchTerm`;
    const regionId = `${id}-region`;
    return /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)($b00c301911a66893$var$Wrapper, {
        onSubmit: (ev)=>ev.preventDefault(),
        children: [
            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $6423f2b356e6849d$export$2e2bcd8739ae039), {
                id: searchTermId,
                label: "Search",
                placeholder: "Search for a country...",
                type: "text",
                value: searchTerm,
                onChange: (ev)=>handleSearchTermChange(ev.target.value),
                clearSearchTerm: ()=>handleSearchTermChange("")
            }),
            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)($b00c301911a66893$var$SelectWrapper, {
                children: [
                    /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)($b00c301911a66893$var$SelectLabel, {
                        htmlFor: regionId,
                        children: "Filter by Region:"
                    }),
                    /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)((0, $a1b07b0aa6ea9233$export$2e2bcd8739ae039), {
                        id: regionId,
                        value: region,
                        name: "region",
                        onChange: (event)=>handleRegionChange(event.target.value),
                        children: [
                            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("option", {
                                value: "",
                                children: "All"
                            }),
                            $b00c301911a66893$var$REGIONS.map((region)=>/*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("option", {
                                    value: region,
                                    children: region
                                }, region))
                        ]
                    })
                ]
            })
        ]
    });
}
const $b00c301911a66893$var$Wrapper = (0, $e484c752f3f06549$export$2e2bcd8739ae039).form.withConfig({
    displayName: "CountrySearchForm__Wrapper",
    componentId: "sc-1eacwuv-0"
})([
    "display:flex;align-items:center;gap:16px;margin-bottom:32px;@media ",
    "{display:revert;padding-right:16px;padding-left:16px;}"
], ({ theme: theme })=>theme.queries.tabletAndSmaller);
const $b00c301911a66893$var$SelectWrapper = (0, $e484c752f3f06549$export$2e2bcd8739ae039).div.withConfig({
    displayName: "CountrySearchForm__SelectWrapper",
    componentId: "sc-1eacwuv-1"
})([
    "display:flex;align-items:center;gap:8px;@media ",
    "{margin-top:16px;}"
], ({ theme: theme })=>theme.queries.tabletAndSmaller);
const $b00c301911a66893$var$SelectLabel = (0, $e484c752f3f06549$export$2e2bcd8739ae039).label.withConfig({
    displayName: "CountrySearchForm__SelectLabel",
    componentId: "sc-1eacwuv-2"
})([
    "font-size:14px;text-align:right;"
]);
var $b00c301911a66893$export$2e2bcd8739ae039 = $b00c301911a66893$var$CountrySearchForm;





parcelRequire("bh6RR");


var $bh6RR = parcelRequire("bh6RR");

function $bbdf31144b6041c2$var$_extends() {
    $bbdf31144b6041c2$var$_extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $bbdf31144b6041c2$var$_extends.apply(this, arguments);
}
function $bbdf31144b6041c2$var$_objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = $bbdf31144b6041c2$var$_objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function $bbdf31144b6041c2$var$_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
var $bbdf31144b6041c2$var$ChevronLeft = (0, $bh6RR.forwardRef)(function(_ref, ref) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? "currentColor" : _ref$color, _ref$size = _ref.size, size = _ref$size === void 0 ? 24 : _ref$size, rest = $bbdf31144b6041c2$var$_objectWithoutProperties(_ref, [
        "color",
        "size"
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement("svg", $bbdf31144b6041c2$var$_extends({
        ref: ref,
        xmlns: "http://www.w3.org/2000/svg",
        width: size,
        height: size,
        viewBox: "0 0 24 24",
        fill: "none",
        stroke: color,
        strokeWidth: "2",
        strokeLinecap: "round",
        strokeLinejoin: "round"
    }, rest), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement("polyline", {
        points: "15 18 9 12 15 6"
    }));
});
$bbdf31144b6041c2$var$ChevronLeft.propTypes = {
    color: (0, (/*@__PURE__*/$parcel$interopDefault($aa40b802dd2fccfc$exports))).string,
    size: (0, (/*@__PURE__*/$parcel$interopDefault($aa40b802dd2fccfc$exports))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($aa40b802dd2fccfc$exports))).string,
        (0, (/*@__PURE__*/$parcel$interopDefault($aa40b802dd2fccfc$exports))).number
    ])
};
$bbdf31144b6041c2$var$ChevronLeft.displayName = "ChevronLeft";
var $bbdf31144b6041c2$export$2e2bcd8739ae039 = $bbdf31144b6041c2$var$ChevronLeft;


var $bh6RR = parcelRequire("bh6RR");

function $1c12e48e733dfd06$var$_extends() {
    $1c12e48e733dfd06$var$_extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $1c12e48e733dfd06$var$_extends.apply(this, arguments);
}
function $1c12e48e733dfd06$var$_objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = $1c12e48e733dfd06$var$_objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function $1c12e48e733dfd06$var$_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
var $1c12e48e733dfd06$var$ChevronRight = (0, $bh6RR.forwardRef)(function(_ref, ref) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? "currentColor" : _ref$color, _ref$size = _ref.size, size = _ref$size === void 0 ? 24 : _ref$size, rest = $1c12e48e733dfd06$var$_objectWithoutProperties(_ref, [
        "color",
        "size"
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement("svg", $1c12e48e733dfd06$var$_extends({
        ref: ref,
        xmlns: "http://www.w3.org/2000/svg",
        width: size,
        height: size,
        viewBox: "0 0 24 24",
        fill: "none",
        stroke: color,
        strokeWidth: "2",
        strokeLinecap: "round",
        strokeLinejoin: "round"
    }, rest), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement("polyline", {
        points: "9 18 15 12 9 6"
    }));
});
$1c12e48e733dfd06$var$ChevronRight.propTypes = {
    color: (0, (/*@__PURE__*/$parcel$interopDefault($aa40b802dd2fccfc$exports))).string,
    size: (0, (/*@__PURE__*/$parcel$interopDefault($aa40b802dd2fccfc$exports))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($aa40b802dd2fccfc$exports))).string,
        (0, (/*@__PURE__*/$parcel$interopDefault($aa40b802dd2fccfc$exports))).number
    ])
};
$1c12e48e733dfd06$var$ChevronRight.displayName = "ChevronRight";
var $1c12e48e733dfd06$export$2e2bcd8739ae039 = $1c12e48e733dfd06$var$ChevronRight;


var $bh6RR = parcelRequire("bh6RR");

function $a55d98b6ed8acbde$var$_extends() {
    $a55d98b6ed8acbde$var$_extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $a55d98b6ed8acbde$var$_extends.apply(this, arguments);
}
function $a55d98b6ed8acbde$var$_objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = $a55d98b6ed8acbde$var$_objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function $a55d98b6ed8acbde$var$_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
var $a55d98b6ed8acbde$var$ChevronsLeft = (0, $bh6RR.forwardRef)(function(_ref, ref) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? "currentColor" : _ref$color, _ref$size = _ref.size, size = _ref$size === void 0 ? 24 : _ref$size, rest = $a55d98b6ed8acbde$var$_objectWithoutProperties(_ref, [
        "color",
        "size"
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement("svg", $a55d98b6ed8acbde$var$_extends({
        ref: ref,
        xmlns: "http://www.w3.org/2000/svg",
        width: size,
        height: size,
        viewBox: "0 0 24 24",
        fill: "none",
        stroke: color,
        strokeWidth: "2",
        strokeLinecap: "round",
        strokeLinejoin: "round"
    }, rest), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement("polyline", {
        points: "11 17 6 12 11 7"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement("polyline", {
        points: "18 17 13 12 18 7"
    }));
});
$a55d98b6ed8acbde$var$ChevronsLeft.propTypes = {
    color: (0, (/*@__PURE__*/$parcel$interopDefault($aa40b802dd2fccfc$exports))).string,
    size: (0, (/*@__PURE__*/$parcel$interopDefault($aa40b802dd2fccfc$exports))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($aa40b802dd2fccfc$exports))).string,
        (0, (/*@__PURE__*/$parcel$interopDefault($aa40b802dd2fccfc$exports))).number
    ])
};
$a55d98b6ed8acbde$var$ChevronsLeft.displayName = "ChevronsLeft";
var $a55d98b6ed8acbde$export$2e2bcd8739ae039 = $a55d98b6ed8acbde$var$ChevronsLeft;


var $bh6RR = parcelRequire("bh6RR");

function $c3105ab466389726$var$_extends() {
    $c3105ab466389726$var$_extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $c3105ab466389726$var$_extends.apply(this, arguments);
}
function $c3105ab466389726$var$_objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = $c3105ab466389726$var$_objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function $c3105ab466389726$var$_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
var $c3105ab466389726$var$ChevronsRight = (0, $bh6RR.forwardRef)(function(_ref, ref) {
    var _ref$color = _ref.color, color = _ref$color === void 0 ? "currentColor" : _ref$color, _ref$size = _ref.size, size = _ref$size === void 0 ? 24 : _ref$size, rest = $c3105ab466389726$var$_objectWithoutProperties(_ref, [
        "color",
        "size"
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement("svg", $c3105ab466389726$var$_extends({
        ref: ref,
        xmlns: "http://www.w3.org/2000/svg",
        width: size,
        height: size,
        viewBox: "0 0 24 24",
        fill: "none",
        stroke: color,
        strokeWidth: "2",
        strokeLinecap: "round",
        strokeLinejoin: "round"
    }, rest), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement("polyline", {
        points: "13 17 18 12 13 7"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).createElement("polyline", {
        points: "6 17 11 12 6 7"
    }));
});
$c3105ab466389726$var$ChevronsRight.propTypes = {
    color: (0, (/*@__PURE__*/$parcel$interopDefault($aa40b802dd2fccfc$exports))).string,
    size: (0, (/*@__PURE__*/$parcel$interopDefault($aa40b802dd2fccfc$exports))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($aa40b802dd2fccfc$exports))).string,
        (0, (/*@__PURE__*/$parcel$interopDefault($aa40b802dd2fccfc$exports))).number
    ])
};
$c3105ab466389726$var$ChevronsRight.displayName = "ChevronsRight";
var $c3105ab466389726$export$2e2bcd8739ae039 = $c3105ab466389726$var$ChevronsRight;



parcelRequire("bh6RR");


parcelRequire("bh6RR");


function $ba5acfb455c2167d$var$Card({ children: children, onClick: onClick = null }) {
    return /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $d4dab640dcbe486c$exports.Fragment), {
        children: onClick ? /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)($ba5acfb455c2167d$var$StyledButton, {
            onClick: onClick,
            children: /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)($ba5acfb455c2167d$var$ContentWrapper, {
                children: children
            })
        }) : /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)($ba5acfb455c2167d$var$StyledDiv, {
            children: /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)($ba5acfb455c2167d$var$ContentWrapper, {
                children: children
            })
        })
    });
}
const $ba5acfb455c2167d$var$StyledDiv = (0, $e484c752f3f06549$export$2e2bcd8739ae039).div.withConfig({
    displayName: "Card__StyledDiv",
    componentId: "sc-1pgh4h4-0"
})([
    "display:flex;flex-direction:column;justify-content:stretch;"
]);
const $ba5acfb455c2167d$var$StyledButton = (0, $e484c752f3f06549$export$2e2bcd8739ae039).button.withConfig({
    displayName: "Card__StyledButton",
    componentId: "sc-1pgh4h4-1"
})([
    "display:flex;flex-direction:column;justify-content:stretch;cursor:pointer;"
]);
const $ba5acfb455c2167d$var$ContentWrapper = (0, $e484c752f3f06549$export$2e2bcd8739ae039).article.withConfig({
    displayName: "Card__ContentWrapper",
    componentId: "sc-1pgh4h4-2"
})([
    "flex-grow:1;width:100%;padding:16px;background-color:",
    ";border-radius:8px;box-shadow:",
    ";overflow:hidden;&:hover,&:focus{box-shadow:",
    ";transform:scale(1.01);}"
], ({ theme: theme })=>theme.elements, (0, $41f8a5367d186866$export$a08edecc0325c594).medium, (0, $41f8a5367d186866$export$a08edecc0325c594).large);
var $ba5acfb455c2167d$export$2e2bcd8739ae039 = $ba5acfb455c2167d$var$Card;




function $2db74d7458784377$var$CountryCard({ country: country, handleCountrySelect: handleCountrySelect }) {
    const { countryName: countryName, population: population, flag: flag, region: region, capital: capital } = country;
    return /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)((0, $ba5acfb455c2167d$export$2e2bcd8739ae039), {
        onClick: ()=>handleCountrySelect(country),
        children: [
            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)($2db74d7458784377$var$ImageWrapper, {
                children: /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)($2db74d7458784377$var$Image, {
                    alt: `Flag of ${countryName}`,
                    src: flag
                })
            }),
            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)($2db74d7458784377$var$Details, {
                children: [
                    /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)($2db74d7458784377$var$Heading, {
                        children: countryName
                    }),
                    Number.isFinite(population) && /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)("p", {
                        children: [
                            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("strong", {
                                children: "Population:"
                            }),
                            " ",
                            population.toLocaleString()
                        ]
                    }),
                    region && /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)("p", {
                        children: [
                            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("strong", {
                                children: "Region:"
                            }),
                            " ",
                            region
                        ]
                    }),
                    capital && /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)("p", {
                        children: [
                            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("strong", {
                                children: "Capital:"
                            }),
                            " ",
                            capital
                        ]
                    })
                ]
            })
        ]
    });
}
const $2db74d7458784377$var$ImageWrapper = (0, $e484c752f3f06549$export$2e2bcd8739ae039).div.withConfig({
    displayName: "CountryCard__ImageWrapper",
    componentId: "sc-6wfgs5-0"
})([
    "margin:-16px;margin-bottom:16px;height:150px;overflow:hidden;"
]);
const $2db74d7458784377$var$Image = (0, $e484c752f3f06549$export$2e2bcd8739ae039).img.withConfig({
    displayName: "CountryCard__Image",
    componentId: "sc-6wfgs5-1"
})([
    "display:block;height:100%;width:100%;object-fit:cover;"
]);
const $2db74d7458784377$var$Details = (0, $e484c752f3f06549$export$2e2bcd8739ae039).section.withConfig({
    displayName: "CountryCard__Details",
    componentId: "sc-6wfgs5-2"
})([
    "margin-bottom:-16px;padding-bottom:32px;font-size:14px;"
]);
const $2db74d7458784377$var$Heading = (0, $e484c752f3f06549$export$2e2bcd8739ae039).h2.withConfig({
    displayName: "CountryCard__Heading",
    componentId: "sc-6wfgs5-3"
})([
    "font-size:16px;margin-bottom:8px;"
]);
var $2db74d7458784377$export$2e2bcd8739ae039 = $2db74d7458784377$var$CountryCard;





function $9f5407930d775fe8$var$CountryResultsGrid({ handleCountrySelect: handleCountrySelect, countries: countries, currentPage: currentPage, totalPages: totalPages, handlePageChange: handlePageChange }) {
    return /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)((0, $d4dab640dcbe486c$exports.Fragment), {
        children: [
            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)($9f5407930d775fe8$var$Wrapper, {
                children: countries?.map((country)=>/*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $2db74d7458784377$export$2e2bcd8739ae039), {
                        country: country,
                        handleCountrySelect: handleCountrySelect
                    }, country.numericCode))
            }),
            totalPages > 1 && /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)($9f5407930d775fe8$var$PaginationWrapper, {
                children: [
                    /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)($9f5407930d775fe8$var$Button, {
                        onClick: ()=>handlePageChange(1),
                        disabled: currentPage === 1,
                        children: /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $a55d98b6ed8acbde$export$2e2bcd8739ae039), {
                            size: 24,
                            strokeWidth: 1.5
                        })
                    }),
                    /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)($9f5407930d775fe8$var$Button, {
                        onClick: ()=>handlePageChange(currentPage - 1),
                        disabled: currentPage === 1,
                        children: /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $bbdf31144b6041c2$export$2e2bcd8739ae039), {
                            size: 24,
                            strokeWidth: 1.5
                        })
                    }),
                    /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)($9f5407930d775fe8$var$PageInfo, {
                        children: [
                            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)($9f5407930d775fe8$var$PageSpan, {
                                children: "Page "
                            }),
                            `${currentPage} / ${totalPages}`
                        ]
                    }),
                    /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)($9f5407930d775fe8$var$Button, {
                        onClick: ()=>handlePageChange(currentPage + 1),
                        disabled: currentPage === totalPages,
                        children: /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $1c12e48e733dfd06$export$2e2bcd8739ae039), {
                            size: 24,
                            strokeWidth: 1.5
                        })
                    }),
                    /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)($9f5407930d775fe8$var$Button, {
                        onClick: ()=>handlePageChange(totalPages),
                        disabled: currentPage === totalPages,
                        children: /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $c3105ab466389726$export$2e2bcd8739ae039), {
                            size: 24,
                            strokeWidth: 1.5
                        })
                    })
                ]
            })
        ]
    });
}
const $9f5407930d775fe8$var$Wrapper = (0, $e484c752f3f06549$export$2e2bcd8739ae039).div.withConfig({
    displayName: "CountryResultsGrid__Wrapper",
    componentId: "sc-1kgfvbg-0"
})([
    "display:grid;gap:48px;grid-template-columns:repeat(auto-fill,minmax(250px,1fr));justify-items:stretch;@media ",
    "{gap:32px;padding-left:16px;padding-right:16px;}@media ",
    "{padding-left:32px;padding-right:32px;}"
], ({ theme: theme })=>theme.queries.tabletAndSmaller, ({ theme: theme })=>theme.queries.mobileAndSmaller);
const $9f5407930d775fe8$var$PaginationWrapper = (0, $e484c752f3f06549$export$2e2bcd8739ae039).div.withConfig({
    displayName: "CountryResultsGrid__PaginationWrapper",
    componentId: "sc-1kgfvbg-1"
})([
    "margin-top:48px;display:flex;justify-content:flex-end;gap:8px;@media ",
    "{justify-content:center;}"
], ({ theme: theme })=>theme.queries.mobileAndSmaller);
const $9f5407930d775fe8$var$Button = (0, $e484c752f3f06549$export$2e2bcd8739ae039).button.withConfig({
    displayName: "CountryResultsGrid__Button",
    componentId: "sc-1kgfvbg-2"
})([
    "padding:12px 16px;border-radius:8px;background-color:",
    ";box-shadow:",
    ";&[disabled]{color:#666;box-shadow:none;filter:brightness(95%);&:hover{cursor:revert;}}"
], ({ theme: theme })=>theme.elements, (0, $41f8a5367d186866$export$a08edecc0325c594).small);
const $9f5407930d775fe8$var$PageInfo = (0, $e484c752f3f06549$export$2e2bcd8739ae039).p.withConfig({
    displayName: "CountryResultsGrid__PageInfo",
    componentId: "sc-1kgfvbg-3"
})([
    "padding:12px 16px;border-radius:8px;background-color:",
    ";@media ",
    "{padding-right:8px;padding-left:8px;}"
], ({ theme: theme })=>theme.elements, ({ theme: theme })=>theme.queries.mobileAndSmaller);
const $9f5407930d775fe8$var$PageSpan = (0, $e484c752f3f06549$export$2e2bcd8739ae039).span.withConfig({
    displayName: "CountryResultsGrid__PageSpan",
    componentId: "sc-1kgfvbg-4"
})([
    "@media ",
    "{display:none;}"
], ({ theme: theme })=>theme.queries.mobileAndSmaller);
var $9f5407930d775fe8$export$2e2bcd8739ae039 = $9f5407930d775fe8$var$CountryResultsGrid;





parcelRequire("bh6RR");


function $b2e24922b56df7d9$var$Loader() {
    return /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)($b2e24922b56df7d9$var$Wrapper, {
        children: [
            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $5db3838af17558bd$export$2e2bcd8739ae039), {
                children: "Loading..."
            }),
            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)($b2e24922b56df7d9$var$StyledSvg, {
                viewBox: "0 0 38 38",
                xmlns: "http://www.w3.org/2000/svg",
                stroke: "#000",
                children: /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("g", {
                    fill: "none",
                    fillRule: "evenodd",
                    children: /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)("g", {
                        transform: "translate(1 1)",
                        strokeWidth: "2",
                        children: [
                            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("circle", {
                                strokeOpacity: ".25",
                                cx: "18",
                                cy: "18",
                                r: "18"
                            }),
                            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)("path", {
                                d: "M36 18c0-9.94-8.06-18-18-18"
                            })
                        ]
                    })
                })
            })
        ]
    });
}
const $b2e24922b56df7d9$var$spin = (0, $e484c752f3f06549$export$d25ddfdf17c3ad3e)([
    "from{transform:rotate(-45deg);}to{transform:rotate(315deg);}"
]);
const $b2e24922b56df7d9$var$Wrapper = (0, $e484c752f3f06549$export$2e2bcd8739ae039).div.withConfig({
    displayName: "Loader__Wrapper",
    componentId: "sc-1svj9x7-0"
})([
    "display:flex;justify-content:center;padding:32px;"
]);
const $b2e24922b56df7d9$var$StyledSvg = (0, $e484c752f3f06549$export$2e2bcd8739ae039).svg.withConfig({
    displayName: "Loader__StyledSvg",
    componentId: "sc-1svj9x7-1"
})([
    "width:38px;height:38px;animation:1s ",
    " ease-in-out infinite;& g{& circle{stroke:",
    ";}& path{stroke:",
    ";}}"
], $b2e24922b56df7d9$var$spin, ({ theme: theme })=>theme.loaderTrack, ({ theme: theme })=>theme.loaderFill);
var $b2e24922b56df7d9$export$2e2bcd8739ae039 = $b2e24922b56df7d9$var$Loader;






var $bh6RR = parcelRequire("bh6RR");
const $c2e89246714e26f0$var$sortByCountryName = (a, b)=>{
    if (a.countryName < b.countryName) return -1;
    if (a.countryName > b.countryName) return 1;
    return 0;
};
const $c2e89246714e26f0$export$e5e6ad516e0608c4 = (data)=>{
    return data.map((country)=>{
        return {
            numericCode: country.numericCode || Math.random().toString(),
            alpha3Code: country.alpha3Code,
            flag: country.flag,
            countryName: country.name || null,
            population: Number.isFinite(country.population) ? country.population : null,
            region: country.region || null,
            subregion: country.subregion || null,
            capital: country.capital || null,
            nativeNames: [
                country.nativeName
            ],
            topLevelDomain: country.topLevelDomain || null,
            currencies: country.currencies?.map((cur)=>cur.name) || [],
            languages: country.languages?.map((lang)=>lang.name) || [],
            borders: country.borders || []
        };
    }).sort($c2e89246714e26f0$var$sortByCountryName);
};
const $c2e89246714e26f0$export$f8567c06b2dfb1c1 = (data)=>{
    return data.map((country)=>{
        const nativeNameObj = country.name.nativeName || {};
        const hasMultipleLanguages = Object.keys(nativeNameObj).length > 1;
        const nativeNames = Object.entries(nativeNameObj).map(([key, value])=>{
            return hasMultipleLanguages ? `${value.common} (${key.toUpperCase()})` : value.common;
        });
        const currencies = Object.values(country.currencies || {}).map((cur)=>cur.name);
        const languages = Object.values(country.languages || {});
        return {
            numericCode: country.ccn3 || Math.random().toString(),
            alpha3Code: country.cca3,
            flag: country.flags.svg,
            countryName: country.name.common || null,
            population: country.population || null,
            region: country.region || null,
            subregion: country.subregion || null,
            capital: country.capital?.[0] || null,
            nativeNames: nativeNames,
            topLevelDomain: country.tld?.[0] || null,
            currencies: currencies,
            languages: languages,
            borders: country.borders || []
        };
    }).sort($c2e89246714e26f0$var$sortByCountryName);
};


var $abc5d03f1d982ddc$exports = {};
$abc5d03f1d982ddc$exports = JSON.parse('{"countries":[{"name":"Afghanistan","topLevelDomain":[".af"],"alpha2Code":"AF","alpha3Code":"AFG","callingCodes":["93"],"capital":"Kabul","altSpellings":["AF","Af\u0121\u0101nist\u0101n"],"subregion":"Southern Asia","region":"Asia","population":40218234,"latlng":[33,65],"demonym":"Afghan","area":652230,"timezones":["UTC+04:30"],"borders":["IRN","PAK","TKM","UZB","TJK","CHN"],"nativeName":"\u0627\u0641\u063A\u0627\u0646\u0633\u062A\u0627\u0646","numericCode":"004","flags":{"svg":"https://upload.wikimedia.org/wikipedia/commons/5/5c/Flag_of_the_Taliban.svg","png":"https://upload.wikimedia.org/wikipedia/commons/thumb/5/5c/Flag_of_the_Taliban.svg/320px-Flag_of_the_Taliban.svg.png"},"currencies":[{"code":"AFN","name":"Afghan afghani","symbol":"\u060B"}],"languages":[{"iso639_1":"ps","iso639_2":"pus","name":"Pashto","nativeName":"\u067E\u069A\u062A\u0648"},{"iso639_1":"uz","iso639_2":"uzb","name":"Uzbek","nativeName":"O\u02BBzbek"},{"iso639_1":"tk","iso639_2":"tuk","name":"Turkmen","nativeName":"T\xfcrkmen"}],"translations":{"br":"Afghanistan","pt":"Afeganist\xe3o","nl":"Afghanistan","hr":"Afganistan","fa":"\u0627\u0641\u063A\u0627\u0646\u0633\u062A\u0627\u0646","de":"Afghanistan","es":"Afganist\xe1n","fr":"Afghanistan","ja":"\u30A2\u30D5\u30AC\u30CB\u30B9\u30BF\u30F3","it":"Afghanistan","hu":"Afganiszt\xe1n"},"flag":"https://upload.wikimedia.org/wikipedia/commons/5/5c/Flag_of_the_Taliban.svg","regionalBlocs":[{"acronym":"SAARC","name":"South Asian Association for Regional Cooperation"}],"cioc":"AFG","independent":true},{"name":"\xc5land Islands","topLevelDomain":[".ax"],"alpha2Code":"AX","alpha3Code":"ALA","callingCodes":["358"],"capital":"Mariehamn","altSpellings":["AX","Aaland","Aland","Ahvenanmaa"],"subregion":"Northern Europe","region":"Europe","population":28875,"latlng":[60.116667,19.9],"demonym":"\xc5landish","area":1580,"timezones":["UTC+02:00"],"nativeName":"\xc5land","numericCode":"248","flags":{"svg":"https://flagcdn.com/ax.svg","png":"https://flagcdn.com/w320/ax.png"},"currencies":[{"code":"EUR","name":"Euro","symbol":"\u20AC"}],"languages":[{"iso639_1":"sv","iso639_2":"swe","name":"Swedish","nativeName":"svenska"}],"translations":{"br":"\xc5land","pt":"Ilhas de Aland","nl":"\xc5landeilanden","hr":"\xc5landski otoci","fa":"\u062C\u0632\u0627\u06CC\u0631 \u0627\u0644\u0646\u062F","de":"\xc5land","es":"Alandia","fr":"\xc5land","ja":"\u30AA\u30FC\u30E9\u30F3\u30C9\u8AF8\u5CF6","it":"Isole Aland","hu":"\xc5land-szigetek"},"flag":"https://flagcdn.com/ax.svg","regionalBlocs":[{"acronym":"EU","name":"European Union"}],"independent":false},{"name":"Albania","topLevelDomain":[".al"],"alpha2Code":"AL","alpha3Code":"ALB","callingCodes":["355"],"capital":"Tirana","altSpellings":["AL","Shqip\xebri","Shqip\xebria","Shqipnia"],"subregion":"Southern Europe","region":"Europe","population":2837743,"latlng":[41,20],"demonym":"Albanian","area":28748,"gini":33.2,"timezones":["UTC+01:00"],"borders":["MNE","GRC","MKD","UNK"],"nativeName":"Shqip\xebria","numericCode":"008","flags":{"svg":"https://flagcdn.com/al.svg","png":"https://flagcdn.com/w320/al.png"},"currencies":[{"code":"ALL","name":"Albanian lek","symbol":"L"}],"languages":[{"iso639_1":"sq","iso639_2":"sqi","name":"Albanian","nativeName":"Shqip"}],"translations":{"br":"Albania","pt":"Alb\xe2nia","nl":"Albani\xeb","hr":"Albanija","fa":"\u0622\u0644\u0628\u0627\u0646\u06CC","de":"Albanien","es":"Albania","fr":"Albanie","ja":"\u30A2\u30EB\u30D0\u30CB\u30A2","it":"Albania","hu":"Alb\xe1nia"},"flag":"https://flagcdn.com/al.svg","regionalBlocs":[{"acronym":"CEFTA","name":"Central European Free Trade Agreement"}],"cioc":"ALB","independent":true},{"name":"Algeria","topLevelDomain":[".dz"],"alpha2Code":"DZ","alpha3Code":"DZA","callingCodes":["213"],"capital":"Algiers","altSpellings":["DZ","Dzayer","Alg\xe9rie"],"subregion":"Northern Africa","region":"Africa","population":44700000,"latlng":[28,3],"demonym":"Algerian","area":2381741,"gini":27.6,"timezones":["UTC+01:00"],"borders":["TUN","LBY","NER","ESH","MRT","MLI","MAR"],"nativeName":"\u0627\u0644\u062C\u0632\u0627\u0626\u0631","numericCode":"012","flags":{"svg":"https://flagcdn.com/dz.svg","png":"https://flagcdn.com/w320/dz.png"},"currencies":[{"code":"DZD","name":"Algerian dinar","symbol":"\u062F.\u062C"}],"languages":[{"iso639_1":"ar","iso639_2":"ara","name":"Arabic","nativeName":"\u0627\u0644\u0639\u0631\u0628\u064A\u0629"}],"translations":{"br":"Aljeria","pt":"Arg\xe9lia","nl":"Algerije","hr":"Al\u017Eir","fa":"\u0627\u0644\u062C\u0632\u0627\u06CC\u0631","de":"Algerien","es":"Argelia","fr":"Alg\xe9rie","ja":"\u30A2\u30EB\u30B8\u30A7\u30EA\u30A2","it":"Algeria","hu":"Alg\xe9ria"},"flag":"https://flagcdn.com/dz.svg","regionalBlocs":[{"acronym":"AU","name":"African Union","otherNames":["\u0627\u0644\u0627\u062A\u062D\u0627\u062F \u0627\u0644\u0623\u0641\u0631\u064A\u0642\u064A","Union africaine","Uni\xe3o Africana","Uni\xf3n Africana","Umoja wa Afrika"]},{"acronym":"AL","name":"Arab League","otherNames":["\u062C\u0627\u0645\u0639\u0629 \u0627\u0644\u062F\u0648\u0644 \u0627\u0644\u0639\u0631\u0628\u064A\u0629","J\u0101mi\u02BBat ad-Duwal al-\u02BBArab\u012Byah","League of Arab States"]}],"cioc":"ALG","independent":true},{"name":"American Samoa","topLevelDomain":[".as"],"alpha2Code":"AS","alpha3Code":"ASM","callingCodes":["1"],"capital":"Pago Pago","altSpellings":["AS","Amerika S\u0101moa","Amelika S\u0101moa","S\u0101moa Amelika"],"subregion":"Polynesia","region":"Oceania","population":55197,"latlng":[-14.33333333,-170],"demonym":"American Samoan","area":199,"timezones":["UTC-11:00"],"nativeName":"American Samoa","numericCode":"016","flags":{"svg":"https://flagcdn.com/as.svg","png":"https://flagcdn.com/w320/as.png"},"currencies":[{"code":"USD","name":"United States Dollar","symbol":"$"}],"languages":[{"iso639_1":"en","iso639_2":"eng","name":"English","nativeName":"English"},{"iso639_1":"sm","iso639_2":"smo","name":"Samoan","nativeName":"gagana fa\'a Samoa"}],"translations":{"br":"Samoa Amerikan","pt":"Samoa Americana","nl":"Amerikaans Samoa","hr":"Ameri\u010Dka Samoa","fa":"\u0633\u0627\u0645\u0648\u0622\u06CC \u0622\u0645\u0631\u06CC\u06A9\u0627","de":"Amerikanisch-Samoa","es":"Samoa Americana","fr":"Samoa am\xe9ricaines","ja":"\u30A2\u30E1\u30EA\u30AB\u9818\u30B5\u30E2\u30A2","it":"Samoa Americane","hu":"Amerikai Szamoa"},"flag":"https://flagcdn.com/as.svg","cioc":"ASA","independent":false},{"name":"Andorra","topLevelDomain":[".ad"],"alpha2Code":"AD","alpha3Code":"AND","callingCodes":["376"],"capital":"Andorra la Vella","altSpellings":["AD","Principality of Andorra","Principat d\'Andorra"],"subregion":"Southern Europe","region":"Europe","population":77265,"latlng":[42.5,1.5],"demonym":"Andorran","area":468,"timezones":["UTC+01:00"],"borders":["FRA","ESP"],"nativeName":"Andorra","numericCode":"020","flags":{"svg":"https://flagcdn.com/ad.svg","png":"https://flagcdn.com/w320/ad.png"},"currencies":[{"code":"EUR","name":"Euro","symbol":"\u20AC"}],"languages":[{"iso639_1":"ca","iso639_2":"cat","name":"Catalan","nativeName":"catal\xe0"}],"translations":{"br":"Andorra","pt":"Andorra","nl":"Andorra","hr":"Andora","fa":"\u0622\u0646\u062F\u0648\u0631\u0627","de":"Andorra","es":"Andorra","fr":"Andorre","ja":"\u30A2\u30F3\u30C9\u30E9","it":"Andorra","hu":"Andorra"},"flag":"https://flagcdn.com/ad.svg","cioc":"AND","independent":true},{"name":"Angola","topLevelDomain":[".ao"],"alpha2Code":"AO","alpha3Code":"AGO","callingCodes":["244"],"capital":"Luanda","altSpellings":["AO","Rep\xfablica de Angola","\u0281\u025Bpublika de an\'\u0261\u0254la"],"subregion":"Middle Africa","region":"Africa","population":32866268,"latlng":[-12.5,18.5],"demonym":"Angolan","area":1246700,"gini":51.3,"timezones":["UTC+01:00"],"borders":["COG","COD","ZMB","NAM"],"nativeName":"Angola","numericCode":"024","flags":{"svg":"https://flagcdn.com/ao.svg","png":"https://flagcdn.com/w320/ao.png"},"currencies":[{"code":"AOA","name":"Angolan kwanza","symbol":"Kz"}],"languages":[{"iso639_1":"pt","iso639_2":"por","name":"Portuguese","nativeName":"Portugu\xeas"}],"translations":{"br":"Angola","pt":"Angola","nl":"Angola","hr":"Angola","fa":"\u0622\u0646\u06AF\u0648\u0644\u0627","de":"Angola","es":"Angola","fr":"Angola","ja":"\u30A2\u30F3\u30B4\u30E9","it":"Angola","hu":"Angola"},"flag":"https://flagcdn.com/ao.svg","regionalBlocs":[{"acronym":"AU","name":"African Union","otherNames":["\u0627\u0644\u0627\u062A\u062D\u0627\u062F \u0627\u0644\u0623\u0641\u0631\u064A\u0642\u064A","Union africaine","Uni\xe3o Africana","Uni\xf3n Africana","Umoja wa Afrika"]}],"cioc":"ANG","independent":true},{"name":"Anguilla","topLevelDomain":[".ai"],"alpha2Code":"AI","alpha3Code":"AIA","callingCodes":["1"],"capital":"The Valley","altSpellings":["AI"],"subregion":"Caribbean","region":"Americas","population":13452,"latlng":[18.25,-63.16666666],"demonym":"Anguillian","area":91,"timezones":["UTC-04:00"],"nativeName":"Anguilla","numericCode":"660","flags":{"svg":"https://flagcdn.com/ai.svg","png":"https://flagcdn.com/w320/ai.png"},"currencies":[{"code":"XCD","name":"East Caribbean dollar","symbol":"$"}],"languages":[{"iso639_1":"en","iso639_2":"eng","name":"English","nativeName":"English"}],"translations":{"br":"Anguilla","pt":"Anguila","nl":"Anguilla","hr":"Angvila","fa":"\u0622\u0646\u06AF\u0648\u06CC\u0644\u0627","de":"Anguilla","es":"Anguilla","fr":"Anguilla","ja":"\u30A2\u30F3\u30AE\u30E9","it":"Anguilla","hu":"Anguilla"},"flag":"https://flagcdn.com/ai.svg","independent":false},{"name":"Antarctica","topLevelDomain":[".aq"],"alpha2Code":"AQ","alpha3Code":"ATA","callingCodes":["672"],"subregion":"Antarctica","region":"Polar","population":1000,"latlng":[-74.65,4.48],"demonym":"Antarctic","area":14000000,"timezones":["UTC-03:00","UTC+03:00","UTC+05:00","UTC+06:00","UTC+07:00","UTC+08:00","UTC+10:00","UTC+12:00"],"nativeName":"Antarctica","numericCode":"010","flags":{"svg":"https://flagcdn.com/aq.svg","png":"https://flagcdn.com/w320/aq.png"},"languages":[{"iso639_1":"en","iso639_2":"eng","name":"English","nativeName":"English"},{"iso639_1":"ru","iso639_2":"rus","name":"Russian","nativeName":"\u0420\u0443\u0441\u0441\u043A\u0438\u0439"}],"translations":{"br":"Antarktika","pt":"Ant\xe1rctida","nl":"Antarctica","hr":"Antarktika","fa":"\u062C\u0646\u0648\u0628\u06AF\u0627\u0646","de":"Antarktika","es":"Ant\xe1rtida","fr":"Antarctique","ja":"\u5357\u6975\u5927\u9678","it":"Antartide","hu":"Antarktisz"},"flag":"https://flagcdn.com/aq.svg","independent":false},{"name":"Antigua and Barbuda","topLevelDomain":[".ag"],"alpha2Code":"AG","alpha3Code":"ATG","callingCodes":["1"],"capital":"Saint John\'s","altSpellings":["AG"],"subregion":"Caribbean","region":"Americas","population":97928,"latlng":[17.05,-61.8],"demonym":"Antiguan, Barbudan","area":442,"timezones":["UTC-04:00"],"nativeName":"Antigua and Barbuda","numericCode":"028","flags":{"svg":"https://flagcdn.com/ag.svg","png":"https://flagcdn.com/w320/ag.png"},"currencies":[{"code":"XCD","name":"East Caribbean dollar","symbol":"$"}],"languages":[{"iso639_1":"en","iso639_2":"eng","name":"English","nativeName":"English"}],"translations":{"br":"Antigua ha Barbuda","pt":"Ant\xedgua e Barbuda","nl":"Antigua en Barbuda","hr":"Antigva i Barbuda","fa":"\u0622\u0646\u062A\u06CC\u06AF\u0648\u0627 \u0648 \u0628\u0627\u0631\u0628\u0648\u062F\u0627","de":"Antigua und Barbuda","es":"Antigua y Barbuda","fr":"Antigua-et-Barbuda","ja":"\u30A2\u30F3\u30C6\u30A3\u30B0\u30A2\u30FB\u30D0\u30FC\u30D6\u30FC\u30C0","it":"Antigua e Barbuda","hu":"Antigua \xe9s Barbuda"},"flag":"https://flagcdn.com/ag.svg","regionalBlocs":[{"acronym":"CARICOM","name":"Caribbean Community","otherNames":["Comunidad del Caribe","Communaut\xe9 Carib\xe9enne","Caribische Gemeenschap"]}],"cioc":"ANT","independent":true},{"name":"Argentina","topLevelDomain":[".ar"],"alpha2Code":"AR","alpha3Code":"ARG","callingCodes":["54"],"capital":"Buenos Aires","altSpellings":["AR","Argentine Republic","Rep\xfablica Argentina"],"subregion":"South America","region":"Americas","population":45376763,"latlng":[-34,-64],"demonym":"Argentinean","area":2780400,"gini":42.9,"timezones":["UTC-03:00"],"borders":["BOL","BRA","CHL","PRY","URY"],"nativeName":"Argentina","numericCode":"032","flags":{"svg":"https://flagcdn.com/ar.svg","png":"https://flagcdn.com/w320/ar.png"},"currencies":[{"code":"ARS","name":"Argentine peso","symbol":"$"}],"languages":[{"iso639_1":"es","iso639_2":"spa","name":"Spanish","nativeName":"Espa\xf1ol"},{"iso639_1":"gn","iso639_2":"grn","name":"Guaran\xed","nativeName":"Ava\xf1e\'\u1EBD"}],"translations":{"br":"Arc\'hantina","pt":"Argentina","nl":"Argentini\xeb","hr":"Argentina","fa":"\u0622\u0631\u0698\u0627\u0646\u062A\u06CC\u0646","de":"Argentinien","es":"Argentina","fr":"Argentine","ja":"\u30A2\u30EB\u30BC\u30F3\u30C1\u30F3","it":"Argentina","hu":"Argent\xedna"},"flag":"https://flagcdn.com/ar.svg","regionalBlocs":[{"acronym":"USAN","name":"Union of South American Nations","otherAcronyms":["UNASUR","UNASUL","UZAN"],"otherNames":["Uni\xf3n de Naciones Suramericanas","Uni\xe3o de Na\xe7\xf5es Sul-Americanas","Unie van Zuid-Amerikaanse Naties","South American Union"]}],"cioc":"ARG","independent":true},{"name":"Armenia","topLevelDomain":[".am"],"alpha2Code":"AM","alpha3Code":"ARM","callingCodes":["374"],"capital":"Yerevan","altSpellings":["AM","Hayastan","Republic of Armenia","\u0540\u0561\u0575\u0561\u057D\u057F\u0561\u0576\u056B \u0540\u0561\u0576\u0580\u0561\u057A\u0565\u057F\u0578\u0582\u0569\u0575\u0578\u0582\u0576"],"subregion":"Western Asia","region":"Asia","population":2963234,"latlng":[40,45],"demonym":"Armenian","area":29743,"gini":29.9,"timezones":["UTC+04:00"],"borders":["AZE","GEO","IRN","TUR"],"nativeName":"\u0540\u0561\u0575\u0561\u057D\u057F\u0561\u0576","numericCode":"051","flags":{"svg":"https://flagcdn.com/am.svg","png":"https://flagcdn.com/w320/am.png"},"currencies":[{"code":"AMD","name":"Armenian dram","symbol":"\u058F"}],"languages":[{"iso639_1":"hy","iso639_2":"hye","name":"Armenian","nativeName":"\u0540\u0561\u0575\u0565\u0580\u0565\u0576"}],"translations":{"br":"Armenia","pt":"Arm\xe9nia","nl":"Armeni\xeb","hr":"Armenija","fa":"\u0627\u0631\u0645\u0646\u0633\u062A\u0627\u0646","de":"Armenien","es":"Armenia","fr":"Arm\xe9nie","ja":"\u30A2\u30EB\u30E1\u30CB\u30A2","it":"Armenia","hu":"\xd6rm\xe9nyorsz\xe1g"},"flag":"https://flagcdn.com/am.svg","regionalBlocs":[{"acronym":"EEU","name":"Eurasian Economic Union","otherAcronyms":["EAEU"]}],"cioc":"ARM","independent":true},{"name":"Aruba","topLevelDomain":[".aw"],"alpha2Code":"AW","alpha3Code":"ABW","callingCodes":["297"],"capital":"Oranjestad","altSpellings":["AW"],"subregion":"Caribbean","region":"Americas","population":106766,"latlng":[12.5,-69.96666666],"demonym":"Aruban","area":180,"timezones":["UTC-04:00"],"nativeName":"Aruba","numericCode":"533","flags":{"svg":"https://flagcdn.com/aw.svg","png":"https://flagcdn.com/w320/aw.png"},"currencies":[{"code":"AWG","name":"Aruban florin","symbol":"\u0192"}],"languages":[{"iso639_1":"nl","iso639_2":"nld","name":"Dutch","nativeName":"Nederlands"},{"iso639_1":"pa","iso639_2":"pan","name":"(Eastern) Punjabi","nativeName":"\u0A2A\u0A70\u0A1C\u0A3E\u0A2C\u0A40"}],"translations":{"br":"Aruba","pt":"Aruba","nl":"Aruba","hr":"Aruba","fa":"\u0622\u0631\u0648\u0628\u0627","de":"Aruba","es":"Aruba","fr":"Aruba","ja":"\u30A2\u30EB\u30D0","it":"Aruba","hu":"Aruba"},"flag":"https://flagcdn.com/aw.svg","cioc":"ARU","independent":true},{"name":"Australia","topLevelDomain":[".au"],"alpha2Code":"AU","alpha3Code":"AUS","callingCodes":["61"],"capital":"Canberra","altSpellings":["AU"],"subregion":"Australia and New Zealand","region":"Oceania","population":25687041,"latlng":[-27,133],"demonym":"Australian","area":7692024,"gini":34.4,"timezones":["UTC+05:00","UTC+06:30","UTC+07:00","UTC+08:00","UTC+09:30","UTC+10:00","UTC+10:30","UTC+11:30"],"nativeName":"Australia","numericCode":"036","flags":{"svg":"https://flagcdn.com/au.svg","png":"https://flagcdn.com/w320/au.png"},"currencies":[{"code":"AUD","name":"Australian dollar","symbol":"$"}],"languages":[{"iso639_1":"en","iso639_2":"eng","name":"English","nativeName":"English"}],"translations":{"br":"Aostralia","pt":"Austr\xe1lia","nl":"Australi\xeb","hr":"Australija","fa":"\u0627\u0633\u062A\u0631\u0627\u0644\u06CC\u0627","de":"Australien","es":"Australia","fr":"Australie","ja":"\u30AA\u30FC\u30B9\u30C8\u30E9\u30EA\u30A2","it":"Australia","hu":"Ausztr\xe1lia"},"flag":"https://flagcdn.com/au.svg","cioc":"AUS","independent":true},{"name":"Austria","topLevelDomain":[".at"],"alpha2Code":"AT","alpha3Code":"AUT","callingCodes":["43"],"capital":"Vienna","altSpellings":["AT","\xd6sterreich","Osterreich","Oesterreich"],"subregion":"Central Europe","region":"Europe","population":8917205,"latlng":[47.33333333,13.33333333],"demonym":"Austrian","area":83871,"gini":30.8,"timezones":["UTC+01:00"],"borders":["CZE","DEU","HUN","ITA","LIE","SVK","SVN","CHE"],"nativeName":"\xd6sterreich","numericCode":"040","flags":{"svg":"https://flagcdn.com/at.svg","png":"https://flagcdn.com/w320/at.png"},"currencies":[{"code":"EUR","name":"Euro","symbol":"\u20AC"}],"languages":[{"iso639_1":"de","iso639_2":"deu","name":"German","nativeName":"Deutsch"}],"translations":{"br":"Aostria","pt":"\xc1ustria","nl":"Oostenrijk","hr":"Austrija","fa":"\u0627\u062A\u0631\u06CC\u0634","de":"\xd6sterreich","es":"Austria","fr":"Autriche","ja":"\u30AA\u30FC\u30B9\u30C8\u30EA\u30A2","it":"Austria","hu":"Ausztria"},"flag":"https://flagcdn.com/at.svg","regionalBlocs":[{"acronym":"EU","name":"European Union"}],"cioc":"AUT","independent":true},{"name":"Azerbaijan","topLevelDomain":[".az"],"alpha2Code":"AZ","alpha3Code":"AZE","callingCodes":["994"],"capital":"Baku","altSpellings":["AZ","Republic of Azerbaijan","Az\u0259rbaycan Respublikas\u0131"],"subregion":"Western Asia","region":"Asia","population":10110116,"latlng":[40.5,47.5],"demonym":"Azerbaijani","area":86600,"gini":26.6,"timezones":["UTC+04:00"],"borders":["ARM","GEO","IRN","RUS","TUR"],"nativeName":"Az\u0259rbaycan","numericCode":"031","flags":{"svg":"https://flagcdn.com/az.svg","png":"https://flagcdn.com/w320/az.png"},"currencies":[{"code":"AZN","name":"Azerbaijani manat","symbol":"\u20BC"}],"languages":[{"iso639_1":"az","iso639_2":"aze","name":"Azerbaijani","nativeName":"az\u0259rbaycan dili"}],"translations":{"br":"Azerbaidjan","pt":"Azerbaij\xe3o","nl":"Azerbeidzjan","hr":"Azerbajd\u017Ean","fa":"\u0622\u0630\u0631\u0628\u0627\u06CC\u062C\u0627\u0646","de":"Aserbaidschan","es":"Azerbaiy\xe1n","fr":"Azerba\xefdjan","ja":"\u30A2\u30BC\u30EB\u30D0\u30A4\u30B8\u30E3\u30F3","it":"Azerbaijan","hu":"Azerbajdzs\xe1n"},"flag":"https://flagcdn.com/az.svg","cioc":"AZE","independent":true},{"name":"Bahamas","topLevelDomain":[".bs"],"alpha2Code":"BS","alpha3Code":"BHS","callingCodes":["1"],"capital":"Nassau","altSpellings":["BS","Commonwealth of the Bahamas"],"subregion":"Caribbean","region":"Americas","population":393248,"latlng":[24.25,-76],"demonym":"Bahamian","area":13943,"timezones":["UTC-05:00"],"nativeName":"Bahamas","numericCode":"044","flags":{"svg":"https://flagcdn.com/bs.svg","png":"https://flagcdn.com/w320/bs.png"},"currencies":[{"code":"BSD","name":"Bahamian dollar","symbol":"$"}],"languages":[{"iso639_1":"en","iso639_2":"eng","name":"English","nativeName":"English"}],"translations":{"br":"Bahamas","pt":"Baamas","nl":"Bahama\u2019s","hr":"Bahami","fa":"\u0628\u0627\u0647\u0627\u0645\u0627","de":"Bahamas","es":"Bahamas","fr":"Bahamas","ja":"\u30D0\u30CF\u30DE","it":"Bahamas","hu":"Bahama-szigetek"},"flag":"https://flagcdn.com/bs.svg","regionalBlocs":[{"acronym":"CARICOM","name":"Caribbean Community","otherNames":["Comunidad del Caribe","Communaut\xe9 Carib\xe9enne","Caribische Gemeenschap"]}],"cioc":"BAH","independent":true},{"name":"Bahrain","topLevelDomain":[".bh"],"alpha2Code":"BH","alpha3Code":"BHR","callingCodes":["973"],"capital":"Manama","altSpellings":["BH","Kingdom of Bahrain","Mamlakat al-Ba\u1E25rayn"],"subregion":"Western Asia","region":"Asia","population":1701583,"latlng":[26,50.55],"demonym":"Bahraini","area":765,"timezones":["UTC+03:00"],"nativeName":"\u200F\u0627\u0644\u0628\u062D\u0631\u064A\u0646","numericCode":"048","flags":{"svg":"https://flagcdn.com/bh.svg","png":"https://flagcdn.com/w320/bh.png"},"currencies":[{"code":"BHD","name":"Bahraini dinar","symbol":".\u062F.\u0628"}],"languages":[{"iso639_1":"ar","iso639_2":"ara","name":"Arabic","nativeName":"\u0627\u0644\u0639\u0631\u0628\u064A\u0629"}],"translations":{"br":"Bahrein","pt":"Bar\xe9m","nl":"Bahrein","hr":"Bahrein","fa":"\u0628\u062D\u0631\u06CC\u0646","de":"Bahrain","es":"Bahrein","fr":"Bahre\xefn","ja":"\u30D0\u30FC\u30EC\u30FC\u30F3","it":"Bahrein","hu":"Bahrein"},"flag":"https://flagcdn.com/bh.svg","regionalBlocs":[{"acronym":"AL","name":"Arab League","otherNames":["\u062C\u0627\u0645\u0639\u0629 \u0627\u0644\u062F\u0648\u0644 \u0627\u0644\u0639\u0631\u0628\u064A\u0629","J\u0101mi\u02BBat ad-Duwal al-\u02BBArab\u012Byah","League of Arab States"]}],"cioc":"BRN","independent":true},{"name":"Bangladesh","topLevelDomain":[".bd"],"alpha2Code":"BD","alpha3Code":"BGD","callingCodes":["880"],"capital":"Dhaka","altSpellings":["BD","People\'s Republic of Bangladesh","G\xf4n\xf4pr\xf4jat\xf4ntri Bangladesh"],"subregion":"Southern Asia","region":"Asia","population":164689383,"latlng":[24,90],"demonym":"Bangladeshi","area":147570,"gini":32.4,"timezones":["UTC+06:00"],"borders":["MMR","IND"],"nativeName":"Bangladesh","numericCode":"050","flags":{"svg":"https://flagcdn.com/bd.svg","png":"https://flagcdn.com/w320/bd.png"},"currencies":[{"code":"BDT","name":"Bangladeshi taka","symbol":"\u09F3"}],"languages":[{"iso639_1":"bn","iso639_2":"ben","name":"Bengali","nativeName":"\u09AC\u09BE\u0982\u09B2\u09BE"}],"translations":{"br":"Bangladesh","pt":"Bangladeche","nl":"Bangladesh","hr":"Banglade\u0161","fa":"\u0628\u0646\u06AF\u0644\u0627\u062F\u0634","de":"Bangladesch","es":"Bangladesh","fr":"Bangladesh","ja":"\u30D0\u30F3\u30B0\u30E9\u30C7\u30B7\u30E5","it":"Bangladesh","hu":"Banglades"},"flag":"https://flagcdn.com/bd.svg","regionalBlocs":[{"acronym":"SAARC","name":"South Asian Association for Regional Cooperation"}],"cioc":"BAN","independent":true},{"name":"Barbados","topLevelDomain":[".bb"],"alpha2Code":"BB","alpha3Code":"BRB","callingCodes":["1"],"capital":"Bridgetown","altSpellings":["BB"],"subregion":"Caribbean","region":"Americas","population":287371,"latlng":[13.16666666,-59.53333333],"demonym":"Barbadian","area":430,"timezones":["UTC-04:00"],"nativeName":"Barbados","numericCode":"052","flags":{"svg":"https://flagcdn.com/bb.svg","png":"https://flagcdn.com/w320/bb.png"},"currencies":[{"code":"BBD","name":"Barbadian dollar","symbol":"$"}],"languages":[{"iso639_1":"en","iso639_2":"eng","name":"English","nativeName":"English"}],"translations":{"br":"Barbados","pt":"Barbados","nl":"Barbados","hr":"Barbados","fa":"\u0628\u0627\u0631\u0628\u0627\u062F\u0648\u0633","de":"Barbados","es":"Barbados","fr":"Barbade","ja":"\u30D0\u30EB\u30D0\u30C9\u30B9","it":"Barbados","hu":"Barbados"},"flag":"https://flagcdn.com/bb.svg","regionalBlocs":[{"acronym":"CARICOM","name":"Caribbean Community","otherNames":["Comunidad del Caribe","Communaut\xe9 Carib\xe9enne","Caribische Gemeenschap"]}],"cioc":"BAR","independent":true},{"name":"Belarus","topLevelDomain":[".by"],"alpha2Code":"BY","alpha3Code":"BLR","callingCodes":["375"],"capital":"Minsk","altSpellings":["BY","Bielaru\u015B","Republic of Belarus","\u0411\u0435\u043B\u043E\u0440\u0443\u0441\u0441\u0438\u044F","\u0420\u0435\u0441\u043F\u0443\u0431\u043B\u0438\u043A\u0430 \u0411\u0435\u043B\u0430\u0440\u0443\u0441\u044C","Belorussiya","Respublika Belarus\u2019"],"subregion":"Eastern Europe","region":"Europe","population":9398861,"latlng":[53,28],"demonym":"Belarusian","area":207600,"gini":25.3,"timezones":["UTC+03:00"],"borders":["LVA","LTU","POL","RUS","UKR"],"nativeName":"\u0411\u0435\u043B\u0430\u0440\u0443\u0301\u0441\u044C","numericCode":"112","flags":{"svg":"https://flagcdn.com/by.svg","png":"https://flagcdn.com/w320/by.png"},"currencies":[{"code":"BYN","name":"New Belarusian ruble","symbol":"Br"},{"code":"BYR","name":"Old Belarusian ruble","symbol":"Br"}],"languages":[{"iso639_1":"be","iso639_2":"bel","name":"Belarusian","nativeName":"\u0431\u0435\u043B\u0430\u0440\u0443\u0441\u043A\u0430\u044F \u043C\u043E\u0432\u0430"},{"iso639_1":"ru","iso639_2":"rus","name":"Russian","nativeName":"\u0420\u0443\u0441\u0441\u043A\u0438\u0439"}],"translations":{"br":"Belarus","pt":"Bielorr\xfassia","nl":"Wit-Rusland","hr":"Bjelorusija","fa":"\u0628\u0644\u0627\u0631\u0648\u0633","de":"Wei\xdfrussland","es":"Bielorrusia","fr":"Bi\xe9lorussie","ja":"\u30D9\u30E9\u30EB\u30FC\u30B7","it":"Bielorussia","hu":"Feh\xe9roroszorsz\xe1g"},"flag":"https://flagcdn.com/by.svg","regionalBlocs":[{"acronym":"EEU","name":"Eurasian Economic Union","otherAcronyms":["EAEU"]}],"cioc":"BLR","independent":true},{"name":"Belgium","topLevelDomain":[".be"],"alpha2Code":"BE","alpha3Code":"BEL","callingCodes":["32"],"capital":"Brussels","altSpellings":["BE","Belgi\xeb","Belgie","Belgien","Belgique","Kingdom of Belgium","Koninkrijk Belgi\xeb","Royaume de Belgique","K\xf6nigreich Belgien"],"subregion":"Western Europe","region":"Europe","population":11555997,"latlng":[50.83333333,4],"demonym":"Belgian","area":30528,"gini":27.2,"timezones":["UTC+01:00"],"borders":["FRA","DEU","LUX","NLD"],"nativeName":"Belgi\xeb","numericCode":"056","flags":{"svg":"https://flagcdn.com/be.svg","png":"https://flagcdn.com/w320/be.png"},"currencies":[{"code":"EUR","name":"Euro","symbol":"\u20AC"}],"languages":[{"iso639_1":"nl","iso639_2":"nld","name":"Dutch","nativeName":"Nederlands"},{"iso639_1":"fr","iso639_2":"fra","name":"French","nativeName":"fran\xe7ais"},{"iso639_1":"de","iso639_2":"deu","name":"German","nativeName":"Deutsch"}],"translations":{"br":"Belgia","pt":"B\xe9lgica","nl":"Belgi\xeb","hr":"Belgija","fa":"\u0628\u0644\u0698\u06CC\u06A9","de":"Belgien","es":"B\xe9lgica","fr":"Belgique","ja":"\u30D9\u30EB\u30AE\u30FC","it":"Belgio","hu":"Belgium"},"flag":"https://flagcdn.com/be.svg","regionalBlocs":[{"acronym":"EU","name":"European Union"}],"cioc":"BEL","independent":true},{"name":"Belize","topLevelDomain":[".bz"],"alpha2Code":"BZ","alpha3Code":"BLZ","callingCodes":["501"],"capital":"Belmopan","altSpellings":["BZ"],"subregion":"Central America","region":"Americas","population":397621,"latlng":[17.25,-88.75],"demonym":"Belizean","area":22966,"gini":53.3,"timezones":["UTC-06:00"],"borders":["GTM","MEX"],"nativeName":"Belize","numericCode":"084","flags":{"svg":"https://flagcdn.com/bz.svg","png":"https://flagcdn.com/w320/bz.png"},"currencies":[{"code":"BZD","name":"Belize dollar","symbol":"$"}],"languages":[{"iso639_1":"en","iso639_2":"eng","name":"English","nativeName":"English"},{"iso639_1":"es","iso639_2":"spa","name":"Spanish","nativeName":"Espa\xf1ol"}],"translations":{"br":"Belize","pt":"Belize","nl":"Belize","hr":"Belize","fa":"\u0628\u0644\u06CC\u0632","de":"Belize","es":"Belice","fr":"Belize","ja":"\u30D9\u30EA\u30FC\u30BA","it":"Belize","hu":"Belize"},"flag":"https://flagcdn.com/bz.svg","regionalBlocs":[{"acronym":"CARICOM","name":"Caribbean Community","otherNames":["Comunidad del Caribe","Communaut\xe9 Carib\xe9enne","Caribische Gemeenschap"]},{"acronym":"CAIS","name":"Central American Integration System","otherAcronyms":["SICA"],"otherNames":["Sistema de la Integraci\xf3n Centroamericana,"]}],"cioc":"BIZ","independent":true},{"name":"Benin","topLevelDomain":[".bj"],"alpha2Code":"BJ","alpha3Code":"BEN","callingCodes":["229"],"capital":"Porto-Novo","altSpellings":["BJ","Republic of Benin","R\xe9publique du B\xe9nin"],"subregion":"Western Africa","region":"Africa","population":12123198,"latlng":[9.5,2.25],"demonym":"Beninese","area":112622,"gini":47.8,"timezones":["UTC+01:00"],"borders":["BFA","NER","NGA","TGO"],"nativeName":"B\xe9nin","numericCode":"204","flags":{"svg":"https://flagcdn.com/bj.svg","png":"https://flagcdn.com/w320/bj.png"},"currencies":[{"code":"XOF","name":"West African CFA franc","symbol":"Fr"}],"languages":[{"iso639_1":"fr","iso639_2":"fra","name":"French","nativeName":"fran\xe7ais"}],"translations":{"br":"Benin","pt":"Benim","nl":"Benin","hr":"Benin","fa":"\u0628\u0646\u06CC\u0646","de":"Benin","es":"Ben\xedn","fr":"B\xe9nin","ja":"\u30D9\u30CA\u30F3","it":"Benin","hu":"Benin"},"flag":"https://flagcdn.com/bj.svg","regionalBlocs":[{"acronym":"AU","name":"African Union","otherNames":["\u0627\u0644\u0627\u062A\u062D\u0627\u062F \u0627\u0644\u0623\u0641\u0631\u064A\u0642\u064A","Union africaine","Uni\xe3o Africana","Uni\xf3n Africana","Umoja wa Afrika"]}],"cioc":"BEN","independent":true},{"name":"Bermuda","topLevelDomain":[".bm"],"alpha2Code":"BM","alpha3Code":"BMU","callingCodes":["1"],"capital":"Hamilton","altSpellings":["BM","The Islands of Bermuda","The Bermudas","Somers Isles"],"subregion":"Northern America","region":"Americas","population":63903,"latlng":[32.33333333,-64.75],"demonym":"Bermudian","area":54,"timezones":["UTC-04:00"],"nativeName":"Bermuda","numericCode":"060","flags":{"svg":"https://flagcdn.com/bm.svg","png":"https://flagcdn.com/w320/bm.png"},"currencies":[{"code":"BMD","name":"Bermudian dollar","symbol":"$"}],"languages":[{"iso639_1":"en","iso639_2":"eng","name":"English","nativeName":"English"}],"translations":{"br":"Bermuda","pt":"Bermudas","nl":"Bermuda","hr":"Bermudi","fa":"\u0628\u0631\u0645\u0648\u062F\u0627","de":"Bermuda","es":"Bermudas","fr":"Bermudes","ja":"\u30D0\u30DF\u30E5\u30FC\u30C0","it":"Bermuda","hu":"Bermuda"},"flag":"https://flagcdn.com/bm.svg","cioc":"BER","independent":false},{"name":"Bhutan","topLevelDomain":[".bt"],"alpha2Code":"BT","alpha3Code":"BTN","callingCodes":["975"],"capital":"Thimphu","altSpellings":["BT","Kingdom of Bhutan"],"subregion":"Southern Asia","region":"Asia","population":771612,"latlng":[27.5,90.5],"demonym":"Bhutanese","area":38394,"gini":37.4,"timezones":["UTC+06:00"],"borders":["CHN","IND"],"nativeName":"\u02BCbrug-yul","numericCode":"064","flags":{"svg":"https://flagcdn.com/bt.svg","png":"https://flagcdn.com/w320/bt.png"},"currencies":[{"code":"BTN","name":"Bhutanese ngultrum","symbol":"Nu."},{"code":"INR","name":"Indian rupee","symbol":"\u20B9"}],"languages":[{"iso639_1":"dz","iso639_2":"dzo","name":"Dzongkha","nativeName":"\u0F62\u0FAB\u0F7C\u0F44\u0F0B\u0F41"}],"translations":{"br":"Bhoutan","pt":"But\xe3o","nl":"Bhutan","hr":"Butan","fa":"\u0628\u0648\u062A\u0627\u0646","de":"Bhutan","es":"But\xe1n","fr":"Bhoutan","ja":"\u30D6\u30FC\u30BF\u30F3","it":"Bhutan","hu":"Bhut\xe1n"},"flag":"https://flagcdn.com/bt.svg","regionalBlocs":[{"acronym":"SAARC","name":"South Asian Association for Regional Cooperation"}],"cioc":"BHU","independent":true},{"name":"Bolivia (Plurinational State of)","topLevelDomain":[".bo"],"alpha2Code":"BO","alpha3Code":"BOL","callingCodes":["591"],"capital":"Sucre","altSpellings":["BO","Buliwya","Wuliwya","Plurinational State of Bolivia","Estado Plurinacional de Bolivia","Buliwya Mamallaqta","Wuliwya Suyu","Tet\xe3 Vol\xedvia"],"subregion":"South America","region":"Americas","population":11673029,"latlng":[-17,-65],"demonym":"Bolivian","area":1098581,"gini":41.6,"timezones":["UTC-04:00"],"borders":["ARG","BRA","CHL","PRY","PER"],"nativeName":"Bolivia","numericCode":"068","flags":{"svg":"https://flagcdn.com/bo.svg","png":"https://flagcdn.com/w320/bo.png"},"currencies":[{"code":"BOB","name":"Bolivian boliviano","symbol":"Bs."}],"languages":[{"iso639_1":"es","iso639_2":"spa","name":"Spanish","nativeName":"Espa\xf1ol"},{"iso639_1":"ay","iso639_2":"aym","name":"Aymara","nativeName":"aymar aru"},{"iso639_1":"qu","iso639_2":"que","name":"Quechua","nativeName":"Runa Simi"}],"translations":{"br":"Bolivia","pt":"Bol\xedvia","nl":"Bolivia","hr":"Bolivija","fa":"\u0628\u0648\u0644\u06CC\u0648\u06CC","de":"Bolivien","es":"Bolivia","fr":"Bolivie","ja":"\u30DC\u30EA\u30D3\u30A2\u591A\u6C11\u65CF\u56FD","it":"Bolivia","hu":"Bol\xedvia"},"flag":"https://flagcdn.com/bo.svg","regionalBlocs":[{"acronym":"USAN","name":"Union of South American Nations","otherAcronyms":["UNASUR","UNASUL","UZAN"],"otherNames":["Uni\xf3n de Naciones Suramericanas","Uni\xe3o de Na\xe7\xf5es Sul-Americanas","Unie van Zuid-Amerikaanse Naties","South American Union"]}],"cioc":"BOL","independent":true},{"name":"Bonaire, Sint Eustatius and Saba","topLevelDomain":[".an",".nl"],"alpha2Code":"BQ","alpha3Code":"BES","callingCodes":["599"],"capital":"Kralendijk","altSpellings":["BQ","Boneiru"],"subregion":"Caribbean","region":"Americas","population":17408,"latlng":[12.15,-68.266667],"demonym":"Dutch","area":294,"timezones":["UTC-04:00"],"nativeName":"Bonaire","numericCode":"535","flags":{"svg":"https://flagcdn.com/bq.svg","png":"https://flagcdn.com/w320/bq.png"},"currencies":[{"code":"USD","name":"United States dollar","symbol":"$"}],"languages":[{"iso639_1":"nl","iso639_2":"nld","name":"Dutch","nativeName":"Nederlands"}],"translations":{"br":"Bonaire, Sint Eustatius ha Saba","pt":"Bonaire","nl":"Caribisch Nederland","hr":"Bonaire, Sint Eustatius and Saba","fa":"\u0628\u0648\u0646\u06CC\u0631","de":"Bonaire, Sint Eustatius und Saba","es":"Bonaire, Sint Eustatius and Saba","fr":"Bonaire, Saint-Eustache et Saba","ja":"Bonaire, Sint Eustatius and Saba","it":"Bonaire, Saint-Eustache e Saba","hu":"Bonaire"},"flag":"https://flagcdn.com/bq.svg","independent":true},{"name":"Bosnia and Herzegovina","topLevelDomain":[".ba"],"alpha2Code":"BA","alpha3Code":"BIH","callingCodes":["387"],"capital":"Sarajevo","altSpellings":["BA","Bosnia-Herzegovina","\u0411\u043E\u0441\u043D\u0430 \u0438 \u0425\u0435\u0440\u0446\u0435\u0433\u043E\u0432\u0438\u043D\u0430"],"subregion":"Southern Europe","region":"Europe","population":3280815,"latlng":[44,18],"demonym":"Bosnian, Herzegovinian","area":51209,"gini":33,"timezones":["UTC+01:00"],"borders":["HRV","MNE","SRB"],"nativeName":"Bosna i Hercegovina","numericCode":"070","flags":{"svg":"https://flagcdn.com/ba.svg","png":"https://flagcdn.com/w320/ba.png"},"currencies":[{"code":"BAM","name":"Bosnia and Herzegovina convertible mark","symbol":"KM"}],"languages":[{"iso639_1":"bs","iso639_2":"bos","name":"Bosnian","nativeName":"bosanski jezik"},{"iso639_1":"hr","iso639_2":"hrv","name":"Croatian","nativeName":"hrvatski jezik"},{"iso639_1":"sr","iso639_2":"srp","name":"Serbian","nativeName":"\u0441\u0440\u043F\u0441\u043A\u0438 \u0458\u0435\u0437\u0438\u043A"}],"translations":{"br":"Bosnia-ha-Herzegovina","pt":"B\xf3snia e Herzegovina","nl":"Bosni\xeb en Herzegovina","hr":"Bosna i Hercegovina","fa":"\u0628\u0648\u0633\u0646\u06CC \u0648 \u0647\u0631\u0632\u06AF\u0648\u06CC\u0646","de":"Bosnien und Herzegowina","es":"Bosnia y Herzegovina","fr":"Bosnie-Herz\xe9govine","ja":"\u30DC\u30B9\u30CB\u30A2\u30FB\u30D8\u30EB\u30C4\u30A7\u30B4\u30D3\u30CA","it":"Bosnia ed Erzegovina","hu":"Bosznia-Hercegovina"},"flag":"https://flagcdn.com/ba.svg","regionalBlocs":[{"acronym":"CEFTA","name":"Central European Free Trade Agreement"}],"cioc":"BIH","independent":true},{"name":"Botswana","topLevelDomain":[".bw"],"alpha2Code":"BW","alpha3Code":"BWA","callingCodes":["267"],"capital":"Gaborone","altSpellings":["BW","Republic of Botswana","Lefatshe la Botswana"],"subregion":"Southern Africa","region":"Africa","population":2351625,"latlng":[-22,24],"demonym":"Motswana","area":582000,"gini":53.3,"timezones":["UTC+02:00"],"borders":["NAM","ZAF","ZMB","ZWE"],"nativeName":"Botswana","numericCode":"072","flags":{"svg":"https://flagcdn.com/bw.svg","png":"https://flagcdn.com/w320/bw.png"},"currencies":[{"code":"BWP","name":"Botswana pula","symbol":"P"}],"languages":[{"iso639_1":"en","iso639_2":"eng","name":"English","nativeName":"English"},{"iso639_1":"tn","iso639_2":"tsn","name":"Tswana","nativeName":"Setswana"}],"translations":{"br":"Botswana","pt":"Botsuana","nl":"Botswana","hr":"Bocvana","fa":"\u0628\u0648\u062A\u0633\u0648\u0627\u0646\u0627","de":"Botswana","es":"Botswana","fr":"Botswana","ja":"\u30DC\u30C4\u30EF\u30CA","it":"Botswana","hu":"Botswana"},"flag":"https://flagcdn.com/bw.svg","regionalBlocs":[{"acronym":"AU","name":"African Union","otherNames":["\u0627\u0644\u0627\u062A\u062D\u0627\u062F \u0627\u0644\u0623\u0641\u0631\u064A\u0642\u064A","Union africaine","Uni\xe3o Africana","Uni\xf3n Africana","Umoja wa Afrika"]}],"cioc":"BOT","independent":true},{"name":"Bouvet Island","topLevelDomain":[".bv"],"alpha2Code":"BV","alpha3Code":"BVT","callingCodes":["47"],"altSpellings":["BV","Bouvet\xf8ya","Bouvet-\xf8ya"],"subregion":"South Antarctic Ocean","region":"Antarctic Ocean","population":0,"latlng":[-54.43333333,3.4],"demonym":"Norwegian","area":49,"timezones":["UTC+01:00"],"nativeName":"Bouvet\xf8ya","numericCode":"074","flags":{"svg":"https://flagcdn.com/bv.svg","png":"https://flagcdn.com/w320/bv.png"},"currencies":[{"code":"NOK","name":"Norwegian krone","symbol":"kr"}],"languages":[{"iso639_1":"no","iso639_2":"nor","name":"Norwegian","nativeName":"Norsk"},{"iso639_1":"nb","iso639_2":"nob","name":"Norwegian Bokm\xe5l","nativeName":"Norsk bokm\xe5l"},{"iso639_1":"nn","iso639_2":"nno","name":"Norwegian Nynorsk","nativeName":"Norsk nynorsk"}],"translations":{"br":"Enez Bouvet","pt":"Ilha Bouvet","nl":"Bouveteiland","hr":"Otok Bouvet","fa":"\u062C\u0632\u06CC\u0631\u0647 \u0628\u0648\u0648\u0647","de":"Bouvetinsel","es":"Isla Bouvet","fr":"\xcele Bouvet","ja":"\u30D6\u30FC\u30D9\u5CF6","it":"Isola Bouvet","hu":"Bouvet-sziget"},"flag":"https://flagcdn.com/bv.svg","independent":false},{"name":"Brazil","topLevelDomain":[".br"],"alpha2Code":"BR","alpha3Code":"BRA","callingCodes":["55"],"capital":"Bras\xedlia","altSpellings":["BR","Brasil","Federative Republic of Brazil","Rep\xfablica Federativa do Brasil"],"subregion":"South America","region":"Americas","population":212559409,"latlng":[-10,-55],"demonym":"Brazilian","area":8515767,"gini":53.4,"timezones":["UTC-05:00","UTC-04:00","UTC-03:00","UTC-02:00"],"borders":["ARG","BOL","COL","FRA","GUF","GUY","PRY","PER","SUR","URY","VEN"],"nativeName":"Brasil","numericCode":"076","flags":{"svg":"https://flagcdn.com/br.svg","png":"https://flagcdn.com/w320/br.png"},"currencies":[{"code":"BRL","name":"Brazilian real","symbol":"R$"}],"languages":[{"iso639_1":"pt","iso639_2":"por","name":"Portuguese","nativeName":"Portugu\xeas"}],"translations":{"br":"Brazil","pt":"Brasil","nl":"Brazili\xeb","hr":"Brazil","fa":"\u0628\u0631\u0632\u06CC\u0644","de":"Brasilien","es":"Brasil","fr":"Br\xe9sil","ja":"\u30D6\u30E9\u30B8\u30EB","it":"Brasile","hu":"Braz\xedlia"},"flag":"https://flagcdn.com/br.svg","regionalBlocs":[{"acronym":"USAN","name":"Union of South American Nations","otherAcronyms":["UNASUR","UNASUL","UZAN"],"otherNames":["Uni\xf3n de Naciones Suramericanas","Uni\xe3o de Na\xe7\xf5es Sul-Americanas","Unie van Zuid-Amerikaanse Naties","South American Union"]}],"cioc":"BRA","independent":true},{"name":"British Indian Ocean Territory","topLevelDomain":[".io"],"alpha2Code":"IO","alpha3Code":"IOT","callingCodes":["246"],"capital":"Diego Garcia","altSpellings":["IO"],"subregion":"Eastern Africa","region":"Africa","population":3000,"latlng":[-6,71.5],"demonym":"Indian","area":60,"timezones":["UTC+06:00"],"nativeName":"British Indian Ocean Territory","numericCode":"086","flags":{"svg":"https://flagcdn.com/io.svg","png":"https://flagcdn.com/w320/io.png"},"currencies":[{"code":"USD","name":"United States dollar","symbol":"$"}],"languages":[{"iso639_1":"en","iso639_2":"eng","name":"English","nativeName":"English"}],"translations":{"br":"Tiriad breizhveurat Meurvor Indez","pt":"Territ\xf3rio Brit\xe2nico do Oceano \xcdndico","nl":"Britse Gebieden in de Indische Oceaan","hr":"Britanski Indijskooceanski teritorij","fa":"\u0642\u0644\u0645\u0631\u0648 \u0628\u0631\u06CC\u062A\u0627\u0646\u06CC\u0627 \u062F\u0631 \u0627\u0642\u06CC\u0627\u0646\u0648\u0633 \u0647\u0646\u062F","de":"Britisches Territorium im Indischen Ozean","es":"Territorio Brit\xe1nico del Oc\xe9ano \xcdndico","fr":"Territoire britannique de l\'oc\xe9an Indien","ja":"\u30A4\u30AE\u30EA\u30B9\u9818\u30A4\u30F3\u30C9\u6D0B\u5730\u57DF","it":"Territorio britannico dell\'oceano indiano","hu":"Brit Indiai-\xf3ce\xe1ni Ter\xfclet"},"flag":"https://flagcdn.com/io.svg","regionalBlocs":[{"acronym":"AU","name":"African Union","otherNames":["\u0627\u0644\u0627\u062A\u062D\u0627\u062F \u0627\u0644\u0623\u0641\u0631\u064A\u0642\u064A","Union africaine","Uni\xe3o Africana","Uni\xf3n Africana","Umoja wa Afrika"]}],"independent":true},{"name":"United States Minor Outlying Islands","topLevelDomain":[".us"],"alpha2Code":"UM","alpha3Code":"UMI","callingCodes":["246"],"altSpellings":["UM"],"subregion":"Northern America","region":"Americas","population":300,"demonym":"American","timezones":["UTC-11:00","UTC-10:00","UTC+12:00"],"nativeName":"United States Minor Outlying Islands","numericCode":"581","flags":{"svg":"https://flagcdn.com/um.svg","png":"https://flagcdn.com/w320/um.png"},"currencies":[{"code":"GBP","name":"British pound","symbol":"\xa3"}],"languages":[{"iso639_1":"en","iso639_2":"eng","name":"English","nativeName":"English"}],"translations":{"br":"Inizi Minor A-bell Stado\xf9-Unanet","pt":"Ilhas Menores Distantes dos Estados Unidos","nl":"Kleine afgelegen eilanden van de Verenigde Staten","hr":"Mali udaljeni otoci SAD-a","fa":"\u062C\u0632\u0627\u06CC\u0631 \u06A9\u0648\u0686\u06A9 \u062D\u0627\u0634\u06CC\u0647\u200C\u0627\u06CC \u0627\u06CC\u0627\u0644\u0627\u062A \u0645\u062A\u062D\u062F\u0647 \u0622\u0645\u0631\u06CC\u06A9\u0627","de":"Kleinere Inselbesitzungen der Vereinigten Staaten","es":"Islas Ultramarinas Menores de Estados Unidos","fr":"\xceles mineures \xe9loign\xe9es des \xc9tats-Unis","ja":"\u5408\u8846\u56FD\u9818\u6709\u5C0F\u96E2\u5CF6","it":"Isole minori esterne degli Stati Uniti d\'America","hu":"Amerikai Egyes\xfclt \xc1llamok lakatlan k\xfclbirtokai"},"flag":"https://flagcdn.com/um.svg","independent":false},{"name":"Virgin Islands (British)","topLevelDomain":[".vg"],"alpha2Code":"VG","alpha3Code":"VGB","callingCodes":["1"],"capital":"Road Town","altSpellings":["VG"],"subregion":"Caribbean","region":"Americas","population":30237,"latlng":[18.431383,-64.62305],"demonym":"Virgin Islander","area":151,"timezones":["UTC-04:00"],"nativeName":"British Virgin Islands","numericCode":"092","flags":{"svg":"https://flagcdn.com/vg.svg","png":"https://flagcdn.com/w320/vg.png"},"currencies":[{"code":"USD","name":"United States dollar","symbol":"$"}],"languages":[{"iso639_1":"en","iso639_2":"eng","name":"English","nativeName":"English"}],"translations":{"br":"Inizi Gwerc\'h Breizhveurat","pt":"Ilhas Virgens Brit\xe2nicas","nl":"Britse Maagdeneilanden","hr":"Britanski Djevi\u010Danski Otoci","fa":"\u062C\u0632\u0627\u06CC\u0631 \u0648\u06CC\u0631\u062C\u06CC\u0646 \u0628\u0631\u06CC\u062A\u0627\u0646\u06CC\u0627","de":"Britische Jungferninseln","es":"Islas V\xedrgenes del Reino Unido","fr":"\xceles Vierges britanniques","ja":"\u30A4\u30AE\u30EA\u30B9\u9818\u30F4\u30A1\u30FC\u30B8\u30F3\u8AF8\u5CF6","it":"Isole Vergini Britanniche","hu":"Brit Virgin-szigetek"},"flag":"https://flagcdn.com/vg.svg","cioc":"IVB","independent":false},{"name":"Virgin Islands (U.S.)","topLevelDomain":[".vi"],"alpha2Code":"VI","alpha3Code":"VIR","callingCodes":["1 340"],"capital":"Charlotte Amalie","altSpellings":["VI","USVI","American Virgin Islands","U.S. Virgin Islands"],"subregion":"Caribbean","region":"Americas","population":106290,"latlng":[18.34,-64.93],"demonym":"Virgin Islander","area":346.36,"timezones":["UTC-04:00"],"nativeName":"Virgin Islands of the United States","numericCode":"850","flags":{"svg":"https://flagcdn.com/vi.svg","png":"https://flagcdn.com/w320/vi.png"},"currencies":[{"code":"USD","name":"United States dollar","symbol":"$"}],"languages":[{"iso639_1":"en","iso639_2":"eng","name":"English","nativeName":"English"}],"translations":{"br":"Inizi Gwerc\'h ar Stado\xf9-Unanet","pt":"Ilhas Virgens Americanas","nl":"Verenigde Staten Maagdeneilanden","hr":"Virgin Islands (U.S.)","fa":"\u062C\u0632\u0627\u06CC\u0631 \u0648\u06CC\u0631\u062C\u06CC\u0646 \u0622\u0645\u0631\u06CC\u06A9\u0627","de":"Amerikanische Jungferninseln","es":"Islas V\xedrgenes de los Estados Unidos","fr":"\xceles Vierges des \xc9tats-Unis","ja":"\u30A2\u30E1\u30EA\u30AB\u9818\u30F4\u30A1\u30FC\u30B8\u30F3\u8AF8\u5CF6","it":"Isole Vergini americane","hu":"Amerikai Virgin-szigetek"},"flag":"https://flagcdn.com/vi.svg","cioc":"ISV","independent":false},{"name":"Brunei Darussalam","topLevelDomain":[".bn"],"alpha2Code":"BN","alpha3Code":"BRN","callingCodes":["673"],"capital":"Bandar Seri Begawan","altSpellings":["BN","Nation of Brunei"," the Abode of Peace"],"subregion":"South-Eastern Asia","region":"Asia","population":437483,"latlng":[4.5,114.66666666],"demonym":"Bruneian","area":5765,"timezones":["UTC+08:00"],"borders":["MYS"],"nativeName":"Negara Brunei Darussalam","numericCode":"096","flags":{"svg":"https://flagcdn.com/bn.svg","png":"https://flagcdn.com/w320/bn.png"},"currencies":[{"code":"BND","name":"Brunei dollar","symbol":"$"},{"code":"SGD","name":"Singapore dollar","symbol":"$"}],"languages":[{"iso639_1":"ms","iso639_2":"msa","name":"Malay","nativeName":"bahasa Melayu"}],"translations":{"br":"Brunei","pt":"Brunei","nl":"Brunei","hr":"Brunej","fa":"\u0628\u0631\u0648\u0646\u0626\u06CC","de":"Brunei","es":"Brunei","fr":"Brunei","ja":"\u30D6\u30EB\u30CD\u30A4\u30FB\u30C0\u30EB\u30B5\u30E9\u30FC\u30E0","it":"Brunei","hu":"Brunei"},"flag":"https://flagcdn.com/bn.svg","regionalBlocs":[{"acronym":"ASEAN","name":"Association of Southeast Asian Nations"}],"cioc":"BRU","independent":true},{"name":"Bulgaria","topLevelDomain":[".bg"],"alpha2Code":"BG","alpha3Code":"BGR","callingCodes":["359"],"capital":"Sofia","altSpellings":["BG","Republic of Bulgaria","\u0420\u0435\u043F\u0443\u0431\u043B\u0438\u043A\u0430 \u0411\u044A\u043B\u0433\u0430\u0440\u0438\u044F"],"subregion":"Eastern Europe","region":"Europe","population":6927288,"latlng":[43,25],"demonym":"Bulgarian","area":110879,"gini":41.3,"timezones":["UTC+02:00"],"borders":["GRC","MKD","ROU","SRB","TUR"],"nativeName":"\u0411\u044A\u043B\u0433\u0430\u0440\u0438\u044F","numericCode":"100","flags":{"svg":"https://flagcdn.com/bg.svg","png":"https://flagcdn.com/w320/bg.png"},"currencies":[{"code":"BGN","name":"Bulgarian lev","symbol":"\u043B\u0432"}],"languages":[{"iso639_1":"bg","iso639_2":"bul","name":"Bulgarian","nativeName":"\u0431\u044A\u043B\u0433\u0430\u0440\u0441\u043A\u0438 \u0435\u0437\u0438\u043A"}],"translations":{"br":"Bulgaria","pt":"Bulg\xe1ria","nl":"Bulgarije","hr":"Bugarska","fa":"\u0628\u0644\u063A\u0627\u0631\u0633\u062A\u0627\u0646","de":"Bulgarien","es":"Bulgaria","fr":"Bulgarie","ja":"\u30D6\u30EB\u30AC\u30EA\u30A2","it":"Bulgaria","hu":"Bulg\xe1ria"},"flag":"https://flagcdn.com/bg.svg","regionalBlocs":[{"acronym":"EU","name":"European Union"}],"cioc":"BUL","independent":true},{"name":"Burkina Faso","topLevelDomain":[".bf"],"alpha2Code":"BF","alpha3Code":"BFA","callingCodes":["226"],"capital":"Ouagadougou","altSpellings":["BF"],"subregion":"Western Africa","region":"Africa","population":20903278,"latlng":[13,-2],"demonym":"Burkinabe","area":272967,"gini":35.3,"timezones":["UTC"],"borders":["BEN","CIV","GHA","MLI","NER","TGO"],"nativeName":"Burkina Faso","numericCode":"854","flags":{"svg":"https://flagcdn.com/bf.svg","png":"https://flagcdn.com/w320/bf.png"},"currencies":[{"code":"XOF","name":"West African CFA franc","symbol":"Fr"}],"languages":[{"iso639_1":"fr","iso639_2":"fra","name":"French","nativeName":"fran\xe7ais"},{"iso639_1":"ff","iso639_2":"ful","name":"Fula","nativeName":"Fulfulde"}],"translations":{"br":"Burkina Faso","pt":"Burquina Faso","nl":"Burkina Faso","hr":"Burkina Faso","fa":"\u0628\u0648\u0631\u06A9\u06CC\u0646\u0627\u0641\u0627\u0633\u0648","de":"Burkina Faso","es":"Burkina Faso","fr":"Burkina Faso","ja":"\u30D6\u30EB\u30AD\u30CA\u30D5\u30A1\u30BD","it":"Burkina Faso","hu":"Burkina Faso"},"flag":"https://flagcdn.com/bf.svg","regionalBlocs":[{"acronym":"AU","name":"African Union","otherNames":["\u0627\u0644\u0627\u062A\u062D\u0627\u062F \u0627\u0644\u0623\u0641\u0631\u064A\u0642\u064A","Union africaine","Uni\xe3o Africana","Uni\xf3n Africana","Umoja wa Afrika"]}],"cioc":"BUR","independent":true},{"name":"Burundi","topLevelDomain":[".bi"],"alpha2Code":"BI","alpha3Code":"BDI","callingCodes":["257"],"capital":"Gitega","altSpellings":["BI","Republic of Burundi","Republika y\'Uburundi","R\xe9publique du Burundi"],"subregion":"Eastern Africa","region":"Africa","population":11890781,"latlng":[-3.5,30],"demonym":"Burundian","area":27834,"gini":38.6,"timezones":["UTC+02:00"],"borders":["COD","RWA","TZA"],"nativeName":"Burundi","numericCode":"108","flags":{"svg":"https://flagcdn.com/bi.svg","png":"https://flagcdn.com/w320/bi.png"},"currencies":[{"code":"BIF","name":"Burundian franc","symbol":"Fr"}],"languages":[{"iso639_1":"fr","iso639_2":"fra","name":"French","nativeName":"fran\xe7ais"},{"iso639_1":"rn","iso639_2":"run","name":"Kirundi","nativeName":"Ikirundi"}],"translations":{"br":"Burundi","pt":"Bur\xfandi","nl":"Burundi","hr":"Burundi","fa":"\u0628\u0648\u0631\u0648\u0646\u062F\u06CC","de":"Burundi","es":"Burundi","fr":"Burundi","ja":"\u30D6\u30EB\u30F3\u30B8","it":"Burundi","hu":"Burundi"},"flag":"https://flagcdn.com/bi.svg","regionalBlocs":[{"acronym":"AU","name":"African Union","otherNames":["\u0627\u0644\u0627\u062A\u062D\u0627\u062F \u0627\u0644\u0623\u0641\u0631\u064A\u0642\u064A","Union africaine","Uni\xe3o Africana","Uni\xf3n Africana","Umoja wa Afrika"]}],"cioc":"BDI","independent":true},{"name":"Cambodia","topLevelDomain":[".kh"],"alpha2Code":"KH","alpha3Code":"KHM","callingCodes":["855"],"capital":"Phnom Penh","altSpellings":["KH","Kingdom of Cambodia"],"subregion":"South-Eastern Asia","region":"Asia","population":16718971,"latlng":[13,105],"demonym":"Cambodian","area":181035,"timezones":["UTC+07:00"],"borders":["LAO","THA","VNM"],"nativeName":"K\xe2mp\u016Dch\xe9a","numericCode":"116","flags":{"svg":"https://flagcdn.com/kh.svg","png":"https://flagcdn.com/w320/kh.png"},"currencies":[{"code":"KHR","name":"Cambodian riel","symbol":"\u17DB"},{"code":"USD","name":"United States dollar","symbol":"$"}],"languages":[{"iso639_1":"km","iso639_2":"khm","name":"Khmer","nativeName":"\u1781\u17D2\u1798\u17C2\u179A"}],"translations":{"br":"Kambodja","pt":"Camboja","nl":"Cambodja","hr":"Kambod\u017Ea","fa":"\u06A9\u0627\u0645\u0628\u0648\u062C","de":"Kambodscha","es":"Camboya","fr":"Cambodge","ja":"\u30AB\u30F3\u30DC\u30B8\u30A2","it":"Cambogia","hu":"Kambodzsa"},"flag":"https://flagcdn.com/kh.svg","regionalBlocs":[{"acronym":"ASEAN","name":"Association of Southeast Asian Nations"}],"cioc":"CAM","independent":true},{"name":"Cameroon","topLevelDomain":[".cm"],"alpha2Code":"CM","alpha3Code":"CMR","callingCodes":["237"],"capital":"Yaound\xe9","altSpellings":["CM","Republic of Cameroon","R\xe9publique du Cameroun"],"subregion":"Middle Africa","region":"Africa","population":26545864,"latlng":[6,12],"demonym":"Cameroonian","area":475442,"gini":46.6,"timezones":["UTC+01:00"],"borders":["CAF","TCD","COG","GNQ","GAB","NGA"],"nativeName":"Cameroon","numericCode":"120","flags":{"svg":"https://flagcdn.com/cm.svg","png":"https://flagcdn.com/w320/cm.png"},"currencies":[{"code":"XAF","name":"Central African CFA franc","symbol":"Fr"}],"languages":[{"iso639_1":"en","iso639_2":"eng","name":"English","nativeName":"English"},{"iso639_1":"fr","iso639_2":"fra","name":"French","nativeName":"fran\xe7ais"}],"translations":{"br":"Kameroun","pt":"Camar\xf5es","nl":"Kameroen","hr":"Kamerun","fa":"\u06A9\u0627\u0645\u0631\u0648\u0646","de":"Kamerun","es":"Camer\xfan","fr":"Cameroun","ja":"\u30AB\u30E1\u30EB\u30FC\u30F3","it":"Camerun","hu":"Kamerun"},"flag":"https://flagcdn.com/cm.svg","regionalBlocs":[{"acronym":"AU","name":"African Union","otherNames":["\u0627\u0644\u0627\u062A\u062D\u0627\u062F \u0627\u0644\u0623\u0641\u0631\u064A\u0642\u064A","Union africaine","Uni\xe3o Africana","Uni\xf3n Africana","Umoja wa Afrika"]}],"cioc":"CMR","independent":true},{"name":"Canada","topLevelDomain":[".ca"],"alpha2Code":"CA","alpha3Code":"CAN","callingCodes":["1"],"capital":"Ottawa","altSpellings":["CA"],"subregion":"Northern America","region":"Americas","population":38005238,"latlng":[60,-95],"demonym":"Canadian","area":9984670,"gini":33.3,"timezones":["UTC-08:00","UTC-07:00","UTC-06:00","UTC-05:00","UTC-04:00","UTC-03:30"],"borders":["USA"],"nativeName":"Canada","numericCode":"124","flags":{"svg":"https://flagcdn.com/ca.svg","png":"https://flagcdn.com/w320/ca.png"},"currencies":[{"code":"CAD","name":"Canadian dollar","symbol":"$"}],"languages":[{"iso639_1":"en","iso639_2":"eng","name":"English","nativeName":"English"},{"iso639_1":"fr","iso639_2":"fra","name":"French","nativeName":"fran\xe7ais"}],"translations":{"br":"Kanada","pt":"Canad\xe1","nl":"Canada","hr":"Kanada","fa":"\u06A9\u0627\u0646\u0627\u062F\u0627","de":"Kanada","es":"Canad\xe1","fr":"Canada","ja":"\u30AB\u30CA\u30C0","it":"Canada","hu":"Kanada"},"flag":"https://flagcdn.com/ca.svg","regionalBlocs":[{"acronym":"NAFTA","name":"North American Free Trade Agreement","otherNames":["Tratado de Libre Comercio de Am\xe9rica del Norte","Accord de Libre-\xe9change Nord-Am\xe9ricain"]}],"cioc":"CAN","independent":true},{"name":"Cabo Verde","topLevelDomain":[".cv"],"alpha2Code":"CV","alpha3Code":"CPV","callingCodes":["238"],"capital":"Praia","altSpellings":["CV","Republic of Cabo Verde","Rep\xfablica de Cabo Verde"],"subregion":"Western Africa","region":"Africa","population":555988,"latlng":[16,-24],"demonym":"Cape Verdian","area":4033,"gini":42.4,"timezones":["UTC-01:00"],"nativeName":"Cabo Verde","numericCode":"132","flags":{"svg":"https://flagcdn.com/cv.svg","png":"https://flagcdn.com/w320/cv.png"},"currencies":[{"code":"CVE","name":"Cape Verdean escudo","symbol":"Esc"}],"languages":[{"iso639_1":"pt","iso639_2":"por","name":"Portuguese","nativeName":"Portugu\xeas"}],"translations":{"br":"Kab Glas","pt":"Cabo Verde","nl":"Kaapverdi\xeb","hr":"Zelenortska Republika","fa":"\u06A9\u06CC\u067E \u0648\u0631\u062F","de":"Kap Verde","es":"Cabo Verde","fr":"Cap Vert","ja":"\u30AB\u30FC\u30DC\u30D9\u30EB\u30C7","it":"Capo Verde","hu":"Z\xf6ld-foki K\xf6zt\xe1rsas\xe1g"},"flag":"https://flagcdn.com/cv.svg","regionalBlocs":[{"acronym":"AU","name":"African Union","otherNames":["\u0627\u0644\u0627\u062A\u062D\u0627\u062F \u0627\u0644\u0623\u0641\u0631\u064A\u0642\u064A","Union africaine","Uni\xe3o Africana","Uni\xf3n Africana","Umoja wa Afrika"]}],"cioc":"CPV","independent":true},{"name":"Cayman Islands","topLevelDomain":[".ky"],"alpha2Code":"KY","alpha3Code":"CYM","callingCodes":["1"],"capital":"George Town","altSpellings":["KY"],"subregion":"Caribbean","region":"Americas","population":65720,"latlng":[19.5,-80.5],"demonym":"Caymanian","area":264,"timezones":["UTC-05:00"],"nativeName":"Cayman Islands","numericCode":"136","flags":{"svg":"https://flagcdn.com/ky.svg","png":"https://flagcdn.com/w320/ky.png"},"currencies":[{"code":"KYD","name":"Cayman Islands dollar","symbol":"$"}],"languages":[{"iso639_1":"en","iso639_2":"eng","name":"English","nativeName":"English"}],"translations":{"br":"Inizi Cayman","pt":"Ilhas Caim\xe3o","nl":"Caymaneilanden","hr":"Kajmanski otoci","fa":"\u062C\u0632\u0627\u06CC\u0631 \u06A9\u06CC\u0645\u0646","de":"Kaimaninseln","es":"Islas Caim\xe1n","fr":"\xceles Ca\xefmans","ja":"\u30B1\u30A4\u30DE\u30F3\u8AF8\u5CF6","it":"Isole Cayman","hu":"Kajm\xe1n-szigetek"},"flag":"https://flagcdn.com/ky.svg","cioc":"CAY","independent":false},{"name":"Central African Republic","topLevelDomain":[".cf"],"alpha2Code":"CF","alpha3Code":"CAF","callingCodes":["236"],"capital":"Bangui","altSpellings":["CF","Central African Republic","R\xe9publique centrafricaine"],"subregion":"Middle Africa","region":"Africa","population":4829764,"latlng":[7,21],"demonym":"Central African","area":622984,"gini":56.2,"timezones":["UTC+01:00"],"borders":["CMR","TCD","COD","COG","SSD","SDN"],"nativeName":"K\xf6d\xf6r\xf6s\xease t\xee B\xeaafr\xeeka","numericCode":"140","flags":{"svg":"https://flagcdn.com/cf.svg","png":"https://flagcdn.com/w320/cf.png"},"currencies":[{"code":"XAF","name":"Central African CFA franc","symbol":"Fr"}],"languages":[{"iso639_1":"fr","iso639_2":"fra","name":"French","nativeName":"fran\xe7ais"},{"iso639_1":"sg","iso639_2":"sag","name":"Sango","nativeName":"y\xe2ng\xe2 t\xee s\xe4ng\xf6"}],"translations":{"br":"Republik Kreizafrikan","pt":"Rep\xfablica Centro-Africana","nl":"Centraal-Afrikaanse Republiek","hr":"Srednjoafri\u010Dka Republika","fa":"\u062C\u0645\u0647\u0648\u0631\u06CC \u0622\u0641\u0631\u06CC\u0642\u0627\u06CC \u0645\u0631\u06A9\u0632\u06CC","de":"Zentralafrikanische Republik","es":"Rep\xfablica Centroafricana","fr":"R\xe9publique centrafricaine","ja":"\u4E2D\u592E\u30A2\u30D5\u30EA\u30AB\u5171\u548C\u56FD","it":"Repubblica Centrafricana","hu":"K\xf6z\xe9p-afrikai K\xf6zt\xe1rsas\xe1g"},"flag":"https://flagcdn.com/cf.svg","regionalBlocs":[{"acronym":"AU","name":"African Union","otherNames":["\u0627\u0644\u0627\u062A\u062D\u0627\u062F \u0627\u0644\u0623\u0641\u0631\u064A\u0642\u064A","Union africaine","Uni\xe3o Africana","Uni\xf3n Africana","Umoja wa Afrika"]}],"cioc":"CAF","independent":true},{"name":"Chad","topLevelDomain":[".td"],"alpha2Code":"TD","alpha3Code":"TCD","callingCodes":["235"],"capital":"N\'Djamena","altSpellings":["TD","Tchad","Republic of Chad","R\xe9publique du Tchad"],"subregion":"Middle Africa","region":"Africa","population":16425859,"latlng":[15,19],"demonym":"Chadian","area":1284000,"gini":43.3,"timezones":["UTC+01:00"],"borders":["CMR","CAF","LBY","NER","NGA","SDN"],"nativeName":"Tchad","numericCode":"148","flags":{"svg":"https://flagcdn.com/td.svg","png":"https://flagcdn.com/w320/td.png"},"currencies":[{"code":"XAF","name":"Central African CFA franc","symbol":"Fr"}],"languages":[{"iso639_1":"fr","iso639_2":"fra","name":"French","nativeName":"fran\xe7ais"},{"iso639_1":"ar","iso639_2":"ara","name":"Arabic","nativeName":"\u0627\u0644\u0639\u0631\u0628\u064A\u0629"}],"translations":{"br":"Tchad","pt":"Chade","nl":"Tsjaad","hr":"\u010Cad","fa":"\u0686\u0627\u062F","de":"Tschad","es":"Chad","fr":"Tchad","ja":"\u30C1\u30E3\u30C9","it":"Ciad","hu":"Cs\xe1d"},"flag":"https://flagcdn.com/td.svg","regionalBlocs":[{"acronym":"AU","name":"African Union","otherNames":["\u0627\u0644\u0627\u062A\u062D\u0627\u062F \u0627\u0644\u0623\u0641\u0631\u064A\u0642\u064A","Union africaine","Uni\xe3o Africana","Uni\xf3n Africana","Umoja wa Afrika"]}],"cioc":"CHA","independent":true},{"name":"Chile","topLevelDomain":[".cl"],"alpha2Code":"CL","alpha3Code":"CHL","callingCodes":["56"],"capital":"Santiago","altSpellings":["CL","Republic of Chile","Rep\xfablica de Chile"],"subregion":"South America","region":"Americas","population":19116209,"latlng":[-30,-71],"demonym":"Chilean","area":756102,"gini":44.4,"timezones":["UTC-06:00","UTC-04:00"],"borders":["ARG","BOL","PER"],"nativeName":"Chile","numericCode":"152","flags":{"svg":"https://flagcdn.com/cl.svg","png":"https://flagcdn.com/w320/cl.png"},"currencies":[{"code":"CLP","name":"Chilean peso","symbol":"$"}],"languages":[{"iso639_1":"es","iso639_2":"spa","name":"Spanish","nativeName":"Espa\xf1ol"}],"translations":{"br":"Chile","pt":"Chile","nl":"Chili","hr":"\u010Cile","fa":"\u0634\u06CC\u0644\u06CC","de":"Chile","es":"Chile","fr":"Chili","ja":"\u30C1\u30EA","it":"Cile","hu":"Chile"},"flag":"https://flagcdn.com/cl.svg","regionalBlocs":[{"acronym":"PA","name":"Pacific Alliance","otherNames":["Alianza del Pac\xedfico"]},{"acronym":"USAN","name":"Union of South American Nations","otherAcronyms":["UNASUR","UNASUL","UZAN"],"otherNames":["Uni\xf3n de Naciones Suramericanas","Uni\xe3o de Na\xe7\xf5es Sul-Americanas","Unie van Zuid-Amerikaanse Naties","South American Union"]}],"cioc":"CHI","independent":true},{"name":"China","topLevelDomain":[".cn"],"alpha2Code":"CN","alpha3Code":"CHN","callingCodes":["86"],"capital":"Beijing","altSpellings":["CN","Zh\u014Dnggu\xf3","Zhongguo","Zhonghua","People\'s Republic of China","\u4E2D\u534E\u4EBA\u6C11\u5171\u548C\u56FD","Zh\u014Dnghu\xe1 R\xe9nm\xedn G\xf2ngh\xe9gu\xf3"],"subregion":"Eastern Asia","region":"Asia","population":1402112000,"latlng":[35,105],"demonym":"Chinese","area":9640011,"gini":38.5,"timezones":["UTC+08:00"],"borders":["AFG","BTN","MMR","HKG","IND","KAZ","PRK","KGZ","LAO","MAC","MNG","PAK","RUS","TJK","VNM","NPL"],"nativeName":"\u4E2D\u56FD","numericCode":"156","flags":{"svg":"https://flagcdn.com/cn.svg","png":"https://flagcdn.com/w320/cn.png"},"currencies":[{"code":"CNY","name":"Chinese yuan","symbol":"\xa5"}],"languages":[{"iso639_1":"zh","iso639_2":"zho","name":"Chinese","nativeName":"\u4E2D\u6587 (Zh\u014Dngw\xe9n)"}],"translations":{"br":"Sina","pt":"China","nl":"China","hr":"Kina","fa":"\u0686\u06CC\u0646","de":"China","es":"China","fr":"Chine","ja":"\u4E2D\u56FD","it":"Cina","hu":"K\xedna"},"flag":"https://flagcdn.com/cn.svg","cioc":"CHN","independent":true},{"name":"Christmas Island","topLevelDomain":[".cx"],"alpha2Code":"CX","alpha3Code":"CXR","callingCodes":["61"],"capital":"Flying Fish Cove","altSpellings":["CX","Territory of Christmas Island"],"subregion":"Australia and New Zealand","region":"Oceania","population":2072,"latlng":[-10.5,105.66666666],"demonym":"Christmas Island","area":135,"timezones":["UTC+07:00"],"nativeName":"Christmas Island","numericCode":"162","flags":{"svg":"https://flagcdn.com/cx.svg","png":"https://flagcdn.com/w320/cx.png"},"currencies":[{"code":"AUD","name":"Australian dollar","symbol":"$"}],"languages":[{"iso639_1":"en","iso639_2":"eng","name":"English","nativeName":"English"}],"translations":{"br":"Enez Christmas","pt":"Ilha do Natal","nl":"Christmaseiland","hr":"Bo\u017Ei\u0107ni otok","fa":"\u062C\u0632\u06CC\u0631\u0647 \u06A9\u0631\u06CC\u0633\u0645\u0633","de":"Weihnachtsinsel","es":"Isla de Navidad","fr":"\xcele Christmas","ja":"\u30AF\u30EA\u30B9\u30DE\u30B9\u5CF6","it":"Isola di Natale","hu":"Kar\xe1csony-sziget"},"flag":"https://flagcdn.com/cx.svg","independent":false},{"name":"Cocos (Keeling) Islands","topLevelDomain":[".cc"],"alpha2Code":"CC","alpha3Code":"CCK","callingCodes":["61"],"capital":"West Island","altSpellings":["CC","Territory of the Cocos (Keeling) Islands","Keeling Islands"],"subregion":"Australia and New Zealand","region":"Oceania","population":550,"latlng":[-12.5,96.83333333],"demonym":"Cocos Islander","area":14,"timezones":["UTC+06:30"],"nativeName":"Cocos (Keeling) Islands","numericCode":"166","flags":{"svg":"https://flagcdn.com/cc.svg","png":"https://flagcdn.com/w320/cc.png"},"currencies":[{"code":"AUD","name":"Australian dollar","symbol":"$"}],"languages":[{"iso639_1":"en","iso639_2":"eng","name":"English","nativeName":"English"}],"translations":{"br":"Inizi Cocos (Keeling)","pt":"Ilhas dos Cocos","nl":"Cocoseilanden","hr":"Kokosovi Otoci","fa":"\u062C\u0632\u0627\u06CC\u0631 \u06A9\u0648\u06A9\u0648\u0633","de":"Kokosinseln","es":"Islas Cocos o Islas Keeling","fr":"\xceles Cocos","ja":"\u30B3\u30B3\u30B9\uFF08\u30AD\u30FC\u30EA\u30F3\u30B0\uFF09\u8AF8\u5CF6","it":"Isole Cocos e Keeling","hu":"K\xf3kusz-szigetek"},"flag":"https://flagcdn.com/cc.svg","independent":false},{"name":"Colombia","topLevelDomain":[".co"],"alpha2Code":"CO","alpha3Code":"COL","callingCodes":["57"],"capital":"Bogot\xe1","altSpellings":["CO","Republic of Colombia","Rep\xfablica de Colombia"],"subregion":"South America","region":"Americas","population":50882884,"latlng":[4,-72],"demonym":"Colombian","area":1141748,"gini":51.3,"timezones":["UTC-05:00"],"borders":["BRA","ECU","PAN","PER","VEN"],"nativeName":"Colombia","numericCode":"170","flags":{"svg":"https://flagcdn.com/co.svg","png":"https://flagcdn.com/w320/co.png"},"currencies":[{"code":"COP","name":"Colombian peso","symbol":"$"}],"languages":[{"iso639_1":"es","iso639_2":"spa","name":"Spanish","nativeName":"Espa\xf1ol"}],"translations":{"br":"Kolombia","pt":"Col\xf4mbia","nl":"Colombia","hr":"Kolumbija","fa":"\u06A9\u0644\u0645\u0628\u06CC\u0627","de":"Kolumbien","es":"Colombia","fr":"Colombie","ja":"\u30B3\u30ED\u30F3\u30D3\u30A2","it":"Colombia","hu":"Kolumbia"},"flag":"https://flagcdn.com/co.svg","regionalBlocs":[{"acronym":"PA","name":"Pacific Alliance","otherNames":["Alianza del Pac\xedfico"]},{"acronym":"USAN","name":"Union of South American Nations","otherAcronyms":["UNASUR","UNASUL","UZAN"],"otherNames":["Uni\xf3n de Naciones Suramericanas","Uni\xe3o de Na\xe7\xf5es Sul-Americanas","Unie van Zuid-Amerikaanse Naties","South American Union"]}],"cioc":"COL","independent":true},{"name":"Comoros","topLevelDomain":[".km"],"alpha2Code":"KM","alpha3Code":"COM","callingCodes":["269"],"capital":"Moroni","altSpellings":["KM","Union of the Comoros","Union des Comores","Udzima wa Komori","al-Itti\u1E25\u0101d al-Qumur\u012B"],"subregion":"Eastern Africa","region":"Africa","population":869595,"latlng":[-12.16666666,44.25],"demonym":"Comoran","area":1862,"gini":45.3,"timezones":["UTC+03:00"],"nativeName":"Komori","numericCode":"174","flags":{"svg":"https://flagcdn.com/km.svg","png":"https://flagcdn.com/w320/km.png"},"currencies":[{"code":"KMF","name":"Comorian franc","symbol":"Fr"}],"languages":[{"iso639_1":"ar","iso639_2":"ara","name":"Arabic","nativeName":"\u0627\u0644\u0639\u0631\u0628\u064A\u0629"},{"iso639_1":"fr","iso639_2":"fra","name":"French","nativeName":"fran\xe7ais"}],"translations":{"br":"Komorez","pt":"Comores","nl":"Comoren","hr":"Komori","fa":"\u06A9\u0648\u0645\u0648\u0631","de":"Union der Komoren","es":"Comoras","fr":"Comores","ja":"\u30B3\u30E2\u30ED","it":"Comore","hu":"Comore-szigetek"},"flag":"https://flagcdn.com/km.svg","regionalBlocs":[{"acronym":"AU","name":"African Union","otherNames":["\u0627\u0644\u0627\u062A\u062D\u0627\u062F \u0627\u0644\u0623\u0641\u0631\u064A\u0642\u064A","Union africaine","Uni\xe3o Africana","Uni\xf3n Africana","Umoja wa Afrika"]},{"acronym":"AL","name":"Arab League","otherNames":["\u062C\u0627\u0645\u0639\u0629 \u0627\u0644\u062F\u0648\u0644 \u0627\u0644\u0639\u0631\u0628\u064A\u0629","J\u0101mi\u02BBat ad-Duwal al-\u02BBArab\u012Byah","League of Arab States"]}],"cioc":"COM","independent":true},{"name":"Congo","topLevelDomain":[".cg"],"alpha2Code":"CG","alpha3Code":"COG","callingCodes":["242"],"capital":"Brazzaville","altSpellings":["CG","Congo-Brazzaville"],"subregion":"Middle Africa","region":"Africa","population":5518092,"latlng":[-1,15],"demonym":"Congolese","area":342000,"gini":48.9,"timezones":["UTC+01:00"],"borders":["AGO","CMR","CAF","COD","GAB"],"nativeName":"R\xe9publique du Congo","numericCode":"178","flags":{"svg":"https://flagcdn.com/cg.svg","png":"https://flagcdn.com/w320/cg.png"},"currencies":[{"code":"XAF","name":"Central African CFA franc","symbol":"Fr"}],"languages":[{"iso639_1":"fr","iso639_2":"fra","name":"French","nativeName":"fran\xe7ais"},{"iso639_1":"ln","iso639_2":"lin","name":"Lingala","nativeName":"Ling\xe1la"}],"translations":{"br":"Kongo-Brazzaville","pt":"Congo","nl":"Congo [Republiek]","hr":"Kongo","fa":"\u06A9\u0646\u06AF\u0648","de":"Kongo","es":"Congo","fr":"Congo","ja":"\u30B3\u30F3\u30B4\u5171\u548C\u56FD","it":"Congo","hu":"Kong\xf3i K\xf6zt\xe1rsas\xe1g"},"flag":"https://flagcdn.com/cg.svg","regionalBlocs":[{"acronym":"AU","name":"African Union","otherNames":["\u0627\u0644\u0627\u062A\u062D\u0627\u062F \u0627\u0644\u0623\u0641\u0631\u064A\u0642\u064A","Union africaine","Uni\xe3o Africana","Uni\xf3n Africana","Umoja wa Afrika"]}],"cioc":"CGO","independent":true},{"name":"Congo (Democratic Republic of the)","topLevelDomain":[".cd"],"alpha2Code":"CD","alpha3Code":"COD","callingCodes":["243"],"capital":"Kinshasa","altSpellings":["CD","DR Congo","Congo-Kinshasa","DRC"],"subregion":"Middle Africa","region":"Africa","population":89561404,"latlng":[0,25],"demonym":"Congolese","area":2344858,"gini":42.1,"timezones":["UTC+01:00","UTC+02:00"],"borders":["AGO","BDI","CAF","COG","RWA","SSD","TZA","UGA","ZMB"],"nativeName":"R\xe9publique d\xe9mocratique du Congo","numericCode":"180","flags":{"svg":"https://flagcdn.com/cd.svg","png":"https://flagcdn.com/w320/cd.png"},"currencies":[{"code":"CDF","name":"Congolese franc","symbol":"Fr"}],"languages":[{"iso639_1":"fr","iso639_2":"fra","name":"French","nativeName":"fran\xe7ais"},{"iso639_1":"ln","iso639_2":"lin","name":"Lingala","nativeName":"Ling\xe1la"},{"iso639_1":"kg","iso639_2":"kon","name":"Kongo","nativeName":"Kikongo"},{"iso639_1":"sw","iso639_2":"swa","name":"Swahili","nativeName":"Kiswahili"},{"iso639_1":"lu","iso639_2":"lub","name":"Luba-Katanga","nativeName":"Tshiluba"}],"translations":{"br":"Kongo-Kinshasa","pt":"RD Congo","nl":"Congo [DRC]","hr":"Kongo, Demokratska Republika","fa":"\u062C\u0645\u0647\u0648\u0631\u06CC \u06A9\u0646\u06AF\u0648","de":"Kongo (Dem. Rep.)","es":"Congo (Rep. Dem.)","fr":"Congo (R\xe9p. d\xe9m.)","ja":"\u30B3\u30F3\u30B4\u6C11\u4E3B\u5171\u548C\u56FD","it":"Congo (Rep. Dem.)","hu":"Kong\xf3i Demokratikus K\xf6zt\xe1rsas\xe1g"},"flag":"https://flagcdn.com/cd.svg","regionalBlocs":[{"acronym":"AU","name":"African Union","otherNames":["\u0627\u0644\u0627\u062A\u062D\u0627\u062F \u0627\u0644\u0623\u0641\u0631\u064A\u0642\u064A","Union africaine","Uni\xe3o Africana","Uni\xf3n Africana","Umoja wa Afrika"]}],"cioc":"COD","independent":true},{"name":"Cook Islands","topLevelDomain":[".ck"],"alpha2Code":"CK","alpha3Code":"COK","callingCodes":["682"],"capital":"Avarua","altSpellings":["CK","K\u016Bki \'\u0100irani"],"subregion":"Polynesia","region":"Oceania","population":18100,"latlng":[-21.23333333,-159.76666666],"demonym":"Cook Islander","area":236,"timezones":["UTC-10:00"],"nativeName":"Cook Islands","numericCode":"184","flags":{"svg":"https://flagcdn.com/ck.svg","png":"https://flagcdn.com/w320/ck.png"},"currencies":[{"code":"NZD","name":"New Zealand dollar","symbol":"$"},{"code":"CKD","name":"Cook Islands dollar","symbol":"$"}],"languages":[{"iso639_1":"en","iso639_2":"eng","name":"English","nativeName":"English"},{"iso639_2":"rar","name":"Cook Islands M\u0101ori","nativeName":"M\u0101ori"}],"translations":{"br":"Inizi Cook","pt":"Ilhas Cook","nl":"Cookeilanden","hr":"Cookovo Oto\u010Dje","fa":"\u062C\u0632\u0627\u06CC\u0631 \u06A9\u0648\u06A9","de":"Cookinseln","es":"Islas Cook","fr":"\xceles Cook","ja":"\u30AF\u30C3\u30AF\u8AF8\u5CF6","it":"Isole Cook","hu":"Cook-szigetek"},"flag":"https://flagcdn.com/ck.svg","cioc":"COK","independent":true},{"name":"Costa Rica","topLevelDomain":[".cr"],"alpha2Code":"CR","alpha3Code":"CRI","callingCodes":["506"],"capital":"San Jos\xe9","altSpellings":["CR","Republic of Costa Rica","Rep\xfablica de Costa Rica"],"subregion":"Central America","region":"Americas","population":5094114,"latlng":[10,-84],"demonym":"Costa Rican","area":51100,"gini":48.2,"timezones":["UTC-06:00"],"borders":["NIC","PAN"],"nativeName":"Costa Rica","numericCode":"188","flags":{"svg":"https://flagcdn.com/cr.svg","png":"https://flagcdn.com/w320/cr.png"},"currencies":[{"code":"CRC","name":"Costa Rican col\xf3n","symbol":"\u20A1"}],"languages":[{"iso639_1":"es","iso639_2":"spa","name":"Spanish","nativeName":"Espa\xf1ol"}],"translations":{"br":"Costa Rica","pt":"Costa Rica","nl":"Costa Rica","hr":"Kostarika","fa":"\u06A9\u0627\u0633\u062A\u0627\u0631\u06CC\u06A9\u0627","de":"Costa Rica","es":"Costa Rica","fr":"Costa Rica","ja":"\u30B3\u30B9\u30BF\u30EA\u30AB","it":"Costa Rica","hu":"Costa Rica"},"flag":"https://flagcdn.com/cr.svg","regionalBlocs":[{"acronym":"CAIS","name":"Central American Integration System","otherAcronyms":["SICA"],"otherNames":["Sistema de la Integraci\xf3n Centroamericana,"]}],"cioc":"CRC","independent":true},{"name":"Croatia","topLevelDomain":[".hr"],"alpha2Code":"HR","alpha3Code":"HRV","callingCodes":["385"],"capital":"Zagreb","altSpellings":["HR","Hrvatska","Republic of Croatia","Republika Hrvatska"],"subregion":"Southern Europe","region":"Europe","population":4047200,"latlng":[45.16666666,15.5],"demonym":"Croatian","area":56594,"gini":29.7,"timezones":["UTC+01:00"],"borders":["BIH","HUN","MNE","SRB","SVN"],"nativeName":"Hrvatska","numericCode":"191","flags":{"svg":"https://flagcdn.com/hr.svg","png":"https://flagcdn.com/w320/hr.png"},"currencies":[{"code":"EUR","name":"Euro","symbol":"\u20AC"}],"languages":[{"iso639_1":"hr","iso639_2":"hrv","name":"Croatian","nativeName":"hrvatski jezik"}],"translations":{"br":"Kroatia","pt":"Cro\xe1cia","nl":"Kroati\xeb","hr":"Hrvatska","fa":"\u06A9\u0631\u0648\u0627\u0633\u06CC","de":"Kroatien","es":"Croacia","fr":"Croatie","ja":"\u30AF\u30ED\u30A2\u30C1\u30A2","it":"Croazia","hu":"Horv\xe1torsz\xe1g"},"flag":"https://flagcdn.com/hr.svg","regionalBlocs":[{"acronym":"EU","name":"European Union"}],"cioc":"CRO","independent":true},{"name":"Cuba","topLevelDomain":[".cu"],"alpha2Code":"CU","alpha3Code":"CUB","callingCodes":["53"],"capital":"Havana","altSpellings":["CU","Republic of Cuba","Rep\xfablica de Cuba"],"subregion":"Caribbean","region":"Americas","population":11326616,"latlng":[21.5,-80],"demonym":"Cuban","area":109884,"timezones":["UTC-05:00"],"nativeName":"Cuba","numericCode":"192","flags":{"svg":"https://flagcdn.com/cu.svg","png":"https://flagcdn.com/w320/cu.png"},"currencies":[{"code":"CUC","name":"Cuban convertible peso","symbol":"$"},{"code":"CUP","name":"Cuban peso","symbol":"$"}],"languages":[{"iso639_1":"es","iso639_2":"spa","name":"Spanish","nativeName":"Espa\xf1ol"}],"translations":{"br":"Kuba","pt":"Cuba","nl":"Cuba","hr":"Kuba","fa":"\u06A9\u0648\u0628\u0627","de":"Kuba","es":"Cuba","fr":"Cuba","ja":"\u30AD\u30E5\u30FC\u30D0","it":"Cuba","hu":"Kuba"},"flag":"https://flagcdn.com/cu.svg","cioc":"CUB","independent":true},{"name":"Cura\xe7ao","topLevelDomain":[".cw"],"alpha2Code":"CW","alpha3Code":"CUW","callingCodes":["599"],"capital":"Willemstad","altSpellings":["CW","Curacao","K\xf2rsou","Country of Cura\xe7ao","Land Cura\xe7ao","Pais K\xf2rsou"],"subregion":"Caribbean","region":"Americas","population":155014,"latlng":[12.116667,-68.933333],"demonym":"Dutch","area":444,"timezones":["UTC-04:00"],"nativeName":"Cura\xe7ao","numericCode":"531","flags":{"svg":"https://flagcdn.com/cw.svg","png":"https://flagcdn.com/w320/cw.png"},"currencies":[{"code":"ANG","name":"Netherlands Antillean guilder","symbol":"\u0192"}],"languages":[{"iso639_1":"nl","iso639_2":"nld","name":"Dutch","nativeName":"Nederlands"},{"iso639_1":"pa","iso639_2":"pan","name":"(Eastern) Punjabi","nativeName":"\u0A2A\u0A70\u0A1C\u0A3E\u0A2C\u0A40"},{"iso639_1":"en","iso639_2":"eng","name":"English","nativeName":"English"}],"translations":{"br":"Cura\xe7ao","pt":"Cura\xe7ao","nl":"Cura\xe7ao","hr":"Cura\xe7ao","fa":"\u06A9\u0648\u0631\u0627\u0633\u0627\u0626\u0648","de":"Cura\xe7ao","es":"Cura\xe7ao","fr":"Cura\xe7ao","ja":"Cura\xe7ao","it":"Cura\xe7ao","hu":"Cura\xe7ao"},"flag":"https://flagcdn.com/cw.svg","independent":false},{"name":"Cyprus","topLevelDomain":[".cy"],"alpha2Code":"CY","alpha3Code":"CYP","callingCodes":["357"],"capital":"Nicosia","altSpellings":["CY","K\xfdpros","K\u0131br\u0131s","Republic of Cyprus","\u039A\u03C5\u03C0\u03C1\u03B9\u03B1\u03BA\u03AE \u0394\u03B7\u03BC\u03BF\u03BA\u03C1\u03B1\u03C4\u03AF\u03B1","K\u0131br\u0131s Cumhuriyeti"],"subregion":"Southern Europe","region":"Europe","population":1207361,"latlng":[35,33],"demonym":"Cypriot","area":9251,"gini":32.7,"timezones":["UTC+02:00"],"borders":["GBR"],"nativeName":"\u039A\u03CD\u03C0\u03C1\u03BF\u03C2","numericCode":"196","flags":{"svg":"https://flagcdn.com/cy.svg","png":"https://flagcdn.com/w320/cy.png"},"currencies":[{"code":"EUR","name":"Euro","symbol":"\u20AC"}],"languages":[{"iso639_1":"el","iso639_2":"ell","name":"Greek (modern)","nativeName":"\u03B5\u03BB\u03BB\u03B7\u03BD\u03B9\u03BA\u03AC"},{"iso639_1":"tr","iso639_2":"tur","name":"Turkish","nativeName":"T\xfcrk\xe7e"},{"iso639_1":"hy","iso639_2":"hye","name":"Armenian","nativeName":"\u0540\u0561\u0575\u0565\u0580\u0565\u0576"}],"translations":{"br":"Kiprenez","pt":"Chipre","nl":"Cyprus","hr":"Cipar","fa":"\u0642\u0628\u0631\u0633","de":"Zypern","es":"Chipre","fr":"Chypre","ja":"\u30AD\u30D7\u30ED\u30B9","it":"Cipro","hu":"Ciprus"},"flag":"https://flagcdn.com/cy.svg","regionalBlocs":[{"acronym":"EU","name":"European Union"}],"cioc":"CYP","independent":true},{"name":"Czech Republic","topLevelDomain":[".cz"],"alpha2Code":"CZ","alpha3Code":"CZE","callingCodes":["420"],"capital":"Prague","altSpellings":["CZ","\u010Cesk\xe1 republika","\u010Cesko"],"subregion":"Central Europe","region":"Europe","population":10698896,"latlng":[49.75,15.5],"demonym":"Czech","area":78865,"gini":25,"timezones":["UTC+01:00"],"nativeName":"\u010Cesk\xe1 republika","numericCode":"203","flags":{"svg":"https://flagcdn.com/cz.svg","png":"https://flagcdn.com/w320/cz.png"},"currencies":[{"code":"CZK","name":"Czech koruna","symbol":"K\u010D"}],"languages":[{"iso639_1":"cs","iso639_2":"ces","name":"Czech","nativeName":"\u010De\u0161tina"},{"iso639_1":"sk","iso639_2":"slk","name":"Slovak","nativeName":"sloven\u010Dina"}],"translations":{"br":"Tchekia","pt":"Rep\xfablica Checa","nl":"Tsjechi\xeb","hr":"\u010Ce\u0161ka","fa":"\u062C\u0645\u0647\u0648\u0631\u06CC \u0686\u06A9","de":"Tschechische Republik","es":"Rep\xfablica Checa","fr":"R\xe9publique tch\xe8que","ja":"\u30C1\u30A7\u30B3","it":"Repubblica Ceca","hu":"Csehorsz\xe1g"},"flag":"https://flagcdn.com/cz.svg","regionalBlocs":[{"acronym":"EU","name":"European Union"}],"cioc":"CZE","independent":true},{"name":"Denmark","topLevelDomain":[".dk"],"alpha2Code":"DK","alpha3Code":"DNK","callingCodes":["45"],"capital":"Copenhagen","altSpellings":["DK","Danmark","Kingdom of Denmark","Kongeriget Danmark"],"subregion":"Northern Europe","region":"Europe","population":5831404,"latlng":[56,10],"demonym":"Danish","area":43094,"gini":28.2,"timezones":["UTC-04:00","UTC-03:00","UTC-01:00","UTC","UTC+01:00"],"borders":["DEU"],"nativeName":"Danmark","numericCode":"208","flags":{"svg":"https://flagcdn.com/dk.svg","png":"https://flagcdn.com/w320/dk.png"},"currencies":[{"code":"DKK","name":"Danish krone","symbol":"kr"}],"languages":[{"iso639_1":"da","iso639_2":"dan","name":"Danish","nativeName":"dansk"}],"translations":{"br":"Danmark","pt":"Dinamarca","nl":"Denemarken","hr":"Danska","fa":"\u062F\u0627\u0646\u0645\u0627\u0631\u06A9","de":"D\xe4nemark","es":"Dinamarca","fr":"Danemark","ja":"\u30C7\u30F3\u30DE\u30FC\u30AF","it":"Danimarca","hu":"D\xe1nia"},"flag":"https://flagcdn.com/dk.svg","regionalBlocs":[{"acronym":"EU","name":"European Union"}],"cioc":"DEN","independent":true},{"name":"Djibouti","topLevelDomain":[".dj"],"alpha2Code":"DJ","alpha3Code":"DJI","callingCodes":["253"],"capital":"Djibouti","altSpellings":["DJ","Jabuuti","Gabuuti","Republic of Djibouti","R\xe9publique de Djibouti","Gabuutih Ummuuno","Jamhuuriyadda Jabuuti"],"subregion":"Eastern Africa","region":"Africa","population":988002,"latlng":[11.5,43],"demonym":"Djibouti","area":23200,"gini":41.6,"timezones":["UTC+03:00"],"borders":["ERI","ETH","SOM"],"nativeName":"Djibouti","numericCode":"262","flags":{"svg":"https://flagcdn.com/dj.svg","png":"https://flagcdn.com/w320/dj.png"},"currencies":[{"code":"DJF","name":"Djiboutian franc","symbol":"Fr"}],"languages":[{"iso639_1":"fr","iso639_2":"fra","name":"French","nativeName":"fran\xe7ais"},{"iso639_1":"ar","iso639_2":"ara","name":"Arabic","nativeName":"\u0627\u0644\u0639\u0631\u0628\u064A\u0629"}],"translations":{"br":"Djibouti","pt":"Djibuti","nl":"Djibouti","hr":"D\u017Eibuti","fa":"\u062C\u06CC\u0628\u0648\u062A\u06CC","de":"Dschibuti","es":"Yibuti","fr":"Djibouti","ja":"\u30B8\u30D6\u30C1","it":"Gibuti","hu":"Dzsibuti"},"flag":"https://flagcdn.com/dj.svg","regionalBlocs":[{"acronym":"AU","name":"African Union","otherNames":["\u0627\u0644\u0627\u062A\u062D\u0627\u062F \u0627\u0644\u0623\u0641\u0631\u064A\u0642\u064A","Union africaine","Uni\xe3o Africana","Uni\xf3n Africana","Umoja wa Afrika"]},{"acronym":"AL","name":"Arab League","otherNames":["\u062C\u0627\u0645\u0639\u0629 \u0627\u0644\u062F\u0648\u0644 \u0627\u0644\u0639\u0631\u0628\u064A\u0629","J\u0101mi\u02BBat ad-Duwal al-\u02BBArab\u012Byah","League of Arab States"]}],"cioc":"DJI","independent":true},{"name":"Dominica","topLevelDomain":[".dm"],"alpha2Code":"DM","alpha3Code":"DMA","callingCodes":["1"],"capital":"Roseau","altSpellings":["DM","Dominique","Wai\u2018tu kubuli","Commonwealth of Dominica"],"subregion":"Caribbean","region":"Americas","population":71991,"latlng":[15.41666666,-61.33333333],"demonym":"Dominican","area":751,"timezones":["UTC-04:00"],"nativeName":"Dominica","numericCode":"212","flags":{"svg":"https://flagcdn.com/dm.svg","png":"https://flagcdn.com/w320/dm.png"},"currencies":[{"code":"XCD","name":"East Caribbean dollar","symbol":"$"}],"languages":[{"iso639_1":"en","iso639_2":"eng","name":"English","nativeName":"English"}],"translations":{"br":"Dominika","pt":"Dominica","nl":"Dominica","hr":"Dominika","fa":"\u062F\u0648\u0645\u06CC\u0646\u06CC\u06A9\u0627","de":"Dominica","es":"Dominica","fr":"Dominique","ja":"\u30C9\u30DF\u30CB\u30AB\u56FD","it":"Dominica","hu":"Dominikai K\xf6z\xf6ss\xe9g"},"flag":"https://flagcdn.com/dm.svg","cioc":"DMA","independent":true},{"name":"Dominican Republic","topLevelDomain":[".do"],"alpha2Code":"DO","alpha3Code":"DOM","callingCodes":["1"],"capital":"Santo Domingo","altSpellings":["DO"],"subregion":"Caribbean","region":"Americas","population":10847904,"latlng":[19,-70.66666666],"demonym":"Dominican","area":48671,"gini":41.9,"timezones":["UTC-04:00"],"borders":["HTI"],"nativeName":"Rep\xfablica Dominicana","numericCode":"214","flags":{"svg":"https://flagcdn.com/do.svg","png":"https://flagcdn.com/w320/do.png"},"currencies":[{"code":"DOP","name":"Dominican peso","symbol":"$"}],"languages":[{"iso639_1":"es","iso639_2":"spa","name":"Spanish","nativeName":"Espa\xf1ol"}],"translations":{"br":"Republik Dominikan","pt":"Rep\xfablica Dominicana","nl":"Dominicaanse Republiek","hr":"Dominikanska Republika","fa":"\u062C\u0645\u0647\u0648\u0631\u06CC \u062F\u0648\u0645\u06CC\u0646\u06CC\u06A9\u0646","de":"Dominikanische Republik","es":"Rep\xfablica Dominicana","fr":"R\xe9publique dominicaine","ja":"\u30C9\u30DF\u30CB\u30AB\u5171\u548C\u56FD","it":"Repubblica Dominicana","hu":"Dominikai K\xf6zt\xe1rsas\xe1g"},"flag":"https://flagcdn.com/do.svg","regionalBlocs":[{"acronym":"CARICOM","name":"Caribbean Community","otherNames":["Comunidad del Caribe","Communaut\xe9 Carib\xe9enne","Caribische Gemeenschap"]},{"acronym":"CAIS","name":"Central American Integration System","otherAcronyms":["SICA"],"otherNames":["Sistema de la Integraci\xf3n Centroamericana,"]}],"cioc":"DOM","independent":true},{"name":"Ecuador","topLevelDomain":[".ec"],"alpha2Code":"EC","alpha3Code":"ECU","callingCodes":["593"],"capital":"Quito","altSpellings":["EC","Republic of Ecuador","Rep\xfablica del Ecuador"],"subregion":"South America","region":"Americas","population":17643060,"latlng":[-2,-77.5],"demonym":"Ecuadorean","area":276841,"gini":45.7,"timezones":["UTC-06:00","UTC-05:00"],"borders":["COL","PER"],"nativeName":"Ecuador","numericCode":"218","flags":{"svg":"https://flagcdn.com/ec.svg","png":"https://flagcdn.com/w320/ec.png"},"currencies":[{"code":"USD","name":"United States dollar","symbol":"$"}],"languages":[{"iso639_1":"es","iso639_2":"spa","name":"Spanish","nativeName":"Espa\xf1ol"}],"translations":{"br":"Ecuador","pt":"Equador","nl":"Ecuador","hr":"Ekvador","fa":"\u0627\u06A9\u0648\u0627\u062F\u0648\u0631","de":"Ecuador","es":"Ecuador","fr":"\xc9quateur","ja":"\u30A8\u30AF\u30A2\u30C9\u30EB","it":"Ecuador","hu":"Ecuador"},"flag":"https://flagcdn.com/ec.svg","regionalBlocs":[{"acronym":"USAN","name":"Union of South American Nations","otherAcronyms":["UNASUR","UNASUL","UZAN"],"otherNames":["Uni\xf3n de Naciones Suramericanas","Uni\xe3o de Na\xe7\xf5es Sul-Americanas","Unie van Zuid-Amerikaanse Naties","South American Union"]}],"cioc":"ECU","independent":true},{"name":"Egypt","topLevelDomain":[".eg"],"alpha2Code":"EG","alpha3Code":"EGY","callingCodes":["20"],"capital":"Cairo","altSpellings":["EG","Arab Republic of Egypt"],"subregion":"Northern Africa","region":"Africa","population":102334403,"latlng":[27,30],"demonym":"Egyptian","area":1002450,"gini":31.5,"timezones":["UTC+02:00"],"borders":["ISR","LBY","SDN"],"nativeName":"\u0645\u0635\u0631\u200E","numericCode":"818","flags":{"svg":"https://flagcdn.com/eg.svg","png":"https://flagcdn.com/w320/eg.png"},"currencies":[{"code":"EGP","name":"Egyptian pound","symbol":"\xa3"}],"languages":[{"iso639_1":"ar","iso639_2":"ara","name":"Arabic","nativeName":"\u0627\u0644\u0639\u0631\u0628\u064A\u0629"}],"translations":{"br":"Egipt","pt":"Egipto","nl":"Egypte","hr":"Egipat","fa":"\u0645\u0635\u0631","de":"\xc4gypten","es":"Egipto","fr":"\xc9gypte","ja":"\u30A8\u30B8\u30D7\u30C8","it":"Egitto","hu":"Egyiptom"},"flag":"https://flagcdn.com/eg.svg","regionalBlocs":[{"acronym":"AU","name":"African Union","otherNames":["\u0627\u0644\u0627\u062A\u062D\u0627\u062F \u0627\u0644\u0623\u0641\u0631\u064A\u0642\u064A","Union africaine","Uni\xe3o Africana","Uni\xf3n Africana","Umoja wa Afrika"]},{"acronym":"AL","name":"Arab League","otherNames":["\u062C\u0627\u0645\u0639\u0629 \u0627\u0644\u062F\u0648\u0644 \u0627\u0644\u0639\u0631\u0628\u064A\u0629","J\u0101mi\u02BBat ad-Duwal al-\u02BBArab\u012Byah","League of Arab States"]}],"cioc":"EGY","independent":true},{"name":"El Salvador","topLevelDomain":[".sv"],"alpha2Code":"SV","alpha3Code":"SLV","callingCodes":["503"],"capital":"San Salvador","altSpellings":["SV","Republic of El Salvador","Rep\xfablica de El Salvador"],"subregion":"Central America","region":"Americas","population":6486201,"latlng":[13.83333333,-88.91666666],"demonym":"Salvadoran","area":21041,"gini":38.8,"timezones":["UTC-06:00"],"borders":["GTM","HND"],"nativeName":"El Salvador","numericCode":"222","flags":{"svg":"https://flagcdn.com/sv.svg","png":"https://flagcdn.com/w320/sv.png"},"currencies":[{"code":"USD","name":"United States dollar","symbol":"$"}],"languages":[{"iso639_1":"es","iso639_2":"spa","name":"Spanish","nativeName":"Espa\xf1ol"}],"translations":{"br":"El Salvador","pt":"El Salvador","nl":"El Salvador","hr":"Salvador","fa":"\u0627\u0644\u0633\u0627\u0644\u0648\u0627\u062F\u0648\u0631","de":"El Salvador","es":"El Salvador","fr":"Salvador","ja":"\u30A8\u30EB\u30B5\u30EB\u30D0\u30C9\u30EB","it":"El Salvador","hu":"Salvador"},"flag":"https://flagcdn.com/sv.svg","regionalBlocs":[{"acronym":"CAIS","name":"Central American Integration System","otherAcronyms":["SICA"],"otherNames":["Sistema de la Integraci\xf3n Centroamericana,"]}],"cioc":"ESA","independent":true},{"name":"Equatorial Guinea","topLevelDomain":[".gq"],"alpha2Code":"GQ","alpha3Code":"GNQ","callingCodes":["240"],"capital":"Malabo","altSpellings":["GQ","Republic of Equatorial Guinea","Rep\xfablica de Guinea Ecuatorial","R\xe9publique de Guin\xe9e \xe9quatoriale","Rep\xfablica da Guin\xe9 Equatorial"],"subregion":"Middle Africa","region":"Africa","population":1402985,"latlng":[2,10],"demonym":"Equatorial Guinean","area":28051,"timezones":["UTC+01:00"],"borders":["CMR","GAB"],"nativeName":"Guinea Ecuatorial","numericCode":"226","flags":{"svg":"https://flagcdn.com/gq.svg","png":"https://flagcdn.com/w320/gq.png"},"currencies":[{"code":"XAF","name":"Central African CFA franc","symbol":"Fr"}],"languages":[{"iso639_1":"es","iso639_2":"spa","name":"Spanish","nativeName":"Espa\xf1ol"},{"iso639_1":"fr","iso639_2":"fra","name":"French","nativeName":"fran\xe7ais"},{"iso639_1":"pt","iso639_2":"por","name":"Portuguese","nativeName":"Portugu\xeas"},{"iso639_2":"fan","name":"Fang","nativeName":"Fang"}],"translations":{"br":"Ginea ar C\'heheder","pt":"Guin\xe9 Equatorial","nl":"Equatoriaal-Guinea","hr":"Ekvatorijalna Gvineja","fa":"\u06AF\u06CC\u0646\u0647 \u0627\u0633\u062A\u0648\u0627\u06CC\u06CC","de":"\xc4quatorial-Guinea","es":"Guinea Ecuatorial","fr":"Guin\xe9e-\xc9quatoriale","ja":"\u8D64\u9053\u30AE\u30CB\u30A2","it":"Guinea Equatoriale","hu":"Egyenl\xedt\u0151i-Guinea"},"flag":"https://flagcdn.com/gq.svg","regionalBlocs":[{"acronym":"AU","name":"African Union","otherNames":["\u0627\u0644\u0627\u062A\u062D\u0627\u062F \u0627\u0644\u0623\u0641\u0631\u064A\u0642\u064A","Union africaine","Uni\xe3o Africana","Uni\xf3n Africana","Umoja wa Afrika"]}],"cioc":"GEQ","independent":true},{"name":"Eritrea","topLevelDomain":[".er"],"alpha2Code":"ER","alpha3Code":"ERI","callingCodes":["291"],"capital":"Asmara","altSpellings":["ER","State of Eritrea","\u1203\u1308\u1228 \u12A4\u122D\u1275\u122B","Dawlat Iritriy\xe1","\u02BEErtr\u0101","Iritriy\u0101",""],"subregion":"Eastern Africa","region":"Africa","population":5352000,"latlng":[15,39],"demonym":"Eritrean","area":117600,"timezones":["UTC+03:00"],"borders":["DJI","ETH","SDN"],"nativeName":"\u12A4\u122D\u1275\u122B","numericCode":"232","flags":{"svg":"https://flagcdn.com/er.svg","png":"https://flagcdn.com/w320/er.png"},"currencies":[{"code":"ERN","name":"Eritrean nakfa","symbol":"Nfk"}],"languages":[{"iso639_1":"ti","iso639_2":"tir","name":"Tigrinya","nativeName":"\u1275\u130D\u122D\u129B"},{"iso639_1":"ar","iso639_2":"ara","name":"Arabic","nativeName":"\u0627\u0644\u0639\u0631\u0628\u064A\u0629"},{"iso639_1":"en","iso639_2":"eng","name":"English","nativeName":"English"},{"iso639_2":"tig","name":"Tigre","nativeName":"\u1275\u130D\u1228"},{"iso639_2":"kun","name":"Kunama","nativeName":"Kunama"},{"iso639_2":"ssy","name":"Saho","nativeName":"Saho"},{"iso639_2":"byn","name":"Bilen","nativeName":"\u1265\u120A\u1293"},{"iso639_2":"nrb","name":"Nara","nativeName":"Nara"},{"iso639_1":"aa","iso639_2":"aar","name":"Afar","nativeName":"Afar"}],"translations":{"br":"Eritrea","pt":"Eritreia","nl":"Eritrea","hr":"Eritreja","fa":"\u0627\u0631\u06CC\u062A\u0631\u0647","de":"Eritrea","es":"Eritrea","fr":"\xc9rythr\xe9e","ja":"\u30A8\u30EA\u30C8\u30EA\u30A2","it":"Eritrea","hu":"Eritrea"},"flag":"https://flagcdn.com/er.svg","regionalBlocs":[{"acronym":"AU","name":"African Union","otherNames":["\u0627\u0644\u0627\u062A\u062D\u0627\u062F \u0627\u0644\u0623\u0641\u0631\u064A\u0642\u064A","Union africaine","Uni\xe3o Africana","Uni\xf3n Africana","Umoja wa Afrika"]}],"cioc":"ERI","independent":true},{"name":"Estonia","topLevelDomain":[".ee"],"alpha2Code":"EE","alpha3Code":"EST","callingCodes":["372"],"capital":"Tallinn","altSpellings":["EE","Eesti","Republic of Estonia","Eesti Vabariik"],"subregion":"Northern Europe","region":"Europe","population":1331057,"latlng":[59,26],"demonym":"Estonian","area":45227,"gini":30.3,"timezones":["UTC+02:00"],"borders":["LVA","RUS"],"nativeName":"Eesti","numericCode":"233","flags":{"svg":"https://flagcdn.com/ee.svg","png":"https://flagcdn.com/w320/ee.png"},"currencies":[{"code":"EUR","name":"Euro","symbol":"\u20AC"}],"languages":[{"iso639_1":"et","iso639_2":"est","name":"Estonian","nativeName":"eesti"}],"translations":{"br":"Estonia","pt":"Est\xf3nia","nl":"Estland","hr":"Estonija","fa":"\u0627\u0633\u062A\u0648\u0646\u06CC","de":"Estland","es":"Estonia","fr":"Estonie","ja":"\u30A8\u30B9\u30C8\u30CB\u30A2","it":"Estonia","hu":"\xc9sztorsz\xe1g"},"flag":"https://flagcdn.com/ee.svg","regionalBlocs":[{"acronym":"EU","name":"European Union"}],"cioc":"EST","independent":true},{"name":"Ethiopia","topLevelDomain":[".et"],"alpha2Code":"ET","alpha3Code":"ETH","callingCodes":["251"],"capital":"Addis Ababa","altSpellings":["ET","\u02BE\u012Aty\u014D\u1E57\u1E57y\u0101","Federal Democratic Republic of Ethiopia","\u12E8\u12A2\u1275\u12EE\u1335\u12EB \u134C\u12F4\u122B\u120B\u12CA \u12F2\u121E\u12AD\u122B\u1232\u12EB\u12CA \u122A\u1350\u1265\u120A\u12AD"],"subregion":"Eastern Africa","region":"Africa","population":114963583,"latlng":[8,38],"demonym":"Ethiopian","area":1104300,"gini":35,"timezones":["UTC+03:00"],"borders":["DJI","ERI","KEN","SOM","SSD","SDN"],"nativeName":"\u12A2\u1275\u12EE\u1335\u12EB","numericCode":"231","flags":{"svg":"https://flagcdn.com/et.svg","png":"https://flagcdn.com/w320/et.png"},"currencies":[{"code":"ETB","name":"Ethiopian birr","symbol":"Br"}],"languages":[{"iso639_1":"am","iso639_2":"amh","name":"Amharic","nativeName":"\u12A0\u121B\u122D\u129B"}],"translations":{"br":"Etiopia","pt":"Eti\xf3pia","nl":"Ethiopi\xeb","hr":"Etiopija","fa":"\u0627\u062A\u06CC\u0648\u067E\u06CC","de":"\xc4thiopien","es":"Etiop\xeda","fr":"\xc9thiopie","ja":"\u30A8\u30C1\u30AA\u30D4\u30A2","it":"Etiopia","hu":"Eti\xf3pia"},"flag":"https://flagcdn.com/et.svg","regionalBlocs":[{"acronym":"AU","name":"African Union","otherNames":["\u0627\u0644\u0627\u062A\u062D\u0627\u062F \u0627\u0644\u0623\u0641\u0631\u064A\u0642\u064A","Union africaine","Uni\xe3o Africana","Uni\xf3n Africana","Umoja wa Afrika"]}],"cioc":"ETH","independent":true},{"name":"Falkland Islands (Malvinas)","topLevelDomain":[".fk"],"alpha2Code":"FK","alpha3Code":"FLK","callingCodes":["500"],"capital":"Stanley","altSpellings":["FK","Islas Malvinas"],"subregion":"South America","region":"Americas","population":2563,"latlng":[-51.75,-59],"demonym":"Falkland Islander","area":12173,"timezones":["UTC-04:00"],"nativeName":"Falkland Islands","numericCode":"238","flags":{"svg":"https://flagcdn.com/fk.svg","png":"https://flagcdn.com/w320/fk.png"},"currencies":[{"code":"FKP","name":"Falkland Islands pound","symbol":"\xa3"}],"languages":[{"iso639_1":"en","iso639_2":"eng","name":"English","nativeName":"English"}],"translations":{"br":"Inizi Malo\xf9","pt":"Ilhas Falkland","nl":"Falklandeilanden [Islas Malvinas]","hr":"Falklandski Otoci","fa":"\u062C\u0632\u0627\u06CC\u0631 \u0641\u0627\u0644\u06A9\u0644\u0646\u062F","de":"Falklandinseln","es":"Islas Malvinas","fr":"\xceles Malouines","ja":"\u30D5\u30A9\u30FC\u30AF\u30E9\u30F3\u30C9\uFF08\u30DE\u30EB\u30D3\u30CA\u30B9\uFF09\u8AF8\u5CF6","it":"Isole Falkland o Isole Malvine","hu":"Falkland-szigetek"},"flag":"https://flagcdn.com/fk.svg","regionalBlocs":[{"acronym":"USAN","name":"Union of South American Nations","otherAcronyms":["UNASUR","UNASUL","UZAN"],"otherNames":["Uni\xf3n de Naciones Suramericanas","Uni\xe3o de Na\xe7\xf5es Sul-Americanas","Unie van Zuid-Amerikaanse Naties","South American Union"]}],"independent":false},{"name":"Faroe Islands","topLevelDomain":[".fo"],"alpha2Code":"FO","alpha3Code":"FRO","callingCodes":["298"],"capital":"T\xf3rshavn","altSpellings":["FO","F\xf8royar","F\xe6r\xf8erne"],"subregion":"Northern Europe","region":"Europe","population":48865,"latlng":[62,-7],"demonym":"Faroese","area":1393,"timezones":["UTC+00:00"],"nativeName":"F\xf8royar","numericCode":"234","flags":{"svg":"https://flagcdn.com/fo.svg","png":"https://flagcdn.com/w320/fo.png"},"currencies":[{"code":"DKK","name":"Danish krone","symbol":"kr"},{"code":"FOK","name":"Faroese kr\xf3na","symbol":"kr"}],"languages":[{"iso639_1":"fo","iso639_2":"fao","name":"Faroese","nativeName":"f\xf8royskt"}],"translations":{"br":"Inizi Faero","pt":"Ilhas Faro\xe9","nl":"Faer\xf6er","hr":"Farski Otoci","fa":"\u062C\u0632\u0627\u06CC\u0631 \u0641\u0627\u0631\u0648","de":"F\xe4r\xf6er-Inseln","es":"Islas Faroe","fr":"\xceles F\xe9ro\xe9","ja":"\u30D5\u30A7\u30ED\u30FC\u8AF8\u5CF6","it":"Isole Far Oer","hu":"Fer\xf6er"},"flag":"https://flagcdn.com/fo.svg","independent":false},{"name":"Fiji","topLevelDomain":[".fj"],"alpha2Code":"FJ","alpha3Code":"FJI","callingCodes":["679"],"capital":"Suva","altSpellings":["FJ","Viti","Republic of Fiji","Matanitu ko Viti","Fij\u012B Ga\u1E47ar\u0101jya"],"subregion":"Melanesia","region":"Oceania","population":896444,"latlng":[-18,175],"demonym":"Fijian","area":18272,"gini":36.7,"timezones":["UTC+12:00"],"nativeName":"Fiji","numericCode":"242","flags":{"svg":"https://flagcdn.com/fj.svg","png":"https://flagcdn.com/w320/fj.png"},"currencies":[{"code":"FJD","name":"Fijian dollar","symbol":"$"}],"languages":[{"iso639_1":"en","iso639_2":"eng","name":"English","nativeName":"English"},{"iso639_1":"fj","iso639_2":"fij","name":"Fijian","nativeName":"vosa Vakaviti"},{"iso639_2":"hif","name":"Fiji Hindi","nativeName":"\u092B\u093C\u093F\u091C\u0940 \u092C\u093E\u0924"},{"iso639_2":"rtm","name":"Rotuman","nativeName":"F\xe4eag Rotuma"}],"translations":{"br":"Fidji","pt":"Fiji","nl":"Fiji","hr":"Fi\u0111i","fa":"\u0641\u06CC\u062C\u06CC","de":"Fidschi","es":"Fiyi","fr":"Fidji","ja":"\u30D5\u30A3\u30B8\u30FC","it":"Figi","hu":"Fidzsi-szigetek"},"flag":"https://flagcdn.com/fj.svg","cioc":"FIJ","independent":true},{"name":"Finland","topLevelDomain":[".fi"],"alpha2Code":"FI","alpha3Code":"FIN","callingCodes":["358"],"capital":"Helsinki","altSpellings":["FI","Suomi","Republic of Finland","Suomen tasavalta","Republiken Finland"],"subregion":"Northern Europe","region":"Europe","population":5530719,"latlng":[64,26],"demonym":"Finnish","area":338424,"gini":27.3,"timezones":["UTC+02:00"],"borders":["NOR","SWE","RUS"],"nativeName":"Suomi","numericCode":"246","flags":{"svg":"https://flagcdn.com/fi.svg","png":"https://flagcdn.com/w320/fi.png"},"currencies":[{"code":"EUR","name":"Euro","symbol":"\u20AC"}],"languages":[{"iso639_1":"fi","iso639_2":"fin","name":"Finnish","nativeName":"suomi"},{"iso639_1":"sv","iso639_2":"swe","name":"Swedish","nativeName":"svenska"}],"translations":{"br":"Finland","pt":"Finl\xe2ndia","nl":"Finland","hr":"Finska","fa":"\u0641\u0646\u0644\u0627\u0646\u062F","de":"Finnland","es":"Finlandia","fr":"Finlande","ja":"\u30D5\u30A3\u30F3\u30E9\u30F3\u30C9","it":"Finlandia","hu":"Finnorsz\xe1g"},"flag":"https://flagcdn.com/fi.svg","regionalBlocs":[{"acronym":"EU","name":"European Union"}],"cioc":"FIN","independent":true},{"name":"France","topLevelDomain":[".fr"],"alpha2Code":"FR","alpha3Code":"FRA","callingCodes":["33"],"capital":"Paris","altSpellings":["FR","French Republic","R\xe9publique fran\xe7aise"],"subregion":"Western Europe","region":"Europe","population":67391582,"latlng":[46,2],"demonym":"French","area":640679,"gini":32.4,"timezones":["UTC-10:00","UTC-09:30","UTC-09:00","UTC-08:00","UTC-04:00","UTC-03:00","UTC+01:00","UTC+02:00","UTC+03:00","UTC+04:00","UTC+05:00","UTC+10:00","UTC+11:00","UTC+12:00"],"borders":["AND","BEL","DEU","ITA","LUX","MCO","ESP","CHE"],"nativeName":"France","numericCode":"250","flags":{"svg":"https://flagcdn.com/fr.svg","png":"https://flagcdn.com/w320/fr.png"},"currencies":[{"code":"EUR","name":"Euro","symbol":"\u20AC"}],"languages":[{"iso639_1":"fr","iso639_2":"fra","name":"French","nativeName":"fran\xe7ais"}],"translations":{"br":"Fra\xf1s","pt":"Fran\xe7a","nl":"Frankrijk","hr":"Francuska","fa":"\u0641\u0631\u0627\u0646\u0633\u0647","de":"Frankreich","es":"Francia","fr":"France","ja":"\u30D5\u30E9\u30F3\u30B9","it":"Francia","hu":"Franciaorsz\xe1g"},"flag":"https://flagcdn.com/fr.svg","regionalBlocs":[{"acronym":"EU","name":"European Union"}],"cioc":"FRA","independent":true},{"name":"French Guiana","topLevelDomain":[".gf"],"alpha2Code":"GF","alpha3Code":"GUF","callingCodes":["594"],"capital":"Cayenne","altSpellings":["GF","Guiana","Guyane"],"subregion":"South America","region":"Americas","population":254541,"latlng":[4,-53],"demonym":"French Guianan","timezones":["UTC-03:00"],"borders":["BRA","SUR"],"nativeName":"Guyane fran\xe7aise","numericCode":"254","flags":{"svg":"https://flagcdn.com/gf.svg","png":"https://flagcdn.com/w320/gf.png"},"currencies":[{"code":"EUR","name":"Euro","symbol":"\u20AC"}],"languages":[{"iso639_1":"fr","iso639_2":"fra","name":"French","nativeName":"fran\xe7ais"}],"translations":{"br":"Gwiana C\'hall","pt":"Guiana Francesa","nl":"Frans-Guyana","hr":"Francuska Gvajana","fa":"\u06AF\u0648\u06CC\u0627\u0646 \u0641\u0631\u0627\u0646\u0633\u0647","de":"Franz\xf6sisch Guyana","es":"Guayana Francesa","fr":"Guayane","ja":"\u30D5\u30E9\u30F3\u30B9\u9818\u30AE\u30A2\u30CA","it":"Guyana francese","hu":"Francia Guyana"},"flag":"https://flagcdn.com/gf.svg","regionalBlocs":[{"acronym":"USAN","name":"Union of South American Nations","otherAcronyms":["UNASUR","UNASUL","UZAN"],"otherNames":["Uni\xf3n de Naciones Suramericanas","Uni\xe3o de Na\xe7\xf5es Sul-Americanas","Unie van Zuid-Amerikaanse Naties","South American Union"]},{"acronym":"EU","name":"European Union"}],"independent":false},{"name":"French Polynesia","topLevelDomain":[".pf"],"alpha2Code":"PF","alpha3Code":"PYF","callingCodes":["689"],"capital":"Papeet\u0113","altSpellings":["PF","Polyn\xe9sie fran\xe7aise","French Polynesia","P\u014Dr\u012Bnetia Far\u0101ni"],"subregion":"Polynesia","region":"Oceania","population":280904,"latlng":[-15,-140],"demonym":"French Polynesian","area":4167,"timezones":["UTC-10:00","UTC-09:30","UTC-09:00"],"nativeName":"Polyn\xe9sie fran\xe7aise","numericCode":"258","flags":{"svg":"https://flagcdn.com/pf.svg","png":"https://flagcdn.com/w320/pf.png"},"currencies":[{"code":"XPF","name":"CFP franc","symbol":"Fr"}],"languages":[{"iso639_1":"fr","iso639_2":"fra","name":"French","nativeName":"fran\xe7ais"}],"translations":{"br":"Polinezia C\'hall","pt":"Polin\xe9sia Francesa","nl":"Frans-Polynesi\xeb","hr":"Francuska Polinezija","fa":"\u067E\u0644\u06CC\u200C\u0646\u0632\u06CC \u0641\u0631\u0627\u0646\u0633\u0647","de":"Franz\xf6sisch-Polynesien","es":"Polinesia Francesa","fr":"Polyn\xe9sie fran\xe7aise","ja":"\u30D5\u30E9\u30F3\u30B9\u9818\u30DD\u30EA\u30CD\u30B7\u30A2","it":"Polinesia Francese","hu":"Francia Polin\xe9zia"},"flag":"https://flagcdn.com/pf.svg","independent":false},{"name":"French Southern Territories","topLevelDomain":[".tf"],"alpha2Code":"TF","alpha3Code":"ATF","callingCodes":["262"],"capital":"Port-aux-Fran\xe7ais","altSpellings":["TF"],"subregion":"Southern Africa","region":"Africa","population":140,"latlng":[-49.25,69.167],"demonym":"French","area":7747,"timezones":["UTC+05:00"],"nativeName":"Territoire des Terres australes et antarctiques fran\xe7aises","numericCode":"260","flags":{"svg":"https://flagcdn.com/tf.svg","png":"https://flagcdn.com/w320/tf.png"},"currencies":[{"code":"EUR","name":"Euro","symbol":"\u20AC"}],"languages":[{"iso639_1":"fr","iso639_2":"fra","name":"French","nativeName":"fran\xe7ais"}],"translations":{"br":"Douaro\xf9 Aostral hag Antarktikel Fra\xf1s","pt":"Terras Austrais e Ant\xe1rticas Francesas","nl":"Franse Gebieden in de zuidelijke Indische Oceaan","hr":"Francuski ju\u017Eni i antarkti\u010Dki teritoriji","fa":"\u0633\u0631\u0632\u0645\u06CC\u0646\u200C\u0647\u0627\u06CC \u062C\u0646\u0648\u0628\u06CC \u0648 \u062C\u0646\u0648\u0628\u06AF\u0627\u0646\u06CC \u0641\u0631\u0627\u0646\u0633\u0647","de":"Franz\xf6sische S\xfcd- und Antarktisgebiete","es":"Tierras Australes y Ant\xe1rticas Francesas","fr":"Terres australes et antarctiques fran\xe7aises","ja":"\u30D5\u30E9\u30F3\u30B9\u9818\u5357\u65B9\u30FB\u5357\u6975\u5730\u57DF","it":"Territori Francesi del Sud","hu":"Francia d\xe9li \xe9s antarktiszi ter\xfcletek"},"flag":"https://flagcdn.com/tf.svg","regionalBlocs":[{"acronym":"AU","name":"African Union","otherNames":["\u0627\u0644\u0627\u062A\u062D\u0627\u062F \u0627\u0644\u0623\u0641\u0631\u064A\u0642\u064A","Union africaine","Uni\xe3o Africana","Uni\xf3n Africana","Umoja wa Afrika"]}],"independent":false},{"name":"Gabon","topLevelDomain":[".ga"],"alpha2Code":"GA","alpha3Code":"GAB","callingCodes":["241"],"capital":"Libreville","altSpellings":["GA","Gabonese Republic","R\xe9publique Gabonaise"],"subregion":"Middle Africa","region":"Africa","population":2225728,"latlng":[-1,11.75],"demonym":"Gabonese","area":267668,"gini":38,"timezones":["UTC+01:00"],"borders":["CMR","COG","GNQ"],"nativeName":"Gabon","numericCode":"266","flags":{"svg":"https://flagcdn.com/ga.svg","png":"https://flagcdn.com/w320/ga.png"},"currencies":[{"code":"XAF","name":"Central African CFA franc","symbol":"Fr"}],"languages":[{"iso639_1":"fr","iso639_2":"fra","name":"French","nativeName":"fran\xe7ais"}],"translations":{"br":"Gabon","pt":"Gab\xe3o","nl":"Gabon","hr":"Gabon","fa":"\u06AF\u0627\u0628\u0646","de":"Gabun","es":"Gab\xf3n","fr":"Gabon","ja":"\u30AC\u30DC\u30F3","it":"Gabon","hu":"Gabon"},"flag":"https://flagcdn.com/ga.svg","regionalBlocs":[{"acronym":"AU","name":"African Union","otherNames":["\u0627\u0644\u0627\u062A\u062D\u0627\u062F \u0627\u0644\u0623\u0641\u0631\u064A\u0642\u064A","Union africaine","Uni\xe3o Africana","Uni\xf3n Africana","Umoja wa Afrika"]}],"cioc":"GAB","independent":true},{"name":"Gambia","topLevelDomain":[".gm"],"alpha2Code":"GM","alpha3Code":"GMB","callingCodes":["220"],"capital":"Banjul","altSpellings":["GM","Republic of the Gambia"],"subregion":"Western Africa","region":"Africa","population":2416664,"latlng":[13.46666666,-16.56666666],"demonym":"Gambian","area":11295,"gini":35.9,"timezones":["UTC+00:00"],"borders":["SEN"],"nativeName":"Gambia","numericCode":"270","flags":{"svg":"https://flagcdn.com/gm.svg","png":"https://flagcdn.com/w320/gm.png"},"currencies":[{"code":"GMD","name":"Gambian dalasi","symbol":"D"}],"languages":[{"iso639_1":"en","iso639_2":"eng","name":"English","nativeName":"English"}],"translations":{"br":"Gambia","pt":"G\xe2mbia","nl":"Gambia","hr":"Gambija","fa":"\u06AF\u0627\u0645\u0628\u06CC\u0627","de":"Gambia","es":"Gambia","fr":"Gambie","ja":"\u30AC\u30F3\u30D3\u30A2","it":"Gambia","hu":"Gambia"},"flag":"https://flagcdn.com/gm.svg","regionalBlocs":[{"acronym":"AU","name":"African Union","otherNames":["\u0627\u0644\u0627\u062A\u062D\u0627\u062F \u0627\u0644\u0623\u0641\u0631\u064A\u0642\u064A","Union africaine","Uni\xe3o Africana","Uni\xf3n Africana","Umoja wa Afrika"]}],"cioc":"GAM","independent":true},{"name":"Georgia","topLevelDomain":[".ge"],"alpha2Code":"GE","alpha3Code":"GEO","callingCodes":["995"],"capital":"Tbilisi","altSpellings":["GE","Sakartvelo"],"subregion":"Western Asia","region":"Asia","population":3714000,"latlng":[42,43.5],"demonym":"Georgian","area":69700,"gini":35.9,"timezones":["UTC-04:00"],"borders":["ARM","AZE","RUS","TUR"],"nativeName":"\u10E1\u10D0\u10E5\u10D0\u10E0\u10D7\u10D5\u10D4\u10DA\u10DD","numericCode":"268","flags":{"svg":"https://flagcdn.com/ge.svg","png":"https://flagcdn.com/w320/ge.png"},"currencies":[{"code":"GEL","name":"Georgian Lari","symbol":"\u10DA"}],"languages":[{"iso639_1":"ka","iso639_2":"kat","name":"Georgian","nativeName":"\u10E5\u10D0\u10E0\u10D7\u10E3\u10DA\u10D8"}],"translations":{"br":"Jorjia","pt":"Ge\xf3rgia","nl":"Georgi\xeb","hr":"N\xe9metorsz\xe1g","fa":"\u06AF\u0631\u062C\u0633\u062A\u0627\u0646","de":"Georgien","es":"Georgia","fr":"G\xe9orgie","ja":"\u30B0\u30EB\u30B8\u30A2","it":"Georgia","hu":"Gr\xfazia"},"flag":"https://flagcdn.com/ge.svg","cioc":"GEO","independent":true},{"name":"Germany","topLevelDomain":[".de"],"alpha2Code":"DE","alpha3Code":"DEU","callingCodes":["49"],"capital":"Berlin","altSpellings":["DE","Federal Republic of Germany","Bundesrepublik Deutschland"],"subregion":"Central Europe","region":"Europe","population":83240525,"latlng":[51,9],"demonym":"German","area":357114,"gini":31.9,"timezones":["UTC+01:00"],"borders":["AUT","BEL","CZE","DNK","FRA","LUX","NLD","POL","CHE"],"nativeName":"Deutschland","numericCode":"276","flags":{"svg":"https://flagcdn.com/de.svg","png":"https://flagcdn.com/w320/de.png"},"currencies":[{"code":"EUR","name":"Euro","symbol":"\u20AC"}],"languages":[{"iso639_1":"de","iso639_2":"deu","name":"German","nativeName":"Deutsch"}],"translations":{"br":"Alamagn","pt":"Alemanha","nl":"Duitsland","hr":"Njema\u010Dka","fa":"\u0622\u0644\u0645\u0627\u0646","de":"Deutschland","es":"Alemania","fr":"Allemagne","ja":"\u30C9\u30A4\u30C4","it":"Germania","hu":"Gr\xfazia"},"flag":"https://flagcdn.com/de.svg","regionalBlocs":[{"acronym":"EU","name":"European Union"}],"cioc":"GER","independent":true},{"name":"Ghana","topLevelDomain":[".gh"],"alpha2Code":"GH","alpha3Code":"GHA","callingCodes":["233"],"capital":"Accra","altSpellings":["GH"],"subregion":"Western Africa","region":"Africa","population":31072945,"latlng":[8,-2],"demonym":"Ghanaian","area":238533,"gini":43.5,"timezones":["UTC"],"borders":["BFA","CIV","TGO"],"nativeName":"Ghana","numericCode":"288","flags":{"svg":"https://flagcdn.com/gh.svg","png":"https://flagcdn.com/w320/gh.png"},"currencies":[{"code":"GHS","name":"Ghanaian cedi","symbol":"\u20B5"}],"languages":[{"iso639_1":"en","iso639_2":"eng","name":"English","nativeName":"English"}],"translations":{"br":"Ghana","pt":"Gana","nl":"Ghana","hr":"Gana","fa":"\u063A\u0646\u0627","de":"Ghana","es":"Ghana","fr":"Ghana","ja":"\u30AC\u30FC\u30CA","it":"Ghana","hu":"Gh\xe1na"},"flag":"https://flagcdn.com/gh.svg","regionalBlocs":[{"acronym":"AU","name":"African Union","otherNames":["\u0627\u0644\u0627\u062A\u062D\u0627\u062F \u0627\u0644\u0623\u0641\u0631\u064A\u0642\u064A","Union africaine","Uni\xe3o Africana","Uni\xf3n Africana","Umoja wa Afrika"]}],"cioc":"GHA","independent":true},{"name":"Gibraltar","topLevelDomain":[".gi"],"alpha2Code":"GI","alpha3Code":"GIB","callingCodes":["350"],"capital":"Gibraltar","altSpellings":["GI"],"subregion":"Southern Europe","region":"Europe","population":33691,"latlng":[36.13333333,-5.35],"demonym":"Gibraltar","area":6,"timezones":["UTC+01:00"],"borders":["ESP"],"nativeName":"Gibraltar","numericCode":"292","flags":{"svg":"https://flagcdn.com/gi.svg","png":"https://flagcdn.com/w320/gi.png"},"currencies":[{"code":"GIP","name":"Gibraltar pound","symbol":"\xa3"}],"languages":[{"iso639_1":"en","iso639_2":"eng","name":"English","nativeName":"English"}],"translations":{"br":"Jibraltar","pt":"Gibraltar","nl":"Gibraltar","hr":"Gibraltar","fa":"\u062C\u0628\u0644\u200C\u0637\u0627\u0631\u0642","de":"Gibraltar","es":"Gibraltar","fr":"Gibraltar","ja":"\u30B8\u30D6\u30E9\u30EB\u30BF\u30EB","it":"Gibilterra","hu":"Gibralt\xe1r"},"flag":"https://flagcdn.com/gi.svg","regionalBlocs":[{"acronym":"EU","name":"European Union"}],"independent":false},{"name":"Greece","topLevelDomain":[".gr"],"alpha2Code":"GR","alpha3Code":"GRC","callingCodes":["30"],"capital":"Athens","altSpellings":["GR","Ell\xe1da","Hellenic Republic","\u0395\u03BB\u03BB\u03B7\u03BD\u03B9\u03BA\u03AE \u0394\u03B7\u03BC\u03BF\u03BA\u03C1\u03B1\u03C4\u03AF\u03B1"],"subregion":"Southern Europe","region":"Europe","population":10715549,"latlng":[39,22],"demonym":"Greek","area":131990,"gini":32.9,"timezones":["UTC+02:00"],"borders":["ALB","BGR","TUR","MKD"],"nativeName":"\u0395\u03BB\u03BB\u03AC\u03B4\u03B1","numericCode":"300","flags":{"svg":"https://flagcdn.com/gr.svg","png":"https://flagcdn.com/w320/gr.png"},"currencies":[{"code":"EUR","name":"Euro","symbol":"\u20AC"}],"languages":[{"iso639_1":"el","iso639_2":"ell","name":"Greek (modern)","nativeName":"\u03B5\u03BB\u03BB\u03B7\u03BD\u03B9\u03BA\u03AC"}],"translations":{"br":"Gres","pt":"Gr\xe9cia","nl":"Griekenland","hr":"Gr\u010Dka","fa":"\u06CC\u0648\u0646\u0627\u0646","de":"Griechenland","es":"Grecia","fr":"Gr\xe8ce","ja":"\u30AE\u30EA\u30B7\u30E3","it":"Grecia","hu":"G\xf6r\xf6gorsz\xe1g"},"flag":"https://flagcdn.com/gr.svg","regionalBlocs":[{"acronym":"EU","name":"European Union"}],"cioc":"GRE","independent":true},{"name":"Greenland","topLevelDomain":[".gl"],"alpha2Code":"GL","alpha3Code":"GRL","callingCodes":["299"],"capital":"Nuuk","altSpellings":["GL","Gr\xf8nland"],"subregion":"Northern America","region":"Americas","population":56367,"latlng":[72,-40],"demonym":"Greenlandic","area":2166086,"timezones":["UTC-04:00","UTC-03:00","UTC-01:00","UTC+00:00"],"nativeName":"Kalaallit Nunaat","numericCode":"304","flags":{"svg":"https://flagcdn.com/gl.svg","png":"https://flagcdn.com/w320/gl.png"},"currencies":[{"code":"DKK","name":"Danish krone","symbol":"kr"}],"languages":[{"iso639_1":"kl","iso639_2":"kal","name":"Kalaallisut","nativeName":"kalaallisut"}],"translations":{"br":"Greunland","pt":"Gronel\xe2ndia","nl":"Groenland","hr":"Grenland","fa":"\u06AF\u0631\u06CC\u0646\u0644\u0646\u062F","de":"Gr\xf6nland","es":"Groenlandia","fr":"Groenland","ja":"\u30B0\u30EA\u30FC\u30F3\u30E9\u30F3\u30C9","it":"Groenlandia","hu":"Gr\xf6nland"},"flag":"https://flagcdn.com/gl.svg","independent":false},{"name":"Grenada","topLevelDomain":[".gd"],"alpha2Code":"GD","alpha3Code":"GRD","callingCodes":["1"],"capital":"St. George\'s","altSpellings":["GD"],"subregion":"Caribbean","region":"Americas","population":112519,"latlng":[12.11666666,-61.66666666],"demonym":"Grenadian","area":344,"timezones":["UTC-04:00"],"nativeName":"Grenada","numericCode":"308","flags":{"svg":"https://flagcdn.com/gd.svg","png":"https://flagcdn.com/w320/gd.png"},"currencies":[{"code":"XCD","name":"East Caribbean dollar","symbol":"$"}],"languages":[{"iso639_1":"en","iso639_2":"eng","name":"English","nativeName":"English"}],"translations":{"br":"Grenada","pt":"Granada","nl":"Grenada","hr":"Grenada","fa":"\u06AF\u0631\u0646\u0627\u062F\u0627","de":"Grenada","es":"Grenada","fr":"Grenade","ja":"\u30B0\u30EC\u30CA\u30C0","it":"Grenada","hu":"Grenada"},"flag":"https://flagcdn.com/gd.svg","regionalBlocs":[{"acronym":"CARICOM","name":"Caribbean Community","otherNames":["Comunidad del Caribe","Communaut\xe9 Carib\xe9enne","Caribische Gemeenschap"]}],"cioc":"GRN","independent":true},{"name":"Guadeloupe","topLevelDomain":[".gp"],"alpha2Code":"GP","alpha3Code":"GLP","callingCodes":["590"],"capital":"Basse-Terre","altSpellings":["GP","Gwadloup"],"subregion":"Caribbean","region":"Americas","population":400132,"latlng":[16.25,-61.583333],"demonym":"Guadeloupian","timezones":["UTC-04:00"],"nativeName":"Guadeloupe","numericCode":"312","flags":{"svg":"https://flagcdn.com/gp.svg","png":"https://flagcdn.com/w320/gp.png"},"currencies":[{"code":"EUR","name":"Euro","symbol":"\u20AC"}],"languages":[{"iso639_1":"fr","iso639_2":"fra","name":"French","nativeName":"fran\xe7ais"}],"translations":{"br":"Gwadeloup","pt":"Guadalupe","nl":"Guadeloupe","hr":"Gvadalupa","fa":"\u062C\u0632\u06CC\u0631\u0647 \u06AF\u0648\u0627\u062F\u0644\u0648\u067E","de":"Guadeloupe","es":"Guadalupe","fr":"Guadeloupe","ja":"\u30B0\u30A2\u30C9\u30EB\u30FC\u30D7","it":"Guadeloupa","hu":"Guadeloupe"},"flag":"https://flagcdn.com/gp.svg","independent":false},{"name":"Guam","topLevelDomain":[".gu"],"alpha2Code":"GU","alpha3Code":"GUM","callingCodes":["1"],"capital":"Hag\xe5t\xf1a","altSpellings":["GU","Gu\xe5h\xe5n"],"subregion":"Micronesia","region":"Oceania","population":168783,"latlng":[13.46666666,144.78333333],"demonym":"Guamanian","area":549,"timezones":["UTC+10:00"],"nativeName":"Guam","numericCode":"316","flags":{"svg":"https://flagcdn.com/gu.svg","png":"https://flagcdn.com/w320/gu.png"},"currencies":[{"code":"USD","name":"United States dollar","symbol":"$"}],"languages":[{"iso639_1":"en","iso639_2":"eng","name":"English","nativeName":"English"},{"iso639_1":"ch","iso639_2":"cha","name":"Chamorro","nativeName":"Chamoru"},{"iso639_1":"es","iso639_2":"spa","name":"Spanish","nativeName":"Espa\xf1ol"}],"translations":{"br":"Guam","pt":"Guame","nl":"Guam","hr":"Guam","fa":"\u06AF\u0648\u0627\u0645","de":"Guam","es":"Guam","fr":"Guam","ja":"\u30B0\u30A2\u30E0","it":"Guam","hu":"Guam"},"flag":"https://flagcdn.com/gu.svg","cioc":"GUM","independent":false},{"name":"Guatemala","topLevelDomain":[".gt"],"alpha2Code":"GT","alpha3Code":"GTM","callingCodes":["502"],"capital":"Guatemala City","altSpellings":["GT"],"subregion":"Central America","region":"Americas","population":16858333,"latlng":[15.5,-90.25],"demonym":"Guatemalan","area":108889,"gini":48.3,"timezones":["UTC-06:00"],"borders":["BLZ","SLV","HND","MEX"],"nativeName":"Guatemala","numericCode":"320","flags":{"svg":"https://flagcdn.com/gt.svg","png":"https://flagcdn.com/w320/gt.png"},"currencies":[{"code":"GTQ","name":"Guatemalan quetzal","symbol":"Q"}],"languages":[{"iso639_1":"es","iso639_2":"spa","name":"Spanish","nativeName":"Espa\xf1ol"}],"translations":{"br":"Guatemala","pt":"Guatemala","nl":"Guatemala","hr":"Gvatemala","fa":"\u06AF\u0648\u0627\u062A\u0645\u0627\u0644\u0627","de":"Guatemala","es":"Guatemala","fr":"Guatemala","ja":"\u30B0\u30A2\u30C6\u30DE\u30E9","it":"Guatemala","hu":"Guatemala"},"flag":"https://flagcdn.com/gt.svg","regionalBlocs":[{"acronym":"CAIS","name":"Central American Integration System","otherAcronyms":["SICA"],"otherNames":["Sistema de la Integraci\xf3n Centroamericana,"]}],"cioc":"GUA","independent":true},{"name":"Guernsey","topLevelDomain":[".gg"],"alpha2Code":"GG","alpha3Code":"GGY","callingCodes":["44"],"capital":"St. Peter Port","altSpellings":["GG","Bailiwick of Guernsey","Bailliage de Guernesey"],"subregion":"Northern Europe","region":"Europe","population":62999,"latlng":[49.46666666,-2.58333333],"demonym":"Channel Islander","area":78,"timezones":["UTC+00:00"],"nativeName":"Guernsey","numericCode":"831","flags":{"svg":"https://flagcdn.com/gg.svg","png":"https://flagcdn.com/w320/gg.png"},"currencies":[{"code":"GBP","name":"British pound","symbol":"\xa3"},{"code":"GGP","name":"Guernsey pound","symbol":"\xa3"}],"languages":[{"iso639_1":"en","iso639_2":"eng","name":"English","nativeName":"English"},{"iso639_1":"fr","iso639_2":"fra","name":"French","nativeName":"fran\xe7ais"}],"translations":{"br":"Gwernenez","pt":"Guernsey","nl":"Guernsey","hr":"Guernsey","fa":"\u06AF\u0631\u0646\u0632\u06CC","de":"Guernsey","es":"Guernsey","fr":"Guernesey","ja":"\u30AC\u30FC\u30F3\u30B8\u30FC","it":"Guernsey","hu":"Guernsey"},"flag":"https://flagcdn.com/gg.svg","independent":false},{"name":"Guinea","topLevelDomain":[".gn"],"alpha2Code":"GN","alpha3Code":"GIN","callingCodes":["224"],"capital":"Conakry","altSpellings":["GN","Republic of Guinea","R\xe9publique de Guin\xe9e"],"subregion":"Western Africa","region":"Africa","population":13132792,"latlng":[11,-10],"demonym":"Guinean","area":245857,"gini":33.7,"timezones":["UTC"],"borders":["CIV","GNB","LBR","MLI","SEN","SLE"],"nativeName":"Guin\xe9e","numericCode":"324","flags":{"svg":"https://flagcdn.com/gn.svg","png":"https://flagcdn.com/w320/gn.png"},"currencies":[{"code":"GNF","name":"Guinean franc","symbol":"Fr"}],"languages":[{"iso639_1":"fr","iso639_2":"fra","name":"French","nativeName":"fran\xe7ais"},{"iso639_1":"ff","iso639_2":"ful","name":"Fula","nativeName":"Fulfulde"}],"translations":{"br":"Ginea","pt":"Guin\xe9","nl":"Guinee","hr":"Gvineja","fa":"\u06AF\u06CC\u0646\u0647","de":"Guinea","es":"Guinea","fr":"Guin\xe9e","ja":"\u30AE\u30CB\u30A2","it":"Guinea","hu":"Guinea"},"flag":"https://flagcdn.com/gn.svg","regionalBlocs":[{"acronym":"AU","name":"African Union","otherNames":["\u0627\u0644\u0627\u062A\u062D\u0627\u062F \u0627\u0644\u0623\u0641\u0631\u064A\u0642\u064A","Union africaine","Uni\xe3o Africana","Uni\xf3n Africana","Umoja wa Afrika"]}],"cioc":"GUI","independent":true},{"name":"Guinea-Bissau","topLevelDomain":[".gw"],"alpha2Code":"GW","alpha3Code":"GNB","callingCodes":["245"],"capital":"Bissau","altSpellings":["GW","Republic of Guinea-Bissau","Rep\xfablica da Guin\xe9-Bissau"],"subregion":"Western Africa","region":"Africa","population":1967998,"latlng":[12,-15],"demonym":"Guinea-Bissauan","area":36125,"gini":50.7,"timezones":["UTC"],"borders":["GIN","SEN"],"nativeName":"Guin\xe9-Bissau","numericCode":"624","flags":{"svg":"https://flagcdn.com/gw.svg","png":"https://flagcdn.com/w320/gw.png"},"currencies":[{"code":"XOF","name":"West African CFA franc","symbol":"Fr"}],"languages":[{"iso639_1":"pt","iso639_2":"por","name":"Portuguese","nativeName":"Portugu\xeas"}],"translations":{"br":"Ginea-Bissau","pt":"Guin\xe9-Bissau","nl":"Guinee-Bissau","hr":"Gvineja Bisau","fa":"\u06AF\u06CC\u0646\u0647 \u0628\u06CC\u0633\u0627\u0626\u0648","de":"Guinea-Bissau","es":"Guinea-Bis\xe1u","fr":"Guin\xe9e-Bissau","ja":"\u30AE\u30CB\u30A2\u30D3\u30B5\u30A6","it":"Guinea-Bissau","hu":"Bissau-Guinea"},"flag":"https://flagcdn.com/gw.svg","regionalBlocs":[{"acronym":"AU","name":"African Union","otherNames":["\u0627\u0644\u0627\u062A\u062D\u0627\u062F \u0627\u0644\u0623\u0641\u0631\u064A\u0642\u064A","Union africaine","Uni\xe3o Africana","Uni\xf3n Africana","Umoja wa Afrika"]}],"cioc":"GBS","independent":true},{"name":"Guyana","topLevelDomain":[".gy"],"alpha2Code":"GY","alpha3Code":"GUY","callingCodes":["592"],"capital":"Georgetown","altSpellings":["GY","Co-operative Republic of Guyana"],"subregion":"South America","region":"Americas","population":786559,"latlng":[5,-59],"demonym":"Guyanese","area":214969,"gini":45.1,"timezones":["UTC-04:00"],"borders":["BRA","SUR","VEN"],"nativeName":"Guyana","numericCode":"328","flags":{"svg":"https://flagcdn.com/gy.svg","png":"https://flagcdn.com/w320/gy.png"},"currencies":[{"code":"GYD","name":"Guyanese dollar","symbol":"$"}],"languages":[{"iso639_1":"en","iso639_2":"eng","name":"English","nativeName":"English"}],"translations":{"br":"Guyana","pt":"Guiana","nl":"Guyana","hr":"Gvajana","fa":"\u06AF\u0648\u06CC\u0627\u0646","de":"Guyana","es":"Guyana","fr":"Guyane","ja":"\u30AC\u30A4\u30A2\u30CA","it":"Guyana","hu":"Guyana"},"flag":"https://flagcdn.com/gy.svg","regionalBlocs":[{"acronym":"CARICOM","name":"Caribbean Community","otherNames":["Comunidad del Caribe","Communaut\xe9 Carib\xe9enne","Caribische Gemeenschap"]},{"acronym":"USAN","name":"Union of South American Nations","otherAcronyms":["UNASUR","UNASUL","UZAN"],"otherNames":["Uni\xf3n de Naciones Suramericanas","Uni\xe3o de Na\xe7\xf5es Sul-Americanas","Unie van Zuid-Amerikaanse Naties","South American Union"]}],"cioc":"GUY","independent":true},{"name":"Haiti","topLevelDomain":[".ht"],"alpha2Code":"HT","alpha3Code":"HTI","callingCodes":["509"],"capital":"Port-au-Prince","altSpellings":["HT","Republic of Haiti","R\xe9publique d\'Ha\xefti","Repiblik Ayiti"],"subregion":"Caribbean","region":"Americas","population":11402533,"latlng":[19,-72.41666666],"demonym":"Haitian","area":27750,"gini":41.1,"timezones":["UTC-05:00"],"borders":["DOM"],"nativeName":"Ha\xefti","numericCode":"332","flags":{"svg":"https://flagcdn.com/ht.svg","png":"https://flagcdn.com/w320/ht.png"},"currencies":[{"code":"HTG","name":"Haitian gourde","symbol":"G"}],"languages":[{"iso639_1":"fr","iso639_2":"fra","name":"French","nativeName":"fran\xe7ais"},{"iso639_1":"ht","iso639_2":"hat","name":"Haitian","nativeName":"Krey\xf2l ayisyen"}],"translations":{"br":"Haiti","pt":"Haiti","nl":"Ha\xefti","hr":"Haiti","fa":"\u0647\u0627\u0626\u06CC\u062A\u06CC","de":"Haiti","es":"Haiti","fr":"Ha\xefti","ja":"\u30CF\u30A4\u30C1","it":"Haiti","hu":"Haiti"},"flag":"https://flagcdn.com/ht.svg","regionalBlocs":[{"acronym":"CARICOM","name":"Caribbean Community","otherNames":["Comunidad del Caribe","Communaut\xe9 Carib\xe9enne","Caribische Gemeenschap"]}],"cioc":"HAI","independent":true},{"name":"Heard Island and McDonald Islands","topLevelDomain":[".hm",".aq"],"alpha2Code":"HM","alpha3Code":"HMD","callingCodes":["672"],"altSpellings":["HM"],"subregion":"Antarctic","region":"Antarctic","population":0,"latlng":[-53.1,72.51666666],"demonym":"Heard and McDonald Islander","area":412,"timezones":["UTC+05:00"],"nativeName":"Heard Island and McDonald Islands","numericCode":"334","flags":{"svg":"https://flagcdn.com/hm.svg","png":"https://flagcdn.com/w320/hm.png"},"currencies":[{"code":"AUD","name":"Australian dollar","symbol":"$"}],"languages":[{"iso639_1":"en","iso639_2":"eng","name":"English","nativeName":"English"}],"translations":{"br":"Inizi Heard ha McDonald","pt":"Ilha Heard e Ilhas McDonald","nl":"Heard- en McDonaldeilanden","hr":"Otok Heard i oto\u010Dje McDonald","fa":"\u062C\u0632\u06CC\u0631\u0647 \u0647\u0631\u062F \u0648 \u062C\u0632\u0627\u06CC\u0631 \u0645\u06A9\u200C\u062F\u0648\u0646\u0627\u0644\u062F","de":"Heard und die McDonaldinseln","es":"Islas Heard y McDonald","fr":"\xceles Heard-et-MacDonald","ja":"\u30CF\u30FC\u30C9\u5CF6\u3068\u30DE\u30AF\u30C9\u30CA\u30EB\u30C9\u8AF8\u5CF6","it":"Isole Heard e McDonald","hu":"Heard-sziget \xe9s McDonald-szigetek"},"flag":"https://flagcdn.com/hm.svg","independent":false},{"name":"Vatican City","topLevelDomain":[".va"],"alpha2Code":"VA","alpha3Code":"VAT","callingCodes":["379"],"capital":"Vatican City","altSpellings":["Vatican","The Vatican"],"subregion":"Southern Europe","region":"Europe","population":451,"latlng":[41.9,12.45],"demonym":"Vatican","area":0.44,"timezones":["UTC+01:00"],"borders":["ITA"],"nativeName":"Status Civitatis Vaticanae","numericCode":"336","flags":{"svg":"https://flagcdn.com/va.svg","png":"https://flagcdn.com/w320/va.png"},"currencies":[{"code":"EUR","name":"Euro","symbol":"\u20AC"}],"languages":[{"iso639_1":"la","iso639_2":"lat","name":"Latin","nativeName":"latine"},{"iso639_1":"it","iso639_2":"ita","name":"Italian","nativeName":"Italiano"},{"iso639_1":"fr","iso639_2":"fra","name":"French","nativeName":"Fran\xe7ais"},{"iso639_1":"de","iso639_2":"deu","name":"German","nativeName":"Deutsch"}],"translations":{"br":"Vatikan","pt":"Vaticano","nl":"Heilige Stoel","hr":"Sveta Stolica","fa":"\u0633\u0631\u06CC\u0631 \u0645\u0642\u062F\u0633","de":"Heiliger Stuhl","es":"Santa Sede","fr":"Saint-Si\xe8ge","ja":"\u8056\u5EA7","it":"Santa Sede","hu":"Vatik\xe1n"},"flag":"https://flagcdn.com/va.svg","independent":true},{"name":"Honduras","topLevelDomain":[".hn"],"alpha2Code":"HN","alpha3Code":"HND","callingCodes":["504"],"capital":"Tegucigalpa","altSpellings":["HN","Republic of Honduras","Rep\xfablica de Honduras"],"subregion":"Central America","region":"Americas","population":9904608,"latlng":[15,-86.5],"demonym":"Honduran","area":112492,"gini":48.2,"timezones":["UTC-06:00"],"borders":["GTM","SLV","NIC"],"nativeName":"Honduras","numericCode":"340","flags":{"svg":"https://flagcdn.com/hn.svg","png":"https://flagcdn.com/w320/hn.png"},"currencies":[{"code":"HNL","name":"Honduran lempira","symbol":"L"}],"languages":[{"iso639_1":"es","iso639_2":"spa","name":"Spanish","nativeName":"Espa\xf1ol"}],"translations":{"br":"Honduras","pt":"Honduras","nl":"Honduras","hr":"Honduras","fa":"\u0647\u0646\u062F\u0648\u0631\u0627\u0633","de":"Honduras","es":"Honduras","fr":"Honduras","ja":"\u30DB\u30F3\u30B8\u30E5\u30E9\u30B9","it":"Honduras","hu":"Honduras"},"flag":"https://flagcdn.com/hn.svg","regionalBlocs":[{"acronym":"CAIS","name":"Central American Integration System","otherAcronyms":["SICA"],"otherNames":["Sistema de la Integraci\xf3n Centroamericana,"]}],"cioc":"HON","independent":true},{"name":"Hungary","topLevelDomain":[".hu"],"alpha2Code":"HU","alpha3Code":"HUN","callingCodes":["36"],"capital":"Budapest","altSpellings":["HU"],"subregion":"Central Europe","region":"Europe","population":9749763,"latlng":[47,20],"demonym":"Hungarian","area":93028,"gini":29.6,"timezones":["UTC+01:00"],"borders":["AUT","HRV","ROU","SRB","SVK","SVN","UKR"],"nativeName":"Magyarorsz\xe1g","numericCode":"348","flags":{"svg":"https://flagcdn.com/hu.svg","png":"https://flagcdn.com/w320/hu.png"},"currencies":[{"code":"HUF","name":"Hungarian forint","symbol":"Ft"}],"languages":[{"iso639_1":"hu","iso639_2":"hun","name":"Hungarian","nativeName":"magyar"}],"translations":{"br":"Hungaria","pt":"Hungria","nl":"Hongarije","hr":"Ma\u0111arska","fa":"\u0645\u062C\u0627\u0631\u0633\u062A\u0627\u0646","de":"Ungarn","es":"Hungr\xeda","fr":"Hongrie","ja":"\u30CF\u30F3\u30AC\u30EA\u30FC","it":"Ungheria","hu":"Magyarorsz\xe1g"},"flag":"https://flagcdn.com/hu.svg","regionalBlocs":[{"acronym":"EU","name":"European Union"}],"cioc":"HUN","independent":true},{"name":"Hong Kong","topLevelDomain":[".hk"],"alpha2Code":"HK","alpha3Code":"HKG","callingCodes":["852"],"capital":"City of Victoria","altSpellings":["HK","\u9999\u6E2F"],"subregion":"Eastern Asia","region":"Asia","population":7481800,"latlng":[22.25,114.16666666],"demonym":"Chinese","area":1104,"timezones":["UTC+08:00"],"borders":["CHN"],"nativeName":"\u9999\u6E2F","numericCode":"344","flags":{"svg":"https://flagcdn.com/hk.svg","png":"https://flagcdn.com/w320/hk.png"},"currencies":[{"code":"HKD","name":"Hong Kong dollar","symbol":"$"}],"languages":[{"iso639_1":"en","iso639_2":"eng","name":"English","nativeName":"English"},{"iso639_1":"zh","iso639_2":"zho","name":"Chinese","nativeName":"\u4E2D\u6587 (Zh\u014Dngw\xe9n)"}],"translations":{"br":"Hong Kong","pt":"Hong Kong","nl":"Hongkong","hr":"Hong Kong","fa":"\u0647\u0646\u06AF\u200C\u06A9\u0646\u06AF","de":"Hong Kong","es":"Hong Kong","fr":"Hong Kong","ja":"\u9999\u6E2F","it":"Hong Kong","hu":"Hong Kong"},"flag":"https://flagcdn.com/hk.svg","cioc":"HKG","independent":false},{"name":"Iceland","topLevelDomain":[".is"],"alpha2Code":"IS","alpha3Code":"ISL","callingCodes":["354"],"capital":"Reykjav\xedk","altSpellings":["IS","Island","Republic of Iceland","L\xfd\xf0veldi\xf0 \xcdsland"],"subregion":"Northern Europe","region":"Europe","population":366425,"latlng":[65,-18],"demonym":"Icelander","area":103000,"gini":26.1,"timezones":["UTC"],"nativeName":"\xcdsland","numericCode":"352","flags":{"svg":"https://flagcdn.com/is.svg","png":"https://flagcdn.com/w320/is.png"},"currencies":[{"code":"ISK","name":"Icelandic kr\xf3na","symbol":"kr"}],"languages":[{"iso639_1":"is","iso639_2":"isl","name":"Icelandic","nativeName":"\xcdslenska"}],"translations":{"br":"Island","pt":"Isl\xe2ndia","nl":"IJsland","hr":"Island","fa":"\u0627\u06CC\u0633\u0644\u0646\u062F","de":"Island","es":"Islandia","fr":"Islande","ja":"\u30A2\u30A4\u30B9\u30E9\u30F3\u30C9","it":"Islanda","hu":"Izland"},"flag":"https://flagcdn.com/is.svg","regionalBlocs":[{"acronym":"EFTA","name":"European Free Trade Association"}],"cioc":"ISL","independent":true},{"name":"India","topLevelDomain":[".in"],"alpha2Code":"IN","alpha3Code":"IND","callingCodes":["91"],"capital":"New Delhi","altSpellings":["IN","Bh\u0101rat","Republic of India","Bharat Ganrajya"],"subregion":"Southern Asia","region":"Asia","population":1380004385,"latlng":[20,77],"demonym":"Indian","area":3287590,"gini":35.7,"timezones":["UTC+05:30"],"borders":["AFG","BGD","BTN","MMR","CHN","NPL","PAK","LKA"],"nativeName":"\u092D\u093E\u0930\u0924","numericCode":"356","flags":{"svg":"https://flagcdn.com/in.svg","png":"https://flagcdn.com/w320/in.png"},"currencies":[{"code":"INR","name":"Indian rupee","symbol":"\u20B9"}],"languages":[{"iso639_1":"hi","iso639_2":"hin","name":"Hindi","nativeName":"\u0939\u093F\u0928\u094D\u0926\u0940"},{"iso639_1":"en","iso639_2":"eng","name":"English","nativeName":"English"}],"translations":{"br":"India","pt":"\xcdndia","nl":"India","hr":"Indija","fa":"\u0647\u0646\u062F","de":"Indien","es":"India","fr":"Inde","ja":"\u30A4\u30F3\u30C9","it":"India","hu":"India"},"flag":"https://flagcdn.com/in.svg","regionalBlocs":[{"acronym":"SAARC","name":"South Asian Association for Regional Cooperation"}],"cioc":"IND","independent":true},{"name":"Indonesia","topLevelDomain":[".id"],"alpha2Code":"ID","alpha3Code":"IDN","callingCodes":["62"],"capital":"Jakarta","altSpellings":["ID","Republic of Indonesia","Republik Indonesia"],"subregion":"South-Eastern Asia","region":"Asia","population":273523621,"latlng":[-5,120],"demonym":"Indonesian","area":1904569,"gini":38.2,"timezones":["UTC+07:00","UTC+08:00","UTC+09:00"],"borders":["TLS","MYS","PNG"],"nativeName":"Indonesia","numericCode":"360","flags":{"svg":"https://flagcdn.com/id.svg","png":"https://flagcdn.com/w320/id.png"},"currencies":[{"code":"IDR","name":"Indonesian rupiah","symbol":"Rp"}],"languages":[{"iso639_1":"id","iso639_2":"ind","name":"Indonesian","nativeName":"Bahasa Indonesia"}],"translations":{"br":"Indonezia","pt":"Indon\xe9sia","nl":"Indonesi\xeb","hr":"Indonezija","fa":"\u0627\u0646\u062F\u0648\u0646\u0632\u06CC","de":"Indonesien","es":"Indonesia","fr":"Indon\xe9sie","ja":"\u30A4\u30F3\u30C9\u30CD\u30B7\u30A2","it":"Indonesia","hu":"Indon\xe9zia"},"flag":"https://flagcdn.com/id.svg","regionalBlocs":[{"acronym":"ASEAN","name":"Association of Southeast Asian Nations"}],"cioc":"INA","independent":true},{"name":"Ivory Coast","topLevelDomain":[".ci"],"alpha2Code":"CI","alpha3Code":"CIV","callingCodes":["225"],"capital":"Yamoussoukro","altSpellings":["CI","Ivory Coast","Republic of C\xf4te d\'Ivoire","R\xe9publique de C\xf4te d\'Ivoire"],"subregion":"Western Africa","region":"Africa","population":26378275,"latlng":[8,-5],"demonym":"Ivorian","area":322463,"gini":41.5,"timezones":["UTC"],"borders":["BFA","GHA","GIN","LBR","MLI"],"nativeName":"C\xf4te d\'Ivoire","numericCode":"384","flags":{"svg":"https://flagcdn.com/ci.svg","png":"https://flagcdn.com/w320/ci.png"},"currencies":[{"code":"XOF","name":"West African CFA franc","symbol":"Fr"}],"languages":[{"iso639_1":"fr","iso639_2":"fra","name":"French","nativeName":"fran\xe7ais"}],"translations":{"br":"Aod an Olifant","pt":"Costa do Marfim","nl":"Ivoorkust","hr":"Obala Bjelokosti","fa":"\u0633\u0627\u062D\u0644 \u0639\u0627\u062C","de":"Elfenbeink\xfcste","es":"Costa de Marfil","fr":"C\xf4te d\'Ivoire","ja":"\u30B3\u30FC\u30C8\u30B8\u30DC\u30EF\u30FC\u30EB","it":"Costa D\'Avorio","hu":"Elef\xe1ntcsontpart"},"flag":"https://flagcdn.com/ci.svg","regionalBlocs":[{"acronym":"AU","name":"African Union","otherNames":["\u0627\u0644\u0627\u062A\u062D\u0627\u062F \u0627\u0644\u0623\u0641\u0631\u064A\u0642\u064A","Union africaine","Uni\xe3o Africana","Uni\xf3n Africana","Umoja wa Afrika"]}],"cioc":"CIV","independent":true},{"name":"Iran (Islamic Republic of)","topLevelDomain":[".ir"],"alpha2Code":"IR","alpha3Code":"IRN","callingCodes":["98"],"capital":"Tehran","altSpellings":["IR","Islamic Republic of Iran","Jomhuri-ye Esl\u0101mi-ye Ir\u0101n"],"subregion":"Southern Asia","region":"Asia","population":83992953,"latlng":[32,53],"demonym":"Iranian","area":1648195,"gini":42,"timezones":["UTC+03:30"],"borders":["AFG","ARM","AZE","IRQ","PAK","TUR","TKM"],"nativeName":"\u0627\u06CC\u0631\u0627\u0646","numericCode":"364","flags":{"svg":"https://flagcdn.com/ir.svg","png":"https://flagcdn.com/w320/ir.png"},"currencies":[{"code":"IRR","name":"Iranian rial","symbol":"\uFDFC"}],"languages":[{"iso639_1":"fa","iso639_2":"fas","name":"Persian (Farsi)","nativeName":"\u0641\u0627\u0631\u0633\u06CC"}],"translations":{"br":"Iran","pt":"Ir\xe3o","nl":"Iran","hr":"Iran","fa":"\u0627\u06CC\u0631\u0627\u0646","de":"Iran","es":"Iran","fr":"Iran","ja":"\u30A4\u30E9\u30F3\u30FB\u30A4\u30B9\u30E9\u30E0\u5171\u548C\u56FD","it":"Iran (Islamic Republic of)","hu":"Ir\xe1n"},"flag":"https://flagcdn.com/ir.svg","cioc":"IRI","independent":true},{"name":"Iraq","topLevelDomain":[".iq"],"alpha2Code":"IQ","alpha3Code":"IRQ","callingCodes":["964"],"capital":"Baghdad","altSpellings":["IQ","Republic of Iraq","Jumh\u016Briyyat al-\u2018Ir\u0101q"],"subregion":"Western Asia","region":"Asia","population":40222503,"latlng":[33,44],"demonym":"Iraqi","area":438317,"gini":29.5,"timezones":["UTC+03:00"],"borders":["IRN","JOR","KWT","SAU","SYR","TUR"],"nativeName":"\u0627\u0644\u0639\u0631\u0627\u0642","numericCode":"368","flags":{"svg":"https://flagcdn.com/iq.svg","png":"https://flagcdn.com/w320/iq.png"},"currencies":[{"code":"IQD","name":"Iraqi dinar","symbol":"\u0639.\u062F"}],"languages":[{"iso639_1":"ar","iso639_2":"ara","name":"Arabic","nativeName":"\u0627\u0644\u0639\u0631\u0628\u064A\u0629"},{"iso639_1":"ku","iso639_2":"kur","name":"Kurdish","nativeName":"Kurd\xee"}],"translations":{"br":"Irak","pt":"Iraque","nl":"Irak","hr":"Irak","fa":"\u0639\u0631\u0627\u0642","de":"Irak","es":"Irak","fr":"Irak","ja":"\u30A4\u30E9\u30AF","it":"Iraq","hu":"Irak"},"flag":"https://flagcdn.com/iq.svg","regionalBlocs":[{"acronym":"AL","name":"Arab League","otherNames":["\u062C\u0627\u0645\u0639\u0629 \u0627\u0644\u062F\u0648\u0644 \u0627\u0644\u0639\u0631\u0628\u064A\u0629","J\u0101mi\u02BBat ad-Duwal al-\u02BBArab\u012Byah","League of Arab States"]}],"cioc":"IRQ","independent":true},{"name":"Ireland","topLevelDomain":[".ie"],"alpha2Code":"IE","alpha3Code":"IRL","callingCodes":["353"],"capital":"Dublin","altSpellings":["IE","\xc9ire","Republic of Ireland","Poblacht na h\xc9ireann"],"subregion":"Northern Europe","region":"Europe","population":4994724,"latlng":[53,-8],"demonym":"Irish","area":70273,"gini":31.4,"timezones":["UTC"],"borders":["GBR"],"nativeName":"\xc9ire","numericCode":"372","flags":{"svg":"https://flagcdn.com/ie.svg","png":"https://flagcdn.com/w320/ie.png"},"currencies":[{"code":"EUR","name":"Euro","symbol":"\u20AC"}],"languages":[{"iso639_1":"ga","iso639_2":"gle","name":"Irish","nativeName":"Gaeilge"},{"iso639_1":"en","iso639_2":"eng","name":"English","nativeName":"English"}],"translations":{"br":"Iwerzhon","pt":"Irlanda","nl":"Ierland","hr":"Irska","fa":"\u0627\u06CC\u0631\u0644\u0646\u062F","de":"Irland","es":"Irlanda","fr":"Irlande","ja":"\u30A2\u30A4\u30EB\u30E9\u30F3\u30C9","it":"Irlanda","hu":"\xcdrorsz\xe1g"},"flag":"https://flagcdn.com/ie.svg","regionalBlocs":[{"acronym":"EU","name":"European Union"}],"cioc":"IRL","independent":true},{"name":"Isle of Man","topLevelDomain":[".im"],"alpha2Code":"IM","alpha3Code":"IMN","callingCodes":["44"],"capital":"Douglas","altSpellings":["IM","Ellan Vannin","Mann","Mannin"],"subregion":"Northern Europe","region":"Europe","population":85032,"latlng":[54.25,-4.5],"demonym":"Manx","area":572,"timezones":["UTC+00:00"],"nativeName":"Isle of Man","numericCode":"833","flags":{"svg":"https://flagcdn.com/im.svg","png":"https://flagcdn.com/w320/im.png"},"currencies":[{"code":"GBP","name":"British pound","symbol":"\xa3"},{"code":"IMP[G]","name":"Manx pound","symbol":"\xa3"}],"languages":[{"iso639_1":"en","iso639_2":"eng","name":"English","nativeName":"English"},{"iso639_1":"gv","iso639_2":"glv","name":"Manx","nativeName":"Gaelg"}],"translations":{"br":"Enez Vanav","pt":"Ilha de Man","nl":"Isle of Man","hr":"Otok Man","fa":"\u062C\u0632\u06CC\u0631\u0647 \u0645\u0646","de":"Insel Man","es":"Isla de Man","fr":"\xcele de Man","ja":"\u30DE\u30F3\u5CF6","it":"Isola di Man","hu":"Man"},"flag":"https://flagcdn.com/im.svg","regionalBlocs":[{"acronym":"EU","name":"European Union"}],"independent":false},{"name":"Israel","topLevelDomain":[".il"],"alpha2Code":"IL","alpha3Code":"ISR","callingCodes":["972"],"capital":"Jerusalem","altSpellings":["IL","State of Israel","Med\u012Bnat Yisr\u0101\'el"],"subregion":"Western Asia","region":"Asia","population":9216900,"latlng":[31.5,34.75],"demonym":"Israeli","area":20770,"gini":39,"timezones":["UTC+02:00"],"borders":["EGY","JOR","LBN","SYR"],"nativeName":"\u05D9\u05B4\u05E9\u05B0\u05C2\u05E8\u05B8\u05D0\u05B5\u05DC","numericCode":"376","flags":{"svg":"https://flagcdn.com/il.svg","png":"https://flagcdn.com/w320/il.png"},"currencies":[{"code":"ILS","name":"Israeli new shekel","symbol":"\u20AA"}],"languages":[{"iso639_1":"he","iso639_2":"heb","name":"Hebrew (modern)","nativeName":"\u05E2\u05D1\u05E8\u05D9\u05EA"},{"iso639_1":"ar","iso639_2":"ara","name":"Arabic","nativeName":"\u0627\u0644\u0639\u0631\u0628\u064A\u0629"}],"translations":{"br":"Israel","pt":"Israel","nl":"Isra\xebl","hr":"Izrael","fa":"\u0627\u0633\u0631\u0627\u0626\u06CC\u0644","de":"Israel","es":"Israel","fr":"Isra\xebl","ja":"\u30A4\u30B9\u30E9\u30A8\u30EB","it":"Israele","hu":"Izrael"},"flag":"https://flagcdn.com/il.svg","cioc":"ISR","independent":true},{"name":"Italy","topLevelDomain":[".it"],"alpha2Code":"IT","alpha3Code":"ITA","callingCodes":["39"],"capital":"Rome","altSpellings":["IT","Italian Republic","Repubblica italiana"],"subregion":"Southern Europe","region":"Europe","population":59554023,"latlng":[42.83333333,12.83333333],"demonym":"Italian","area":301336,"gini":35.9,"timezones":["UTC+01:00"],"borders":["AUT","FRA","SMR","SVN","CHE","VAT"],"nativeName":"Italia","numericCode":"380","flags":{"svg":"https://flagcdn.com/it.svg","png":"https://flagcdn.com/w320/it.png"},"currencies":[{"code":"EUR","name":"Euro","symbol":"\u20AC"}],"languages":[{"iso639_1":"it","iso639_2":"ita","name":"Italian","nativeName":"Italiano"}],"translations":{"br":"Italia","pt":"It\xe1lia","nl":"Itali\xeb","hr":"Italija","fa":"\u0627\u06CC\u062A\u0627\u0644\u06CC\u0627","de":"Italien","es":"Italia","fr":"Italie","ja":"\u30A4\u30BF\u30EA\u30A2","it":"Italia","hu":"Olaszorsz\xe1g"},"flag":"https://flagcdn.com/it.svg","regionalBlocs":[{"acronym":"EU","name":"European Union"}],"cioc":"ITA","independent":true},{"name":"Jamaica","topLevelDomain":[".jm"],"alpha2Code":"JM","alpha3Code":"JAM","callingCodes":["1"],"capital":"Kingston","altSpellings":["JM"],"subregion":"Caribbean","region":"Americas","population":2961161,"latlng":[18.25,-77.5],"demonym":"Jamaican","area":10991,"gini":45.5,"timezones":["UTC-05:00"],"nativeName":"Jamaica","numericCode":"388","flags":{"svg":"https://flagcdn.com/jm.svg","png":"https://flagcdn.com/w320/jm.png"},"currencies":[{"code":"JMD","name":"Jamaican dollar","symbol":"$"}],"languages":[{"iso639_1":"en","iso639_2":"eng","name":"English","nativeName":"English"}],"translations":{"br":"Jamaika","pt":"Jamaica","nl":"Jamaica","hr":"Jamajka","fa":"\u062C\u0627\u0645\u0627\u0626\u06CC\u06A9\u0627","de":"Jamaika","es":"Jamaica","fr":"Jama\xefque","ja":"\u30B8\u30E3\u30DE\u30A4\u30AB","it":"Giamaica","hu":"Jamaica"},"flag":"https://flagcdn.com/jm.svg","regionalBlocs":[{"acronym":"CARICOM","name":"Caribbean Community","otherNames":["Comunidad del Caribe","Communaut\xe9 Carib\xe9enne","Caribische Gemeenschap"]}],"cioc":"JAM","independent":true},{"name":"Japan","topLevelDomain":[".jp"],"alpha2Code":"JP","alpha3Code":"JPN","callingCodes":["81"],"capital":"Tokyo","altSpellings":["JP","Nippon","Nihon"],"subregion":"Eastern Asia","region":"Asia","population":125836021,"latlng":[36,138],"demonym":"Japanese","area":377930,"gini":32.9,"timezones":["UTC+09:00"],"nativeName":"\u65E5\u672C","numericCode":"392","flags":{"svg":"https://flagcdn.com/jp.svg","png":"https://flagcdn.com/w320/jp.png"},"currencies":[{"code":"JPY","name":"Japanese yen","symbol":"\xa5"}],"languages":[{"iso639_1":"ja","iso639_2":"jpn","name":"Japanese","nativeName":"\u65E5\u672C\u8A9E (\u306B\u307B\u3093\u3054)"}],"translations":{"br":"Japan","pt":"Jap\xe3o","nl":"Japan","hr":"Japan","fa":"\u0698\u0627\u067E\u0646","de":"Japan","es":"Jap\xf3n","fr":"Japon","ja":"\u65E5\u672C","it":"Giappone","hu":"Jap\xe1n"},"flag":"https://flagcdn.com/jp.svg","cioc":"JPN","independent":true},{"name":"Jersey","topLevelDomain":[".je"],"alpha2Code":"JE","alpha3Code":"JEY","callingCodes":["44"],"capital":"Saint Helier","altSpellings":["JE","Bailiwick of Jersey","Bailliage de Jersey","Bailliage d\xe9 J\xe8rri"],"subregion":"Northern Europe","region":"Europe","population":100800,"latlng":[49.25,-2.16666666],"demonym":"Channel Islander","area":116,"timezones":["UTC+01:00"],"nativeName":"Jersey","numericCode":"832","flags":{"svg":"https://flagcdn.com/je.svg","png":"https://flagcdn.com/w320/je.png"},"currencies":[{"code":"GBP","name":"British pound","symbol":"\xa3"},{"code":"JEP[G]","name":"Jersey pound","symbol":"\xa3"}],"languages":[{"iso639_1":"en","iso639_2":"eng","name":"English","nativeName":"English"},{"iso639_1":"fr","iso639_2":"fra","name":"French","nativeName":"fran\xe7ais"}],"translations":{"br":"Jerzenez","pt":"Jersey","nl":"Jersey","hr":"Jersey","fa":"\u062C\u0631\u0632\u06CC","de":"Jersey","es":"Jersey","fr":"Jersey","ja":"\u30B8\u30E3\u30FC\u30B8\u30FC","it":"Isola di Jersey","hu":"Jersey"},"flag":"https://flagcdn.com/je.svg","independent":false},{"name":"Jordan","topLevelDomain":[".jo"],"alpha2Code":"JO","alpha3Code":"JOR","callingCodes":["962"],"capital":"Amman","altSpellings":["JO","Hashemite Kingdom of Jordan","al-Mamlakah al-Urdun\u012Byah al-H\u0101shim\u012Byah"],"subregion":"Western Asia","region":"Asia","population":10203140,"latlng":[31,36],"demonym":"Jordanian","area":89342,"gini":33.7,"timezones":["UTC+03:00"],"borders":["IRQ","ISR","SAU","SYR"],"nativeName":"\u0627\u0644\u0623\u0631\u062F\u0646","numericCode":"400","flags":{"svg":"https://flagcdn.com/jo.svg","png":"https://flagcdn.com/w320/jo.png"},"currencies":[{"code":"JOD","name":"Jordanian dinar","symbol":"\u062F.\u0627"}],"languages":[{"iso639_1":"ar","iso639_2":"ara","name":"Arabic","nativeName":"\u0627\u0644\u0639\u0631\u0628\u064A\u0629"}],"translations":{"br":"Jordania","pt":"Jord\xe2nia","nl":"Jordani\xeb","hr":"Jordan","fa":"\u0627\u0631\u062F\u0646","de":"Jordanien","es":"Jordania","fr":"Jordanie","ja":"\u30E8\u30EB\u30C0\u30F3","it":"Giordania","hu":"Jord\xe1nia"},"flag":"https://flagcdn.com/jo.svg","regionalBlocs":[{"acronym":"AL","name":"Arab League","otherNames":["\u062C\u0627\u0645\u0639\u0629 \u0627\u0644\u062F\u0648\u0644 \u0627\u0644\u0639\u0631\u0628\u064A\u0629","J\u0101mi\u02BBat ad-Duwal al-\u02BBArab\u012Byah","League of Arab States"]}],"cioc":"JOR","independent":true},{"name":"Kazakhstan","topLevelDomain":[".kz",".\u049B\u0430\u0437"],"alpha2Code":"KZ","alpha3Code":"KAZ","callingCodes":["76","77"],"capital":"Nur-Sultan","altSpellings":["KZ","Qazaqstan","\u041A\u0430\u0437\u0430\u0445\u0441\u0442\u0430\u043D","Republic of Kazakhstan","\u049A\u0430\u0437\u0430\u049B\u0441\u0442\u0430\u043D \u0420\u0435\u0441\u043F\u0443\u0431\u043B\u0438\u043A\u0430\u0441\u044B","Qazaqstan Respubl\xefkas\u0131","\u0420\u0435\u0441\u043F\u0443\u0431\u043B\u0438\u043A\u0430 \u041A\u0430\u0437\u0430\u0445\u0441\u0442\u0430\u043D","Respublika Kazakhstan"],"subregion":"Central Asia","region":"Asia","population":18754440,"latlng":[48,68],"demonym":"Kazakhstani","area":2724900,"gini":27.8,"timezones":["UTC+05:00","UTC+06:00"],"borders":["CHN","KGZ","RUS","TKM","UZB"],"nativeName":"\u049A\u0430\u0437\u0430\u049B\u0441\u0442\u0430\u043D","numericCode":"398","flags":{"svg":"https://flagcdn.com/kz.svg","png":"https://flagcdn.com/w320/kz.png"},"currencies":[{"code":"KZT","name":"Kazakhstani tenge","symbol":"\u20B8"}],"languages":[{"iso639_1":"kk","iso639_2":"kaz","name":"Kazakh","nativeName":"\u049B\u0430\u0437\u0430\u049B \u0442\u0456\u043B\u0456"},{"iso639_1":"ru","iso639_2":"rus","name":"Russian","nativeName":"\u0420\u0443\u0441\u0441\u043A\u0438\u0439"}],"translations":{"br":"Kazakstan","pt":"Cazaquist\xe3o","nl":"Kazachstan","hr":"Kazahstan","fa":"\u0642\u0632\u0627\u0642\u0633\u062A\u0627\u0646","de":"Kasachstan","es":"Kazajist\xe1n","fr":"Kazakhstan","ja":"\u30AB\u30B6\u30D5\u30B9\u30BF\u30F3","it":"Kazakistan","hu":"Kazahszt\xe1n"},"flag":"https://flagcdn.com/kz.svg","regionalBlocs":[{"acronym":"EEU","name":"Eurasian Economic Union","otherAcronyms":["EAEU"]}],"cioc":"KAZ","independent":true},{"name":"Kenya","topLevelDomain":[".ke"],"alpha2Code":"KE","alpha3Code":"KEN","callingCodes":["254"],"capital":"Nairobi","altSpellings":["KE","Republic of Kenya","Jamhuri ya Kenya"],"subregion":"Eastern Africa","region":"Africa","population":53771300,"latlng":[1,38],"demonym":"Kenyan","area":580367,"gini":40.8,"timezones":["UTC+03:00"],"borders":["ETH","SOM","SSD","TZA","UGA"],"nativeName":"Kenya","numericCode":"404","flags":{"svg":"https://flagcdn.com/ke.svg","png":"https://flagcdn.com/w320/ke.png"},"currencies":[{"code":"KES","name":"Kenyan shilling","symbol":"Sh"}],"languages":[{"iso639_1":"en","iso639_2":"eng","name":"English","nativeName":"English"},{"iso639_1":"sw","iso639_2":"swa","name":"Swahili","nativeName":"Kiswahili"}],"translations":{"br":"Kenya","pt":"Qu\xe9nia","nl":"Kenia","hr":"Kenija","fa":"\u06A9\u0646\u06CC\u0627","de":"Kenia","es":"Kenia","fr":"Kenya","ja":"\u30B1\u30CB\u30A2","it":"Kenya","hu":"Kenya"},"flag":"https://flagcdn.com/ke.svg","regionalBlocs":[{"acronym":"AU","name":"African Union","otherNames":["\u0627\u0644\u0627\u062A\u062D\u0627\u062F \u0627\u0644\u0623\u0641\u0631\u064A\u0642\u064A","Union africaine","Uni\xe3o Africana","Uni\xf3n Africana","Umoja wa Afrika"]}],"cioc":"KEN","independent":true},{"name":"Kiribati","topLevelDomain":[".ki"],"alpha2Code":"KI","alpha3Code":"KIR","callingCodes":["686"],"capital":"South Tarawa","altSpellings":["KI","Republic of Kiribati","Ribaberiki Kiribati"],"subregion":"Micronesia","region":"Oceania","population":119446,"latlng":[1.41666666,173],"demonym":"I-Kiribati","area":811,"gini":37,"timezones":["UTC+12:00","UTC+13:00","UTC+14:00"],"nativeName":"Kiribati","numericCode":"296","flags":{"svg":"https://flagcdn.com/ki.svg","png":"https://flagcdn.com/w320/ki.png"},"currencies":[{"code":"AUD","name":"Australian dollar","symbol":"$"},{"code":"KID","name":"Kiribati dollar","symbol":"$"}],"languages":[{"iso639_1":"en","iso639_2":"eng","name":"English","nativeName":"English"}],"translations":{"br":"Kiribati","pt":"Quirib\xe1ti","nl":"Kiribati","hr":"Kiribati","fa":"\u06A9\u06CC\u0631\u06CC\u0628\u0627\u062A\u06CC","de":"Kiribati","es":"Kiribati","fr":"Kiribati","ja":"\u30AD\u30EA\u30D0\u30B9","it":"Kiribati","hu":"Kiribati"},"flag":"https://flagcdn.com/ki.svg","cioc":"KIR","independent":true},{"name":"Kuwait","topLevelDomain":[".kw"],"alpha2Code":"KW","alpha3Code":"KWT","callingCodes":["965"],"capital":"Kuwait City","altSpellings":["KW","State of Kuwait","Dawlat al-Kuwait"],"subregion":"Western Asia","region":"Asia","population":4270563,"latlng":[29.5,45.75],"demonym":"Kuwaiti","area":17818,"timezones":["UTC+03:00"],"borders":["IRQ","SAU"],"nativeName":"\u0627\u0644\u0643\u0648\u064A\u062A","numericCode":"414","flags":{"svg":"https://flagcdn.com/kw.svg","png":"https://flagcdn.com/w320/kw.png"},"currencies":[{"code":"KWD","name":"Kuwaiti dinar","symbol":"\u062F.\u0643"}],"languages":[{"iso639_1":"ar","iso639_2":"ara","name":"Arabic","nativeName":"\u0627\u0644\u0639\u0631\u0628\u064A\u0629"}],"translations":{"br":"Koweit","pt":"Kuwait","nl":"Koeweit","hr":"Kuvajt","fa":"\u06A9\u0648\u06CC\u062A","de":"Kuwait","es":"Kuwait","fr":"Kowe\xeft","ja":"\u30AF\u30A6\u30A7\u30FC\u30C8","it":"Kuwait","hu":"Kuvait"},"flag":"https://flagcdn.com/kw.svg","regionalBlocs":[{"acronym":"AL","name":"Arab League","otherNames":["\u062C\u0627\u0645\u0639\u0629 \u0627\u0644\u062F\u0648\u0644 \u0627\u0644\u0639\u0631\u0628\u064A\u0629","J\u0101mi\u02BBat ad-Duwal al-\u02BBArab\u012Byah","League of Arab States"]}],"cioc":"KUW","independent":true},{"name":"Kyrgyzstan","topLevelDomain":[".kg"],"alpha2Code":"KG","alpha3Code":"KGZ","callingCodes":["996"],"capital":"Bishkek","altSpellings":["KG","\u041A\u0438\u0440\u0433\u0438\u0437\u0438\u044F","Kyrgyz Republic","\u041A\u044B\u0440\u0433\u044B\u0437 \u0420\u0435\u0441\u043F\u0443\u0431\u043B\u0438\u043A\u0430\u0441\u044B","Kyrgyz Respublikasy"],"subregion":"Central Asia","region":"Asia","population":6591600,"latlng":[41,75],"demonym":"Kirghiz","area":199951,"gini":29.7,"timezones":["UTC+06:00"],"borders":["CHN","KAZ","TJK","UZB"],"nativeName":"\u041A\u044B\u0440\u0433\u044B\u0437\u0441\u0442\u0430\u043D","numericCode":"417","flags":{"svg":"https://flagcdn.com/kg.svg","png":"https://flagcdn.com/w320/kg.png"},"currencies":[{"code":"KGS","name":"Kyrgyzstani som","symbol":"\u0441"}],"languages":[{"iso639_1":"ky","iso639_2":"kir","name":"Kyrgyz","nativeName":"\u041A\u044B\u0440\u0433\u044B\u0437\u0447\u0430"},{"iso639_1":"ru","iso639_2":"rus","name":"Russian","nativeName":"\u0420\u0443\u0441\u0441\u043A\u0438\u0439"}],"translations":{"br":"Kirgizstan","pt":"Quirguizist\xe3o","nl":"Kirgizi\xeb","hr":"Kirgistan","fa":"\u0642\u0631\u0642\u06CC\u0632\u0633\u062A\u0627\u0646","de":"Kirgisistan","es":"Kirguizist\xe1n","fr":"Kirghizistan","ja":"\u30AD\u30EB\u30AE\u30B9","it":"Kirghizistan","hu":"Kirgiziszt\xe1n"},"flag":"https://flagcdn.com/kg.svg","regionalBlocs":[{"acronym":"EEU","name":"Eurasian Economic Union","otherAcronyms":["EAEU"]}],"cioc":"KGZ","independent":true},{"name":"Lao People\'s Democratic Republic","topLevelDomain":[".la"],"alpha2Code":"LA","alpha3Code":"LAO","callingCodes":["856"],"capital":"Vientiane","altSpellings":["LA","Lao","Laos","Lao People\'s Democratic Republic","Sathalanalat Paxathipatai Paxaxon Lao"],"subregion":"South-Eastern Asia","region":"Asia","population":7275556,"latlng":[18,105],"demonym":"Laotian","area":236800,"gini":38.8,"timezones":["UTC+07:00"],"borders":["MMR","KHM","CHN","THA","VNM"],"nativeName":"\u0EAA\u0EB2\u0E97\u0EB2\u0EA5\u0EB0\u0E99\u0EB0\u0EA5\u0EB1\u0E94 \u0E9B\u0EB0\u0E8A\u0EB2\u0E97\u0EB4\u0E9B\u0EB0\u0EC4\u0E95 \u0E9B\u0EB0\u0E8A\u0EB2\u0E8A\u0EBB\u0E99\u0EA5\u0EB2\u0EA7","numericCode":"418","flags":{"svg":"https://flagcdn.com/la.svg","png":"https://flagcdn.com/w320/la.png"},"currencies":[{"code":"LAK","name":"Lao kip","symbol":"\u20AD"}],"languages":[{"iso639_1":"lo","iso639_2":"lao","name":"Lao","nativeName":"\u0E9E\u0EB2\u0EAA\u0EB2\u0EA5\u0EB2\u0EA7"}],"translations":{"br":"Laos","pt":"Laos","nl":"Laos","hr":"Laos","fa":"\u0644\u0627\u0626\u0648\u0633","de":"Laos","es":"Laos","fr":"Laos","ja":"\u30E9\u30AA\u30B9\u4EBA\u6C11\u6C11\u4E3B\u5171\u548C\u56FD","it":"Laos","hu":"Laosz"},"flag":"https://flagcdn.com/la.svg","regionalBlocs":[{"acronym":"ASEAN","name":"Association of Southeast Asian Nations"}],"cioc":"LAO","independent":true},{"name":"Latvia","topLevelDomain":[".lv"],"alpha2Code":"LV","alpha3Code":"LVA","callingCodes":["371"],"capital":"Riga","altSpellings":["LV","Republic of Latvia","Latvijas Republika"],"subregion":"Northern Europe","region":"Europe","population":1901548,"latlng":[57,25],"demonym":"Latvian","area":64559,"gini":35.1,"timezones":["UTC+02:00"],"borders":["BLR","EST","LTU","RUS"],"nativeName":"Latvija","numericCode":"428","flags":{"svg":"https://flagcdn.com/lv.svg","png":"https://flagcdn.com/w320/lv.png"},"currencies":[{"code":"EUR","name":"Euro","symbol":"\u20AC"}],"languages":[{"iso639_1":"lv","iso639_2":"lav","name":"Latvian","nativeName":"latvie\u0161u valoda"}],"translations":{"br":"Latvia","pt":"Let\xf3nia","nl":"Letland","hr":"Latvija","fa":"\u0644\u062A\u0648\u0646\u06CC","de":"Lettland","es":"Letonia","fr":"Lettonie","ja":"\u30E9\u30C8\u30D3\u30A2","it":"Lettonia","hu":"Lettorsz\xe1g"},"flag":"https://flagcdn.com/lv.svg","regionalBlocs":[{"acronym":"EU","name":"European Union"}],"cioc":"LAT","independent":true},{"name":"Lebanon","topLevelDomain":[".lb"],"alpha2Code":"LB","alpha3Code":"LBN","callingCodes":["961"],"capital":"Beirut","altSpellings":["LB","Lebanese Republic","Al-Jumh\u016Br\u012Byah Al-Libn\u0101n\u012Byah"],"subregion":"Western Asia","region":"Asia","population":6825442,"latlng":[33.83333333,35.83333333],"demonym":"Lebanese","area":10452,"gini":31.8,"timezones":["UTC+02:00"],"borders":["ISR","SYR"],"nativeName":"\u0644\u0628\u0646\u0627\u0646","numericCode":"422","flags":{"svg":"https://flagcdn.com/lb.svg","png":"https://flagcdn.com/w320/lb.png"},"currencies":[{"code":"LBP","name":"Lebanese pound","symbol":"\u0644.\u0644"}],"languages":[{"iso639_1":"ar","iso639_2":"ara","name":"Arabic","nativeName":"\u0627\u0644\u0639\u0631\u0628\u064A\u0629"},{"iso639_1":"fr","iso639_2":"fra","name":"French","nativeName":"fran\xe7ais"}],"translations":{"br":"Liban","pt":"L\xedbano","nl":"Libanon","hr":"Libanon","fa":"\u0644\u0628\u0646\u0627\u0646","de":"Libanon","es":"L\xedbano","fr":"Liban","ja":"\u30EC\u30D0\u30CE\u30F3","it":"Libano","hu":"Libanon"},"flag":"https://flagcdn.com/lb.svg","regionalBlocs":[{"acronym":"AL","name":"Arab League","otherNames":["\u062C\u0627\u0645\u0639\u0629 \u0627\u0644\u062F\u0648\u0644 \u0627\u0644\u0639\u0631\u0628\u064A\u0629","J\u0101mi\u02BBat ad-Duwal al-\u02BBArab\u012Byah","League of Arab States"]}],"cioc":"LIB","independent":true},{"name":"Lesotho","topLevelDomain":[".ls"],"alpha2Code":"LS","alpha3Code":"LSO","callingCodes":["266"],"capital":"Maseru","altSpellings":["LS","Kingdom of Lesotho","Muso oa Lesotho"],"subregion":"Southern Africa","region":"Africa","population":2142252,"latlng":[-29.5,28.5],"demonym":"Mosotho","area":30355,"gini":44.9,"timezones":["UTC+02:00"],"borders":["ZAF"],"nativeName":"Lesotho","numericCode":"426","flags":{"svg":"https://flagcdn.com/ls.svg","png":"https://flagcdn.com/w320/ls.png"},"currencies":[{"code":"LSL","name":"Lesotho loti","symbol":"L"},{"code":"ZAR","name":"South African rand","symbol":"R"}],"languages":[{"iso639_1":"en","iso639_2":"eng","name":"English","nativeName":"English"},{"iso639_1":"st","iso639_2":"sot","name":"Southern Sotho","nativeName":"Sesotho"}],"translations":{"br":"Lesotho","pt":"Lesoto","nl":"Lesotho","hr":"Lesoto","fa":"\u0644\u0633\u0648\u062A\u0648","de":"Lesotho","es":"Lesotho","fr":"Lesotho","ja":"\u30EC\u30BD\u30C8","it":"Lesotho","hu":"Lesotho"},"flag":"https://flagcdn.com/ls.svg","regionalBlocs":[{"acronym":"AU","name":"African Union","otherNames":["\u0627\u0644\u0627\u062A\u062D\u0627\u062F \u0627\u0644\u0623\u0641\u0631\u064A\u0642\u064A","Union africaine","Uni\xe3o Africana","Uni\xf3n Africana","Umoja wa Afrika"]}],"cioc":"LES","independent":true},{"name":"Liberia","topLevelDomain":[".lr"],"alpha2Code":"LR","alpha3Code":"LBR","callingCodes":["231"],"capital":"Monrovia","altSpellings":["LR","Republic of Liberia"],"subregion":"Western Africa","region":"Africa","population":5057677,"latlng":[6.5,-9.5],"demonym":"Liberian","area":111369,"gini":35.3,"timezones":["UTC"],"borders":["GIN","CIV","SLE"],"nativeName":"Liberia","numericCode":"430","flags":{"svg":"https://flagcdn.com/lr.svg","png":"https://flagcdn.com/w320/lr.png"},"currencies":[{"code":"LRD","name":"Liberian dollar","symbol":"$"}],"languages":[{"iso639_1":"en","iso639_2":"eng","name":"English","nativeName":"English"}],"translations":{"br":"Liberia","pt":"Lib\xe9ria","nl":"Liberia","hr":"Liberija","fa":"\u0644\u06CC\u0628\u0631\u06CC\u0627","de":"Liberia","es":"Liberia","fr":"Liberia","ja":"\u30EA\u30D9\u30EA\u30A2","it":"Liberia","hu":"Lib\xe9ria"},"flag":"https://flagcdn.com/lr.svg","regionalBlocs":[{"acronym":"AU","name":"African Union","otherNames":["\u0627\u0644\u0627\u062A\u062D\u0627\u062F \u0627\u0644\u0623\u0641\u0631\u064A\u0642\u064A","Union africaine","Uni\xe3o Africana","Uni\xf3n Africana","Umoja wa Afrika"]}],"cioc":"LBR","independent":true},{"name":"Libya","topLevelDomain":[".ly"],"alpha2Code":"LY","alpha3Code":"LBY","callingCodes":["218"],"capital":"Tripoli","altSpellings":["LY","State of Libya","Dawlat Libya"],"subregion":"Northern Africa","region":"Africa","population":6871287,"latlng":[25,17],"demonym":"Libyan","area":1759540,"timezones":["UTC+01:00"],"borders":["DZA","TCD","EGY","NER","SDN","TUN"],"nativeName":"\u200F\u0644\u064A\u0628\u064A\u0627","numericCode":"434","flags":{"svg":"https://flagcdn.com/ly.svg","png":"https://flagcdn.com/w320/ly.png"},"currencies":[{"code":"LYD","name":"Libyan dinar","symbol":"\u0644.\u062F"}],"languages":[{"iso639_1":"ar","iso639_2":"ara","name":"Arabic","nativeName":"\u0627\u0644\u0639\u0631\u0628\u064A\u0629"}],"translations":{"br":"Libia","pt":"L\xedbia","nl":"Libi\xeb","hr":"Libija","fa":"\u0644\u06CC\u0628\u06CC","de":"Libyen","es":"Libia","fr":"Libye","ja":"\u30EA\u30D3\u30A2","it":"Libia","hu":"L\xedbia"},"flag":"https://flagcdn.com/ly.svg","regionalBlocs":[{"acronym":"AU","name":"African Union","otherNames":["\u0627\u0644\u0627\u062A\u062D\u0627\u062F \u0627\u0644\u0623\u0641\u0631\u064A\u0642\u064A","Union africaine","Uni\xe3o Africana","Uni\xf3n Africana","Umoja wa Afrika"]},{"acronym":"AL","name":"Arab League","otherNames":["\u062C\u0627\u0645\u0639\u0629 \u0627\u0644\u062F\u0648\u0644 \u0627\u0644\u0639\u0631\u0628\u064A\u0629","J\u0101mi\u02BBat ad-Duwal al-\u02BBArab\u012Byah","League of Arab States"]}],"cioc":"LBA","independent":true},{"name":"Liechtenstein","topLevelDomain":[".li"],"alpha2Code":"LI","alpha3Code":"LIE","callingCodes":["423"],"capital":"Vaduz","altSpellings":["LI","Principality of Liechtenstein","F\xfcrstentum Liechtenstein"],"subregion":"Central Europe","region":"Europe","population":38137,"latlng":[47.26666666,9.53333333],"demonym":"Liechtensteiner","area":160,"timezones":["UTC+01:00"],"borders":["AUT","CHE"],"nativeName":"Liechtenstein","numericCode":"438","flags":{"svg":"https://flagcdn.com/li.svg","png":"https://flagcdn.com/w320/li.png"},"currencies":[{"code":"CHF","name":"Swiss franc","symbol":"Fr"}],"languages":[{"iso639_1":"de","iso639_2":"deu","name":"German","nativeName":"Deutsch"}],"translations":{"br":"Liechtenstein","pt":"Listenstaine","nl":"Liechtenstein","hr":"Lihten\u0161tajn","fa":"\u0644\u06CC\u062E\u062A\u0646\u200C\u0627\u0634\u062A\u0627\u06CC\u0646","de":"Liechtenstein","es":"Liechtenstein","fr":"Liechtenstein","ja":"\u30EA\u30D2\u30C6\u30F3\u30B7\u30E5\u30BF\u30A4\u30F3","it":"Liechtenstein","hu":"Liechtenstein"},"flag":"https://flagcdn.com/li.svg","regionalBlocs":[{"acronym":"EFTA","name":"European Free Trade Association"}],"cioc":"LIE","independent":true},{"name":"Lithuania","topLevelDomain":[".lt"],"alpha2Code":"LT","alpha3Code":"LTU","callingCodes":["370"],"capital":"Vilnius","altSpellings":["LT","Republic of Lithuania","Lietuvos Respublika"],"subregion":"Northern Europe","region":"Europe","population":2794700,"latlng":[56,24],"demonym":"Lithuanian","area":65300,"gini":35.7,"timezones":["UTC+02:00"],"borders":["BLR","LVA","POL","RUS"],"nativeName":"Lietuva","numericCode":"440","flags":{"svg":"https://flagcdn.com/lt.svg","png":"https://flagcdn.com/w320/lt.png"},"currencies":[{"code":"EUR","name":"Euro","symbol":"\u20AC"}],"languages":[{"iso639_1":"lt","iso639_2":"lit","name":"Lithuanian","nativeName":"lietuvi\u0173 kalba"}],"translations":{"br":"Lituania","pt":"Litu\xe2nia","nl":"Litouwen","hr":"Litva","fa":"\u0644\u06CC\u062A\u0648\u0627\u0646\u06CC","de":"Litauen","es":"Lituania","fr":"Lituanie","ja":"\u30EA\u30C8\u30A2\u30CB\u30A2","it":"Lituania","hu":"Litv\xe1nia"},"flag":"https://flagcdn.com/lt.svg","regionalBlocs":[{"acronym":"EU","name":"European Union"}],"cioc":"LTU","independent":true},{"name":"Luxembourg","topLevelDomain":[".lu"],"alpha2Code":"LU","alpha3Code":"LUX","callingCodes":["352"],"capital":"Luxembourg","altSpellings":["LU","Grand Duchy of Luxembourg","Grand-Duch\xe9 de Luxembourg","Gro\xdfherzogtum Luxemburg","Groussherzogtum L\xebtzebuerg"],"subregion":"Western Europe","region":"Europe","population":632275,"latlng":[49.75,6.16666666],"demonym":"Luxembourger","area":2586,"gini":35.4,"timezones":["UTC+01:00"],"borders":["BEL","FRA","DEU"],"nativeName":"L\xebtzebuerg","numericCode":"442","flags":{"svg":"https://flagcdn.com/lu.svg","png":"https://flagcdn.com/w320/lu.png"},"currencies":[{"code":"EUR","name":"Euro","symbol":"\u20AC"}],"languages":[{"iso639_1":"fr","iso639_2":"fra","name":"French","nativeName":"fran\xe7ais"},{"iso639_1":"de","iso639_2":"deu","name":"German","nativeName":"Deutsch"},{"iso639_1":"lb","iso639_2":"ltz","name":"Luxembourgish","nativeName":"L\xebtzebuergesch"}],"translations":{"br":"Luksembourg","pt":"Luxemburgo","nl":"Luxemburg","hr":"Luksemburg","fa":"\u0644\u0648\u06A9\u0632\u0627\u0645\u0628\u0648\u0631\u06AF","de":"Luxemburg","es":"Luxemburgo","fr":"Luxembourg","ja":"\u30EB\u30AF\u30BB\u30F3\u30D6\u30EB\u30AF","it":"Lussemburgo","hu":"Luxemburg"},"flag":"https://flagcdn.com/lu.svg","regionalBlocs":[{"acronym":"EU","name":"European Union"}],"cioc":"LUX","independent":true},{"name":"Macao","topLevelDomain":[".mo"],"alpha2Code":"MO","alpha3Code":"MAC","callingCodes":["853"],"altSpellings":["MO","\u6FB3\u95E8","Macao Special Administrative Region of the People\'s Republic of China","\u4E2D\u83EF\u4EBA\u6C11\u5171\u548C\u570B\u6FB3\u9580\u7279\u5225\u884C\u653F\u5340","Regi\xe3o Administrativa Especial de Macau da Rep\xfablica Popular da China"],"subregion":"Eastern Asia","region":"Asia","population":649342,"latlng":[22.16666666,113.55],"demonym":"Chinese","area":30,"timezones":["UTC+08:00"],"borders":["CHN"],"nativeName":"\u6FB3\u9580","numericCode":"446","flags":{"svg":"https://flagcdn.com/mo.svg","png":"https://flagcdn.com/w320/mo.png"},"currencies":[{"code":"MOP","name":"Macanese pataca","symbol":"P"}],"languages":[{"iso639_1":"zh","iso639_2":"zho","name":"Chinese","nativeName":"\u4E2D\u6587 (Zh\u014Dngw\xe9n)"},{"iso639_1":"pt","iso639_2":"por","name":"Portuguese","nativeName":"Portugu\xeas"}],"translations":{"br":"Makao","pt":"Macau","nl":"Macao","hr":"Makao","fa":"\u0645\u06A9\u0627\u0626\u0648","de":"Macao","es":"Macao","fr":"Macao","ja":"\u30DE\u30AB\u30AA","it":"Macao","hu":"Maka\xf3"},"flag":"https://flagcdn.com/mo.svg","independent":false},{"name":"North Macedonia","topLevelDomain":[".mk"],"alpha2Code":"MK","alpha3Code":"MKD","callingCodes":["389"],"capital":"Skopje","altSpellings":["MK","Republic of Macedonia","\u0420\u0435\u043F\u0443\u0431\u043B\u0438\u043A\u0430 \u041C\u0430\u043A\u0435\u0434\u043E\u043D\u0438\u0458\u0430"],"subregion":"Southern Europe","region":"Europe","population":2083380,"latlng":[41.83333333,22],"demonym":"Macedonian","area":25713,"gini":33,"timezones":["UTC+01:00"],"borders":["ALB","BGR","GRC","UNK","SRB"],"nativeName":"\u041C\u0430\u043A\u0435\u0434\u043E\u043D\u0438\u0458\u0430","numericCode":"807","flags":{"svg":"https://flagcdn.com/mk.svg","png":"https://flagcdn.com/w320/mk.png"},"currencies":[{"code":"MKD","name":"Macedonian denar","symbol":"\u0434\u0435\u043D"}],"languages":[{"iso639_1":"mk","iso639_2":"mkd","name":"Macedonian","nativeName":"\u043C\u0430\u043A\u0435\u0434\u043E\u043D\u0441\u043A\u0438 \u0458\u0430\u0437\u0438\u043A"}],"translations":{"br":"Makedonia an Norzh","pt":"Maced\xf3nia","nl":"Macedoni\xeb","hr":"Makedonija","de":"Mazedonien","es":"Macedonia","fr":"Mac\xe9doine","ja":"\u30DE\u30B1\u30C9\u30CB\u30A2\u65E7\u30E6\u30FC\u30B4\u30B9\u30E9\u30D3\u30A2\u5171\u548C\u56FD","it":"Macedonia","hu":"Maced\xf3nia"},"flag":"https://flagcdn.com/mk.svg","regionalBlocs":[{"acronym":"CEFTA","name":"Central European Free Trade Agreement"}],"cioc":"MKD","independent":true},{"name":"Madagascar","topLevelDomain":[".mg"],"alpha2Code":"MG","alpha3Code":"MDG","callingCodes":["261"],"capital":"Antananarivo","altSpellings":["MG","Republic of Madagascar","Repoblikan\'i Madagasikara","R\xe9publique de Madagascar"],"subregion":"Eastern Africa","region":"Africa","population":27691019,"latlng":[-20,47],"demonym":"Malagasy","area":587041,"gini":42.6,"timezones":["UTC+03:00"],"nativeName":"Madagasikara","numericCode":"450","flags":{"svg":"https://flagcdn.com/mg.svg","png":"https://flagcdn.com/w320/mg.png"},"currencies":[{"code":"MGA","name":"Malagasy ariary","symbol":"Ar"}],"languages":[{"iso639_1":"fr","iso639_2":"fra","name":"French","nativeName":"fran\xe7ais"},{"iso639_1":"mg","iso639_2":"mlg","name":"Malagasy","nativeName":"fiteny malagasy"}],"translations":{"br":"Madagaskar","pt":"Madag\xe1scar","nl":"Madagaskar","hr":"Madagaskar","fa":"\u0645\u0627\u062F\u0627\u06AF\u0627\u0633\u06A9\u0627\u0631","de":"Madagaskar","es":"Madagascar","fr":"Madagascar","ja":"\u30DE\u30C0\u30AC\u30B9\u30AB\u30EB","it":"Madagascar","hu":"Madagaszk\xe1r"},"flag":"https://flagcdn.com/mg.svg","regionalBlocs":[{"acronym":"AU","name":"African Union","otherNames":["\u0627\u0644\u0627\u062A\u062D\u0627\u062F \u0627\u0644\u0623\u0641\u0631\u064A\u0642\u064A","Union africaine","Uni\xe3o Africana","Uni\xf3n Africana","Umoja wa Afrika"]}],"cioc":"MAD","independent":true},{"name":"Malawi","topLevelDomain":[".mw"],"alpha2Code":"MW","alpha3Code":"MWI","callingCodes":["265"],"capital":"Lilongwe","altSpellings":["MW","Republic of Malawi"],"subregion":"Eastern Africa","region":"Africa","population":19129955,"latlng":[-13.5,34],"demonym":"Malawian","area":118484,"gini":44.7,"timezones":["UTC+02:00"],"borders":["MOZ","TZA","ZMB"],"nativeName":"Malawi","numericCode":"454","flags":{"svg":"https://flagcdn.com/mw.svg","png":"https://flagcdn.com/w320/mw.png"},"currencies":[{"code":"MWK","name":"Malawian kwacha","symbol":"MK"}],"languages":[{"iso639_1":"en","iso639_2":"eng","name":"English","nativeName":"English"},{"iso639_1":"ny","iso639_2":"nya","name":"Chichewa","nativeName":"chiChe\u0175a"}],"translations":{"br":"Malawi","pt":"Mal\xe1vi","nl":"Malawi","hr":"Malavi","fa":"\u0645\u0627\u0644\u0627\u0648\u06CC","de":"Malawi","es":"Malawi","fr":"Malawi","ja":"\u30DE\u30E9\u30A6\u30A4","it":"Malawi","hu":"Malawi"},"flag":"https://flagcdn.com/mw.svg","regionalBlocs":[{"acronym":"AU","name":"African Union","otherNames":["\u0627\u0644\u0627\u062A\u062D\u0627\u062F \u0627\u0644\u0623\u0641\u0631\u064A\u0642\u064A","Union africaine","Uni\xe3o Africana","Uni\xf3n Africana","Umoja wa Afrika"]}],"cioc":"MAW","independent":true},{"name":"Malaysia","topLevelDomain":[".my"],"alpha2Code":"MY","alpha3Code":"MYS","callingCodes":["60"],"capital":"Kuala Lumpur","altSpellings":["MY"],"subregion":"South-Eastern Asia","region":"Asia","population":32365998,"latlng":[2.5,112.5],"demonym":"Malaysian","area":330803,"gini":41.1,"timezones":["UTC+08:00"],"borders":["BRN","IDN","THA"],"nativeName":"Malaysia","numericCode":"458","flags":{"svg":"https://flagcdn.com/my.svg","png":"https://flagcdn.com/w320/my.png"},"currencies":[{"code":"MYR","name":"Malaysian ringgit","symbol":"RM"}],"languages":[{"iso639_1":"ms","iso639_2":"zsm","name":"Malaysian","nativeName":"\u0628\u0647\u0627\u0633 \u0645\u0644\u064A\u0633\u064A\u0627"}],"translations":{"br":"Malaysia","pt":"Mal\xe1sia","nl":"Maleisi\xeb","hr":"Malezija","fa":"\u0645\u0627\u0644\u0632\u06CC","de":"Malaysia","es":"Malasia","fr":"Malaisie","ja":"\u30DE\u30EC\u30FC\u30B7\u30A2","it":"Malesia","hu":"Malajzia"},"flag":"https://flagcdn.com/my.svg","regionalBlocs":[{"acronym":"ASEAN","name":"Association of Southeast Asian Nations"}],"cioc":"MAS","independent":true},{"name":"Maldives","topLevelDomain":[".mv"],"alpha2Code":"MV","alpha3Code":"MDV","callingCodes":["960"],"capital":"Mal\xe9","altSpellings":["MV","Maldive Islands","Republic of the Maldives","Dhivehi Raajjeyge Jumhooriyya"],"subregion":"Southern Asia","region":"Asia","population":540542,"latlng":[3.25,73],"demonym":"Maldivan","area":300,"gini":31.3,"timezones":["UTC+05:00"],"nativeName":"Maldives","numericCode":"462","flags":{"svg":"https://flagcdn.com/mv.svg","png":"https://flagcdn.com/w320/mv.png"},"currencies":[{"code":"MVR","name":"Maldivian rufiyaa","symbol":".\u0783"}],"languages":[{"iso639_1":"dv","iso639_2":"div","name":"Divehi","nativeName":"\u078B\u07A8\u0788\u07AC\u0780\u07A8"}],"translations":{"br":"Maldivez","pt":"Maldivas","nl":"Maldiven","hr":"Maldivi","fa":"\u0645\u0627\u0644\u062F\u06CC\u0648","de":"Malediven","es":"Maldivas","fr":"Maldives","ja":"\u30E2\u30EB\u30C7\u30A3\u30D6","it":"Maldive","hu":"Mald\xedv-szigetek"},"flag":"https://flagcdn.com/mv.svg","regionalBlocs":[{"acronym":"SAARC","name":"South Asian Association for Regional Cooperation"}],"cioc":"MDV","independent":true},{"name":"Mali","topLevelDomain":[".ml"],"alpha2Code":"ML","alpha3Code":"MLI","callingCodes":["223"],"capital":"Bamako","altSpellings":["ML","Republic of Mali","R\xe9publique du Mali"],"subregion":"Western Africa","region":"Africa","population":20250834,"latlng":[17,-4],"demonym":"Malian","area":1240192,"gini":33,"timezones":["UTC"],"borders":["DZA","BFA","GIN","CIV","MRT","NER","SEN"],"nativeName":"Mali","numericCode":"466","flags":{"svg":"https://flagcdn.com/ml.svg","png":"https://flagcdn.com/w320/ml.png"},"currencies":[{"code":"XOF","name":"West African CFA franc","symbol":"Fr"}],"languages":[{"iso639_1":"fr","iso639_2":"fra","name":"French","nativeName":"fran\xe7ais"}],"translations":{"br":"Mali","pt":"Mali","nl":"Mali","hr":"Mali","fa":"\u0645\u0627\u0644\u06CC","de":"Mali","es":"Mali","fr":"Mali","ja":"\u30DE\u30EA","it":"Mali","hu":"Mali"},"flag":"https://flagcdn.com/ml.svg","regionalBlocs":[{"acronym":"AU","name":"African Union","otherNames":["\u0627\u0644\u0627\u062A\u062D\u0627\u062F \u0627\u0644\u0623\u0641\u0631\u064A\u0642\u064A","Union africaine","Uni\xe3o Africana","Uni\xf3n Africana","Umoja wa Afrika"]}],"cioc":"MLI","independent":true},{"name":"Malta","topLevelDomain":[".mt"],"alpha2Code":"MT","alpha3Code":"MLT","callingCodes":["356"],"capital":"Valletta","altSpellings":["MT","Republic of Malta","Repubblika ta\' Malta"],"subregion":"Southern Europe","region":"Europe","population":525285,"latlng":[35.83333333,14.58333333],"demonym":"Maltese","area":316,"gini":28.7,"timezones":["UTC+01:00"],"nativeName":"Malta","numericCode":"470","flags":{"svg":"https://flagcdn.com/mt.svg","png":"https://flagcdn.com/w320/mt.png"},"currencies":[{"code":"EUR","name":"Euro","symbol":"\u20AC"}],"languages":[{"iso639_1":"mt","iso639_2":"mlt","name":"Maltese","nativeName":"Malti"},{"iso639_1":"en","iso639_2":"eng","name":"English","nativeName":"English"}],"translations":{"br":"Malta","pt":"Malta","nl":"Malta","hr":"Malta","fa":"\u0645\u0627\u0644\u062A","de":"Malta","es":"Malta","fr":"Malte","ja":"\u30DE\u30EB\u30BF","it":"Malta","hu":"M\xe1lta"},"flag":"https://flagcdn.com/mt.svg","regionalBlocs":[{"acronym":"EU","name":"European Union"}],"cioc":"MLT","independent":true},{"name":"Marshall Islands","topLevelDomain":[".mh"],"alpha2Code":"MH","alpha3Code":"MHL","callingCodes":["692"],"capital":"Majuro","altSpellings":["MH","Republic of the Marshall Islands","Aolep\u0101n Aor\u014Dkin M\u0327aje\u013C"],"subregion":"Micronesia","region":"Oceania","population":59194,"latlng":[9,168],"demonym":"Marshallese","area":181,"timezones":["UTC+12:00"],"nativeName":"M\u0327aje\u013C","numericCode":"584","flags":{"svg":"https://flagcdn.com/mh.svg","png":"https://flagcdn.com/w320/mh.png"},"currencies":[{"code":"USD","name":"United States dollar","symbol":"$"}],"languages":[{"iso639_1":"en","iso639_2":"eng","name":"English","nativeName":"English"},{"iso639_1":"mh","iso639_2":"mah","name":"Marshallese","nativeName":"Kajin M\u0327aje\u013C"}],"translations":{"br":"Inizi Marshall","pt":"Ilhas Marshall","nl":"Marshalleilanden","hr":"Mar\u0161alovi Otoci","fa":"\u062C\u0632\u0627\u06CC\u0631 \u0645\u0627\u0631\u0634\u0627\u0644","de":"Marshallinseln","es":"Islas Marshall","fr":"\xceles Marshall","ja":"\u30DE\u30FC\u30B7\u30E3\u30EB\u8AF8\u5CF6","it":"Isole Marshall","hu":"Marshall-szigetek"},"flag":"https://flagcdn.com/mh.svg","cioc":"MHL","independent":true},{"name":"Martinique","topLevelDomain":[".mq"],"alpha2Code":"MQ","alpha3Code":"MTQ","callingCodes":["596"],"capital":"Fort-de-France","altSpellings":["MQ"],"subregion":"Caribbean","region":"Americas","population":378243,"latlng":[14.666667,-61],"demonym":"French","timezones":["UTC-04:00"],"nativeName":"Martinique","numericCode":"474","flags":{"svg":"https://flagcdn.com/mq.svg","png":"https://flagcdn.com/w320/mq.png"},"currencies":[{"code":"EUR","name":"Euro","symbol":"\u20AC"}],"languages":[{"iso639_1":"fr","iso639_2":"fra","name":"French","nativeName":"fran\xe7ais"}],"translations":{"br":"Martinik","pt":"Martinica","nl":"Martinique","hr":"Martinique","fa":"\u0645\u0648\u0646\u062A\u0633\u0631\u0627\u062A","de":"Martinique","es":"Martinica","fr":"Martinique","ja":"\u30DE\u30EB\u30C6\u30A3\u30CB\u30FC\u30AF","it":"Martinica","hu":"Martinique"},"flag":"https://flagcdn.com/mq.svg","independent":false},{"name":"Mauritania","topLevelDomain":[".mr"],"alpha2Code":"MR","alpha3Code":"MRT","callingCodes":["222"],"capital":"Nouakchott","altSpellings":["MR","Islamic Republic of Mauritania","al-Jumh\u016Briyyah al-\u02BEIsl\u0101miyyah al-M\u016Br\u012Bt\u0101niyyah"],"subregion":"Western Africa","region":"Africa","population":4649660,"latlng":[20,-12],"demonym":"Mauritanian","area":1030700,"gini":32.6,"timezones":["UTC"],"borders":["DZA","MLI","SEN","ESH"],"nativeName":"\u0645\u0648\u0631\u064A\u062A\u0627\u0646\u064A\u0627","numericCode":"478","flags":{"svg":"https://flagcdn.com/mr.svg","png":"https://flagcdn.com/w320/mr.png"},"currencies":[{"code":"MRO","name":"Mauritanian ouguiya","symbol":"UM"}],"languages":[{"iso639_1":"ar","iso639_2":"ara","name":"Arabic","nativeName":"\u0627\u0644\u0639\u0631\u0628\u064A\u0629"}],"translations":{"br":"Maouritania","pt":"Maurit\xe2nia","nl":"Mauritani\xeb","hr":"Mauritanija","fa":"\u0645\u0648\u0631\u06CC\u062A\u0627\u0646\u06CC","de":"Mauretanien","es":"Mauritania","fr":"Mauritanie","ja":"\u30E2\u30FC\u30EA\u30BF\u30CB\u30A2","it":"Mauritania","hu":"Maurit\xe1nia"},"flag":"https://flagcdn.com/mr.svg","regionalBlocs":[{"acronym":"AU","name":"African Union","otherNames":["\u0627\u0644\u0627\u062A\u062D\u0627\u062F \u0627\u0644\u0623\u0641\u0631\u064A\u0642\u064A","Union africaine","Uni\xe3o Africana","Uni\xf3n Africana","Umoja wa Afrika"]},{"acronym":"AL","name":"Arab League","otherNames":["\u062C\u0627\u0645\u0639\u0629 \u0627\u0644\u062F\u0648\u0644 \u0627\u0644\u0639\u0631\u0628\u064A\u0629","J\u0101mi\u02BBat ad-Duwal al-\u02BBArab\u012Byah","League of Arab States"]}],"cioc":"MTN","independent":true},{"name":"Mauritius","topLevelDomain":[".mu"],"alpha2Code":"MU","alpha3Code":"MUS","callingCodes":["230"],"capital":"Port Louis","altSpellings":["MU","Republic of Mauritius","R\xe9publique de Maurice"],"subregion":"Eastern Africa","region":"Africa","population":1265740,"latlng":[-20.28333333,57.55],"demonym":"Mauritian","area":2040,"gini":36.8,"timezones":["UTC+04:00"],"nativeName":"Maurice","numericCode":"480","flags":{"svg":"https://flagcdn.com/mu.svg","png":"https://flagcdn.com/w320/mu.png"},"currencies":[{"code":"MUR","name":"Mauritian rupee","symbol":"\u20A8"}],"languages":[{"iso639_1":"en","iso639_2":"eng","name":"English","nativeName":"English"}],"translations":{"br":"Moris","pt":"Maur\xedcia","nl":"Mauritius","hr":"Mauricijus","fa":"\u0645\u0648\u0631\u06CC\u0633","de":"Mauritius","es":"Mauricio","fr":"\xcele Maurice","ja":"\u30E2\u30FC\u30EA\u30B7\u30E3\u30B9","it":"Mauritius","hu":"Mauritius"},"flag":"https://flagcdn.com/mu.svg","regionalBlocs":[{"acronym":"AU","name":"African Union","otherNames":["\u0627\u0644\u0627\u062A\u062D\u0627\u062F \u0627\u0644\u0623\u0641\u0631\u064A\u0642\u064A","Union africaine","Uni\xe3o Africana","Uni\xf3n Africana","Umoja wa Afrika"]}],"cioc":"MRI","independent":true},{"name":"Mayotte","topLevelDomain":[".yt"],"alpha2Code":"YT","alpha3Code":"MYT","callingCodes":["262"],"capital":"Mamoudzou","altSpellings":["YT","Department of Mayotte","D\xe9partement de Mayotte"],"subregion":"Eastern Africa","region":"Africa","population":226915,"latlng":[-12.83333333,45.16666666],"demonym":"French","timezones":["UTC+03:00"],"nativeName":"Mayotte","numericCode":"175","flags":{"svg":"https://flagcdn.com/yt.svg","png":"https://flagcdn.com/w320/yt.png"},"currencies":[{"code":"EUR","name":"Euro","symbol":"\u20AC"}],"languages":[{"iso639_1":"fr","iso639_2":"fra","name":"French","nativeName":"fran\xe7ais"}],"translations":{"br":"Mayotte","pt":"Mayotte","nl":"Mayotte","hr":"Mayotte","fa":"\u0645\u0627\u06CC\u0648\u062A","de":"Mayotte","es":"Mayotte","fr":"Mayotte","ja":"\u30DE\u30E8\u30C3\u30C8","it":"Mayotte","hu":"Mayotte"},"flag":"https://flagcdn.com/yt.svg","regionalBlocs":[{"acronym":"AU","name":"African Union","otherNames":["\u0627\u0644\u0627\u062A\u062D\u0627\u062F \u0627\u0644\u0623\u0641\u0631\u064A\u0642\u064A","Union africaine","Uni\xe3o Africana","Uni\xf3n Africana","Umoja wa Afrika"]}],"independent":false},{"name":"Mexico","topLevelDomain":[".mx"],"alpha2Code":"MX","alpha3Code":"MEX","callingCodes":["52"],"capital":"Mexico City","altSpellings":["MX","Mexicanos","United Mexican States","Estados Unidos Mexicanos"],"subregion":"North America","region":"Americas","population":128932753,"latlng":[23,-102],"demonym":"Mexican","area":1964375,"gini":45.4,"timezones":["UTC-08:00","UTC-07:00","UTC-06:00"],"borders":["BLZ","GTM","USA"],"nativeName":"M\xe9xico","numericCode":"484","flags":{"svg":"https://flagcdn.com/mx.svg","png":"https://flagcdn.com/w320/mx.png"},"currencies":[{"code":"MXN","name":"Mexican peso","symbol":"$"}],"languages":[{"iso639_1":"es","iso639_2":"spa","name":"Spanish","nativeName":"Espa\xf1ol"}],"translations":{"br":"Mec\'hiko","pt":"M\xe9xico","nl":"Mexico","hr":"Meksiko","fa":"\u0645\u06A9\u0632\u06CC\u06A9","de":"Mexiko","es":"M\xe9xico","fr":"Mexique","ja":"\u30E1\u30AD\u30B7\u30B3","it":"Messico","hu":"Mexik\xf3"},"flag":"https://flagcdn.com/mx.svg","regionalBlocs":[{"acronym":"PA","name":"Pacific Alliance","otherNames":["Alianza del Pac\xedfico"]},{"acronym":"NAFTA","name":"North American Free Trade Agreement","otherNames":["Tratado de Libre Comercio de Am\xe9rica del Norte","Accord de Libre-\xe9change Nord-Am\xe9ricain"]}],"cioc":"MEX","independent":true},{"name":"Micronesia (Federated States of)","topLevelDomain":[".fm"],"alpha2Code":"FM","alpha3Code":"FSM","callingCodes":["691"],"capital":"Palikir","altSpellings":["FM","Federated States of Micronesia"],"subregion":"Micronesia","region":"Oceania","population":115021,"latlng":[6.91666666,158.25],"demonym":"Micronesian","area":702,"gini":40.1,"timezones":["UTC+10:00","UTC+11:00"],"nativeName":"Micronesia","numericCode":"583","flags":{"svg":"https://flagcdn.com/fm.svg","png":"https://flagcdn.com/w320/fm.png"},"currencies":[{"code":"USD","name":"United States dollar","symbol":"$"}],"languages":[{"iso639_1":"en","iso639_2":"eng","name":"English","nativeName":"English"}],"translations":{"br":"Mikronezia","pt":"Micron\xe9sia","nl":"Micronesi\xeb","hr":"Mikronezija","fa":"\u0627\u06CC\u0627\u0644\u0627\u062A \u0641\u062F\u0631\u0627\u0644 \u0645\u06CC\u06A9\u0631\u0648\u0646\u0632\u06CC","de":"Mikronesien","es":"Micronesia","fr":"Micron\xe9sie","ja":"\u30DF\u30AF\u30ED\u30CD\u30B7\u30A2\u9023\u90A6","it":"Micronesia","hu":"Mikron\xe9zia"},"flag":"https://flagcdn.com/fm.svg","cioc":"FSM","independent":true},{"name":"Moldova (Republic of)","topLevelDomain":[".md"],"alpha2Code":"MD","alpha3Code":"MDA","callingCodes":["373"],"capital":"Chi\u0219in\u0103u","altSpellings":["MD","Republic of Moldova","Republica Moldova"],"subregion":"Eastern Europe","region":"Europe","population":2617820,"latlng":[47,29],"demonym":"Moldovan","area":33846,"gini":25.7,"timezones":["UTC+02:00"],"borders":["ROU","UKR"],"nativeName":"Moldova","numericCode":"498","flags":{"svg":"https://flagcdn.com/md.svg","png":"https://flagcdn.com/w320/md.png"},"currencies":[{"code":"MDL","name":"Moldovan leu","symbol":"L"}],"languages":[{"iso639_1":"ro","iso639_2":"ron","name":"Romanian","nativeName":"Rom\xe2n\u0103"}],"translations":{"br":"Moldova","pt":"Mold\xe1via","nl":"Moldavi\xeb","hr":"Moldova","fa":"\u0645\u0648\u0644\u062F\u0627\u0648\u06CC","de":"Moldawie","es":"Moldavia","fr":"Moldavie","ja":"\u30E2\u30EB\u30C9\u30D0\u5171\u548C\u56FD","it":"Moldavia","hu":"Moldova"},"flag":"https://flagcdn.com/md.svg","regionalBlocs":[{"acronym":"CEFTA","name":"Central European Free Trade Agreement"}],"cioc":"MDA","independent":true},{"name":"Monaco","topLevelDomain":[".mc"],"alpha2Code":"MC","alpha3Code":"MCO","callingCodes":["377"],"capital":"Monaco","altSpellings":["MC","Principality of Monaco","Principaut\xe9 de Monaco"],"subregion":"Western Europe","region":"Europe","population":39244,"latlng":[43.73333333,7.4],"demonym":"Monegasque","area":2.02,"timezones":["UTC+01:00"],"borders":["FRA"],"nativeName":"Monaco","numericCode":"492","flags":{"svg":"https://flagcdn.com/mc.svg","png":"https://flagcdn.com/w320/mc.png"},"currencies":[{"code":"EUR","name":"Euro","symbol":"\u20AC"}],"languages":[{"iso639_1":"fr","iso639_2":"fra","name":"French","nativeName":"fran\xe7ais"}],"translations":{"br":"Monako","pt":"M\xf3naco","nl":"Monaco","hr":"Monako","fa":"\u0645\u0648\u0646\u0627\u06A9\u0648","de":"Monaco","es":"M\xf3naco","fr":"Monaco","ja":"\u30E2\u30CA\u30B3","it":"Principato di Monaco","hu":"Monaco"},"flag":"https://flagcdn.com/mc.svg","cioc":"MON","independent":true},{"name":"Mongolia","topLevelDomain":[".mn"],"alpha2Code":"MN","alpha3Code":"MNG","callingCodes":["976"],"capital":"Ulan Bator","altSpellings":["MN"],"subregion":"Eastern Asia","region":"Asia","population":3278292,"latlng":[46,105],"demonym":"Mongolian","area":1564110,"gini":32.7,"timezones":["UTC+07:00","UTC+08:00"],"borders":["CHN","RUS"],"nativeName":"\u041C\u043E\u043D\u0433\u043E\u043B \u0443\u043B\u0441","numericCode":"496","flags":{"svg":"https://flagcdn.com/mn.svg","png":"https://flagcdn.com/w320/mn.png"},"currencies":[{"code":"MNT","name":"Mongolian t\xf6gr\xf6g","symbol":"\u20AE"}],"languages":[{"iso639_1":"mn","iso639_2":"mon","name":"Mongolian","nativeName":"\u041C\u043E\u043D\u0433\u043E\u043B \u0445\u044D\u043B"}],"translations":{"br":"Mongolia","pt":"Mong\xf3lia","nl":"Mongoli\xeb","hr":"Mongolija","fa":"\u0645\u063A\u0648\u0644\u0633\u062A\u0627\u0646","de":"Mongolei","es":"Mongolia","fr":"Mongolie","ja":"\u30E2\u30F3\u30B4\u30EB","it":"Mongolia","hu":"Mong\xf3lia"},"flag":"https://flagcdn.com/mn.svg","cioc":"MGL","independent":true},{"name":"Montenegro","topLevelDomain":[".me"],"alpha2Code":"ME","alpha3Code":"MNE","callingCodes":["382"],"capital":"Podgorica","altSpellings":["ME","Crna Gora"],"subregion":"Southern Europe","region":"Europe","population":621718,"latlng":[42.5,19.3],"demonym":"Montenegrin","area":13812,"gini":38.5,"timezones":["UTC+01:00"],"borders":["ALB","BIH","HRV","UNK","SRB"],"nativeName":"\u0426\u0440\u043D\u0430 \u0413\u043E\u0440\u0430","numericCode":"499","flags":{"svg":"https://flagcdn.com/me.svg","png":"https://flagcdn.com/w320/me.png"},"currencies":[{"code":"EUR","name":"Euro","symbol":"\u20AC"}],"languages":[{"iso639_1":"sr","iso639_2":"srp","name":"Serbian","nativeName":"\u0441\u0440\u043F\u0441\u043A\u0438 \u0458\u0435\u0437\u0438\u043A"},{"iso639_1":"bs","iso639_2":"bos","name":"Bosnian","nativeName":"bosanski jezik"},{"iso639_1":"sq","iso639_2":"sqi","name":"Albanian","nativeName":"Shqip"},{"iso639_1":"hr","iso639_2":"hrv","name":"Croatian","nativeName":"hrvatski jezik"}],"translations":{"br":"Montenegro","pt":"Montenegro","nl":"Montenegro","hr":"Crna Gora","fa":"\u0645\u0648\u0646\u062A\u0647\u200C\u0646\u06AF\u0631\u0648","de":"Montenegro","es":"Montenegro","fr":"Mont\xe9n\xe9gro","ja":"\u30E2\u30F3\u30C6\u30CD\u30B0\u30ED","it":"Montenegro","hu":"Montenegr\xf3"},"flag":"https://flagcdn.com/me.svg","regionalBlocs":[{"acronym":"CEFTA","name":"Central European Free Trade Agreement"}],"cioc":"MNE","independent":true},{"name":"Montserrat","topLevelDomain":[".ms"],"alpha2Code":"MS","alpha3Code":"MSR","callingCodes":["1"],"capital":"Plymouth","altSpellings":["MS"],"subregion":"Caribbean","region":"Americas","population":4922,"latlng":[16.75,-62.2],"demonym":"Montserratian","area":102,"timezones":["UTC-04:00"],"nativeName":"Montserrat","numericCode":"500","flags":{"svg":"https://flagcdn.com/ms.svg","png":"https://flagcdn.com/w320/ms.png"},"currencies":[{"code":"XCD","name":"East Caribbean dollar","symbol":"$"}],"languages":[{"iso639_1":"en","iso639_2":"eng","name":"English","nativeName":"English"}],"translations":{"br":"Montserrat","pt":"Monserrate","nl":"Montserrat","hr":"Montserrat","fa":"\u0645\u0627\u06CC\u0648\u062A","de":"Montserrat","es":"Montserrat","fr":"Montserrat","ja":"\u30E2\u30F3\u30C8\u30BB\u30E9\u30C8","it":"Montserrat","hu":"Montserrat"},"flag":"https://flagcdn.com/ms.svg","regionalBlocs":[{"acronym":"CARICOM","name":"Caribbean Community","otherNames":["Comunidad del Caribe","Communaut\xe9 Carib\xe9enne","Caribische Gemeenschap"]}],"independent":false},{"name":"Morocco","topLevelDomain":[".ma"],"alpha2Code":"MA","alpha3Code":"MAR","callingCodes":["212"],"capital":"Rabat","altSpellings":["MA","Kingdom of Morocco","Al-Mamlakah al-Ma\u0121ribiyah"],"subregion":"Northern Africa","region":"Africa","population":36910558,"latlng":[32,-5],"demonym":"Moroccan","area":446550,"gini":39.5,"timezones":["UTC"],"borders":["DZA","ESH","ESP"],"nativeName":"\u0627\u0644\u0645\u063A\u0631\u0628","numericCode":"504","flags":{"svg":"https://flagcdn.com/ma.svg","png":"https://flagcdn.com/w320/ma.png"},"currencies":[{"code":"MAD","name":"Moroccan dirham","symbol":"\u062F.\u0645."}],"languages":[{"iso639_1":"ar","iso639_2":"ara","name":"Arabic","nativeName":"\u0627\u0644\u0639\u0631\u0628\u064A\u0629"}],"translations":{"br":"Maroko","pt":"Marrocos","nl":"Marokko","hr":"Maroko","fa":"\u0627\u0644\u0645\u063A\u0631\u0628","de":"Marokko","es":"Marruecos","fr":"Maroc","ja":"\u30E2\u30ED\u30C3\u30B3","it":"Marocco","hu":"Marokk\xf3"},"flag":"https://flagcdn.com/ma.svg","regionalBlocs":[{"acronym":"AU","name":"African Union","otherNames":["\u0627\u0644\u0627\u062A\u062D\u0627\u062F \u0627\u0644\u0623\u0641\u0631\u064A\u0642\u064A","Union africaine","Uni\xe3o Africana","Uni\xf3n Africana","Umoja wa Afrika"]},{"acronym":"AL","name":"Arab League","otherNames":["\u062C\u0627\u0645\u0639\u0629 \u0627\u0644\u062F\u0648\u0644 \u0627\u0644\u0639\u0631\u0628\u064A\u0629","J\u0101mi\u02BBat ad-Duwal al-\u02BBArab\u012Byah","League of Arab States"]}],"cioc":"MAR","independent":true},{"name":"Mozambique","topLevelDomain":[".mz"],"alpha2Code":"MZ","alpha3Code":"MOZ","callingCodes":["258"],"capital":"Maputo","altSpellings":["MZ","Republic of Mozambique","Rep\xfablica de Mo\xe7ambique"],"subregion":"Eastern Africa","region":"Africa","population":31255435,"latlng":[-18.25,35],"demonym":"Mozambican","area":801590,"gini":54,"timezones":["UTC+02:00"],"borders":["MWI","ZAF","SWZ","TZA","ZMB","ZWE"],"nativeName":"Mo\xe7ambique","numericCode":"508","flags":{"svg":"https://flagcdn.com/mz.svg","png":"https://flagcdn.com/w320/mz.png"},"currencies":[{"code":"MZN","name":"Mozambican metical","symbol":"MT"}],"languages":[{"iso639_1":"pt","iso639_2":"por","name":"Portuguese","nativeName":"Portugu\xeas"}],"translations":{"br":"Mozambik","pt":"Mo\xe7ambique","nl":"Mozambique","hr":"Mozambik","fa":"\u0645\u0648\u0632\u0627\u0645\u0628\u06CC\u06A9","de":"Mosambik","es":"Mozambique","fr":"Mozambique","ja":"\u30E2\u30B6\u30F3\u30D3\u30FC\u30AF","it":"Mozambico","hu":"Mozambik"},"flag":"https://flagcdn.com/mz.svg","regionalBlocs":[{"acronym":"AU","name":"African Union","otherNames":["\u0627\u0644\u0627\u062A\u062D\u0627\u062F \u0627\u0644\u0623\u0641\u0631\u064A\u0642\u064A","Union africaine","Uni\xe3o Africana","Uni\xf3n Africana","Umoja wa Afrika"]}],"cioc":"MOZ","independent":true},{"name":"Myanmar","topLevelDomain":[".mm"],"alpha2Code":"MM","alpha3Code":"MMR","callingCodes":["95"],"capital":"Naypyidaw","altSpellings":["MM","Burma","Republic of the Union of Myanmar","Pyidaunzu Thanm\u0103da My\u0103ma Nainngandaw"],"subregion":"South-Eastern Asia","region":"Asia","population":54409794,"latlng":[22,98],"demonym":"Burmese","area":676578,"gini":30.7,"timezones":["UTC+06:30"],"borders":["BGD","CHN","IND","LAO","THA"],"nativeName":"Myanma","numericCode":"104","flags":{"svg":"https://flagcdn.com/mm.svg","png":"https://flagcdn.com/w320/mm.png"},"currencies":[{"code":"MMK","name":"Burmese kyat","symbol":"Ks"}],"languages":[{"iso639_1":"my","iso639_2":"mya","name":"Burmese","nativeName":"\u1017\u1019\u102C\u1005\u102C"}],"translations":{"br":"Myanmar","pt":"Myanmar","nl":"Myanmar","hr":"Mijanmar","fa":"\u0645\u06CC\u0627\u0646\u0645\u0627\u0631","de":"Myanmar","es":"Myanmar","fr":"Myanmar","ja":"\u30DF\u30E3\u30F3\u30DE\u30FC","it":"Birmania","hu":"Mianmar"},"flag":"https://flagcdn.com/mm.svg","regionalBlocs":[{"acronym":"ASEAN","name":"Association of Southeast Asian Nations"}],"cioc":"MYA","independent":true},{"name":"Namibia","topLevelDomain":[".na"],"alpha2Code":"NA","alpha3Code":"NAM","callingCodes":["264"],"capital":"Windhoek","altSpellings":["NA","Namibi\xeb","Republic of Namibia"],"subregion":"Southern Africa","region":"Africa","population":2540916,"latlng":[-22,17],"demonym":"Namibian","area":825615,"gini":59.1,"timezones":["UTC+01:00"],"borders":["AGO","BWA","ZAF","ZMB"],"nativeName":"Namibia","numericCode":"516","flags":{"svg":"https://flagcdn.com/na.svg","png":"https://flagcdn.com/w320/na.png"},"currencies":[{"code":"NAD","name":"Namibian dollar","symbol":"$"},{"code":"ZAR","name":"South African rand","symbol":"R"}],"languages":[{"iso639_1":"en","iso639_2":"eng","name":"English","nativeName":"English"},{"iso639_1":"af","iso639_2":"afr","name":"Afrikaans","nativeName":"Afrikaans"}],"translations":{"br":"Namibia","pt":"Nam\xedbia","nl":"Namibi\xeb","hr":"Namibija","fa":"\u0646\u0627\u0645\u06CC\u0628\u06CC\u0627","de":"Namibia","es":"Namibia","fr":"Namibie","ja":"\u30CA\u30DF\u30D3\u30A2","it":"Namibia","hu":"Nam\xedbia"},"flag":"https://flagcdn.com/na.svg","regionalBlocs":[{"acronym":"AU","name":"African Union","otherNames":["\u0627\u0644\u0627\u062A\u062D\u0627\u062F \u0627\u0644\u0623\u0641\u0631\u064A\u0642\u064A","Union africaine","Uni\xe3o Africana","Uni\xf3n Africana","Umoja wa Afrika"]}],"cioc":"NAM","independent":true},{"name":"Nauru","topLevelDomain":[".nr"],"alpha2Code":"NR","alpha3Code":"NRU","callingCodes":["674"],"capital":"Yaren","altSpellings":["NR","Naoero","Pleasant Island","Republic of Nauru","Ripublik Naoero"],"subregion":"Micronesia","region":"Oceania","population":10834,"latlng":[-0.53333333,166.91666666],"demonym":"Nauruan","area":21,"gini":34.8,"timezones":["UTC+12:00"],"nativeName":"Nauru","numericCode":"520","flags":{"svg":"https://flagcdn.com/nr.svg","png":"https://flagcdn.com/w320/nr.png"},"currencies":[{"code":"AUD","name":"Australian dollar","symbol":"$"}],"languages":[{"iso639_1":"en","iso639_2":"eng","name":"English","nativeName":"English"},{"iso639_1":"na","iso639_2":"nau","name":"Nauruan","nativeName":"Dorerin Naoero"}],"translations":{"br":"Nauru","pt":"Nauru","nl":"Nauru","hr":"Nauru","fa":"\u0646\u0627\u0626\u0648\u0631\u0648","de":"Nauru","es":"Nauru","fr":"Nauru","ja":"\u30CA\u30A6\u30EB","it":"Nauru","hu":"Nauru"},"flag":"https://flagcdn.com/nr.svg","cioc":"NRU","independent":true},{"name":"Nepal","topLevelDomain":[".np"],"alpha2Code":"NP","alpha3Code":"NPL","callingCodes":["977"],"capital":"Kathmandu","altSpellings":["NP","Federal Democratic Republic of Nepal","Lokt\u0101ntrik Ganatantra Nep\u0101l"],"subregion":"Southern Asia","region":"Asia","population":29136808,"latlng":[28,84],"demonym":"Nepalese","area":147181,"gini":32.8,"timezones":["UTC+05:45"],"borders":["CHN","IND"],"nativeName":"\u0928\u0947\u092A\u093E\u0932","numericCode":"524","flags":{"svg":"https://flagcdn.com/np.svg","png":"https://flagcdn.com/w320/np.png"},"currencies":[{"code":"NPR","name":"Nepalese rupee","symbol":"\u20A8"}],"languages":[{"iso639_1":"ne","iso639_2":"nep","name":"Nepali","nativeName":"\u0928\u0947\u092A\u093E\u0932\u0940"}],"translations":{"br":"Nepal","pt":"Nepal","nl":"Nepal","hr":"Nepal","fa":"\u0646\u067E\u0627\u0644","de":"N\xe9pal","es":"Nepal","fr":"N\xe9pal","ja":"\u30CD\u30D1\u30FC\u30EB","it":"Nepal","hu":"Nep\xe1l"},"flag":"https://flagcdn.com/np.svg","regionalBlocs":[{"acronym":"SAARC","name":"South Asian Association for Regional Cooperation"}],"cioc":"NEP","independent":true},{"name":"Netherlands","topLevelDomain":[".nl"],"alpha2Code":"NL","alpha3Code":"NLD","callingCodes":["31"],"capital":"Amsterdam","altSpellings":["NL","Holland","Nederland"],"subregion":"Western Europe","region":"Europe","population":17441139,"latlng":[52.5,5.75],"demonym":"Dutch","area":41850,"gini":28.1,"timezones":["UTC-04:00","UTC+01:00"],"borders":["BEL","DEU"],"nativeName":"Nederland","numericCode":"528","flags":{"svg":"https://flagcdn.com/nl.svg","png":"https://flagcdn.com/w320/nl.png"},"currencies":[{"code":"EUR","name":"Euro","symbol":"\u20AC"}],"languages":[{"iso639_1":"nl","iso639_2":"nld","name":"Dutch","nativeName":"Nederlands"}],"translations":{"br":"Izelvroio\xf9","pt":"Pa\xedses Baixos","nl":"Nederland","hr":"Nizozemska","fa":"\u067E\u0627\u062F\u0634\u0627\u0647\u06CC \u0647\u0644\u0646\u062F","de":"Niederlande","es":"Pa\xedses Bajos","fr":"Pays-Bas","ja":"\u30AA\u30E9\u30F3\u30C0","it":"Paesi Bassi","hu":"Hollandia"},"flag":"https://flagcdn.com/nl.svg","regionalBlocs":[{"acronym":"EU","name":"European Union"}],"cioc":"NED","independent":true},{"name":"New Caledonia","topLevelDomain":[".nc"],"alpha2Code":"NC","alpha3Code":"NCL","callingCodes":["687"],"capital":"Noum\xe9a","altSpellings":["NC"],"subregion":"Melanesia","region":"Oceania","population":271960,"latlng":[-21.5,165.5],"demonym":"New Caledonian","area":18575,"timezones":["UTC+11:00"],"nativeName":"Nouvelle-Cal\xe9donie","numericCode":"540","flags":{"svg":"https://flagcdn.com/nc.svg","png":"https://flagcdn.com/w320/nc.png"},"currencies":[{"code":"XPF","name":"CFP franc","symbol":"Fr"}],"languages":[{"iso639_1":"fr","iso639_2":"fra","name":"French","nativeName":"fran\xe7ais"}],"translations":{"br":"Kaledonia-Nevez","pt":"Nova Caled\xf3nia","nl":"Nieuw-Caledoni\xeb","hr":"Nova Kaledonija","fa":"\u06A9\u0627\u0644\u062F\u0648\u0646\u06CC\u0627\u06CC \u062C\u062F\u06CC\u062F","de":"Neukaledonien","es":"Nueva Caledonia","fr":"Nouvelle-Cal\xe9donie","ja":"\u30CB\u30E5\u30FC\u30AB\u30EC\u30C9\u30CB\u30A2","it":"Nuova Caledonia","hu":"\xdaj-Kaled\xf3nia"},"flag":"https://flagcdn.com/nc.svg","independent":false},{"name":"New Zealand","topLevelDomain":[".nz"],"alpha2Code":"NZ","alpha3Code":"NZL","callingCodes":["64"],"capital":"Wellington","altSpellings":["NZ","Aotearoa"],"subregion":"Australia and New Zealand","region":"Oceania","population":5084300,"latlng":[-41,174],"demonym":"New Zealander","area":270467,"timezones":["UTC-11:00","UTC-10:00","UTC+12:00","UTC+12:45","UTC+13:00"],"nativeName":"New Zealand","numericCode":"554","flags":{"svg":"https://flagcdn.com/nz.svg","png":"https://flagcdn.com/w320/nz.png"},"currencies":[{"code":"NZD","name":"New Zealand dollar","symbol":"$"}],"languages":[{"iso639_1":"en","iso639_2":"eng","name":"English","nativeName":"English"},{"iso639_1":"mi","iso639_2":"mri","name":"M\u0101ori","nativeName":"te reo M\u0101ori"}],"translations":{"br":"Zeland-Nevez","pt":"Nova Zel\xe2ndia","nl":"Nieuw-Zeeland","hr":"Novi Zeland","fa":"\u0646\u06CC\u0648\u0632\u06CC\u0644\u0646\u062F","de":"Neuseeland","es":"Nueva Zelanda","fr":"Nouvelle-Z\xe9lande","ja":"\u30CB\u30E5\u30FC\u30B8\u30FC\u30E9\u30F3\u30C9","it":"Nuova Zelanda","hu":"\xdaj-Z\xe9land"},"flag":"https://flagcdn.com/nz.svg","cioc":"NZL","independent":true},{"name":"Nicaragua","topLevelDomain":[".ni"],"alpha2Code":"NI","alpha3Code":"NIC","callingCodes":["505"],"capital":"Managua","altSpellings":["NI","Republic of Nicaragua","Rep\xfablica de Nicaragua"],"subregion":"Central America","region":"Americas","population":6624554,"latlng":[13,-85],"demonym":"Nicaraguan","area":130373,"gini":46.2,"timezones":["UTC-06:00"],"borders":["CRI","HND"],"nativeName":"Nicaragua","numericCode":"558","flags":{"svg":"https://flagcdn.com/ni.svg","png":"https://flagcdn.com/w320/ni.png"},"currencies":[{"code":"NIO","name":"Nicaraguan c\xf3rdoba","symbol":"C$"}],"languages":[{"iso639_1":"es","iso639_2":"spa","name":"Spanish","nativeName":"Espa\xf1ol"}],"translations":{"br":"Nicaragua","pt":"Nicar\xe1gua","nl":"Nicaragua","hr":"Nikaragva","fa":"\u0646\u06CC\u06A9\u0627\u0631\u0627\u06AF\u0648\u0626\u0647","de":"Nicaragua","es":"Nicaragua","fr":"Nicaragua","ja":"\u30CB\u30AB\u30E9\u30B0\u30A2","it":"Nicaragua","hu":"Nicaragua"},"flag":"https://flagcdn.com/ni.svg","regionalBlocs":[{"acronym":"CAIS","name":"Central American Integration System","otherAcronyms":["SICA"],"otherNames":["Sistema de la Integraci\xf3n Centroamericana,"]}],"cioc":"NCA","independent":true},{"name":"Niger","topLevelDomain":[".ne"],"alpha2Code":"NE","alpha3Code":"NER","callingCodes":["227"],"capital":"Niamey","altSpellings":["NE","Nijar","Republic of Niger","R\xe9publique du Niger"],"subregion":"Western Africa","region":"Africa","population":24206636,"latlng":[16,8],"demonym":"Nigerien","area":1267000,"gini":34.3,"timezones":["UTC+01:00"],"borders":["DZA","BEN","BFA","TCD","LBY","MLI","NGA"],"nativeName":"Niger","numericCode":"562","flags":{"svg":"https://flagcdn.com/ne.svg","png":"https://flagcdn.com/w320/ne.png"},"currencies":[{"code":"XOF","name":"West African CFA franc","symbol":"Fr"}],"languages":[{"iso639_1":"fr","iso639_2":"fra","name":"French","nativeName":"fran\xe7ais"}],"translations":{"br":"Niger","pt":"N\xedger","nl":"Niger","hr":"Niger","fa":"\u0646\u06CC\u062C\u0631","de":"Niger","es":"N\xedger","fr":"Niger","ja":"\u30CB\u30B8\u30A7\u30FC\u30EB","it":"Niger","hu":"Niger"},"flag":"https://flagcdn.com/ne.svg","regionalBlocs":[{"acronym":"AU","name":"African Union","otherNames":["\u0627\u0644\u0627\u062A\u062D\u0627\u062F \u0627\u0644\u0623\u0641\u0631\u064A\u0642\u064A","Union africaine","Uni\xe3o Africana","Uni\xf3n Africana","Umoja wa Afrika"]}],"cioc":"NIG","independent":true},{"name":"Nigeria","topLevelDomain":[".ng"],"alpha2Code":"NG","alpha3Code":"NGA","callingCodes":["234"],"capital":"Abuja","altSpellings":["NG","Nijeriya","Na\xedj\xedr\xed\xe0","Federal Republic of Nigeria"],"subregion":"Western Africa","region":"Africa","population":206139587,"latlng":[10,8],"demonym":"Nigerian","area":923768,"gini":35.1,"timezones":["UTC+01:00"],"borders":["BEN","CMR","TCD","NER"],"nativeName":"Nigeria","numericCode":"566","flags":{"svg":"https://flagcdn.com/ng.svg","png":"https://flagcdn.com/w320/ng.png"},"currencies":[{"code":"NGN","name":"Nigerian naira","symbol":"\u20A6"}],"languages":[{"iso639_1":"en","iso639_2":"eng","name":"English","nativeName":"English"}],"translations":{"br":"Nigeria","pt":"Nig\xe9ria","nl":"Nigeria","hr":"Nigerija","fa":"\u0646\u06CC\u062C\u0631\u06CC\u0647","de":"Nigeria","es":"Nigeria","fr":"Nig\xe9ria","ja":"\u30CA\u30A4\u30B8\u30A7\u30EA\u30A2","it":"Nigeria","hu":"Nig\xe9ria"},"flag":"https://flagcdn.com/ng.svg","regionalBlocs":[{"acronym":"AU","name":"African Union","otherNames":["\u0627\u0644\u0627\u062A\u062D\u0627\u062F \u0627\u0644\u0623\u0641\u0631\u064A\u0642\u064A","Union africaine","Uni\xe3o Africana","Uni\xf3n Africana","Umoja wa Afrika"]}],"cioc":"NGR","independent":true},{"name":"Niue","topLevelDomain":[".nu"],"alpha2Code":"NU","alpha3Code":"NIU","callingCodes":["683"],"capital":"Alofi","altSpellings":["NU"],"subregion":"Polynesia","region":"Oceania","population":1470,"latlng":[-19.03333333,-169.86666666],"demonym":"Niuean","area":260,"timezones":["UTC-11:00"],"nativeName":"Niu\u0113","numericCode":"570","flags":{"svg":"https://flagcdn.com/nu.svg","png":"https://flagcdn.com/w320/nu.png"},"currencies":[{"code":"NZD","name":"New Zealand dollar","symbol":"$"},{"code":"NZD","name":"Niue dollar","symbol":"$"}],"languages":[{"iso639_1":"en","iso639_2":"eng","name":"English","nativeName":"English"}],"translations":{"br":"Niue","pt":"Niue","nl":"Niue","hr":"Niue","fa":"\u0646\u06CC\u0648\u0648\u06CC","de":"Niue","es":"Niue","fr":"Niue","ja":"\u30CB\u30A6\u30A8","it":"Niue","hu":"Niue"},"flag":"https://flagcdn.com/nu.svg","independent":true},{"name":"Norfolk Island","topLevelDomain":[".nf"],"alpha2Code":"NF","alpha3Code":"NFK","callingCodes":["672"],"capital":"Kingston","altSpellings":["NF","Territory of Norfolk Island","Teratri of Norf\'k Ailen"],"subregion":"Australia and New Zealand","region":"Oceania","population":2302,"latlng":[-29.03333333,167.95],"demonym":"Norfolk Islander","area":36,"timezones":["UTC+11:30"],"nativeName":"Norfolk Island","numericCode":"574","flags":{"svg":"https://flagcdn.com/nf.svg","png":"https://flagcdn.com/w320/nf.png"},"currencies":[{"code":"AUD","name":"Australian dollar","symbol":"$"}],"languages":[{"iso639_1":"en","iso639_2":"eng","name":"English","nativeName":"English"}],"translations":{"br":"Enez Norfolk","pt":"Ilha Norfolk","nl":"Norfolkeiland","hr":"Otok Norfolk","fa":"\u062C\u0632\u06CC\u0631\u0647 \u0646\u0648\u0631\u0641\u06A9","de":"Norfolkinsel","es":"Isla de Norfolk","fr":"\xcele de Norfolk","ja":"\u30CE\u30FC\u30D5\u30A9\u30FC\u30AF\u5CF6","it":"Isola Norfolk","hu":"Norfolk-sziget"},"flag":"https://flagcdn.com/nf.svg","independent":false},{"name":"Korea (Democratic People\'s Republic of)","topLevelDomain":[".kp"],"alpha2Code":"KP","alpha3Code":"PRK","callingCodes":["850"],"capital":"Pyongyang","altSpellings":["KP","Democratic People\'s Republic of Korea","\uC870\uC120\uBBFC\uC8FC\uC8FC\uC758\uC778\uBBFC\uACF5\uD654\uAD6D","Chos\u014Fn Minjuju\u016Di Inmin Konghwaguk"],"subregion":"Eastern Asia","region":"Asia","population":25778815,"latlng":[40,127],"demonym":"North Korean","area":120538,"timezones":["UTC+09:00"],"borders":["CHN","KOR","RUS"],"nativeName":"\uBD81\uD55C","numericCode":"408","flags":{"svg":"https://flagcdn.com/kp.svg","png":"https://flagcdn.com/w320/kp.png"},"currencies":[{"code":"KPW","name":"North Korean won","symbol":"\u20A9"}],"languages":[{"iso639_1":"ko","iso639_2":"kor","name":"Korean","nativeName":"\uD55C\uAD6D\uC5B4"}],"translations":{"br":"Korea an Norzh","pt":"Coreia do Norte","nl":"Noord-Korea","hr":"Sjeverna Koreja","fa":"\u06A9\u0631\u0647 \u062C\u0646\u0648\u0628\u06CC","de":"Nordkorea","es":"Corea del Norte","fr":"Cor\xe9e du Nord","ja":"\u671D\u9BAE\u6C11\u4E3B\u4E3B\u7FA9\u4EBA\u6C11\u5171\u548C\u56FD","it":"Corea del Nord","hu":"\xc9szak-Korea"},"flag":"https://flagcdn.com/kp.svg","cioc":"PRK","independent":true},{"name":"Northern Mariana Islands","topLevelDomain":[".mp"],"alpha2Code":"MP","alpha3Code":"MNP","callingCodes":["1"],"capital":"Saipan","altSpellings":["MP","Commonwealth of the Northern Mariana Islands","Sankattan Siha Na Islas Mari\xe5nas"],"subregion":"Micronesia","region":"Oceania","population":57557,"latlng":[15.2,145.75],"demonym":"American","area":464,"timezones":["UTC+10:00"],"nativeName":"Northern Mariana Islands","numericCode":"580","flags":{"svg":"https://flagcdn.com/mp.svg","png":"https://flagcdn.com/w320/mp.png"},"currencies":[{"code":"USD","name":"United States dollar","symbol":"$"}],"languages":[{"iso639_1":"en","iso639_2":"eng","name":"English","nativeName":"English"},{"iso639_1":"ch","iso639_2":"cha","name":"Chamorro","nativeName":"Chamoru"}],"translations":{"br":"Inizi Mariana an Norzh","pt":"Ilhas Marianas","nl":"Noordelijke Marianeneilanden","hr":"Sjevernomarijanski otoci","fa":"\u062C\u0632\u0627\u06CC\u0631 \u0645\u0627\u0631\u06CC\u0627\u0646\u0627\u06CC \u0634\u0645\u0627\u0644\u06CC","de":"N\xf6rdliche Marianen","es":"Islas Marianas del Norte","fr":"\xceles Mariannes du Nord","ja":"\u5317\u30DE\u30EA\u30A2\u30CA\u8AF8\u5CF6","it":"Isole Marianne Settentrionali","hu":"\xc9szaki-Mariana-szigetek"},"flag":"https://flagcdn.com/mp.svg","independent":false},{"name":"Norway","topLevelDomain":[".no"],"alpha2Code":"NO","alpha3Code":"NOR","callingCodes":["47"],"capital":"Oslo","altSpellings":["NO","Norge","Noreg","Kingdom of Norway","Kongeriket Norge","Kongeriket Noreg"],"subregion":"Northern Europe","region":"Europe","population":5379475,"latlng":[62,10],"demonym":"Norwegian","area":323802,"gini":27.6,"timezones":["UTC+01:00"],"borders":["FIN","SWE","RUS"],"nativeName":"Norge","numericCode":"578","flags":{"svg":"https://flagcdn.com/no.svg","png":"https://flagcdn.com/w320/no.png"},"currencies":[{"code":"NOK","name":"Norwegian krone","symbol":"kr"}],"languages":[{"iso639_1":"no","iso639_2":"nor","name":"Norwegian","nativeName":"Norsk"},{"iso639_1":"nb","iso639_2":"nob","name":"Norwegian Bokm\xe5l","nativeName":"Norsk bokm\xe5l"},{"iso639_1":"nn","iso639_2":"nno","name":"Norwegian Nynorsk","nativeName":"Norsk nynorsk"}],"translations":{"br":"Norvegia","pt":"Noruega","nl":"Noorwegen","hr":"Norve\u0161ka","fa":"\u0646\u0631\u0648\u0698","de":"Norwegen","es":"Noruega","fr":"Norv\xe8ge","ja":"\u30CE\u30EB\u30A6\u30A7\u30FC","it":"Norvegia","hu":"Norv\xe9gia"},"flag":"https://flagcdn.com/no.svg","regionalBlocs":[{"acronym":"EFTA","name":"European Free Trade Association"}],"cioc":"NOR","independent":true},{"name":"Oman","topLevelDomain":[".om"],"alpha2Code":"OM","alpha3Code":"OMN","callingCodes":["968"],"capital":"Muscat","altSpellings":["OM","Sultanate of Oman","Sal\u1E6Danat \u02BBUm\u0101n"],"subregion":"Western Asia","region":"Asia","population":5106622,"latlng":[21,57],"demonym":"Omani","area":309500,"timezones":["UTC+04:00"],"borders":["SAU","ARE","YEM"],"nativeName":"\u0639\u0645\u0627\u0646","numericCode":"512","flags":{"svg":"https://flagcdn.com/om.svg","png":"https://flagcdn.com/w320/om.png"},"currencies":[{"code":"OMR","name":"Omani rial","symbol":"\u0631.\u0639."}],"languages":[{"iso639_1":"ar","iso639_2":"ara","name":"Arabic","nativeName":"\u0627\u0644\u0639\u0631\u0628\u064A\u0629"}],"translations":{"br":"Oman","pt":"Om\xe3","nl":"Oman","hr":"Oman","fa":"\u0639\u0645\u0627\u0646","de":"Oman","es":"Om\xe1n","fr":"Oman","ja":"\u30AA\u30DE\u30FC\u30F3","it":"oman","hu":"Om\xe1n"},"flag":"https://flagcdn.com/om.svg","regionalBlocs":[{"acronym":"AL","name":"Arab League","otherNames":["\u062C\u0627\u0645\u0639\u0629 \u0627\u0644\u062F\u0648\u0644 \u0627\u0644\u0639\u0631\u0628\u064A\u0629","J\u0101mi\u02BBat ad-Duwal al-\u02BBArab\u012Byah","League of Arab States"]}],"cioc":"OMA","independent":true},{"name":"Pakistan","topLevelDomain":[".pk"],"alpha2Code":"PK","alpha3Code":"PAK","callingCodes":["92"],"capital":"Islamabad","altSpellings":["PK","P\u0101kist\u0101n","Islamic Republic of Pakistan","Isl\u0101m\u012B Jumh\u016Briya\'eh P\u0101kist\u0101n"],"subregion":"Southern Asia","region":"Asia","population":220892331,"latlng":[30,70],"demonym":"Pakistani","area":881912,"gini":31.6,"timezones":["UTC+05:00"],"borders":["AFG","CHN","IND","IRN"],"nativeName":"Pakistan","numericCode":"586","flags":{"svg":"https://flagcdn.com/pk.svg","png":"https://flagcdn.com/w320/pk.png"},"currencies":[{"code":"PKR","name":"Pakistani rupee","symbol":"\u20A8"}],"languages":[{"iso639_1":"ur","iso639_2":"urd","name":"Urdu","nativeName":"\u0627\u0631\u062F\u0648"},{"iso639_1":"en","iso639_2":"eng","name":"English","nativeName":"English"}],"translations":{"br":"Pakistan","pt":"Paquist\xe3o","nl":"Pakistan","hr":"Pakistan","fa":"\u067E\u0627\u06A9\u0633\u062A\u0627\u0646","de":"Pakistan","es":"Pakist\xe1n","fr":"Pakistan","ja":"\u30D1\u30AD\u30B9\u30BF\u30F3","it":"Pakistan","hu":"Pakiszt\xe1n"},"flag":"https://flagcdn.com/pk.svg","regionalBlocs":[{"acronym":"SAARC","name":"South Asian Association for Regional Cooperation"}],"cioc":"PAK","independent":true},{"name":"Palau","topLevelDomain":[".pw"],"alpha2Code":"PW","alpha3Code":"PLW","callingCodes":["680"],"capital":"Ngerulmud","altSpellings":["PW","Republic of Palau","Beluu er a Belau"],"subregion":"Micronesia","region":"Oceania","population":18092,"latlng":[7.5,134.5],"demonym":"Palauan","area":459,"timezones":["UTC+09:00"],"nativeName":"Palau","numericCode":"585","flags":{"svg":"https://flagcdn.com/pw.svg","png":"https://flagcdn.com/w320/pw.png"},"currencies":[{"code":"USD","name":"United States dollar","symbol":"$"}],"languages":[{"iso639_1":"en","iso639_2":"eng","name":"English","nativeName":"English"}],"translations":{"br":"Palau","pt":"Palau","nl":"Palau","hr":"Palau","fa":"\u067E\u0627\u0644\u0627\u0626\u0648","de":"Palau","es":"Palau","fr":"Palaos","ja":"\u30D1\u30E9\u30AA","it":"Palau","hu":"Palau"},"flag":"https://flagcdn.com/pw.svg","cioc":"PLW","independent":true},{"name":"Palestine, State of","topLevelDomain":[".ps"],"alpha2Code":"PS","alpha3Code":"PSE","callingCodes":["970"],"capital":"Ramallah","altSpellings":["PS","State of Palestine","Dawlat Filas\u1E6Din"],"subregion":"Western Asia","region":"Asia","population":4803269,"latlng":[31.9,35.2],"demonym":"Palestinian","gini":33.7,"timezones":["UTC+02:00"],"borders":["ISR","EGY","JOR"],"nativeName":"\u0641\u0644\u0633\u0637\u064A\u0646","numericCode":"275","flags":{"svg":"https://flagcdn.com/ps.svg","png":"https://flagcdn.com/w320/ps.png"},"currencies":[{"code":"EGP","name":"Egyptian pound","symbol":"E\xa3"},{"code":"ILS","name":"Israeli new shekel","symbol":"\u20AA"},{"code":"JOD","name":"Jordanian dinar","symbol":"\u062F.\u0623"}],"languages":[{"iso639_1":"ar","iso639_2":"ara","name":"Arabic","nativeName":"\u0627\u0644\u0639\u0631\u0628\u064A\u0629"}],"translations":{"br":"Palestina","pt":"Palestina","nl":"Palestijnse gebieden","hr":"Palestina","fa":"\u0641\u0644\u0633\u0637\u06CC\u0646","de":"Pal\xe4stina","es":"Palestina","fr":"Palestine","ja":"\u30D1\u30EC\u30B9\u30C1\u30CA","it":"Palestina","hu":"Palesztina"},"flag":"https://flagcdn.com/ps.svg","regionalBlocs":[{"acronym":"AL","name":"Arab League","otherNames":["\u062C\u0627\u0645\u0639\u0629 \u0627\u0644\u062F\u0648\u0644 \u0627\u0644\u0639\u0631\u0628\u064A\u0629","J\u0101mi\u02BBat ad-Duwal al-\u02BBArab\u012Byah","League of Arab States"]}],"cioc":"PLE","independent":true},{"name":"Panama","topLevelDomain":[".pa"],"alpha2Code":"PA","alpha3Code":"PAN","callingCodes":["507"],"capital":"Panama City","altSpellings":["PA","Republic of Panama","Rep\xfablica de Panam\xe1"],"subregion":"Central America","region":"Americas","population":4314768,"latlng":[9,-80],"demonym":"Panamanian","area":75417,"gini":49.8,"timezones":["UTC-05:00"],"borders":["COL","CRI"],"nativeName":"Panam\xe1","numericCode":"591","flags":{"svg":"https://flagcdn.com/pa.svg","png":"https://flagcdn.com/w320/pa.png"},"currencies":[{"code":"PAB","name":"Panamanian balboa","symbol":"B/."},{"code":"USD","name":"United States dollar","symbol":"$"}],"languages":[{"iso639_1":"es","iso639_2":"spa","name":"Spanish","nativeName":"Espa\xf1ol"}],"translations":{"br":"Panama","pt":"Panam\xe1","nl":"Panama","hr":"Panama","fa":"\u067E\u0627\u0646\u0627\u0645\u0627","de":"Panama","es":"Panam\xe1","fr":"Panama","ja":"\u30D1\u30CA\u30DE","it":"Panama","hu":"Panama"},"flag":"https://flagcdn.com/pa.svg","regionalBlocs":[{"acronym":"CAIS","name":"Central American Integration System","otherAcronyms":["SICA"],"otherNames":["Sistema de la Integraci\xf3n Centroamericana,"]}],"cioc":"PAN","independent":true},{"name":"Papua New Guinea","topLevelDomain":[".pg"],"alpha2Code":"PG","alpha3Code":"PNG","callingCodes":["675"],"capital":"Port Moresby","altSpellings":["PG","Independent State of Papua New Guinea","Independen Stet bilong Papua Niugini"],"subregion":"Melanesia","region":"Oceania","population":8947027,"latlng":[-6,147],"demonym":"Papua New Guinean","area":462840,"gini":41.9,"timezones":["UTC+10:00"],"borders":["IDN"],"nativeName":"Papua Niugini","numericCode":"598","flags":{"svg":"https://flagcdn.com/pg.svg","png":"https://flagcdn.com/w320/pg.png"},"currencies":[{"code":"PGK","name":"Papua New Guinean kina","symbol":"K"}],"languages":[{"iso639_1":"en","iso639_2":"eng","name":"English","nativeName":"English"}],"translations":{"br":"Papoua-Ginea Nevez","pt":"Papua Nova Guin\xe9","nl":"Papoea-Nieuw-Guinea","hr":"Papua Nova Gvineja","fa":"\u067E\u0627\u067E\u0648\u0622 \u06AF\u06CC\u0646\u0647 \u0646\u0648","de":"Papua-Neuguinea","es":"Pap\xfaa Nueva Guinea","fr":"Papouasie-Nouvelle-Guin\xe9e","ja":"\u30D1\u30D7\u30A2\u30CB\u30E5\u30FC\u30AE\u30CB\u30A2","it":"Papua Nuova Guinea","hu":"P\xe1pua \xdaj-Guinea"},"flag":"https://flagcdn.com/pg.svg","cioc":"PNG","independent":true},{"name":"Paraguay","topLevelDomain":[".py"],"alpha2Code":"PY","alpha3Code":"PRY","callingCodes":["595"],"capital":"Asunci\xf3n","altSpellings":["PY","Republic of Paraguay","Rep\xfablica del Paraguay","Tet\xe3 Paragu\xe1i"],"subregion":"South America","region":"Americas","population":7132530,"latlng":[-23,-58],"demonym":"Paraguayan","area":406752,"gini":45.7,"timezones":["UTC-04:00"],"borders":["ARG","BOL","BRA"],"nativeName":"Paraguay","numericCode":"600","flags":{"svg":"https://flagcdn.com/py.svg","png":"https://flagcdn.com/w320/py.png"},"currencies":[{"code":"PYG","name":"Paraguayan guaran\xed","symbol":"\u20B2"}],"languages":[{"iso639_1":"es","iso639_2":"spa","name":"Spanish","nativeName":"Espa\xf1ol"},{"iso639_1":"gn","iso639_2":"grn","name":"Guaran\xed","nativeName":"Ava\xf1e\'\u1EBD"}],"translations":{"br":"Paraguay","pt":"Paraguai","nl":"Paraguay","hr":"Paragvaj","fa":"\u067E\u0627\u0631\u0627\u06AF\u0648\u0626\u0647","de":"Paraguay","es":"Paraguay","fr":"Paraguay","ja":"\u30D1\u30E9\u30B0\u30A2\u30A4","it":"Paraguay","hu":"Paraguay"},"flag":"https://flagcdn.com/py.svg","regionalBlocs":[{"acronym":"USAN","name":"Union of South American Nations","otherAcronyms":["UNASUR","UNASUL","UZAN"],"otherNames":["Uni\xf3n de Naciones Suramericanas","Uni\xe3o de Na\xe7\xf5es Sul-Americanas","Unie van Zuid-Amerikaanse Naties","South American Union"]}],"cioc":"PAR","independent":true},{"name":"Peru","topLevelDomain":[".pe"],"alpha2Code":"PE","alpha3Code":"PER","callingCodes":["51"],"capital":"Lima","altSpellings":["PE","Republic of Peru"," Rep\xfablica del Per\xfa"],"subregion":"South America","region":"Americas","population":32971846,"latlng":[-10,-76],"demonym":"Peruvian","area":1285216,"gini":41.5,"timezones":["UTC-05:00"],"borders":["BOL","BRA","CHL","COL","ECU"],"nativeName":"Per\xfa","numericCode":"604","flags":{"svg":"https://flagcdn.com/pe.svg","png":"https://flagcdn.com/w320/pe.png"},"currencies":[{"code":"PEN","name":"Peruvian sol","symbol":"S/."}],"languages":[{"iso639_1":"es","iso639_2":"spa","name":"Spanish","nativeName":"Espa\xf1ol"}],"translations":{"br":"Perou","pt":"Peru","nl":"Peru","hr":"Peru","fa":"\u067E\u0631\u0648","de":"Peru","es":"Per\xfa","fr":"P\xe9rou","ja":"\u30DA\u30EB\u30FC","it":"Per\xf9","hu":"Peru"},"flag":"https://flagcdn.com/pe.svg","regionalBlocs":[{"acronym":"PA","name":"Pacific Alliance","otherNames":["Alianza del Pac\xedfico"]},{"acronym":"USAN","name":"Union of South American Nations","otherAcronyms":["UNASUR","UNASUL","UZAN"],"otherNames":["Uni\xf3n de Naciones Suramericanas","Uni\xe3o de Na\xe7\xf5es Sul-Americanas","Unie van Zuid-Amerikaanse Naties","South American Union"]}],"cioc":"PER","independent":true},{"name":"Philippines","topLevelDomain":[".ph"],"alpha2Code":"PH","alpha3Code":"PHL","callingCodes":["63"],"capital":"Manila","altSpellings":["PH","Republic of the Philippines","Rep\xfablika ng Pilipinas"],"subregion":"South-Eastern Asia","region":"Asia","population":109581085,"latlng":[13,122],"demonym":"Filipino","area":342353,"gini":42.3,"timezones":["UTC+08:00"],"nativeName":"Pilipinas","numericCode":"608","flags":{"svg":"https://flagcdn.com/ph.svg","png":"https://flagcdn.com/w320/ph.png"},"currencies":[{"code":"PHP","name":"Philippine peso","symbol":"\u20B1"}],"languages":[{"iso639_1":"en","iso639_2":"eng","name":"English","nativeName":"English"}],"translations":{"br":"Filipinez","pt":"Filipinas","nl":"Filipijnen","hr":"Filipini","fa":"\u062C\u0632\u0627\u06CC\u0631 \u0627\u0644\u0646\u062F\u0641\u06CC\u0644\u06CC\u067E\u06CC\u0646","de":"Philippinen","es":"Filipinas","fr":"Philippines","ja":"\u30D5\u30A3\u30EA\u30D4\u30F3","it":"Filippine","hu":"F\xfcl\xf6p-szigetek"},"flag":"https://flagcdn.com/ph.svg","regionalBlocs":[{"acronym":"ASEAN","name":"Association of Southeast Asian Nations"}],"cioc":"PHI","independent":true},{"name":"Pitcairn","topLevelDomain":[".pn"],"alpha2Code":"PN","alpha3Code":"PCN","callingCodes":["64"],"capital":"Adamstown","altSpellings":["PN","Pitcairn Henderson Ducie and Oeno Islands"],"subregion":"Polynesia","region":"Oceania","population":56,"latlng":[-25.06666666,-130.1],"demonym":"Pitcairn Islander","area":47,"timezones":["UTC-08:00"],"nativeName":"Pitcairn Islands","numericCode":"612","flags":{"svg":"https://flagcdn.com/pn.svg","png":"https://flagcdn.com/w320/pn.png"},"currencies":[{"code":"NZD","name":"New Zealand dollar","symbol":"$"},{"code":"PND","name":"Pitcairn Islands dollar","symbol":"$"}],"languages":[{"iso639_1":"en","iso639_2":"eng","name":"English","nativeName":"English"}],"translations":{"br":"Inizi Pitcairn","pt":"Ilhas Pic\xe1rnia","nl":"Pitcairneilanden","hr":"Pitcairnovo oto\u010Dje","fa":"\u067E\u06CC\u062A\u06A9\u0631\u0646","de":"Pitcairn","es":"Islas Pitcairn","fr":"\xceles Pitcairn","ja":"\u30D4\u30C8\u30B1\u30A2\u30F3","it":"Isole Pitcairn","hu":"Pitcairn-szigetek"},"flag":"https://flagcdn.com/pn.svg","independent":true},{"name":"Poland","topLevelDomain":[".pl"],"alpha2Code":"PL","alpha3Code":"POL","callingCodes":["48"],"capital":"Warsaw","altSpellings":["PL","Republic of Poland","Rzeczpospolita Polska"],"subregion":"Central Europe","region":"Europe","population":37950802,"latlng":[52,20],"demonym":"Polish","area":312679,"gini":30.2,"timezones":["UTC+01:00"],"borders":["BLR","CZE","DEU","LTU","RUS","SVK","UKR"],"nativeName":"Polska","numericCode":"616","flags":{"svg":"https://flagcdn.com/pl.svg","png":"https://flagcdn.com/w320/pl.png"},"currencies":[{"code":"PLN","name":"Polish z\u0142oty","symbol":"z\u0142"}],"languages":[{"iso639_1":"pl","iso639_2":"pol","name":"Polish","nativeName":"j\u0119zyk polski"}],"translations":{"br":"Polonia","pt":"Pol\xf3nia","nl":"Polen","hr":"Poljska","fa":"\u0644\u0647\u0633\u062A\u0627\u0646","de":"Polen","es":"Polonia","fr":"Pologne","ja":"\u30DD\u30FC\u30E9\u30F3\u30C9","it":"Polonia","hu":"Lengyelorsz\xe1g"},"flag":"https://flagcdn.com/pl.svg","regionalBlocs":[{"acronym":"EU","name":"European Union"}],"cioc":"POL","independent":true},{"name":"Portugal","topLevelDomain":[".pt"],"alpha2Code":"PT","alpha3Code":"PRT","callingCodes":["351"],"capital":"Lisbon","altSpellings":["PT","Portuguesa","Portuguese Republic","Rep\xfablica Portuguesa"],"subregion":"Southern Europe","region":"Europe","population":10305564,"latlng":[39.5,-8],"demonym":"Portuguese","area":92090,"gini":33.5,"timezones":["UTC-01:00","UTC"],"borders":["ESP"],"nativeName":"Portugal","numericCode":"620","flags":{"svg":"https://flagcdn.com/pt.svg","png":"https://flagcdn.com/w320/pt.png"},"currencies":[{"code":"EUR","name":"Euro","symbol":"\u20AC"}],"languages":[{"iso639_1":"pt","iso639_2":"por","name":"Portuguese","nativeName":"Portugu\xeas"}],"translations":{"br":"Portugal","pt":"Portugal","nl":"Portugal","hr":"Portugal","fa":"\u067E\u0631\u062A\u063A\u0627\u0644","de":"Portugal","es":"Portugal","fr":"Portugal","ja":"\u30DD\u30EB\u30C8\u30AC\u30EB","it":"Portogallo","hu":"Portug\xe1lia"},"flag":"https://flagcdn.com/pt.svg","regionalBlocs":[{"acronym":"EU","name":"European Union"}],"cioc":"POR","independent":true},{"name":"Puerto Rico","topLevelDomain":[".pr"],"alpha2Code":"PR","alpha3Code":"PRI","callingCodes":["1"],"capital":"San Juan","altSpellings":["PR","Commonwealth of Puerto Rico","Estado Libre Asociado de Puerto Rico"],"subregion":"Caribbean","region":"Americas","population":3194034,"latlng":[18.25,-66.5],"demonym":"Puerto Rican","area":8870,"timezones":["UTC-04:00"],"nativeName":"Puerto Rico","numericCode":"630","flags":{"svg":"https://flagcdn.com/pr.svg","png":"https://flagcdn.com/w320/pr.png"},"currencies":[{"code":"USD","name":"United States dollar","symbol":"$"}],"languages":[{"iso639_1":"es","iso639_2":"spa","name":"Spanish","nativeName":"Espa\xf1ol"},{"iso639_1":"en","iso639_2":"eng","name":"English","nativeName":"English"}],"translations":{"br":"Puerto Rico","pt":"Porto Rico","nl":"Puerto Rico","hr":"Portoriko","fa":"\u067E\u0648\u0631\u062A\u0648 \u0631\u06CC\u06A9\u0648","de":"Puerto Rico","es":"Puerto Rico","fr":"Porto Rico","ja":"\u30D7\u30A8\u30EB\u30C8\u30EA\u30B3","it":"Porto Rico","hu":"Puerto Rico"},"flag":"https://flagcdn.com/pr.svg","cioc":"PUR","independent":false},{"name":"Qatar","topLevelDomain":[".qa"],"alpha2Code":"QA","alpha3Code":"QAT","callingCodes":["974"],"capital":"Doha","altSpellings":["QA","State of Qatar","Dawlat Qa\u1E6Dar"],"subregion":"Western Asia","region":"Asia","population":2881060,"latlng":[25.5,51.25],"demonym":"Qatari","area":11586,"timezones":["UTC+03:00"],"borders":["SAU"],"nativeName":"\u0642\u0637\u0631","numericCode":"634","flags":{"svg":"https://flagcdn.com/qa.svg","png":"https://flagcdn.com/w320/qa.png"},"currencies":[{"code":"QAR","name":"Qatari riyal","symbol":"\u0631.\u0642"}],"languages":[{"iso639_1":"ar","iso639_2":"ara","name":"Arabic","nativeName":"\u0627\u0644\u0639\u0631\u0628\u064A\u0629"}],"translations":{"br":"Katar","pt":"Catar","nl":"Qatar","hr":"Katar","fa":"\u0642\u0637\u0631","de":"Katar","es":"Catar","fr":"Qatar","ja":"\u30AB\u30BF\u30FC\u30EB","it":"Qatar","hu":"Katar"},"flag":"https://flagcdn.com/qa.svg","regionalBlocs":[{"acronym":"AL","name":"Arab League","otherNames":["\u062C\u0627\u0645\u0639\u0629 \u0627\u0644\u062F\u0648\u0644 \u0627\u0644\u0639\u0631\u0628\u064A\u0629","J\u0101mi\u02BBat ad-Duwal al-\u02BBArab\u012Byah","League of Arab States"]}],"cioc":"QAT","independent":true},{"name":"Republic of Kosovo","topLevelDomain":[""],"alpha2Code":"XK","alpha3Code":"UNK","callingCodes":["383"],"capital":"Pristina","altSpellings":["XK","\u0420\u0435\u043F\u0443\u0431\u043B\u0438\u043A\u0430 \u041A\u043E\u0441\u043E\u0432\u043E"],"subregion":"Eastern Europe","region":"Europe","population":1775378,"latlng":[42.666667,21.166667],"demonym":"Kosovar","area":10908,"gini":29,"timezones":["UTC+01:00"],"borders":["ALB","MKD","MNE","SRB"],"nativeName":"Republika e Kosov\xebs","numericCode":"926","flags":{"svg":"https://flagcdn.com/xk.svg","png":"https://flagcdn.com/w320/xk.png"},"currencies":[{"code":"EUR","name":"Euro","symbol":"\u20AC"}],"languages":[{"iso639_1":"sq","iso639_2":"sqi","name":"Albanian","nativeName":"Shqip"},{"iso639_1":"sr","iso639_2":"srp","name":"Serbian","nativeName":"\u0441\u0440\u043F\u0441\u043A\u0438 \u0458\u0435\u0437\u0438\u043A"}],"translations":{"br":"Kosovo","pt":"Kosovo","nl":"Republiek van Kosovo","hr":"Kosovo","fa":"\u06A9\u0648\u0632\u0648\u0648","de":"Republic of Kosovo","es":"Kosovo","fr":"Kosovo","ja":"Republic of Kosovo","it":"Republic of Kosovo","hu":"Koszov\xf3"},"flag":"https://flagcdn.com/xk.svg","regionalBlocs":[{"acronym":"CEFTA","name":"Central European Free Trade Agreement"}],"independent":true},{"name":"R\xe9union","topLevelDomain":[".re"],"alpha2Code":"RE","alpha3Code":"REU","callingCodes":["262"],"capital":"Saint-Denis","altSpellings":["RE","Reunion"],"subregion":"Eastern Africa","region":"Africa","population":840974,"latlng":[-21.15,55.5],"demonym":"French","timezones":["UTC+04:00"],"nativeName":"La R\xe9union","numericCode":"638","flags":{"svg":"https://flagcdn.com/re.svg","png":"https://flagcdn.com/w320/re.png"},"currencies":[{"code":"EUR","name":"Euro","symbol":"\u20AC"}],"languages":[{"iso639_1":"fr","iso639_2":"fra","name":"French","nativeName":"fran\xe7ais"}],"translations":{"br":"Re\xfcnion","pt":"Reuni\xe3o","nl":"R\xe9union","hr":"R\xe9union","fa":"\u0631\u0626\u0648\u0646\u06CC\u0648\u0646","de":"R\xe9union","es":"Reuni\xf3n","fr":"R\xe9union","ja":"\u30EC\u30E6\u30CB\u30AA\u30F3","it":"Riunione","hu":"R\xe9union"},"flag":"https://flagcdn.com/re.svg","regionalBlocs":[{"acronym":"AU","name":"African Union","otherNames":["\u0627\u0644\u0627\u062A\u062D\u0627\u062F \u0627\u0644\u0623\u0641\u0631\u064A\u0642\u064A","Union africaine","Uni\xe3o Africana","Uni\xf3n Africana","Umoja wa Afrika"]}],"independent":false},{"name":"Romania","topLevelDomain":[".ro"],"alpha2Code":"RO","alpha3Code":"ROU","callingCodes":["40"],"capital":"Bucharest","altSpellings":["RO","Rumania","Roumania","Rom\xe2nia"],"subregion":"Eastern Europe","region":"Europe","population":19286123,"latlng":[46,25],"demonym":"Romanian","area":238391,"gini":35.8,"timezones":["UTC+02:00"],"borders":["BGR","HUN","MDA","SRB","UKR"],"nativeName":"Rom\xe2nia","numericCode":"642","flags":{"svg":"https://flagcdn.com/ro.svg","png":"https://flagcdn.com/w320/ro.png"},"currencies":[{"code":"RON","name":"Romanian leu","symbol":"lei"}],"languages":[{"iso639_1":"ro","iso639_2":"ron","name":"Romanian","nativeName":"Rom\xe2n\u0103"}],"translations":{"br":"Roumania","pt":"Rom\xe9nia","nl":"Roemeni\xeb","hr":"Rumunjska","fa":"\u0631\u0648\u0645\u0627\u0646\u06CC","de":"Rum\xe4nien","es":"Rumania","fr":"Roumanie","ja":"\u30EB\u30FC\u30DE\u30CB\u30A2","it":"Romania","hu":"Rom\xe1nia"},"flag":"https://flagcdn.com/ro.svg","regionalBlocs":[{"acronym":"EU","name":"European Union"}],"cioc":"ROU","independent":true},{"name":"Russian Federation","topLevelDomain":[".ru"],"alpha2Code":"RU","alpha3Code":"RUS","callingCodes":["7"],"capital":"Moscow","altSpellings":["RU","Rossiya","Russian Federation","\u0420\u043E\u0441\u0441\u0438\u0439\u0441\u043A\u0430\u044F \u0424\u0435\u0434\u0435\u0440\u0430\u0446\u0438\u044F","Rossiyskaya Federatsiya"],"subregion":"Eastern Europe","region":"Europe","population":144104080,"latlng":[60,100],"demonym":"Russian","area":17124442,"gini":37.5,"timezones":["UTC+03:00","UTC+04:00","UTC+06:00","UTC+07:00","UTC+08:00","UTC+09:00","UTC+10:00","UTC+11:00","UTC+12:00"],"borders":["AZE","BLR","CHN","EST","FIN","GEO","KAZ","PRK","LVA","LTU","MNG","NOR","POL","UKR"],"nativeName":"\u0420\u043E\u0441\u0441\u0438\u044F","numericCode":"643","flags":{"svg":"https://flagcdn.com/ru.svg","png":"https://flagcdn.com/w320/ru.png"},"currencies":[{"code":"RUB","name":"Russian ruble","symbol":"\u20BD"}],"languages":[{"iso639_1":"ru","iso639_2":"rus","name":"Russian","nativeName":"\u0420\u0443\u0441\u0441\u043A\u0438\u0439"}],"translations":{"br":"Rusia","pt":"R\xfassia","nl":"Rusland","hr":"Rusija","fa":"\u0631\u0648\u0633\u06CC\u0647","de":"Russland","es":"Rusia","fr":"Russie","ja":"\u30ED\u30B7\u30A2\u9023\u90A6","it":"Russia","hu":"Oroszorsz\xe1g"},"flag":"https://flagcdn.com/ru.svg","regionalBlocs":[{"acronym":"EEU","name":"Eurasian Economic Union","otherAcronyms":["EAEU"]}],"cioc":"RUS","independent":true},{"name":"Rwanda","topLevelDomain":[".rw"],"alpha2Code":"RW","alpha3Code":"RWA","callingCodes":["250"],"capital":"Kigali","altSpellings":["RW","Republic of Rwanda","Repubulika y\'u Rwanda","R\xe9publique du Rwanda"],"subregion":"Eastern Africa","region":"Africa","population":12952209,"latlng":[-2,30],"demonym":"Rwandan","area":26338,"gini":43.7,"timezones":["UTC+02:00"],"borders":["BDI","COD","TZA","UGA"],"nativeName":"Rwanda","numericCode":"646","flags":{"svg":"https://flagcdn.com/rw.svg","png":"https://flagcdn.com/w320/rw.png"},"currencies":[{"code":"RWF","name":"Rwandan franc","symbol":"Fr"}],"languages":[{"iso639_1":"rw","iso639_2":"kin","name":"Kinyarwanda","nativeName":"Ikinyarwanda"},{"iso639_1":"en","iso639_2":"eng","name":"English","nativeName":"English"},{"iso639_1":"fr","iso639_2":"fra","name":"French","nativeName":"fran\xe7ais"}],"translations":{"br":"Rwanda","pt":"Ruanda","nl":"Rwanda","hr":"Ruanda","fa":"\u0631\u0648\u0627\u0646\u062F\u0627","de":"Ruanda","es":"Ruanda","fr":"Rwanda","ja":"\u30EB\u30EF\u30F3\u30C0","it":"Ruanda","hu":"Ruanda"},"flag":"https://flagcdn.com/rw.svg","regionalBlocs":[{"acronym":"AU","name":"African Union","otherNames":["\u0627\u0644\u0627\u062A\u062D\u0627\u062F \u0627\u0644\u0623\u0641\u0631\u064A\u0642\u064A","Union africaine","Uni\xe3o Africana","Uni\xf3n Africana","Umoja wa Afrika"]}],"cioc":"RWA","independent":true},{"name":"Saint Barth\xe9lemy","topLevelDomain":[".bl"],"alpha2Code":"BL","alpha3Code":"BLM","callingCodes":["590"],"capital":"Gustavia","altSpellings":["BL","St. Barthelemy","Collectivity of Saint Barth\xe9lemy","Collectivit\xe9 de Saint-Barth\xe9lemy"],"subregion":"Caribbean","region":"Americas","population":9417,"latlng":[18.5,-63.41666666],"demonym":"Saint Barth\xe9lemy Islander","area":21,"timezones":["UTC-04:00"],"nativeName":"Saint-Barth\xe9lemy","numericCode":"652","flags":{"svg":"https://flagcdn.com/bl.svg","png":"https://flagcdn.com/w320/bl.png"},"currencies":[{"code":"EUR","name":"Euro","symbol":"\u20AC"}],"languages":[{"iso639_1":"fr","iso639_2":"fra","name":"French","nativeName":"fran\xe7ais"}],"translations":{"br":"Saint-Barth\xe9lemy","pt":"S\xe3o Bartolomeu","nl":"Saint Barth\xe9lemy","hr":"Saint Barth\xe9lemy","fa":"\u0633\u0646-\u0628\u0627\u0631\u062A\u0644\u0645\u06CC","de":"Saint-Barth\xe9lemy","es":"San Bartolom\xe9","fr":"Saint-Barth\xe9lemy","ja":"\u30B5\u30F3\u30FB\u30D0\u30EB\u30C6\u30EB\u30DF\u30FC","it":"Antille Francesi","hu":"Saint-Barth\xe9lemy"},"flag":"https://flagcdn.com/bl.svg","independent":false},{"name":"Saint Helena, Ascension and Tristan da Cunha","topLevelDomain":[".sh"],"alpha2Code":"SH","alpha3Code":"SHN","callingCodes":["290"],"capital":"Jamestown","altSpellings":["SH"],"subregion":"Western Africa","region":"Africa","population":4255,"latlng":[-15.95,-5.7],"demonym":"Saint Helenian","timezones":["UTC+00:00"],"nativeName":"Saint Helena","numericCode":"654","flags":{"svg":"https://flagcdn.com/sh.svg","png":"https://flagcdn.com/w320/sh.png"},"currencies":[{"code":"SHP","name":"Saint Helena pound","symbol":"\xa3"}],"languages":[{"iso639_1":"en","iso639_2":"eng","name":"English","nativeName":"English"}],"translations":{"br":"Saint Helena, Ascension ha Tristan da Cunha","pt":"Santa Helena","nl":"Sint-Helena","hr":"Sveta Helena","fa":"\u0633\u0646\u062A \u0647\u0644\u0646\u0627\u060C \u0627\u0633\u0646\u0634\u0646 \u0648 \u062A\u0631\u06CC\u0633\u062A\u0627\u0646 \u062F\u0627 \u06A9\u0648\u0646\u0627","de":"Sankt Helena","es":"Santa Helena","fr":"Sainte-H\xe9l\xe8ne","ja":"\u30BB\u30F3\u30C8\u30D8\u30EC\u30CA\u30FB\u30A2\u30BB\u30F3\u30B7\u30E7\u30F3\u304A\u3088\u3073\u30C8\u30EA\u30B9\u30BF\u30F3\u30C0\u30AF\u30FC\u30CB\u30E3","it":"Sant\'Elena","hu":"Szent Ilona"},"flag":"https://flagcdn.com/sh.svg","regionalBlocs":[{"acronym":"AU","name":"African Union","otherNames":["\u0627\u0644\u0627\u062A\u062D\u0627\u062F \u0627\u0644\u0623\u0641\u0631\u064A\u0642\u064A","Union africaine","Uni\xe3o Africana","Uni\xf3n Africana","Umoja wa Afrika"]}],"independent":false},{"name":"Saint Kitts and Nevis","topLevelDomain":[".kn"],"alpha2Code":"KN","alpha3Code":"KNA","callingCodes":["1"],"capital":"Basseterre","altSpellings":["KN","Federation of Saint Christopher and Nevis"],"subregion":"Caribbean","region":"Americas","population":53192,"latlng":[17.33333333,-62.75],"demonym":"Kittian and Nevisian","area":261,"timezones":["UTC-04:00"],"nativeName":"Saint Kitts and Nevis","numericCode":"659","flags":{"svg":"https://flagcdn.com/kn.svg","png":"https://flagcdn.com/w320/kn.png"},"currencies":[{"code":"XCD","name":"East Caribbean dollar","symbol":"$"}],"languages":[{"iso639_1":"en","iso639_2":"eng","name":"English","nativeName":"English"}],"translations":{"br":"Saint Kitts ha Nevis","pt":"S\xe3o Crist\xf3v\xe3o e Neves","nl":"Saint Kitts en Nevis","hr":"Sveti Kristof i Nevis","fa":"\u0633\u0646\u062A \u06A9\u06CC\u062A\u0633 \u0648 \u0646\u0648\u06CC\u0633","de":"St. Kitts und Nevis","es":"San Crist\xf3bal y Nieves","fr":"Saint-Christophe-et-Ni\xe9v\xe8s","ja":"\u30BB\u30F3\u30C8\u30AF\u30EA\u30B9\u30C8\u30D5\u30A1\u30FC\u30FB\u30CD\u30A4\u30D3\u30B9","it":"Saint Kitts e Nevis","hu":"Saint Kitts \xe9s Nevis"},"flag":"https://flagcdn.com/kn.svg","regionalBlocs":[{"acronym":"CARICOM","name":"Caribbean Community","otherNames":["Comunidad del Caribe","Communaut\xe9 Carib\xe9enne","Caribische Gemeenschap"]}],"cioc":"SKN","independent":true},{"name":"Saint Lucia","topLevelDomain":[".lc"],"alpha2Code":"LC","alpha3Code":"LCA","callingCodes":["1"],"capital":"Castries","altSpellings":["LC"],"subregion":"Caribbean","region":"Americas","population":183629,"latlng":[13.88333333,-60.96666666],"demonym":"Saint Lucian","area":616,"gini":51.2,"timezones":["UTC-04:00"],"nativeName":"Saint Lucia","numericCode":"662","flags":{"svg":"https://flagcdn.com/lc.svg","png":"https://flagcdn.com/w320/lc.png"},"currencies":[{"code":"XCD","name":"East Caribbean dollar","symbol":"$"}],"languages":[{"iso639_1":"en","iso639_2":"eng","name":"English","nativeName":"English"}],"translations":{"br":"Santez-Lusia","pt":"Santa L\xfacia","nl":"Saint Lucia","hr":"Sveta Lucija","fa":"\u0633\u0646\u062A \u0644\u0648\u0633\u06CC\u0627","de":"Saint Lucia","es":"Santa Luc\xeda","fr":"Saint-Lucie","ja":"\u30BB\u30F3\u30C8\u30EB\u30B7\u30A2","it":"Santa Lucia","hu":"Saint Lucia"},"flag":"https://flagcdn.com/lc.svg","regionalBlocs":[{"acronym":"CARICOM","name":"Caribbean Community","otherNames":["Comunidad del Caribe","Communaut\xe9 Carib\xe9enne","Caribische Gemeenschap"]}],"cioc":"LCA","independent":true},{"name":"Saint Martin (French part)","topLevelDomain":[".mf",".fr",".gp"],"alpha2Code":"MF","alpha3Code":"MAF","callingCodes":["590"],"capital":"Marigot","altSpellings":["MF","Collectivity of Saint Martin","Collectivit\xe9 de Saint-Martin"],"subregion":"Caribbean","region":"Americas","population":38659,"latlng":[18.08333333,-63.95],"demonym":"Saint Martin Islander","area":53,"timezones":["UTC-04:00"],"borders":["SXM","NLD"],"nativeName":"Saint-Martin","numericCode":"663","flags":{"svg":"https://flagcdn.com/mf.svg","png":"https://flagcdn.com/w320/mf.png"},"currencies":[{"code":"EUR","name":"Euro","symbol":"\u20AC"}],"languages":[{"iso639_1":"en","iso639_2":"eng","name":"English","nativeName":"English"},{"iso639_1":"fr","iso639_2":"fra","name":"French","nativeName":"fran\xe7ais"},{"iso639_1":"nl","iso639_2":"nld","name":"Dutch","nativeName":"Nederlands"}],"translations":{"br":"Saint-Martin","pt":"Ilha S\xe3o Martinho","nl":"Saint-Martin","hr":"Sveti Martin","fa":"\u0633\u06CC\u0646\u062A \u0645\u0627\u0631\u062A\u0646","de":"Saint Martin","es":"Saint Martin","fr":"Saint-Martin","ja":"\u30B5\u30F3\u30FB\u30DE\u30EB\u30BF\u30F3\uFF08\u30D5\u30E9\u30F3\u30B9\u9818\uFF09","it":"Saint Martin","hu":"Saint-Martin"},"flag":"https://flagcdn.com/mf.svg","independent":false},{"name":"Saint Pierre and Miquelon","topLevelDomain":[".pm"],"alpha2Code":"PM","alpha3Code":"SPM","callingCodes":["508"],"capital":"Saint-Pierre","altSpellings":["PM","Collectivit\xe9 territoriale de Saint-Pierre-et-Miquelon"],"subregion":"Northern America","region":"Americas","population":6069,"latlng":[46.83333333,-56.33333333],"demonym":"French","area":242,"timezones":["UTC-03:00"],"nativeName":"Saint-Pierre-et-Miquelon","numericCode":"666","flags":{"svg":"https://flagcdn.com/pm.svg","png":"https://flagcdn.com/w320/pm.png"},"currencies":[{"code":"EUR","name":"Euro","symbol":"\u20AC"}],"languages":[{"iso639_1":"fr","iso639_2":"fra","name":"French","nativeName":"fran\xe7ais"}],"translations":{"br":"Sant-P\xear-ha-Mikelon","pt":"S\xe3o Pedro e Miquelon","nl":"Saint Pierre en Miquelon","hr":"Sveti Petar i Mikelon","fa":"\u0633\u0646 \u067E\u06CC\u0631 \u0648 \u0645\u06CC\u06A9\u0644\u0646","de":"Saint-Pierre und Miquelon","es":"San Pedro y Miquel\xf3n","fr":"Saint-Pierre-et-Miquelon","ja":"\u30B5\u30F3\u30D4\u30A8\u30FC\u30EB\u5CF6\u30FB\u30DF\u30AF\u30ED\u30F3\u5CF6","it":"Saint-Pierre e Miquelon","hu":"Saint-Pierre \xe9s Miquelon"},"flag":"https://flagcdn.com/pm.svg","independent":false},{"name":"Saint Vincent and the Grenadines","topLevelDomain":[".vc"],"alpha2Code":"VC","alpha3Code":"VCT","callingCodes":["1"],"capital":"Kingstown","altSpellings":["VC"],"subregion":"Caribbean","region":"Americas","population":110947,"latlng":[13.25,-61.2],"demonym":"Saint Vincentian","area":389,"timezones":["UTC-04:00"],"nativeName":"Saint Vincent and the Grenadines","numericCode":"670","flags":{"svg":"https://flagcdn.com/vc.svg","png":"https://flagcdn.com/w320/vc.png"},"currencies":[{"code":"XCD","name":"East Caribbean dollar","symbol":"$"}],"languages":[{"iso639_1":"en","iso639_2":"eng","name":"English","nativeName":"English"}],"translations":{"br":"Sant-Visant hag ar Grenadinez","pt":"S\xe3o Vicente e Granadinas","nl":"Saint Vincent en de Grenadines","hr":"Sveti Vincent i Grenadini","fa":"\u0633\u0646\u062A \u0648\u06CC\u0646\u0633\u0646\u062A \u0648 \u06AF\u0631\u0646\u0627\u062F\u06CC\u0646\u200C\u0647\u0627","de":"Saint Vincent und die Grenadinen","es":"San Vicente y Granadinas","fr":"Saint-Vincent-et-les-Grenadines","ja":"\u30BB\u30F3\u30C8\u30D3\u30F3\u30BB\u30F3\u30C8\u304A\u3088\u3073\u30B0\u30EC\u30CA\u30C7\u30A3\u30FC\u30F3\u8AF8\u5CF6","it":"Saint Vincent e Grenadine","hu":"Saint Vincent \xe9s a Grenadine-szigetek"},"flag":"https://flagcdn.com/vc.svg","regionalBlocs":[{"acronym":"CARICOM","name":"Caribbean Community","otherNames":["Comunidad del Caribe","Communaut\xe9 Carib\xe9enne","Caribische Gemeenschap"]}],"cioc":"VIN","independent":true},{"name":"Samoa","topLevelDomain":[".ws"],"alpha2Code":"WS","alpha3Code":"WSM","callingCodes":["685"],"capital":"Apia","altSpellings":["WS","Independent State of Samoa","Malo Sa\u02BBoloto Tuto\u02BBatasi o S\u0101moa"],"subregion":"Polynesia","region":"Oceania","population":198410,"latlng":[-13.58333333,-172.33333333],"demonym":"Samoan","area":2842,"gini":38.7,"timezones":["UTC+13:00"],"nativeName":"Samoa","numericCode":"882","flags":{"svg":"https://flagcdn.com/ws.svg","png":"https://flagcdn.com/w320/ws.png"},"currencies":[{"code":"WST","name":"Samoan t\u0101l\u0101","symbol":"T"}],"languages":[{"iso639_1":"sm","iso639_2":"smo","name":"Samoan","nativeName":"gagana fa\'a Samoa"},{"iso639_1":"en","iso639_2":"eng","name":"English","nativeName":"English"}],"translations":{"br":"Samoa","pt":"Samoa","nl":"Samoa","hr":"Samoa","fa":"\u0633\u0627\u0645\u0648\u0622","de":"Samoa","es":"Samoa","fr":"Samoa","ja":"\u30B5\u30E2\u30A2","it":"Samoa","hu":"Szamoa"},"flag":"https://flagcdn.com/ws.svg","cioc":"SAM","independent":true},{"name":"San Marino","topLevelDomain":[".sm"],"alpha2Code":"SM","alpha3Code":"SMR","callingCodes":["378"],"capital":"City of San Marino","altSpellings":["SM","Republic of San Marino","Repubblica di San Marino"],"subregion":"Southern Europe","region":"Europe","population":33938,"latlng":[43.76666666,12.41666666],"demonym":"Sammarinese","area":61,"timezones":["UTC+01:00"],"borders":["ITA"],"nativeName":"San Marino","numericCode":"674","flags":{"svg":"https://flagcdn.com/sm.svg","png":"https://flagcdn.com/w320/sm.png"},"currencies":[{"code":"EUR","name":"Euro","symbol":"\u20AC"}],"languages":[{"iso639_1":"it","iso639_2":"ita","name":"Italian","nativeName":"Italiano"}],"translations":{"br":"San Marino","pt":"S\xe3o Marinho","nl":"San Marino","hr":"San Marino","fa":"\u0633\u0627\u0646 \u0645\u0627\u0631\u06CC\u0646\u0648","de":"San Marino","es":"San Marino","fr":"Saint-Marin","ja":"\u30B5\u30F3\u30DE\u30EA\u30CE","it":"San Marino","hu":"San Marino"},"flag":"https://flagcdn.com/sm.svg","cioc":"SMR","independent":true},{"name":"Sao Tome and Principe","topLevelDomain":[".st"],"alpha2Code":"ST","alpha3Code":"STP","callingCodes":["239"],"capital":"S\xe3o Tom\xe9","altSpellings":["ST","Democratic Republic of S\xe3o Tom\xe9 and Pr\xedncipe","Rep\xfablica Democr\xe1tica de S\xe3o Tom\xe9 e Pr\xedncipe"],"subregion":"Middle Africa","region":"Africa","population":219161,"latlng":[1,7],"demonym":"Sao Tomean","area":964,"gini":56.3,"timezones":["UTC"],"nativeName":"S\xe3o Tom\xe9 e Pr\xedncipe","numericCode":"678","flags":{"svg":"https://flagcdn.com/st.svg","png":"https://flagcdn.com/w320/st.png"},"currencies":[{"code":"STD","name":"S\xe3o Tom\xe9 and Pr\xedncipe dobra","symbol":"Db"}],"languages":[{"iso639_1":"pt","iso639_2":"por","name":"Portuguese","nativeName":"Portugu\xeas"}],"translations":{"br":"S\xe3o Tom\xe9 ha Pr\xedncipe","pt":"S\xe3o Tom\xe9 e Pr\xedncipe","nl":"Sao Tom\xe9 en Principe","hr":"Sveti Toma i Princip","fa":"\u06A9\u0648\u0627\u062A\u0631\u0648 \u062F\u0648 \u0641\u0631\u0648\u06CC\u0631\u0648","de":"S\xe3o Tom\xe9 und Pr\xedncipe","es":"Santo Tom\xe9 y Pr\xedncipe","fr":"Sao Tom\xe9-et-Principe","ja":"\u30B5\u30F3\u30C8\u30E1\u30FB\u30D7\u30EA\u30F3\u30B7\u30DA","it":"S\xe3o Tom\xe9 e Pr\xedncipe","hu":"S\xe3o Tom\xe9 \xe9s Pr\xedncipe"},"flag":"https://flagcdn.com/st.svg","regionalBlocs":[{"acronym":"AU","name":"African Union","otherNames":["\u0627\u0644\u0627\u062A\u062D\u0627\u062F \u0627\u0644\u0623\u0641\u0631\u064A\u0642\u064A","Union africaine","Uni\xe3o Africana","Uni\xf3n Africana","Umoja wa Afrika"]}],"cioc":"STP","independent":true},{"name":"Saudi Arabia","topLevelDomain":[".sa"],"alpha2Code":"SA","alpha3Code":"SAU","callingCodes":["966"],"capital":"Riyadh","altSpellings":["SA","Kingdom of Saudi Arabia","Al-Mamlakah al-\u2018Arabiyyah as-Su\u2018\u016Bdiyyah"],"subregion":"Western Asia","region":"Asia","population":34813867,"latlng":[25,45],"demonym":"Saudi Arabian","area":2149690,"timezones":["UTC+03:00"],"borders":["IRQ","JOR","KWT","OMN","QAT","ARE","YEM"],"nativeName":"\u0627\u0644\u0639\u0631\u0628\u064A\u0629 \u0627\u0644\u0633\u0639\u0648\u062F\u064A\u0629","numericCode":"682","flags":{"svg":"https://flagcdn.com/sa.svg","png":"https://flagcdn.com/w320/sa.png"},"currencies":[{"code":"SAR","name":"Saudi riyal","symbol":"\u0631.\u0633"}],"languages":[{"iso639_1":"ar","iso639_2":"ara","name":"Arabic","nativeName":"\u0627\u0644\u0639\u0631\u0628\u064A\u0629"}],"translations":{"br":"Arabia Saoudat","pt":"Ar\xe1bia Saudita","nl":"Saoedi-Arabi\xeb","hr":"Saudijska Arabija","fa":"\u0639\u0631\u0628\u0633\u062A\u0627\u0646 \u0633\u0639\u0648\u062F\u06CC","de":"Saudi-Arabien","es":"Arabia Saud\xed","fr":"Arabie Saoudite","ja":"\u30B5\u30A6\u30B8\u30A2\u30E9\u30D3\u30A2","it":"Arabia Saudita","hu":"Sza\xfad-Ar\xe1bia"},"flag":"https://flagcdn.com/sa.svg","regionalBlocs":[{"acronym":"AL","name":"Arab League","otherNames":["\u062C\u0627\u0645\u0639\u0629 \u0627\u0644\u062F\u0648\u0644 \u0627\u0644\u0639\u0631\u0628\u064A\u0629","J\u0101mi\u02BBat ad-Duwal al-\u02BBArab\u012Byah","League of Arab States"]}],"cioc":"KSA","independent":true},{"name":"Senegal","topLevelDomain":[".sn"],"alpha2Code":"SN","alpha3Code":"SEN","callingCodes":["221"],"capital":"Dakar","altSpellings":["SN","Republic of Senegal","R\xe9publique du S\xe9n\xe9gal"],"subregion":"Western Africa","region":"Africa","population":16743930,"latlng":[14,-14],"demonym":"Senegalese","area":196722,"gini":40.3,"timezones":["UTC"],"borders":["GMB","GIN","GNB","MLI","MRT"],"nativeName":"S\xe9n\xe9gal","numericCode":"686","flags":{"svg":"https://flagcdn.com/sn.svg","png":"https://flagcdn.com/w320/sn.png"},"currencies":[{"code":"XOF","name":"West African CFA franc","symbol":"Fr"}],"languages":[{"iso639_1":"fr","iso639_2":"fra","name":"French","nativeName":"fran\xe7ais"}],"translations":{"br":"Senegal","pt":"Senegal","nl":"Senegal","hr":"Senegal","fa":"\u0633\u0646\u06AF\u0627\u0644","de":"Senegal","es":"Senegal","fr":"S\xe9n\xe9gal","ja":"\u30BB\u30CD\u30AC\u30EB","it":"Senegal","hu":"Szeneg\xe1l"},"flag":"https://flagcdn.com/sn.svg","regionalBlocs":[{"acronym":"AU","name":"African Union","otherNames":["\u0627\u0644\u0627\u062A\u062D\u0627\u062F \u0627\u0644\u0623\u0641\u0631\u064A\u0642\u064A","Union africaine","Uni\xe3o Africana","Uni\xf3n Africana","Umoja wa Afrika"]}],"cioc":"SEN","independent":true},{"name":"Serbia","topLevelDomain":[".rs"],"alpha2Code":"RS","alpha3Code":"SRB","callingCodes":["381"],"capital":"Belgrade","altSpellings":["RS","Srbija","Republic of Serbia","\u0420\u0435\u043F\u0443\u0431\u043B\u0438\u043A\u0430 \u0421\u0440\u0431\u0438\u0458\u0430","Republika Srbija"],"subregion":"Southern Europe","region":"Europe","population":6908224,"latlng":[44,21],"demonym":"Serbian","area":88361,"gini":36.2,"timezones":["UTC+01:00"],"borders":["BIH","BGR","HRV","HUN","UNK","MKD","MNE","ROU"],"nativeName":"\u0421\u0440\u0431\u0438\u0458\u0430","numericCode":"688","flags":{"svg":"https://flagcdn.com/rs.svg","png":"https://flagcdn.com/w320/rs.png"},"currencies":[{"code":"RSD","name":"Serbian dinar","symbol":"\u0434\u0438\u043D."}],"languages":[{"iso639_1":"sr","iso639_2":"srp","name":"Serbian","nativeName":"\u0441\u0440\u043F\u0441\u043A\u0438 \u0458\u0435\u0437\u0438\u043A"}],"translations":{"br":"Serbia","pt":"S\xe9rvia","nl":"Servi\xeb","hr":"Srbija","fa":"\u0635\u0631\u0628\u0633\u062A\u0627\u0646","de":"Serbien","es":"Serbia","fr":"Serbie","ja":"\u30BB\u30EB\u30D3\u30A2","it":"Serbia","hu":"Szerbia"},"flag":"https://flagcdn.com/rs.svg","regionalBlocs":[{"acronym":"CEFTA","name":"Central European Free Trade Agreement"}],"cioc":"SRB","independent":true},{"name":"Seychelles","topLevelDomain":[".sc"],"alpha2Code":"SC","alpha3Code":"SYC","callingCodes":["248"],"capital":"Victoria","altSpellings":["SC","Republic of Seychelles","Repiblik Sesel","R\xe9publique des Seychelles"],"subregion":"Eastern Africa","region":"Africa","population":98462,"latlng":[-4.58333333,55.66666666],"demonym":"Seychellois","area":452,"gini":32.1,"timezones":["UTC+04:00"],"nativeName":"Seychelles","numericCode":"690","flags":{"svg":"https://flagcdn.com/sc.svg","png":"https://flagcdn.com/w320/sc.png"},"currencies":[{"code":"SCR","name":"Seychellois rupee","symbol":"\u20A8"}],"languages":[{"iso639_1":"fr","iso639_2":"fra","name":"French","nativeName":"fran\xe7ais"},{"iso639_1":"en","iso639_2":"eng","name":"English","nativeName":"English"}],"translations":{"br":"Sechelez","pt":"Seicheles","nl":"Seychellen","hr":"Sej\u0161eli","fa":"\u0633\u06CC\u0634\u0644","de":"Seychellen","es":"Seychelles","fr":"Seychelles","ja":"\u30BB\u30FC\u30B7\u30A7\u30EB","it":"Seychelles","hu":"Seychelle-szigetek"},"flag":"https://flagcdn.com/sc.svg","regionalBlocs":[{"acronym":"AU","name":"African Union","otherNames":["\u0627\u0644\u0627\u062A\u062D\u0627\u062F \u0627\u0644\u0623\u0641\u0631\u064A\u0642\u064A","Union africaine","Uni\xe3o Africana","Uni\xf3n Africana","Umoja wa Afrika"]}],"cioc":"SEY","independent":true},{"name":"Sierra Leone","topLevelDomain":[".sl"],"alpha2Code":"SL","alpha3Code":"SLE","callingCodes":["232"],"capital":"Freetown","altSpellings":["SL","Republic of Sierra Leone"],"subregion":"Western Africa","region":"Africa","population":7976985,"latlng":[8.5,-11.5],"demonym":"Sierra Leonean","area":71740,"gini":35.7,"timezones":["UTC"],"borders":["GIN","LBR"],"nativeName":"Sierra Leone","numericCode":"694","flags":{"svg":"https://flagcdn.com/sl.svg","png":"https://flagcdn.com/w320/sl.png"},"currencies":[{"code":"SLL","name":"Sierra Leonean leone","symbol":"Le"}],"languages":[{"iso639_1":"en","iso639_2":"eng","name":"English","nativeName":"English"}],"translations":{"br":"Sierra Leone","pt":"Serra Leoa","nl":"Sierra Leone","hr":"Sijera Leone","fa":"\u0633\u06CC\u0631\u0627\u0644\u0626\u0648\u0646","de":"Sierra Leone","es":"Sierra Leone","fr":"Sierra Leone","ja":"\u30B7\u30A8\u30E9\u30EC\u30AA\u30CD","it":"Sierra Leone","hu":"Sierra Leone"},"flag":"https://flagcdn.com/sl.svg","regionalBlocs":[{"acronym":"AU","name":"African Union","otherNames":["\u0627\u0644\u0627\u062A\u062D\u0627\u062F \u0627\u0644\u0623\u0641\u0631\u064A\u0642\u064A","Union africaine","Uni\xe3o Africana","Uni\xf3n Africana","Umoja wa Afrika"]}],"cioc":"SLE","independent":true},{"name":"Singapore","topLevelDomain":[".sg"],"alpha2Code":"SG","alpha3Code":"SGP","callingCodes":["65"],"capital":"Singapore","altSpellings":["SG","Singapura","Republik Singapura","\u65B0\u52A0\u5761\u5171\u548C\u56FD"],"subregion":"South-Eastern Asia","region":"Asia","population":5685807,"latlng":[1.36666666,103.8],"demonym":"Singaporean","area":710,"timezones":["UTC+08:00"],"nativeName":"Singapore","numericCode":"702","flags":{"svg":"https://flagcdn.com/sg.svg","png":"https://flagcdn.com/w320/sg.png"},"currencies":[{"code":"SGD","name":"Singapore dollar","symbol":"$"}],"languages":[{"iso639_1":"en","iso639_2":"eng","name":"English","nativeName":"English"},{"iso639_1":"ms","iso639_2":"msa","name":"Malay","nativeName":"bahasa Melayu"},{"iso639_1":"ta","iso639_2":"tam","name":"Tamil","nativeName":"\u0BA4\u0BAE\u0BBF\u0BB4\u0BCD"},{"iso639_1":"zh","iso639_2":"zho","name":"Chinese","nativeName":"\u4E2D\u6587 (Zh\u014Dngw\xe9n)"}],"translations":{"br":"Singapour","pt":"Singapura","nl":"Singapore","hr":"Singapur","fa":"\u0633\u0646\u06AF\u0627\u067E\u0648\u0631","de":"Singapur","es":"Singapur","fr":"Singapour","ja":"\u30B7\u30F3\u30AC\u30DD\u30FC\u30EB","it":"Singapore","hu":"Szingap\xfar"},"flag":"https://flagcdn.com/sg.svg","regionalBlocs":[{"acronym":"ASEAN","name":"Association of Southeast Asian Nations"}],"cioc":"SIN","independent":true},{"name":"Sint Maarten (Dutch part)","topLevelDomain":[".sx"],"alpha2Code":"SX","alpha3Code":"SXM","callingCodes":["1"],"capital":"Philipsburg","altSpellings":["SX"],"subregion":"Caribbean","region":"Americas","population":40812,"latlng":[18.033333,-63.05],"demonym":"Dutch","area":34,"timezones":["UTC-04:00"],"borders":["MAF"],"nativeName":"Sint Maarten","numericCode":"534","flags":{"svg":"https://flagcdn.com/sx.svg","png":"https://flagcdn.com/w320/sx.png"},"currencies":[{"code":"ANG","name":"Netherlands Antillean guilder","symbol":"\u0192"}],"languages":[{"iso639_1":"nl","iso639_2":"nld","name":"Dutch","nativeName":"Nederlands"},{"iso639_1":"en","iso639_2":"eng","name":"English","nativeName":"English"}],"translations":{"br":"Sint Maarten","pt":"S\xe3o Martinho","nl":"Sint Maarten","hr":"Sint Maarten (Dutch part)","fa":"\u0633\u06CC\u0646\u062A \u0645\u0627\u0631\u062A\u0646","de":"Sint Maarten (niederl. Teil)","es":"Sint Maarten (Dutch part)","fr":"Saint Martin (partie n\xe9erlandaise)","ja":"Sint Maarten (Dutch part)","it":"Saint Martin (parte olandese)","hu":"Sint Maarten"},"flag":"https://flagcdn.com/sx.svg","independent":false},{"name":"Slovakia","topLevelDomain":[".sk"],"alpha2Code":"SK","alpha3Code":"SVK","callingCodes":["421"],"capital":"Bratislava","altSpellings":["SK","Slovak Republic","Slovensk\xe1 republika"],"subregion":"Central Europe","region":"Europe","population":5458827,"latlng":[48.66666666,19.5],"demonym":"Slovak","area":49037,"gini":25,"timezones":["UTC+01:00"],"borders":["AUT","CZE","HUN","POL","UKR"],"nativeName":"Slovensko","numericCode":"703","flags":{"svg":"https://flagcdn.com/sk.svg","png":"https://flagcdn.com/w320/sk.png"},"currencies":[{"code":"EUR","name":"Euro","symbol":"\u20AC"}],"languages":[{"iso639_1":"sk","iso639_2":"slk","name":"Slovak","nativeName":"sloven\u010Dina"}],"translations":{"br":"Slovakia","pt":"Eslov\xe1quia","nl":"Slowakije","hr":"Slova\u010Dka","fa":"\u0627\u0633\u0644\u0648\u0627\u06A9\u06CC","de":"Slowakei","es":"Rep\xfablica Eslovaca","fr":"Slovaquie","ja":"\u30B9\u30ED\u30D0\u30AD\u30A2","it":"Slovacchia","hu":"Szlov\xe1kia"},"flag":"https://flagcdn.com/sk.svg","regionalBlocs":[{"acronym":"EU","name":"European Union"}],"cioc":"SVK","independent":true},{"name":"Slovenia","topLevelDomain":[".si"],"alpha2Code":"SI","alpha3Code":"SVN","callingCodes":["386"],"capital":"Ljubljana","altSpellings":["SI","Republic of Slovenia","Republika Slovenija"],"subregion":"Southern Europe","region":"Europe","population":2100126,"latlng":[46.11666666,14.81666666],"demonym":"Slovene","area":20273,"gini":24.6,"timezones":["UTC+01:00"],"borders":["AUT","HRV","ITA","HUN"],"nativeName":"Slovenija","numericCode":"705","flags":{"svg":"https://flagcdn.com/si.svg","png":"https://flagcdn.com/w320/si.png"},"currencies":[{"code":"EUR","name":"Euro","symbol":"\u20AC"}],"languages":[{"iso639_1":"sl","iso639_2":"slv","name":"Slovene","nativeName":"slovenski jezik"}],"translations":{"br":"Slovenia","pt":"Eslov\xe9nia","nl":"Sloveni\xeb","hr":"Slovenija","fa":"\u0627\u0633\u0644\u0648\u0648\u0646\u06CC","de":"Slowenien","es":"Eslovenia","fr":"Slov\xe9nie","ja":"\u30B9\u30ED\u30D9\u30CB\u30A2","it":"Slovenia","hu":"Szlov\xe9nia"},"flag":"https://flagcdn.com/si.svg","regionalBlocs":[{"acronym":"EU","name":"European Union"}],"cioc":"SLO","independent":true},{"name":"Solomon Islands","topLevelDomain":[".sb"],"alpha2Code":"SB","alpha3Code":"SLB","callingCodes":["677"],"capital":"Honiara","altSpellings":["SB"],"subregion":"Melanesia","region":"Oceania","population":686878,"latlng":[-8,159],"demonym":"Solomon Islander","area":28896,"gini":37.1,"timezones":["UTC+11:00"],"nativeName":"Solomon Islands","numericCode":"090","flags":{"svg":"https://flagcdn.com/sb.svg","png":"https://flagcdn.com/w320/sb.png"},"currencies":[{"code":"SBD","name":"Solomon Islands dollar","symbol":"$"}],"languages":[{"iso639_1":"en","iso639_2":"eng","name":"English","nativeName":"English"}],"translations":{"br":"Inizi Salomon","pt":"Ilhas Salom\xe3o","nl":"Salomonseilanden","hr":"Solomonski Otoci","fa":"\u062C\u0632\u0627\u06CC\u0631 \u0633\u0644\u06CC\u0645\u0627\u0646","de":"Salomonen","es":"Islas Salom\xf3n","fr":"\xceles Salomon","ja":"\u30BD\u30ED\u30E2\u30F3\u8AF8\u5CF6","it":"Isole Salomone","hu":"Salamon-szigetek"},"flag":"https://flagcdn.com/sb.svg","cioc":"SOL","independent":true},{"name":"Somalia","topLevelDomain":[".so"],"alpha2Code":"SO","alpha3Code":"SOM","callingCodes":["252"],"capital":"Mogadishu","altSpellings":["SO","a\u1E63-\u1E62\u016Bm\u0101l","Federal Republic of Somalia","Jamhuuriyadda Federaalka Soomaaliya","Jumh\u016Briyyat a\u1E63-\u1E62\u016Bm\u0101l al-Fider\u0101liyya"],"subregion":"Eastern Africa","region":"Africa","population":15893219,"latlng":[10,49],"demonym":"Somali","area":637657,"gini":36.8,"timezones":["UTC+03:00"],"borders":["DJI","ETH","KEN"],"nativeName":"Soomaaliya","numericCode":"706","flags":{"svg":"https://flagcdn.com/so.svg","png":"https://flagcdn.com/w320/so.png"},"currencies":[{"code":"SOS","name":"Somali shilling","symbol":"Sh"}],"languages":[{"iso639_1":"so","iso639_2":"som","name":"Somali","nativeName":"Soomaaliga"},{"iso639_1":"ar","iso639_2":"ara","name":"Arabic","nativeName":"\u0627\u0644\u0639\u0631\u0628\u064A\u0629"}],"translations":{"br":"Somalia","pt":"Som\xe1lia","nl":"Somali\xeb","hr":"Somalija","fa":"\u0633\u0648\u0645\u0627\u0644\u06CC","de":"Somalia","es":"Somalia","fr":"Somalie","ja":"\u30BD\u30DE\u30EA\u30A2","it":"Somalia","hu":"Szom\xe1lia"},"flag":"https://flagcdn.com/so.svg","regionalBlocs":[{"acronym":"AU","name":"African Union","otherNames":["\u0627\u0644\u0627\u062A\u062D\u0627\u062F \u0627\u0644\u0623\u0641\u0631\u064A\u0642\u064A","Union africaine","Uni\xe3o Africana","Uni\xf3n Africana","Umoja wa Afrika"]},{"acronym":"AL","name":"Arab League","otherNames":["\u062C\u0627\u0645\u0639\u0629 \u0627\u0644\u062F\u0648\u0644 \u0627\u0644\u0639\u0631\u0628\u064A\u0629","J\u0101mi\u02BBat ad-Duwal al-\u02BBArab\u012Byah","League of Arab States"]}],"cioc":"SOM","independent":true},{"name":"South Africa","topLevelDomain":[".za"],"alpha2Code":"ZA","alpha3Code":"ZAF","callingCodes":["27"],"capital":"Pretoria","altSpellings":["ZA","RSA","Suid-Afrika","Republic of South Africa"],"subregion":"Southern Africa","region":"Africa","population":59308690,"latlng":[-29,24],"demonym":"South African","area":1221037,"gini":63,"timezones":["UTC+02:00"],"borders":["BWA","LSO","MOZ","NAM","SWZ","ZWE"],"nativeName":"South Africa","numericCode":"710","flags":{"svg":"https://flagcdn.com/za.svg","png":"https://flagcdn.com/w320/za.png"},"currencies":[{"code":"ZAR","name":"South African rand","symbol":"R"}],"languages":[{"iso639_1":"af","iso639_2":"afr","name":"Afrikaans","nativeName":"Afrikaans"},{"iso639_1":"en","iso639_2":"eng","name":"English","nativeName":"English"},{"iso639_1":"nr","iso639_2":"nbl","name":"Southern Ndebele","nativeName":"isiNdebele"},{"iso639_1":"st","iso639_2":"sot","name":"Southern Sotho","nativeName":"Sesotho"},{"iso639_1":"ss","iso639_2":"ssw","name":"Swati","nativeName":"SiSwati"},{"iso639_1":"tn","iso639_2":"tsn","name":"Tswana","nativeName":"Setswana"},{"iso639_1":"ts","iso639_2":"tso","name":"Tsonga","nativeName":"Xitsonga"},{"iso639_1":"ve","iso639_2":"ven","name":"Venda","nativeName":"Tshiven\u1E13a"},{"iso639_1":"xh","iso639_2":"xho","name":"Xhosa","nativeName":"isiXhosa"},{"iso639_1":"zu","iso639_2":"zul","name":"Zulu","nativeName":"isiZulu"}],"translations":{"br":"Suafrika","pt":"Rep\xfablica Sul-Africana","nl":"Zuid-Afrika","hr":"Ju\u017Enoafri\u010Dka Republika","fa":"\u0622\u0641\u0631\u06CC\u0642\u0627\u06CC \u062C\u0646\u0648\u0628\u06CC","de":"Republik S\xfcdafrika","es":"Rep\xfablica de Sud\xe1frica","fr":"Afrique du Sud","ja":"\u5357\u30A2\u30D5\u30EA\u30AB","it":"Sud Africa","hu":"D\xe9l-afrikai K\xf6zt\xe1rsas\xe1g"},"flag":"https://flagcdn.com/za.svg","regionalBlocs":[{"acronym":"AU","name":"African Union","otherNames":["\u0627\u0644\u0627\u062A\u062D\u0627\u062F \u0627\u0644\u0623\u0641\u0631\u064A\u0642\u064A","Union africaine","Uni\xe3o Africana","Uni\xf3n Africana","Umoja wa Afrika"]}],"cioc":"RSA","independent":true},{"name":"South Georgia and the South Sandwich Islands","topLevelDomain":[".gs"],"alpha2Code":"GS","alpha3Code":"SGS","callingCodes":["500"],"capital":"King Edward Point","altSpellings":["GS","South Georgia and the South Sandwich Islands"],"subregion":"South America","region":"Americas","population":30,"latlng":[-54.5,-37],"demonym":"South Georgia and the South Sandwich Islander","timezones":["UTC-02:00"],"nativeName":"South Georgia","numericCode":"239","flags":{"svg":"https://flagcdn.com/gs.svg","png":"https://flagcdn.com/w320/gs.png"},"currencies":[{"code":"FKP","name":"Falkland Islands Pound","symbol":"\xa3"}],"languages":[{"iso639_1":"en","iso639_2":"eng","name":"English","nativeName":"English"}],"translations":{"br":"Georgia ar Su hag Inizi Sandwich ar Su","pt":"Ilhas Ge\xf3rgia do Sul e Sandu\xedche do Sul","nl":"Zuid-Georgia en Zuidelijke Sandwicheilanden","hr":"Ju\u017Ena Georgija i oto\u010Dje Ju\u017Eni Sandwich","fa":"\u062C\u0632\u0627\u06CC\u0631 \u062C\u0648\u0631\u062C\u06CC\u0627\u06CC \u062C\u0646\u0648\u0628\u06CC \u0648 \u0633\u0627\u0646\u062F\u0648\u06CC\u0686 \u062C\u0646\u0648\u0628\u06CC","de":"S\xfcdgeorgien und die S\xfcdlichen Sandwichinseln","es":"Islas Georgias del Sur y Sandwich del Sur","fr":"G\xe9orgie du Sud-et-les \xceles Sandwich du Sud","ja":"\u30B5\u30A6\u30B9\u30B8\u30E7\u30FC\u30B8\u30A2\u30FB\u30B5\u30A6\u30B9\u30B5\u30F3\u30C9\u30A6\u30A3\u30C3\u30C1\u8AF8\u5CF6","it":"Georgia del Sud e Isole Sandwich Meridionali","hu":"D\xe9li-Georgia \xe9s D\xe9li-Sandwich-szigetek"},"flag":"https://flagcdn.com/gs.svg","regionalBlocs":[{"acronym":"USAN","name":"Union of South American Nations","otherAcronyms":["UNASUR","UNASUL","UZAN"],"otherNames":["Uni\xf3n de Naciones Suramericanas","Uni\xe3o de Na\xe7\xf5es Sul-Americanas","Unie van Zuid-Amerikaanse Naties","South American Union"]}],"independent":false},{"name":"Korea (Republic of)","topLevelDomain":[".kr"],"alpha2Code":"KR","alpha3Code":"KOR","callingCodes":["82"],"capital":"Seoul","altSpellings":["KR","Republic of Korea"],"subregion":"Eastern Asia","region":"Asia","population":51780579,"latlng":[37,127.5],"demonym":"South Korean","area":100210,"gini":31.4,"timezones":["UTC+09:00"],"borders":["PRK"],"nativeName":"\uB300\uD55C\uBBFC\uAD6D","numericCode":"410","flags":{"svg":"https://flagcdn.com/kr.svg","png":"https://flagcdn.com/w320/kr.png"},"currencies":[{"code":"KRW","name":"South Korean won","symbol":"\u20A9"}],"languages":[{"iso639_1":"ko","iso639_2":"kor","name":"Korean","nativeName":"\uD55C\uAD6D\uC5B4"}],"translations":{"br":"Korea ar Su","pt":"Coreia do Sul","nl":"Zuid-Korea","hr":"Ju\u017Ena Koreja","fa":"\u06A9\u0631\u0647 \u0634\u0645\u0627\u0644\u06CC","de":"S\xfcdkorea","es":"Corea del Sur","fr":"Cor\xe9e du Sud","ja":"\u5927\u97D3\u6C11\u56FD","it":"Corea del Sud","hu":"D\xe9l-Korea"},"flag":"https://flagcdn.com/kr.svg","cioc":"KOR","independent":true},{"name":"Spain","topLevelDomain":[".es"],"alpha2Code":"ES","alpha3Code":"ESP","callingCodes":["34"],"capital":"Madrid","altSpellings":["ES","Kingdom of Spain","Reino de Espa\xf1a"],"subregion":"Southern Europe","region":"Europe","population":47351567,"latlng":[40,-4],"demonym":"Spanish","area":505992,"gini":34.7,"timezones":["UTC","UTC+01:00"],"borders":["AND","FRA","GIB","PRT","MAR"],"nativeName":"Espa\xf1a","numericCode":"724","flags":{"svg":"https://flagcdn.com/es.svg","png":"https://flagcdn.com/w320/es.png"},"currencies":[{"code":"EUR","name":"Euro","symbol":"\u20AC"}],"languages":[{"iso639_1":"es","iso639_2":"spa","name":"Spanish","nativeName":"Espa\xf1ol"}],"translations":{"br":"Spagn","pt":"Espanha","nl":"Spanje","hr":"\u0160panjolska","fa":"\u0627\u0633\u067E\u0627\u0646\u06CC\u0627","de":"Spanien","es":"Espa\xf1a","fr":"Espagne","ja":"\u30B9\u30DA\u30A4\u30F3","it":"Spagna","hu":"Spanyolorsz\xe1g"},"flag":"https://flagcdn.com/es.svg","regionalBlocs":[{"acronym":"EU","name":"European Union"}],"cioc":"ESP","independent":true},{"name":"Sri Lanka","topLevelDomain":[".lk"],"alpha2Code":"LK","alpha3Code":"LKA","callingCodes":["94"],"capital":"Sri Jayawardenepura Kotte","altSpellings":["LK","ila\u1E45kai","Democratic Socialist Republic of Sri Lanka"],"subregion":"Southern Asia","region":"Asia","population":21919000,"latlng":[7,81],"demonym":"Sri Lankan","area":65610,"gini":39.3,"timezones":["UTC+05:30"],"borders":["IND"],"nativeName":"\u015Br\u012B la\u1E43k\u0101va","numericCode":"144","flags":{"svg":"https://flagcdn.com/lk.svg","png":"https://flagcdn.com/w320/lk.png"},"currencies":[{"code":"LKR","name":"Sri Lankan rupee","symbol":"Rs"}],"languages":[{"iso639_1":"si","iso639_2":"sin","name":"Sinhalese","nativeName":"\u0DC3\u0DD2\u0D82\u0DC4\u0DBD"},{"iso639_1":"ta","iso639_2":"tam","name":"Tamil","nativeName":"\u0BA4\u0BAE\u0BBF\u0BB4\u0BCD"}],"translations":{"br":"Sri Lanka","pt":"Sri Lanka","nl":"Sri Lanka","hr":"\u0160ri Lanka","fa":"\u0633\u0631\u06CC\u200C\u0644\u0627\u0646\u06A9\u0627","de":"Sri Lanka","es":"Sri Lanka","fr":"Sri Lanka","ja":"\u30B9\u30EA\u30E9\u30F3\u30AB","it":"Sri Lanka","hu":"Sr\xed Lanka"},"flag":"https://flagcdn.com/lk.svg","regionalBlocs":[{"acronym":"SAARC","name":"South Asian Association for Regional Cooperation"}],"cioc":"SRI","independent":true},{"name":"Sudan","topLevelDomain":[".sd"],"alpha2Code":"SD","alpha3Code":"SDN","callingCodes":["249"],"capital":"Khartoum","altSpellings":["SD","Republic of the Sudan","Jumh\u016Br\u012Byat as-S\u016Bd\u0101n"],"subregion":"Northern Africa","region":"Africa","population":43849269,"latlng":[15,30],"demonym":"Sudanese","area":1886068,"gini":34.2,"timezones":["UTC+03:00"],"borders":["CAF","TCD","EGY","ERI","ETH","LBY","SSD"],"nativeName":"\u0627\u0644\u0633\u0648\u062F\u0627\u0646","numericCode":"729","flags":{"svg":"https://flagcdn.com/sd.svg","png":"https://flagcdn.com/w320/sd.png"},"currencies":[{"code":"SDG","name":"Sudanese pound","symbol":"\u062C.\u0633."}],"languages":[{"iso639_1":"ar","iso639_2":"ara","name":"Arabic","nativeName":"\u0627\u0644\u0639\u0631\u0628\u064A\u0629"},{"iso639_1":"en","iso639_2":"eng","name":"English","nativeName":"English"}],"translations":{"br":"Soudan","pt":"Sud\xe3o","nl":"Soedan","hr":"Sudan","fa":"\u0633\u0648\u062F\u0627\u0646","de":"Sudan","es":"Sud\xe1n","fr":"Soudan","ja":"\u30B9\u30FC\u30C0\u30F3","it":"Sudan","hu":"Szud\xe1n"},"flag":"https://flagcdn.com/sd.svg","regionalBlocs":[{"acronym":"AU","name":"African Union","otherNames":["\u0627\u0644\u0627\u062A\u062D\u0627\u062F \u0627\u0644\u0623\u0641\u0631\u064A\u0642\u064A","Union africaine","Uni\xe3o Africana","Uni\xf3n Africana","Umoja wa Afrika"]},{"acronym":"AL","name":"Arab League","otherNames":["\u062C\u0627\u0645\u0639\u0629 \u0627\u0644\u062F\u0648\u0644 \u0627\u0644\u0639\u0631\u0628\u064A\u0629","J\u0101mi\u02BBat ad-Duwal al-\u02BBArab\u012Byah","League of Arab States"]}],"cioc":"SUD","independent":true},{"name":"South Sudan","topLevelDomain":[".ss"],"alpha2Code":"SS","alpha3Code":"SSD","callingCodes":["211"],"capital":"Juba","altSpellings":["SS"],"subregion":"Middle Africa","region":"Africa","population":11193729,"latlng":[7,30],"demonym":"South Sudanese","area":619745,"gini":44.1,"timezones":["UTC+03:00"],"borders":["CAF","COD","ETH","KEN","SDN","UGA"],"nativeName":"South Sudan","numericCode":"728","flags":{"svg":"https://flagcdn.com/ss.svg","png":"https://flagcdn.com/w320/ss.png"},"currencies":[{"code":"SSP","name":"South Sudanese pound","symbol":"\xa3"}],"languages":[{"iso639_1":"en","iso639_2":"eng","name":"English","nativeName":"English"}],"translations":{"br":"Soudan ar Su","pt":"Sud\xe3o do Sul","nl":"Zuid-Soedan","hr":"Ju\u017Eni Sudan","fa":"\u0633\u0648\u062F\u0627\u0646 \u062C\u0646\u0648\u0628\u06CC","de":"S\xfcdsudan","es":"Sud\xe1n del Sur","fr":"Soudan du Sud","ja":"\u5357\u30B9\u30FC\u30C0\u30F3","it":"Sudan del sud","hu":"D\xe9l-Szud\xe1n"},"flag":"https://flagcdn.com/ss.svg","regionalBlocs":[{"acronym":"AU","name":"African Union","otherNames":["\u0627\u0644\u0627\u062A\u062D\u0627\u062F \u0627\u0644\u0623\u0641\u0631\u064A\u0642\u064A","Union africaine","Uni\xe3o Africana","Uni\xf3n Africana","Umoja wa Afrika"]}],"cioc":"SSD","independent":true},{"name":"Suriname","topLevelDomain":[".sr"],"alpha2Code":"SR","alpha3Code":"SUR","callingCodes":["597"],"capital":"Paramaribo","altSpellings":["SR","Sarnam","Sranangron","Republic of Suriname","Republiek Suriname"],"subregion":"South America","region":"Americas","population":586634,"latlng":[4,-56],"demonym":"Surinamer","area":163820,"gini":57.9,"timezones":["UTC-03:00"],"borders":["BRA","FRA","GUF","GUY"],"nativeName":"Suriname","numericCode":"740","flags":{"svg":"https://flagcdn.com/sr.svg","png":"https://flagcdn.com/w320/sr.png"},"currencies":[{"code":"SRD","name":"Surinamese dollar","symbol":"$"}],"languages":[{"iso639_1":"nl","iso639_2":"nld","name":"Dutch","nativeName":"Nederlands"}],"translations":{"br":"Surinam","pt":"Suriname","nl":"Suriname","hr":"Surinam","fa":"\u0633\u0648\u0631\u06CC\u0646\u0627\u0645","de":"Suriname","es":"Surinam","fr":"Surinam","ja":"\u30B9\u30EA\u30CA\u30E0","it":"Suriname","hu":"Suriname"},"flag":"https://flagcdn.com/sr.svg","regionalBlocs":[{"acronym":"CARICOM","name":"Caribbean Community","otherNames":["Comunidad del Caribe","Communaut\xe9 Carib\xe9enne","Caribische Gemeenschap"]},{"acronym":"USAN","name":"Union of South American Nations","otherAcronyms":["UNASUR","UNASUL","UZAN"],"otherNames":["Uni\xf3n de Naciones Suramericanas","Uni\xe3o de Na\xe7\xf5es Sul-Americanas","Unie van Zuid-Amerikaanse Naties","South American Union"]}],"cioc":"SUR","independent":true},{"name":"Svalbard and Jan Mayen","topLevelDomain":[".sj"],"alpha2Code":"SJ","alpha3Code":"SJM","callingCodes":["47"],"capital":"Longyearbyen","altSpellings":["SJ","Svalbard and Jan Mayen Islands"],"subregion":"Northern Europe","region":"Europe","population":2562,"latlng":[78,20],"demonym":"Norwegian","timezones":["UTC+01:00"],"nativeName":"Svalbard og Jan Mayen","numericCode":"744","flags":{"svg":"https://flagcdn.com/sj.svg","png":"https://flagcdn.com/w320/sj.png"},"currencies":[{"code":"NOK","name":"Norwegian krone","symbol":"kr"}],"languages":[{"iso639_1":"no","iso639_2":"nor","name":"Norwegian","nativeName":"Norsk"}],"translations":{"br":"Svalbard ha Jan Mayen","pt":"Svalbard","nl":"Svalbard en Jan Mayen","hr":"Svalbard i Jan Mayen","fa":"\u0633\u0648\u0627\u0644\u0628\u0627\u0631\u062F \u0648 \u06CC\u0627\u0646 \u0645\u0627\u06CC\u0646","de":"Svalbard und Jan Mayen","es":"Islas Svalbard y Jan Mayen","fr":"Svalbard et Jan Mayen","ja":"\u30B9\u30F4\u30A1\u30FC\u30EB\u30D0\u30EB\u8AF8\u5CF6\u304A\u3088\u3073\u30E4\u30F3\u30DE\u30A4\u30A8\u30F3\u5CF6","it":"Svalbard e Jan Mayen","hu":"Spitzberg\xe1k \xe9s Jan Mayen-szigetek"},"flag":"https://flagcdn.com/sj.svg","independent":false},{"name":"Swaziland","topLevelDomain":[".sz"],"alpha2Code":"SZ","alpha3Code":"SWZ","callingCodes":["268"],"capital":"Mbabane","altSpellings":["SZ","weSwatini","Swatini","Ngwane","Kingdom of Swaziland","Umbuso waseSwatini"],"subregion":"Southern Africa","region":"Africa","population":1160164,"latlng":[-26.5,31.5],"demonym":"Swazi","area":17364,"gini":54.6,"timezones":["UTC+02:00"],"borders":["MOZ","ZAF"],"nativeName":"Swaziland","numericCode":"748","flags":{"svg":"https://flagcdn.com/sz.svg","png":"https://flagcdn.com/w320/sz.png"},"currencies":[{"code":"SZL","name":"Swazi lilangeni","symbol":"L"}],"languages":[{"iso639_1":"en","iso639_2":"eng","name":"English","nativeName":"English"},{"iso639_1":"ss","iso639_2":"ssw","name":"Swati","nativeName":"SiSwati"}],"translations":{"br":"Eswatini","pt":"Suazil\xe2ndia","nl":"Swaziland","hr":"Svazi","fa":"\u0633\u0648\u0627\u0632\u06CC\u0644\u0646\u062F","de":"Swasiland","es":"Suazilandia","fr":"Swaziland","ja":"\u30B9\u30EF\u30B8\u30E9\u30F3\u30C9","it":"Swaziland","hu":"Szv\xe1zif\xf6ld"},"flag":"https://flagcdn.com/sz.svg","regionalBlocs":[{"acronym":"AU","name":"African Union","otherNames":["\u0627\u0644\u0627\u062A\u062D\u0627\u062F \u0627\u0644\u0623\u0641\u0631\u064A\u0642\u064A","Union africaine","Uni\xe3o Africana","Uni\xf3n Africana","Umoja wa Afrika"]}],"cioc":"SWZ","independent":true},{"name":"Sweden","topLevelDomain":[".se"],"alpha2Code":"SE","alpha3Code":"SWE","callingCodes":["46"],"capital":"Stockholm","altSpellings":["SE","Kingdom of Sweden","Konungariket Sverige"],"subregion":"Northern Europe","region":"Europe","population":10353442,"latlng":[62,15],"demonym":"Swedish","area":450295,"gini":30,"timezones":["UTC+01:00"],"borders":["FIN","NOR"],"nativeName":"Sverige","numericCode":"752","flags":{"svg":"https://flagcdn.com/se.svg","png":"https://flagcdn.com/w320/se.png"},"currencies":[{"code":"SEK","name":"Swedish krona","symbol":"kr"}],"languages":[{"iso639_1":"sv","iso639_2":"swe","name":"Swedish","nativeName":"svenska"}],"translations":{"br":"Sveden","pt":"Su\xe9cia","nl":"Zweden","hr":"\u0160vedska","fa":"\u0633\u0648\u0626\u062F","de":"Schweden","es":"Suecia","fr":"Su\xe8de","ja":"\u30B9\u30A6\u30A7\u30FC\u30C7\u30F3","it":"Svezia","hu":"Sv\xe9dorsz\xe1g"},"flag":"https://flagcdn.com/se.svg","regionalBlocs":[{"acronym":"EU","name":"European Union"}],"cioc":"SWE","independent":true},{"name":"Switzerland","topLevelDomain":[".ch"],"alpha2Code":"CH","alpha3Code":"CHE","callingCodes":["41"],"capital":"Bern","altSpellings":["CH","Swiss Confederation","Schweiz","Suisse","Svizzera","Svizra"],"subregion":"Central Europe","region":"Europe","population":8636896,"latlng":[47,8],"demonym":"Swiss","area":41284,"gini":33.1,"timezones":["UTC+01:00"],"borders":["AUT","FRA","ITA","LIE","DEU"],"nativeName":"Schweiz","numericCode":"756","flags":{"svg":"https://flagcdn.com/ch.svg","png":"https://flagcdn.com/w320/ch.png"},"currencies":[{"code":"CHF","name":"Swiss franc","symbol":"Fr"}],"languages":[{"iso639_1":"de","iso639_2":"deu","name":"German","nativeName":"Deutsch"},{"iso639_1":"fr","iso639_2":"fra","name":"French","nativeName":"fran\xe7ais"},{"iso639_1":"it","iso639_2":"ita","name":"Italian","nativeName":"Italiano"},{"iso639_2":"roh","name":"Romansh"}],"translations":{"br":"Suis","pt":"Su\xed\xe7a","nl":"Zwitserland","hr":"\u0160vicarska","fa":"\u0633\u0648\u0626\u06CC\u0633","de":"Schweiz","es":"Suiza","fr":"Suisse","ja":"\u30B9\u30A4\u30B9","it":"Svizzera","hu":"Sv\xe1jc"},"flag":"https://flagcdn.com/ch.svg","regionalBlocs":[{"acronym":"EFTA","name":"European Free Trade Association"}],"cioc":"SUI","independent":true},{"name":"Syrian Arab Republic","topLevelDomain":[".sy"],"alpha2Code":"SY","alpha3Code":"SYR","callingCodes":["963"],"capital":"Damascus","altSpellings":["SY","Syrian Arab Republic","Al-Jumh\u016Br\u012Byah Al-\u02BBArab\u012Byah As-S\u016Br\u012Byah"],"subregion":"Western Asia","region":"Asia","population":17500657,"latlng":[35,38],"demonym":"Syrian","area":185180,"gini":37.5,"timezones":["UTC+02:00"],"borders":["IRQ","ISR","JOR","LBN","TUR"],"nativeName":"\u0633\u0648\u0631\u064A\u0627","numericCode":"760","flags":{"svg":"https://flagcdn.com/sy.svg","png":"https://flagcdn.com/w320/sy.png"},"currencies":[{"code":"SYP","name":"Syrian pound","symbol":"\xa3"}],"languages":[{"iso639_1":"ar","iso639_2":"ara","name":"Arabic","nativeName":"\u0627\u0644\u0639\u0631\u0628\u064A\u0629"}],"translations":{"br":"Siria","pt":"S\xedria","nl":"Syri\xeb","hr":"Sirija","fa":"\u0633\u0648\u0631\u06CC\u0647","de":"Syrien","es":"Siria","fr":"Syrie","ja":"\u30B7\u30EA\u30A2\u30FB\u30A2\u30E9\u30D6\u5171\u548C\u56FD","it":"Siria","hu":"Sz\xedria"},"flag":"https://flagcdn.com/sy.svg","regionalBlocs":[{"acronym":"AL","name":"Arab League","otherNames":["\u062C\u0627\u0645\u0639\u0629 \u0627\u0644\u062F\u0648\u0644 \u0627\u0644\u0639\u0631\u0628\u064A\u0629","J\u0101mi\u02BBat ad-Duwal al-\u02BBArab\u012Byah","League of Arab States"]}],"cioc":"SYR","independent":true},{"name":"Taiwan","topLevelDomain":[".tw"],"alpha2Code":"TW","alpha3Code":"TWN","callingCodes":["886"],"capital":"Taipei","altSpellings":["TW","T\xe1iw\u0101n","Republic of China","\u4E2D\u83EF\u6C11\u570B","Zh\u014Dnghu\xe1 M\xedngu\xf3"],"subregion":"Eastern Asia","region":"Asia","population":23503349,"latlng":[23.5,121],"demonym":"Taiwanese","area":36193,"timezones":["UTC+08:00"],"nativeName":"\u81FA\u7063","numericCode":"158","flags":{"svg":"https://flagcdn.com/tw.svg","png":"https://flagcdn.com/w320/tw.png"},"currencies":[{"code":"TWD","name":"New Taiwan dollar","symbol":"$"}],"languages":[{"iso639_1":"zh","iso639_2":"zho","name":"Chinese","nativeName":"\u4E2D\u6587 (Zh\u014Dngw\xe9n)"}],"translations":{"br":"Taiwan","pt":"Taiwan","nl":"Taiwan","hr":"Tajvan","fa":"\u062A\u0627\u06CC\u0648\u0627\u0646","de":"Taiwan","es":"Taiw\xe1n","fr":"Ta\xefwan","ja":"\u53F0\u6E7E\uFF08\u4E2D\u83EF\u6C11\u56FD\uFF09","it":"Taiwan","hu":"Tajvan"},"flag":"https://flagcdn.com/tw.svg","cioc":"TPE","independent":true},{"name":"Tajikistan","topLevelDomain":[".tj"],"alpha2Code":"TJ","alpha3Code":"TJK","callingCodes":["992"],"capital":"Dushanbe","altSpellings":["TJ","To\xe7ikiston","Republic of Tajikistan","\u04B6\u0443\u043C\u04B3\u0443\u0440\u0438\u0438 \u0422\u043E\u04B7\u0438\u043A\u0438\u0441\u0442\u043E\u043D","\xc7umhuriyi To\xe7ikiston"],"subregion":"Central Asia","region":"Asia","population":9537642,"latlng":[39,71],"demonym":"Tadzhik","area":143100,"gini":34,"timezones":["UTC+05:00"],"borders":["AFG","CHN","KGZ","UZB"],"nativeName":"\u0422\u043E\u04B7\u0438\u043A\u0438\u0441\u0442\u043E\u043D","numericCode":"762","flags":{"svg":"https://flagcdn.com/tj.svg","png":"https://flagcdn.com/w320/tj.png"},"currencies":[{"code":"TJS","name":"Tajikistani somoni","symbol":"\u0405\u041C"}],"languages":[{"iso639_1":"tg","iso639_2":"tgk","name":"Tajik","nativeName":"\u0442\u043E\u04B7\u0438\u043A\u04E3"},{"iso639_1":"ru","iso639_2":"rus","name":"Russian","nativeName":"\u0420\u0443\u0441\u0441\u043A\u0438\u0439"}],"translations":{"br":"Tadjikistan","pt":"Tajiquist\xe3o","nl":"Tadzjikistan","hr":"Ta\u0111ikistan","fa":"\u062A\u0627\u062C\u06CC\u06A9\u0633\u062A\u0627\u0646","de":"Tadschikistan","es":"Tayikist\xe1n","fr":"Tadjikistan","ja":"\u30BF\u30B8\u30AD\u30B9\u30BF\u30F3","it":"Tagikistan","hu":"T\xe1dzsikiszt\xe1n"},"flag":"https://flagcdn.com/tj.svg","cioc":"TJK","independent":true},{"name":"Tanzania, United Republic of","topLevelDomain":[".tz"],"alpha2Code":"TZ","alpha3Code":"TZA","callingCodes":["255"],"capital":"Dodoma","altSpellings":["TZ","United Republic of Tanzania","Jamhuri ya Muungano wa Tanzania"],"subregion":"Eastern Africa","region":"Africa","population":59734213,"latlng":[-6,35],"demonym":"Tanzanian","area":945087,"gini":40.5,"timezones":["UTC+03:00"],"borders":["BDI","COD","KEN","MWI","MOZ","RWA","UGA","ZMB"],"nativeName":"Tanzania","numericCode":"834","flags":{"svg":"https://flagcdn.com/tz.svg","png":"https://flagcdn.com/w320/tz.png"},"currencies":[{"code":"TZS","name":"Tanzanian shilling","symbol":"Sh"}],"languages":[{"iso639_1":"sw","iso639_2":"swa","name":"Swahili","nativeName":"Kiswahili"},{"iso639_1":"en","iso639_2":"eng","name":"English","nativeName":"English"}],"translations":{"br":"Tanzania","pt":"Tanz\xe2nia","nl":"Tanzania","hr":"Tanzanija","fa":"\u062A\u0627\u0646\u0632\u0627\u0646\u06CC\u0627","de":"Tansania","es":"Tanzania","fr":"Tanzanie","ja":"\u30BF\u30F3\u30B6\u30CB\u30A2","it":"Tanzania","hu":"Tanz\xe1nia"},"flag":"https://flagcdn.com/tz.svg","regionalBlocs":[{"acronym":"AU","name":"African Union","otherNames":["\u0627\u0644\u0627\u062A\u062D\u0627\u062F \u0627\u0644\u0623\u0641\u0631\u064A\u0642\u064A","Union africaine","Uni\xe3o Africana","Uni\xf3n Africana","Umoja wa Afrika"]}],"cioc":"TAN","independent":true},{"name":"Thailand","topLevelDomain":[".th"],"alpha2Code":"TH","alpha3Code":"THA","callingCodes":["66"],"capital":"Bangkok","altSpellings":["TH","Prathet","Thai","Kingdom of Thailand","\u0E23\u0E32\u0E0A\u0E2D\u0E32\u0E13\u0E32\u0E08\u0E31\u0E01\u0E23\u0E44\u0E17\u0E22","Ratcha Anachak Thai"],"subregion":"South-Eastern Asia","region":"Asia","population":69799978,"latlng":[15,100],"demonym":"Thai","area":513120,"gini":34.9,"timezones":["UTC+07:00"],"borders":["MMR","KHM","LAO","MYS"],"nativeName":"\u0E1B\u0E23\u0E30\u0E40\u0E17\u0E28\u0E44\u0E17\u0E22","numericCode":"764","flags":{"svg":"https://flagcdn.com/th.svg","png":"https://flagcdn.com/w320/th.png"},"currencies":[{"code":"THB","name":"Thai baht","symbol":"\u0E3F"}],"languages":[{"iso639_1":"th","iso639_2":"tha","name":"Thai","nativeName":"\u0E44\u0E17\u0E22"}],"translations":{"br":"Thailand","pt":"Tail\xe2ndia","nl":"Thailand","hr":"Tajland","fa":"\u062A\u0627\u06CC\u0644\u0646\u062F","de":"Thailand","es":"Tailandia","fr":"Tha\xeflande","ja":"\u30BF\u30A4","it":"Tailandia","hu":"Thaif\xf6ld"},"flag":"https://flagcdn.com/th.svg","regionalBlocs":[{"acronym":"ASEAN","name":"Association of Southeast Asian Nations"}],"cioc":"THA","independent":true},{"name":"Timor-Leste","topLevelDomain":[".tl"],"alpha2Code":"TL","alpha3Code":"TLS","callingCodes":["670"],"capital":"Dili","altSpellings":["TL","East Timor","Democratic Republic of Timor-Leste","Rep\xfablica Democr\xe1tica de Timor-Leste","Rep\xfablika Demokr\xe1tika Tim\xf3r-Leste"],"subregion":"South-Eastern Asia","region":"Asia","population":1318442,"latlng":[-8.83333333,125.91666666],"demonym":"East Timorese","area":14874,"gini":28.7,"timezones":["UTC+09:00"],"borders":["IDN"],"nativeName":"Timor-Leste","numericCode":"626","flags":{"svg":"https://flagcdn.com/tl.svg","png":"https://flagcdn.com/w320/tl.png"},"currencies":[{"code":"USD","name":"United States Dollar","symbol":"$"}],"languages":[{"iso639_1":"pt","iso639_2":"por","name":"Portuguese","nativeName":"Portugu\xeas"}],"translations":{"br":"Timor ar Reter","pt":"Timor Leste","nl":"Oost-Timor","hr":"Isto\u010Dni Timor","fa":"\u062A\u06CC\u0645\u0648\u0631 \u0634\u0631\u0642\u06CC","de":"Timor-Leste","es":"Timor Oriental","fr":"Timor oriental","ja":"\u6771\u30C6\u30A3\u30E2\u30FC\u30EB","it":"Timor Est","hu":"Kelet-Timor"},"flag":"https://flagcdn.com/tl.svg","cioc":"TLS","independent":true},{"name":"Togo","topLevelDomain":[".tg"],"alpha2Code":"TG","alpha3Code":"TGO","callingCodes":["228"],"capital":"Lom\xe9","altSpellings":["TG","Togolese","Togolese Republic","R\xe9publique Togolaise"],"subregion":"Western Africa","region":"Africa","population":8278737,"latlng":[8,1.16666666],"demonym":"Togolese","area":56785,"gini":43.1,"timezones":["UTC"],"borders":["BEN","BFA","GHA"],"nativeName":"Togo","numericCode":"768","flags":{"svg":"https://flagcdn.com/tg.svg","png":"https://flagcdn.com/w320/tg.png"},"currencies":[{"code":"XOF","name":"West African CFA franc","symbol":"Fr"}],"languages":[{"iso639_1":"fr","iso639_2":"fra","name":"French","nativeName":"fran\xe7ais"}],"translations":{"br":"Togo","pt":"Togo","nl":"Togo","hr":"Togo","fa":"\u062A\u0648\u06AF\u0648","de":"Togo","es":"Togo","fr":"Togo","ja":"\u30C8\u30FC\u30B4","it":"Togo","hu":"Togo"},"flag":"https://flagcdn.com/tg.svg","regionalBlocs":[{"acronym":"AU","name":"African Union","otherNames":["\u0627\u0644\u0627\u062A\u062D\u0627\u062F \u0627\u0644\u0623\u0641\u0631\u064A\u0642\u064A","Union africaine","Uni\xe3o Africana","Uni\xf3n Africana","Umoja wa Afrika"]}],"cioc":"TOG","independent":true},{"name":"Tokelau","topLevelDomain":[".tk"],"alpha2Code":"TK","alpha3Code":"TKL","callingCodes":["690"],"capital":"Fakaofo","altSpellings":["TK"],"subregion":"Polynesia","region":"Oceania","population":1411,"latlng":[-9,-172],"demonym":"Tokelauan","area":12,"timezones":["UTC+13:00"],"nativeName":"Tokelau","numericCode":"772","flags":{"svg":"https://flagcdn.com/tk.svg","png":"https://flagcdn.com/w320/tk.png"},"currencies":[{"code":"NZD","name":"New Zealand dollar","symbol":"$"}],"languages":[{"iso639_1":"en","iso639_2":"eng","name":"English","nativeName":"English"}],"translations":{"br":"Tokelau","pt":"Toquelau","nl":"Tokelau","hr":"Tokelau","fa":"\u062A\u0648\u06A9\u0644\u0627\u0626\u0648","de":"Tokelau","es":"Islas Tokelau","fr":"Tokelau","ja":"\u30C8\u30B1\u30E9\u30A6","it":"Isole Tokelau","hu":"Tokelau-szigetek"},"flag":"https://flagcdn.com/tk.svg","independent":false},{"name":"Tonga","topLevelDomain":[".to"],"alpha2Code":"TO","alpha3Code":"TON","callingCodes":["676"],"capital":"Nuku\'alofa","altSpellings":["TO"],"subregion":"Polynesia","region":"Oceania","population":105697,"latlng":[-20,-175],"demonym":"Tongan","area":747,"gini":37.6,"timezones":["UTC+13:00"],"nativeName":"Tonga","numericCode":"776","flags":{"svg":"https://flagcdn.com/to.svg","png":"https://flagcdn.com/w320/to.png"},"currencies":[{"code":"TOP","name":"Tongan pa\u02BBanga","symbol":"T$"}],"languages":[{"iso639_1":"en","iso639_2":"eng","name":"English","nativeName":"English"},{"iso639_1":"to","iso639_2":"ton","name":"Tonga (Tonga Islands)","nativeName":"faka Tonga"}],"translations":{"br":"Tonga","pt":"Tonga","nl":"Tonga","hr":"Tonga","fa":"\u062A\u0648\u0646\u06AF\u0627","de":"Tonga","es":"Tonga","fr":"Tonga","ja":"\u30C8\u30F3\u30AC","it":"Tonga","hu":"Tonga"},"flag":"https://flagcdn.com/to.svg","cioc":"TGA","independent":true},{"name":"Trinidad and Tobago","topLevelDomain":[".tt"],"alpha2Code":"TT","alpha3Code":"TTO","callingCodes":["1"],"capital":"Port of Spain","altSpellings":["TT","Republic of Trinidad and Tobago"],"subregion":"Caribbean","region":"Americas","population":1399491,"latlng":[11,-61],"demonym":"Trinidadian","area":5130,"gini":40.3,"timezones":["UTC-04:00"],"nativeName":"Trinidad and Tobago","numericCode":"780","flags":{"svg":"https://flagcdn.com/tt.svg","png":"https://flagcdn.com/w320/tt.png"},"currencies":[{"code":"TTD","name":"Trinidad and Tobago dollar","symbol":"$"}],"languages":[{"iso639_1":"en","iso639_2":"eng","name":"English","nativeName":"English"}],"translations":{"br":"Trinidad ha Tobago","pt":"Trindade e Tobago","nl":"Trinidad en Tobago","hr":"Trinidad i Tobago","fa":"\u062A\u0631\u06CC\u0646\u06CC\u062F\u0627\u062F \u0648 \u062A\u0648\u0628\u0627\u06AF\u0648","de":"Trinidad und Tobago","es":"Trinidad y Tobago","fr":"Trinit\xe9 et Tobago","ja":"\u30C8\u30EA\u30CB\u30C0\u30FC\u30C9\u30FB\u30C8\u30D0\u30B4","it":"Trinidad e Tobago","hu":"Trinidad \xe9s Tobago"},"flag":"https://flagcdn.com/tt.svg","regionalBlocs":[{"acronym":"CARICOM","name":"Caribbean Community","otherNames":["Comunidad del Caribe","Communaut\xe9 Carib\xe9enne","Caribische Gemeenschap"]}],"cioc":"TTO","independent":true},{"name":"Tunisia","topLevelDomain":[".tn"],"alpha2Code":"TN","alpha3Code":"TUN","callingCodes":["216"],"capital":"Tunis","altSpellings":["TN","Republic of Tunisia","al-Jumh\u016Briyyah at-T\u016Bnisiyyah"],"subregion":"Northern Africa","region":"Africa","population":11818618,"latlng":[34,9],"demonym":"Tunisian","area":163610,"gini":32.8,"timezones":["UTC+01:00"],"borders":["DZA","LBY"],"nativeName":"\u062A\u0648\u0646\u0633","numericCode":"788","flags":{"svg":"https://flagcdn.com/tn.svg","png":"https://flagcdn.com/w320/tn.png"},"currencies":[{"code":"TND","name":"Tunisian dinar","symbol":"\u062F.\u062A"}],"languages":[{"iso639_1":"ar","iso639_2":"ara","name":"Arabic","nativeName":"\u0627\u0644\u0639\u0631\u0628\u064A\u0629"}],"translations":{"br":"Tunizia","pt":"Tun\xedsia","nl":"Tunesi\xeb","hr":"Tunis","fa":"\u062A\u0648\u0646\u0633","de":"Tunesien","es":"T\xfanez","fr":"Tunisie","ja":"\u30C1\u30E5\u30CB\u30B8\u30A2","it":"Tunisia","hu":"Tun\xe9zia"},"flag":"https://flagcdn.com/tn.svg","regionalBlocs":[{"acronym":"AU","name":"African Union","otherNames":["\u0627\u0644\u0627\u062A\u062D\u0627\u062F \u0627\u0644\u0623\u0641\u0631\u064A\u0642\u064A","Union africaine","Uni\xe3o Africana","Uni\xf3n Africana","Umoja wa Afrika"]},{"acronym":"AL","name":"Arab League","otherNames":["\u062C\u0627\u0645\u0639\u0629 \u0627\u0644\u062F\u0648\u0644 \u0627\u0644\u0639\u0631\u0628\u064A\u0629","J\u0101mi\u02BBat ad-Duwal al-\u02BBArab\u012Byah","League of Arab States"]}],"cioc":"TUN","independent":true},{"name":"Turkey","topLevelDomain":[".tr"],"alpha2Code":"TR","alpha3Code":"TUR","callingCodes":["90"],"capital":"Ankara","altSpellings":["TR","Turkiye","Republic of Turkey","T\xfcrkiye Cumhuriyeti"],"subregion":"Western Asia","region":"Asia","population":84339067,"latlng":[39,35],"demonym":"Turkish","area":783562,"gini":41.9,"timezones":["UTC+03:00"],"borders":["ARM","AZE","BGR","GEO","GRC","IRN","IRQ","SYR"],"nativeName":"T\xfcrkiye","numericCode":"792","flags":{"svg":"https://flagcdn.com/tr.svg","png":"https://flagcdn.com/w320/tr.png"},"currencies":[{"code":"TRY","name":"Turkish lira","symbol":"\u20BA"}],"languages":[{"iso639_1":"tr","iso639_2":"tur","name":"Turkish","nativeName":"T\xfcrk\xe7e"}],"translations":{"br":"Turkia","pt":"Turquia","nl":"Turkije","hr":"Turska","fa":"\u062A\u0631\u06A9\u06CC\u0647","de":"T\xfcrkei","es":"Turqu\xeda","fr":"Turquie","ja":"\u30C8\u30EB\u30B3","it":"Turchia","hu":"T\xf6r\xf6korsz\xe1g"},"flag":"https://flagcdn.com/tr.svg","cioc":"TUR","independent":true},{"name":"Turkmenistan","topLevelDomain":[".tm"],"alpha2Code":"TM","alpha3Code":"TKM","callingCodes":["993"],"capital":"Ashgabat","altSpellings":["TM"],"subregion":"Central Asia","region":"Asia","population":6031187,"latlng":[40,60],"demonym":"Turkmen","area":488100,"gini":40.8,"timezones":["UTC+05:00"],"borders":["AFG","IRN","KAZ","UZB"],"nativeName":"T\xfcrkmenistan","numericCode":"795","flags":{"svg":"https://flagcdn.com/tm.svg","png":"https://flagcdn.com/w320/tm.png"},"currencies":[{"code":"TMT","name":"Turkmenistan manat","symbol":"m"}],"languages":[{"iso639_1":"tk","iso639_2":"tuk","name":"Turkmen","nativeName":"T\xfcrkmen"},{"iso639_1":"ru","iso639_2":"rus","name":"Russian","nativeName":"\u0420\u0443\u0441\u0441\u043A\u0438\u0439"}],"translations":{"br":"Turkmenistan","pt":"Turquemenist\xe3o","nl":"Turkmenistan","hr":"Turkmenistan","fa":"\u062A\u0631\u06A9\u0645\u0646\u0633\u062A\u0627\u0646","de":"Turkmenistan","es":"Turkmenist\xe1n","fr":"Turkm\xe9nistan","ja":"\u30C8\u30EB\u30AF\u30E1\u30CB\u30B9\u30BF\u30F3","it":"Turkmenistan","hu":"T\xfcrkmeniszt\xe1n"},"flag":"https://flagcdn.com/tm.svg","cioc":"TKM","independent":true},{"name":"Turks and Caicos Islands","topLevelDomain":[".tc"],"alpha2Code":"TC","alpha3Code":"TCA","callingCodes":["1"],"capital":"Cockburn Town","altSpellings":["TC"],"subregion":"Caribbean","region":"Americas","population":38718,"latlng":[21.75,-71.58333333],"demonym":"Turks and Caicos Islander","area":948,"timezones":["UTC-04:00"],"nativeName":"Turks and Caicos Islands","numericCode":"796","flags":{"svg":"https://flagcdn.com/tc.svg","png":"https://flagcdn.com/w320/tc.png"},"currencies":[{"code":"USD","name":"United States dollar","symbol":"$"}],"languages":[{"iso639_1":"en","iso639_2":"eng","name":"English","nativeName":"English"}],"translations":{"br":"Inizi Turks ha Caicos","pt":"Ilhas Turcas e Caicos","nl":"Turks- en Caicoseilanden","hr":"Otoci Turks i Caicos","fa":"\u062C\u0632\u0627\u06CC\u0631 \u062A\u0648\u0631\u06A9\u0633 \u0648 \u06A9\u0627\u06CC\u06A9\u0648\u0633","de":"Turks- und Caicosinseln","es":"Islas Turks y Caicos","fr":"\xceles Turques-et-Ca\xefques","ja":"\u30BF\u30FC\u30AF\u30B9\u30FB\u30AB\u30A4\u30B3\u30B9\u8AF8\u5CF6","it":"Isole Turks e Caicos","hu":"Turks- \xe9s Caicos-szigetek"},"flag":"https://flagcdn.com/tc.svg","independent":false},{"name":"Tuvalu","topLevelDomain":[".tv"],"alpha2Code":"TV","alpha3Code":"TUV","callingCodes":["688"],"capital":"Funafuti","altSpellings":["TV"],"subregion":"Polynesia","region":"Oceania","population":11792,"latlng":[-8,178],"demonym":"Tuvaluan","area":26,"gini":39.1,"timezones":["UTC+12:00"],"nativeName":"Tuvalu","numericCode":"798","flags":{"svg":"https://flagcdn.com/tv.svg","png":"https://flagcdn.com/w320/tv.png"},"currencies":[{"code":"AUD","name":"Australian dollar","symbol":"$"},{"code":"TVD[G]","name":"Tuvaluan dollar","symbol":"$"}],"languages":[{"iso639_1":"en","iso639_2":"eng","name":"English","nativeName":"English"}],"translations":{"br":"Tuvalu","pt":"Tuvalu","nl":"Tuvalu","hr":"Tuvalu","fa":"\u062A\u0648\u0648\u0627\u0644\u0648","de":"Tuvalu","es":"Tuvalu","fr":"Tuvalu","ja":"\u30C4\u30D0\u30EB","it":"Tuvalu","hu":"Tuvalu"},"flag":"https://flagcdn.com/tv.svg","cioc":"TUV","independent":true},{"name":"Uganda","topLevelDomain":[".ug"],"alpha2Code":"UG","alpha3Code":"UGA","callingCodes":["256"],"capital":"Kampala","altSpellings":["UG","Republic of Uganda","Jamhuri ya Uganda"],"subregion":"Eastern Africa","region":"Africa","population":45741000,"latlng":[1,32],"demonym":"Ugandan","area":241550,"gini":42.8,"timezones":["UTC+03:00"],"borders":["COD","KEN","RWA","SSD","TZA"],"nativeName":"Uganda","numericCode":"800","flags":{"svg":"https://flagcdn.com/ug.svg","png":"https://flagcdn.com/w320/ug.png"},"currencies":[{"code":"UGX","name":"Ugandan shilling","symbol":"Sh"}],"languages":[{"iso639_1":"en","iso639_2":"eng","name":"English","nativeName":"English"},{"iso639_1":"sw","iso639_2":"swa","name":"Swahili","nativeName":"Kiswahili"}],"translations":{"br":"Ouganda","pt":"Uganda","nl":"Oeganda","hr":"Uganda","fa":"\u0627\u0648\u06AF\u0627\u0646\u062F\u0627","de":"Uganda","es":"Uganda","fr":"Uganda","ja":"\u30A6\u30AC\u30F3\u30C0","it":"Uganda","hu":"Uganda"},"flag":"https://flagcdn.com/ug.svg","regionalBlocs":[{"acronym":"AU","name":"African Union","otherNames":["\u0627\u0644\u0627\u062A\u062D\u0627\u062F \u0627\u0644\u0623\u0641\u0631\u064A\u0642\u064A","Union africaine","Uni\xe3o Africana","Uni\xf3n Africana","Umoja wa Afrika"]}],"cioc":"UGA","independent":true},{"name":"Ukraine","topLevelDomain":[".ua"],"alpha2Code":"UA","alpha3Code":"UKR","callingCodes":["380"],"capital":"Kyiv","altSpellings":["UA","Ukrayina"],"subregion":"Eastern Europe","region":"Europe","population":44134693,"latlng":[49,32],"demonym":"Ukrainian","area":603700,"gini":26.6,"timezones":["UTC+02:00"],"borders":["BLR","HUN","MDA","POL","ROU","RUS","SVK"],"nativeName":"\u0423\u043A\u0440\u0430\u0457\u043D\u0430","numericCode":"804","flags":{"svg":"https://flagcdn.com/ua.svg","png":"https://flagcdn.com/w320/ua.png"},"currencies":[{"code":"UAH","name":"Ukrainian hryvnia","symbol":"\u20B4"}],"languages":[{"iso639_1":"uk","iso639_2":"ukr","name":"Ukrainian","nativeName":"\u0423\u043A\u0440\u0430\u0457\u043D\u0441\u044C\u043A\u0430"}],"translations":{"br":"Ukraina","pt":"Ucr\xe2nia","nl":"Oekra\xefne","hr":"Ukrajina","fa":"\u0648\u06A9\u0631\u0627\u06CC\u0646","de":"Ukraine","es":"Ucrania","fr":"Ukraine","ja":"\u30A6\u30AF\u30E9\u30A4\u30CA","it":"Ucraina","hu":"Ukrajna"},"flag":"https://flagcdn.com/ua.svg","cioc":"UKR","independent":true},{"name":"United Arab Emirates","topLevelDomain":[".ae"],"alpha2Code":"AE","alpha3Code":"ARE","callingCodes":["971"],"capital":"Abu Dhabi","altSpellings":["AE","UAE"],"subregion":"Western Asia","region":"Asia","population":9890400,"latlng":[24,54],"demonym":"Emirati","area":83600,"gini":26,"timezones":["UTC+04:00"],"borders":["OMN","SAU"],"nativeName":"\u062F\u0648\u0644\u0629 \u0627\u0644\u0625\u0645\u0627\u0631\u0627\u062A \u0627\u0644\u0639\u0631\u0628\u064A\u0629 \u0627\u0644\u0645\u062A\u062D\u062F\u0629","numericCode":"784","flags":{"svg":"https://flagcdn.com/ae.svg","png":"https://flagcdn.com/w320/ae.png"},"currencies":[{"code":"AED","name":"United Arab Emirates dirham","symbol":"\u062F.\u0625"}],"languages":[{"iso639_1":"ar","iso639_2":"ara","name":"Arabic","nativeName":"\u0627\u0644\u0639\u0631\u0628\u064A\u0629"}],"translations":{"br":"Emirelezhio\xf9 Arab Unanet","pt":"Emirados \xe1rabes Unidos","nl":"Verenigde Arabische Emiraten","hr":"Ujedinjeni Arapski Emirati","fa":"\u0627\u0645\u0627\u0631\u0627\u062A \u0645\u062A\u062D\u062F\u0647 \u0639\u0631\u0628\u06CC","de":"Vereinigte Arabische Emirate","es":"Emiratos \xc1rabes Unidos","fr":"\xc9mirats arabes unis","ja":"\u30A2\u30E9\u30D6\u9996\u9577\u56FD\u9023\u90A6","it":"Emirati Arabi Uniti","hu":"Egyes\xfclt Arab Em\xedrs\xe9gek"},"flag":"https://flagcdn.com/ae.svg","regionalBlocs":[{"acronym":"AL","name":"Arab League","otherNames":["\u062C\u0627\u0645\u0639\u0629 \u0627\u0644\u062F\u0648\u0644 \u0627\u0644\u0639\u0631\u0628\u064A\u0629","J\u0101mi\u02BBat ad-Duwal al-\u02BBArab\u012Byah","League of Arab States"]}],"cioc":"UAE","independent":true},{"name":"United Kingdom of Great Britain and Northern Ireland","topLevelDomain":[".uk"],"alpha2Code":"GB","alpha3Code":"GBR","callingCodes":["44"],"capital":"London","altSpellings":["GB","UK","Great Britain"],"subregion":"Northern Europe","region":"Europe","population":67215293,"latlng":[54,-2],"demonym":"British","area":242900,"gini":35.1,"timezones":["UTC-08:00","UTC-05:00","UTC-04:00","UTC-03:00","UTC-02:00","UTC","UTC+01:00","UTC+02:00","UTC+06:00"],"borders":["IRL"],"nativeName":"United Kingdom","numericCode":"826","flags":{"svg":"https://flagcdn.com/gb.svg","png":"https://flagcdn.com/w320/gb.png"},"currencies":[{"code":"GBP","name":"British pound","symbol":"\xa3"}],"languages":[{"iso639_1":"en","iso639_2":"eng","name":"English","nativeName":"English"}],"translations":{"br":"Rouantelezh-Unanet","pt":"Reino Unido","nl":"Verenigd Koninkrijk","hr":"Ujedinjeno Kraljevstvo","fa":"\u0628\u0631\u06CC\u062A\u0627\u0646\u06CC\u0627\u06CC \u06A9\u0628\u06CC\u0631 \u0648 \u0627\u06CC\u0631\u0644\u0646\u062F \u0634\u0645\u0627\u0644\u06CC","de":"Vereinigtes K\xf6nigreich","es":"Reino Unido","fr":"Royaume-Uni","ja":"\u30A4\u30AE\u30EA\u30B9","it":"Regno Unito","hu":"Nagy-Britannia"},"flag":"https://flagcdn.com/gb.svg","cioc":"GBR","independent":true},{"name":"United States of America","topLevelDomain":[".us"],"alpha2Code":"US","alpha3Code":"USA","callingCodes":["1"],"capital":"Washington, D.C.","altSpellings":["US","USA","United States of America"],"subregion":"Northern America","region":"Americas","population":329484123,"latlng":[38,-97],"demonym":"American","area":9629091,"gini":41.4,"timezones":["UTC-12:00","UTC-11:00","UTC-10:00","UTC-09:00","UTC-08:00","UTC-07:00","UTC-06:00","UTC-05:00","UTC-04:00","UTC+10:00","UTC+12:00"],"borders":["CAN","MEX"],"nativeName":"United States","numericCode":"840","flags":{"svg":"https://flagcdn.com/us.svg","png":"https://flagcdn.com/w320/us.png"},"currencies":[{"code":"USD","name":"United States dollar","symbol":"$"}],"languages":[{"iso639_1":"en","iso639_2":"eng","name":"English","nativeName":"English"}],"translations":{"br":"Stado\xf9-Unanet","pt":"Estados Unidos","nl":"Verenigde Staten","hr":"Sjedinjene Ameri\u010Dke Dr\u017Eave","fa":"\u0627\u06CC\u0627\u0644\u0627\u062A \u0645\u062A\u062D\u062F\u0647 \u0622\u0645\u0631\u06CC\u06A9\u0627","de":"Vereinigte Staaten von Amerika","es":"Estados Unidos","fr":"\xc9tats-Unis","ja":"\u30A2\u30E1\u30EA\u30AB\u5408\u8846\u56FD","it":"Stati Uniti D\'America","hu":"Amerikai Egyes\xfclt \xc1llamok"},"flag":"https://flagcdn.com/us.svg","regionalBlocs":[{"acronym":"NAFTA","name":"North American Free Trade Agreement","otherNames":["Tratado de Libre Comercio de Am\xe9rica del Norte","Accord de Libre-\xe9change Nord-Am\xe9ricain"]}],"cioc":"USA","independent":true},{"name":"Uruguay","topLevelDomain":[".uy"],"alpha2Code":"UY","alpha3Code":"URY","callingCodes":["598"],"capital":"Montevideo","altSpellings":["UY","Oriental Republic of Uruguay","Rep\xfablica Oriental del Uruguay"],"subregion":"South America","region":"Americas","population":3473727,"latlng":[-33,-56],"demonym":"Uruguayan","area":181034,"gini":39.7,"timezones":["UTC-03:00"],"borders":["ARG","BRA"],"nativeName":"Uruguay","numericCode":"858","flags":{"svg":"https://flagcdn.com/uy.svg","png":"https://flagcdn.com/w320/uy.png"},"currencies":[{"code":"UYU","name":"Uruguayan peso","symbol":"$"}],"languages":[{"iso639_1":"es","iso639_2":"spa","name":"Spanish","nativeName":"Espa\xf1ol"}],"translations":{"br":"Uruguay","pt":"Uruguai","nl":"Uruguay","hr":"Urugvaj","fa":"\u0627\u0631\u0648\u06AF\u0648\u0626\u0647","de":"Uruguay","es":"Uruguay","fr":"Uruguay","ja":"\u30A6\u30EB\u30B0\u30A2\u30A4","it":"Uruguay","hu":"Uruguay"},"flag":"https://flagcdn.com/uy.svg","regionalBlocs":[{"acronym":"USAN","name":"Union of South American Nations","otherAcronyms":["UNASUR","UNASUL","UZAN"],"otherNames":["Uni\xf3n de Naciones Suramericanas","Uni\xe3o de Na\xe7\xf5es Sul-Americanas","Unie van Zuid-Amerikaanse Naties","South American Union"]}],"cioc":"URU","independent":true},{"name":"Uzbekistan","topLevelDomain":[".uz"],"alpha2Code":"UZ","alpha3Code":"UZB","callingCodes":["998"],"capital":"Tashkent","altSpellings":["UZ","Republic of Uzbekistan","O\u2018zbekiston Respublikasi","\u040E\u0437\u0431\u0435\u043A\u0438\u0441\u0442\u043E\u043D \u0420\u0435\u0441\u043F\u0443\u0431\u043B\u0438\u043A\u0430\u0441\u0438"],"subregion":"Central Asia","region":"Asia","population":34232050,"latlng":[41,64],"demonym":"Uzbekistani","area":447400,"gini":35.3,"timezones":["UTC+05:00"],"borders":["AFG","KAZ","KGZ","TJK","TKM"],"nativeName":"O\u2018zbekiston","numericCode":"860","flags":{"svg":"https://flagcdn.com/uz.svg","png":"https://flagcdn.com/w320/uz.png"},"currencies":[{"code":"UZS","name":"Uzbekistani so\'m","symbol":"so\'m"}],"languages":[{"iso639_1":"uz","iso639_2":"uzb","name":"Uzbek","nativeName":"O\u02BBzbek"},{"iso639_1":"ru","iso639_2":"rus","name":"Russian","nativeName":"\u0420\u0443\u0441\u0441\u043A\u0438\u0439"}],"translations":{"br":"Ouzbekistan","pt":"Usbequist\xe3o","nl":"Oezbekistan","hr":"Uzbekistan","fa":"\u0627\u0632\u0628\u06A9\u0633\u062A\u0627\u0646","de":"Usbekistan","es":"Uzbekist\xe1n","fr":"Ouzb\xe9kistan","ja":"\u30A6\u30BA\u30D9\u30AD\u30B9\u30BF\u30F3","it":"Uzbekistan","hu":"\xdczbegiszt\xe1n"},"flag":"https://flagcdn.com/uz.svg","cioc":"UZB","independent":false},{"name":"Vanuatu","topLevelDomain":[".vu"],"alpha2Code":"VU","alpha3Code":"VUT","callingCodes":["678"],"capital":"Port Vila","altSpellings":["VU","Republic of Vanuatu","Ripablik blong Vanuatu","R\xe9publique de Vanuatu"],"subregion":"Melanesia","region":"Oceania","population":307150,"latlng":[-16,167],"demonym":"Ni-Vanuatu","area":12189,"gini":37.6,"timezones":["UTC+11:00"],"nativeName":"Vanuatu","numericCode":"548","flags":{"svg":"https://flagcdn.com/vu.svg","png":"https://flagcdn.com/w320/vu.png"},"currencies":[{"code":"VUV","name":"Vanuatu vatu","symbol":"Vt"}],"languages":[{"iso639_1":"bi","iso639_2":"bis","name":"Bislama","nativeName":"Bislama"},{"iso639_1":"en","iso639_2":"eng","name":"English","nativeName":"English"},{"iso639_1":"fr","iso639_2":"fra","name":"French","nativeName":"fran\xe7ais"}],"translations":{"br":"Vanuatu","pt":"Vanuatu","nl":"Vanuatu","hr":"Vanuatu","fa":"\u0648\u0627\u0646\u0648\u0627\u062A\u0648","de":"Vanuatu","es":"Vanuatu","fr":"Vanuatu","ja":"\u30D0\u30CC\u30A2\u30C4","it":"Vanuatu","hu":"Vanuatu"},"flag":"https://flagcdn.com/vu.svg","cioc":"VAN","independent":true},{"name":"Venezuela (Bolivarian Republic of)","topLevelDomain":[".ve"],"alpha2Code":"VE","alpha3Code":"VEN","callingCodes":["58"],"capital":"Caracas","altSpellings":["VE","Bolivarian Republic of Venezuela","Rep\xfablica Bolivariana de Venezuela"],"subregion":"South America","region":"Americas","population":28435943,"latlng":[8,-66],"demonym":"Venezuelan","area":916445,"gini":44.8,"timezones":["UTC-04:00"],"borders":["BRA","COL","GUY"],"nativeName":"Venezuela","numericCode":"862","flags":{"svg":"https://flagcdn.com/ve.svg","png":"https://flagcdn.com/w320/ve.png"},"currencies":[{"code":"VEF","name":"Venezuelan bol\xedvar","symbol":"Bs S"}],"languages":[{"iso639_1":"es","iso639_2":"spa","name":"Spanish","nativeName":"Espa\xf1ol"}],"translations":{"br":"Venezuela","pt":"Venezuela","nl":"Venezuela","hr":"Venezuela","fa":"\u0648\u0646\u0632\u0648\u0626\u0644\u0627","de":"Venezuela","es":"Venezuela","fr":"Venezuela","ja":"\u30D9\u30CD\u30BA\u30A8\u30E9\u30FB\u30DC\u30EA\u30D0\u30EB\u5171\u548C\u56FD","it":"Venezuela","hu":"Venezuela"},"flag":"https://flagcdn.com/ve.svg","regionalBlocs":[{"acronym":"USAN","name":"Union of South American Nations","otherAcronyms":["UNASUR","UNASUL","UZAN"],"otherNames":["Uni\xf3n de Naciones Suramericanas","Uni\xe3o de Na\xe7\xf5es Sul-Americanas","Unie van Zuid-Amerikaanse Naties","South American Union"]}],"cioc":"VEN","independent":true},{"name":"Vietnam","topLevelDomain":[".vn"],"alpha2Code":"VN","alpha3Code":"VNM","callingCodes":["84"],"capital":"Hanoi","altSpellings":["VN","Socialist Republic of Vietnam","C\u1ED9ng h\xf2a X\xe3 h\u1ED9i ch\u1EE7 ngh\u0129a Vi\u1EC7t Nam"],"subregion":"South-Eastern Asia","region":"Asia","population":97338583,"latlng":[16.16666666,107.83333333],"demonym":"Vietnamese","area":331212,"gini":35.7,"timezones":["UTC+07:00"],"borders":["KHM","CHN","LAO"],"nativeName":"Vi\u1EC7t Nam","numericCode":"704","flags":{"svg":"https://flagcdn.com/vn.svg","png":"https://flagcdn.com/w320/vn.png"},"currencies":[{"code":"VND","name":"Vietnamese \u0111\u1ED3ng","symbol":"\u20AB"}],"languages":[{"iso639_1":"vi","iso639_2":"vie","name":"Vietnamese","nativeName":"Ti\u1EBFng Vi\u1EC7t"}],"translations":{"br":"Vi\xeat Nam","pt":"Vietname","nl":"Vietnam","hr":"Vijetnam","fa":"\u0648\u06CC\u062A\u0646\u0627\u0645","de":"Vietnam","es":"Vietnam","fr":"Vi\xeat Nam","ja":"\u30D9\u30C8\u30CA\u30E0","it":"Vietnam","hu":"Vietn\xe1m"},"flag":"https://flagcdn.com/vn.svg","regionalBlocs":[{"acronym":"ASEAN","name":"Association of Southeast Asian Nations"}],"cioc":"VIE","independent":true},{"name":"Wallis and Futuna","topLevelDomain":[".wf"],"alpha2Code":"WF","alpha3Code":"WLF","callingCodes":["681"],"capital":"Mata-Utu","altSpellings":["WF","Territory of the Wallis and Futuna Islands","Territoire des \xeeles Wallis et Futuna"],"subregion":"Polynesia","region":"Oceania","population":11750,"latlng":[-13.3,-176.2],"demonym":"Wallis and Futuna Islander","area":142,"timezones":["UTC+12:00"],"nativeName":"Wallis et Futuna","numericCode":"876","flags":{"svg":"https://flagcdn.com/wf.svg","png":"https://flagcdn.com/w320/wf.png"},"currencies":[{"code":"XPF","name":"CFP franc","symbol":"Fr"}],"languages":[{"iso639_1":"fr","iso639_2":"fra","name":"French","nativeName":"fran\xe7ais"}],"translations":{"br":"Wallis ha Futuna","pt":"Wallis e Futuna","nl":"Wallis en Futuna","hr":"Wallis i Fortuna","fa":"\u0648\u0627\u0644\u06CC\u0633 \u0648 \u0641\u0648\u062A\u0648\u0646\u0627","de":"Wallis und Futuna","es":"Wallis y Futuna","fr":"Wallis-et-Futuna","ja":"\u30A6\u30A9\u30EA\u30B9\u30FB\u30D5\u30C4\u30CA","it":"Wallis e Futuna","hu":"Wallis \xe9s Futuna"},"flag":"https://flagcdn.com/wf.svg","independent":false},{"name":"Western Sahara","topLevelDomain":[".eh"],"alpha2Code":"EH","alpha3Code":"ESH","callingCodes":["212"],"capital":"El Aai\xfan","altSpellings":["EH","Tane\u1E93roft Tutrimt"],"subregion":"Northern Africa","region":"Africa","population":510713,"latlng":[24.5,-13],"demonym":"Sahrawi","area":266000,"timezones":["UTC+00:00"],"borders":["DZA","MRT","MAR"],"nativeName":"\u0627\u0644\u0635\u062D\u0631\u0627\u0621 \u0627\u0644\u063A\u0631\u0628\u064A\u0629","numericCode":"732","flags":{"svg":"https://flagcdn.com/eh.svg","png":"https://flagcdn.com/w320/eh.png"},"currencies":[{"code":"MAD","name":"Moroccan dirham","symbol":"\u062F.\u0645."},{"code":"DZD","name":"Algerian dinar","symbol":"\u062F.\u062C"}],"languages":[{"iso639_1":"es","iso639_2":"spa","name":"Spanish","nativeName":"Espa\xf1ol"}],"translations":{"br":"Sahara ar C\'horn\xf4g","pt":"Saara Ocidental","nl":"Westelijke Sahara","hr":"Zapadna Sahara","fa":"\u062C\u0645\u0647\u0648\u0631\u06CC \u062F\u0645\u0648\u06A9\u0631\u0627\u062A\u06CC\u06A9 \u0639\u0631\u0628\u06CC \u0635\u062D\u0631\u0627","de":"Westsahara","es":"Sahara Occidental","fr":"Sahara Occidental","ja":"\u897F\u30B5\u30CF\u30E9","it":"Sahara Occidentale","hu":"Nyugat-Szahara"},"flag":"https://flagcdn.com/eh.svg","regionalBlocs":[{"acronym":"AU","name":"African Union","otherNames":["\u0627\u0644\u0627\u062A\u062D\u0627\u062F \u0627\u0644\u0623\u0641\u0631\u064A\u0642\u064A","Union africaine","Uni\xe3o Africana","Uni\xf3n Africana","Umoja wa Afrika"]}],"independent":false},{"name":"Yemen","topLevelDomain":[".ye"],"alpha2Code":"YE","alpha3Code":"YEM","callingCodes":["967"],"capital":"Sana\'a","altSpellings":["YE","Yemeni Republic","al-Jumh\u016Briyyah al-Yamaniyyah"],"subregion":"Western Asia","region":"Asia","population":29825968,"latlng":[15,48],"demonym":"Yemeni","area":527968,"gini":36.7,"timezones":["UTC+03:00"],"borders":["OMN","SAU"],"nativeName":"\u0627\u0644\u064A\u064E\u0645\u064E\u0646","numericCode":"887","flags":{"svg":"https://flagcdn.com/ye.svg","png":"https://flagcdn.com/w320/ye.png"},"currencies":[{"code":"YER","name":"Yemeni rial","symbol":"\uFDFC"}],"languages":[{"iso639_1":"ar","iso639_2":"ara","name":"Arabic","nativeName":"\u0627\u0644\u0639\u0631\u0628\u064A\u0629"}],"translations":{"br":"Yemen","pt":"I\xe9men","nl":"Jemen","hr":"Jemen","fa":"\u06CC\u0645\u0646","de":"Jemen","es":"Yemen","fr":"Y\xe9men","ja":"\u30A4\u30A8\u30E1\u30F3","it":"Yemen","hu":"Jemen"},"flag":"https://flagcdn.com/ye.svg","regionalBlocs":[{"acronym":"AL","name":"Arab League","otherNames":["\u062C\u0627\u0645\u0639\u0629 \u0627\u0644\u062F\u0648\u0644 \u0627\u0644\u0639\u0631\u0628\u064A\u0629","J\u0101mi\u02BBat ad-Duwal al-\u02BBArab\u012Byah","League of Arab States"]}],"cioc":"YEM","independent":true},{"name":"Zambia","topLevelDomain":[".zm"],"alpha2Code":"ZM","alpha3Code":"ZMB","callingCodes":["260"],"capital":"Lusaka","altSpellings":["ZM","Republic of Zambia"],"subregion":"Eastern Africa","region":"Africa","population":18383956,"latlng":[-15,30],"demonym":"Zambian","area":752618,"gini":57.1,"timezones":["UTC+02:00"],"borders":["AGO","BWA","COD","MWI","MOZ","NAM","TZA","ZWE"],"nativeName":"Zambia","numericCode":"894","flags":{"svg":"https://flagcdn.com/zm.svg","png":"https://flagcdn.com/w320/zm.png"},"currencies":[{"code":"ZMW","name":"Zambian kwacha","symbol":"ZK"}],"languages":[{"iso639_1":"en","iso639_2":"eng","name":"English","nativeName":"English"}],"translations":{"br":"Zambia","pt":"Z\xe2mbia","nl":"Zambia","hr":"Zambija","fa":"\u0632\u0627\u0645\u0628\u06CC\u0627","de":"Sambia","es":"Zambia","fr":"Zambie","ja":"\u30B6\u30F3\u30D3\u30A2","it":"Zambia","hu":"Zambia"},"flag":"https://flagcdn.com/zm.svg","regionalBlocs":[{"acronym":"AU","name":"African Union","otherNames":["\u0627\u0644\u0627\u062A\u062D\u0627\u062F \u0627\u0644\u0623\u0641\u0631\u064A\u0642\u064A","Union africaine","Uni\xe3o Africana","Uni\xf3n Africana","Umoja wa Afrika"]}],"cioc":"ZAM","independent":true},{"name":"Zimbabwe","topLevelDomain":[".zw"],"alpha2Code":"ZW","alpha3Code":"ZWE","callingCodes":["263"],"capital":"Harare","altSpellings":["ZW","Republic of Zimbabwe"],"subregion":"Southern Africa","region":"Africa","population":14862927,"latlng":[-20,30],"demonym":"Zimbabwean","area":390757,"gini":50.3,"timezones":["UTC+02:00"],"borders":["BWA","MOZ","ZAF","ZMB"],"nativeName":"Zimbabwe","numericCode":"716","flags":{"svg":"https://flagcdn.com/zw.svg","png":"https://flagcdn.com/w320/zw.png"},"currencies":[{"code":"ZMW","name":"Zambian kwacha","symbol":"K"}],"languages":[{"iso639_1":"en","iso639_2":"eng","name":"English","nativeName":"English"},{"iso639_1":"sn","iso639_2":"sna","name":"Shona","nativeName":"chiShona"},{"iso639_1":"nd","iso639_2":"nde","name":"Northern Ndebele","nativeName":"isiNdebele"}],"translations":{"br":"Zimbabwe","pt":"Zimbabu\xe9","nl":"Zimbabwe","hr":"Zimbabve","fa":"\u0632\u06CC\u0645\u0628\u0627\u0648\u0647","de":"Simbabwe","es":"Zimbabue","fr":"Zimbabwe","ja":"\u30B8\u30F3\u30D0\u30D6\u30A8","it":"Zimbabwe","hu":"Zimbabwe"},"flag":"https://flagcdn.com/zw.svg","regionalBlocs":[{"acronym":"AU","name":"African Union","otherNames":["\u0627\u0644\u0627\u062A\u062D\u0627\u062F \u0627\u0644\u0623\u0641\u0631\u064A\u0642\u064A","Union africaine","Uni\xe3o Africana","Uni\xf3n Africana","Umoja wa Afrika"]}],"cioc":"ZIM","independent":true}]}');


const $2def7d6f5f23d94b$var$MAX_TIMEOUT_DURATION = 5000; // 5 seconds
const $2def7d6f5f23d94b$var$apiEndpoint = "https://restcountries.com/v3.1/all";
const $2def7d6f5f23d94b$export$d852f5f778460fa4 = ()=>{
    const [data, setData] = (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).useState([]);
    const [isLoading, setIsLoading] = (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).useState(false);
    (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).useEffect(()=>{
        const controller = new AbortController();
        async function fetchWithTimeout(endpoint) {
            const timeoutId = window.setTimeout(()=>{
                controller.abort();
            }, $2def7d6f5f23d94b$var$MAX_TIMEOUT_DURATION);
            try {
                const response = await fetch(endpoint, {
                    signal: controller.signal
                });
                window.clearTimeout(timeoutId);
                return response;
            } catch (err) {
                window.clearTimeout(timeoutId);
                throw err;
            }
        }
        async function fetchApiData() {
            setIsLoading(true);
            try {
                const response = await fetchWithTimeout($2def7d6f5f23d94b$var$apiEndpoint);
                if (!response.ok) throw new Error(response.statusText);
                const json = await response.json();
                setData((0, $c2e89246714e26f0$export$f8567c06b2dfb1c1)(json));
            } catch (err) {
                if (err.name === "AbortError") console.info("Fetch request timed out, using backup instead");
                else console.warn("Fetch error:", err);
                setData((0, $c2e89246714e26f0$export$e5e6ad516e0608c4)((0, (/*@__PURE__*/$parcel$interopDefault($abc5d03f1d982ddc$exports))).countries));
            } finally{
                setIsLoading(false);
            }
        }
        fetchApiData();
        return ()=>{
            controller.abort();
        };
    }, []);
    return {
        data: data,
        isLoading: isLoading
    };
};


function $b0e5921763636db2$var$MainContent() {
    const { data: countries, isLoading: isLoading } = (0, $2def7d6f5f23d94b$export$d852f5f778460fa4)();
    const [selectedCountry, setSelectedCountry] = (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).useState(null);
    const [searchTerm, setSearchTerm] = (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).useState("");
    const [region, setRegion] = (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).useState("");
    const [currentPage, setCurrentPage] = (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).useState(1);
    const handleSearchTermChange = (term)=>{
        setSearchTerm(term);
        setCurrentPage(1);
    };
    const handleRegionChange = (region)=>{
        setRegion(region);
        setCurrentPage(1);
    };
    const filteredCountries = (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).useMemo(()=>{
        return countries.filter((country)=>{
            const matchesSearchTerm = country.countryName.toLowerCase().includes(searchTerm.trim().toLowerCase());
            const matchesRegion = region !== "" ? country.region === region : true;
            return matchesSearchTerm && matchesRegion;
        });
    }, [
        countries,
        searchTerm,
        region
    ]);
    const startIndex = (currentPage - 1) * (0, $41f8a5367d186866$export$3407ea1c46ff4268);
    const countriesForCurrentPage = filteredCountries.slice(startIndex, startIndex + (0, $41f8a5367d186866$export$3407ea1c46ff4268));
    const totalPages = Math.ceil(filteredCountries.length / (0, $41f8a5367d186866$export$3407ea1c46ff4268));
    const handlePageChange = (page)=>{
        if (page > 0 && page <= totalPages) setCurrentPage(page);
    };
    if (selectedCountry) return /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $0d8704a8d6951237$export$2e2bcd8739ae039), {
        country: selectedCountry,
        handleGoBack: ()=>setSelectedCountry(null),
        countries: countries,
        handleCountrySelect: setSelectedCountry
    });
    return /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)((0, $d4dab640dcbe486c$exports.Fragment), {
        children: [
            isLoading && /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $b2e24922b56df7d9$export$2e2bcd8739ae039), {}),
            !isLoading && countries.length !== 0 && /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)((0, $d4dab640dcbe486c$exports.Fragment), {
                children: [
                    /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $b00c301911a66893$export$2e2bcd8739ae039), {
                        searchTerm: searchTerm,
                        handleSearchTermChange: handleSearchTermChange,
                        region: region,
                        handleRegionChange: handleRegionChange
                    }),
                    /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $9f5407930d775fe8$export$2e2bcd8739ae039), {
                        handleCountrySelect: setSelectedCountry,
                        countries: countriesForCurrentPage,
                        currentPage: currentPage,
                        handlePageChange: handlePageChange,
                        totalPages: totalPages
                    })
                ]
            })
        ]
    });
}
var $b0e5921763636db2$export$2e2bcd8739ae039 = $b0e5921763636db2$var$MainContent;



function $47c18933f59b2062$var$getHeight({ axis: axis, size: size }) {
    return axis === "horizontal" ? 1 : size;
}
function $47c18933f59b2062$var$getWidth({ axis: axis, size: size }) {
    return axis === "vertical" ? 1 : size;
}
const $47c18933f59b2062$var$Spacer = (0, $e484c752f3f06549$export$2e2bcd8739ae039).span.withConfig({
    displayName: "Spacer",
    componentId: "sc-styoid-0"
})([
    "display:block;width:",
    "px;min-width:",
    "px;height:",
    "px;min-height:",
    "px;"
], $47c18933f59b2062$var$getWidth, $47c18933f59b2062$var$getWidth, $47c18933f59b2062$var$getHeight, $47c18933f59b2062$var$getHeight);
var $47c18933f59b2062$export$2e2bcd8739ae039 = $47c18933f59b2062$var$Spacer;






const $52dd227177540b61$var$GlobalStyles = (0, $e484c752f3f06549$export$f0f03736edb61697)([
    "*,*::before,*::after{box-sizing:border-box;}*{margin:0;}html,body,#root{height:100%;}body{line-height:1.5;-webkit-font-smoothing:antialiased;font-family:'Nunito Sans',sans-serif;}img,picture,video,canvas,svg{display:block;max-width:100%;}input,button,textarea,select{font:inherit;}p,h1,h2,h3,h4,h5,h6{overflow-wrap:break-word;}#root{isolation:isolate;}button{display:block;margin:0;padding:0;border:none;background:transparent;cursor:pointer;text-align:left;font:inherit;color:inherit;}input{color:inherit;}a{color:inherit;text-decoration:none;}html{--dark-blue-elements:",
    ";--dark-blue-background:",
    ";--dark-blue-text:",
    ";--dark-gray-input:",
    ";--light-gray-background:",
    ";--white:",
    ";--font-weight-light:",
    ";--font-weight-bold:",
    ";--font-weight-extrabold:",
    ";--shadow-light:0deg 0% 88%;--shadow-dark:207deg 20% 12%;}body{background-color:",
    ";color:",
    ";--shadow-color:",
    ";}"
], (0, $41f8a5367d186866$export$56d196d2844d1ca1).darkBlue.elements, (0, $41f8a5367d186866$export$56d196d2844d1ca1).darkBlue.background, (0, $41f8a5367d186866$export$56d196d2844d1ca1).darkBlue.text, (0, $41f8a5367d186866$export$56d196d2844d1ca1).darkGray.input, (0, $41f8a5367d186866$export$56d196d2844d1ca1).lightGray.background, (0, $41f8a5367d186866$export$56d196d2844d1ca1).white, (0, $41f8a5367d186866$export$caa8b992bc9d96e3).light, (0, $41f8a5367d186866$export$caa8b992bc9d96e3).bold, (0, $41f8a5367d186866$export$caa8b992bc9d96e3).extrabold, ({ theme: theme })=>theme.background, ({ theme: theme })=>theme.text, ({ theme: theme })=>theme.shadow);
var $52dd227177540b61$export$2e2bcd8739ae039 = $52dd227177540b61$var$GlobalStyles;





var $bh6RR = parcelRequire("bh6RR");

const $000e24c86d614fb3$export$f30cb9bc4f736419 = {
    background: "var(--light-gray-background)",
    elements: "var(--white)",
    text: "var(--dark-blue-text)",
    shadow: "var(--shadow-light)",
    placeholderText: "var(--dark-gray-input)",
    loaderTrack: "hsl(0deg 0% 35%)",
    loaderFill: "hsl(--dark-blue-background)",
    queries: (0, $41f8a5367d186866$export$538a4a49c4b9cbab)
};
const $000e24c86d614fb3$export$3e936a8db52a10a0 = {
    background: "var(--dark-blue-background)",
    elements: "var(--dark-blue-elements)",
    text: "var(--white)",
    shadow: "var(--shadow-dark)",
    placeholderText: "hsl(0deg 0% 90%)",
    loaderTrack: "hsl(0deg 0% 90%)",
    loaderFill: "var(--white)",
    queries: (0, $41f8a5367d186866$export$538a4a49c4b9cbab)
}; /*

    --shadow-light: 0deg 0% 88%;
    --shadow-dark: 207deg 20% 12%;

Dark Blue (Dark Mode Elements): hsl(209, 23%, 22%)
Very Dark Blue (Dark Mode Background): hsl(207, 26%, 17%)
Very Dark Blue (Light Mode Text): hsl(200, 15%, 8%)
Dark Gray (Light Mode Input): hsl(0, 0%, 52%)
Very Light Gray (Light Mode Background): hsl(0, 0%, 98%)
White (Dark Mode Text & Light Mode Elements): hsl(0, 0%, 100%)

    --dark-blue-elements: ${COLORS.darkBlue.elements};
    --dark-blue-background: ${COLORS.darkBlue.background};
    --dark-blue-text: ${COLORS.darkBlue.text};
    --dark-gray-input: ${COLORS.darkGray.input};
    --light-gray-background: ${COLORS.lightGray.background};
    --white: ${COLORS.white};

    --font-weight-light: ${WEIGHTS.light};
    --font-weight-bold: ${WEIGHTS.bold};
    --font-weight-extrabold: ${WEIGHTS.extrabold};

*/ 


const $1805eab219018404$export$93d4e7f90805808f = ()=>{
    const [theme, setTheme] = (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).useState(()=>window.localStorage.getItem("preferred-mode") || "light");
    const themeToggler = ()=>theme === "light" ? setTheme("dark") : setTheme("light");
    (0, (/*@__PURE__*/$parcel$interopDefault($bh6RR))).useEffect(()=>{
        window.localStorage.setItem("preferred-mode", theme);
    }, [
        theme
    ]);
    return {
        theme: theme,
        themeToggler: themeToggler,
        currentTheme: theme === "light" ? (0, $000e24c86d614fb3$export$f30cb9bc4f736419) : (0, $000e24c86d614fb3$export$3e936a8db52a10a0)
    };
};


function $5c4c715ef872aa13$var$App() {
    const { theme: theme, themeToggler: themeToggler, currentTheme: currentTheme } = (0, $1805eab219018404$export$93d4e7f90805808f)();
    return /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)((0, $e484c752f3f06549$export$d8964aec282183a3), {
        theme: currentTheme,
        children: [
            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $02ce57c81a0104d3$export$2e2bcd8739ae039), {
                theme: theme,
                themeToggler: themeToggler
            }),
            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsxs)((0, $cb3c883d63db9e8e$export$2e2bcd8739ae039), {
                as: "main",
                children: [
                    /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $b0e5921763636db2$export$2e2bcd8739ae039), {}),
                    /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $47c18933f59b2062$export$2e2bcd8739ae039), {
                        size: 32
                    })
                ]
            }),
            /*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $52dd227177540b61$export$2e2bcd8739ae039), {})
        ]
    });
}
var $5c4c715ef872aa13$export$2e2bcd8739ae039 = $5c4c715ef872aa13$var$App;




const $1f0dc3b9307be026$var$root = (0, (/*@__PURE__*/$parcel$interopDefault($6fc264ec92100d3a$exports))).createRoot(document.getElementById("root"));
$1f0dc3b9307be026$var$root.render(/*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $5c4c715ef872aa13$export$2e2bcd8739ae039), {}));


//# sourceMappingURL=index.be39b5fc.js.map
